import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** The javascript `Date` as string. Type represents date and time as the ISO Date string. */
  DateTime: any;
  /** The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSONObject: any;
};

export type AcceptAppointmentInput = {
  appointmentId: Scalars['ID'];
  profileId: Scalars['ID'];
  start: Scalars['DateTime'];
};

export type AcceptedPaymentMethods = {
  __typename?: 'AcceptedPaymentMethods';
  applePay?: Maybe<Scalars['Boolean']>;
  creditCard?: Maybe<Scalars['Boolean']>;
};

export type AcceptedPaymentMethodsInput = {
  applePay?: InputMaybe<Scalars['Boolean']>;
  creditCard?: InputMaybe<Scalars['Boolean']>;
};

export type AddGroupAppointmentMemberInput = {
  clientProfileId: Scalars['ID'];
  procedureBaseDefIds: Array<Scalars['ID']>;
};

export type AddOrganizationsToMarketplaceInput = {
  marketplaceId: Scalars['ID'];
  organizationIds: Array<Scalars['ID']>;
};

export type AllergyIntolerance = {
  __typename?: 'AllergyIntolerance';
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  name: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type ApiKey = {
  __typename?: 'ApiKey';
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  kid: Scalars['ID'];
  name: Scalars['String'];
  roles: Array<Role>;
  updatedAt: Scalars['DateTime'];
  userId: Scalars['ID'];
};

export type Appointment = {
  __typename?: 'Appointment';
  /** Additional patients beyond the primary booker. Empty for solo appointments and for the primary leg of a group. For request-originated groups, reads from `constraint.request.patients`. For dispatch-created groups (which have no AppointmentRequest), synthesizes equivalents from sibling appointments — `id` is the sibling appointment id in that case. */
  additionalPatients: Array<AppointmentRequestPatient>;
  alternateTimes: Array<Scalars['DateTime']>;
  archivedAt?: Maybe<Scalars['DateTime']>;
  cancelReason?: Maybe<Scalars['String']>;
  checkout?: Maybe<Checkout>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['ID']>;
  /** Appointment length in minutes */
  duration: Scalars['Int'];
  end: Scalars['DateTime'];
  /** UUID linking this appointment to others materialized from the same grouped request. NULL for solo appointments. */
  groupId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  intakeStatus?: Maybe<Scalars['String']>;
  intakeSubmissions: Array<IntakeSubmission>;
  latitude?: Maybe<Scalars['Float']>;
  location: Scalars['String'];
  longitude?: Maybe<Scalars['Float']>;
  notes?: Maybe<Scalars['String']>;
  ordersRequired: Scalars['Boolean'];
  participants: Array<AppointmentParticipant>;
  procedureBaseDefs: Array<ProcedureBaseDefinition>;
  qualiphyInvitation?: Maybe<QualiphyInvitation>;
  start: Scalars['DateTime'];
  startedAt?: Maybe<Scalars['DateTime']>;
  status: AppointmentStatus;
  updatedAt: Scalars['DateTime'];
};

export type AppointmentCandidate = {
  __typename?: 'AppointmentCandidate';
  availableTimes: Array<Scalars['DateTime']>;
  duration?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  organization?: Maybe<Organization>;
  profile?: Maybe<Profile>;
  rank: Scalars['Int'];
  reservableTimes: Array<Scalars['DateTime']>;
  start?: Maybe<Scalars['DateTime']>;
};

export type AppointmentConstraint = {
  __typename?: 'AppointmentConstraint';
  appointments: Array<Appointment>;
  candidates: Array<AppointmentCandidate>;
  id: Scalars['ID'];
  organizations: Array<Organization>;
  profiles: Array<Profile>;
  timeRanges: Array<AppointmentTimeRange>;
};

export type AppointmentConstraintInput = {
  organizationIds?: InputMaybe<Array<Scalars['ID']>>;
  profileIds?: InputMaybe<Array<Scalars['ID']>>;
  timeRanges: Array<AppointmentTimeRangeInput>;
};

export type AppointmentFilterInput = {
  client_name?: InputMaybe<FilterStringInput>;
  duration?: InputMaybe<FilterIntegerInput>;
  id?: InputMaybe<FilterIntegerInput>;
  intakeStatus?: InputMaybe<FilterStringInput>;
  location?: InputMaybe<FilterStringInput>;
  orderApproved?: InputMaybe<Scalars['Boolean']>;
  practitioner_name?: InputMaybe<FilterStringInput>;
  procedure?: InputMaybe<FilterStringInput>;
  start?: InputMaybe<FilterDateInput>;
  status?: InputMaybe<FilterStringInput>;
};

export type AppointmentPage = {
  __typename?: 'AppointmentPage';
  data: Array<Appointment>;
  totalCount: Scalars['Int'];
};

export type AppointmentPageInput = {
  dateRange?: InputMaybe<Array<Scalars['DateTime']>>;
  filter?: InputMaybe<AppointmentFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<AppointmentSortInput>>;
};

export type AppointmentParticipant = {
  __typename?: 'AppointmentParticipant';
  clientProfileId?: Maybe<Scalars['ID']>;
  forms: Array<Form>;
  id: Scalars['ID'];
  name: Scalars['String'];
  orderApproved?: Maybe<Scalars['Boolean']>;
  participant?: Maybe<Participant>;
  profileId?: Maybe<Scalars['ID']>;
  responses: Array<AppointmentResponse>;
  status: ParticipationStatus;
  type: ParticipantType;
};

export type AppointmentParticipantInput = {
  id: Scalars['ID'];
  type: ParticipantType;
};

export enum AppointmentRefundType {
  Custom = 'CUSTOM',
  Full = 'FULL',
  FullMinusDeposit = 'FULL_MINUS_DEPOSIT',
  None = 'NONE'
}

export type AppointmentRequest = {
  __typename?: 'AppointmentRequest';
  /** Additional patients on this request beyond the primary (clientProfiles[0]). Each carries their own procedures. */
  additionalPatients: Array<AppointmentRequestPatient>;
  archivedAt?: Maybe<Scalars['DateTime']>;
  bookingMode?: Maybe<BookingMode>;
  cancelReason?: Maybe<Scalars['String']>;
  checkout?: Maybe<Checkout>;
  checkoutNotes?: Maybe<Scalars['JSONObject']>;
  clientProfiles: Array<ClientProfile>;
  constraints: Array<AppointmentConstraint>;
  createdAt: Scalars['DateTime'];
  /** Practitioners who have declined an offer on this request (ENG-203 decline memory). Survives constraint edits and resets; used to warn on re-approval and badge candidates in the UI. */
  declinedProfiles: Array<Profile>;
  id: Scalars['ID'];
  intakeStatus?: Maybe<Scalars['String']>;
  lastResetAt?: Maybe<Scalars['DateTime']>;
  latitude?: Maybe<Scalars['Float']>;
  location: Scalars['String'];
  longitude?: Maybe<Scalars['Float']>;
  marketplace: Marketplace;
  notes?: Maybe<Scalars['String']>;
  orderApproved?: Maybe<Scalars['Boolean']>;
  procedureBaseDefs: Array<ProcedureBaseDefinition>;
  status: AppointmentRequestStatus;
  updatedAt: Scalars['DateTime'];
  waitlistedAt?: Maybe<Scalars['DateTime']>;
};

export type AppointmentRequestFilterInput = {
  client_name?: InputMaybe<FilterStringInput>;
  id?: InputMaybe<FilterIntegerInput>;
  intakeStatus?: InputMaybe<FilterStringInput>;
  location?: InputMaybe<FilterStringInput>;
  marketplace_id?: InputMaybe<FilterIntegerInput>;
  marketplace_name?: InputMaybe<FilterStringInput>;
  membership?: InputMaybe<FilterStringInput>;
  orderApproved?: InputMaybe<Scalars['Boolean']>;
  organization_name?: InputMaybe<FilterStringInput>;
  practitioner_name?: InputMaybe<FilterStringInput>;
  procedure?: InputMaybe<FilterStringInput>;
  status?: InputMaybe<FilterStringInput>;
};

export type AppointmentRequestPage = {
  __typename?: 'AppointmentRequestPage';
  data: Array<AppointmentRequest>;
  totalCount: Scalars['Int'];
};

export type AppointmentRequestPageInput = {
  filter?: InputMaybe<AppointmentRequestFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<AppointmentRequestSortInput>>;
};

export type AppointmentRequestPatient = {
  __typename?: 'AppointmentRequestPatient';
  clientProfile: ClientProfile;
  id: Scalars['ID'];
  procedureBaseDefs: Array<ProcedureBaseDefinition>;
};

export type AppointmentRequestPatientInput = {
  clientProfileId: Scalars['ID'];
  procedureBaseDefIds: Array<Scalars['ID']>;
};

export enum AppointmentRequestSortFields {
  Balance = 'BALANCE',
  ClientName = 'CLIENT_NAME',
  Createdat = 'CREATEDAT',
  Id = 'ID',
  Intakestatus = 'INTAKESTATUS',
  Location = 'LOCATION',
  MarketplaceName = 'MARKETPLACE_NAME',
  Membership = 'MEMBERSHIP',
  Orderapproved = 'ORDERAPPROVED',
  Procedure = 'PROCEDURE',
  Status = 'STATUS',
  Updatedat = 'UPDATEDAT'
}

export type AppointmentRequestSortInput = {
  direction: SortDirection;
  field: AppointmentRequestSortFields;
};

export enum AppointmentRequestStatus {
  Cancelled = 'CANCELLED',
  Fulfilled = 'FULFILLED',
  Pending = 'PENDING',
  PendingApproval = 'PENDING_APPROVAL',
  Waitlist = 'WAITLIST'
}

export type AppointmentResponse = {
  __typename?: 'AppointmentResponse';
  createdAt: Scalars['DateTime'];
  /** Time for appointment, or requested new end time */
  end?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  /** Time for appointment, or requested new start time */
  start?: Maybe<Scalars['DateTime']>;
  status: ParticipationStatus;
  updatedAt: Scalars['DateTime'];
};

export enum AppointmentSortFields {
  Balance = 'BALANCE',
  ClientName = 'CLIENT_NAME',
  Createdat = 'CREATEDAT',
  Duration = 'DURATION',
  Id = 'ID',
  Intakestatus = 'INTAKESTATUS',
  Location = 'LOCATION',
  Orderapproved = 'ORDERAPPROVED',
  PractitionerName = 'PRACTITIONER_NAME',
  Procedure = 'PROCEDURE',
  Start = 'START',
  Status = 'STATUS',
  Updatedat = 'UPDATEDAT'
}

export type AppointmentSortInput = {
  direction: SortDirection;
  field: AppointmentSortFields;
};

export enum AppointmentStatus {
  Booked = 'BOOKED',
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Noshow = 'NOSHOW',
  Pending = 'PENDING'
}

export type AppointmentTimeRange = {
  __typename?: 'AppointmentTimeRange';
  end: Scalars['DateTime'];
  fixedStart: Scalars['Boolean'];
  id: Scalars['ID'];
  start: Scalars['DateTime'];
};

export type AppointmentTimeRangeInput = {
  end: Scalars['DateTime'];
  fixedStart?: InputMaybe<Scalars['Boolean']>;
  start: Scalars['DateTime'];
};

export type ApproveAppointmentRequestInput = {
  appointmentRequestId: Scalars['ID'];
};

export type ArchiveAppointmentInput = {
  appointmentId: Scalars['ID'];
  reason?: InputMaybe<Scalars['String']>;
};

export type ArchiveAppointmentRequestInput = {
  appointmentRequestId: Scalars['ID'];
};

export type ArchiveMarketplaceGroupInput = {
  groupId: Scalars['ID'];
};

export type ArchiveMarketplaceInput = {
  marketplaceId: Scalars['ID'];
};

export type ArchiveOrganizationInput = {
  organizationId: Scalars['ID'];
};

export type ArchivePaymentAccountInput = {
  paymentAccountId: Scalars['ID'];
};

export type ArchiveProfileInput = {
  profileId: Scalars['ID'];
};

export type AssignEmrInstanceInput = {
  emrInstanceId?: InputMaybe<Scalars['ID']>;
  organizationId: Scalars['ID'];
};

export type AssignPaymentAccountInput = {
  marketplaceId?: InputMaybe<Scalars['ID']>;
  organizationId?: InputMaybe<Scalars['ID']>;
  paymentAccountId: Scalars['ID'];
};

export type AssignProcedureProfileInput = {
  procedureProfileId: Scalars['ID'];
  profileId: Scalars['ID'];
};

export type AssignRoleInput = {
  profileId: Scalars['ID'];
  roleId: Scalars['ID'];
};

export type AttentiveIntegration = {
  __typename?: 'AttentiveIntegration';
  apiKeyDescription?: Maybe<Scalars['String']>;
  appointmentBookedEnabled?: Maybe<Scalars['Boolean']>;
  appointmentBookedEvent?: Maybe<Scalars['String']>;
  appointmentCompletedEnabled?: Maybe<Scalars['Boolean']>;
  appointmentCompletedEvent?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  marketingSignUpUnitId?: Maybe<Scalars['String']>;
  qualiphyTextsEnabled?: Maybe<Scalars['Boolean']>;
  qualiphyTextsEvent?: Maybe<Scalars['String']>;
  transactionalSignUpUnitId?: Maybe<Scalars['String']>;
};

export type AuthenticateInput = {
  email: Scalars['String'];
  ignoreTrustedDevice?: InputMaybe<Scalars['Boolean']>;
  password: Scalars['String'];
};

export type AuthenticatePayload = {
  __typename?: 'AuthenticatePayload';
  accessToken: Scalars['String'];
  refreshToken: Scalars['String'];
  user: User;
};

export type Availability = {
  __typename?: 'Availability';
  createdAt: Scalars['DateTime'];
  /** Availability length in minutes */
  duration: Scalars['Int'];
  end: Scalars['DateTime'];
  id: Scalars['ID'];
  profileId: Scalars['ID'];
  repeat?: Maybe<RepeatRule>;
  start: Scalars['DateTime'];
  type: AvailabilityType;
  tzid: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type AvailabilityCoverage = {
  __typename?: 'AvailabilityCoverage';
  createdAt: Scalars['DateTime'];
  end: Scalars['DateTime'];
  id: Scalars['ID'];
  label: Scalars['String'];
  organizationId: Scalars['ID'];
  profiles: Array<ProcedureProfile>;
  repeat?: Maybe<RepeatRule>;
  start: Scalars['DateTime'];
  threshold: Scalars['Int'];
  tzid: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type AvailabilityCoverageRange = {
  __typename?: 'AvailabilityCoverageRange';
  end: Scalars['DateTime'];
  id: Scalars['ID'];
  label: Scalars['String'];
  procedureProfileIds: Array<Scalars['ID']>;
  start: Scalars['DateTime'];
  type: CoverageType;
  tzid: Scalars['String'];
};

export type AvailabilityCoverageRangeInput = {
  dateRange: Array<Scalars['DateTime']>;
  profileId?: InputMaybe<Scalars['ID']>;
};

export enum AvailabilityType {
  Available = 'AVAILABLE',
  Unavailable = 'UNAVAILABLE'
}

export enum BookingMode {
  SpecificTime = 'specific_time',
  Window = 'window'
}

export type CancelAppointmentGroupInput = {
  customRefundAmount?: InputMaybe<Scalars['Int']>;
  groupId: Scalars['String'];
  reason?: InputMaybe<Scalars['String']>;
  refundType?: InputMaybe<AppointmentRefundType>;
};

export type CancelAppointmentInput = {
  appointmentId: Scalars['ID'];
  customRefundAmount?: InputMaybe<Scalars['Int']>;
  reason?: InputMaybe<Scalars['String']>;
  refundType?: InputMaybe<AppointmentRefundType>;
};

export type CancelAppointmentRequestInput = {
  appointmentRequestId: Scalars['ID'];
  reason?: InputMaybe<Scalars['String']>;
};

export type ChangeEmailInput = {
  token: Scalars['String'];
};

export type ChartData = {
  __typename?: 'ChartData';
  datasets: Array<Dataset>;
  labels: Array<Scalars['String']>;
};

export type Checkout = {
  __typename?: 'Checkout';
  appointment?: Maybe<Appointment>;
  appointmentRequest?: Maybe<AppointmentRequest>;
  archivedAt?: Maybe<Scalars['DateTime']>;
  balance: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  items: Array<CheckoutItem>;
  marketplace?: Maybe<Marketplace>;
  marketplaceId?: Maybe<Scalars['ID']>;
  marketplaceUser?: Maybe<MarketplaceUser>;
  marketplaceUserId?: Maybe<Scalars['ID']>;
  paid: Scalars['Int'];
  paymentInstrument?: Maybe<PaymentInstrument>;
  paymentLinks: Array<PaymentLink>;
  paymentMethodType?: Maybe<PaymentMethodType>;
  payments: Array<Payment>;
  payouts: Array<Payout>;
  summary?: Maybe<Scalars['String']>;
  total: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
  voidedAt?: Maybe<Scalars['DateTime']>;
};

export type CheckoutFilterInput = {
  balance?: InputMaybe<FilterStringInput>;
  fullName?: InputMaybe<FilterStringInput>;
  id?: InputMaybe<FilterIntegerInput>;
  marketplaceId?: InputMaybe<FilterIntegerInput>;
  paid?: InputMaybe<FilterStringInput>;
  summary?: InputMaybe<FilterStringInput>;
  total?: InputMaybe<FilterStringInput>;
};

export type CheckoutItem = {
  __typename?: 'CheckoutItem';
  createdAt: Scalars['DateTime'];
  description: Scalars['String'];
  id: Scalars['ID'];
  key?: Maybe<Scalars['String']>;
  price: Scalars['Int'];
  quantity: Scalars['Int'];
  type: CheckoutItemType;
  updatedAt: Scalars['DateTime'];
};

export type CheckoutItemInput = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  price?: InputMaybe<Scalars['Int']>;
  quantity?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<CheckoutItemType>;
};

export enum CheckoutItemType {
  Discount = 'DISCOUNT',
  Gratuity = 'GRATUITY',
  Membership = 'MEMBERSHIP',
  Other = 'OTHER',
  Package = 'PACKAGE',
  PackageCredit = 'PACKAGE_CREDIT',
  Procedure = 'PROCEDURE',
  PromoCode = 'PROMO_CODE',
  Refund = 'REFUND',
  TravelFee = 'TRAVEL_FEE'
}

export type CheckoutNoteItem = {
  __typename?: 'CheckoutNoteItem';
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  index: Scalars['Int'];
  label: Scalars['String'];
  options?: Maybe<Scalars['String']>;
  type: FormItemType;
  updatedAt: Scalars['DateTime'];
};

export type CheckoutNoteItemInput = {
  id?: InputMaybe<Scalars['ID']>;
  label: Scalars['String'];
  options?: InputMaybe<Scalars['String']>;
  type: FormItemType;
};

export type CheckoutPage = {
  __typename?: 'CheckoutPage';
  data: Array<Checkout>;
  totalCount: Scalars['Int'];
};

export type CheckoutPageInput = {
  filter?: InputMaybe<CheckoutFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<CheckoutSortInput>>;
};

export enum CheckoutSortField {
  Balance = 'BALANCE',
  Createdat = 'CREATEDAT',
  Fullname = 'FULLNAME',
  Id = 'ID',
  Marketplaceid = 'MARKETPLACEID',
  Paid = 'PAID',
  Summary = 'SUMMARY',
  Total = 'TOTAL',
  Updatedat = 'UPDATEDAT'
}

export type CheckoutSortInput = {
  direction: SortDirection;
  field: CheckoutSortField;
};

export type ClientProfile = {
  __typename?: 'ClientProfile';
  address: Scalars['String'];
  appointments: Array<Appointment>;
  archivedAt?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  dob: Scalars['String'];
  email: Scalars['String'];
  familyName: Scalars['String'];
  givenName: Scalars['String'];
  id: Scalars['ID'];
  intakeSubmissions: Array<IntakeSubmission>;
  internalNotes?: Maybe<Scalars['String']>;
  internalNotesUpdatedAt?: Maybe<Scalars['DateTime']>;
  internalNotesUpdatedBy?: Maybe<Scalars['String']>;
  marketplaceUserId?: Maybe<Scalars['ID']>;
  marketplaceUsers: Array<MarketplaceUser>;
  membership: Scalars['String'];
  organizations: Array<Organization>;
  patient?: Maybe<Patient>;
  phone: Scalars['String'];
  sexAssignedAtBirth?: Maybe<Scalars['String']>;
  tzid: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};


export type ClientProfileAppointmentsArgs = {
  limit?: InputMaybe<Scalars['Float']>;
  page?: InputMaybe<AppointmentPageInput>;
};


export type ClientProfileMarketplaceUsersArgs = {
  groupId?: InputMaybe<Scalars['ID']>;
};

export type ClientProfileFilterInput = {
  address?: InputMaybe<FilterStringInput>;
  email?: InputMaybe<FilterStringInput>;
  familyName?: InputMaybe<FilterStringInput>;
  fullName?: InputMaybe<FilterStringInput>;
  givenName?: InputMaybe<FilterStringInput>;
  id?: InputMaybe<FilterIntegerInput>;
  marketplaceGroup?: InputMaybe<FilterIntegerInput>;
  organization?: InputMaybe<FilterIntegerInput>;
  phone?: InputMaybe<FilterStringInput>;
};

export type ClientProfileInput = {
  address?: InputMaybe<Scalars['String']>;
  /** yyyy-mm-dd */
  dob?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  familyName?: InputMaybe<Scalars['String']>;
  givenName?: InputMaybe<Scalars['String']>;
  internalNotes?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  sexAssignedAtBirth?: InputMaybe<Scalars['String']>;
  tzid?: InputMaybe<Scalars['String']>;
};

export type ClientProfilePage = {
  __typename?: 'ClientProfilePage';
  data: Array<ClientProfile>;
  totalCount: Scalars['Int'];
};

export type ClientProfilePageInput = {
  filter?: InputMaybe<ClientProfileFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<ClientProfileSortInput>>;
};

export type ClientProfileRequiredInput = {
  address: Scalars['String'];
  /** yyyy-mm-dd */
  dob: Scalars['String'];
  email: Scalars['String'];
  familyName: Scalars['String'];
  givenName: Scalars['String'];
  internalNotes?: InputMaybe<Scalars['String']>;
  phone: Scalars['String'];
  sexAssignedAtBirth?: InputMaybe<Scalars['String']>;
  tzid: Scalars['String'];
};

export enum ClientProfileSortFields {
  Address = 'ADDRESS',
  Createdat = 'CREATEDAT',
  Dob = 'DOB',
  Email = 'EMAIL',
  Familyname = 'FAMILYNAME',
  Fullname = 'FULLNAME',
  Givenname = 'GIVENNAME',
  Id = 'ID',
  Phone = 'PHONE',
  Updatedat = 'UPDATEDAT'
}

export type ClientProfileSortInput = {
  direction: SortDirection;
  field: ClientProfileSortFields;
};

export type ClinicalProcedure = {
  __typename?: 'ClinicalProcedure';
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  name: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type CompleteAppointmentInput = {
  appointmentId: Scalars['ID'];
  completedAt?: InputMaybe<Scalars['DateTime']>;
  startedAt?: InputMaybe<Scalars['DateTime']>;
};

export type CompleteCheckoutInput = {
  amount?: InputMaybe<Scalars['Int']>;
  checkoutId: Scalars['ID'];
  expectedAmount?: InputMaybe<Scalars['Int']>;
  paymentMethod?: InputMaybe<PaymentMethodInput>;
};

export type Condition = {
  __typename?: 'Condition';
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  name: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type ConfirmConsumerEmailInput = {
  marketplaceId: Scalars['ID'];
  token: Scalars['String'];
};

export type ConfirmConsumerPhoneInput = {
  code: Scalars['String'];
  marketplaceId: Scalars['ID'];
  marketplaceUserId: Scalars['ID'];
};

export type ConfirmTotpEnrollmentInput = {
  challengeId?: InputMaybe<Scalars['String']>;
  code: Scalars['String'];
  enrollmentId: Scalars['ID'];
};

export type ConfirmTotpEnrollmentPayload = {
  __typename?: 'ConfirmTotpEnrollmentPayload';
  accessToken: Scalars['String'];
  recoveryCodes: Array<Scalars['String']>;
  refreshToken: Scalars['String'];
};

export type ConsentResult = {
  __typename?: 'ConsentResult';
  marketing: Scalars['Boolean'];
};

export type CopyOrganizationInput = {
  name: Scalars['String'];
  ownerEmails: Array<Scalars['String']>;
  sourceOrganizationId: Scalars['ID'];
  tzid?: InputMaybe<Scalars['String']>;
};

export type CopyOrganizationResult = {
  __typename?: 'CopyOrganizationResult';
  failures: Array<Scalars['String']>;
  marketplaces: Scalars['Int'];
  medications: Scalars['Int'];
  organization: Organization;
  procedureDefs: Scalars['Int'];
  procedureProfiles: Scalars['Int'];
};

export enum CoverageType {
  Covered = 'COVERED',
  NoCoverage = 'NO_COVERAGE',
  UnderCovered = 'UNDER_COVERED'
}

export type CreateAllergyIntoleranceInput = {
  name: Scalars['String'];
  patientId: Scalars['ID'];
};

export type CreateApiKeyInput = {
  name: Scalars['String'];
  roleIds: Array<Scalars['ID']>;
  userId: Scalars['ID'];
};

export type CreateApiKeyPayload = {
  __typename?: 'CreateApiKeyPayload';
  apiKey: ApiKey;
  privateKey: Scalars['String'];
};

export type CreateApplePaySessionInput = {
  displayName: Scalars['String'];
  domain: Scalars['String'];
  validationUrl: Scalars['String'];
};

export type CreateAppointmentCheckoutPayload = {
  __typename?: 'CreateAppointmentCheckoutPayload';
  checkout: Checkout;
  errorMessage?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type CreateAppointmentInput = {
  /** Additional patients beyond the primary in `participants`. When non-empty, a group is materialized: the primary gets a fresh groupId and one sibling appointment is inserted per additional patient. */
  additionalPatients?: InputMaybe<Array<CreateAppointmentPatientInput>>;
  allowOverlap?: InputMaybe<Scalars['Boolean']>;
  constraintId?: InputMaybe<Scalars['ID']>;
  createdBy?: InputMaybe<Scalars['ID']>;
  end: Scalars['DateTime'];
  location: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  participants: Array<AppointmentParticipantInput>;
  procedureBaseDefIds: Array<Scalars['ID']>;
  start: Scalars['DateTime'];
  status?: InputMaybe<AppointmentStatus>;
};

export type CreateAppointmentPatientInput = {
  clientProfileId: Scalars['ID'];
  procedureBaseDefIds: Array<Scalars['ID']>;
};

export type CreateAppointmentRequestInput = {
  /** Additional patients beyond the primary booker (clientProfileIds[0]). Each gets their own procedures; all share location, schedule, and practitioner. */
  additionalPatients?: InputMaybe<Array<AppointmentRequestPatientInput>>;
  bookingMode?: InputMaybe<BookingMode>;
  checkoutNotes?: InputMaybe<Scalars['JSONObject']>;
  checkoutSessionId?: InputMaybe<Scalars['String']>;
  clientProfileIds: Array<Scalars['ID']>;
  constraints: Array<AppointmentConstraintInput>;
  gratuity?: InputMaybe<Scalars['Int']>;
  ip?: InputMaybe<Scalars['String']>;
  location: Scalars['String'];
  marketingConsents?: InputMaybe<Array<MarketingConsentInput>>;
  marketplaceId: Scalars['ID'];
  marketplaceUserId?: InputMaybe<Scalars['ID']>;
  notes?: InputMaybe<Scalars['String']>;
  paymentMethod?: InputMaybe<PaymentMethodInput>;
  procedureBaseDefIds: Array<Scalars['ID']>;
  promoCode?: InputMaybe<Scalars['String']>;
  userAgent?: InputMaybe<Scalars['String']>;
};

export type CreateAttachmentInput = {
  filename: Scalars['String'];
  formId?: InputMaybe<Scalars['ID']>;
  label: Scalars['String'];
  patientId?: InputMaybe<Scalars['ID']>;
  /** document file token */
  token: Scalars['String'];
};

export type CreateAvailabilityCoverageInput = {
  end: Scalars['DateTime'];
  label: Scalars['String'];
  organizationId: Scalars['ID'];
  procedureProfileIds: Array<Scalars['ID']>;
  repeat?: InputMaybe<RepeatRuleInput>;
  start: Scalars['DateTime'];
  threshold: Scalars['Int'];
  tzid: Scalars['String'];
};

export type CreateAvailabilityInput = {
  end: Scalars['DateTime'];
  profileId: Scalars['ID'];
  repeat?: InputMaybe<RepeatRuleInput>;
  start: Scalars['DateTime'];
  type: AvailabilityType;
};

export type CreateClientProfileInput = {
  address: Scalars['String'];
  /** yyyy-mm-dd */
  dob: Scalars['String'];
  email: Scalars['String'];
  familyName: Scalars['String'];
  givenName: Scalars['String'];
  internalNotes?: InputMaybe<Scalars['String']>;
  organizationId: Scalars['ID'];
  phone: Scalars['String'];
  sexAssignedAtBirth?: InputMaybe<Scalars['String']>;
  tzid: Scalars['String'];
};

export type CreateClinicalProcedureInput = {
  name: Scalars['String'];
  patientId: Scalars['ID'];
};

export type CreateConditionInput = {
  name: Scalars['String'];
  patientId: Scalars['ID'];
};

export type CreateDiscountInput = {
  membershipDefinitionId: Scalars['ID'];
  percentage: Scalars['Int'];
  procedureGroupIds: Array<Scalars['String']>;
};

export type CreateDocumentInput = {
  emrInstanceId: Scalars['ID'];
  filename: Scalars['String'];
  label?: InputMaybe<Scalars['String']>;
  /** document file token */
  token: Scalars['String'];
  type: DocumentType;
};

export type CreateEmrInstanceInput = {
  label: Scalars['String'];
};

export type CreateFormNoteInput = {
  formId: Scalars['ID'];
  note: Scalars['String'];
  profileId: Scalars['ID'];
};

export type CreateFormTemplateInput = {
  emrInstanceId: Scalars['ID'];
  items: Array<FormTemplateItemInput>;
  name: Scalars['String'];
  parentId?: InputMaybe<Scalars['ID']>;
  type: FormType;
};

export type CreateGeoperimeterInput = {
  lat?: InputMaybe<Scalars['Float']>;
  lng?: InputMaybe<Scalars['Float']>;
  organizationId: Scalars['ID'];
  paths?: InputMaybe<Scalars['String']>;
  radius?: InputMaybe<Scalars['Float']>;
  travelFee?: InputMaybe<Scalars['Int']>;
  type: GeoperimeterType;
};

export type CreateImmunizationInput = {
  name: Scalars['String'];
  patientId: Scalars['ID'];
};

export type CreateIntakeSubmissionNoteInput = {
  note: Scalars['String'];
  submissionId: Scalars['ID'];
};

export type CreateLabInput = {
  name: Scalars['String'];
  patientId: Scalars['ID'];
};

export type CreateMarketplaceInput = {
  bookingMode?: InputMaybe<BookingMode>;
  consentTokenSecret?: InputMaybe<Scalars['String']>;
  dispatchStrategy?: InputMaybe<DispatchStrategy>;
  faviconToken?: InputMaybe<Scalars['String']>;
  featureFlags?: InputMaybe<MarketplaceFeatureFlagsInput>;
  feeProfileBasisPoints?: InputMaybe<Scalars['Int']>;
  feeProfileFixed?: InputMaybe<Scalars['Int']>;
  groupId?: InputMaybe<Scalars['ID']>;
  gtmContainer?: InputMaybe<Scalars['String']>;
  gtmDataTier?: InputMaybe<GtmDataTier>;
  gtmRequiresConsent?: InputMaybe<Scalars['Boolean']>;
  gtmV2Enabled?: InputMaybe<Scalars['Boolean']>;
  hasPaymentPolicy?: InputMaybe<Scalars['Boolean']>;
  logoToken?: InputMaybe<Scalars['String']>;
  marketingSiteUrl?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  organizationIds?: InputMaybe<Array<Scalars['ID']>>;
  ownerProfileIds?: InputMaybe<Array<Scalars['ID']>>;
  paymentCollectionMethod?: InputMaybe<PaymentCollectionMethod>;
  paymentDepositType?: InputMaybe<PaymentDepositType>;
  paymentDepositValue?: InputMaybe<Scalars['Float']>;
  paymentPolicyName?: InputMaybe<Scalars['String']>;
  paymentPolicyText?: InputMaybe<Scalars['String']>;
  primaryColor?: InputMaybe<Scalars['String']>;
  requireDispatchApproval?: InputMaybe<Scalars['Boolean']>;
  requirePaymentPolicyAttestation?: InputMaybe<Scalars['Boolean']>;
  requirePractitionerApproval?: InputMaybe<Scalars['Boolean']>;
  reviewsIoKey?: InputMaybe<Scalars['String']>;
  reviewsIoStoreId?: InputMaybe<Scalars['String']>;
  slackWebhookUrl?: InputMaybe<Scalars['String']>;
};

export type CreateMarketplaceUserInput = {
  clientProfile: ClientProfileRequiredInput;
  consumerSignup?: InputMaybe<Scalars['Boolean']>;
  email?: InputMaybe<Scalars['String']>;
  emailConfirmed?: InputMaybe<Scalars['Boolean']>;
  emailOptIn?: InputMaybe<Scalars['Boolean']>;
  groupId: Scalars['ID'];
  phone?: InputMaybe<Scalars['String']>;
  phoneConfirmed?: InputMaybe<Scalars['Boolean']>;
  phoneOptIn?: InputMaybe<Scalars['Boolean']>;
};

export type CreateMedicationInput = {
  name: Scalars['String'];
  organizationId: Scalars['ID'];
  unit: Scalars['String'];
};

export type CreateMedicationStatementInput = {
  name: Scalars['String'];
  patientId: Scalars['ID'];
};

export type CreateMembershipDefinitionInput = {
  advertise: Scalars['Boolean'];
  description?: InputMaybe<Scalars['String']>;
  list?: InputMaybe<Scalars['String']>;
  marketplaceId: Scalars['ID'];
  name: Scalars['String'];
  packageId?: InputMaybe<Scalars['ID']>;
  period: MembershipDefinitionPeriodType;
  price: Scalars['Int'];
};

export type CreateMembershipInput = {
  marketplaceUserId: Scalars['ID'];
  membershipDefinitionId: Scalars['ID'];
  paymentInstrumentId?: InputMaybe<Scalars['ID']>;
  start?: InputMaybe<Scalars['DateTime']>;
  status: MembershipStatusType;
};

export type CreateObservationsInput = {
  createdById: Scalars['ID'];
  formId: Scalars['ID'];
  observations: Array<ObservationInput>;
};

export type CreateOrderInput = {
  expiresAt: Scalars['DateTime'];
  note?: InputMaybe<Scalars['String']>;
  patientId: Scalars['ID'];
  procedureDefIds?: InputMaybe<Array<Scalars['ID']>>;
  profileId: Scalars['ID'];
  refills: Scalars['Int'];
  startsAt?: InputMaybe<Scalars['DateTime']>;
};

export type CreateOrganizationInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  address?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  emrInstanceId?: InputMaybe<Scalars['ID']>;
  enablePractitionerSms?: InputMaybe<Scalars['Boolean']>;
  enableReceiptSending?: InputMaybe<Scalars['Boolean']>;
  googleReviewsUrl?: InputMaybe<Scalars['String']>;
  intakeAutoSendMode?: InputMaybe<IntakeAutoSendMode>;
  intakeDeliveryChannel?: InputMaybe<IntakeDeliveryChannel>;
  intakeSmsTemplate?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  ownerEmails: Array<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  providesAtClinic?: InputMaybe<Scalars['Boolean']>;
  qualiphyApiKey?: InputMaybe<Scalars['String']>;
  slackWebhookUrl?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<StateCode>;
  tzid: Scalars['String'];
};

export type CreatePackageInput = {
  advertise: Scalars['Boolean'];
  description?: InputMaybe<Scalars['String']>;
  list?: InputMaybe<Scalars['String']>;
  marketplaceId: Scalars['ID'];
  name: Scalars['String'];
  price: Scalars['Int'];
};

export type CreatePackageItemDefinitionInput = {
  packageId: Scalars['ID'];
  points: Scalars['Int'];
  procedureGroupIds: Array<Scalars['ID']>;
};

export type CreatePatientInput = {
  clientProfileId: Scalars['ID'];
};

export type CreatePaymentAccountInput = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  label: Scalars['String'];
  marketplaceId?: InputMaybe<Scalars['ID']>;
  organizationId?: InputMaybe<Scalars['ID']>;
};

export type CreateProcedureBaseDefinitionGroupInput = {
  bannerToken?: InputMaybe<Scalars['String']>;
  bgcolor?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  fontColor?: InputMaybe<Scalars['String']>;
  marketplaceId: Scalars['ID'];
  name: Scalars['String'];
  thumbnailToken?: InputMaybe<Scalars['String']>;
  type: ProcedureGroupType;
};

export type CreateProcedureBaseDefinitionInput = {
  category?: InputMaybe<Scalars['String']>;
  description: Scalars['String'];
  duration: Scalars['Float'];
  ingredients?: InputMaybe<Scalars['String']>;
  marketplaceId: Scalars['ID'];
  name: Scalars['String'];
  points?: InputMaybe<Scalars['Float']>;
  tagline?: InputMaybe<Scalars['String']>;
  thumbnailToken?: InputMaybe<Scalars['String']>;
};

export type CreateProcedureDefinitionInput = {
  assessmentFormTemplateId?: InputMaybe<Scalars['ID']>;
  baseDefinitionIds?: InputMaybe<Array<Scalars['ID']>>;
  consentFormIds?: InputMaybe<Array<Scalars['ID']>>;
  description: Scalars['String'];
  duration: Scalars['Float'];
  intakeFormTemplateIds?: InputMaybe<Array<Scalars['ID']>>;
  interventionFormTemplateId?: InputMaybe<Scalars['ID']>;
  medicationProtocols?: InputMaybe<Array<MedicationProtocolInput>>;
  name: Scalars['String'];
  ordersRequired?: InputMaybe<Scalars['Boolean']>;
  organizationId: Scalars['ID'];
  price: Scalars['Float'];
};

export type CreateProcedureProfileInput = {
  name: Scalars['String'];
  organizationId: Scalars['ID'];
  procedureDefIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type CreateProfileInput = {
  address?: InputMaybe<Scalars['String']>;
  allowSmsNotifications?: InputMaybe<Scalars['Boolean']>;
  availableUntil?: InputMaybe<Scalars['DateTime']>;
  color?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  familyName?: InputMaybe<Scalars['String']>;
  givenName?: InputMaybe<Scalars['String']>;
  organizationId: Scalars['ID'];
  phone?: InputMaybe<Scalars['String']>;
  roleId: Scalars['ID'];
  sendInvitation?: InputMaybe<Scalars['Boolean']>;
  title?: InputMaybe<Scalars['String']>;
  tzid?: InputMaybe<Scalars['String']>;
};

export type CreatePromoCodeInput = {
  activationEndDate: Scalars['String'];
  activationStartDate: Scalars['String'];
  active?: InputMaybe<Scalars['Boolean']>;
  code?: InputMaybe<Scalars['String']>;
  discountType: PromoCodeDiscountType;
  discountValue: Scalars['Int'];
  marketplaceId: Scalars['ID'];
  minimumBookingAmount?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  organizationIds?: InputMaybe<Array<Scalars['String']>>;
  procedureGroupIds?: InputMaybe<Array<Scalars['String']>>;
  usageEndDate: Scalars['String'];
  usageLimitPerUser?: InputMaybe<Scalars['Int']>;
  usageLimitTotal?: InputMaybe<Scalars['Int']>;
  usageStartDate: Scalars['String'];
};

export type CreateReachIntegrationInput = {
  marketplaceId: Scalars['ID'];
};

export type CreateRoleInput = {
  name: Scalars['String'];
  permissions: Array<Scalars['String']>;
  resourceId?: InputMaybe<Scalars['ID']>;
  scope: RoleScope;
};

export type CreateUploadUrlInput = {
  contentType: Scalars['String'];
};

export type CreateUploadUrlPayload = {
  __typename?: 'CreateUploadUrlPayload';
  /** Inputs to include with the form data */
  fields: Scalars['String'];
  /** A token used to later attach the file to a document */
  token: Scalars['String'];
  /** Send an HTTP POST request to this URL, with the file and form fields encoded as multipart/form-data */
  url: Scalars['String'];
};

export type CreateUserInput = {
  email: Scalars['String'];
};

export type CreateVitalsInput = {
  createdById: Scalars['ID'];
  patientId: Scalars['ID'];
  recordedAt: Scalars['DateTime'];
  vitals: Array<VitalSignInput>;
};

export type Dataset = {
  __typename?: 'Dataset';
  backgroundColor: Array<Scalars['String']>;
  borderColor: Array<Scalars['String']>;
  data: Array<Scalars['Int']>;
  label: Scalars['String'];
};

export type DeactivatePaymentLinkInput = {
  paymentLinkId: Scalars['ID'];
};

export type DeclineAppointmentInput = {
  appointmentId: Scalars['ID'];
  profileId: Scalars['ID'];
};

export type Discount = {
  __typename?: 'Discount';
  archivedAt?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  membershipDefinitionId: Scalars['ID'];
  percentage: Scalars['Int'];
  procedureGroups: Array<ProcedureBaseDefinitionGroup>;
  updatedAt: Scalars['DateTime'];
};

export enum DispatchStrategy {
  Default = 'default',
  Open = 'open'
}

export type Document = {
  __typename?: 'Document';
  archivedAt?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  fileSize: Scalars['Int'];
  filename: Scalars['String'];
  id: Scalars['ID'];
  label: Scalars['String'];
  signatures: Array<DocumentSignature>;
  type: DocumentType;
  updatedAt: Scalars['DateTime'];
  url: Scalars['String'];
  version: Scalars['Int'];
};

export type DocumentSignature = {
  __typename?: 'DocumentSignature';
  archivedAt?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  documentId: Scalars['ID'];
  documentLabel: Scalars['String'];
  id: Scalars['ID'];
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  signedAt: Scalars['DateTime'];
  signerEmail?: Maybe<Scalars['String']>;
  signerName: Scalars['String'];
  signerType: DocumentSignatureSignerType;
  tzid: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  url?: Maybe<Scalars['String']>;
  verificationDetail?: Maybe<Scalars['String']>;
  verificationType: DocumentSignatureVerificationType;
  version: Scalars['Int'];
};

export enum DocumentSignatureSignerType {
  Patient = 'PATIENT'
}

export enum DocumentSignatureVerificationType {
  Email = 'EMAIL',
  Witness = 'WITNESS'
}

export enum DocumentType {
  Attachment = 'ATTACHMENT',
  ChartForm = 'CHART_FORM',
  ConsentForm = 'CONSENT_FORM',
  IntakeForm = 'INTAKE_FORM'
}

export type EmrInstance = {
  __typename?: 'EmrInstance';
  archivedAt?: Maybe<Scalars['DateTime']>;
  consentForms: Array<Document>;
  createdAt: Scalars['DateTime'];
  formTemplates: Array<FormTemplate>;
  id: Scalars['ID'];
  label: Scalars['String'];
  organizations: Array<Organization>;
  updatedAt: Scalars['DateTime'];
};

export type FcmTokenInput = {
  token: Scalars['String'];
};

export type FilterDateInput = {
  between?: InputMaybe<Array<Scalars['DateTime']>>;
  gte?: InputMaybe<Scalars['DateTime']>;
  lte?: InputMaybe<Scalars['DateTime']>;
};

export type FilterIntegerInput = {
  between?: InputMaybe<Array<Scalars['Int']>>;
  eq?: InputMaybe<Scalars['Int']>;
  gt?: InputMaybe<Scalars['Int']>;
  gte?: InputMaybe<Scalars['Int']>;
  lt?: InputMaybe<Scalars['Int']>;
  lte?: InputMaybe<Scalars['Int']>;
  notBetween?: InputMaybe<Array<Scalars['Int']>>;
  oneOf?: InputMaybe<Array<Scalars['Int']>>;
};

export type FilterStringInput = {
  contains?: InputMaybe<Array<Scalars['String']>>;
  containsAll?: InputMaybe<Array<Scalars['String']>>;
  exact?: InputMaybe<Array<Scalars['String']>>;
};

export type FinishPasskeyRegistrationInput = {
  challengeId?: InputMaybe<Scalars['String']>;
  credential: Scalars['JSONObject'];
  label?: InputMaybe<Scalars['String']>;
};

export type FinishPasskeyRegistrationPayload = {
  __typename?: 'FinishPasskeyRegistrationPayload';
  accessToken: Scalars['String'];
  factor: MfaFactor;
  recoveryCodes: Array<Scalars['String']>;
  refreshToken: Scalars['String'];
};

export type Form = {
  __typename?: 'Form';
  archivedAt?: Maybe<Scalars['DateTime']>;
  attachments?: Maybe<Array<Document>>;
  createdAt: Scalars['DateTime'];
  document?: Maybe<Document>;
  editable: Scalars['Boolean'];
  id: Scalars['ID'];
  items: Array<FormItem>;
  lockedAt?: Maybe<Scalars['DateTime']>;
  lockedBy?: Maybe<Profile>;
  lockedById?: Maybe<Scalars['ID']>;
  notes: Array<FormNote>;
  observations: Array<Observation>;
  patientId: Scalars['ID'];
  providers: Array<Profile>;
  status: FormStatusType;
  type: FormType;
  updatedAt: Scalars['DateTime'];
};

export type FormItem = {
  __typename?: 'FormItem';
  code: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  index: Scalars['Int'];
  label: Scalars['String'];
  options?: Maybe<Scalars['String']>;
  type: FormItemType;
  updatedAt: Scalars['DateTime'];
};

export enum FormItemType {
  Boolean = 'BOOLEAN',
  Datetime = 'DATETIME',
  FileUpload = 'FILE_UPLOAD',
  Header = 'HEADER',
  Multiselect = 'MULTISELECT',
  Select = 'SELECT',
  Text = 'TEXT'
}

export type FormNote = {
  __typename?: 'FormNote';
  archivedAt?: Maybe<Scalars['DateTime']>;
  author: Scalars['String'];
  createdAt: Scalars['DateTime'];
  edited: Scalars['Boolean'];
  id: Scalars['ID'];
  note: Scalars['String'];
  profileId: Scalars['ID'];
  updatedAt: Scalars['DateTime'];
};

export enum FormStatusType {
  Created = 'CREATED',
  Locked = 'LOCKED',
  Unlocked = 'UNLOCKED'
}

export type FormTemplate = {
  __typename?: 'FormTemplate';
  archivedAt?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  items: Array<FormTemplateItem>;
  name: Scalars['String'];
  parentId?: Maybe<Scalars['ID']>;
  type: FormType;
  updatedAt: Scalars['DateTime'];
};

export type FormTemplateItem = {
  __typename?: 'FormTemplateItem';
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  index: Scalars['Int'];
  label: Scalars['String'];
  options?: Maybe<Scalars['String']>;
  type: FormItemType;
  updatedAt: Scalars['DateTime'];
};

export type FormTemplateItemInput = {
  id?: InputMaybe<Scalars['ID']>;
  label: Scalars['String'];
  options?: InputMaybe<Scalars['String']>;
  type: FormItemType;
};

export enum FormType {
  Assessment = 'ASSESSMENT',
  Intake = 'INTAKE',
  Intervention = 'INTERVENTION'
}

export type GeneratePaymentLinkInput = {
  amount?: InputMaybe<Scalars['Int']>;
  checkoutId: Scalars['ID'];
  deliveryMethods?: InputMaybe<PaymentLinkDeliveryMethodsInput>;
};

export type GeneratePaymentLinkPayload = {
  __typename?: 'GeneratePaymentLinkPayload';
  checkout?: Maybe<Checkout>;
  message?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
  url?: Maybe<Scalars['String']>;
};

export type Geoperimeter = {
  __typename?: 'Geoperimeter';
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  lat?: Maybe<Scalars['Float']>;
  lng?: Maybe<Scalars['Float']>;
  organizationId: Scalars['ID'];
  paths?: Maybe<Scalars['String']>;
  radius?: Maybe<Scalars['Float']>;
  travelFee?: Maybe<Scalars['Int']>;
  type: GeoperimeterType;
  updatedAt: Scalars['DateTime'];
};

export enum GeoperimeterType {
  Circle = 'CIRCLE',
  Polygon = 'POLYGON'
}

export type GrantPackageInput = {
  expiresAt?: InputMaybe<Scalars['DateTime']>;
  marketplaceUserId: Scalars['ID'];
  packageId: Scalars['ID'];
  paymentMethod?: InputMaybe<PaymentMethodInput>;
  primaryOrganizationId?: InputMaybe<Scalars['ID']>;
};

export enum GtmDataTier {
  Commerce = 'commerce',
  Minimal = 'minimal'
}

export type Immunization = {
  __typename?: 'Immunization';
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  name: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export enum IntakeAutoSendMode {
  Always = 'ALWAYS',
  ManualOnly = 'MANUAL_ONLY',
  OrdersGated = 'ORDERS_GATED'
}

export type IntakeChannelOutcome = {
  __typename?: 'IntakeChannelOutcome';
  destination?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  sent: Scalars['Boolean'];
};

export enum IntakeDeliveryChannel {
  Both = 'BOTH',
  Email = 'EMAIL',
  Sms = 'SMS'
}

export type IntakeReviewEvent = {
  __typename?: 'IntakeReviewEvent';
  author: Scalars['String'];
  createdAt: Scalars['DateTime'];
  fromReviewStatus?: Maybe<IntakeReviewStatus>;
  id: Scalars['ID'];
  profileId: Scalars['ID'];
  toReviewStatus: IntakeReviewStatus;
  updatedAt: Scalars['DateTime'];
};

export enum IntakeReviewStatus {
  Approved = 'APPROVED',
  Rejected = 'REJECTED'
}

export type IntakeSubmission = {
  __typename?: 'IntakeSubmission';
  appointment?: Maybe<Appointment>;
  appointmentId: Scalars['ID'];
  appointmentParticipantId: Scalars['ID'];
  clientProfileId: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  documentId?: Maybe<Scalars['ID']>;
  emailSentAt?: Maybe<Scalars['DateTime']>;
  flaggedItems?: Maybe<Scalars['String']>;
  formName?: Maybe<Scalars['String']>;
  formTemplateId: Scalars['ID'];
  formUrl?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  items?: Maybe<Array<IntakeSubmissionItem>>;
  marketplaceId: Scalars['ID'];
  notes: Array<IntakeSubmissionNote>;
  pdfUrl?: Maybe<Scalars['String']>;
  reminderSentAt?: Maybe<Scalars['DateTime']>;
  responses?: Maybe<Scalars['String']>;
  reviewEvents: Array<IntakeReviewEvent>;
  reviewNotes?: Maybe<Scalars['String']>;
  reviewStatus?: Maybe<IntakeReviewStatus>;
  reviewedAt?: Maybe<Scalars['DateTime']>;
  reviewedBy?: Maybe<Scalars['ID']>;
  reviewedByName?: Maybe<Scalars['String']>;
  smsSentAt?: Maybe<Scalars['DateTime']>;
  status: IntakeSubmissionStatus;
  submittedAt?: Maybe<Scalars['DateTime']>;
  triggerType: IntakeTriggerType;
  updatedAt: Scalars['DateTime'];
};

export type IntakeSubmissionItem = {
  __typename?: 'IntakeSubmissionItem';
  code: Scalars['String'];
  documentUrls: Array<Maybe<Scalars['String']>>;
  id: Scalars['ID'];
  index: Scalars['Float'];
  label: Scalars['String'];
  options?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export type IntakeSubmissionNote = {
  __typename?: 'IntakeSubmissionNote';
  archivedAt?: Maybe<Scalars['DateTime']>;
  author: Scalars['String'];
  createdAt: Scalars['DateTime'];
  edited: Scalars['Boolean'];
  id: Scalars['ID'];
  note: Scalars['String'];
  profileId: Scalars['ID'];
  updatedAt: Scalars['DateTime'];
};

export enum IntakeSubmissionStatus {
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  NeedsReview = 'NEEDS_REVIEW',
  Reviewed = 'REVIEWED',
  Sent = 'SENT'
}

export enum IntakeTriggerType {
  Auto = 'AUTO',
  Manual = 'MANUAL'
}

export type JoinOrganizationInput = {
  code: Scalars['String'];
};

export type Lab = {
  __typename?: 'Lab';
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  name: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type LeaveOrganizationInput = {
  organizationId: Scalars['ID'];
  userId?: InputMaybe<Scalars['ID']>;
};

export type LinkClientProfileToAccountInput = {
  clientProfileId: Scalars['ID'];
  marketplaceUserId: Scalars['ID'];
};

export type LockFormInput = {
  formId: Scalars['ID'];
  lockedById: Scalars['ID'];
};

export enum MarketingConsentChannel {
  Email = 'EMAIL',
  Sms = 'SMS'
}

export type MarketingConsentInput = {
  channel: MarketingConsentChannel;
  consent: Scalars['Boolean'];
  email?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
};

export type Marketplace = {
  __typename?: 'Marketplace';
  appointmentRequests: AppointmentRequestPage;
  archivedAt?: Maybe<Scalars['DateTime']>;
  attentive?: Maybe<AttentiveIntegration>;
  bookingMode?: Maybe<BookingMode>;
  checkoutContent: MarketplaceCheckoutContent;
  checkoutNotes: Array<CheckoutNoteItem>;
  consentTokenSecretDescription?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  dispatchStrategy?: Maybe<DispatchStrategy>;
  favicon?: Maybe<Scalars['String']>;
  featureFlags: MarketplaceFeatureFlags;
  feeProfileBasisPoints?: Maybe<Scalars['Int']>;
  feeProfileFixed?: Maybe<Scalars['Int']>;
  group: MarketplaceGroup;
  groupId: Scalars['ID'];
  gtmContainer?: Maybe<Scalars['String']>;
  gtmDataTier: GtmDataTier;
  gtmRequiresConsent: Scalars['Boolean'];
  gtmV2Enabled: Scalars['Boolean'];
  hasPaymentPolicy?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  logo?: Maybe<Scalars['String']>;
  marketingSiteUrl?: Maybe<Scalars['String']>;
  membershipDefinitions: Array<MembershipDefinition>;
  mfaMode?: Maybe<MfaScopeMode>;
  name: Scalars['String'];
  navigationGroupId?: Maybe<Scalars['ID']>;
  organizations: Array<Organization>;
  packages: Array<Package>;
  paymentAccountId?: Maybe<Scalars['ID']>;
  paymentAccounts: Array<PaymentAccount>;
  paymentCollectionMethod?: Maybe<PaymentCollectionMethod>;
  paymentDepositType?: Maybe<PaymentDepositType>;
  paymentDepositValue?: Maybe<Scalars['Float']>;
  paymentPolicyName?: Maybe<Scalars['String']>;
  paymentPolicyText?: Maybe<Scalars['String']>;
  primaryColor?: Maybe<Scalars['String']>;
  procedureBaseDefGroups: Array<ProcedureBaseDefinitionGroup>;
  procedureBaseDefs: Array<ProcedureBaseDefinition>;
  reach?: Maybe<ReachIntegration>;
  requireDispatchApproval: Scalars['Boolean'];
  requirePaymentPolicyAttestation?: Maybe<Scalars['Boolean']>;
  requirePractitionerApproval: Scalars['Boolean'];
  reviewsIoKeyDescription?: Maybe<Scalars['String']>;
  reviewsIoStoreId?: Maybe<Scalars['String']>;
  roles: Array<Role>;
  segment?: Maybe<SegmentIntegration>;
  segmentClientWriteKey?: Maybe<Scalars['String']>;
  sendgrid?: Maybe<SendgridIntegration>;
  slackWebhookUrl?: Maybe<Scalars['String']>;
  twilio?: Maybe<TwilioIntegration>;
  updatedAt: Scalars['DateTime'];
};


export type MarketplaceAppointmentRequestsArgs = {
  page?: InputMaybe<AppointmentRequestPageInput>;
};

export type MarketplaceCheckoutContent = {
  __typename?: 'MarketplaceCheckoutContent';
  confirmationMessage?: Maybe<Scalars['String']>;
  footerLinks: Array<MarketplaceFooterLink>;
  scheduleNotice?: Maybe<Scalars['String']>;
  servicesNotice?: Maybe<Scalars['String']>;
};

export type MarketplaceCheckoutContentInput = {
  confirmationMessage?: InputMaybe<Scalars['String']>;
  footerLinks?: InputMaybe<Array<MarketplaceFooterLinkInput>>;
  scheduleNotice?: InputMaybe<Scalars['String']>;
  servicesNotice?: InputMaybe<Scalars['String']>;
};

export type MarketplaceFeatureFlags = {
  __typename?: 'MarketplaceFeatureFlags';
  acceptedPaymentMethods?: Maybe<AcceptedPaymentMethods>;
  waitListEnabled?: Maybe<Scalars['Boolean']>;
  windowBooking?: Maybe<WindowBookingConfig>;
};

export type MarketplaceFeatureFlagsInput = {
  acceptedPaymentMethods?: InputMaybe<AcceptedPaymentMethodsInput>;
  waitListEnabled?: InputMaybe<Scalars['Boolean']>;
  windowBooking?: InputMaybe<WindowBookingConfigInput>;
};

export type MarketplaceFooterLink = {
  __typename?: 'MarketplaceFooterLink';
  label: Scalars['String'];
  url: Scalars['String'];
};

export type MarketplaceFooterLinkInput = {
  label: Scalars['String'];
  url: Scalars['String'];
};

export type MarketplaceGroup = {
  __typename?: 'MarketplaceGroup';
  archivedAt?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  label: Scalars['String'];
  marketplaceUsers: MarketplaceUserPage;
  marketplaces: Array<Marketplace>;
  messagingServiceSid?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


export type MarketplaceGroupMarketplaceUsersArgs = {
  page?: InputMaybe<MarketplaceUserPageInput>;
};

export type MarketplaceUser = {
  __typename?: 'MarketplaceUser';
  appointmentRequests: Array<AppointmentRequest>;
  appointments: Array<Appointment>;
  archivedAt?: Maybe<Scalars['DateTime']>;
  checkouts: Array<Checkout>;
  clientProfile?: Maybe<ClientProfile>;
  clientProfileId: Scalars['ID'];
  clientProfiles: Array<ClientProfile>;
  createdAt: Scalars['DateTime'];
  email?: Maybe<Scalars['String']>;
  emailConfirmed: Scalars['Boolean'];
  emailOptIn: Scalars['Boolean'];
  groupId: Scalars['ID'];
  id: Scalars['ID'];
  marketplaceGroup: MarketplaceGroup;
  marketplaceIds: Array<Scalars['ID']>;
  membership: Scalars['String'];
  memberships: Array<Membership>;
  packageItems: Array<PackageItem>;
  paymentInstruments: Array<PaymentInstrument>;
  phone?: Maybe<Scalars['String']>;
  phoneConfirmed: Scalars['Boolean'];
  phoneOptIn: Scalars['Boolean'];
  primaryInstrumentId?: Maybe<Scalars['ID']>;
  updatedAt: Scalars['DateTime'];
};

export type MarketplaceUserFilterInput = {
  address?: InputMaybe<FilterStringInput>;
  clientProfileId?: InputMaybe<FilterIntegerInput>;
  email?: InputMaybe<FilterStringInput>;
  familyName?: InputMaybe<FilterStringInput>;
  fullName?: InputMaybe<FilterStringInput>;
  givenName?: InputMaybe<FilterStringInput>;
  groupId?: InputMaybe<FilterIntegerInput>;
  id?: InputMaybe<FilterIntegerInput>;
  membership?: InputMaybe<FilterStringInput>;
  memberships?: InputMaybe<FilterStringInput>;
  phone?: InputMaybe<FilterStringInput>;
};

export type MarketplaceUserPage = {
  __typename?: 'MarketplaceUserPage';
  data: Array<MarketplaceUser>;
  totalCount: Scalars['Int'];
};

export type MarketplaceUserPageInput = {
  filter?: InputMaybe<MarketplaceUserFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<MarketplaceUserSortInput>>;
};

export enum MarketplaceUserSortFields {
  Address = 'ADDRESS',
  Clientprofileid = 'CLIENTPROFILEID',
  Createdat = 'CREATEDAT',
  Dob = 'DOB',
  Email = 'EMAIL',
  Familyname = 'FAMILYNAME',
  Fullname = 'FULLNAME',
  Givenname = 'GIVENNAME',
  Id = 'ID',
  Membership = 'MEMBERSHIP',
  Memberships = 'MEMBERSHIPS',
  Phone = 'PHONE',
  Updatedat = 'UPDATEDAT'
}

export type MarketplaceUserSortInput = {
  direction: SortDirection;
  field: MarketplaceUserSortFields;
};

export type Medication = {
  __typename?: 'Medication';
  archivedAt?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  name: Scalars['String'];
  organizationId: Scalars['ID'];
  unit: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type MedicationProtocol = {
  __typename?: 'MedicationProtocol';
  createdAt: Scalars['DateTime'];
  dose: Scalars['Float'];
  id: Scalars['ID'];
  medication: Medication;
  updatedAt: Scalars['DateTime'];
};

export type MedicationProtocolInput = {
  dose: Scalars['Float'];
  medicationId: Scalars['ID'];
};

export type MedicationStatement = {
  __typename?: 'MedicationStatement';
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  name: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type Membership = {
  __typename?: 'Membership';
  id: Scalars['ID'];
  marketplaceName: Scalars['String'];
  marketplaceUserId: Scalars['ID'];
  membershipDefinition: MembershipDefinition;
  membershipDefinitionId: Scalars['ID'];
  name: Scalars['String'];
  renewalDate: Scalars['DateTime'];
  status: MembershipStatusType;
};

export type MembershipDefinition = {
  __typename?: 'MembershipDefinition';
  advertise: Scalars['Boolean'];
  archivedAt?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  discounts: Array<Discount>;
  id: Scalars['ID'];
  list?: Maybe<Scalars['String']>;
  marketplaceId: Scalars['ID'];
  name: Scalars['String'];
  packageId?: Maybe<Scalars['ID']>;
  period: MembershipDefinitionPeriodType;
  price: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export enum MembershipDefinitionPeriodType {
  Monthly = 'MONTHLY',
  Quarterly = 'QUARTERLY',
  Yearly = 'YEARLY'
}

export enum MembershipStatusType {
  Active = 'ACTIVE',
  Cancelled = 'CANCELLED',
  Inactive = 'INACTIVE',
  PaymentError = 'PAYMENT_ERROR'
}

export enum MessagingSenderSource {
  Group = 'GROUP',
  Marketplace = 'MARKETPLACE',
  None = 'NONE',
  Platform = 'PLATFORM'
}

export type MessagingSenderStatus = {
  __typename?: 'MessagingSenderStatus';
  error?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<Array<Scalars['String']>>;
  sid?: Maybe<Scalars['String']>;
  source: MessagingSenderSource;
};

export enum MetricChartTypes {
  AppointmentRequestsByMarketplace = 'AppointmentRequestsByMarketplace',
  AppointmentRequestsByStatus = 'AppointmentRequestsByStatus',
  AppointmentsByLocation = 'AppointmentsByLocation',
  AppointmentsByLocationTrend = 'AppointmentsByLocationTrend',
  AppointmentsByProcedure = 'AppointmentsByProcedure',
  AppointmentsByProcedureTrend = 'AppointmentsByProcedureTrend',
  AppointmentsByStatus = 'AppointmentsByStatus',
  Memberships = 'Memberships',
  OrganizationCount = 'OrganizationCount',
  UserCount = 'UserCount'
}

export type MetricData = {
  __typename?: 'MetricData';
  count?: Maybe<Scalars['Int']>;
  data?: Maybe<ChartData>;
  id: Scalars['ID'];
  type: MetricChartTypes;
};

export type MetricsInput = {
  charts: Array<MetricChartTypes>;
  dateRange: Array<Scalars['DateTime']>;
  marketplaceIds: Array<Scalars['ID']>;
  organizationIds: Array<Scalars['ID']>;
  procedureBaseDefIds: Array<Scalars['ID']>;
  tzid?: InputMaybe<Scalars['String']>;
};

export type MfaEnrollmentReport = {
  __typename?: 'MfaEnrollmentReport';
  enabled: Scalars['Boolean'];
  generatedAt: Scalars['DateTime'];
  platformMode: MfaMode;
  rows: Array<MfaEnrollmentRow>;
  totals: MfaEnrollmentTotals;
};

export type MfaEnrollmentRow = {
  __typename?: 'MfaEnrollmentRow';
  enrolled: Scalars['Int'];
  id?: Maybe<Scalars['ID']>;
  inGrace: Scalars['Int'];
  kind: RoleScope;
  mode: MfaMode;
  name: Scalars['String'];
  pastGrace: Scalars['Int'];
  percentEnrolled: Scalars['Float'];
  setting: MfaModeSetting;
  users: Scalars['Int'];
};

export type MfaEnrollmentTotals = {
  __typename?: 'MfaEnrollmentTotals';
  enrolled: Scalars['Int'];
  inGrace: Scalars['Int'];
  pastGrace: Scalars['Int'];
  percentEnrolled: Scalars['Float'];
  users: Scalars['Int'];
};

export type MfaFactor = {
  __typename?: 'MfaFactor';
  backedUp?: Maybe<Scalars['Boolean']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  label?: Maybe<Scalars['String']>;
  lastUsedAt?: Maybe<Scalars['DateTime']>;
  type: MfaFactorType;
  updatedAt: Scalars['DateTime'];
  verifiedAt?: Maybe<Scalars['DateTime']>;
};

export enum MfaFactorType {
  Sms = 'SMS',
  Totp = 'TOTP',
  Webauthn = 'WEBAUTHN'
}

export enum MfaMethod {
  RecoveryCode = 'RECOVERY_CODE',
  Totp = 'TOTP',
  Webauthn = 'WEBAUTHN'
}

/** How much two-step verification applies */
export enum MfaMode {
  Enforced = 'ENFORCED',
  Off = 'OFF'
}

/** A two-step verification mode, or INHERIT for the parent one */
export enum MfaModeSetting {
  Enforced = 'ENFORCED',
  Inherit = 'INHERIT',
  Off = 'OFF'
}

/** How the admin checked who asked for the reset. */
export enum MfaResetVerificationMethod {
  CallBack = 'CALL_BACK',
  InPerson = 'IN_PERSON',
  OrganizationOwner = 'ORGANIZATION_OWNER',
  VideoCall = 'VIDEO_CALL'
}

export type MfaScopeMode = {
  __typename?: 'MfaScopeMode';
  effective: MfaMode;
  enabled: Scalars['Boolean'];
  inherited: MfaMode;
  setting: MfaModeSetting;
};

export type MfaStatus = {
  __typename?: 'MfaStatus';
  enabled: Scalars['Boolean'];
  factors: Array<MfaFactor>;
  graceUntil?: Maybe<Scalars['DateTime']>;
  mode: MfaMode;
  recoveryCodesLeft: Scalars['Int'];
  required: Scalars['Boolean'];
};

export type MfaStepUp = {
  __typename?: 'MfaStepUp';
  challengeId: Scalars['String'];
  expiresAt: Scalars['DateTime'];
  methods: Array<MfaMethod>;
};

export type Mutation = {
  __typename?: 'Mutation';
  acceptAppointment?: Maybe<Appointment>;
  addOrganizationsToMarketplace: Scalars['Boolean'];
  approveAppointmentRequest?: Maybe<AppointmentRequest>;
  archiveAppointment?: Maybe<Appointment>;
  archiveAppointmentRequest?: Maybe<AppointmentRequest>;
  archiveDiscount?: Maybe<Scalars['Boolean']>;
  archiveDocument: Scalars['Boolean'];
  archiveEmrInstance: Scalars['Boolean'];
  archiveFormNote: Scalars['Boolean'];
  archiveMarketplace: Scalars['Boolean'];
  archiveMarketplaceGroup: Scalars['Boolean'];
  archiveMembershipDefinition?: Maybe<Scalars['Boolean']>;
  archiveOrganization: Scalars['Boolean'];
  archivePackage?: Maybe<Scalars['Boolean']>;
  archivePackageItemDefinition?: Maybe<Scalars['Boolean']>;
  archivePaymentAccount: Scalars['Boolean'];
  archiveProfile: Scalars['Boolean'];
  archivePromoCode: Scalars['Boolean'];
  assignEmrInstance: Scalars['Boolean'];
  assignPaymentAccount: Scalars['Boolean'];
  assignProcedureProfile: Scalars['Boolean'];
  assignRole: Scalars['Boolean'];
  authenticate: AuthenticatePayload;
  authenticateAs: AuthenticatePayload;
  cancelAppointment?: Maybe<Appointment>;
  cancelAppointmentGroup: Scalars['Boolean'];
  cancelAppointmentRequest?: Maybe<AppointmentRequest>;
  cancelMembership?: Maybe<Scalars['Boolean']>;
  changeEmail: Scalars['Boolean'];
  completeAppointment?: Maybe<Appointment>;
  completeCheckout: CreateAppointmentCheckoutPayload;
  confirmConsumerEmail: Scalars['Boolean'];
  confirmConsumerPhone: Scalars['Boolean'];
  confirmTotpEnrollment: ConfirmTotpEnrollmentPayload;
  copyOrganization: CopyOrganizationResult;
  createAllergyIntolerance: AllergyIntolerance;
  createApiKey: CreateApiKeyPayload;
  createApplePayInstrument?: Maybe<PaymentInstrument>;
  createApplePaySession?: Maybe<Scalars['String']>;
  createAppointment?: Maybe<Appointment>;
  createAppointmentRequest?: Maybe<AppointmentRequest>;
  createAttachment: Document;
  createAvailability?: Maybe<Availability>;
  createAvailabilityCoverage?: Maybe<AvailabilityCoverage>;
  createClientProfile?: Maybe<ClientProfile>;
  createClinicalProcedure: ClinicalProcedure;
  createCondition: Condition;
  createDiscount?: Maybe<Discount>;
  createDocument: Document;
  createEmrInstance?: Maybe<EmrInstance>;
  createFormNote?: Maybe<FormNote>;
  createFormTemplate?: Maybe<FormTemplate>;
  createGeoperimeter?: Maybe<Geoperimeter>;
  createImmunization: Immunization;
  createIntakeSubmissionNote: IntakeSubmissionNote;
  createLab: Lab;
  createMarketplace?: Maybe<Marketplace>;
  createMarketplaceUser?: Maybe<MarketplaceUser>;
  createMedication: Medication;
  createMedicationStatement: MedicationStatement;
  createMembership?: Maybe<Membership>;
  createMembershipDefinition?: Maybe<MembershipDefinition>;
  createObservations: Form;
  createOrder: Order;
  createOrganization?: Maybe<Organization>;
  createPackage?: Maybe<Package>;
  createPackageItemDefinition?: Maybe<PackageItemDefinition>;
  createPatient: Patient;
  createPaymentAccount?: Maybe<PaymentAccount>;
  createPaymentInstrument?: Maybe<PaymentInstrument>;
  createProcedureBaseDefinition?: Maybe<ProcedureBaseDefinition>;
  createProcedureBaseDefinitionGroup?: Maybe<ProcedureBaseDefinitionGroup>;
  createProcedureBaseDefinitionTag: ProcedureBaseDefinition;
  createProcedureDefinition?: Maybe<ProcedureDefinition>;
  createProcedureProfile?: Maybe<ProcedureProfile>;
  createProfile: Profile;
  createPromoCode?: Maybe<PromoCode>;
  createReachIntegration?: Maybe<ReachIntegration>;
  createRole?: Maybe<Role>;
  createUploadUrl: CreateUploadUrlPayload;
  createUser: User;
  createVitals: Patient;
  deactivatePaymentLink: Checkout;
  declineAppointment?: Maybe<Appointment>;
  deleteAllergyIntolerance: Patient;
  deleteAvailability: Scalars['Boolean'];
  deleteAvailabilityCoverage?: Maybe<Scalars['Boolean']>;
  deleteClinicalProcedure: Patient;
  deleteCondition: Patient;
  deleteFormTemplate: Scalars['Boolean'];
  deleteGeoperimeter?: Maybe<Scalars['Boolean']>;
  deleteImmunization: Patient;
  deleteLab: Patient;
  deleteMedication: Scalars['Boolean'];
  deleteMedicationStatement: Patient;
  deleteMembership?: Maybe<Scalars['Boolean']>;
  deleteObservation: Form;
  deleteOrder: Scalars['Boolean'];
  deletePackageItem?: Maybe<Scalars['Boolean']>;
  deletePaymentInstrument?: Maybe<Scalars['Boolean']>;
  deleteProcedureBaseDefinition: Scalars['Boolean'];
  deleteProcedureBaseDefinitionGroup?: Maybe<Scalars['Boolean']>;
  deleteProcedureBaseDefinitionTag: ProcedureBaseDefinition;
  deleteProcedureDefinition: Scalars['Boolean'];
  deleteProcedureProfile: Scalars['Boolean'];
  deleteQualiphyExam: Scalars['Boolean'];
  deleteReport: Scalars['Boolean'];
  deleteRole: Scalars['Boolean'];
  deleteVital: Patient;
  fcmToken: Scalars['Boolean'];
  finishPasskeyRegistration: FinishPasskeyRegistrationPayload;
  generatePaymentLink: GeneratePaymentLinkPayload;
  grantPackage?: Maybe<Array<PackageItem>>;
  joinOrganization?: Maybe<Profile>;
  leaveOrganization: Scalars['Boolean'];
  linkClientProfileToAccount: MarketplaceUser;
  lockForm: Form;
  logout: Scalars['Boolean'];
  mfaAuthenticationOptions: Scalars['JSONObject'];
  noShowAppointment?: Maybe<Appointment>;
  reactivateMembership?: Maybe<Membership>;
  recordCashPayment: RecordCashPaymentPayload;
  refreshTokens: AuthenticatePayload;
  refundCheckout: Checkout;
  regenerateRecoveryCodes: Array<Scalars['String']>;
  register: AuthenticatePayload;
  removeMfaFactor: Scalars['Boolean'];
  removeOrganizationsFromMarketplace: Scalars['Boolean'];
  reportAppointments: Report;
  reportPersonnel: Report;
  requestChangeEmail: Scalars['Boolean'];
  requestConfirmConsumerEmail: Scalars['Boolean'];
  requestConfirmConsumerPhone: Scalars['Boolean'];
  requestResetPassword: Scalars['Boolean'];
  requestVerifyEmail: Scalars['Boolean'];
  resendInvitationCode: Scalars['Boolean'];
  resendQualiphyExamInvite: QualiphyInvitation;
  resetAppointment?: Maybe<Appointment>;
  resetAppointmentRequest?: Maybe<AppointmentRequest>;
  resetPassword: Scalars['Boolean'];
  resetUserMfa: ResetUserMfaPayload;
  reviewIntakeSubmission: IntakeSubmission;
  revokeApiKey: Scalars['Boolean'];
  revokeRefreshTokens: Scalars['Boolean'];
  revokeTrustedDevice: Scalars['Boolean'];
  revokeTrustedDevices: Scalars['Int'];
  saveProfileLocation: Profile;
  sendIntakeForm: SendIntakeFormResult;
  sendPaymentLink: GeneratePaymentLinkPayload;
  sendProfileInvitation: Scalars['Boolean'];
  sendQualiphyExamInvite: QualiphyInvitation;
  sendReceipt: SendReceiptPayload;
  sendWaitlistNotification?: Maybe<AppointmentRequest>;
  setUserMcpAccess: User;
  signDocument: DocumentSignature;
  signOutEverywhere: Scalars['Boolean'];
  startAppointment?: Maybe<Appointment>;
  startMfaStepUp: MfaStepUp;
  startPasskeyRegistration: PasskeyRegistrationOptions;
  startTotpEnrollment: TotpEnrollment;
  unarchiveProfile: Scalars['Boolean'];
  unassignPaymentAccount: Scalars['Boolean'];
  unassignProcedureProfile: Scalars['Boolean'];
  unassignRole: Scalars['Boolean'];
  unlockForm: Form;
  updateApiKey: ApiKey;
  updateAppointment?: Maybe<Appointment>;
  updateAppointmentRequest?: Maybe<AppointmentRequest>;
  updateAppointmentSecondaryParticipants?: Maybe<Appointment>;
  updateAttentiveIntegration?: Maybe<AttentiveIntegration>;
  updateAvailability?: Maybe<Availability>;
  updateAvailabilityCoverage?: Maybe<AvailabilityCoverage>;
  updateCheckout: Checkout;
  updateClientProfile?: Maybe<ClientProfile>;
  updateDiscount?: Maybe<Discount>;
  updateDocument: Document;
  updateEmrInstance: EmrInstance;
  updateFormNote?: Maybe<FormNote>;
  updateFormTemplate?: Maybe<FormTemplate>;
  updateGeoperimeter?: Maybe<Geoperimeter>;
  updateGroupAppointment: Array<Appointment>;
  updateMarketplace?: Maybe<Marketplace>;
  updateMarketplaceCheckoutNotes?: Maybe<Marketplace>;
  updateMarketplaceGroup?: Maybe<MarketplaceGroup>;
  updateMarketplaceMfaMode: Marketplace;
  updateMarketplaceUser?: Maybe<MarketplaceUser>;
  updateMedication: Medication;
  updateMembership: Membership;
  updateMembershipDefinition?: Maybe<MembershipDefinition>;
  updateNavigationGroup?: Maybe<ProcedureBaseDefinitionGroup>;
  updateNotificationsGroup?: Maybe<ProcedureBaseDefinitionGroup>;
  updateOrder: Order;
  updateOrganization?: Maybe<Organization>;
  updateOrganizationMfaMode: Organization;
  updatePackage?: Maybe<Package>;
  updatePackageItem: PackageItem;
  updatePackageItemDefinition?: Maybe<PackageItemDefinition>;
  updatePatient: Patient;
  updatePaymentAccount: PaymentAccount;
  updateProcedureBaseDefinition?: Maybe<ProcedureBaseDefinition>;
  updateProcedureBaseDefinitionGroup?: Maybe<ProcedureBaseDefinitionGroup>;
  updateProcedureDefinition?: Maybe<ProcedureDefinition>;
  updateProcedureProfile?: Maybe<ProcedureProfile>;
  updateProfile: Profile;
  updatePromoCode?: Maybe<PromoCode>;
  updateQualiphyExam?: Maybe<QualiphyExam>;
  updateQualiphyIntegration?: Maybe<QualiphyIntegration>;
  updateReviewsGroup?: Maybe<ProcedureBaseDefinitionGroup>;
  updateRole?: Maybe<Role>;
  updateSegmentIntegration?: Maybe<SegmentIntegration>;
  updateSendgridIntegration?: Maybe<SendgridIntegration>;
  updateTwilioIntegration?: Maybe<TwilioIntegration>;
  upsertReachUser?: Maybe<Scalars['Boolean']>;
  usePaymentAccount: Scalars['Boolean'];
  verifyEmail: Scalars['Boolean'];
  verifyMfa: AuthenticatePayload;
  verifyMfaStepUp: AuthenticatePayload;
  voidMembership?: Maybe<Scalars['Boolean']>;
  waitlistAppointmentRequest?: Maybe<AppointmentRequest>;
};


export type MutationAcceptAppointmentArgs = {
  input: AcceptAppointmentInput;
};


export type MutationAddOrganizationsToMarketplaceArgs = {
  input: AddOrganizationsToMarketplaceInput;
};


export type MutationApproveAppointmentRequestArgs = {
  input: ApproveAppointmentRequestInput;
};


export type MutationArchiveAppointmentArgs = {
  input: ArchiveAppointmentInput;
};


export type MutationArchiveAppointmentRequestArgs = {
  input: ArchiveAppointmentRequestInput;
};


export type MutationArchiveDiscountArgs = {
  id: Scalars['ID'];
};


export type MutationArchiveDocumentArgs = {
  id: Scalars['ID'];
};


export type MutationArchiveEmrInstanceArgs = {
  id: Scalars['ID'];
};


export type MutationArchiveFormNoteArgs = {
  id: Scalars['ID'];
};


export type MutationArchiveMarketplaceArgs = {
  input: ArchiveMarketplaceInput;
};


export type MutationArchiveMarketplaceGroupArgs = {
  input: ArchiveMarketplaceGroupInput;
};


export type MutationArchiveMembershipDefinitionArgs = {
  id: Scalars['ID'];
};


export type MutationArchiveOrganizationArgs = {
  input: ArchiveOrganizationInput;
};


export type MutationArchivePackageArgs = {
  id: Scalars['ID'];
};


export type MutationArchivePackageItemDefinitionArgs = {
  id: Scalars['ID'];
};


export type MutationArchivePaymentAccountArgs = {
  input: ArchivePaymentAccountInput;
};


export type MutationArchiveProfileArgs = {
  input: ArchiveProfileInput;
};


export type MutationArchivePromoCodeArgs = {
  id: Scalars['ID'];
};


export type MutationAssignEmrInstanceArgs = {
  input: AssignEmrInstanceInput;
};


export type MutationAssignPaymentAccountArgs = {
  input: AssignPaymentAccountInput;
};


export type MutationAssignProcedureProfileArgs = {
  input: AssignProcedureProfileInput;
};


export type MutationAssignRoleArgs = {
  input: AssignRoleInput;
};


export type MutationAuthenticateArgs = {
  input: AuthenticateInput;
};


export type MutationAuthenticateAsArgs = {
  userId: Scalars['ID'];
};


export type MutationCancelAppointmentArgs = {
  input: CancelAppointmentInput;
};


export type MutationCancelAppointmentGroupArgs = {
  input: CancelAppointmentGroupInput;
};


export type MutationCancelAppointmentRequestArgs = {
  input: CancelAppointmentRequestInput;
};


export type MutationCancelMembershipArgs = {
  id: Scalars['ID'];
};


export type MutationChangeEmailArgs = {
  input: ChangeEmailInput;
};


export type MutationCompleteAppointmentArgs = {
  input: CompleteAppointmentInput;
};


export type MutationCompleteCheckoutArgs = {
  input: CompleteCheckoutInput;
};


export type MutationConfirmConsumerEmailArgs = {
  input: ConfirmConsumerEmailInput;
};


export type MutationConfirmConsumerPhoneArgs = {
  input: ConfirmConsumerPhoneInput;
};


export type MutationConfirmTotpEnrollmentArgs = {
  input: ConfirmTotpEnrollmentInput;
};


export type MutationCopyOrganizationArgs = {
  input: CopyOrganizationInput;
};


export type MutationCreateAllergyIntoleranceArgs = {
  input: CreateAllergyIntoleranceInput;
};


export type MutationCreateApiKeyArgs = {
  input: CreateApiKeyInput;
};


export type MutationCreateApplePayInstrumentArgs = {
  input: PaymentMethodInput;
};


export type MutationCreateApplePaySessionArgs = {
  input: CreateApplePaySessionInput;
};


export type MutationCreateAppointmentArgs = {
  input: CreateAppointmentInput;
};


export type MutationCreateAppointmentRequestArgs = {
  input: CreateAppointmentRequestInput;
};


export type MutationCreateAttachmentArgs = {
  input: CreateAttachmentInput;
};


export type MutationCreateAvailabilityArgs = {
  input: CreateAvailabilityInput;
};


export type MutationCreateAvailabilityCoverageArgs = {
  input: CreateAvailabilityCoverageInput;
};


export type MutationCreateClientProfileArgs = {
  input: CreateClientProfileInput;
};


export type MutationCreateClinicalProcedureArgs = {
  input: CreateClinicalProcedureInput;
};


export type MutationCreateConditionArgs = {
  input: CreateConditionInput;
};


export type MutationCreateDiscountArgs = {
  input: CreateDiscountInput;
};


export type MutationCreateDocumentArgs = {
  input: CreateDocumentInput;
};


export type MutationCreateEmrInstanceArgs = {
  input: CreateEmrInstanceInput;
};


export type MutationCreateFormNoteArgs = {
  input: CreateFormNoteInput;
};


export type MutationCreateFormTemplateArgs = {
  input: CreateFormTemplateInput;
};


export type MutationCreateGeoperimeterArgs = {
  input: CreateGeoperimeterInput;
};


export type MutationCreateImmunizationArgs = {
  input: CreateImmunizationInput;
};


export type MutationCreateIntakeSubmissionNoteArgs = {
  input: CreateIntakeSubmissionNoteInput;
};


export type MutationCreateLabArgs = {
  input: CreateLabInput;
};


export type MutationCreateMarketplaceArgs = {
  input: CreateMarketplaceInput;
};


export type MutationCreateMarketplaceUserArgs = {
  input: CreateMarketplaceUserInput;
};


export type MutationCreateMedicationArgs = {
  input: CreateMedicationInput;
};


export type MutationCreateMedicationStatementArgs = {
  input: CreateMedicationStatementInput;
};


export type MutationCreateMembershipArgs = {
  input: CreateMembershipInput;
};


export type MutationCreateMembershipDefinitionArgs = {
  input: CreateMembershipDefinitionInput;
};


export type MutationCreateObservationsArgs = {
  input: CreateObservationsInput;
};


export type MutationCreateOrderArgs = {
  input: CreateOrderInput;
};


export type MutationCreateOrganizationArgs = {
  input: CreateOrganizationInput;
};


export type MutationCreatePackageArgs = {
  input: CreatePackageInput;
};


export type MutationCreatePackageItemDefinitionArgs = {
  input: CreatePackageItemDefinitionInput;
};


export type MutationCreatePatientArgs = {
  input: CreatePatientInput;
};


export type MutationCreatePaymentAccountArgs = {
  input: CreatePaymentAccountInput;
};


export type MutationCreatePaymentInstrumentArgs = {
  input: PaymentMethodInput;
};


export type MutationCreateProcedureBaseDefinitionArgs = {
  input: CreateProcedureBaseDefinitionInput;
};


export type MutationCreateProcedureBaseDefinitionGroupArgs = {
  input: CreateProcedureBaseDefinitionGroupInput;
};


export type MutationCreateProcedureBaseDefinitionTagArgs = {
  input: ProcedureBaseDefinitionTagInput;
};


export type MutationCreateProcedureDefinitionArgs = {
  input: CreateProcedureDefinitionInput;
};


export type MutationCreateProcedureProfileArgs = {
  input: CreateProcedureProfileInput;
};


export type MutationCreateProfileArgs = {
  input: CreateProfileInput;
};


export type MutationCreatePromoCodeArgs = {
  input: CreatePromoCodeInput;
};


export type MutationCreateReachIntegrationArgs = {
  input: CreateReachIntegrationInput;
};


export type MutationCreateRoleArgs = {
  input: CreateRoleInput;
};


export type MutationCreateUploadUrlArgs = {
  input: CreateUploadUrlInput;
};


export type MutationCreateUserArgs = {
  input: CreateUserInput;
};


export type MutationCreateVitalsArgs = {
  input: CreateVitalsInput;
};


export type MutationDeactivatePaymentLinkArgs = {
  input: DeactivatePaymentLinkInput;
};


export type MutationDeclineAppointmentArgs = {
  input: DeclineAppointmentInput;
};


export type MutationDeleteAllergyIntoleranceArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteAvailabilityArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteAvailabilityCoverageArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteClinicalProcedureArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteConditionArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteFormTemplateArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteGeoperimeterArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteImmunizationArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteLabArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteMedicationArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteMedicationStatementArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteMembershipArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteObservationArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteOrderArgs = {
  id: Scalars['ID'];
};


export type MutationDeletePackageItemArgs = {
  id: Scalars['ID'];
};


export type MutationDeletePaymentInstrumentArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteProcedureBaseDefinitionArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteProcedureBaseDefinitionGroupArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteProcedureBaseDefinitionTagArgs = {
  input: ProcedureBaseDefinitionTagInput;
};


export type MutationDeleteProcedureDefinitionArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteProcedureProfileArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteQualiphyExamArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteReportArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteRoleArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteVitalArgs = {
  id: Scalars['ID'];
};


export type MutationFcmTokenArgs = {
  input: FcmTokenInput;
};


export type MutationFinishPasskeyRegistrationArgs = {
  input: FinishPasskeyRegistrationInput;
};


export type MutationGeneratePaymentLinkArgs = {
  input: GeneratePaymentLinkInput;
};


export type MutationGrantPackageArgs = {
  input: GrantPackageInput;
};


export type MutationJoinOrganizationArgs = {
  input: JoinOrganizationInput;
};


export type MutationLeaveOrganizationArgs = {
  input: LeaveOrganizationInput;
};


export type MutationLinkClientProfileToAccountArgs = {
  input: LinkClientProfileToAccountInput;
};


export type MutationLockFormArgs = {
  input: LockFormInput;
};


export type MutationLogoutArgs = {
  fcmToken?: InputMaybe<Scalars['String']>;
};


export type MutationMfaAuthenticationOptionsArgs = {
  challengeId?: InputMaybe<Scalars['String']>;
};


export type MutationNoShowAppointmentArgs = {
  input: NoShowAppointmentInput;
};


export type MutationReactivateMembershipArgs = {
  id: Scalars['ID'];
};


export type MutationRecordCashPaymentArgs = {
  input: RecordCashPaymentInput;
};


export type MutationRefreshTokensArgs = {
  refreshToken: Scalars['String'];
};


export type MutationRefundCheckoutArgs = {
  input: RefundCheckoutInput;
};


export type MutationRegisterArgs = {
  input: RegisterInput;
};


export type MutationRemoveMfaFactorArgs = {
  id: Scalars['ID'];
};


export type MutationRemoveOrganizationsFromMarketplaceArgs = {
  input: RemoveOrganizationsFromMarketplaceInput;
};


export type MutationReportAppointmentsArgs = {
  input: ReportAppointmentsInput;
};


export type MutationReportPersonnelArgs = {
  input: ReportPersonnelInput;
};


export type MutationRequestChangeEmailArgs = {
  newEmail: Scalars['String'];
};


export type MutationRequestConfirmConsumerEmailArgs = {
  input: RequestConfirmConsumerEmailInput;
};


export type MutationRequestConfirmConsumerPhoneArgs = {
  input: RequestConfirmConsumerPhoneInput;
};


export type MutationRequestResetPasswordArgs = {
  email: Scalars['String'];
};


export type MutationResendInvitationCodeArgs = {
  email: Scalars['String'];
};


export type MutationResendQualiphyExamInviteArgs = {
  id: Scalars['String'];
};


export type MutationResetAppointmentArgs = {
  input: ResetAppointmentInput;
};


export type MutationResetAppointmentRequestArgs = {
  input: ResetAppointmentRequestInput;
};


export type MutationResetPasswordArgs = {
  input: ResetPasswordInput;
};


export type MutationResetUserMfaArgs = {
  input: ResetUserMfaInput;
};


export type MutationReviewIntakeSubmissionArgs = {
  input: ReviewIntakeSubmissionInput;
};


export type MutationRevokeApiKeyArgs = {
  kid: Scalars['String'];
};


export type MutationRevokeRefreshTokensArgs = {
  userId?: InputMaybe<Scalars['ID']>;
};


export type MutationRevokeTrustedDeviceArgs = {
  id: Scalars['ID'];
};


export type MutationSaveProfileLocationArgs = {
  input: SaveProfileLocationInput;
};


export type MutationSendIntakeFormArgs = {
  appointmentId: Scalars['ID'];
  deliveryMethods?: InputMaybe<SendIntakeFormDeliveryInput>;
  formTemplateIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type MutationSendPaymentLinkArgs = {
  input: SendPaymentLinkInput;
};


export type MutationSendProfileInvitationArgs = {
  input: SendInvitationInput;
};


export type MutationSendQualiphyExamInviteArgs = {
  id: Scalars['String'];
};


export type MutationSendReceiptArgs = {
  input: SendReceiptInput;
};


export type MutationSendWaitlistNotificationArgs = {
  input: SendWaitlistNotificationInput;
};


export type MutationSetUserMcpAccessArgs = {
  input: SetUserMcpAccessInput;
};


export type MutationSignDocumentArgs = {
  input: SignDocumentInput;
};


export type MutationStartAppointmentArgs = {
  input: StartAppointmentInput;
};


export type MutationStartPasskeyRegistrationArgs = {
  challengeId?: InputMaybe<Scalars['String']>;
};


export type MutationStartTotpEnrollmentArgs = {
  challengeId?: InputMaybe<Scalars['String']>;
};


export type MutationUnarchiveProfileArgs = {
  input: ArchiveProfileInput;
};


export type MutationUnassignPaymentAccountArgs = {
  input: UnassignPaymentAccountInput;
};


export type MutationUnassignProcedureProfileArgs = {
  input: UnassignProcedureProfileInput;
};


export type MutationUnassignRoleArgs = {
  input: UnassignRoleInput;
};


export type MutationUnlockFormArgs = {
  input: UnlockFormInput;
};


export type MutationUpdateApiKeyArgs = {
  input: UpdateApiKeyInput;
};


export type MutationUpdateAppointmentArgs = {
  input: UpdateAppointmentInput;
};


export type MutationUpdateAppointmentRequestArgs = {
  input: UpdateAppointmentRequestInput;
};


export type MutationUpdateAppointmentSecondaryParticipantsArgs = {
  input: UpdateAppointmentSecondaryParticipantsInput;
};


export type MutationUpdateAttentiveIntegrationArgs = {
  input: UpdateAttentiveIntegrationInput;
};


export type MutationUpdateAvailabilityArgs = {
  input: UpdateAvailabilityInput;
};


export type MutationUpdateAvailabilityCoverageArgs = {
  input: UpdateAvailabilityCoverageInput;
};


export type MutationUpdateCheckoutArgs = {
  input: UpdateCheckoutInput;
};


export type MutationUpdateClientProfileArgs = {
  input: UpdateClientProfileInput;
};


export type MutationUpdateDiscountArgs = {
  input: UpdateDiscountInput;
};


export type MutationUpdateDocumentArgs = {
  input: UpdateDocumentInput;
};


export type MutationUpdateEmrInstanceArgs = {
  input: UpdateEmrInstanceInput;
};


export type MutationUpdateFormNoteArgs = {
  input: UpdateFormNoteInput;
};


export type MutationUpdateFormTemplateArgs = {
  input: UpdateFormTemplateInput;
};


export type MutationUpdateGeoperimeterArgs = {
  input: UpdateGeoperimeterInput;
};


export type MutationUpdateGroupAppointmentArgs = {
  input: UpdateGroupAppointmentInput;
};


export type MutationUpdateMarketplaceArgs = {
  input: UpdateMarketplaceInput;
};


export type MutationUpdateMarketplaceCheckoutNotesArgs = {
  input: UpdateMarketplaceCheckoutNotesInput;
};


export type MutationUpdateMarketplaceGroupArgs = {
  input: UpdateMarketplaceGroupInput;
};


export type MutationUpdateMarketplaceMfaModeArgs = {
  input: UpdateMarketplaceMfaModeInput;
};


export type MutationUpdateMarketplaceUserArgs = {
  input: UpdateMarketplaceUserInput;
};


export type MutationUpdateMedicationArgs = {
  input: UpdateMedicationInput;
};


export type MutationUpdateMembershipArgs = {
  input: UpdateMembershipInput;
};


export type MutationUpdateMembershipDefinitionArgs = {
  input: UpdateMembershipDefinitionInput;
};


export type MutationUpdateNavigationGroupArgs = {
  input: UpdateConfigGroupInput;
};


export type MutationUpdateNotificationsGroupArgs = {
  input: UpdateConfigGroupInput;
};


export type MutationUpdateOrderArgs = {
  input: UpdateOrderInput;
};


export type MutationUpdateOrganizationArgs = {
  input: UpdateOrganizationInput;
};


export type MutationUpdateOrganizationMfaModeArgs = {
  input: UpdateOrganizationMfaModeInput;
};


export type MutationUpdatePackageArgs = {
  input: UpdatePackageInput;
};


export type MutationUpdatePackageItemArgs = {
  input: UpdatePackageItemInput;
};


export type MutationUpdatePackageItemDefinitionArgs = {
  input: UpdatePackageItemDefinitionInput;
};


export type MutationUpdatePatientArgs = {
  input: UpdatePatientInput;
};


export type MutationUpdatePaymentAccountArgs = {
  input: UpdatePaymentAccountInput;
};


export type MutationUpdateProcedureBaseDefinitionArgs = {
  input: UpdateProcedureBaseDefinitionInput;
};


export type MutationUpdateProcedureBaseDefinitionGroupArgs = {
  input: UpdateProcedureBaseDefinitionGroupInput;
};


export type MutationUpdateProcedureDefinitionArgs = {
  input: UpdateProcedureDefinitionInput;
};


export type MutationUpdateProcedureProfileArgs = {
  input: UpdateProcedureProfileInput;
};


export type MutationUpdateProfileArgs = {
  input: UpdateProfileInput;
};


export type MutationUpdatePromoCodeArgs = {
  input: UpdatePromoCodeInput;
};


export type MutationUpdateQualiphyExamArgs = {
  input: UpdateQualiphyExamInput;
};


export type MutationUpdateQualiphyIntegrationArgs = {
  input: UpdateQualiphyIntegrationInput;
};


export type MutationUpdateReviewsGroupArgs = {
  input: UpdateConfigGroupInput;
};


export type MutationUpdateRoleArgs = {
  input: UpdateRoleInput;
};


export type MutationUpdateSegmentIntegrationArgs = {
  input: UpdateSegmentIntegrationInput;
};


export type MutationUpdateSendgridIntegrationArgs = {
  input: UpdateSendgridIntegrationInput;
};


export type MutationUpdateTwilioIntegrationArgs = {
  input: UpdateTwilioIntegrationInput;
};


export type MutationUpsertReachUserArgs = {
  input: UpsertReachUserInput;
};


export type MutationUsePaymentAccountArgs = {
  input: UsePaymentAccountInput;
};


export type MutationVerifyEmailArgs = {
  input: VerifyEmailInput;
};


export type MutationVerifyMfaArgs = {
  input: VerifyMfaInput;
};


export type MutationVerifyMfaStepUpArgs = {
  input: VerifyMfaStepUpInput;
};


export type MutationVoidMembershipArgs = {
  id: Scalars['ID'];
};


export type MutationWaitlistAppointmentRequestArgs = {
  input: WaitlistAppointmentRequestInput;
};

export type NoShowAppointmentInput = {
  appointmentId: Scalars['ID'];
  noShowBy?: InputMaybe<NoShowBy>;
};

export enum NoShowBy {
  Patient = 'PATIENT',
  Practitioner = 'PRACTITIONER'
}

export type Observation = {
  __typename?: 'Observation';
  code: Scalars['String'];
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<Profile>;
  createdById: Scalars['ID'];
  id: Scalars['ID'];
  note?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  value: Scalars['String'];
};

export type ObservationInput = {
  code: Scalars['String'];
  note?: InputMaybe<Scalars['String']>;
  value: Scalars['String'];
};

export type Order = {
  __typename?: 'Order';
  archivedAt?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  expiresAt: Scalars['DateTime'];
  fillCount: Scalars['Int'];
  id: Scalars['ID'];
  note?: Maybe<Scalars['String']>;
  organizations: Array<Organization>;
  patient: Patient;
  procedureDefs: Array<ProcedureDefinition>;
  profile?: Maybe<Profile>;
  providerType: ProviderType;
  refills: Scalars['Int'];
  startsAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
};

export type Organization = {
  __typename?: 'Organization';
  active: Scalars['Boolean'];
  address?: Maybe<Scalars['String']>;
  appointments: AppointmentPage;
  archivedAt?: Maybe<Scalars['DateTime']>;
  availabilityCoverageRanges: Array<AvailabilityCoverageRange>;
  availabilityCoverages: Array<AvailabilityCoverage>;
  clientProfiles: ClientProfilePage;
  createdAt: Scalars['DateTime'];
  email?: Maybe<Scalars['String']>;
  emrInstance?: Maybe<EmrInstance>;
  emrInstanceId?: Maybe<Scalars['ID']>;
  enablePractitionerSms: Scalars['Boolean'];
  enableReceiptSending: Scalars['Boolean'];
  geoperimeters: Array<Geoperimeter>;
  googleReviewsUrl?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  intakeAutoSendMode?: Maybe<IntakeAutoSendMode>;
  intakeDeliveryChannel?: Maybe<IntakeDeliveryChannel>;
  intakeSmsTemplate?: Maybe<Scalars['String']>;
  marketplaces: Array<Marketplace>;
  medications: Array<Medication>;
  mfaMode?: Maybe<MfaScopeMode>;
  name: Scalars['String'];
  paymentAccountId?: Maybe<Scalars['ID']>;
  paymentAccounts: Array<PaymentAccount>;
  phone?: Maybe<Scalars['String']>;
  procedureDefs: Array<ProcedureDefinition>;
  procedureProfiles: Array<ProcedureProfile>;
  profiles: Array<Profile>;
  providesAtClinic: Scalars['Boolean'];
  qualiphy?: Maybe<QualiphyIntegration>;
  qualiphyEnabled: Scalars['Boolean'];
  roles: Array<Role>;
  slackWebhookUrl?: Maybe<Scalars['String']>;
  state?: Maybe<StateCode>;
  tzid: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};


export type OrganizationAppointmentsArgs = {
  page?: InputMaybe<AppointmentPageInput>;
};


export type OrganizationAvailabilityCoverageRangesArgs = {
  input: AvailabilityCoverageRangeInput;
};


export type OrganizationClientProfilesArgs = {
  page?: InputMaybe<ClientProfilePageInput>;
};


export type OrganizationProfilesArgs = {
  includeArchived?: InputMaybe<Scalars['Boolean']>;
};

export type Package = {
  __typename?: 'Package';
  advertise: Scalars['Boolean'];
  archivedAt?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  list?: Maybe<Scalars['String']>;
  marketplaceId: Scalars['ID'];
  name: Scalars['String'];
  packageItemDefinitions: Array<PackageItemDefinition>;
  price: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export type PackageItem = {
  __typename?: 'PackageItem';
  balance: Scalars['Int'];
  costBasis: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  expiresAt?: Maybe<Scalars['DateTime']>;
  groupNames: Scalars['String'];
  id: Scalars['ID'];
  marketplaceName: Scalars['String'];
  marketplaceUserId: Scalars['ID'];
  membershipId?: Maybe<Scalars['ID']>;
  packageItemDefinitionId: Scalars['ID'];
  packageName: Scalars['String'];
  points: Scalars['Int'];
  primaryOrganizationId?: Maybe<Scalars['ID']>;
  totalPoints: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export type PackageItemDefinition = {
  __typename?: 'PackageItemDefinition';
  archivedAt?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  packageId: Scalars['ID'];
  points: Scalars['Int'];
  procedureGroups: Array<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type Participant = ClientProfile | Profile;

export enum ParticipantType {
  Patient = 'PATIENT',
  Practitioner = 'PRACTITIONER',
  Secondary = 'SECONDARY'
}

export enum ParticipationStatus {
  Accepted = 'ACCEPTED',
  Declined = 'DECLINED',
  NeedsAction = 'NEEDS_ACTION',
  Tentative = 'TENTATIVE'
}

export type PasskeyRegistrationOptions = {
  __typename?: 'PasskeyRegistrationOptions';
  challengeId?: Maybe<Scalars['String']>;
  options: Scalars['JSONObject'];
};

export type Patient = {
  __typename?: 'Patient';
  allergies?: Maybe<Scalars['String']>;
  allergyRecords: Array<AllergyIntolerance>;
  archivedAt?: Maybe<Scalars['DateTime']>;
  attachments?: Maybe<Array<Document>>;
  clientProfileId: Scalars['ID'];
  clinicalProcedureRecords: Array<ClinicalProcedure>;
  conditionRecords: Array<Condition>;
  conditions?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  emrInstanceId: Scalars['ID'];
  id: Scalars['ID'];
  immunizationRecords: Array<Immunization>;
  immunizations?: Maybe<Scalars['String']>;
  labRecords: Array<Lab>;
  labs?: Maybe<Scalars['String']>;
  medicationRecords: Array<MedicationStatement>;
  medications?: Maybe<Scalars['String']>;
  orders: Array<Order>;
  procedures?: Maybe<Scalars['String']>;
  signedConsentForms: Array<DocumentSignature>;
  updatedAt: Scalars['DateTime'];
  vitals: Array<VitalSign>;
};

export type Payment = {
  __typename?: 'Payment';
  amount: Scalars['Int'];
  amountRequested: Scalars['Int'];
  amountReversed?: Maybe<Scalars['Int']>;
  archivedAt?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  description: Scalars['String'];
  fee: Scalars['Int'];
  id: Scalars['ID'];
  isDeposit: Scalars['Boolean'];
  status: PaymentStatus;
  type: PaymentType;
  updatedAt: Scalars['DateTime'];
};

export type PaymentAccount = {
  __typename?: 'PaymentAccount';
  archivedAt?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  enabled: Scalars['Boolean'];
  id: Scalars['ID'];
  label: Scalars['String'];
  marketplaces: Array<Marketplace>;
  onboardingUrl?: Maybe<Scalars['String']>;
  organizations: Array<Organization>;
  platform: PaymentAccountPlatform;
  state: PaymentAccountState;
  updatedAt: Scalars['DateTime'];
};

export enum PaymentAccountPlatform {
  Finix = 'FINIX'
}

export enum PaymentAccountState {
  Approved = 'APPROVED',
  Created = 'CREATED',
  Onboarding = 'ONBOARDING',
  Provisioning = 'PROVISIONING',
  Rejected = 'REJECTED'
}

export enum PaymentCollectionMethod {
  CollectDeposit = 'collect_deposit',
  CollectOnConfirmation = 'collect_on_confirmation',
  CollectOnSite = 'collect_on_site'
}

export enum PaymentDepositType {
  FixedAmount = 'fixed_amount',
  Percentage = 'percentage'
}

export type PaymentIdentityInput = {
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
};

export type PaymentInstrument = {
  __typename?: 'PaymentInstrument';
  archivedAt?: Maybe<Scalars['DateTime']>;
  brand?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  expirationMonth?: Maybe<Scalars['Float']>;
  expirationYear?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  lastFour?: Maybe<Scalars['String']>;
  processor: PaymentAccountPlatform;
  type: PaymentInstrumentType;
  updatedAt: Scalars['DateTime'];
};

export enum PaymentInstrumentType {
  Card = 'CARD'
}

export type PaymentLink = {
  __typename?: 'PaymentLink';
  amount: Scalars['Int'];
  checkoutId: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  expiresAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  status: PaymentLinkStatus;
  updatedAt: Scalars['DateTime'];
  url: Scalars['String'];
};

export type PaymentLinkDeliveryMethodsInput = {
  email?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};

export enum PaymentLinkStatus {
  Active = 'ACTIVE',
  Completed = 'COMPLETED',
  Deactivated = 'DEACTIVATED',
  Expired = 'EXPIRED'
}

export type PaymentMethodCardInput = {
  identity?: InputMaybe<PaymentIdentityInput>;
  thirdPartyToken?: InputMaybe<Scalars['String']>;
  token?: InputMaybe<Scalars['String']>;
};

export type PaymentMethodInput = {
  card?: InputMaybe<PaymentMethodCardInput>;
  marketplaceUserId?: InputMaybe<Scalars['ID']>;
  paymentInstrumentId?: InputMaybe<Scalars['ID']>;
  save?: InputMaybe<Scalars['Boolean']>;
};

export enum PaymentMethodType {
  Cash = 'CASH',
  CreditCard = 'CREDIT_CARD',
  PaymentLink = 'PAYMENT_LINK'
}

export enum PaymentStatus {
  Accepted = 'ACCEPTED',
  Authorized = 'AUTHORIZED',
  Failed = 'FAILED',
  Pending = 'PENDING'
}

export enum PaymentType {
  Cash = 'CASH',
  Credit = 'CREDIT'
}

export type Payout = {
  __typename?: 'Payout';
  amount: Scalars['Int'];
  amountRequested: Scalars['Int'];
  amountReversed?: Maybe<Scalars['Int']>;
  archivedAt?: Maybe<Scalars['DateTime']>;
  checkout?: Maybe<Checkout>;
  checkoutId: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  description: Scalars['String'];
  id: Scalars['ID'];
  status: PayoutStatus;
  updatedAt: Scalars['DateTime'];
};

export type PayoutFilterInput = {
  amount?: InputMaybe<FilterIntegerInput>;
  amountRequested?: InputMaybe<FilterIntegerInput>;
  amountReversed?: InputMaybe<FilterIntegerInput>;
  description?: InputMaybe<FilterStringInput>;
  id?: InputMaybe<FilterIntegerInput>;
  marketplaceId?: InputMaybe<FilterIntegerInput>;
  status?: InputMaybe<FilterStringInput>;
};

export type PayoutPage = {
  __typename?: 'PayoutPage';
  data: Array<Payout>;
  totalCount: Scalars['Int'];
};

export type PayoutPageInput = {
  filter?: InputMaybe<PayoutFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<PayoutSortInput>>;
};

export enum PayoutSortField {
  Amount = 'AMOUNT',
  Amountrequested = 'AMOUNTREQUESTED',
  Amountreversed = 'AMOUNTREVERSED',
  Createdat = 'CREATEDAT',
  Description = 'DESCRIPTION',
  Id = 'ID',
  Marketplaceid = 'MARKETPLACEID',
  Status = 'STATUS',
  Updatedat = 'UPDATEDAT'
}

export type PayoutSortInput = {
  direction: SortDirection;
  field: PayoutSortField;
};

export enum PayoutStatus {
  Accepted = 'ACCEPTED',
  Failed = 'FAILED',
  Pending = 'PENDING'
}

export type PreviewCheckoutItemsInput = {
  applyPackages?: InputMaybe<Scalars['Boolean']>;
  latitude?: InputMaybe<Scalars['Float']>;
  longitude?: InputMaybe<Scalars['Float']>;
  marketplaceUserId?: InputMaybe<Scalars['ID']>;
  membershipDefinitionId?: InputMaybe<Scalars['ID']>;
  /** Requests a checkout preview for each organizationId */
  organizationIds: Array<Scalars['ID']>;
  procedureBaseDefIds: Array<Scalars['ID']>;
  promoCode?: InputMaybe<Scalars['String']>;
};

export type ProcedureBaseDefLayoutInput = {
  itemIndex: Scalars['Float'];
  layout: Scalars['String'];
  type: ProcedureBaseDefinitionLayoutType;
};

export type ProcedureBaseDefinition = {
  __typename?: 'ProcedureBaseDefinition';
  addOns: Array<Scalars['String']>;
  archivedAt?: Maybe<Scalars['DateTime']>;
  category?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  description: Scalars['String'];
  duration: Scalars['Float'];
  id: Scalars['ID'];
  ingredients?: Maybe<Scalars['String']>;
  layouts: Array<ProcedureBaseDefinitionLayout>;
  marketplaceId: Scalars['ID'];
  name: Scalars['String'];
  points?: Maybe<Scalars['Int']>;
  tagline?: Maybe<Scalars['String']>;
  tags: Array<Scalars['String']>;
  thumbnail?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type ProcedureBaseDefinitionGroup = {
  __typename?: 'ProcedureBaseDefinitionGroup';
  banner?: Maybe<Scalars['String']>;
  bgcolor?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  featuredBaseDefs: Array<ProcedureBaseDefinition>;
  fontColor?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  marketplaceId: Scalars['ID'];
  name: Scalars['String'];
  procedureBaseDefGroups: Array<ProcedureBaseDefinitionGroup>;
  procedureBaseDefs: Array<ProcedureBaseDefinition>;
  thumbnail?: Maybe<Scalars['String']>;
  type: ProcedureGroupType;
};

export type ProcedureBaseDefinitionLayout = {
  __typename?: 'ProcedureBaseDefinitionLayout';
  id: Scalars['ID'];
  itemIndex: Scalars['Float'];
  layout: Scalars['String'];
  procedureBaseDefinitionId: Scalars['ID'];
  type: ProcedureBaseDefinitionLayoutType;
};

export enum ProcedureBaseDefinitionLayoutType {
  Block = 'BLOCK',
  Faq = 'FAQ',
  Grid = 'GRID',
  List = 'LIST'
}

export type ProcedureBaseDefinitionTagInput = {
  procedureBaseDefinitionId: Scalars['ID'];
  tag: Scalars['String'];
};

export type ProcedureDefinition = {
  __typename?: 'ProcedureDefinition';
  archivedAt?: Maybe<Scalars['DateTime']>;
  assessmentFormTemplateId?: Maybe<Scalars['ID']>;
  baseDefinitions: Array<ProcedureBaseDefinition>;
  consentForms: Array<Document>;
  createdAt: Scalars['DateTime'];
  description: Scalars['String'];
  duration: Scalars['Float'];
  id: Scalars['ID'];
  intakeFormTemplates: Array<FormTemplate>;
  interventionFormTemplateId?: Maybe<Scalars['ID']>;
  medicationProtocols: Array<MedicationProtocol>;
  name: Scalars['String'];
  ordersRequired: Scalars['Boolean'];
  organizationId: Scalars['ID'];
  price: Scalars['Float'];
  updatedAt: Scalars['DateTime'];
};

export enum ProcedureGroupType {
  Consumer = 'CONSUMER',
  Navigation = 'NAVIGATION',
  Notifications = 'NOTIFICATIONS',
  Reviews = 'REVIEWS',
  UserDefined = 'USER_DEFINED'
}

export type ProcedureProfile = {
  __typename?: 'ProcedureProfile';
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  name: Scalars['String'];
  organizationId: Scalars['ID'];
  procedureDefs: Array<ProcedureDefinition>;
  profiles: Array<Profile>;
  updatedAt: Scalars['DateTime'];
};

export type Profile = {
  __typename?: 'Profile';
  address: Scalars['String'];
  allowSmsNotifications: Scalars['Boolean'];
  appointments: AppointmentPage;
  archivedAt?: Maybe<Scalars['DateTime']>;
  availabilities: Array<Availability>;
  availableUntil?: Maybe<Scalars['DateTime']>;
  color: Scalars['String'];
  createdAt: Scalars['DateTime'];
  email: Scalars['String'];
  familyName: Scalars['String'];
  givenName: Scalars['String'];
  id: Scalars['ID'];
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  organization?: Maybe<Organization>;
  phone: Scalars['String'];
  pid: Scalars['String'];
  procedureProfiles: Array<ProcedureProfile>;
  roles: Array<Role>;
  title: Scalars['String'];
  tzid: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  userId?: Maybe<Scalars['ID']>;
};


export type ProfileAppointmentsArgs = {
  page?: InputMaybe<AppointmentPageInput>;
};

export type PromoCode = {
  __typename?: 'PromoCode';
  activationEndDate: Scalars['DateTime'];
  activationStartDate: Scalars['DateTime'];
  active: Scalars['Boolean'];
  archivedAt?: Maybe<Scalars['DateTime']>;
  code: Scalars['String'];
  createdAt: Scalars['DateTime'];
  discountType: PromoCodeDiscountType;
  discountValue: Scalars['Int'];
  id: Scalars['ID'];
  marketplaceId: Scalars['ID'];
  minimumBookingAmount?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  organizations: Array<Organization>;
  procedureGroups: Array<ProcedureBaseDefinitionGroup>;
  updatedAt: Scalars['DateTime'];
  usage: Array<PromoCodeUsage>;
  usageEndDate: Scalars['DateTime'];
  usageLimitPerUser?: Maybe<Scalars['Int']>;
  usageLimitTotal?: Maybe<Scalars['Int']>;
  usageStartDate: Scalars['DateTime'];
};

export enum PromoCodeDiscountType {
  FixedAmount = 'FIXED_AMOUNT',
  Percentage = 'PERCENTAGE'
}

export type PromoCodeItemDiscount = {
  __typename?: 'PromoCodeItemDiscount';
  discountAmount: Scalars['Int'];
  procedureBaseDefId: Scalars['ID'];
};

export type PromoCodeUsage = {
  __typename?: 'PromoCodeUsage';
  checkoutId?: Maybe<Scalars['ID']>;
  createdAt: Scalars['DateTime'];
  discountAmount: Scalars['Int'];
  id: Scalars['ID'];
  marketplaceUserId: Scalars['ID'];
  promoCodeId: Scalars['ID'];
  updatedAt: Scalars['DateTime'];
  usedAt: Scalars['DateTime'];
};

export type PromoCodeValidationResult = {
  __typename?: 'PromoCodeValidationResult';
  discountAmount?: Maybe<Scalars['Int']>;
  error?: Maybe<Scalars['String']>;
  itemDiscounts?: Maybe<Array<PromoCodeItemDiscount>>;
  valid: Scalars['Boolean'];
};

export enum ProviderType {
  Profile = 'PROFILE',
  Qualiphy = 'QUALIPHY'
}

export type QualiphyExam = {
  __typename?: 'QualiphyExam';
  archived: Scalars['Boolean'];
  expiresAfter: Scalars['Int'];
  id: Scalars['ID'];
  index: Scalars['Int'];
  procedureDefinitions?: Maybe<Array<Scalars['String']>>;
  qualiphyId: Scalars['ID'];
  qualiphyIntegrationId: Scalars['ID'];
  refills: Scalars['Int'];
  status?: Maybe<QualiphyInvitationStatus>;
  title: Scalars['String'];
};

export type QualiphyIntegration = {
  __typename?: 'QualiphyIntegration';
  apiKey?: Maybe<Scalars['String']>;
  apiKeyDescription?: Maybe<Scalars['String']>;
  enabled: Scalars['Boolean'];
  exams?: Maybe<Array<QualiphyExam>>;
  id: Scalars['ID'];
  organizationId: Scalars['ID'];
};

export type QualiphyInvitation = {
  __typename?: 'QualiphyInvitation';
  exams?: Maybe<Array<QualiphyExam>>;
  expiration: Scalars['DateTime'];
  id: Scalars['ID'];
  meetingUrl?: Maybe<Scalars['String']>;
  meetingUuid?: Maybe<Scalars['String']>;
  organizationId: Scalars['ID'];
};

export enum QualiphyInvitationStatus {
  Approved = 'APPROVED',
  Cancelled = 'CANCELLED',
  Deferred = 'DEFERRED',
  Missed = 'MISSED',
  NotApplicable = 'NOT_APPLICABLE',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export type Query = {
  __typename?: 'Query';
  appointment?: Maybe<Appointment>;
  appointmentRequest?: Maybe<AppointmentRequest>;
  appointmentRequests?: Maybe<AppointmentRequestPage>;
  appointmentsByGroup: Array<Appointment>;
  checkout: Checkout;
  checkouts: CheckoutPage;
  clientProfile?: Maybe<ClientProfile>;
  clientProfiles: ClientProfilePage;
  document?: Maybe<Document>;
  emrInstance?: Maybe<EmrInstance>;
  emrInstances: Array<EmrInstance>;
  formTemplate?: Maybe<FormTemplate>;
  geoperimeter?: Maybe<Geoperimeter>;
  intakeSubmission?: Maybe<IntakeSubmission>;
  intakeSubmissionsForAppointment: Array<IntakeSubmission>;
  intakeSubmissionsForClient: Array<IntakeSubmission>;
  marketplace?: Maybe<Marketplace>;
  marketplaceGroup?: Maybe<MarketplaceGroup>;
  marketplaceGroups: Array<MarketplaceGroup>;
  marketplaceUser: MarketplaceUser;
  marketplaceUsers: MarketplaceUserPage;
  marketplaces: Array<Marketplace>;
  membershipDefinition?: Maybe<MembershipDefinition>;
  metrics: Array<MetricData>;
  mfaEnrollmentReport: MfaEnrollmentReport;
  organization?: Maybe<Organization>;
  organizations: Array<Organization>;
  package?: Maybe<Package>;
  paymentAccount?: Maybe<PaymentAccount>;
  paymentAccounts: Array<PaymentAccount>;
  payout: Payout;
  payouts: PayoutPage;
  previewCheckoutItems: Array<Array<CheckoutItem>>;
  procedureBaseDefinition?: Maybe<ProcedureBaseDefinition>;
  procedureBaseDefinitionGroup?: Maybe<ProcedureBaseDefinitionGroup>;
  procedureDefinition?: Maybe<ProcedureDefinition>;
  procedureProfile?: Maybe<ProcedureProfile>;
  profile?: Maybe<Profile>;
  profiles: Array<Profile>;
  promoCode?: Maybe<PromoCode>;
  promoCodes: Array<PromoCode>;
  qualiphyExam?: Maybe<QualiphyExam>;
  reachJwt: Scalars['String'];
  report?: Maybe<Report>;
  reports: ReportPage;
  roles: Array<Role>;
  user?: Maybe<User>;
  users: Array<User>;
  validatePromoCode: PromoCodeValidationResult;
  verifyConsentToken?: Maybe<ConsentResult>;
  viewer?: Maybe<User>;
};


export type QueryAppointmentArgs = {
  id: Scalars['ID'];
};


export type QueryAppointmentRequestArgs = {
  id: Scalars['ID'];
};


export type QueryAppointmentRequestsArgs = {
  page?: InputMaybe<AppointmentRequestPageInput>;
};


export type QueryAppointmentsByGroupArgs = {
  groupId: Scalars['String'];
};


export type QueryCheckoutArgs = {
  id: Scalars['ID'];
};


export type QueryCheckoutsArgs = {
  page?: InputMaybe<CheckoutPageInput>;
};


export type QueryClientProfileArgs = {
  id: Scalars['ID'];
};


export type QueryClientProfilesArgs = {
  page?: InputMaybe<ClientProfilePageInput>;
};


export type QueryDocumentArgs = {
  id: Scalars['ID'];
};


export type QueryEmrInstanceArgs = {
  id: Scalars['ID'];
};


export type QueryFormTemplateArgs = {
  id: Scalars['ID'];
};


export type QueryGeoperimeterArgs = {
  id: Scalars['ID'];
};


export type QueryIntakeSubmissionArgs = {
  id: Scalars['ID'];
};


export type QueryIntakeSubmissionsForAppointmentArgs = {
  appointmentId: Scalars['ID'];
};


export type QueryIntakeSubmissionsForClientArgs = {
  clientProfileId: Scalars['ID'];
};


export type QueryMarketplaceArgs = {
  id: Scalars['ID'];
};


export type QueryMarketplaceGroupArgs = {
  id: Scalars['ID'];
};


export type QueryMarketplaceUserArgs = {
  id: Scalars['ID'];
};


export type QueryMarketplaceUsersArgs = {
  page?: InputMaybe<MarketplaceUserPageInput>;
};


export type QueryMembershipDefinitionArgs = {
  id: Scalars['ID'];
};


export type QueryMetricsArgs = {
  input: MetricsInput;
};


export type QueryOrganizationArgs = {
  id: Scalars['ID'];
};


export type QueryPackageArgs = {
  id: Scalars['ID'];
};


export type QueryPaymentAccountArgs = {
  id: Scalars['ID'];
};


export type QueryPayoutArgs = {
  id: Scalars['ID'];
};


export type QueryPayoutsArgs = {
  page?: InputMaybe<PayoutPageInput>;
};


export type QueryPreviewCheckoutItemsArgs = {
  input: PreviewCheckoutItemsInput;
};


export type QueryProcedureBaseDefinitionArgs = {
  id: Scalars['ID'];
};


export type QueryProcedureBaseDefinitionGroupArgs = {
  id: Scalars['ID'];
};


export type QueryProcedureDefinitionArgs = {
  id: Scalars['ID'];
};


export type QueryProcedureProfileArgs = {
  id: Scalars['ID'];
};


export type QueryProfileArgs = {
  id: Scalars['ID'];
};


export type QueryPromoCodeArgs = {
  id: Scalars['ID'];
};


export type QueryPromoCodesArgs = {
  marketplaceId: Scalars['ID'];
};


export type QueryQualiphyExamArgs = {
  id: Scalars['ID'];
};


export type QueryReachJwtArgs = {
  marketplaceId: Scalars['ID'];
};


export type QueryReportArgs = {
  id: Scalars['ID'];
};


export type QueryReportsArgs = {
  page?: InputMaybe<ReportPageInput>;
};


export type QueryUserArgs = {
  id: Scalars['ID'];
};


export type QueryValidatePromoCodeArgs = {
  input: ValidatePromoCodeInput;
};


export type QueryVerifyConsentTokenArgs = {
  marketplaceId: Scalars['ID'];
  token: Scalars['String'];
};

export type ReachIntegration = {
  __typename?: 'ReachIntegration';
  id: Scalars['ID'];
  marketplaceId: Scalars['ID'];
  reachId: Scalars['String'];
};

export type RecordCashPaymentInput = {
  amount: Scalars['Int'];
  checkoutId: Scalars['ID'];
};

export type RecordCashPaymentPayload = {
  __typename?: 'RecordCashPaymentPayload';
  checkout: Checkout;
  errorMessage?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type RefundCheckoutInput = {
  /** Required to prevent race conditions */
  balanceAfterRefund: Scalars['Int'];
  checkoutId?: InputMaybe<Scalars['ID']>;
  refundAmount: Scalars['Int'];
};

export type RegisterInput = {
  code: Scalars['String'];
  email: Scalars['String'];
  password: Scalars['String'];
};

export type RemoveOrganizationsFromMarketplaceInput = {
  marketplaceId: Scalars['ID'];
  organizationIds: Array<Scalars['ID']>;
};

export enum RepeatFrequencyType {
  Weekly = 'WEEKLY'
}

export type RepeatRule = {
  __typename?: 'RepeatRule';
  availabilityId?: Maybe<Scalars['ID']>;
  byWeekday: Array<RepeatWeekdayType>;
  frequency: RepeatFrequencyType;
  id: Scalars['ID'];
  until?: Maybe<Scalars['DateTime']>;
};

export type RepeatRuleInput = {
  byWeekday: Array<RepeatWeekdayType>;
  frequency: RepeatFrequencyType;
  until?: InputMaybe<Scalars['DateTime']>;
};

export enum RepeatWeekdayType {
  Fr = 'FR',
  Mo = 'MO',
  Sa = 'SA',
  Su = 'SU',
  Th = 'TH',
  Tu = 'TU',
  We = 'WE'
}

export type Report = {
  __typename?: 'Report';
  createdAt: Scalars['DateTime'];
  downloadUrl: Scalars['String'];
  filename?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  organizationId: Scalars['ID'];
  status: ReportStatus;
  type: ReportType;
  updatedAt: Scalars['DateTime'];
  user: User;
  userId: Scalars['ID'];
  userName?: Maybe<Scalars['String']>;
};

export type ReportAppointmentsInput = {
  dateRange: Array<Scalars['DateTime']>;
  organizationId: Scalars['ID'];
};

export type ReportFilterInput = {
  createdAt?: InputMaybe<FilterDateInput>;
  filename?: InputMaybe<FilterStringInput>;
  organizationId?: InputMaybe<FilterIntegerInput>;
  type?: InputMaybe<Array<ReportType>>;
  updatedAt?: InputMaybe<FilterDateInput>;
};

export type ReportPage = {
  __typename?: 'ReportPage';
  data: Array<Report>;
  totalCount: Scalars['Int'];
};

export type ReportPageInput = {
  filter?: InputMaybe<ReportFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<ReportSortInput>>;
};

export type ReportPersonnelInput = {
  dateRange: Array<Scalars['DateTime']>;
  organizationId: Scalars['ID'];
  profileIds?: InputMaybe<Array<Scalars['ID']>>;
};

export enum ReportSortField {
  Createdat = 'CREATEDAT',
  Filename = 'FILENAME',
  Id = 'ID',
  Status = 'STATUS',
  Type = 'TYPE',
  Updatedat = 'UPDATEDAT'
}

export type ReportSortInput = {
  direction: SortDirection;
  field: ReportSortField;
};

export enum ReportStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Processing = 'PROCESSING'
}

export enum ReportType {
  Appointments = 'APPOINTMENTS',
  Personnel = 'PERSONNEL'
}

export type RequestConfirmConsumerEmailInput = {
  email: Scalars['String'];
  marketplaceId: Scalars['ID'];
  marketplaceUserId: Scalars['ID'];
};

export type RequestConfirmConsumerPhoneInput = {
  marketplaceId: Scalars['ID'];
  marketplaceUserId: Scalars['ID'];
};

export type ResetAppointmentInput = {
  appointmentId: Scalars['ID'];
};

export type ResetAppointmentRequestInput = {
  appointmentRequestId: Scalars['ID'];
};

export type ResetPasswordInput = {
  password: Scalars['String'];
  token: Scalars['String'];
};

export type ResetUserMfaInput = {
  reason: Scalars['String'];
  userId: Scalars['ID'];
  verificationMethod: MfaResetVerificationMethod;
};

export type ResetUserMfaPayload = {
  __typename?: 'ResetUserMfaPayload';
  factorsRemoved: Scalars['Int'];
  graceUntil?: Maybe<Scalars['DateTime']>;
  sessionsEnded: Scalars['Int'];
};

export type ReviewIntakeSubmissionInput = {
  reviewNotes?: InputMaybe<Scalars['String']>;
  reviewStatus: IntakeReviewStatus;
  submissionId: Scalars['ID'];
};

export type Role = {
  __typename?: 'Role';
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  name: Scalars['String'];
  permissions: Array<Scalars['String']>;
  resourceId?: Maybe<Scalars['ID']>;
  scope: RoleScope;
  type: RoleType;
  updatedAt: Scalars['DateTime'];
};

export enum RoleScope {
  Marketplace = 'MARKETPLACE',
  Organization = 'ORGANIZATION',
  Root = 'ROOT'
}

export enum RoleType {
  Custom = 'CUSTOM',
  System = 'SYSTEM',
  SystemBase = 'SYSTEM_BASE'
}

export type SaveProfileLocationInput = {
  profileId: Scalars['ID'];
};

export type SegmentIntegration = {
  __typename?: 'SegmentIntegration';
  clientWriteKey?: Maybe<Scalars['String']>;
  enabled: Scalars['Boolean'];
  id: Scalars['ID'];
  sendChartNotes: Scalars['Boolean'];
  v2Enabled: Scalars['Boolean'];
  v2WriteKeyDescription?: Maybe<Scalars['String']>;
  writeKeyDescription?: Maybe<Scalars['String']>;
};

export type SendIntakeFormDeliveryInput = {
  email?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};

export type SendIntakeFormResult = {
  __typename?: 'SendIntakeFormResult';
  email?: Maybe<IntakeChannelOutcome>;
  rotationError?: Maybe<Scalars['String']>;
  sms?: Maybe<IntakeChannelOutcome>;
  submissions: Array<IntakeSubmission>;
};

export type SendInvitationInput = {
  email?: InputMaybe<Scalars['String']>;
  profileId: Scalars['ID'];
};

export type SendPaymentLinkInput = {
  deliveryMethods: PaymentLinkDeliveryMethodsInput;
  paymentLinkId: Scalars['ID'];
};

export type SendReceiptDeliveryMethodsInput = {
  email?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};

export type SendReceiptInput = {
  deliveryMethods?: InputMaybe<SendReceiptDeliveryMethodsInput>;
  paymentId: Scalars['ID'];
};

export type SendReceiptPayload = {
  __typename?: 'SendReceiptPayload';
  message?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type SendWaitlistNotificationInput = {
  appointmentRequestId: Scalars['ID'];
};

export type SendgridIntegration = {
  __typename?: 'SendgridIntegration';
  apiKeyDescription?: Maybe<Scalars['String']>;
  domain: Scalars['String'];
  enabled: Scalars['Boolean'];
  id: Scalars['ID'];
  webOrigin: Scalars['String'];
};

export type SetUserMcpAccessInput = {
  enabled: Scalars['Boolean'];
  userId: Scalars['ID'];
};

export type SignDocumentInput = {
  documentId: Scalars['ID'];
  documentVersion: Scalars['Int'];
  latitude?: InputMaybe<Scalars['Float']>;
  longitude?: InputMaybe<Scalars['Float']>;
  /** signature image file token (4:1 aspect ratio) */
  signatureImageToken?: InputMaybe<Scalars['String']>;
  signerEmail?: InputMaybe<Scalars['String']>;
  /** patient ID if signerType is PATIENT */
  signerId?: InputMaybe<Scalars['ID']>;
  signerName: Scalars['String'];
  signerType: DocumentSignatureSignerType;
  tzid: Scalars['String'];
  verificationDetail?: InputMaybe<Scalars['String']>;
  verificationType: DocumentSignatureVerificationType;
};

export enum SortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type StartAppointmentInput = {
  appointmentId: Scalars['ID'];
  startedAt?: InputMaybe<Scalars['DateTime']>;
};

export enum StateCode {
  Ak = 'AK',
  Al = 'AL',
  Ar = 'AR',
  Az = 'AZ',
  Ca = 'CA',
  Co = 'CO',
  Ct = 'CT',
  De = 'DE',
  Fl = 'FL',
  Ga = 'GA',
  Hi = 'HI',
  Ia = 'IA',
  Id = 'ID',
  Il = 'IL',
  In = 'IN',
  Ks = 'KS',
  Ky = 'KY',
  La = 'LA',
  Ma = 'MA',
  Md = 'MD',
  Me = 'ME',
  Mi = 'MI',
  Mn = 'MN',
  Mo = 'MO',
  Ms = 'MS',
  Mt = 'MT',
  Nc = 'NC',
  Nd = 'ND',
  Ne = 'NE',
  Nh = 'NH',
  Nj = 'NJ',
  Nm = 'NM',
  Nv = 'NV',
  Ny = 'NY',
  Oh = 'OH',
  Ok = 'OK',
  Or = 'OR',
  Pa = 'PA',
  Ri = 'RI',
  Sc = 'SC',
  Sd = 'SD',
  Tn = 'TN',
  Tx = 'TX',
  Ut = 'UT',
  Va = 'VA',
  Vt = 'VT',
  Wa = 'WA',
  Wi = 'WI',
  Wv = 'WV',
  Wy = 'WY'
}

export type TotpEnrollment = {
  __typename?: 'TotpEnrollment';
  enrollmentId: Scalars['ID'];
  otpauthUrl: Scalars['String'];
  qrSvg: Scalars['String'];
};

export type TrustedDevice = {
  __typename?: 'TrustedDevice';
  createdAt: Scalars['DateTime'];
  current: Scalars['Boolean'];
  expiresAt: Scalars['DateTime'];
  id: Scalars['ID'];
  label: Scalars['String'];
  lastUsedAt?: Maybe<Scalars['DateTime']>;
};

export type TwilioIntegration = {
  __typename?: 'TwilioIntegration';
  appointmentRequestsEnabled: Scalars['Boolean'];
  appointmentsEnabled: Scalars['Boolean'];
  id: Scalars['ID'];
  intakeTextsEnabled: Scalars['Boolean'];
  messagingSender?: Maybe<MessagingSenderStatus>;
  waitlistTextsEnabled: Scalars['Boolean'];
};

export type UnassignPaymentAccountInput = {
  marketplaceId?: InputMaybe<Scalars['ID']>;
  organizationId?: InputMaybe<Scalars['ID']>;
  paymentAccountId: Scalars['ID'];
};

export type UnassignProcedureProfileInput = {
  procedureProfileId: Scalars['ID'];
  profileId: Scalars['ID'];
};

export type UnassignRoleInput = {
  profileId: Scalars['ID'];
  resourceId?: InputMaybe<Scalars['ID']>;
  scope: RoleScope;
};

export type UnlockFormInput = {
  formId: Scalars['ID'];
};

export type UpdateApiKeyInput = {
  kid: Scalars['ID'];
  roleIds: Array<Scalars['ID']>;
};

export type UpdateAppointmentInput = {
  end?: InputMaybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  location?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  participants?: InputMaybe<Array<AppointmentParticipantInput>>;
  procedureBaseDefIds?: InputMaybe<Array<Scalars['ID']>>;
  start?: InputMaybe<Scalars['DateTime']>;
};

export type UpdateAppointmentRequestInput = {
  /** Replaces the additional patients on this request. Omit to leave patients unchanged; pass [] to remove all additional patients. */
  additionalPatients?: InputMaybe<Array<AppointmentRequestPatientInput>>;
  checkoutNotes?: InputMaybe<Scalars['JSONObject']>;
  clientProfileIds?: InputMaybe<Array<Scalars['ID']>>;
  constraints?: InputMaybe<Array<AppointmentConstraintInput>>;
  id: Scalars['ID'];
  location?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  procedureBaseDefIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type UpdateAppointmentSecondaryParticipantsInput = {
  appointmentId: Scalars['ID'];
  profileIds: Array<Scalars['ID']>;
};

export type UpdateAttentiveIntegrationInput = {
  apiKey?: InputMaybe<Scalars['String']>;
  appointmentBookedEnabled?: InputMaybe<Scalars['Boolean']>;
  appointmentBookedEvent?: InputMaybe<Scalars['String']>;
  appointmentCompletedEnabled?: InputMaybe<Scalars['Boolean']>;
  appointmentCompletedEvent?: InputMaybe<Scalars['String']>;
  marketingSignUpUnitId?: InputMaybe<Scalars['String']>;
  marketplaceId: Scalars['ID'];
  qualiphyTextsEnabled?: InputMaybe<Scalars['Boolean']>;
  qualiphyTextsEvent?: InputMaybe<Scalars['String']>;
  transactionalSignUpUnitId?: InputMaybe<Scalars['String']>;
};

export type UpdateAvailabilityCoverageInput = {
  end: Scalars['DateTime'];
  id: Scalars['ID'];
  label: Scalars['String'];
  procedureProfileIds: Array<Scalars['ID']>;
  repeat?: InputMaybe<RepeatRuleInput>;
  start: Scalars['DateTime'];
  threshold: Scalars['Int'];
  tzid: Scalars['String'];
};

export type UpdateAvailabilityInput = {
  end: Scalars['DateTime'];
  id: Scalars['ID'];
  repeat?: InputMaybe<RepeatRuleInput>;
  start: Scalars['DateTime'];
};

export type UpdateCheckoutInput = {
  id: Scalars['ID'];
  items?: InputMaybe<Array<CheckoutItemInput>>;
  paymentMethod?: InputMaybe<PaymentMethodInput>;
  paymentMethodType?: InputMaybe<PaymentMethodType>;
};

export type UpdateClientProfileInput = {
  address?: InputMaybe<Scalars['String']>;
  /** yyyy-mm-dd */
  dob?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  familyName?: InputMaybe<Scalars['String']>;
  givenName?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  internalNotes?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  sexAssignedAtBirth?: InputMaybe<Scalars['String']>;
  tzid?: InputMaybe<Scalars['String']>;
  /** Profile of the acting user, recorded as the internal-note editor when internalNotes changes. Must belong to the caller. */
  updatedByProfileId?: InputMaybe<Scalars['ID']>;
};

export type UpdateConfigGroupInput = {
  baseDefinitionIds?: InputMaybe<Array<Scalars['ID']>>;
  groupIds?: InputMaybe<Array<Scalars['ID']>>;
  marketplaceId: Scalars['ID'];
};

export type UpdateDiscountInput = {
  id: Scalars['ID'];
  percentage?: InputMaybe<Scalars['Int']>;
  procedureGroupIds?: InputMaybe<Array<Scalars['String']>>;
};

export type UpdateDocumentInput = {
  filename?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  label?: InputMaybe<Scalars['String']>;
  token?: InputMaybe<Scalars['String']>;
};

export type UpdateEmrInstanceInput = {
  id: Scalars['ID'];
  label: Scalars['String'];
};

export type UpdateFormNoteInput = {
  id: Scalars['ID'];
  note: Scalars['String'];
};

export type UpdateFormTemplateInput = {
  id: Scalars['ID'];
  items?: InputMaybe<Array<FormTemplateItemInput>>;
  name: Scalars['String'];
  parentId?: InputMaybe<Scalars['ID']>;
  type: FormType;
};

export type UpdateGeoperimeterInput = {
  id: Scalars['ID'];
  lat?: InputMaybe<Scalars['Float']>;
  lng?: InputMaybe<Scalars['Float']>;
  paths?: InputMaybe<Scalars['String']>;
  radius?: InputMaybe<Scalars['Float']>;
  travelFee?: InputMaybe<Scalars['Int']>;
  type: GeoperimeterType;
};

export type UpdateGroupAppointmentInput = {
  /** New patients to add to the group. Each gets a sibling appointment sharing groupId/start/end/location/practitioner. */
  addMembers?: InputMaybe<Array<AddGroupAppointmentMemberInput>>;
  /** Explicit end time. When omitted, end is auto-derived from the longest member procedure-duration sum. */
  end?: InputMaybe<Scalars['DateTime']>;
  /** Existing group identifier. Mutually exclusive with `primaryAppointmentId`. */
  groupId?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['String']>;
  members?: InputMaybe<Array<UpdateGroupAppointmentMemberInput>>;
  notes?: InputMaybe<Scalars['String']>;
  /** Replace the practitioner across every active appointment in the group. */
  practitionerProfileId?: InputMaybe<Scalars['ID']>;
  /** Use to convert a solo appointment into a group. The appointment must not already have a groupId, and `addMembers` must be non-empty. Mutually exclusive with `groupId`. */
  primaryAppointmentId?: InputMaybe<Scalars['ID']>;
  /** Appointment IDs to cancel (members removed from the group). */
  removeAppointmentIds?: InputMaybe<Array<Scalars['ID']>>;
  start?: InputMaybe<Scalars['DateTime']>;
};

export type UpdateGroupAppointmentMemberInput = {
  appointmentId: Scalars['ID'];
  procedureBaseDefIds: Array<Scalars['ID']>;
};

export type UpdateMarketplaceCheckoutNotesInput = {
  id: Scalars['ID'];
  items: Array<CheckoutNoteItemInput>;
};

export type UpdateMarketplaceGroupInput = {
  id: Scalars['ID'];
  label?: InputMaybe<Scalars['String']>;
  messagingServiceSid?: InputMaybe<Scalars['String']>;
};

export type UpdateMarketplaceInput = {
  bookingMode?: InputMaybe<BookingMode>;
  checkoutContent?: InputMaybe<MarketplaceCheckoutContentInput>;
  consentTokenSecret?: InputMaybe<Scalars['String']>;
  dispatchStrategy?: InputMaybe<DispatchStrategy>;
  faviconToken?: InputMaybe<Scalars['String']>;
  featureFlags?: InputMaybe<MarketplaceFeatureFlagsInput>;
  feeProfileBasisPoints?: InputMaybe<Scalars['Int']>;
  feeProfileFixed?: InputMaybe<Scalars['Int']>;
  groupId?: InputMaybe<Scalars['ID']>;
  gtmContainer?: InputMaybe<Scalars['String']>;
  gtmDataTier?: InputMaybe<GtmDataTier>;
  gtmRequiresConsent?: InputMaybe<Scalars['Boolean']>;
  gtmV2Enabled?: InputMaybe<Scalars['Boolean']>;
  hasPaymentPolicy?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  logoToken?: InputMaybe<Scalars['String']>;
  marketingSiteUrl?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  paymentCollectionMethod?: InputMaybe<PaymentCollectionMethod>;
  paymentDepositType?: InputMaybe<PaymentDepositType>;
  paymentDepositValue?: InputMaybe<Scalars['Float']>;
  paymentPolicyName?: InputMaybe<Scalars['String']>;
  paymentPolicyText?: InputMaybe<Scalars['String']>;
  primaryColor?: InputMaybe<Scalars['String']>;
  requireDispatchApproval?: InputMaybe<Scalars['Boolean']>;
  requirePaymentPolicyAttestation?: InputMaybe<Scalars['Boolean']>;
  requirePractitionerApproval?: InputMaybe<Scalars['Boolean']>;
  reviewsIoKey?: InputMaybe<Scalars['String']>;
  reviewsIoStoreId?: InputMaybe<Scalars['String']>;
  slackWebhookUrl?: InputMaybe<Scalars['String']>;
};

export type UpdateMarketplaceMfaModeInput = {
  marketplaceId: Scalars['ID'];
  mode: MfaModeSetting;
};

export type UpdateMarketplaceUserInput = {
  clientProfile?: InputMaybe<ClientProfileInput>;
  email?: InputMaybe<Scalars['String']>;
  emailConfirmed?: InputMaybe<Scalars['Boolean']>;
  emailOptIn?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  membership?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  phoneConfirmed?: InputMaybe<Scalars['Boolean']>;
  phoneOptIn?: InputMaybe<Scalars['Boolean']>;
  primaryInstrumentId?: InputMaybe<Scalars['ID']>;
};

export type UpdateMedicationInput = {
  id: Scalars['ID'];
  name: Scalars['String'];
  unit: Scalars['String'];
};

export type UpdateMembershipDefinitionInput = {
  advertise?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  list?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  packageId?: InputMaybe<Scalars['ID']>;
  period?: InputMaybe<MembershipDefinitionPeriodType>;
  price?: InputMaybe<Scalars['Int']>;
};

export type UpdateMembershipInput = {
  id: Scalars['ID'];
  renewalDate?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<MembershipStatusType>;
};

export type UpdateOrderInput = {
  expiresAt: Scalars['DateTime'];
  id: Scalars['ID'];
  note?: InputMaybe<Scalars['String']>;
  procedureDefIds?: InputMaybe<Array<Scalars['ID']>>;
  refills: Scalars['Int'];
  startsAt?: InputMaybe<Scalars['DateTime']>;
};

export type UpdateOrganizationInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  address?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  enablePractitionerSms?: InputMaybe<Scalars['Boolean']>;
  enableReceiptSending?: InputMaybe<Scalars['Boolean']>;
  googleReviewsUrl?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  intakeAutoSendMode?: InputMaybe<IntakeAutoSendMode>;
  intakeDeliveryChannel?: InputMaybe<IntakeDeliveryChannel>;
  intakeSmsTemplate?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  providesAtClinic?: InputMaybe<Scalars['Boolean']>;
  qualiphyApiKey?: InputMaybe<Scalars['String']>;
  slackWebhookUrl?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<StateCode>;
  tzid?: InputMaybe<Scalars['String']>;
};

export type UpdateOrganizationMfaModeInput = {
  mode: MfaModeSetting;
  organizationId: Scalars['ID'];
};

export type UpdatePackageInput = {
  advertise?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  list?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Int']>;
};

export type UpdatePackageItemDefinitionInput = {
  id: Scalars['ID'];
  points?: InputMaybe<Scalars['Int']>;
  procedureGroupIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type UpdatePackageItemInput = {
  expiresAt?: InputMaybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  primaryOrganizationId?: InputMaybe<Scalars['ID']>;
};

export type UpdatePatientInput = {
  allergies?: InputMaybe<Scalars['String']>;
  conditions?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  immunizations?: InputMaybe<Scalars['String']>;
  labs?: InputMaybe<Scalars['String']>;
  medications?: InputMaybe<Scalars['String']>;
  procedures?: InputMaybe<Scalars['String']>;
};

export type UpdatePaymentAccountInput = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  label: Scalars['String'];
};

export type UpdateProcedureBaseDefinitionGroupInput = {
  bannerToken?: InputMaybe<Scalars['String']>;
  baseDefinitionIds?: InputMaybe<Array<Scalars['ID']>>;
  bgcolor?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  featuredBaseDefIds?: InputMaybe<Array<Scalars['ID']>>;
  fontColor?: InputMaybe<Scalars['String']>;
  groupIds?: InputMaybe<Array<Scalars['ID']>>;
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  thumbnailToken?: InputMaybe<Scalars['String']>;
};

export type UpdateProcedureBaseDefinitionInput = {
  /** procedure base def group ids */
  addOnIds?: InputMaybe<Array<Scalars['ID']>>;
  category?: InputMaybe<Scalars['String']>;
  description: Scalars['String'];
  duration: Scalars['Float'];
  id: Scalars['ID'];
  ingredients?: InputMaybe<Scalars['String']>;
  layouts?: InputMaybe<Array<ProcedureBaseDefLayoutInput>>;
  name: Scalars['String'];
  points?: InputMaybe<Scalars['Float']>;
  tagline?: InputMaybe<Scalars['String']>;
  thumbnailToken?: InputMaybe<Scalars['String']>;
};

export type UpdateProcedureDefinitionInput = {
  assessmentFormTemplateId?: InputMaybe<Scalars['ID']>;
  baseDefinitionIds?: InputMaybe<Array<Scalars['ID']>>;
  consentFormIds?: InputMaybe<Array<Scalars['ID']>>;
  description: Scalars['String'];
  duration: Scalars['Float'];
  id: Scalars['ID'];
  intakeFormTemplateIds?: InputMaybe<Array<Scalars['ID']>>;
  interventionFormTemplateId?: InputMaybe<Scalars['ID']>;
  medicationProtocols?: InputMaybe<Array<MedicationProtocolInput>>;
  name: Scalars['String'];
  ordersRequired?: InputMaybe<Scalars['Boolean']>;
  price: Scalars['Float'];
};

export type UpdateProcedureProfileInput = {
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  procedureDefIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type UpdateProfileInput = {
  address?: InputMaybe<Scalars['String']>;
  allowSmsNotifications?: InputMaybe<Scalars['Boolean']>;
  availableUntil?: InputMaybe<Scalars['DateTime']>;
  color?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  familyName?: InputMaybe<Scalars['String']>;
  givenName?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  phone?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  tzid?: InputMaybe<Scalars['String']>;
};

export type UpdatePromoCodeInput = {
  activationEndDate?: InputMaybe<Scalars['String']>;
  activationStartDate?: InputMaybe<Scalars['String']>;
  active?: InputMaybe<Scalars['Boolean']>;
  code?: InputMaybe<Scalars['String']>;
  discountType?: InputMaybe<PromoCodeDiscountType>;
  discountValue?: InputMaybe<Scalars['Int']>;
  id: Scalars['ID'];
  minimumBookingAmount?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  organizationIds?: InputMaybe<Array<Scalars['String']>>;
  procedureGroupIds?: InputMaybe<Array<Scalars['String']>>;
  usageEndDate?: InputMaybe<Scalars['String']>;
  usageLimitPerUser?: InputMaybe<Scalars['Int']>;
  usageLimitTotal?: InputMaybe<Scalars['Int']>;
  usageStartDate?: InputMaybe<Scalars['String']>;
};

export type UpdateQualiphyExamInput = {
  expiresAfter?: InputMaybe<Scalars['Int']>;
  id: Scalars['ID'];
  organizationId: Scalars['ID'];
  procedureDefinitionIds: Array<Scalars['ID']>;
  refills?: InputMaybe<Scalars['Int']>;
};

export type UpdateQualiphyIntegrationInput = {
  apiKey?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  examIds?: InputMaybe<Array<Scalars['String']>>;
  organizationId: Scalars['ID'];
};

export type UpdateRoleInput = {
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  permissions?: InputMaybe<Array<Scalars['String']>>;
};

export type UpdateSegmentIntegrationInput = {
  clientWriteKey?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  marketplaceId: Scalars['ID'];
  sendChartNotes?: InputMaybe<Scalars['Boolean']>;
  v2Enabled?: InputMaybe<Scalars['Boolean']>;
  v2WriteKey?: InputMaybe<Scalars['String']>;
  writeKey?: InputMaybe<Scalars['String']>;
};

export type UpdateSendgridIntegrationInput = {
  apiKey?: InputMaybe<Scalars['String']>;
  domain?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  marketplaceId: Scalars['ID'];
  webOrigin?: InputMaybe<Scalars['String']>;
};

export type UpdateTwilioIntegrationInput = {
  appointmentRequestsEnabled?: InputMaybe<Scalars['Boolean']>;
  appointmentsEnabled?: InputMaybe<Scalars['Boolean']>;
  intakeTextsEnabled?: InputMaybe<Scalars['Boolean']>;
  marketplaceId: Scalars['ID'];
  waitlistTextsEnabled?: InputMaybe<Scalars['Boolean']>;
};

export type UpsertReachUserInput = {
  marketplaceId: Scalars['ID'];
  marketplaceUserId: Scalars['ID'];
};

export type UsePaymentAccountInput = {
  marketplaceId?: InputMaybe<Scalars['ID']>;
  organizationId?: InputMaybe<Scalars['ID']>;
  paymentAccountId?: InputMaybe<Scalars['ID']>;
};

export type User = {
  __typename?: 'User';
  apiKeys: Array<ApiKey>;
  createdAt: Scalars['DateTime'];
  email: Scalars['String'];
  emailConfirmed: Scalars['Boolean'];
  id: Scalars['ID'];
  isMcpEnabled: Scalars['Boolean'];
  mfa?: Maybe<MfaStatus>;
  profiles: Array<Profile>;
  trustedDevices?: Maybe<Array<TrustedDevice>>;
  updatedAt: Scalars['DateTime'];
};

export type ValidatePromoCodeInput = {
  bookingAmount?: InputMaybe<Scalars['Int']>;
  bookingDate?: InputMaybe<Scalars['String']>;
  code: Scalars['String'];
  marketplaceId: Scalars['ID'];
  marketplaceUserId?: InputMaybe<Scalars['ID']>;
  organizationId?: InputMaybe<Scalars['ID']>;
  procedureBaseDefIds?: InputMaybe<Array<Scalars['String']>>;
  waitlistDates?: InputMaybe<Array<Scalars['String']>>;
};

export type VerifyEmailInput = {
  token: Scalars['String'];
};

export type VerifyMfaInput = {
  challengeId?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
  credential?: InputMaybe<Scalars['JSONObject']>;
  method: MfaMethod;
  trustDevice?: InputMaybe<Scalars['Boolean']>;
};

export type VerifyMfaStepUpInput = {
  challengeId: Scalars['String'];
  code?: InputMaybe<Scalars['String']>;
  credential?: InputMaybe<Scalars['JSONObject']>;
  method: MfaMethod;
};

export type VitalSign = {
  __typename?: 'VitalSign';
  createdAt: Scalars['DateTime'];
  createdById: Scalars['ID'];
  id: Scalars['ID'];
  recordedAt: Scalars['DateTime'];
  type: VitalSignType;
  updatedAt: Scalars['DateTime'];
  value: Scalars['String'];
};

export type VitalSignInput = {
  type: VitalSignType;
  value: Scalars['String'];
};

export enum VitalSignType {
  BloodPressure = 'BLOOD_PRESSURE',
  OxygenSaturation = 'OXYGEN_SATURATION',
  Pulse = 'PULSE',
  RespiratoryRate = 'RESPIRATORY_RATE',
  Temperature = 'TEMPERATURE'
}

export type WaitlistAppointmentRequestInput = {
  appointmentRequestId: Scalars['ID'];
};

export type WindowBookingConfig = {
  __typename?: 'WindowBookingConfig';
  allowSpecificTimeRequest?: Maybe<Scalars['Boolean']>;
  minRemainingMinutes?: Maybe<Scalars['Int']>;
  windows?: Maybe<Array<WindowConfig>>;
};

export type WindowBookingConfigInput = {
  allowSpecificTimeRequest?: InputMaybe<Scalars['Boolean']>;
  minRemainingMinutes?: InputMaybe<Scalars['Int']>;
  windows?: InputMaybe<Array<WindowConfigInput>>;
};

export type WindowConfig = {
  __typename?: 'WindowConfig';
  enabled: Scalars['Boolean'];
  endTime: Scalars['String'];
  key: WindowKey;
  startTime: Scalars['String'];
};

export type WindowConfigInput = {
  enabled: Scalars['Boolean'];
  endTime: Scalars['String'];
  key: WindowKey;
  startTime: Scalars['String'];
};

export enum WindowKey {
  Afternoon = 'afternoon',
  Evening = 'evening',
  Morning = 'morning'
}

export type AllergyIntoleranceFieldsFragment = { __typename?: 'AllergyIntolerance', id: string, name: string };

export type ApiKeyFieldsFragment = { __typename?: 'ApiKey', id: string, kid: string, name: string, createdAt: any, roles: Array<{ __typename?: 'Role', id: string, name: string, scope: RoleScope, type: RoleType, permissions: Array<string>, resourceId?: string | null }> };

export type AppointmentCandidateFieldsFragment = { __typename?: 'AppointmentCandidate', id: string, rank: number, start?: any | null, duration?: number | null, reservableTimes: Array<any>, availableTimes: Array<any>, profile?: { __typename?: 'Profile', latitude?: number | null, longitude?: number | null, id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null } | null };

export type AppointmentConstraintFieldsFragment = { __typename?: 'AppointmentConstraint', id: string, organizations: Array<{ __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null }>, profiles: Array<{ __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null }>, timeRanges: Array<{ __typename?: 'AppointmentTimeRange', id: string, start: any, end: any }> };

export type AppointmentFieldsFragment = { __typename?: 'Appointment', id: string, location: string, latitude?: number | null, longitude?: number | null, start: any, end: any, duration: number, createdAt: any, updatedAt: any, archivedAt?: any | null, status: AppointmentStatus, startedAt?: any | null, completedAt?: any | null, notes?: string | null, createdBy?: string | null, cancelReason?: string | null, groupId?: string | null, ordersRequired: boolean };

export type AppointmentIntakeFieldsFragment = { __typename?: 'Appointment', intakeStatus?: string | null, intakeSubmissions: Array<{ __typename?: 'IntakeSubmission', id: string, formName?: string | null, status: IntakeSubmissionStatus, reviewStatus?: IntakeReviewStatus | null, formUrl?: string | null, formTemplateId: string, triggerType: IntakeTriggerType, submittedAt?: any | null, smsSentAt?: any | null }> };

export type AppointmentParticipantFieldsFragment = { __typename?: 'AppointmentParticipant', id: string, name: string, type: ParticipantType, status: ParticipationStatus, profileId?: string | null, clientProfileId?: string | null, orderApproved?: boolean | null };

export type AppointmentRequestFieldsFragment = { __typename?: 'AppointmentRequest', id: string, location: string, latitude?: number | null, longitude?: number | null, status: AppointmentRequestStatus, bookingMode?: BookingMode | null, cancelReason?: string | null, notes?: string | null, lastResetAt?: any | null, waitlistedAt?: any | null, createdAt: any, updatedAt: any, archivedAt?: any | null };

export type AppointmentSummaryFieldsFragment = { __typename?: 'Appointment', id: string, status: AppointmentStatus, cancelReason?: string | null, start: any, end: any, duration: number, location: string, groupId?: string | null, archivedAt?: any | null, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string }>, participants: Array<{ __typename?: 'AppointmentParticipant', id: string, name: string, type: ParticipantType, status: ParticipationStatus, profileId?: string | null, clientProfileId?: string | null, orderApproved?: boolean | null }> };

export type AppointmentTimeRangeFieldsFragment = { __typename?: 'AppointmentTimeRange', id: string, start: any, end: any };

export type AttentiveFieldsFragment = { __typename?: 'AttentiveIntegration', id: string, apiKeyDescription?: string | null, appointmentCompletedEnabled?: boolean | null, appointmentCompletedEvent?: string | null, qualiphyTextsEnabled?: boolean | null, qualiphyTextsEvent?: string | null, marketingSignUpUnitId?: string | null, transactionalSignUpUnitId?: string | null };

export type AvailabilityCoverageFieldsFragment = { __typename?: 'AvailabilityCoverage', id: string, label: string, threshold: number, start: any, end: any, tzid: string, repeat?: { __typename?: 'RepeatRule', id: string, frequency: RepeatFrequencyType, byWeekday: Array<RepeatWeekdayType>, until?: any | null } | null, profiles: Array<{ __typename?: 'ProcedureProfile', id: string }> };

export type AvailabilityCoverageRangeFieldsFragment = { __typename?: 'AvailabilityCoverageRange', tzid: string, id: string, start: any, end: any, label: string, type: CoverageType, procedureProfileIds: Array<string> };

export type AvailabilityFieldsFragment = { __typename?: 'Availability', id: string, type: AvailabilityType, start: any, end: any, tzid: string, duration: number, createdAt: any, updatedAt: any, repeat?: { __typename?: 'RepeatRule', id: string, frequency: RepeatFrequencyType, byWeekday: Array<RepeatWeekdayType>, until?: any | null } | null };

export type ChartDataFieldsFragment = { __typename?: 'ChartData', labels: Array<string>, datasets: Array<{ __typename?: 'Dataset', label: string, data: Array<number>, backgroundColor: Array<string>, borderColor: Array<string> }> };

export type CheckoutFieldsFragment = { __typename?: 'Checkout', id: string, total: number, paid: number, balance: number, marketplaceUserId?: string | null, summary?: string | null, voidedAt?: any | null, paymentMethodType?: PaymentMethodType | null, createdAt: any, updatedAt: any, paymentLinks: Array<{ __typename?: 'PaymentLink', id: string, checkoutId: string, url: string, status: PaymentLinkStatus, amount: number, expiresAt?: any | null, createdAt: any, updatedAt: any }> };

export type CheckoutItemFieldsFragment = { __typename?: 'CheckoutItem', id: string, type: CheckoutItemType, description: string, quantity: number, price: number, key?: string | null };

export type CheckoutNoteItemFieldsFragment = { __typename?: 'CheckoutNoteItem', id: string, index: number, label: string, type: FormItemType, options?: string | null, createdAt: any, updatedAt: any };

export type CheckoutWithAppointmentFieldsFragment = { __typename?: 'Checkout', id: string, total: number, paid: number, balance: number, marketplaceUserId?: string | null, summary?: string | null, voidedAt?: any | null, paymentMethodType?: PaymentMethodType | null, createdAt: any, updatedAt: any, appointment?: { __typename?: 'Appointment', id: string, location: string, latitude?: number | null, longitude?: number | null, start: any, end: any, duration: number, createdAt: any, updatedAt: any, archivedAt?: any | null, status: AppointmentStatus, startedAt?: any | null, completedAt?: any | null, notes?: string | null, createdBy?: string | null, cancelReason?: string | null, groupId?: string | null, ordersRequired: boolean, participants: Array<{ __typename?: 'AppointmentParticipant', id: string, name: string, type: ParticipantType, status: ParticipationStatus, profileId?: string | null, clientProfileId?: string | null, orderApproved?: boolean | null, participant?: { __typename?: 'ClientProfile', internalNotesUpdatedBy?: string | null, internalNotesUpdatedAt?: any | null, id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null, patient?: { __typename?: 'Patient', id: string, allergies?: string | null, archivedAt?: any | null, clientProfileId: string, conditions?: string | null, createdAt: any, emrInstanceId: string, immunizations?: string | null, labs?: string | null, medications?: string | null, procedures?: string | null, updatedAt: any, orders: Array<{ __typename?: 'Order', id: string, archivedAt?: any | null, createdAt: any, expiresAt: any, providerType: ProviderType, fillCount: number, note?: string | null, refills: number, startsAt: any, updatedAt: any, procedureDefs: Array<{ __typename?: 'ProcedureDefinition', id: string, name: string, description: string, price: number, duration: number, assessmentFormTemplateId?: string | null, interventionFormTemplateId?: string | null, ordersRequired: boolean, createdAt: any, intakeFormTemplates: Array<{ __typename?: 'FormTemplate', id: string, name: string }> }>, profile?: { __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null } | null, organizations: Array<{ __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null }> }>, vitals: Array<{ __typename?: 'VitalSign', id: string, createdAt: any, createdById: string, recordedAt: any, type: VitalSignType, updatedAt: any, value: string }>, signedConsentForms: Array<{ __typename?: 'DocumentSignature', id: string, signerName: string, signerEmail?: string | null, signerType: DocumentSignatureSignerType, signedAt: any, verificationType: DocumentSignatureVerificationType, verificationDetail?: string | null, tzid: string, latitude?: number | null, longitude?: number | null, documentId: string, version: number, documentLabel: string, url?: string | null, createdAt: any, updatedAt: any }>, allergyRecords: Array<{ __typename?: 'AllergyIntolerance', id: string, name: string }>, clinicalProcedureRecords: Array<{ __typename?: 'ClinicalProcedure', id: string, name: string }>, conditionRecords: Array<{ __typename?: 'Condition', id: string, name: string }>, immunizationRecords: Array<{ __typename?: 'Immunization', id: string, name: string }>, labRecords: Array<{ __typename?: 'Lab', id: string, name: string }>, medicationRecords: Array<{ __typename?: 'MedicationStatement', id: string, name: string }>, attachments?: Array<{ __typename?: 'Document', id: string, filename: string, label: string, type: DocumentType, version: number, fileSize: number, url: string, createdAt: any, updatedAt: any }> | null } | null } | { __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null } | null, responses: Array<{ __typename?: 'AppointmentResponse', id: string, start?: any | null, end?: any | null, createdAt: any, updatedAt: any }>, forms: Array<{ __typename?: 'Form', id: string, type: FormType, status: FormStatusType, patientId: string, lockedById?: string | null, editable: boolean, createdAt: any, updatedAt: any, items: Array<{ __typename?: 'FormItem', id: string, index: number, label: string, type: FormItemType, code: string, options?: string | null, createdAt: any, updatedAt: any }>, observations: Array<{ __typename?: 'Observation', id: string, code: string, value: string, note?: string | null, createdById: string, createdAt: any, updatedAt: any, createdBy?: { __typename?: 'Profile', id: string, givenName: string, familyName: string, title: string } | null }>, lockedBy?: { __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null } | null, document?: { __typename?: 'Document', id: string, filename: string, label: string, type: DocumentType, version: number, fileSize: number, url: string, createdAt: any, updatedAt: any } | null, attachments?: Array<{ __typename?: 'Document', id: string, filename: string, label: string, type: DocumentType, version: number, fileSize: number, url: string, createdAt: any, updatedAt: any }> | null, notes: Array<{ __typename?: 'FormNote', id: string, note: string, edited: boolean, profileId: string, createdAt: any, updatedAt: any, author: string }> }> }>, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }> } | null, appointmentRequest?: { __typename?: 'AppointmentRequest', id: string, location: string, latitude?: number | null, longitude?: number | null, status: AppointmentRequestStatus, bookingMode?: BookingMode | null, cancelReason?: string | null, notes?: string | null, lastResetAt?: any | null, waitlistedAt?: any | null, createdAt: any, updatedAt: any, archivedAt?: any | null, marketplace: { __typename?: 'Marketplace', id: string, name: string, groupId: string, createdAt: any, logo?: string | null, favicon?: string | null, primaryColor?: string | null, marketingSiteUrl?: string | null, gtmContainer?: string | null, gtmRequiresConsent: boolean, gtmDataTier: GtmDataTier, gtmV2Enabled: boolean, featureFlags: { __typename?: 'MarketplaceFeatureFlags', waitListEnabled?: boolean | null, acceptedPaymentMethods?: { __typename?: 'AcceptedPaymentMethods', creditCard?: boolean | null, applePay?: boolean | null } | null } }, clientProfiles: Array<{ __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null }>, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }>, constraints: Array<{ __typename?: 'AppointmentConstraint', id: string, organizations: Array<{ __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null }>, profiles: Array<{ __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null }>, timeRanges: Array<{ __typename?: 'AppointmentTimeRange', id: string, start: any, end: any }> }>, additionalPatients: Array<{ __typename?: 'AppointmentRequestPatient', id: string, clientProfile: { __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null }, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }> }> } | null, items: Array<{ __typename?: 'CheckoutItem', id: string, type: CheckoutItemType, description: string, quantity: number, price: number, key?: string | null }>, payments: Array<{ __typename?: 'Payment', id: string, type: PaymentType, status: PaymentStatus, description: string, amount: number, amountRequested: number, amountReversed?: number | null, isDeposit: boolean, createdAt: any, updatedAt: any }>, payouts: Array<{ __typename?: 'Payout', id: string, status: PayoutStatus, description: string, amount: number, amountRequested: number, amountReversed?: number | null, createdAt: any, updatedAt: any, checkoutId: string }>, paymentInstrument?: { __typename?: 'PaymentInstrument', id: string, type: PaymentInstrumentType, processor: PaymentAccountPlatform, brand?: string | null, lastFour?: string | null, expirationMonth?: number | null, expirationYear?: number | null, createdAt: any, updatedAt: any } | null, marketplaceUser?: { __typename?: 'MarketplaceUser', id: string, createdAt: any, updatedAt: any, groupId: string, membership: string, primaryInstrumentId?: string | null, email?: string | null, phone?: string | null, emailConfirmed: boolean, phoneConfirmed: boolean, emailOptIn: boolean, phoneOptIn: boolean, clientProfile?: { __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null } | null } | null, paymentLinks: Array<{ __typename?: 'PaymentLink', id: string, checkoutId: string, url: string, status: PaymentLinkStatus, amount: number, expiresAt?: any | null, createdAt: any, updatedAt: any }> };

export type ClientProfileFieldsFragment = { __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null };

export type ClinicalProcedureFieldsFragment = { __typename?: 'ClinicalProcedure', id: string, name: string };

export type ConditionFieldsFragment = { __typename?: 'Condition', id: string, name: string };

export type DatasetFieldsFragment = { __typename?: 'Dataset', label: string, data: Array<number>, backgroundColor: Array<string>, borderColor: Array<string> };

export type DiscountFieldsFragment = { __typename?: 'Discount', id: string, percentage: number, membershipDefinitionId: string, procedureGroups: Array<{ __typename?: 'ProcedureBaseDefinitionGroup', id: string, name: string }> };

export type DocumentFieldsFragment = { __typename?: 'Document', id: string, filename: string, label: string, type: DocumentType, version: number, fileSize: number, url: string, createdAt: any, updatedAt: any };

export type DocumentSignatureFieldsFragment = { __typename?: 'DocumentSignature', id: string, signerName: string, signerEmail?: string | null, signerType: DocumentSignatureSignerType, signedAt: any, verificationType: DocumentSignatureVerificationType, verificationDetail?: string | null, tzid: string, latitude?: number | null, longitude?: number | null, documentId: string, version: number, documentLabel: string, url?: string | null, createdAt: any, updatedAt: any };

export type EmrInstanceFieldsFragment = { __typename?: 'EmrInstance', id: string, label: string, createdAt: any };

export type FormFieldsFragment = { __typename?: 'Form', id: string, type: FormType, status: FormStatusType, patientId: string, lockedById?: string | null, editable: boolean, createdAt: any, updatedAt: any };

export type FormItemFieldsFragment = { __typename?: 'FormItem', id: string, index: number, label: string, type: FormItemType, code: string, options?: string | null, createdAt: any, updatedAt: any };

export type FormNoteFieldsFragment = { __typename?: 'FormNote', id: string, note: string, edited: boolean, profileId: string, createdAt: any, updatedAt: any, author: string };

export type FormTemplateFieldsFragment = { __typename?: 'FormTemplate', id: string, name: string, type: FormType, parentId?: string | null, createdAt: any, updatedAt: any, items: Array<{ __typename?: 'FormTemplateItem', id: string, index: number, label: string, type: FormItemType, options?: string | null, createdAt: any, updatedAt: any }> };

export type FormTemplateItemFieldsFragment = { __typename?: 'FormTemplateItem', id: string, index: number, label: string, type: FormItemType, options?: string | null, createdAt: any, updatedAt: any };

export type FullAppointmentFieldsFragment = { __typename?: 'Appointment', id: string, location: string, latitude?: number | null, longitude?: number | null, start: any, end: any, duration: number, createdAt: any, updatedAt: any, archivedAt?: any | null, status: AppointmentStatus, startedAt?: any | null, completedAt?: any | null, notes?: string | null, createdBy?: string | null, cancelReason?: string | null, groupId?: string | null, ordersRequired: boolean, participants: Array<{ __typename?: 'AppointmentParticipant', id: string, name: string, type: ParticipantType, status: ParticipationStatus, profileId?: string | null, clientProfileId?: string | null, orderApproved?: boolean | null, participant?: { __typename?: 'ClientProfile', internalNotesUpdatedBy?: string | null, internalNotesUpdatedAt?: any | null, id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null, patient?: { __typename?: 'Patient', id: string, allergies?: string | null, archivedAt?: any | null, clientProfileId: string, conditions?: string | null, createdAt: any, emrInstanceId: string, immunizations?: string | null, labs?: string | null, medications?: string | null, procedures?: string | null, updatedAt: any, orders: Array<{ __typename?: 'Order', id: string, archivedAt?: any | null, createdAt: any, expiresAt: any, providerType: ProviderType, fillCount: number, note?: string | null, refills: number, startsAt: any, updatedAt: any, procedureDefs: Array<{ __typename?: 'ProcedureDefinition', id: string, name: string, description: string, price: number, duration: number, assessmentFormTemplateId?: string | null, interventionFormTemplateId?: string | null, ordersRequired: boolean, createdAt: any, intakeFormTemplates: Array<{ __typename?: 'FormTemplate', id: string, name: string }> }>, profile?: { __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null } | null, organizations: Array<{ __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null }> }>, vitals: Array<{ __typename?: 'VitalSign', id: string, createdAt: any, createdById: string, recordedAt: any, type: VitalSignType, updatedAt: any, value: string }>, signedConsentForms: Array<{ __typename?: 'DocumentSignature', id: string, signerName: string, signerEmail?: string | null, signerType: DocumentSignatureSignerType, signedAt: any, verificationType: DocumentSignatureVerificationType, verificationDetail?: string | null, tzid: string, latitude?: number | null, longitude?: number | null, documentId: string, version: number, documentLabel: string, url?: string | null, createdAt: any, updatedAt: any }>, allergyRecords: Array<{ __typename?: 'AllergyIntolerance', id: string, name: string }>, clinicalProcedureRecords: Array<{ __typename?: 'ClinicalProcedure', id: string, name: string }>, conditionRecords: Array<{ __typename?: 'Condition', id: string, name: string }>, immunizationRecords: Array<{ __typename?: 'Immunization', id: string, name: string }>, labRecords: Array<{ __typename?: 'Lab', id: string, name: string }>, medicationRecords: Array<{ __typename?: 'MedicationStatement', id: string, name: string }>, attachments?: Array<{ __typename?: 'Document', id: string, filename: string, label: string, type: DocumentType, version: number, fileSize: number, url: string, createdAt: any, updatedAt: any }> | null } | null } | { __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null } | null, responses: Array<{ __typename?: 'AppointmentResponse', id: string, start?: any | null, end?: any | null, createdAt: any, updatedAt: any }>, forms: Array<{ __typename?: 'Form', id: string, type: FormType, status: FormStatusType, patientId: string, lockedById?: string | null, editable: boolean, createdAt: any, updatedAt: any, items: Array<{ __typename?: 'FormItem', id: string, index: number, label: string, type: FormItemType, code: string, options?: string | null, createdAt: any, updatedAt: any }>, observations: Array<{ __typename?: 'Observation', id: string, code: string, value: string, note?: string | null, createdById: string, createdAt: any, updatedAt: any, createdBy?: { __typename?: 'Profile', id: string, givenName: string, familyName: string, title: string } | null }>, lockedBy?: { __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null } | null, document?: { __typename?: 'Document', id: string, filename: string, label: string, type: DocumentType, version: number, fileSize: number, url: string, createdAt: any, updatedAt: any } | null, attachments?: Array<{ __typename?: 'Document', id: string, filename: string, label: string, type: DocumentType, version: number, fileSize: number, url: string, createdAt: any, updatedAt: any }> | null, notes: Array<{ __typename?: 'FormNote', id: string, note: string, edited: boolean, profileId: string, createdAt: any, updatedAt: any, author: string }> }> }>, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }>, checkout?: { __typename?: 'Checkout', id: string, total: number, paid: number, balance: number, marketplaceUserId?: string | null, summary?: string | null, voidedAt?: any | null, paymentMethodType?: PaymentMethodType | null, createdAt: any, updatedAt: any, items: Array<{ __typename?: 'CheckoutItem', id: string, type: CheckoutItemType, description: string, quantity: number, price: number, key?: string | null }>, payments: Array<{ __typename?: 'Payment', id: string, type: PaymentType, status: PaymentStatus, description: string, amount: number, amountRequested: number, amountReversed?: number | null, isDeposit: boolean, createdAt: any, updatedAt: any }>, payouts: Array<{ __typename?: 'Payout', id: string, status: PayoutStatus, description: string, amount: number, amountRequested: number, amountReversed?: number | null, createdAt: any, updatedAt: any, checkoutId: string }>, paymentInstrument?: { __typename?: 'PaymentInstrument', id: string, type: PaymentInstrumentType, processor: PaymentAccountPlatform, brand?: string | null, lastFour?: string | null, expirationMonth?: number | null, expirationYear?: number | null, createdAt: any, updatedAt: any } | null, marketplaceUser?: { __typename?: 'MarketplaceUser', id: string, createdAt: any, updatedAt: any, groupId: string, membership: string, primaryInstrumentId?: string | null, email?: string | null, phone?: string | null, emailConfirmed: boolean, phoneConfirmed: boolean, emailOptIn: boolean, phoneOptIn: boolean, clientProfile?: { __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null } | null } | null, paymentLinks: Array<{ __typename?: 'PaymentLink', id: string, checkoutId: string, url: string, status: PaymentLinkStatus, amount: number, expiresAt?: any | null, createdAt: any, updatedAt: any }> } | null, qualiphyInvitation?: { __typename?: 'QualiphyInvitation', id: string, expiration: any, meetingUrl?: string | null, exams?: Array<{ __typename?: 'QualiphyExam', id: string, title: string, status?: QualiphyInvitationStatus | null }> | null } | null, additionalPatients: Array<{ __typename?: 'AppointmentRequestPatient', id: string, clientProfile: { __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null }, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }> }> };

export type FullAppointmentParticipantFieldsFragment = { __typename?: 'AppointmentParticipant', id: string, name: string, type: ParticipantType, status: ParticipationStatus, profileId?: string | null, clientProfileId?: string | null, orderApproved?: boolean | null, participant?: { __typename?: 'ClientProfile', internalNotesUpdatedBy?: string | null, internalNotesUpdatedAt?: any | null, id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null, patient?: { __typename?: 'Patient', id: string, allergies?: string | null, archivedAt?: any | null, clientProfileId: string, conditions?: string | null, createdAt: any, emrInstanceId: string, immunizations?: string | null, labs?: string | null, medications?: string | null, procedures?: string | null, updatedAt: any, orders: Array<{ __typename?: 'Order', id: string, archivedAt?: any | null, createdAt: any, expiresAt: any, providerType: ProviderType, fillCount: number, note?: string | null, refills: number, startsAt: any, updatedAt: any, procedureDefs: Array<{ __typename?: 'ProcedureDefinition', id: string, name: string, description: string, price: number, duration: number, assessmentFormTemplateId?: string | null, interventionFormTemplateId?: string | null, ordersRequired: boolean, createdAt: any, intakeFormTemplates: Array<{ __typename?: 'FormTemplate', id: string, name: string }> }>, profile?: { __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null } | null, organizations: Array<{ __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null }> }>, vitals: Array<{ __typename?: 'VitalSign', id: string, createdAt: any, createdById: string, recordedAt: any, type: VitalSignType, updatedAt: any, value: string }>, signedConsentForms: Array<{ __typename?: 'DocumentSignature', id: string, signerName: string, signerEmail?: string | null, signerType: DocumentSignatureSignerType, signedAt: any, verificationType: DocumentSignatureVerificationType, verificationDetail?: string | null, tzid: string, latitude?: number | null, longitude?: number | null, documentId: string, version: number, documentLabel: string, url?: string | null, createdAt: any, updatedAt: any }>, allergyRecords: Array<{ __typename?: 'AllergyIntolerance', id: string, name: string }>, clinicalProcedureRecords: Array<{ __typename?: 'ClinicalProcedure', id: string, name: string }>, conditionRecords: Array<{ __typename?: 'Condition', id: string, name: string }>, immunizationRecords: Array<{ __typename?: 'Immunization', id: string, name: string }>, labRecords: Array<{ __typename?: 'Lab', id: string, name: string }>, medicationRecords: Array<{ __typename?: 'MedicationStatement', id: string, name: string }>, attachments?: Array<{ __typename?: 'Document', id: string, filename: string, label: string, type: DocumentType, version: number, fileSize: number, url: string, createdAt: any, updatedAt: any }> | null } | null } | { __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null } | null, responses: Array<{ __typename?: 'AppointmentResponse', id: string, start?: any | null, end?: any | null, createdAt: any, updatedAt: any }>, forms: Array<{ __typename?: 'Form', id: string, type: FormType, status: FormStatusType, patientId: string, lockedById?: string | null, editable: boolean, createdAt: any, updatedAt: any, items: Array<{ __typename?: 'FormItem', id: string, index: number, label: string, type: FormItemType, code: string, options?: string | null, createdAt: any, updatedAt: any }>, observations: Array<{ __typename?: 'Observation', id: string, code: string, value: string, note?: string | null, createdById: string, createdAt: any, updatedAt: any, createdBy?: { __typename?: 'Profile', id: string, givenName: string, familyName: string, title: string } | null }>, lockedBy?: { __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null } | null, document?: { __typename?: 'Document', id: string, filename: string, label: string, type: DocumentType, version: number, fileSize: number, url: string, createdAt: any, updatedAt: any } | null, attachments?: Array<{ __typename?: 'Document', id: string, filename: string, label: string, type: DocumentType, version: number, fileSize: number, url: string, createdAt: any, updatedAt: any }> | null, notes: Array<{ __typename?: 'FormNote', id: string, note: string, edited: boolean, profileId: string, createdAt: any, updatedAt: any, author: string }> }> };

export type FullAppointmentRequestFieldsFragment = { __typename?: 'AppointmentRequest', id: string, location: string, latitude?: number | null, longitude?: number | null, status: AppointmentRequestStatus, bookingMode?: BookingMode | null, cancelReason?: string | null, notes?: string | null, lastResetAt?: any | null, waitlistedAt?: any | null, createdAt: any, updatedAt: any, archivedAt?: any | null, declinedProfiles: Array<{ __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null }>, clientProfiles: Array<{ __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null, marketplaceUsers: Array<{ __typename?: 'MarketplaceUser', marketplaceIds: Array<string>, id: string, createdAt: any, updatedAt: any, groupId: string, membership: string, primaryInstrumentId?: string | null, email?: string | null, phone?: string | null, emailConfirmed: boolean, phoneConfirmed: boolean, emailOptIn: boolean, phoneOptIn: boolean, memberships: Array<{ __typename?: 'Membership', marketplaceName: string, id: string, membershipDefinitionId: string, renewalDate: any, name: string, status: MembershipStatusType }>, packageItems: Array<{ __typename?: 'PackageItem', marketplaceName: string, id: string, packageItemDefinitionId: string, membershipId?: string | null, balance: number, packageName: string, totalPoints: number, groupNames: string, expiresAt?: any | null, primaryOrganizationId?: string | null }>, clientProfiles: Array<{ __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null, organizations: Array<{ __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null }> }>, marketplaceGroup: { __typename?: 'MarketplaceGroup', id: string, label: string, createdAt: any, messagingServiceSid?: string | null }, paymentInstruments: Array<{ __typename?: 'PaymentInstrument', id: string, type: PaymentInstrumentType, processor: PaymentAccountPlatform, brand?: string | null, lastFour?: string | null, expirationMonth?: number | null, expirationYear?: number | null, createdAt: any, updatedAt: any }>, checkouts: Array<{ __typename?: 'Checkout', id: string, total: number, paid: number, balance: number, marketplaceUserId?: string | null, summary?: string | null, voidedAt?: any | null, paymentMethodType?: PaymentMethodType | null, createdAt: any, updatedAt: any, items: Array<{ __typename?: 'CheckoutItem', id: string, type: CheckoutItemType, description: string, quantity: number, price: number, key?: string | null }>, paymentLinks: Array<{ __typename?: 'PaymentLink', id: string, checkoutId: string, url: string, status: PaymentLinkStatus, amount: number, expiresAt?: any | null, createdAt: any, updatedAt: any }> }>, appointments: Array<{ __typename?: 'Appointment', intakeStatus?: string | null, id: string, location: string, latitude?: number | null, longitude?: number | null, start: any, end: any, duration: number, createdAt: any, updatedAt: any, archivedAt?: any | null, status: AppointmentStatus, startedAt?: any | null, completedAt?: any | null, notes?: string | null, createdBy?: string | null, cancelReason?: string | null, groupId?: string | null, ordersRequired: boolean, participants: Array<{ __typename?: 'AppointmentParticipant', id: string, name: string, type: ParticipantType, status: ParticipationStatus, profileId?: string | null, clientProfileId?: string | null, orderApproved?: boolean | null }>, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }>, checkout?: { __typename?: 'Checkout', id: string, total: number, paid: number, balance: number, marketplaceUserId?: string | null, summary?: string | null, voidedAt?: any | null, paymentMethodType?: PaymentMethodType | null, createdAt: any, updatedAt: any, paymentLinks: Array<{ __typename?: 'PaymentLink', id: string, checkoutId: string, url: string, status: PaymentLinkStatus, amount: number, expiresAt?: any | null, createdAt: any, updatedAt: any }> } | null, additionalPatients: Array<{ __typename?: 'AppointmentRequestPatient', id: string, clientProfile: { __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null }, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }> }> }>, appointmentRequests: Array<{ __typename?: 'AppointmentRequest', id: string, location: string, latitude?: number | null, longitude?: number | null, status: AppointmentRequestStatus, bookingMode?: BookingMode | null, cancelReason?: string | null, notes?: string | null, lastResetAt?: any | null, waitlistedAt?: any | null, createdAt: any, updatedAt: any, archivedAt?: any | null, marketplace: { __typename?: 'Marketplace', id: string, name: string, groupId: string, createdAt: any, logo?: string | null, favicon?: string | null, primaryColor?: string | null, marketingSiteUrl?: string | null, gtmContainer?: string | null, gtmRequiresConsent: boolean, gtmDataTier: GtmDataTier, gtmV2Enabled: boolean, featureFlags: { __typename?: 'MarketplaceFeatureFlags', waitListEnabled?: boolean | null, acceptedPaymentMethods?: { __typename?: 'AcceptedPaymentMethods', creditCard?: boolean | null, applePay?: boolean | null } | null } }, clientProfiles: Array<{ __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null }>, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }>, constraints: Array<{ __typename?: 'AppointmentConstraint', id: string, organizations: Array<{ __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null }>, profiles: Array<{ __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null }>, timeRanges: Array<{ __typename?: 'AppointmentTimeRange', id: string, start: any, end: any }> }>, additionalPatients: Array<{ __typename?: 'AppointmentRequestPatient', id: string, clientProfile: { __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null }, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }> }> }>, clientProfile?: { __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null } | null }> }>, checkout?: { __typename?: 'Checkout', id: string, total: number, paid: number, balance: number, marketplaceUserId?: string | null, summary?: string | null, voidedAt?: any | null, paymentMethodType?: PaymentMethodType | null, createdAt: any, updatedAt: any, items: Array<{ __typename?: 'CheckoutItem', id: string, type: CheckoutItemType, description: string, quantity: number, price: number, key?: string | null }>, payments: Array<{ __typename?: 'Payment', id: string, type: PaymentType, status: PaymentStatus, description: string, amount: number, amountRequested: number, amountReversed?: number | null, isDeposit: boolean, createdAt: any, updatedAt: any }>, payouts: Array<{ __typename?: 'Payout', id: string, status: PayoutStatus, description: string, amount: number, amountRequested: number, amountReversed?: number | null, createdAt: any, updatedAt: any, checkoutId: string }>, paymentInstrument?: { __typename?: 'PaymentInstrument', id: string, type: PaymentInstrumentType, processor: PaymentAccountPlatform, brand?: string | null, lastFour?: string | null, expirationMonth?: number | null, expirationYear?: number | null, createdAt: any, updatedAt: any } | null, marketplaceUser?: { __typename?: 'MarketplaceUser', id: string, createdAt: any, updatedAt: any, groupId: string, membership: string, primaryInstrumentId?: string | null, email?: string | null, phone?: string | null, emailConfirmed: boolean, phoneConfirmed: boolean, emailOptIn: boolean, phoneOptIn: boolean, clientProfile?: { __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null } | null } | null, paymentLinks: Array<{ __typename?: 'PaymentLink', id: string, checkoutId: string, url: string, status: PaymentLinkStatus, amount: number, expiresAt?: any | null, createdAt: any, updatedAt: any }> } | null, marketplace: { __typename?: 'Marketplace', id: string, name: string, groupId: string, createdAt: any, logo?: string | null, favicon?: string | null, primaryColor?: string | null, marketingSiteUrl?: string | null, gtmContainer?: string | null, gtmRequiresConsent: boolean, gtmDataTier: GtmDataTier, gtmV2Enabled: boolean, featureFlags: { __typename?: 'MarketplaceFeatureFlags', waitListEnabled?: boolean | null, acceptedPaymentMethods?: { __typename?: 'AcceptedPaymentMethods', creditCard?: boolean | null, applePay?: boolean | null } | null } }, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }>, constraints: Array<{ __typename?: 'AppointmentConstraint', id: string, organizations: Array<{ __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null }>, profiles: Array<{ __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null }>, timeRanges: Array<{ __typename?: 'AppointmentTimeRange', id: string, start: any, end: any }> }>, additionalPatients: Array<{ __typename?: 'AppointmentRequestPatient', id: string, clientProfile: { __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null }, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }> }> };

export type FullCheckoutFieldsFragment = { __typename?: 'Checkout', id: string, total: number, paid: number, balance: number, marketplaceUserId?: string | null, summary?: string | null, voidedAt?: any | null, paymentMethodType?: PaymentMethodType | null, createdAt: any, updatedAt: any, items: Array<{ __typename?: 'CheckoutItem', id: string, type: CheckoutItemType, description: string, quantity: number, price: number, key?: string | null }>, payments: Array<{ __typename?: 'Payment', id: string, type: PaymentType, status: PaymentStatus, description: string, amount: number, amountRequested: number, amountReversed?: number | null, isDeposit: boolean, createdAt: any, updatedAt: any }>, payouts: Array<{ __typename?: 'Payout', id: string, status: PayoutStatus, description: string, amount: number, amountRequested: number, amountReversed?: number | null, createdAt: any, updatedAt: any, checkoutId: string }>, paymentInstrument?: { __typename?: 'PaymentInstrument', id: string, type: PaymentInstrumentType, processor: PaymentAccountPlatform, brand?: string | null, lastFour?: string | null, expirationMonth?: number | null, expirationYear?: number | null, createdAt: any, updatedAt: any } | null, marketplaceUser?: { __typename?: 'MarketplaceUser', id: string, createdAt: any, updatedAt: any, groupId: string, membership: string, primaryInstrumentId?: string | null, email?: string | null, phone?: string | null, emailConfirmed: boolean, phoneConfirmed: boolean, emailOptIn: boolean, phoneOptIn: boolean, clientProfile?: { __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null } | null } | null, paymentLinks: Array<{ __typename?: 'PaymentLink', id: string, checkoutId: string, url: string, status: PaymentLinkStatus, amount: number, expiresAt?: any | null, createdAt: any, updatedAt: any }> };

export type FullClientProfileFieldsFragment = { __typename?: 'ClientProfile', internalNotesUpdatedBy?: string | null, internalNotesUpdatedAt?: any | null, id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null, patient?: { __typename?: 'Patient', id: string, allergies?: string | null, archivedAt?: any | null, clientProfileId: string, conditions?: string | null, createdAt: any, emrInstanceId: string, immunizations?: string | null, labs?: string | null, medications?: string | null, procedures?: string | null, updatedAt: any, orders: Array<{ __typename?: 'Order', id: string, archivedAt?: any | null, createdAt: any, expiresAt: any, providerType: ProviderType, fillCount: number, note?: string | null, refills: number, startsAt: any, updatedAt: any, procedureDefs: Array<{ __typename?: 'ProcedureDefinition', id: string, name: string, description: string, price: number, duration: number, assessmentFormTemplateId?: string | null, interventionFormTemplateId?: string | null, ordersRequired: boolean, createdAt: any, intakeFormTemplates: Array<{ __typename?: 'FormTemplate', id: string, name: string }> }>, profile?: { __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null } | null, organizations: Array<{ __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null }> }>, vitals: Array<{ __typename?: 'VitalSign', id: string, createdAt: any, createdById: string, recordedAt: any, type: VitalSignType, updatedAt: any, value: string }>, signedConsentForms: Array<{ __typename?: 'DocumentSignature', id: string, signerName: string, signerEmail?: string | null, signerType: DocumentSignatureSignerType, signedAt: any, verificationType: DocumentSignatureVerificationType, verificationDetail?: string | null, tzid: string, latitude?: number | null, longitude?: number | null, documentId: string, version: number, documentLabel: string, url?: string | null, createdAt: any, updatedAt: any }>, allergyRecords: Array<{ __typename?: 'AllergyIntolerance', id: string, name: string }>, clinicalProcedureRecords: Array<{ __typename?: 'ClinicalProcedure', id: string, name: string }>, conditionRecords: Array<{ __typename?: 'Condition', id: string, name: string }>, immunizationRecords: Array<{ __typename?: 'Immunization', id: string, name: string }>, labRecords: Array<{ __typename?: 'Lab', id: string, name: string }>, medicationRecords: Array<{ __typename?: 'MedicationStatement', id: string, name: string }>, attachments?: Array<{ __typename?: 'Document', id: string, filename: string, label: string, type: DocumentType, version: number, fileSize: number, url: string, createdAt: any, updatedAt: any }> | null } | null, appointments: Array<{ __typename?: 'Appointment', id: string, status: AppointmentStatus, cancelReason?: string | null, start: any, end: any, duration: number, location: string, groupId?: string | null, archivedAt?: any | null, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string }>, participants: Array<{ __typename?: 'AppointmentParticipant', id: string, name: string, type: ParticipantType, status: ParticipationStatus, profileId?: string | null, clientProfileId?: string | null, orderApproved?: boolean | null }> }>, intakeSubmissions: Array<{ __typename?: 'IntakeSubmission', id: string, status: IntakeSubmissionStatus, reviewStatus?: IntakeReviewStatus | null, formName?: string | null, submittedAt?: any | null, appointmentId: string, pdfUrl?: string | null, reviewedByName?: string | null, documentId?: string | null, appointment?: { __typename?: 'Appointment', id: string, start: any, status: AppointmentStatus } | null }> };

export type FullMarketplaceUserFieldsFragment = { __typename?: 'MarketplaceUser', id: string, createdAt: any, updatedAt: any, groupId: string, membership: string, primaryInstrumentId?: string | null, email?: string | null, phone?: string | null, emailConfirmed: boolean, phoneConfirmed: boolean, emailOptIn: boolean, phoneOptIn: boolean, clientProfiles: Array<{ __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null, organizations: Array<{ __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null }> }>, packageItems: Array<{ __typename?: 'PackageItem', marketplaceName: string, id: string, packageItemDefinitionId: string, membershipId?: string | null, balance: number, packageName: string, totalPoints: number, groupNames: string, expiresAt?: any | null, primaryOrganizationId?: string | null }>, memberships: Array<{ __typename?: 'Membership', marketplaceName: string, id: string, membershipDefinitionId: string, renewalDate: any, name: string, status: MembershipStatusType }>, marketplaceGroup: { __typename?: 'MarketplaceGroup', id: string, label: string, createdAt: any, messagingServiceSid?: string | null }, paymentInstruments: Array<{ __typename?: 'PaymentInstrument', id: string, type: PaymentInstrumentType, processor: PaymentAccountPlatform, brand?: string | null, lastFour?: string | null, expirationMonth?: number | null, expirationYear?: number | null, createdAt: any, updatedAt: any }>, checkouts: Array<{ __typename?: 'Checkout', id: string, total: number, paid: number, balance: number, marketplaceUserId?: string | null, summary?: string | null, voidedAt?: any | null, paymentMethodType?: PaymentMethodType | null, createdAt: any, updatedAt: any, items: Array<{ __typename?: 'CheckoutItem', id: string, type: CheckoutItemType, description: string, quantity: number, price: number, key?: string | null }>, paymentLinks: Array<{ __typename?: 'PaymentLink', id: string, checkoutId: string, url: string, status: PaymentLinkStatus, amount: number, expiresAt?: any | null, createdAt: any, updatedAt: any }> }>, appointments: Array<{ __typename?: 'Appointment', intakeStatus?: string | null, id: string, location: string, latitude?: number | null, longitude?: number | null, start: any, end: any, duration: number, createdAt: any, updatedAt: any, archivedAt?: any | null, status: AppointmentStatus, startedAt?: any | null, completedAt?: any | null, notes?: string | null, createdBy?: string | null, cancelReason?: string | null, groupId?: string | null, ordersRequired: boolean, participants: Array<{ __typename?: 'AppointmentParticipant', id: string, name: string, type: ParticipantType, status: ParticipationStatus, profileId?: string | null, clientProfileId?: string | null, orderApproved?: boolean | null }>, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }>, checkout?: { __typename?: 'Checkout', id: string, total: number, paid: number, balance: number, marketplaceUserId?: string | null, summary?: string | null, voidedAt?: any | null, paymentMethodType?: PaymentMethodType | null, createdAt: any, updatedAt: any, paymentLinks: Array<{ __typename?: 'PaymentLink', id: string, checkoutId: string, url: string, status: PaymentLinkStatus, amount: number, expiresAt?: any | null, createdAt: any, updatedAt: any }> } | null, additionalPatients: Array<{ __typename?: 'AppointmentRequestPatient', id: string, clientProfile: { __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null }, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }> }> }>, appointmentRequests: Array<{ __typename?: 'AppointmentRequest', id: string, location: string, latitude?: number | null, longitude?: number | null, status: AppointmentRequestStatus, bookingMode?: BookingMode | null, cancelReason?: string | null, notes?: string | null, lastResetAt?: any | null, waitlistedAt?: any | null, createdAt: any, updatedAt: any, archivedAt?: any | null, marketplace: { __typename?: 'Marketplace', id: string, name: string, groupId: string, createdAt: any, logo?: string | null, favicon?: string | null, primaryColor?: string | null, marketingSiteUrl?: string | null, gtmContainer?: string | null, gtmRequiresConsent: boolean, gtmDataTier: GtmDataTier, gtmV2Enabled: boolean, featureFlags: { __typename?: 'MarketplaceFeatureFlags', waitListEnabled?: boolean | null, acceptedPaymentMethods?: { __typename?: 'AcceptedPaymentMethods', creditCard?: boolean | null, applePay?: boolean | null } | null } }, clientProfiles: Array<{ __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null }>, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }>, constraints: Array<{ __typename?: 'AppointmentConstraint', id: string, organizations: Array<{ __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null }>, profiles: Array<{ __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null }>, timeRanges: Array<{ __typename?: 'AppointmentTimeRange', id: string, start: any, end: any }> }>, additionalPatients: Array<{ __typename?: 'AppointmentRequestPatient', id: string, clientProfile: { __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null }, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }> }> }>, clientProfile?: { __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null } | null };

export type FullMembershipDefinitionFieldsFragment = { __typename?: 'MembershipDefinition', id: string, name: string, price: number, period: MembershipDefinitionPeriodType, packageId?: string | null, marketplaceId: string, advertise: boolean, description?: string | null, list?: string | null, discounts: Array<{ __typename?: 'Discount', id: string, percentage: number, membershipDefinitionId: string, procedureGroups: Array<{ __typename?: 'ProcedureBaseDefinitionGroup', id: string, name: string }> }> };

export type FullOrganizationFragment = { __typename?: 'Organization', qualiphyEnabled: boolean, id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null, profiles: Array<{ __typename?: 'Profile', latitude?: number | null, longitude?: number | null, id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, procedureProfiles: Array<{ __typename?: 'ProcedureProfile', createdAt: any, id: string, name: string, updatedAt: any }>, availabilities: Array<{ __typename?: 'Availability', id: string, type: AvailabilityType, start: any, end: any, tzid: string, duration: number, createdAt: any, updatedAt: any, repeat?: { __typename?: 'RepeatRule', id: string, frequency: RepeatFrequencyType, byWeekday: Array<RepeatWeekdayType>, until?: any | null } | null }>, roles: Array<{ __typename?: 'Role', id: string, name: string, scope: RoleScope, type: RoleType, permissions: Array<string>, resourceId?: string | null }>, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null }>, roles: Array<{ __typename?: 'Role', id: string, name: string, scope: RoleScope, type: RoleType, permissions: Array<string>, resourceId?: string | null }>, procedureDefs: Array<{ __typename?: 'ProcedureDefinition', id: string, name: string, description: string, price: number, duration: number, assessmentFormTemplateId?: string | null, interventionFormTemplateId?: string | null, ordersRequired: boolean, createdAt: any, baseDefinitions: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }>, consentForms: Array<{ __typename?: 'Document', id: string, filename: string, label: string, type: DocumentType, version: number, fileSize: number, url: string, createdAt: any, updatedAt: any }>, intakeFormTemplates: Array<{ __typename?: 'FormTemplate', id: string, name: string }> }>, procedureProfiles: Array<{ __typename?: 'ProcedureProfile', createdAt: any, id: string, name: string, updatedAt: any, procedureDefs: Array<{ __typename?: 'ProcedureDefinition', id: string }> }>, marketplaces: Array<{ __typename?: 'Marketplace', id: string, name: string, groupId: string, createdAt: any, logo?: string | null, favicon?: string | null, primaryColor?: string | null, marketingSiteUrl?: string | null, gtmContainer?: string | null, gtmRequiresConsent: boolean, gtmDataTier: GtmDataTier, gtmV2Enabled: boolean, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }>, featureFlags: { __typename?: 'MarketplaceFeatureFlags', waitListEnabled?: boolean | null, acceptedPaymentMethods?: { __typename?: 'AcceptedPaymentMethods', creditCard?: boolean | null, applePay?: boolean | null } | null } }>, emrInstance?: { __typename?: 'EmrInstance', id: string, label: string, createdAt: any } | null, medications: Array<{ __typename?: 'Medication', id: string, name: string, unit: string, createdAt: any }>, availabilityCoverages: Array<{ __typename?: 'AvailabilityCoverage', id: string, label: string, threshold: number, start: any, end: any, tzid: string, repeat?: { __typename?: 'RepeatRule', id: string, frequency: RepeatFrequencyType, byWeekday: Array<RepeatWeekdayType>, until?: any | null } | null, profiles: Array<{ __typename?: 'ProcedureProfile', id: string }> }>, paymentAccounts: Array<{ __typename?: 'PaymentAccount', id: string, label: string, platform: PaymentAccountPlatform, enabled: boolean, state: PaymentAccountState, onboardingUrl?: string | null, createdAt: any, updatedAt: any }> };

export type FullPackageFieldsFragment = { __typename?: 'Package', id: string, name: string, price: number, marketplaceId: string, advertise: boolean, description?: string | null, list?: string | null, packageItemDefinitions: Array<{ __typename?: 'PackageItemDefinition', id: string, packageId: string, points: number, procedureGroups: Array<string> }> };

export type FullPatientFieldsFragment = { __typename?: 'Patient', id: string, allergies?: string | null, archivedAt?: any | null, clientProfileId: string, conditions?: string | null, createdAt: any, emrInstanceId: string, immunizations?: string | null, labs?: string | null, medications?: string | null, procedures?: string | null, updatedAt: any, orders: Array<{ __typename?: 'Order', id: string, archivedAt?: any | null, createdAt: any, expiresAt: any, providerType: ProviderType, fillCount: number, note?: string | null, refills: number, startsAt: any, updatedAt: any, procedureDefs: Array<{ __typename?: 'ProcedureDefinition', id: string, name: string, description: string, price: number, duration: number, assessmentFormTemplateId?: string | null, interventionFormTemplateId?: string | null, ordersRequired: boolean, createdAt: any, intakeFormTemplates: Array<{ __typename?: 'FormTemplate', id: string, name: string }> }>, profile?: { __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null } | null, organizations: Array<{ __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null }> }>, vitals: Array<{ __typename?: 'VitalSign', id: string, createdAt: any, createdById: string, recordedAt: any, type: VitalSignType, updatedAt: any, value: string }>, signedConsentForms: Array<{ __typename?: 'DocumentSignature', id: string, signerName: string, signerEmail?: string | null, signerType: DocumentSignatureSignerType, signedAt: any, verificationType: DocumentSignatureVerificationType, verificationDetail?: string | null, tzid: string, latitude?: number | null, longitude?: number | null, documentId: string, version: number, documentLabel: string, url?: string | null, createdAt: any, updatedAt: any }>, allergyRecords: Array<{ __typename?: 'AllergyIntolerance', id: string, name: string }>, clinicalProcedureRecords: Array<{ __typename?: 'ClinicalProcedure', id: string, name: string }>, conditionRecords: Array<{ __typename?: 'Condition', id: string, name: string }>, immunizationRecords: Array<{ __typename?: 'Immunization', id: string, name: string }>, labRecords: Array<{ __typename?: 'Lab', id: string, name: string }>, medicationRecords: Array<{ __typename?: 'MedicationStatement', id: string, name: string }>, attachments?: Array<{ __typename?: 'Document', id: string, filename: string, label: string, type: DocumentType, version: number, fileSize: number, url: string, createdAt: any, updatedAt: any }> | null };

export type FullProcedureBaseDefFieldsFragment = { __typename?: 'ProcedureBaseDefinition', tags: Array<string>, addOns: Array<string>, id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null, layouts: Array<{ __typename?: 'ProcedureBaseDefinitionLayout', type: ProcedureBaseDefinitionLayoutType, layout: string, itemIndex: number }> };

export type FullProcedureDefFieldsFragment = { __typename?: 'ProcedureDefinition', id: string, name: string, description: string, price: number, duration: number, assessmentFormTemplateId?: string | null, interventionFormTemplateId?: string | null, ordersRequired: boolean, createdAt: any, baseDefinitions: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }>, consentForms: Array<{ __typename?: 'Document', id: string, filename: string, label: string, type: DocumentType, version: number, fileSize: number, url: string, createdAt: any, updatedAt: any }>, intakeFormTemplates: Array<{ __typename?: 'FormTemplate', id: string, name: string }> };

export type FullProfileFragment = { __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, procedureProfiles: Array<{ __typename?: 'ProcedureProfile', createdAt: any, id: string, name: string, updatedAt: any, procedureDefs: Array<{ __typename?: 'ProcedureDefinition', id: string, name: string, description: string, price: number, duration: number, assessmentFormTemplateId?: string | null, interventionFormTemplateId?: string | null, ordersRequired: boolean, createdAt: any, baseDefinitions: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }>, intakeFormTemplates: Array<{ __typename?: 'FormTemplate', id: string, name: string }> }> }>, availabilities: Array<{ __typename?: 'Availability', id: string, type: AvailabilityType, start: any, end: any, tzid: string, duration: number, createdAt: any, updatedAt: any, repeat?: { __typename?: 'RepeatRule', id: string, frequency: RepeatFrequencyType, byWeekday: Array<RepeatWeekdayType>, until?: any | null } | null }>, roles: Array<{ __typename?: 'Role', id: string, name: string, scope: RoleScope, type: RoleType, permissions: Array<string>, resourceId?: string | null }>, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null };

export type GeoperimeterFieldsFragment = { __typename?: 'Geoperimeter', id: string, type: GeoperimeterType, organizationId: string, lat?: number | null, lng?: number | null, radius?: number | null, paths?: string | null, travelFee?: number | null };

export type ImmunizationFieldsFragment = { __typename?: 'Immunization', id: string, name: string };

export type LabFieldsFragment = { __typename?: 'Lab', id: string, name: string };

export type MarketplaceFieldsFragment = { __typename?: 'Marketplace', id: string, name: string, groupId: string, createdAt: any, logo?: string | null, favicon?: string | null, primaryColor?: string | null, marketingSiteUrl?: string | null, gtmContainer?: string | null, gtmRequiresConsent: boolean, gtmDataTier: GtmDataTier, gtmV2Enabled: boolean, featureFlags: { __typename?: 'MarketplaceFeatureFlags', waitListEnabled?: boolean | null, acceptedPaymentMethods?: { __typename?: 'AcceptedPaymentMethods', creditCard?: boolean | null, applePay?: boolean | null } | null } };

export type MarketplaceGroupFieldsFragment = { __typename?: 'MarketplaceGroup', id: string, label: string, createdAt: any, messagingServiceSid?: string | null };

export type MarketplaceSettingsFieldsFragment = { __typename?: 'Marketplace', requireDispatchApproval: boolean, requirePractitionerApproval: boolean, dispatchStrategy?: DispatchStrategy | null, bookingMode?: BookingMode | null, slackWebhookUrl?: string | null, reviewsIoKeyDescription?: string | null, consentTokenSecretDescription?: string | null, reviewsIoStoreId?: string | null, paymentAccountId?: string | null, feeProfileFixed?: number | null, feeProfileBasisPoints?: number | null, logo?: string | null, favicon?: string | null, primaryColor?: string | null, marketingSiteUrl?: string | null, paymentCollectionMethod?: PaymentCollectionMethod | null, paymentDepositType?: PaymentDepositType | null, paymentDepositValue?: number | null, hasPaymentPolicy?: boolean | null, paymentPolicyName?: string | null, paymentPolicyText?: string | null, requirePaymentPolicyAttestation?: boolean | null, id: string, name: string, groupId: string, createdAt: any, gtmContainer?: string | null, gtmRequiresConsent: boolean, gtmDataTier: GtmDataTier, gtmV2Enabled: boolean, checkoutContent: { __typename?: 'MarketplaceCheckoutContent', servicesNotice?: string | null, scheduleNotice?: string | null, confirmationMessage?: string | null, footerLinks: Array<{ __typename?: 'MarketplaceFooterLink', label: string, url: string }> }, featureFlags: { __typename?: 'MarketplaceFeatureFlags', waitListEnabled?: boolean | null, acceptedPaymentMethods?: { __typename?: 'AcceptedPaymentMethods', creditCard?: boolean | null, applePay?: boolean | null } | null, windowBooking?: { __typename?: 'WindowBookingConfig', allowSpecificTimeRequest?: boolean | null, minRemainingMinutes?: number | null, windows?: Array<{ __typename?: 'WindowConfig', key: WindowKey, enabled: boolean, startTime: string, endTime: string }> | null } | null } };

export type MarketplaceUserFieldsFragment = { __typename?: 'MarketplaceUser', id: string, createdAt: any, updatedAt: any, groupId: string, membership: string, primaryInstrumentId?: string | null, email?: string | null, phone?: string | null, emailConfirmed: boolean, phoneConfirmed: boolean, emailOptIn: boolean, phoneOptIn: boolean, clientProfile?: { __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null } | null };

export type MedicationFieldsFragment = { __typename?: 'Medication', id: string, name: string, unit: string, createdAt: any };

export type MedicationProtocolFieldsFragment = { __typename?: 'MedicationProtocol', id: string, dose: number, createdAt: any };

export type MedicationStatementFieldsFragment = { __typename?: 'MedicationStatement', id: string, name: string };

export type MembershipDefinitionFieldsFragment = { __typename?: 'MembershipDefinition', id: string, name: string, price: number, period: MembershipDefinitionPeriodType, packageId?: string | null, marketplaceId: string, advertise: boolean, description?: string | null, list?: string | null };

export type MembershipFieldsFragment = { __typename?: 'Membership', id: string, membershipDefinitionId: string, renewalDate: any, name: string, status: MembershipStatusType };

export type MetricDataFieldsFragment = { __typename?: 'MetricData', id: string, type: MetricChartTypes, count?: number | null, data?: { __typename?: 'ChartData', labels: Array<string>, datasets: Array<{ __typename?: 'Dataset', label: string, data: Array<number>, backgroundColor: Array<string>, borderColor: Array<string> }> } | null };

export type MetricsMarketplaceFieldsFragment = { __typename?: 'Marketplace', id: string, name: string, groupId: string, createdAt: any, logo?: string | null, favicon?: string | null, primaryColor?: string | null, marketingSiteUrl?: string | null, gtmContainer?: string | null, gtmRequiresConsent: boolean, gtmDataTier: GtmDataTier, gtmV2Enabled: boolean, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }>, procedureBaseDefGroups: Array<{ __typename?: 'ProcedureBaseDefinitionGroup', id: string, name: string, thumbnail?: string | null, banner?: string | null, type: ProcedureGroupType, description?: string | null, bgcolor?: string | null, fontColor?: string | null, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string }>, featuredBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string }>, procedureBaseDefGroups: Array<{ __typename?: 'ProcedureBaseDefinitionGroup', id: string, name: string, type: ProcedureGroupType }> }>, organizations: Array<{ __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null }>, featureFlags: { __typename?: 'MarketplaceFeatureFlags', waitListEnabled?: boolean | null, acceptedPaymentMethods?: { __typename?: 'AcceptedPaymentMethods', creditCard?: boolean | null, applePay?: boolean | null } | null } };

export type MfaScopeModeFieldsFragment = { __typename?: 'MfaScopeMode', setting: MfaModeSetting, inherited: MfaMode, effective: MfaMode, enabled: boolean };

export type MfaStatusFieldsFragment = { __typename?: 'MfaStatus', mode: MfaMode, enabled: boolean, required: boolean, graceUntil?: any | null, recoveryCodesLeft: number, factors: Array<{ __typename?: 'MfaFactor', id: string, type: MfaFactorType, label?: string | null, createdAt: any, verifiedAt?: any | null, lastUsedAt?: any | null, backedUp?: boolean | null }> };

export type OrderFieldsFragment = { __typename?: 'Order', id: string, archivedAt?: any | null, createdAt: any, expiresAt: any, providerType: ProviderType, fillCount: number, note?: string | null, refills: number, startsAt: any, updatedAt: any, procedureDefs: Array<{ __typename?: 'ProcedureDefinition', id: string, name: string, description: string, price: number, duration: number, assessmentFormTemplateId?: string | null, interventionFormTemplateId?: string | null, ordersRequired: boolean, createdAt: any, intakeFormTemplates: Array<{ __typename?: 'FormTemplate', id: string, name: string }> }>, profile?: { __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null } | null, organizations: Array<{ __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null }> };

export type OrganizationFieldsFragment = { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null };

export type OrganizationSettingsFieldsFragment = { __typename?: 'Organization', slackWebhookUrl?: string | null, googleReviewsUrl?: string | null, paymentAccountId?: string | null, id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null };

export type PackageFieldsFragment = { __typename?: 'Package', id: string, name: string, price: number, marketplaceId: string, advertise: boolean, description?: string | null, list?: string | null };

export type PackageItemDefinitionFieldsFragment = { __typename?: 'PackageItemDefinition', id: string, packageId: string, points: number, procedureGroups: Array<string> };

export type PackageItemFieldsFragment = { __typename?: 'PackageItem', id: string, packageItemDefinitionId: string, membershipId?: string | null, balance: number, packageName: string, totalPoints: number, groupNames: string, expiresAt?: any | null, primaryOrganizationId?: string | null };

export type PaginatedAppointmentRequestFieldsFragment = { __typename?: 'AppointmentRequest', orderApproved?: boolean | null, intakeStatus?: string | null, id: string, location: string, latitude?: number | null, longitude?: number | null, status: AppointmentRequestStatus, bookingMode?: BookingMode | null, cancelReason?: string | null, notes?: string | null, lastResetAt?: any | null, waitlistedAt?: any | null, createdAt: any, updatedAt: any, archivedAt?: any | null, checkout?: { __typename?: 'Checkout', id: string, total: number, paid: number, balance: number, marketplaceUserId?: string | null, summary?: string | null, voidedAt?: any | null, paymentMethodType?: PaymentMethodType | null, createdAt: any, updatedAt: any, paymentLinks: Array<{ __typename?: 'PaymentLink', id: string, checkoutId: string, url: string, status: PaymentLinkStatus, amount: number, expiresAt?: any | null, createdAt: any, updatedAt: any }> } | null, marketplace: { __typename?: 'Marketplace', id: string, name: string, groupId: string, createdAt: any, logo?: string | null, favicon?: string | null, primaryColor?: string | null, marketingSiteUrl?: string | null, gtmContainer?: string | null, gtmRequiresConsent: boolean, gtmDataTier: GtmDataTier, gtmV2Enabled: boolean, featureFlags: { __typename?: 'MarketplaceFeatureFlags', waitListEnabled?: boolean | null, acceptedPaymentMethods?: { __typename?: 'AcceptedPaymentMethods', creditCard?: boolean | null, applePay?: boolean | null } | null } }, clientProfiles: Array<{ __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null }>, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }>, constraints: Array<{ __typename?: 'AppointmentConstraint', id: string, organizations: Array<{ __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null }>, profiles: Array<{ __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null }>, timeRanges: Array<{ __typename?: 'AppointmentTimeRange', id: string, start: any, end: any }> }>, additionalPatients: Array<{ __typename?: 'AppointmentRequestPatient', id: string, clientProfile: { __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null }, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }> }> };

export type PaginatedCheckoutFieldsFragment = { __typename?: 'Checkout', id: string, total: number, paid: number, balance: number, marketplaceUserId?: string | null, summary?: string | null, voidedAt?: any | null, paymentMethodType?: PaymentMethodType | null, createdAt: any, updatedAt: any, marketplace?: { __typename?: 'Marketplace', id: string, name: string, groupId: string, createdAt: any, logo?: string | null, favicon?: string | null, primaryColor?: string | null, marketingSiteUrl?: string | null, gtmContainer?: string | null, gtmRequiresConsent: boolean, gtmDataTier: GtmDataTier, gtmV2Enabled: boolean, featureFlags: { __typename?: 'MarketplaceFeatureFlags', waitListEnabled?: boolean | null, acceptedPaymentMethods?: { __typename?: 'AcceptedPaymentMethods', creditCard?: boolean | null, applePay?: boolean | null } | null } } | null, marketplaceUser?: { __typename?: 'MarketplaceUser', id: string, createdAt: any, updatedAt: any, groupId: string, membership: string, primaryInstrumentId?: string | null, email?: string | null, phone?: string | null, emailConfirmed: boolean, phoneConfirmed: boolean, emailOptIn: boolean, phoneOptIn: boolean, clientProfile?: { __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null } | null } | null, paymentLinks: Array<{ __typename?: 'PaymentLink', id: string, checkoutId: string, url: string, status: PaymentLinkStatus, amount: number, expiresAt?: any | null, createdAt: any, updatedAt: any }> };

export type PaginatedMarketplaceUserFieldsFragment = { __typename?: 'MarketplaceUser', id: string, createdAt: any, updatedAt: any, groupId: string, membership: string, primaryInstrumentId?: string | null, email?: string | null, phone?: string | null, emailConfirmed: boolean, phoneConfirmed: boolean, emailOptIn: boolean, phoneOptIn: boolean, memberships: Array<{ __typename?: 'Membership', id: string, membershipDefinitionId: string, renewalDate: any, name: string, status: MembershipStatusType }>, marketplaceGroup: { __typename?: 'MarketplaceGroup', id: string, label: string, createdAt: any, messagingServiceSid?: string | null }, clientProfile?: { __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null } | null };

export type PaginatedPayoutFieldsFragment = { __typename?: 'Payout', id: string, status: PayoutStatus, description: string, amount: number, amountRequested: number, amountReversed?: number | null, createdAt: any, updatedAt: any, checkoutId: string, checkout?: { __typename?: 'Checkout', id: string, total: number, paid: number, balance: number, marketplaceUserId?: string | null, summary?: string | null, voidedAt?: any | null, paymentMethodType?: PaymentMethodType | null, createdAt: any, updatedAt: any, marketplace?: { __typename?: 'Marketplace', id: string, name: string, groupId: string, createdAt: any, logo?: string | null, favicon?: string | null, primaryColor?: string | null, marketingSiteUrl?: string | null, gtmContainer?: string | null, gtmRequiresConsent: boolean, gtmDataTier: GtmDataTier, gtmV2Enabled: boolean, featureFlags: { __typename?: 'MarketplaceFeatureFlags', waitListEnabled?: boolean | null, acceptedPaymentMethods?: { __typename?: 'AcceptedPaymentMethods', creditCard?: boolean | null, applePay?: boolean | null } | null } } | null, paymentLinks: Array<{ __typename?: 'PaymentLink', id: string, checkoutId: string, url: string, status: PaymentLinkStatus, amount: number, expiresAt?: any | null, createdAt: any, updatedAt: any }> } | null };

export type PatientFieldsFragment = { __typename?: 'Patient', id: string, allergies?: string | null, archivedAt?: any | null, clientProfileId: string, conditions?: string | null, createdAt: any, emrInstanceId: string, immunizations?: string | null, labs?: string | null, medications?: string | null, procedures?: string | null, updatedAt: any };

export type PaymentAccountFieldsFragment = { __typename?: 'PaymentAccount', id: string, label: string, platform: PaymentAccountPlatform, enabled: boolean, state: PaymentAccountState, onboardingUrl?: string | null, createdAt: any, updatedAt: any };

export type PaymentFieldsFragment = { __typename?: 'Payment', id: string, type: PaymentType, status: PaymentStatus, description: string, amount: number, amountRequested: number, amountReversed?: number | null, isDeposit: boolean, createdAt: any, updatedAt: any };

export type PaymentInstrumentFieldsFragment = { __typename?: 'PaymentInstrument', id: string, type: PaymentInstrumentType, processor: PaymentAccountPlatform, brand?: string | null, lastFour?: string | null, expirationMonth?: number | null, expirationYear?: number | null, createdAt: any, updatedAt: any };

export type PaymentLinkFieldsFragment = { __typename?: 'PaymentLink', id: string, checkoutId: string, url: string, status: PaymentLinkStatus, amount: number, expiresAt?: any | null, createdAt: any, updatedAt: any };

export type PayoutFieldsFragment = { __typename?: 'Payout', id: string, status: PayoutStatus, description: string, amount: number, amountRequested: number, amountReversed?: number | null, createdAt: any, updatedAt: any, checkoutId: string };

export type ProcedureBaseDefFieldsFragment = { __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null };

export type ProcedureBaseDefGroupFieldsFragment = { __typename?: 'ProcedureBaseDefinitionGroup', id: string, name: string, thumbnail?: string | null, banner?: string | null, type: ProcedureGroupType, description?: string | null, bgcolor?: string | null, fontColor?: string | null, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string }>, featuredBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string }>, procedureBaseDefGroups: Array<{ __typename?: 'ProcedureBaseDefinitionGroup', id: string, name: string, type: ProcedureGroupType }> };

export type ProcedureBaseDefLayoutFieldsFragment = { __typename?: 'ProcedureBaseDefinitionLayout', type: ProcedureBaseDefinitionLayoutType, layout: string, itemIndex: number };

export type ProcedureDefFieldsFragment = { __typename?: 'ProcedureDefinition', id: string, name: string, description: string, price: number, duration: number, assessmentFormTemplateId?: string | null, interventionFormTemplateId?: string | null, ordersRequired: boolean, createdAt: any, intakeFormTemplates: Array<{ __typename?: 'FormTemplate', id: string, name: string }> };

export type ProcedureProfileFieldsFragment = { __typename?: 'ProcedureProfile', createdAt: any, id: string, name: string, updatedAt: any };

export type ProfileFieldsFragment = { __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null };

export type PromoCodeFieldsFragment = { __typename?: 'PromoCode', id: string, name: string, code: string, discountType: PromoCodeDiscountType, discountValue: number, activationStartDate: any, activationEndDate: any, usageStartDate: any, usageEndDate: any, usageLimitTotal?: number | null, usageLimitPerUser?: number | null, minimumBookingAmount?: number | null, active: boolean, marketplaceId: string, createdAt: any, updatedAt: any, procedureGroups: Array<{ __typename?: 'ProcedureBaseDefinitionGroup', id: string, name: string }>, organizations: Array<{ __typename?: 'Organization', id: string, name: string }>, usage: Array<{ __typename?: 'PromoCodeUsage', id: string, marketplaceUserId: string, discountAmount: number, usedAt: any }> };

export type QualiphyExamFieldsFragment = { __typename?: 'QualiphyExam', id: string, qualiphyId: string, title: string, index: number, procedureDefinitions?: Array<string> | null, expiresAfter: number, refills: number, archived: boolean };

export type QualiphyFieldsFragment = { __typename?: 'QualiphyIntegration', id: string, enabled: boolean, apiKeyDescription?: string | null, exams?: Array<{ __typename?: 'QualiphyExam', id: string, qualiphyId: string, title: string, index: number, procedureDefinitions?: Array<string> | null, expiresAfter: number, refills: number, archived: boolean }> | null };

export type QualiphyInvitationFieldsFragment = { __typename?: 'QualiphyInvitation', id: string, expiration: any, meetingUrl?: string | null, exams?: Array<{ __typename?: 'QualiphyExam', id: string, title: string, status?: QualiphyInvitationStatus | null }> | null };

export type RegularAppointmentFieldsFragment = { __typename?: 'Appointment', intakeStatus?: string | null, id: string, location: string, latitude?: number | null, longitude?: number | null, start: any, end: any, duration: number, createdAt: any, updatedAt: any, archivedAt?: any | null, status: AppointmentStatus, startedAt?: any | null, completedAt?: any | null, notes?: string | null, createdBy?: string | null, cancelReason?: string | null, groupId?: string | null, ordersRequired: boolean, participants: Array<{ __typename?: 'AppointmentParticipant', id: string, name: string, type: ParticipantType, status: ParticipationStatus, profileId?: string | null, clientProfileId?: string | null, orderApproved?: boolean | null }>, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }>, checkout?: { __typename?: 'Checkout', id: string, total: number, paid: number, balance: number, marketplaceUserId?: string | null, summary?: string | null, voidedAt?: any | null, paymentMethodType?: PaymentMethodType | null, createdAt: any, updatedAt: any, paymentLinks: Array<{ __typename?: 'PaymentLink', id: string, checkoutId: string, url: string, status: PaymentLinkStatus, amount: number, expiresAt?: any | null, createdAt: any, updatedAt: any }> } | null, additionalPatients: Array<{ __typename?: 'AppointmentRequestPatient', id: string, clientProfile: { __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null }, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }> }> };

export type RegularAppointmentRequestFieldsFragment = { __typename?: 'AppointmentRequest', id: string, location: string, latitude?: number | null, longitude?: number | null, status: AppointmentRequestStatus, bookingMode?: BookingMode | null, cancelReason?: string | null, notes?: string | null, lastResetAt?: any | null, waitlistedAt?: any | null, createdAt: any, updatedAt: any, archivedAt?: any | null, marketplace: { __typename?: 'Marketplace', id: string, name: string, groupId: string, createdAt: any, logo?: string | null, favicon?: string | null, primaryColor?: string | null, marketingSiteUrl?: string | null, gtmContainer?: string | null, gtmRequiresConsent: boolean, gtmDataTier: GtmDataTier, gtmV2Enabled: boolean, featureFlags: { __typename?: 'MarketplaceFeatureFlags', waitListEnabled?: boolean | null, acceptedPaymentMethods?: { __typename?: 'AcceptedPaymentMethods', creditCard?: boolean | null, applePay?: boolean | null } | null } }, clientProfiles: Array<{ __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null }>, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }>, constraints: Array<{ __typename?: 'AppointmentConstraint', id: string, organizations: Array<{ __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null }>, profiles: Array<{ __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null }>, timeRanges: Array<{ __typename?: 'AppointmentTimeRange', id: string, start: any, end: any }> }>, additionalPatients: Array<{ __typename?: 'AppointmentRequestPatient', id: string, clientProfile: { __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null }, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }> }> };

export type RegularFormFieldsFragment = { __typename?: 'Form', id: string, type: FormType, status: FormStatusType, patientId: string, lockedById?: string | null, editable: boolean, createdAt: any, updatedAt: any, items: Array<{ __typename?: 'FormItem', id: string, index: number, label: string, type: FormItemType, code: string, options?: string | null, createdAt: any, updatedAt: any }>, observations: Array<{ __typename?: 'Observation', id: string, code: string, value: string, note?: string | null, createdById: string, createdAt: any, updatedAt: any, createdBy?: { __typename?: 'Profile', id: string, givenName: string, familyName: string, title: string } | null }>, lockedBy?: { __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null } | null, document?: { __typename?: 'Document', id: string, filename: string, label: string, type: DocumentType, version: number, fileSize: number, url: string, createdAt: any, updatedAt: any } | null, attachments?: Array<{ __typename?: 'Document', id: string, filename: string, label: string, type: DocumentType, version: number, fileSize: number, url: string, createdAt: any, updatedAt: any }> | null, notes: Array<{ __typename?: 'FormNote', id: string, note: string, edited: boolean, profileId: string, createdAt: any, updatedAt: any, author: string }> };

export type ProfileRolesFragment = { __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, roles: Array<{ __typename?: 'Role', id: string, name: string, scope: RoleScope, type: RoleType, permissions: Array<string>, resourceId?: string | null }>, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null };

export type RepeatRuleFieldsFragment = { __typename?: 'RepeatRule', id: string, frequency: RepeatFrequencyType, byWeekday: Array<RepeatWeekdayType>, until?: any | null };

export type RoleFieldsFragment = { __typename?: 'Role', id: string, name: string, scope: RoleScope, type: RoleType, permissions: Array<string>, resourceId?: string | null };

export type SegmentFieldsFragment = { __typename?: 'SegmentIntegration', id: string, writeKeyDescription?: string | null, enabled: boolean, v2Enabled: boolean, v2WriteKeyDescription?: string | null, clientWriteKey?: string | null };

export type SendgridFieldsFragment = { __typename?: 'SendgridIntegration', apiKeyDescription?: string | null, enabled: boolean, domain: string, webOrigin: string };

export type TwilioFieldsFragment = { __typename?: 'TwilioIntegration', id: string, appointmentsEnabled: boolean, appointmentRequestsEnabled: boolean, waitlistTextsEnabled: boolean, intakeTextsEnabled: boolean };

export type UserFieldsFragment = { __typename?: 'User', id: string, email: string, emailConfirmed: boolean, isMcpEnabled: boolean, createdAt: any };

export type VitalSignFieldsFragment = { __typename?: 'VitalSign', id: string, createdAt: any, createdById: string, recordedAt: any, type: VitalSignType, updatedAt: any, value: string };

export type SaveProfileLocationMutationVariables = Exact<{
  input: SaveProfileLocationInput;
}>;


export type SaveProfileLocationMutation = { __typename?: 'Mutation', saveProfileLocation: { __typename?: 'Profile', latitude?: number | null, longitude?: number | null, id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null } };

export type AcceptAppointmentMutationVariables = Exact<{
  input: AcceptAppointmentInput;
}>;


export type AcceptAppointmentMutation = { __typename?: 'Mutation', acceptAppointment?: { __typename?: 'Appointment', id: string, location: string, latitude?: number | null, longitude?: number | null, start: any, end: any, duration: number, createdAt: any, updatedAt: any, archivedAt?: any | null, status: AppointmentStatus, startedAt?: any | null, completedAt?: any | null, notes?: string | null, createdBy?: string | null, cancelReason?: string | null, groupId?: string | null, ordersRequired: boolean, participants: Array<{ __typename?: 'AppointmentParticipant', id: string, name: string, type: ParticipantType, status: ParticipationStatus, profileId?: string | null, clientProfileId?: string | null, orderApproved?: boolean | null, participant?: { __typename?: 'ClientProfile', internalNotesUpdatedBy?: string | null, internalNotesUpdatedAt?: any | null, id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null, patient?: { __typename?: 'Patient', id: string, allergies?: string | null, archivedAt?: any | null, clientProfileId: string, conditions?: string | null, createdAt: any, emrInstanceId: string, immunizations?: string | null, labs?: string | null, medications?: string | null, procedures?: string | null, updatedAt: any, orders: Array<{ __typename?: 'Order', id: string, archivedAt?: any | null, createdAt: any, expiresAt: any, providerType: ProviderType, fillCount: number, note?: string | null, refills: number, startsAt: any, updatedAt: any, procedureDefs: Array<{ __typename?: 'ProcedureDefinition', id: string, name: string, description: string, price: number, duration: number, assessmentFormTemplateId?: string | null, interventionFormTemplateId?: string | null, ordersRequired: boolean, createdAt: any, intakeFormTemplates: Array<{ __typename?: 'FormTemplate', id: string, name: string }> }>, profile?: { __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null } | null, organizations: Array<{ __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null }> }>, vitals: Array<{ __typename?: 'VitalSign', id: string, createdAt: any, createdById: string, recordedAt: any, type: VitalSignType, updatedAt: any, value: string }>, signedConsentForms: Array<{ __typename?: 'DocumentSignature', id: string, signerName: string, signerEmail?: string | null, signerType: DocumentSignatureSignerType, signedAt: any, verificationType: DocumentSignatureVerificationType, verificationDetail?: string | null, tzid: string, latitude?: number | null, longitude?: number | null, documentId: string, version: number, documentLabel: string, url?: string | null, createdAt: any, updatedAt: any }>, allergyRecords: Array<{ __typename?: 'AllergyIntolerance', id: string, name: string }>, clinicalProcedureRecords: Array<{ __typename?: 'ClinicalProcedure', id: string, name: string }>, conditionRecords: Array<{ __typename?: 'Condition', id: string, name: string }>, immunizationRecords: Array<{ __typename?: 'Immunization', id: string, name: string }>, labRecords: Array<{ __typename?: 'Lab', id: string, name: string }>, medicationRecords: Array<{ __typename?: 'MedicationStatement', id: string, name: string }>, attachments?: Array<{ __typename?: 'Document', id: string, filename: string, label: string, type: DocumentType, version: number, fileSize: number, url: string, createdAt: any, updatedAt: any }> | null } | null } | { __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null } | null, responses: Array<{ __typename?: 'AppointmentResponse', id: string, start?: any | null, end?: any | null, createdAt: any, updatedAt: any }>, forms: Array<{ __typename?: 'Form', id: string, type: FormType, status: FormStatusType, patientId: string, lockedById?: string | null, editable: boolean, createdAt: any, updatedAt: any, items: Array<{ __typename?: 'FormItem', id: string, index: number, label: string, type: FormItemType, code: string, options?: string | null, createdAt: any, updatedAt: any }>, observations: Array<{ __typename?: 'Observation', id: string, code: string, value: string, note?: string | null, createdById: string, createdAt: any, updatedAt: any, createdBy?: { __typename?: 'Profile', id: string, givenName: string, familyName: string, title: string } | null }>, lockedBy?: { __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null } | null, document?: { __typename?: 'Document', id: string, filename: string, label: string, type: DocumentType, version: number, fileSize: number, url: string, createdAt: any, updatedAt: any } | null, attachments?: Array<{ __typename?: 'Document', id: string, filename: string, label: string, type: DocumentType, version: number, fileSize: number, url: string, createdAt: any, updatedAt: any }> | null, notes: Array<{ __typename?: 'FormNote', id: string, note: string, edited: boolean, profileId: string, createdAt: any, updatedAt: any, author: string }> }> }>, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }>, checkout?: { __typename?: 'Checkout', id: string, total: number, paid: number, balance: number, marketplaceUserId?: string | null, summary?: string | null, voidedAt?: any | null, paymentMethodType?: PaymentMethodType | null, createdAt: any, updatedAt: any, items: Array<{ __typename?: 'CheckoutItem', id: string, type: CheckoutItemType, description: string, quantity: number, price: number, key?: string | null }>, payments: Array<{ __typename?: 'Payment', id: string, type: PaymentType, status: PaymentStatus, description: string, amount: number, amountRequested: number, amountReversed?: number | null, isDeposit: boolean, createdAt: any, updatedAt: any }>, payouts: Array<{ __typename?: 'Payout', id: string, status: PayoutStatus, description: string, amount: number, amountRequested: number, amountReversed?: number | null, createdAt: any, updatedAt: any, checkoutId: string }>, paymentInstrument?: { __typename?: 'PaymentInstrument', id: string, type: PaymentInstrumentType, processor: PaymentAccountPlatform, brand?: string | null, lastFour?: string | null, expirationMonth?: number | null, expirationYear?: number | null, createdAt: any, updatedAt: any } | null, marketplaceUser?: { __typename?: 'MarketplaceUser', id: string, createdAt: any, updatedAt: any, groupId: string, membership: string, primaryInstrumentId?: string | null, email?: string | null, phone?: string | null, emailConfirmed: boolean, phoneConfirmed: boolean, emailOptIn: boolean, phoneOptIn: boolean, clientProfile?: { __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null } | null } | null, paymentLinks: Array<{ __typename?: 'PaymentLink', id: string, checkoutId: string, url: string, status: PaymentLinkStatus, amount: number, expiresAt?: any | null, createdAt: any, updatedAt: any }> } | null, qualiphyInvitation?: { __typename?: 'QualiphyInvitation', id: string, expiration: any, meetingUrl?: string | null, exams?: Array<{ __typename?: 'QualiphyExam', id: string, title: string, status?: QualiphyInvitationStatus | null }> | null } | null, additionalPatients: Array<{ __typename?: 'AppointmentRequestPatient', id: string, clientProfile: { __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null }, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }> }> } | null };

export type AddOrganizationsToMarketplaceMutationVariables = Exact<{
  input: AddOrganizationsToMarketplaceInput;
}>;


export type AddOrganizationsToMarketplaceMutation = { __typename?: 'Mutation', addOrganizationsToMarketplace: boolean };

export type ApproveAppointmentRequestMutationVariables = Exact<{
  input: ApproveAppointmentRequestInput;
}>;


export type ApproveAppointmentRequestMutation = { __typename?: 'Mutation', approveAppointmentRequest?: { __typename?: 'AppointmentRequest', id: string, location: string, latitude?: number | null, longitude?: number | null, status: AppointmentRequestStatus, bookingMode?: BookingMode | null, cancelReason?: string | null, notes?: string | null, lastResetAt?: any | null, waitlistedAt?: any | null, createdAt: any, updatedAt: any, archivedAt?: any | null, declinedProfiles: Array<{ __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null }>, clientProfiles: Array<{ __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null, marketplaceUsers: Array<{ __typename?: 'MarketplaceUser', marketplaceIds: Array<string>, id: string, createdAt: any, updatedAt: any, groupId: string, membership: string, primaryInstrumentId?: string | null, email?: string | null, phone?: string | null, emailConfirmed: boolean, phoneConfirmed: boolean, emailOptIn: boolean, phoneOptIn: boolean, memberships: Array<{ __typename?: 'Membership', marketplaceName: string, id: string, membershipDefinitionId: string, renewalDate: any, name: string, status: MembershipStatusType }>, packageItems: Array<{ __typename?: 'PackageItem', marketplaceName: string, id: string, packageItemDefinitionId: string, membershipId?: string | null, balance: number, packageName: string, totalPoints: number, groupNames: string, expiresAt?: any | null, primaryOrganizationId?: string | null }>, clientProfiles: Array<{ __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null, organizations: Array<{ __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null }> }>, marketplaceGroup: { __typename?: 'MarketplaceGroup', id: string, label: string, createdAt: any, messagingServiceSid?: string | null }, paymentInstruments: Array<{ __typename?: 'PaymentInstrument', id: string, type: PaymentInstrumentType, processor: PaymentAccountPlatform, brand?: string | null, lastFour?: string | null, expirationMonth?: number | null, expirationYear?: number | null, createdAt: any, updatedAt: any }>, checkouts: Array<{ __typename?: 'Checkout', id: string, total: number, paid: number, balance: number, marketplaceUserId?: string | null, summary?: string | null, voidedAt?: any | null, paymentMethodType?: PaymentMethodType | null, createdAt: any, updatedAt: any, items: Array<{ __typename?: 'CheckoutItem', id: string, type: CheckoutItemType, description: string, quantity: number, price: number, key?: string | null }>, paymentLinks: Array<{ __typename?: 'PaymentLink', id: string, checkoutId: string, url: string, status: PaymentLinkStatus, amount: number, expiresAt?: any | null, createdAt: any, updatedAt: any }> }>, appointments: Array<{ __typename?: 'Appointment', intakeStatus?: string | null, id: string, location: string, latitude?: number | null, longitude?: number | null, start: any, end: any, duration: number, createdAt: any, updatedAt: any, archivedAt?: any | null, status: AppointmentStatus, startedAt?: any | null, completedAt?: any | null, notes?: string | null, createdBy?: string | null, cancelReason?: string | null, groupId?: string | null, ordersRequired: boolean, participants: Array<{ __typename?: 'AppointmentParticipant', id: string, name: string, type: ParticipantType, status: ParticipationStatus, profileId?: string | null, clientProfileId?: string | null, orderApproved?: boolean | null }>, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }>, checkout?: { __typename?: 'Checkout', id: string, total: number, paid: number, balance: number, marketplaceUserId?: string | null, summary?: string | null, voidedAt?: any | null, paymentMethodType?: PaymentMethodType | null, createdAt: any, updatedAt: any, paymentLinks: Array<{ __typename?: 'PaymentLink', id: string, checkoutId: string, url: string, status: PaymentLinkStatus, amount: number, expiresAt?: any | null, createdAt: any, updatedAt: any }> } | null, additionalPatients: Array<{ __typename?: 'AppointmentRequestPatient', id: string, clientProfile: { __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null }, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }> }> }>, appointmentRequests: Array<{ __typename?: 'AppointmentRequest', id: string, location: string, latitude?: number | null, longitude?: number | null, status: AppointmentRequestStatus, bookingMode?: BookingMode | null, cancelReason?: string | null, notes?: string | null, lastResetAt?: any | null, waitlistedAt?: any | null, createdAt: any, updatedAt: any, archivedAt?: any | null, marketplace: { __typename?: 'Marketplace', id: string, name: string, groupId: string, createdAt: any, logo?: string | null, favicon?: string | null, primaryColor?: string | null, marketingSiteUrl?: string | null, gtmContainer?: string | null, gtmRequiresConsent: boolean, gtmDataTier: GtmDataTier, gtmV2Enabled: boolean, featureFlags: { __typename?: 'MarketplaceFeatureFlags', waitListEnabled?: boolean | null, acceptedPaymentMethods?: { __typename?: 'AcceptedPaymentMethods', creditCard?: boolean | null, applePay?: boolean | null } | null } }, clientProfiles: Array<{ __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null }>, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }>, constraints: Array<{ __typename?: 'AppointmentConstraint', id: string, organizations: Array<{ __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null }>, profiles: Array<{ __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null }>, timeRanges: Array<{ __typename?: 'AppointmentTimeRange', id: string, start: any, end: any }> }>, additionalPatients: Array<{ __typename?: 'AppointmentRequestPatient', id: string, clientProfile: { __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null }, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }> }> }>, clientProfile?: { __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null } | null }> }>, checkout?: { __typename?: 'Checkout', id: string, total: number, paid: number, balance: number, marketplaceUserId?: string | null, summary?: string | null, voidedAt?: any | null, paymentMethodType?: PaymentMethodType | null, createdAt: any, updatedAt: any, items: Array<{ __typename?: 'CheckoutItem', id: string, type: CheckoutItemType, description: string, quantity: number, price: number, key?: string | null }>, payments: Array<{ __typename?: 'Payment', id: string, type: PaymentType, status: PaymentStatus, description: string, amount: number, amountRequested: number, amountReversed?: number | null, isDeposit: boolean, createdAt: any, updatedAt: any }>, payouts: Array<{ __typename?: 'Payout', id: string, status: PayoutStatus, description: string, amount: number, amountRequested: number, amountReversed?: number | null, createdAt: any, updatedAt: any, checkoutId: string }>, paymentInstrument?: { __typename?: 'PaymentInstrument', id: string, type: PaymentInstrumentType, processor: PaymentAccountPlatform, brand?: string | null, lastFour?: string | null, expirationMonth?: number | null, expirationYear?: number | null, createdAt: any, updatedAt: any } | null, marketplaceUser?: { __typename?: 'MarketplaceUser', id: string, createdAt: any, updatedAt: any, groupId: string, membership: string, primaryInstrumentId?: string | null, email?: string | null, phone?: string | null, emailConfirmed: boolean, phoneConfirmed: boolean, emailOptIn: boolean, phoneOptIn: boolean, clientProfile?: { __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null } | null } | null, paymentLinks: Array<{ __typename?: 'PaymentLink', id: string, checkoutId: string, url: string, status: PaymentLinkStatus, amount: number, expiresAt?: any | null, createdAt: any, updatedAt: any }> } | null, marketplace: { __typename?: 'Marketplace', id: string, name: string, groupId: string, createdAt: any, logo?: string | null, favicon?: string | null, primaryColor?: string | null, marketingSiteUrl?: string | null, gtmContainer?: string | null, gtmRequiresConsent: boolean, gtmDataTier: GtmDataTier, gtmV2Enabled: boolean, featureFlags: { __typename?: 'MarketplaceFeatureFlags', waitListEnabled?: boolean | null, acceptedPaymentMethods?: { __typename?: 'AcceptedPaymentMethods', creditCard?: boolean | null, applePay?: boolean | null } | null } }, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }>, constraints: Array<{ __typename?: 'AppointmentConstraint', id: string, organizations: Array<{ __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null }>, profiles: Array<{ __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null }>, timeRanges: Array<{ __typename?: 'AppointmentTimeRange', id: string, start: any, end: any }> }>, additionalPatients: Array<{ __typename?: 'AppointmentRequestPatient', id: string, clientProfile: { __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null }, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }> }> } | null };

export type ArchiveAppointmentMutationVariables = Exact<{
  input: ArchiveAppointmentInput;
}>;


export type ArchiveAppointmentMutation = { __typename?: 'Mutation', archiveAppointment?: { __typename?: 'Appointment', id: string, location: string, latitude?: number | null, longitude?: number | null, start: any, end: any, duration: number, createdAt: any, updatedAt: any, archivedAt?: any | null, status: AppointmentStatus, startedAt?: any | null, completedAt?: any | null, notes?: string | null, createdBy?: string | null, cancelReason?: string | null, groupId?: string | null, ordersRequired: boolean } | null };

export type ArchiveAppointmentRequestMutationVariables = Exact<{
  input: ArchiveAppointmentRequestInput;
}>;


export type ArchiveAppointmentRequestMutation = { __typename?: 'Mutation', archiveAppointmentRequest?: { __typename?: 'AppointmentRequest', id: string, location: string, latitude?: number | null, longitude?: number | null, status: AppointmentRequestStatus, bookingMode?: BookingMode | null, cancelReason?: string | null, notes?: string | null, lastResetAt?: any | null, waitlistedAt?: any | null, createdAt: any, updatedAt: any, archivedAt?: any | null, declinedProfiles: Array<{ __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null }>, clientProfiles: Array<{ __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null, marketplaceUsers: Array<{ __typename?: 'MarketplaceUser', marketplaceIds: Array<string>, id: string, createdAt: any, updatedAt: any, groupId: string, membership: string, primaryInstrumentId?: string | null, email?: string | null, phone?: string | null, emailConfirmed: boolean, phoneConfirmed: boolean, emailOptIn: boolean, phoneOptIn: boolean, memberships: Array<{ __typename?: 'Membership', marketplaceName: string, id: string, membershipDefinitionId: string, renewalDate: any, name: string, status: MembershipStatusType }>, packageItems: Array<{ __typename?: 'PackageItem', marketplaceName: string, id: string, packageItemDefinitionId: string, membershipId?: string | null, balance: number, packageName: string, totalPoints: number, groupNames: string, expiresAt?: any | null, primaryOrganizationId?: string | null }>, clientProfiles: Array<{ __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null, organizations: Array<{ __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null }> }>, marketplaceGroup: { __typename?: 'MarketplaceGroup', id: string, label: string, createdAt: any, messagingServiceSid?: string | null }, paymentInstruments: Array<{ __typename?: 'PaymentInstrument', id: string, type: PaymentInstrumentType, processor: PaymentAccountPlatform, brand?: string | null, lastFour?: string | null, expirationMonth?: number | null, expirationYear?: number | null, createdAt: any, updatedAt: any }>, checkouts: Array<{ __typename?: 'Checkout', id: string, total: number, paid: number, balance: number, marketplaceUserId?: string | null, summary?: string | null, voidedAt?: any | null, paymentMethodType?: PaymentMethodType | null, createdAt: any, updatedAt: any, items: Array<{ __typename?: 'CheckoutItem', id: string, type: CheckoutItemType, description: string, quantity: number, price: number, key?: string | null }>, paymentLinks: Array<{ __typename?: 'PaymentLink', id: string, checkoutId: string, url: string, status: PaymentLinkStatus, amount: number, expiresAt?: any | null, createdAt: any, updatedAt: any }> }>, appointments: Array<{ __typename?: 'Appointment', intakeStatus?: string | null, id: string, location: string, latitude?: number | null, longitude?: number | null, start: any, end: any, duration: number, createdAt: any, updatedAt: any, archivedAt?: any | null, status: AppointmentStatus, startedAt?: any | null, completedAt?: any | null, notes?: string | null, createdBy?: string | null, cancelReason?: string | null, groupId?: string | null, ordersRequired: boolean, participants: Array<{ __typename?: 'AppointmentParticipant', id: string, name: string, type: ParticipantType, status: ParticipationStatus, profileId?: string | null, clientProfileId?: string | null, orderApproved?: boolean | null }>, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }>, checkout?: { __typename?: 'Checkout', id: string, total: number, paid: number, balance: number, marketplaceUserId?: string | null, summary?: string | null, voidedAt?: any | null, paymentMethodType?: PaymentMethodType | null, createdAt: any, updatedAt: any, paymentLinks: Array<{ __typename?: 'PaymentLink', id: string, checkoutId: string, url: string, status: PaymentLinkStatus, amount: number, expiresAt?: any | null, createdAt: any, updatedAt: any }> } | null, additionalPatients: Array<{ __typename?: 'AppointmentRequestPatient', id: string, clientProfile: { __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null }, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }> }> }>, appointmentRequests: Array<{ __typename?: 'AppointmentRequest', id: string, location: string, latitude?: number | null, longitude?: number | null, status: AppointmentRequestStatus, bookingMode?: BookingMode | null, cancelReason?: string | null, notes?: string | null, lastResetAt?: any | null, waitlistedAt?: any | null, createdAt: any, updatedAt: any, archivedAt?: any | null, marketplace: { __typename?: 'Marketplace', id: string, name: string, groupId: string, createdAt: any, logo?: string | null, favicon?: string | null, primaryColor?: string | null, marketingSiteUrl?: string | null, gtmContainer?: string | null, gtmRequiresConsent: boolean, gtmDataTier: GtmDataTier, gtmV2Enabled: boolean, featureFlags: { __typename?: 'MarketplaceFeatureFlags', waitListEnabled?: boolean | null, acceptedPaymentMethods?: { __typename?: 'AcceptedPaymentMethods', creditCard?: boolean | null, applePay?: boolean | null } | null } }, clientProfiles: Array<{ __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null }>, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }>, constraints: Array<{ __typename?: 'AppointmentConstraint', id: string, organizations: Array<{ __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null }>, profiles: Array<{ __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null }>, timeRanges: Array<{ __typename?: 'AppointmentTimeRange', id: string, start: any, end: any }> }>, additionalPatients: Array<{ __typename?: 'AppointmentRequestPatient', id: string, clientProfile: { __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null }, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }> }> }>, clientProfile?: { __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null } | null }> }>, checkout?: { __typename?: 'Checkout', id: string, total: number, paid: number, balance: number, marketplaceUserId?: string | null, summary?: string | null, voidedAt?: any | null, paymentMethodType?: PaymentMethodType | null, createdAt: any, updatedAt: any, items: Array<{ __typename?: 'CheckoutItem', id: string, type: CheckoutItemType, description: string, quantity: number, price: number, key?: string | null }>, payments: Array<{ __typename?: 'Payment', id: string, type: PaymentType, status: PaymentStatus, description: string, amount: number, amountRequested: number, amountReversed?: number | null, isDeposit: boolean, createdAt: any, updatedAt: any }>, payouts: Array<{ __typename?: 'Payout', id: string, status: PayoutStatus, description: string, amount: number, amountRequested: number, amountReversed?: number | null, createdAt: any, updatedAt: any, checkoutId: string }>, paymentInstrument?: { __typename?: 'PaymentInstrument', id: string, type: PaymentInstrumentType, processor: PaymentAccountPlatform, brand?: string | null, lastFour?: string | null, expirationMonth?: number | null, expirationYear?: number | null, createdAt: any, updatedAt: any } | null, marketplaceUser?: { __typename?: 'MarketplaceUser', id: string, createdAt: any, updatedAt: any, groupId: string, membership: string, primaryInstrumentId?: string | null, email?: string | null, phone?: string | null, emailConfirmed: boolean, phoneConfirmed: boolean, emailOptIn: boolean, phoneOptIn: boolean, clientProfile?: { __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null } | null } | null, paymentLinks: Array<{ __typename?: 'PaymentLink', id: string, checkoutId: string, url: string, status: PaymentLinkStatus, amount: number, expiresAt?: any | null, createdAt: any, updatedAt: any }> } | null, marketplace: { __typename?: 'Marketplace', id: string, name: string, groupId: string, createdAt: any, logo?: string | null, favicon?: string | null, primaryColor?: string | null, marketingSiteUrl?: string | null, gtmContainer?: string | null, gtmRequiresConsent: boolean, gtmDataTier: GtmDataTier, gtmV2Enabled: boolean, featureFlags: { __typename?: 'MarketplaceFeatureFlags', waitListEnabled?: boolean | null, acceptedPaymentMethods?: { __typename?: 'AcceptedPaymentMethods', creditCard?: boolean | null, applePay?: boolean | null } | null } }, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }>, constraints: Array<{ __typename?: 'AppointmentConstraint', id: string, organizations: Array<{ __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null }>, profiles: Array<{ __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null }>, timeRanges: Array<{ __typename?: 'AppointmentTimeRange', id: string, start: any, end: any }> }>, additionalPatients: Array<{ __typename?: 'AppointmentRequestPatient', id: string, clientProfile: { __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null }, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }> }> } | null };

export type ArchiveDiscountMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ArchiveDiscountMutation = { __typename?: 'Mutation', archiveDiscount?: boolean | null };

export type ArchiveDocumentMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ArchiveDocumentMutation = { __typename?: 'Mutation', archiveDocument: boolean };

export type ArchiveEmrInstanceMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ArchiveEmrInstanceMutation = { __typename?: 'Mutation', archiveEmrInstance: boolean };

export type ArchiveFormNoteMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ArchiveFormNoteMutation = { __typename?: 'Mutation', archiveFormNote: boolean };

export type ArchiveMarketplaceGroupMutationVariables = Exact<{
  input: ArchiveMarketplaceGroupInput;
}>;


export type ArchiveMarketplaceGroupMutation = { __typename?: 'Mutation', archiveMarketplaceGroup: boolean };

export type ArchiveMembershipDefinitionMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ArchiveMembershipDefinitionMutation = { __typename?: 'Mutation', archiveMembershipDefinition?: boolean | null };

export type ArchivePackageMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ArchivePackageMutation = { __typename?: 'Mutation', archivePackage?: boolean | null };

export type ArchivePackageItemDefinitionMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ArchivePackageItemDefinitionMutation = { __typename?: 'Mutation', archivePackageItemDefinition?: boolean | null };

export type ArchivePaymentAccountMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ArchivePaymentAccountMutation = { __typename?: 'Mutation', archivePaymentAccount: boolean };

export type ArchiveProfileMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ArchiveProfileMutation = { __typename?: 'Mutation', archiveProfile: boolean };

export type ArchivePromoCodeMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ArchivePromoCodeMutation = { __typename?: 'Mutation', archivePromoCode: boolean };

export type AssignEmrInstanceMutationVariables = Exact<{
  input: AssignEmrInstanceInput;
}>;


export type AssignEmrInstanceMutation = { __typename?: 'Mutation', assignEmrInstance: boolean };

export type AssignPaymentAccountMutationVariables = Exact<{
  input: AssignPaymentAccountInput;
}>;


export type AssignPaymentAccountMutation = { __typename?: 'Mutation', assignPaymentAccount: boolean };

export type AssignProcedureProfileMutationVariables = Exact<{
  input: AssignProcedureProfileInput;
}>;


export type AssignProcedureProfileMutation = { __typename?: 'Mutation', assignProcedureProfile: boolean };

export type AssignRoleMutationVariables = Exact<{
  input: AssignRoleInput;
}>;


export type AssignRoleMutation = { __typename?: 'Mutation', assignRole: boolean };

export type AuthenticateMutationVariables = Exact<{
  email: Scalars['String'];
  password: Scalars['String'];
  ignoreTrustedDevice?: InputMaybe<Scalars['Boolean']>;
}>;


export type AuthenticateMutation = { __typename?: 'Mutation', authenticate: { __typename?: 'AuthenticatePayload', user: { __typename?: 'User', id: string, email: string } } };

export type AuthenticateAsMutationVariables = Exact<{
  userId: Scalars['ID'];
}>;


export type AuthenticateAsMutation = { __typename?: 'Mutation', authenticateAs: { __typename?: 'AuthenticatePayload', user: { __typename?: 'User', id: string, email: string } } };

export type CancelAppointmentMutationVariables = Exact<{
  input: CancelAppointmentInput;
}>;


export type CancelAppointmentMutation = { __typename?: 'Mutation', cancelAppointment?: { __typename?: 'Appointment', id: string, location: string, latitude?: number | null, longitude?: number | null, start: any, end: any, duration: number, createdAt: any, updatedAt: any, archivedAt?: any | null, status: AppointmentStatus, startedAt?: any | null, completedAt?: any | null, notes?: string | null, createdBy?: string | null, cancelReason?: string | null, groupId?: string | null, ordersRequired: boolean, participants: Array<{ __typename?: 'AppointmentParticipant', id: string, name: string, type: ParticipantType, status: ParticipationStatus, profileId?: string | null, clientProfileId?: string | null, orderApproved?: boolean | null, participant?: { __typename?: 'ClientProfile', internalNotesUpdatedBy?: string | null, internalNotesUpdatedAt?: any | null, id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null, patient?: { __typename?: 'Patient', id: string, allergies?: string | null, archivedAt?: any | null, clientProfileId: string, conditions?: string | null, createdAt: any, emrInstanceId: string, immunizations?: string | null, labs?: string | null, medications?: string | null, procedures?: string | null, updatedAt: any, orders: Array<{ __typename?: 'Order', id: string, archivedAt?: any | null, createdAt: any, expiresAt: any, providerType: ProviderType, fillCount: number, note?: string | null, refills: number, startsAt: any, updatedAt: any, procedureDefs: Array<{ __typename?: 'ProcedureDefinition', id: string, name: string, description: string, price: number, duration: number, assessmentFormTemplateId?: string | null, interventionFormTemplateId?: string | null, ordersRequired: boolean, createdAt: any, intakeFormTemplates: Array<{ __typename?: 'FormTemplate', id: string, name: string }> }>, profile?: { __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null } | null, organizations: Array<{ __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null }> }>, vitals: Array<{ __typename?: 'VitalSign', id: string, createdAt: any, createdById: string, recordedAt: any, type: VitalSignType, updatedAt: any, value: string }>, signedConsentForms: Array<{ __typename?: 'DocumentSignature', id: string, signerName: string, signerEmail?: string | null, signerType: DocumentSignatureSignerType, signedAt: any, verificationType: DocumentSignatureVerificationType, verificationDetail?: string | null, tzid: string, latitude?: number | null, longitude?: number | null, documentId: string, version: number, documentLabel: string, url?: string | null, createdAt: any, updatedAt: any }>, allergyRecords: Array<{ __typename?: 'AllergyIntolerance', id: string, name: string }>, clinicalProcedureRecords: Array<{ __typename?: 'ClinicalProcedure', id: string, name: string }>, conditionRecords: Array<{ __typename?: 'Condition', id: string, name: string }>, immunizationRecords: Array<{ __typename?: 'Immunization', id: string, name: string }>, labRecords: Array<{ __typename?: 'Lab', id: string, name: string }>, medicationRecords: Array<{ __typename?: 'MedicationStatement', id: string, name: string }>, attachments?: Array<{ __typename?: 'Document', id: string, filename: string, label: string, type: DocumentType, version: number, fileSize: number, url: string, createdAt: any, updatedAt: any }> | null } | null } | { __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null } | null, responses: Array<{ __typename?: 'AppointmentResponse', id: string, start?: any | null, end?: any | null, createdAt: any, updatedAt: any }>, forms: Array<{ __typename?: 'Form', id: string, type: FormType, status: FormStatusType, patientId: string, lockedById?: string | null, editable: boolean, createdAt: any, updatedAt: any, items: Array<{ __typename?: 'FormItem', id: string, index: number, label: string, type: FormItemType, code: string, options?: string | null, createdAt: any, updatedAt: any }>, observations: Array<{ __typename?: 'Observation', id: string, code: string, value: string, note?: string | null, createdById: string, createdAt: any, updatedAt: any, createdBy?: { __typename?: 'Profile', id: string, givenName: string, familyName: string, title: string } | null }>, lockedBy?: { __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null } | null, document?: { __typename?: 'Document', id: string, filename: string, label: string, type: DocumentType, version: number, fileSize: number, url: string, createdAt: any, updatedAt: any } | null, attachments?: Array<{ __typename?: 'Document', id: string, filename: string, label: string, type: DocumentType, version: number, fileSize: number, url: string, createdAt: any, updatedAt: any }> | null, notes: Array<{ __typename?: 'FormNote', id: string, note: string, edited: boolean, profileId: string, createdAt: any, updatedAt: any, author: string }> }> }>, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }>, checkout?: { __typename?: 'Checkout', id: string, total: number, paid: number, balance: number, marketplaceUserId?: string | null, summary?: string | null, voidedAt?: any | null, paymentMethodType?: PaymentMethodType | null, createdAt: any, updatedAt: any, items: Array<{ __typename?: 'CheckoutItem', id: string, type: CheckoutItemType, description: string, quantity: number, price: number, key?: string | null }>, payments: Array<{ __typename?: 'Payment', id: string, type: PaymentType, status: PaymentStatus, description: string, amount: number, amountRequested: number, amountReversed?: number | null, isDeposit: boolean, createdAt: any, updatedAt: any }>, payouts: Array<{ __typename?: 'Payout', id: string, status: PayoutStatus, description: string, amount: number, amountRequested: number, amountReversed?: number | null, createdAt: any, updatedAt: any, checkoutId: string }>, paymentInstrument?: { __typename?: 'PaymentInstrument', id: string, type: PaymentInstrumentType, processor: PaymentAccountPlatform, brand?: string | null, lastFour?: string | null, expirationMonth?: number | null, expirationYear?: number | null, createdAt: any, updatedAt: any } | null, marketplaceUser?: { __typename?: 'MarketplaceUser', id: string, createdAt: any, updatedAt: any, groupId: string, membership: string, primaryInstrumentId?: string | null, email?: string | null, phone?: string | null, emailConfirmed: boolean, phoneConfirmed: boolean, emailOptIn: boolean, phoneOptIn: boolean, clientProfile?: { __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null } | null } | null, paymentLinks: Array<{ __typename?: 'PaymentLink', id: string, checkoutId: string, url: string, status: PaymentLinkStatus, amount: number, expiresAt?: any | null, createdAt: any, updatedAt: any }> } | null, qualiphyInvitation?: { __typename?: 'QualiphyInvitation', id: string, expiration: any, meetingUrl?: string | null, exams?: Array<{ __typename?: 'QualiphyExam', id: string, title: string, status?: QualiphyInvitationStatus | null }> | null } | null, additionalPatients: Array<{ __typename?: 'AppointmentRequestPatient', id: string, clientProfile: { __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null }, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }> }> } | null };

export type CancelAppointmentGroupMutationVariables = Exact<{
  input: CancelAppointmentGroupInput;
}>;


export type CancelAppointmentGroupMutation = { __typename?: 'Mutation', cancelAppointmentGroup: boolean };

export type CancelAppointmentRequestMutationVariables = Exact<{
  input: CancelAppointmentRequestInput;
}>;


export type CancelAppointmentRequestMutation = { __typename?: 'Mutation', cancelAppointmentRequest?: { __typename?: 'AppointmentRequest', id: string, location: string, latitude?: number | null, longitude?: number | null, status: AppointmentRequestStatus, bookingMode?: BookingMode | null, cancelReason?: string | null, notes?: string | null, lastResetAt?: any | null, waitlistedAt?: any | null, createdAt: any, updatedAt: any, archivedAt?: any | null, declinedProfiles: Array<{ __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null }>, clientProfiles: Array<{ __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null, marketplaceUsers: Array<{ __typename?: 'MarketplaceUser', marketplaceIds: Array<string>, id: string, createdAt: any, updatedAt: any, groupId: string, membership: string, primaryInstrumentId?: string | null, email?: string | null, phone?: string | null, emailConfirmed: boolean, phoneConfirmed: boolean, emailOptIn: boolean, phoneOptIn: boolean, memberships: Array<{ __typename?: 'Membership', marketplaceName: string, id: string, membershipDefinitionId: string, renewalDate: any, name: string, status: MembershipStatusType }>, packageItems: Array<{ __typename?: 'PackageItem', marketplaceName: string, id: string, packageItemDefinitionId: string, membershipId?: string | null, balance: number, packageName: string, totalPoints: number, groupNames: string, expiresAt?: any | null, primaryOrganizationId?: string | null }>, clientProfiles: Array<{ __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null, organizations: Array<{ __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null }> }>, marketplaceGroup: { __typename?: 'MarketplaceGroup', id: string, label: string, createdAt: any, messagingServiceSid?: string | null }, paymentInstruments: Array<{ __typename?: 'PaymentInstrument', id: string, type: PaymentInstrumentType, processor: PaymentAccountPlatform, brand?: string | null, lastFour?: string | null, expirationMonth?: number | null, expirationYear?: number | null, createdAt: any, updatedAt: any }>, checkouts: Array<{ __typename?: 'Checkout', id: string, total: number, paid: number, balance: number, marketplaceUserId?: string | null, summary?: string | null, voidedAt?: any | null, paymentMethodType?: PaymentMethodType | null, createdAt: any, updatedAt: any, items: Array<{ __typename?: 'CheckoutItem', id: string, type: CheckoutItemType, description: string, quantity: number, price: number, key?: string | null }>, paymentLinks: Array<{ __typename?: 'PaymentLink', id: string, checkoutId: string, url: string, status: PaymentLinkStatus, amount: number, expiresAt?: any | null, createdAt: any, updatedAt: any }> }>, appointments: Array<{ __typename?: 'Appointment', intakeStatus?: string | null, id: string, location: string, latitude?: number | null, longitude?: number | null, start: any, end: any, duration: number, createdAt: any, updatedAt: any, archivedAt?: any | null, status: AppointmentStatus, startedAt?: any | null, completedAt?: any | null, notes?: string | null, createdBy?: string | null, cancelReason?: string | null, groupId?: string | null, ordersRequired: boolean, participants: Array<{ __typename?: 'AppointmentParticipant', id: string, name: string, type: ParticipantType, status: ParticipationStatus, profileId?: string | null, clientProfileId?: string | null, orderApproved?: boolean | null }>, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }>, checkout?: { __typename?: 'Checkout', id: string, total: number, paid: number, balance: number, marketplaceUserId?: string | null, summary?: string | null, voidedAt?: any | null, paymentMethodType?: PaymentMethodType | null, createdAt: any, updatedAt: any, paymentLinks: Array<{ __typename?: 'PaymentLink', id: string, checkoutId: string, url: string, status: PaymentLinkStatus, amount: number, expiresAt?: any | null, createdAt: any, updatedAt: any }> } | null, additionalPatients: Array<{ __typename?: 'AppointmentRequestPatient', id: string, clientProfile: { __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null }, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }> }> }>, appointmentRequests: Array<{ __typename?: 'AppointmentRequest', id: string, location: string, latitude?: number | null, longitude?: number | null, status: AppointmentRequestStatus, bookingMode?: BookingMode | null, cancelReason?: string | null, notes?: string | null, lastResetAt?: any | null, waitlistedAt?: any | null, createdAt: any, updatedAt: any, archivedAt?: any | null, marketplace: { __typename?: 'Marketplace', id: string, name: string, groupId: string, createdAt: any, logo?: string | null, favicon?: string | null, primaryColor?: string | null, marketingSiteUrl?: string | null, gtmContainer?: string | null, gtmRequiresConsent: boolean, gtmDataTier: GtmDataTier, gtmV2Enabled: boolean, featureFlags: { __typename?: 'MarketplaceFeatureFlags', waitListEnabled?: boolean | null, acceptedPaymentMethods?: { __typename?: 'AcceptedPaymentMethods', creditCard?: boolean | null, applePay?: boolean | null } | null } }, clientProfiles: Array<{ __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null }>, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }>, constraints: Array<{ __typename?: 'AppointmentConstraint', id: string, organizations: Array<{ __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null }>, profiles: Array<{ __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null }>, timeRanges: Array<{ __typename?: 'AppointmentTimeRange', id: string, start: any, end: any }> }>, additionalPatients: Array<{ __typename?: 'AppointmentRequestPatient', id: string, clientProfile: { __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null }, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }> }> }>, clientProfile?: { __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null } | null }> }>, checkout?: { __typename?: 'Checkout', id: string, total: number, paid: number, balance: number, marketplaceUserId?: string | null, summary?: string | null, voidedAt?: any | null, paymentMethodType?: PaymentMethodType | null, createdAt: any, updatedAt: any, items: Array<{ __typename?: 'CheckoutItem', id: string, type: CheckoutItemType, description: string, quantity: number, price: number, key?: string | null }>, payments: Array<{ __typename?: 'Payment', id: string, type: PaymentType, status: PaymentStatus, description: string, amount: number, amountRequested: number, amountReversed?: number | null, isDeposit: boolean, createdAt: any, updatedAt: any }>, payouts: Array<{ __typename?: 'Payout', id: string, status: PayoutStatus, description: string, amount: number, amountRequested: number, amountReversed?: number | null, createdAt: any, updatedAt: any, checkoutId: string }>, paymentInstrument?: { __typename?: 'PaymentInstrument', id: string, type: PaymentInstrumentType, processor: PaymentAccountPlatform, brand?: string | null, lastFour?: string | null, expirationMonth?: number | null, expirationYear?: number | null, createdAt: any, updatedAt: any } | null, marketplaceUser?: { __typename?: 'MarketplaceUser', id: string, createdAt: any, updatedAt: any, groupId: string, membership: string, primaryInstrumentId?: string | null, email?: string | null, phone?: string | null, emailConfirmed: boolean, phoneConfirmed: boolean, emailOptIn: boolean, phoneOptIn: boolean, clientProfile?: { __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null } | null } | null, paymentLinks: Array<{ __typename?: 'PaymentLink', id: string, checkoutId: string, url: string, status: PaymentLinkStatus, amount: number, expiresAt?: any | null, createdAt: any, updatedAt: any }> } | null, marketplace: { __typename?: 'Marketplace', id: string, name: string, groupId: string, createdAt: any, logo?: string | null, favicon?: string | null, primaryColor?: string | null, marketingSiteUrl?: string | null, gtmContainer?: string | null, gtmRequiresConsent: boolean, gtmDataTier: GtmDataTier, gtmV2Enabled: boolean, featureFlags: { __typename?: 'MarketplaceFeatureFlags', waitListEnabled?: boolean | null, acceptedPaymentMethods?: { __typename?: 'AcceptedPaymentMethods', creditCard?: boolean | null, applePay?: boolean | null } | null } }, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }>, constraints: Array<{ __typename?: 'AppointmentConstraint', id: string, organizations: Array<{ __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null }>, profiles: Array<{ __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null }>, timeRanges: Array<{ __typename?: 'AppointmentTimeRange', id: string, start: any, end: any }> }>, additionalPatients: Array<{ __typename?: 'AppointmentRequestPatient', id: string, clientProfile: { __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null }, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }> }> } | null };

export type CancelMembershipMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CancelMembershipMutation = { __typename?: 'Mutation', cancelMembership?: boolean | null };

export type ChangeEmailMutationVariables = Exact<{
  input: ChangeEmailInput;
}>;


export type ChangeEmailMutation = { __typename?: 'Mutation', changeEmail: boolean };

export type CompleteAppointmentMutationVariables = Exact<{
  input: CompleteAppointmentInput;
}>;


export type CompleteAppointmentMutation = { __typename?: 'Mutation', completeAppointment?: { __typename?: 'Appointment', id: string, location: string, latitude?: number | null, longitude?: number | null, start: any, end: any, duration: number, createdAt: any, updatedAt: any, archivedAt?: any | null, status: AppointmentStatus, startedAt?: any | null, completedAt?: any | null, notes?: string | null, createdBy?: string | null, cancelReason?: string | null, groupId?: string | null, ordersRequired: boolean, participants: Array<{ __typename?: 'AppointmentParticipant', id: string, name: string, type: ParticipantType, status: ParticipationStatus, profileId?: string | null, clientProfileId?: string | null, orderApproved?: boolean | null, participant?: { __typename?: 'ClientProfile', internalNotesUpdatedBy?: string | null, internalNotesUpdatedAt?: any | null, id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null, patient?: { __typename?: 'Patient', id: string, allergies?: string | null, archivedAt?: any | null, clientProfileId: string, conditions?: string | null, createdAt: any, emrInstanceId: string, immunizations?: string | null, labs?: string | null, medications?: string | null, procedures?: string | null, updatedAt: any, orders: Array<{ __typename?: 'Order', id: string, archivedAt?: any | null, createdAt: any, expiresAt: any, providerType: ProviderType, fillCount: number, note?: string | null, refills: number, startsAt: any, updatedAt: any, procedureDefs: Array<{ __typename?: 'ProcedureDefinition', id: string, name: string, description: string, price: number, duration: number, assessmentFormTemplateId?: string | null, interventionFormTemplateId?: string | null, ordersRequired: boolean, createdAt: any, intakeFormTemplates: Array<{ __typename?: 'FormTemplate', id: string, name: string }> }>, profile?: { __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null } | null, organizations: Array<{ __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null }> }>, vitals: Array<{ __typename?: 'VitalSign', id: string, createdAt: any, createdById: string, recordedAt: any, type: VitalSignType, updatedAt: any, value: string }>, signedConsentForms: Array<{ __typename?: 'DocumentSignature', id: string, signerName: string, signerEmail?: string | null, signerType: DocumentSignatureSignerType, signedAt: any, verificationType: DocumentSignatureVerificationType, verificationDetail?: string | null, tzid: string, latitude?: number | null, longitude?: number | null, documentId: string, version: number, documentLabel: string, url?: string | null, createdAt: any, updatedAt: any }>, allergyRecords: Array<{ __typename?: 'AllergyIntolerance', id: string, name: string }>, clinicalProcedureRecords: Array<{ __typename?: 'ClinicalProcedure', id: string, name: string }>, conditionRecords: Array<{ __typename?: 'Condition', id: string, name: string }>, immunizationRecords: Array<{ __typename?: 'Immunization', id: string, name: string }>, labRecords: Array<{ __typename?: 'Lab', id: string, name: string }>, medicationRecords: Array<{ __typename?: 'MedicationStatement', id: string, name: string }>, attachments?: Array<{ __typename?: 'Document', id: string, filename: string, label: string, type: DocumentType, version: number, fileSize: number, url: string, createdAt: any, updatedAt: any }> | null } | null } | { __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null } | null, responses: Array<{ __typename?: 'AppointmentResponse', id: string, start?: any | null, end?: any | null, createdAt: any, updatedAt: any }>, forms: Array<{ __typename?: 'Form', id: string, type: FormType, status: FormStatusType, patientId: string, lockedById?: string | null, editable: boolean, createdAt: any, updatedAt: any, items: Array<{ __typename?: 'FormItem', id: string, index: number, label: string, type: FormItemType, code: string, options?: string | null, createdAt: any, updatedAt: any }>, observations: Array<{ __typename?: 'Observation', id: string, code: string, value: string, note?: string | null, createdById: string, createdAt: any, updatedAt: any, createdBy?: { __typename?: 'Profile', id: string, givenName: string, familyName: string, title: string } | null }>, lockedBy?: { __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null } | null, document?: { __typename?: 'Document', id: string, filename: string, label: string, type: DocumentType, version: number, fileSize: number, url: string, createdAt: any, updatedAt: any } | null, attachments?: Array<{ __typename?: 'Document', id: string, filename: string, label: string, type: DocumentType, version: number, fileSize: number, url: string, createdAt: any, updatedAt: any }> | null, notes: Array<{ __typename?: 'FormNote', id: string, note: string, edited: boolean, profileId: string, createdAt: any, updatedAt: any, author: string }> }> }>, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }>, checkout?: { __typename?: 'Checkout', id: string, total: number, paid: number, balance: number, marketplaceUserId?: string | null, summary?: string | null, voidedAt?: any | null, paymentMethodType?: PaymentMethodType | null, createdAt: any, updatedAt: any, items: Array<{ __typename?: 'CheckoutItem', id: string, type: CheckoutItemType, description: string, quantity: number, price: number, key?: string | null }>, payments: Array<{ __typename?: 'Payment', id: string, type: PaymentType, status: PaymentStatus, description: string, amount: number, amountRequested: number, amountReversed?: number | null, isDeposit: boolean, createdAt: any, updatedAt: any }>, payouts: Array<{ __typename?: 'Payout', id: string, status: PayoutStatus, description: string, amount: number, amountRequested: number, amountReversed?: number | null, createdAt: any, updatedAt: any, checkoutId: string }>, paymentInstrument?: { __typename?: 'PaymentInstrument', id: string, type: PaymentInstrumentType, processor: PaymentAccountPlatform, brand?: string | null, lastFour?: string | null, expirationMonth?: number | null, expirationYear?: number | null, createdAt: any, updatedAt: any } | null, marketplaceUser?: { __typename?: 'MarketplaceUser', id: string, createdAt: any, updatedAt: any, groupId: string, membership: string, primaryInstrumentId?: string | null, email?: string | null, phone?: string | null, emailConfirmed: boolean, phoneConfirmed: boolean, emailOptIn: boolean, phoneOptIn: boolean, clientProfile?: { __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null } | null } | null, paymentLinks: Array<{ __typename?: 'PaymentLink', id: string, checkoutId: string, url: string, status: PaymentLinkStatus, amount: number, expiresAt?: any | null, createdAt: any, updatedAt: any }> } | null, qualiphyInvitation?: { __typename?: 'QualiphyInvitation', id: string, expiration: any, meetingUrl?: string | null, exams?: Array<{ __typename?: 'QualiphyExam', id: string, title: string, status?: QualiphyInvitationStatus | null }> | null } | null, additionalPatients: Array<{ __typename?: 'AppointmentRequestPatient', id: string, clientProfile: { __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null }, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }> }> } | null };

export type CompleteCheckoutMutationVariables = Exact<{
  input: CompleteCheckoutInput;
}>;


export type CompleteCheckoutMutation = { __typename?: 'Mutation', completeCheckout: { __typename?: 'CreateAppointmentCheckoutPayload', success: boolean, errorMessage?: string | null, checkout: { __typename?: 'Checkout', id: string, total: number, paid: number, balance: number, marketplaceUserId?: string | null, summary?: string | null, voidedAt?: any | null, paymentMethodType?: PaymentMethodType | null, createdAt: any, updatedAt: any, appointment?: { __typename?: 'Appointment', id: string, location: string, latitude?: number | null, longitude?: number | null, start: any, end: any, duration: number, createdAt: any, updatedAt: any, archivedAt?: any | null, status: AppointmentStatus, startedAt?: any | null, completedAt?: any | null, notes?: string | null, createdBy?: string | null, cancelReason?: string | null, groupId?: string | null, ordersRequired: boolean, participants: Array<{ __typename?: 'AppointmentParticipant', id: string, name: string, type: ParticipantType, status: ParticipationStatus, profileId?: string | null, clientProfileId?: string | null, orderApproved?: boolean | null, participant?: { __typename?: 'ClientProfile', internalNotesUpdatedBy?: string | null, internalNotesUpdatedAt?: any | null, id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null, patient?: { __typename?: 'Patient', id: string, allergies?: string | null, archivedAt?: any | null, clientProfileId: string, conditions?: string | null, createdAt: any, emrInstanceId: string, immunizations?: string | null, labs?: string | null, medications?: string | null, procedures?: string | null, updatedAt: any, orders: Array<{ __typename?: 'Order', id: string, archivedAt?: any | null, createdAt: any, expiresAt: any, providerType: ProviderType, fillCount: number, note?: string | null, refills: number, startsAt: any, updatedAt: any, procedureDefs: Array<{ __typename?: 'ProcedureDefinition', id: string, name: string, description: string, price: number, duration: number, assessmentFormTemplateId?: string | null, interventionFormTemplateId?: string | null, ordersRequired: boolean, createdAt: any, intakeFormTemplates: Array<{ __typename?: 'FormTemplate', id: string, name: string }> }>, profile?: { __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null } | null, organizations: Array<{ __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null }> }>, vitals: Array<{ __typename?: 'VitalSign', id: string, createdAt: any, createdById: string, recordedAt: any, type: VitalSignType, updatedAt: any, value: string }>, signedConsentForms: Array<{ __typename?: 'DocumentSignature', id: string, signerName: string, signerEmail?: string | null, signerType: DocumentSignatureSignerType, signedAt: any, verificationType: DocumentSignatureVerificationType, verificationDetail?: string | null, tzid: string, latitude?: number | null, longitude?: number | null, documentId: string, version: number, documentLabel: string, url?: string | null, createdAt: any, updatedAt: any }>, allergyRecords: Array<{ __typename?: 'AllergyIntolerance', id: string, name: string }>, clinicalProcedureRecords: Array<{ __typename?: 'ClinicalProcedure', id: string, name: string }>, conditionRecords: Array<{ __typename?: 'Condition', id: string, name: string }>, immunizationRecords: Array<{ __typename?: 'Immunization', id: string, name: string }>, labRecords: Array<{ __typename?: 'Lab', id: string, name: string }>, medicationRecords: Array<{ __typename?: 'MedicationStatement', id: string, name: string }>, attachments?: Array<{ __typename?: 'Document', id: string, filename: string, label: string, type: DocumentType, version: number, fileSize: number, url: string, createdAt: any, updatedAt: any }> | null } | null } | { __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null } | null, responses: Array<{ __typename?: 'AppointmentResponse', id: string, start?: any | null, end?: any | null, createdAt: any, updatedAt: any }>, forms: Array<{ __typename?: 'Form', id: string, type: FormType, status: FormStatusType, patientId: string, lockedById?: string | null, editable: boolean, createdAt: any, updatedAt: any, items: Array<{ __typename?: 'FormItem', id: string, index: number, label: string, type: FormItemType, code: string, options?: string | null, createdAt: any, updatedAt: any }>, observations: Array<{ __typename?: 'Observation', id: string, code: string, value: string, note?: string | null, createdById: string, createdAt: any, updatedAt: any, createdBy?: { __typename?: 'Profile', id: string, givenName: string, familyName: string, title: string } | null }>, lockedBy?: { __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null } | null, document?: { __typename?: 'Document', id: string, filename: string, label: string, type: DocumentType, version: number, fileSize: number, url: string, createdAt: any, updatedAt: any } | null, attachments?: Array<{ __typename?: 'Document', id: string, filename: string, label: string, type: DocumentType, version: number, fileSize: number, url: string, createdAt: any, updatedAt: any }> | null, notes: Array<{ __typename?: 'FormNote', id: string, note: string, edited: boolean, profileId: string, createdAt: any, updatedAt: any, author: string }> }> }>, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }> } | null, appointmentRequest?: { __typename?: 'AppointmentRequest', id: string, location: string, latitude?: number | null, longitude?: number | null, status: AppointmentRequestStatus, bookingMode?: BookingMode | null, cancelReason?: string | null, notes?: string | null, lastResetAt?: any | null, waitlistedAt?: any | null, createdAt: any, updatedAt: any, archivedAt?: any | null, marketplace: { __typename?: 'Marketplace', id: string, name: string, groupId: string, createdAt: any, logo?: string | null, favicon?: string | null, primaryColor?: string | null, marketingSiteUrl?: string | null, gtmContainer?: string | null, gtmRequiresConsent: boolean, gtmDataTier: GtmDataTier, gtmV2Enabled: boolean, featureFlags: { __typename?: 'MarketplaceFeatureFlags', waitListEnabled?: boolean | null, acceptedPaymentMethods?: { __typename?: 'AcceptedPaymentMethods', creditCard?: boolean | null, applePay?: boolean | null } | null } }, clientProfiles: Array<{ __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null }>, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }>, constraints: Array<{ __typename?: 'AppointmentConstraint', id: string, organizations: Array<{ __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null }>, profiles: Array<{ __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null }>, timeRanges: Array<{ __typename?: 'AppointmentTimeRange', id: string, start: any, end: any }> }>, additionalPatients: Array<{ __typename?: 'AppointmentRequestPatient', id: string, clientProfile: { __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null }, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }> }> } | null, items: Array<{ __typename?: 'CheckoutItem', id: string, type: CheckoutItemType, description: string, quantity: number, price: number, key?: string | null }>, payments: Array<{ __typename?: 'Payment', id: string, type: PaymentType, status: PaymentStatus, description: string, amount: number, amountRequested: number, amountReversed?: number | null, isDeposit: boolean, createdAt: any, updatedAt: any }>, payouts: Array<{ __typename?: 'Payout', id: string, status: PayoutStatus, description: string, amount: number, amountRequested: number, amountReversed?: number | null, createdAt: any, updatedAt: any, checkoutId: string }>, paymentInstrument?: { __typename?: 'PaymentInstrument', id: string, type: PaymentInstrumentType, processor: PaymentAccountPlatform, brand?: string | null, lastFour?: string | null, expirationMonth?: number | null, expirationYear?: number | null, createdAt: any, updatedAt: any } | null, marketplaceUser?: { __typename?: 'MarketplaceUser', id: string, createdAt: any, updatedAt: any, groupId: string, membership: string, primaryInstrumentId?: string | null, email?: string | null, phone?: string | null, emailConfirmed: boolean, phoneConfirmed: boolean, emailOptIn: boolean, phoneOptIn: boolean, clientProfile?: { __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null } | null } | null, paymentLinks: Array<{ __typename?: 'PaymentLink', id: string, checkoutId: string, url: string, status: PaymentLinkStatus, amount: number, expiresAt?: any | null, createdAt: any, updatedAt: any }> } } };

export type ConfirmTotpEnrollmentMutationVariables = Exact<{
  input: ConfirmTotpEnrollmentInput;
}>;


export type ConfirmTotpEnrollmentMutation = { __typename?: 'Mutation', confirmTotpEnrollment: { __typename?: 'ConfirmTotpEnrollmentPayload', recoveryCodes: Array<string> } };

export type CreateAllergyIntoleranceMutationVariables = Exact<{
  input: CreateAllergyIntoleranceInput;
}>;


export type CreateAllergyIntoleranceMutation = { __typename?: 'Mutation', createAllergyIntolerance: { __typename?: 'AllergyIntolerance', id: string, name: string } };

export type CreateApiKeyMutationVariables = Exact<{
  input: CreateApiKeyInput;
}>;


export type CreateApiKeyMutation = { __typename?: 'Mutation', createApiKey: { __typename?: 'CreateApiKeyPayload', privateKey: string, apiKey: { __typename?: 'ApiKey', id: string, kid: string, name: string, createdAt: any, roles: Array<{ __typename?: 'Role', id: string, name: string, scope: RoleScope, type: RoleType, permissions: Array<string>, resourceId?: string | null }> } } };

export type CreateAppointmentMutationVariables = Exact<{
  input: CreateAppointmentInput;
}>;


export type CreateAppointmentMutation = { __typename?: 'Mutation', createAppointment?: { __typename?: 'Appointment', id: string, location: string, latitude?: number | null, longitude?: number | null, start: any, end: any, duration: number, createdAt: any, updatedAt: any, archivedAt?: any | null, status: AppointmentStatus, startedAt?: any | null, completedAt?: any | null, notes?: string | null, createdBy?: string | null, cancelReason?: string | null, groupId?: string | null, ordersRequired: boolean, participants: Array<{ __typename?: 'AppointmentParticipant', id: string, name: string, type: ParticipantType, status: ParticipationStatus, profileId?: string | null, clientProfileId?: string | null, orderApproved?: boolean | null, participant?: { __typename?: 'ClientProfile', internalNotesUpdatedBy?: string | null, internalNotesUpdatedAt?: any | null, id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null, patient?: { __typename?: 'Patient', id: string, allergies?: string | null, archivedAt?: any | null, clientProfileId: string, conditions?: string | null, createdAt: any, emrInstanceId: string, immunizations?: string | null, labs?: string | null, medications?: string | null, procedures?: string | null, updatedAt: any, orders: Array<{ __typename?: 'Order', id: string, archivedAt?: any | null, createdAt: any, expiresAt: any, providerType: ProviderType, fillCount: number, note?: string | null, refills: number, startsAt: any, updatedAt: any, procedureDefs: Array<{ __typename?: 'ProcedureDefinition', id: string, name: string, description: string, price: number, duration: number, assessmentFormTemplateId?: string | null, interventionFormTemplateId?: string | null, ordersRequired: boolean, createdAt: any, intakeFormTemplates: Array<{ __typename?: 'FormTemplate', id: string, name: string }> }>, profile?: { __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null } | null, organizations: Array<{ __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null }> }>, vitals: Array<{ __typename?: 'VitalSign', id: string, createdAt: any, createdById: string, recordedAt: any, type: VitalSignType, updatedAt: any, value: string }>, signedConsentForms: Array<{ __typename?: 'DocumentSignature', id: string, signerName: string, signerEmail?: string | null, signerType: DocumentSignatureSignerType, signedAt: any, verificationType: DocumentSignatureVerificationType, verificationDetail?: string | null, tzid: string, latitude?: number | null, longitude?: number | null, documentId: string, version: number, documentLabel: string, url?: string | null, createdAt: any, updatedAt: any }>, allergyRecords: Array<{ __typename?: 'AllergyIntolerance', id: string, name: string }>, clinicalProcedureRecords: Array<{ __typename?: 'ClinicalProcedure', id: string, name: string }>, conditionRecords: Array<{ __typename?: 'Condition', id: string, name: string }>, immunizationRecords: Array<{ __typename?: 'Immunization', id: string, name: string }>, labRecords: Array<{ __typename?: 'Lab', id: string, name: string }>, medicationRecords: Array<{ __typename?: 'MedicationStatement', id: string, name: string }>, attachments?: Array<{ __typename?: 'Document', id: string, filename: string, label: string, type: DocumentType, version: number, fileSize: number, url: string, createdAt: any, updatedAt: any }> | null } | null } | { __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null } | null, responses: Array<{ __typename?: 'AppointmentResponse', id: string, start?: any | null, end?: any | null, createdAt: any, updatedAt: any }>, forms: Array<{ __typename?: 'Form', id: string, type: FormType, status: FormStatusType, patientId: string, lockedById?: string | null, editable: boolean, createdAt: any, updatedAt: any, items: Array<{ __typename?: 'FormItem', id: string, index: number, label: string, type: FormItemType, code: string, options?: string | null, createdAt: any, updatedAt: any }>, observations: Array<{ __typename?: 'Observation', id: string, code: string, value: string, note?: string | null, createdById: string, createdAt: any, updatedAt: any, createdBy?: { __typename?: 'Profile', id: string, givenName: string, familyName: string, title: string } | null }>, lockedBy?: { __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null } | null, document?: { __typename?: 'Document', id: string, filename: string, label: string, type: DocumentType, version: number, fileSize: number, url: string, createdAt: any, updatedAt: any } | null, attachments?: Array<{ __typename?: 'Document', id: string, filename: string, label: string, type: DocumentType, version: number, fileSize: number, url: string, createdAt: any, updatedAt: any }> | null, notes: Array<{ __typename?: 'FormNote', id: string, note: string, edited: boolean, profileId: string, createdAt: any, updatedAt: any, author: string }> }> }>, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }>, checkout?: { __typename?: 'Checkout', id: string, total: number, paid: number, balance: number, marketplaceUserId?: string | null, summary?: string | null, voidedAt?: any | null, paymentMethodType?: PaymentMethodType | null, createdAt: any, updatedAt: any, items: Array<{ __typename?: 'CheckoutItem', id: string, type: CheckoutItemType, description: string, quantity: number, price: number, key?: string | null }>, payments: Array<{ __typename?: 'Payment', id: string, type: PaymentType, status: PaymentStatus, description: string, amount: number, amountRequested: number, amountReversed?: number | null, isDeposit: boolean, createdAt: any, updatedAt: any }>, payouts: Array<{ __typename?: 'Payout', id: string, status: PayoutStatus, description: string, amount: number, amountRequested: number, amountReversed?: number | null, createdAt: any, updatedAt: any, checkoutId: string }>, paymentInstrument?: { __typename?: 'PaymentInstrument', id: string, type: PaymentInstrumentType, processor: PaymentAccountPlatform, brand?: string | null, lastFour?: string | null, expirationMonth?: number | null, expirationYear?: number | null, createdAt: any, updatedAt: any } | null, marketplaceUser?: { __typename?: 'MarketplaceUser', id: string, createdAt: any, updatedAt: any, groupId: string, membership: string, primaryInstrumentId?: string | null, email?: string | null, phone?: string | null, emailConfirmed: boolean, phoneConfirmed: boolean, emailOptIn: boolean, phoneOptIn: boolean, clientProfile?: { __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null } | null } | null, paymentLinks: Array<{ __typename?: 'PaymentLink', id: string, checkoutId: string, url: string, status: PaymentLinkStatus, amount: number, expiresAt?: any | null, createdAt: any, updatedAt: any }> } | null, qualiphyInvitation?: { __typename?: 'QualiphyInvitation', id: string, expiration: any, meetingUrl?: string | null, exams?: Array<{ __typename?: 'QualiphyExam', id: string, title: string, status?: QualiphyInvitationStatus | null }> | null } | null, additionalPatients: Array<{ __typename?: 'AppointmentRequestPatient', id: string, clientProfile: { __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null }, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }> }> } | null };

export type CreateAppointmentRequestMutationVariables = Exact<{
  input: CreateAppointmentRequestInput;
}>;


export type CreateAppointmentRequestMutation = { __typename?: 'Mutation', createAppointmentRequest?: { __typename?: 'AppointmentRequest', id: string, location: string, latitude?: number | null, longitude?: number | null, status: AppointmentRequestStatus, bookingMode?: BookingMode | null, cancelReason?: string | null, notes?: string | null, lastResetAt?: any | null, waitlistedAt?: any | null, createdAt: any, updatedAt: any, archivedAt?: any | null, declinedProfiles: Array<{ __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null }>, clientProfiles: Array<{ __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null, marketplaceUsers: Array<{ __typename?: 'MarketplaceUser', marketplaceIds: Array<string>, id: string, createdAt: any, updatedAt: any, groupId: string, membership: string, primaryInstrumentId?: string | null, email?: string | null, phone?: string | null, emailConfirmed: boolean, phoneConfirmed: boolean, emailOptIn: boolean, phoneOptIn: boolean, memberships: Array<{ __typename?: 'Membership', marketplaceName: string, id: string, membershipDefinitionId: string, renewalDate: any, name: string, status: MembershipStatusType }>, packageItems: Array<{ __typename?: 'PackageItem', marketplaceName: string, id: string, packageItemDefinitionId: string, membershipId?: string | null, balance: number, packageName: string, totalPoints: number, groupNames: string, expiresAt?: any | null, primaryOrganizationId?: string | null }>, clientProfiles: Array<{ __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null, organizations: Array<{ __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null }> }>, marketplaceGroup: { __typename?: 'MarketplaceGroup', id: string, label: string, createdAt: any, messagingServiceSid?: string | null }, paymentInstruments: Array<{ __typename?: 'PaymentInstrument', id: string, type: PaymentInstrumentType, processor: PaymentAccountPlatform, brand?: string | null, lastFour?: string | null, expirationMonth?: number | null, expirationYear?: number | null, createdAt: any, updatedAt: any }>, checkouts: Array<{ __typename?: 'Checkout', id: string, total: number, paid: number, balance: number, marketplaceUserId?: string | null, summary?: string | null, voidedAt?: any | null, paymentMethodType?: PaymentMethodType | null, createdAt: any, updatedAt: any, items: Array<{ __typename?: 'CheckoutItem', id: string, type: CheckoutItemType, description: string, quantity: number, price: number, key?: string | null }>, paymentLinks: Array<{ __typename?: 'PaymentLink', id: string, checkoutId: string, url: string, status: PaymentLinkStatus, amount: number, expiresAt?: any | null, createdAt: any, updatedAt: any }> }>, appointments: Array<{ __typename?: 'Appointment', intakeStatus?: string | null, id: string, location: string, latitude?: number | null, longitude?: number | null, start: any, end: any, duration: number, createdAt: any, updatedAt: any, archivedAt?: any | null, status: AppointmentStatus, startedAt?: any | null, completedAt?: any | null, notes?: string | null, createdBy?: string | null, cancelReason?: string | null, groupId?: string | null, ordersRequired: boolean, participants: Array<{ __typename?: 'AppointmentParticipant', id: string, name: string, type: ParticipantType, status: ParticipationStatus, profileId?: string | null, clientProfileId?: string | null, orderApproved?: boolean | null }>, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }>, checkout?: { __typename?: 'Checkout', id: string, total: number, paid: number, balance: number, marketplaceUserId?: string | null, summary?: string | null, voidedAt?: any | null, paymentMethodType?: PaymentMethodType | null, createdAt: any, updatedAt: any, paymentLinks: Array<{ __typename?: 'PaymentLink', id: string, checkoutId: string, url: string, status: PaymentLinkStatus, amount: number, expiresAt?: any | null, createdAt: any, updatedAt: any }> } | null, additionalPatients: Array<{ __typename?: 'AppointmentRequestPatient', id: string, clientProfile: { __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null }, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }> }> }>, appointmentRequests: Array<{ __typename?: 'AppointmentRequest', id: string, location: string, latitude?: number | null, longitude?: number | null, status: AppointmentRequestStatus, bookingMode?: BookingMode | null, cancelReason?: string | null, notes?: string | null, lastResetAt?: any | null, waitlistedAt?: any | null, createdAt: any, updatedAt: any, archivedAt?: any | null, marketplace: { __typename?: 'Marketplace', id: string, name: string, groupId: string, createdAt: any, logo?: string | null, favicon?: string | null, primaryColor?: string | null, marketingSiteUrl?: string | null, gtmContainer?: string | null, gtmRequiresConsent: boolean, gtmDataTier: GtmDataTier, gtmV2Enabled: boolean, featureFlags: { __typename?: 'MarketplaceFeatureFlags', waitListEnabled?: boolean | null, acceptedPaymentMethods?: { __typename?: 'AcceptedPaymentMethods', creditCard?: boolean | null, applePay?: boolean | null } | null } }, clientProfiles: Array<{ __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null }>, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }>, constraints: Array<{ __typename?: 'AppointmentConstraint', id: string, organizations: Array<{ __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null }>, profiles: Array<{ __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null }>, timeRanges: Array<{ __typename?: 'AppointmentTimeRange', id: string, start: any, end: any }> }>, additionalPatients: Array<{ __typename?: 'AppointmentRequestPatient', id: string, clientProfile: { __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null }, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }> }> }>, clientProfile?: { __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null } | null }> }>, checkout?: { __typename?: 'Checkout', id: string, total: number, paid: number, balance: number, marketplaceUserId?: string | null, summary?: string | null, voidedAt?: any | null, paymentMethodType?: PaymentMethodType | null, createdAt: any, updatedAt: any, items: Array<{ __typename?: 'CheckoutItem', id: string, type: CheckoutItemType, description: string, quantity: number, price: number, key?: string | null }>, payments: Array<{ __typename?: 'Payment', id: string, type: PaymentType, status: PaymentStatus, description: string, amount: number, amountRequested: number, amountReversed?: number | null, isDeposit: boolean, createdAt: any, updatedAt: any }>, payouts: Array<{ __typename?: 'Payout', id: string, status: PayoutStatus, description: string, amount: number, amountRequested: number, amountReversed?: number | null, createdAt: any, updatedAt: any, checkoutId: string }>, paymentInstrument?: { __typename?: 'PaymentInstrument', id: string, type: PaymentInstrumentType, processor: PaymentAccountPlatform, brand?: string | null, lastFour?: string | null, expirationMonth?: number | null, expirationYear?: number | null, createdAt: any, updatedAt: any } | null, marketplaceUser?: { __typename?: 'MarketplaceUser', id: string, createdAt: any, updatedAt: any, groupId: string, membership: string, primaryInstrumentId?: string | null, email?: string | null, phone?: string | null, emailConfirmed: boolean, phoneConfirmed: boolean, emailOptIn: boolean, phoneOptIn: boolean, clientProfile?: { __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null } | null } | null, paymentLinks: Array<{ __typename?: 'PaymentLink', id: string, checkoutId: string, url: string, status: PaymentLinkStatus, amount: number, expiresAt?: any | null, createdAt: any, updatedAt: any }> } | null, marketplace: { __typename?: 'Marketplace', id: string, name: string, groupId: string, createdAt: any, logo?: string | null, favicon?: string | null, primaryColor?: string | null, marketingSiteUrl?: string | null, gtmContainer?: string | null, gtmRequiresConsent: boolean, gtmDataTier: GtmDataTier, gtmV2Enabled: boolean, featureFlags: { __typename?: 'MarketplaceFeatureFlags', waitListEnabled?: boolean | null, acceptedPaymentMethods?: { __typename?: 'AcceptedPaymentMethods', creditCard?: boolean | null, applePay?: boolean | null } | null } }, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }>, constraints: Array<{ __typename?: 'AppointmentConstraint', id: string, organizations: Array<{ __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null }>, profiles: Array<{ __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null }>, timeRanges: Array<{ __typename?: 'AppointmentTimeRange', id: string, start: any, end: any }> }>, additionalPatients: Array<{ __typename?: 'AppointmentRequestPatient', id: string, clientProfile: { __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null }, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }> }> } | null };

export type CreateAttachmentMutationVariables = Exact<{
  input: CreateAttachmentInput;
}>;


export type CreateAttachmentMutation = { __typename?: 'Mutation', createAttachment: { __typename?: 'Document', id: string, filename: string, label: string, type: DocumentType, version: number, fileSize: number, url: string, createdAt: any, updatedAt: any } };

export type CreateAvailabilityMutationVariables = Exact<{
  input: CreateAvailabilityInput;
}>;


export type CreateAvailabilityMutation = { __typename?: 'Mutation', createAvailability?: { __typename?: 'Availability', id: string, type: AvailabilityType, start: any, end: any, tzid: string, duration: number, createdAt: any, updatedAt: any, repeat?: { __typename?: 'RepeatRule', id: string, frequency: RepeatFrequencyType, byWeekday: Array<RepeatWeekdayType>, until?: any | null } | null } | null };

export type CreateAvailabilityCoverageMutationVariables = Exact<{
  input: CreateAvailabilityCoverageInput;
}>;


export type CreateAvailabilityCoverageMutation = { __typename?: 'Mutation', createAvailabilityCoverage?: { __typename?: 'AvailabilityCoverage', id: string, label: string, threshold: number, start: any, end: any, tzid: string, repeat?: { __typename?: 'RepeatRule', id: string, frequency: RepeatFrequencyType, byWeekday: Array<RepeatWeekdayType>, until?: any | null } | null, profiles: Array<{ __typename?: 'ProcedureProfile', id: string }> } | null };

export type CreateClientProfileMutationVariables = Exact<{
  input: CreateClientProfileInput;
}>;


export type CreateClientProfileMutation = { __typename?: 'Mutation', createClientProfile?: { __typename?: 'ClientProfile', internalNotesUpdatedBy?: string | null, internalNotesUpdatedAt?: any | null, id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null, patient?: { __typename?: 'Patient', id: string, allergies?: string | null, archivedAt?: any | null, clientProfileId: string, conditions?: string | null, createdAt: any, emrInstanceId: string, immunizations?: string | null, labs?: string | null, medications?: string | null, procedures?: string | null, updatedAt: any, orders: Array<{ __typename?: 'Order', id: string, archivedAt?: any | null, createdAt: any, expiresAt: any, providerType: ProviderType, fillCount: number, note?: string | null, refills: number, startsAt: any, updatedAt: any, procedureDefs: Array<{ __typename?: 'ProcedureDefinition', id: string, name: string, description: string, price: number, duration: number, assessmentFormTemplateId?: string | null, interventionFormTemplateId?: string | null, ordersRequired: boolean, createdAt: any, intakeFormTemplates: Array<{ __typename?: 'FormTemplate', id: string, name: string }> }>, profile?: { __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null } | null, organizations: Array<{ __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null }> }>, vitals: Array<{ __typename?: 'VitalSign', id: string, createdAt: any, createdById: string, recordedAt: any, type: VitalSignType, updatedAt: any, value: string }>, signedConsentForms: Array<{ __typename?: 'DocumentSignature', id: string, signerName: string, signerEmail?: string | null, signerType: DocumentSignatureSignerType, signedAt: any, verificationType: DocumentSignatureVerificationType, verificationDetail?: string | null, tzid: string, latitude?: number | null, longitude?: number | null, documentId: string, version: number, documentLabel: string, url?: string | null, createdAt: any, updatedAt: any }>, allergyRecords: Array<{ __typename?: 'AllergyIntolerance', id: string, name: string }>, clinicalProcedureRecords: Array<{ __typename?: 'ClinicalProcedure', id: string, name: string }>, conditionRecords: Array<{ __typename?: 'Condition', id: string, name: string }>, immunizationRecords: Array<{ __typename?: 'Immunization', id: string, name: string }>, labRecords: Array<{ __typename?: 'Lab', id: string, name: string }>, medicationRecords: Array<{ __typename?: 'MedicationStatement', id: string, name: string }>, attachments?: Array<{ __typename?: 'Document', id: string, filename: string, label: string, type: DocumentType, version: number, fileSize: number, url: string, createdAt: any, updatedAt: any }> | null } | null, appointments: Array<{ __typename?: 'Appointment', id: string, status: AppointmentStatus, cancelReason?: string | null, start: any, end: any, duration: number, location: string, groupId?: string | null, archivedAt?: any | null, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string }>, participants: Array<{ __typename?: 'AppointmentParticipant', id: string, name: string, type: ParticipantType, status: ParticipationStatus, profileId?: string | null, clientProfileId?: string | null, orderApproved?: boolean | null }> }>, intakeSubmissions: Array<{ __typename?: 'IntakeSubmission', id: string, status: IntakeSubmissionStatus, reviewStatus?: IntakeReviewStatus | null, formName?: string | null, submittedAt?: any | null, appointmentId: string, pdfUrl?: string | null, reviewedByName?: string | null, documentId?: string | null, appointment?: { __typename?: 'Appointment', id: string, start: any, status: AppointmentStatus } | null }> } | null };

export type CreateClinicalProcedureMutationVariables = Exact<{
  input: CreateClinicalProcedureInput;
}>;


export type CreateClinicalProcedureMutation = { __typename?: 'Mutation', createClinicalProcedure: { __typename?: 'ClinicalProcedure', id: string, name: string } };

export type CreateConditionMutationVariables = Exact<{
  input: CreateConditionInput;
}>;


export type CreateConditionMutation = { __typename?: 'Mutation', createCondition: { __typename?: 'Condition', id: string, name: string } };

export type CreateDiscountMutationVariables = Exact<{
  input: CreateDiscountInput;
}>;


export type CreateDiscountMutation = { __typename?: 'Mutation', createDiscount?: { __typename?: 'Discount', id: string, percentage: number, membershipDefinitionId: string, procedureGroups: Array<{ __typename?: 'ProcedureBaseDefinitionGroup', id: string, name: string }> } | null };

export type CreateDocumentMutationVariables = Exact<{
  input: CreateDocumentInput;
}>;


export type CreateDocumentMutation = { __typename?: 'Mutation', createDocument: { __typename?: 'Document', id: string, filename: string, label: string, type: DocumentType, version: number, fileSize: number, url: string, createdAt: any, updatedAt: any } };

export type CreateEmrInstanceMutationVariables = Exact<{
  input: CreateEmrInstanceInput;
}>;


export type CreateEmrInstanceMutation = { __typename?: 'Mutation', createEmrInstance?: { __typename?: 'EmrInstance', id: string, label: string, createdAt: any } | null };

export type CreateFormNoteMutationVariables = Exact<{
  input: CreateFormNoteInput;
}>;


export type CreateFormNoteMutation = { __typename?: 'Mutation', createFormNote?: { __typename?: 'FormNote', id: string, note: string, edited: boolean, profileId: string, createdAt: any, updatedAt: any, author: string } | null };

export type CreateFormTemplateMutationVariables = Exact<{
  input: CreateFormTemplateInput;
}>;


export type CreateFormTemplateMutation = { __typename?: 'Mutation', createFormTemplate?: { __typename?: 'FormTemplate', id: string, name: string, type: FormType, parentId?: string | null, createdAt: any, updatedAt: any, items: Array<{ __typename?: 'FormTemplateItem', id: string, index: number, label: string, type: FormItemType, options?: string | null, createdAt: any, updatedAt: any }> } | null };

export type CreateGeoperimeterMutationVariables = Exact<{
  input: CreateGeoperimeterInput;
}>;


export type CreateGeoperimeterMutation = { __typename?: 'Mutation', createGeoperimeter?: { __typename?: 'Geoperimeter', id: string, type: GeoperimeterType, organizationId: string, lat?: number | null, lng?: number | null, radius?: number | null, paths?: string | null, travelFee?: number | null } | null };

export type CreateImmunizationMutationVariables = Exact<{
  input: CreateImmunizationInput;
}>;


export type CreateImmunizationMutation = { __typename?: 'Mutation', createImmunization: { __typename?: 'Immunization', id: string, name: string } };

export type CreateLabMutationVariables = Exact<{
  input: CreateLabInput;
}>;


export type CreateLabMutation = { __typename?: 'Mutation', createLab: { __typename?: 'Lab', id: string, name: string } };

export type CreateMarketplaceMutationVariables = Exact<{
  input: CreateMarketplaceInput;
}>;


export type CreateMarketplaceMutation = { __typename?: 'Mutation', createMarketplace?: { __typename?: 'Marketplace', requireDispatchApproval: boolean, requirePractitionerApproval: boolean, dispatchStrategy?: DispatchStrategy | null, bookingMode?: BookingMode | null, slackWebhookUrl?: string | null, reviewsIoKeyDescription?: string | null, consentTokenSecretDescription?: string | null, reviewsIoStoreId?: string | null, paymentAccountId?: string | null, feeProfileFixed?: number | null, feeProfileBasisPoints?: number | null, logo?: string | null, favicon?: string | null, primaryColor?: string | null, marketingSiteUrl?: string | null, paymentCollectionMethod?: PaymentCollectionMethod | null, paymentDepositType?: PaymentDepositType | null, paymentDepositValue?: number | null, hasPaymentPolicy?: boolean | null, paymentPolicyName?: string | null, paymentPolicyText?: string | null, requirePaymentPolicyAttestation?: boolean | null, id: string, name: string, groupId: string, createdAt: any, gtmContainer?: string | null, gtmRequiresConsent: boolean, gtmDataTier: GtmDataTier, gtmV2Enabled: boolean, roles: Array<{ __typename?: 'Role', id: string, name: string, scope: RoleScope, type: RoleType, permissions: Array<string>, resourceId?: string | null }>, checkoutContent: { __typename?: 'MarketplaceCheckoutContent', servicesNotice?: string | null, scheduleNotice?: string | null, confirmationMessage?: string | null, footerLinks: Array<{ __typename?: 'MarketplaceFooterLink', label: string, url: string }> }, featureFlags: { __typename?: 'MarketplaceFeatureFlags', waitListEnabled?: boolean | null, acceptedPaymentMethods?: { __typename?: 'AcceptedPaymentMethods', creditCard?: boolean | null, applePay?: boolean | null } | null, windowBooking?: { __typename?: 'WindowBookingConfig', allowSpecificTimeRequest?: boolean | null, minRemainingMinutes?: number | null, windows?: Array<{ __typename?: 'WindowConfig', key: WindowKey, enabled: boolean, startTime: string, endTime: string }> | null } | null } } | null };

export type CreateMedicationMutationVariables = Exact<{
  input: CreateMedicationInput;
}>;


export type CreateMedicationMutation = { __typename?: 'Mutation', createMedication: { __typename?: 'Medication', id: string, name: string, unit: string, createdAt: any } };

export type CreateMedicationStatementMutationVariables = Exact<{
  input: CreateMedicationStatementInput;
}>;


export type CreateMedicationStatementMutation = { __typename?: 'Mutation', createMedicationStatement: { __typename?: 'MedicationStatement', id: string, name: string } };

export type CreateMembershipMutationVariables = Exact<{
  input: CreateMembershipInput;
}>;


export type CreateMembershipMutation = { __typename?: 'Mutation', createMembership?: { __typename?: 'Membership', id: string, membershipDefinitionId: string, renewalDate: any, name: string, status: MembershipStatusType } | null };

export type CreateMembershipDefinitionMutationVariables = Exact<{
  input: CreateMembershipDefinitionInput;
}>;


export type CreateMembershipDefinitionMutation = { __typename?: 'Mutation', createMembershipDefinition?: { __typename?: 'MembershipDefinition', id: string, name: string, price: number, period: MembershipDefinitionPeriodType, packageId?: string | null, marketplaceId: string, advertise: boolean, description?: string | null, list?: string | null } | null };

export type CreateObservationsMutationVariables = Exact<{
  input: CreateObservationsInput;
}>;


export type CreateObservationsMutation = { __typename?: 'Mutation', createObservations: { __typename?: 'Form', id: string, type: FormType, status: FormStatusType, patientId: string, lockedById?: string | null, editable: boolean, createdAt: any, updatedAt: any, items: Array<{ __typename?: 'FormItem', id: string, index: number, label: string, type: FormItemType, code: string, options?: string | null, createdAt: any, updatedAt: any }>, observations: Array<{ __typename?: 'Observation', id: string, code: string, value: string, note?: string | null, createdById: string, createdAt: any, updatedAt: any, createdBy?: { __typename?: 'Profile', id: string, givenName: string, familyName: string, title: string } | null }>, lockedBy?: { __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null } | null, document?: { __typename?: 'Document', id: string, filename: string, label: string, type: DocumentType, version: number, fileSize: number, url: string, createdAt: any, updatedAt: any } | null, attachments?: Array<{ __typename?: 'Document', id: string, filename: string, label: string, type: DocumentType, version: number, fileSize: number, url: string, createdAt: any, updatedAt: any }> | null, notes: Array<{ __typename?: 'FormNote', id: string, note: string, edited: boolean, profileId: string, createdAt: any, updatedAt: any, author: string }> } };

export type CreateOrderMutationVariables = Exact<{
  input: CreateOrderInput;
}>;


export type CreateOrderMutation = { __typename?: 'Mutation', createOrder: { __typename?: 'Order', id: string, archivedAt?: any | null, createdAt: any, expiresAt: any, providerType: ProviderType, fillCount: number, note?: string | null, refills: number, startsAt: any, updatedAt: any, procedureDefs: Array<{ __typename?: 'ProcedureDefinition', id: string, name: string, description: string, price: number, duration: number, assessmentFormTemplateId?: string | null, interventionFormTemplateId?: string | null, ordersRequired: boolean, createdAt: any, intakeFormTemplates: Array<{ __typename?: 'FormTemplate', id: string, name: string }> }>, profile?: { __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null } | null, organizations: Array<{ __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null }> } };

export type CreateOrganizationMutationVariables = Exact<{
  input: CreateOrganizationInput;
}>;


export type CreateOrganizationMutation = { __typename?: 'Mutation', createOrganization?: { __typename?: 'Organization', slackWebhookUrl?: string | null, googleReviewsUrl?: string | null, paymentAccountId?: string | null, id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null };

export type CreatePackageMutationVariables = Exact<{
  input: CreatePackageInput;
}>;


export type CreatePackageMutation = { __typename?: 'Mutation', createPackage?: { __typename?: 'Package', id: string, name: string, price: number, marketplaceId: string, advertise: boolean, description?: string | null, list?: string | null } | null };

export type CreatePackageItemDefinitionMutationVariables = Exact<{
  input: CreatePackageItemDefinitionInput;
}>;


export type CreatePackageItemDefinitionMutation = { __typename?: 'Mutation', createPackageItemDefinition?: { __typename?: 'PackageItemDefinition', id: string, packageId: string, points: number, procedureGroups: Array<string> } | null };

export type CreatePaymentAccountMutationVariables = Exact<{
  input: CreatePaymentAccountInput;
}>;


export type CreatePaymentAccountMutation = { __typename?: 'Mutation', createPaymentAccount?: { __typename?: 'PaymentAccount', id: string, label: string, platform: PaymentAccountPlatform, enabled: boolean, state: PaymentAccountState, onboardingUrl?: string | null, createdAt: any, updatedAt: any } | null };

export type CreatePaymentInstrumentMutationVariables = Exact<{
  input: PaymentMethodInput;
}>;


export type CreatePaymentInstrumentMutation = { __typename?: 'Mutation', createPaymentInstrument?: { __typename?: 'PaymentInstrument', id: string, type: PaymentInstrumentType, processor: PaymentAccountPlatform, brand?: string | null, lastFour?: string | null, expirationMonth?: number | null, expirationYear?: number | null, createdAt: any, updatedAt: any } | null };

export type CreateProcedureBaseDefGroupMutationVariables = Exact<{
  input: CreateProcedureBaseDefinitionGroupInput;
}>;


export type CreateProcedureBaseDefGroupMutation = { __typename?: 'Mutation', createProcedureBaseDefinitionGroup?: { __typename?: 'ProcedureBaseDefinitionGroup', id: string, name: string, thumbnail?: string | null, banner?: string | null, type: ProcedureGroupType, description?: string | null, bgcolor?: string | null, fontColor?: string | null, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string }>, featuredBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string }>, procedureBaseDefGroups: Array<{ __typename?: 'ProcedureBaseDefinitionGroup', id: string, name: string, type: ProcedureGroupType }> } | null };

export type CreateProcedureBaseDefinitionMutationVariables = Exact<{
  input: CreateProcedureBaseDefinitionInput;
}>;


export type CreateProcedureBaseDefinitionMutation = { __typename?: 'Mutation', createProcedureBaseDefinition?: { __typename?: 'ProcedureBaseDefinition', tags: Array<string>, addOns: Array<string>, id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null, layouts: Array<{ __typename?: 'ProcedureBaseDefinitionLayout', type: ProcedureBaseDefinitionLayoutType, layout: string, itemIndex: number }> } | null };

export type CreateProcedureBaseDefinitionTagMutationVariables = Exact<{
  input: ProcedureBaseDefinitionTagInput;
}>;


export type CreateProcedureBaseDefinitionTagMutation = { __typename?: 'Mutation', createProcedureBaseDefinitionTag: { __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null } };

export type CreateProcedureDefinitionMutationVariables = Exact<{
  input: CreateProcedureDefinitionInput;
}>;


export type CreateProcedureDefinitionMutation = { __typename?: 'Mutation', createProcedureDefinition?: { __typename?: 'ProcedureDefinition', id: string, name: string, description: string, price: number, duration: number, assessmentFormTemplateId?: string | null, interventionFormTemplateId?: string | null, ordersRequired: boolean, createdAt: any, intakeFormTemplates: Array<{ __typename?: 'FormTemplate', id: string, name: string }> } | null };

export type CreateProcedureProfileMutationVariables = Exact<{
  input: CreateProcedureProfileInput;
}>;


export type CreateProcedureProfileMutation = { __typename?: 'Mutation', createProcedureProfile?: { __typename?: 'ProcedureProfile', createdAt: any, id: string, name: string, updatedAt: any, procedureDefs: Array<{ __typename?: 'ProcedureDefinition', id: string, name: string, description: string, price: number, duration: number, assessmentFormTemplateId?: string | null, interventionFormTemplateId?: string | null, ordersRequired: boolean, createdAt: any, baseDefinitions: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }>, intakeFormTemplates: Array<{ __typename?: 'FormTemplate', id: string, name: string }> }> } | null };

export type CreateProfileMutationVariables = Exact<{
  input: CreateProfileInput;
}>;


export type CreateProfileMutation = { __typename?: 'Mutation', createProfile: { __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, procedureProfiles: Array<{ __typename?: 'ProcedureProfile', createdAt: any, id: string, name: string, updatedAt: any, procedureDefs: Array<{ __typename?: 'ProcedureDefinition', id: string, name: string, description: string, price: number, duration: number, assessmentFormTemplateId?: string | null, interventionFormTemplateId?: string | null, ordersRequired: boolean, createdAt: any, baseDefinitions: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }>, intakeFormTemplates: Array<{ __typename?: 'FormTemplate', id: string, name: string }> }> }>, availabilities: Array<{ __typename?: 'Availability', id: string, type: AvailabilityType, start: any, end: any, tzid: string, duration: number, createdAt: any, updatedAt: any, repeat?: { __typename?: 'RepeatRule', id: string, frequency: RepeatFrequencyType, byWeekday: Array<RepeatWeekdayType>, until?: any | null } | null }>, roles: Array<{ __typename?: 'Role', id: string, name: string, scope: RoleScope, type: RoleType, permissions: Array<string>, resourceId?: string | null }>, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null } };

export type CreatePromoCodeMutationVariables = Exact<{
  input: CreatePromoCodeInput;
}>;


export type CreatePromoCodeMutation = { __typename?: 'Mutation', createPromoCode?: { __typename?: 'PromoCode', id: string, name: string, code: string, discountType: PromoCodeDiscountType, discountValue: number, activationStartDate: any, activationEndDate: any, usageStartDate: any, usageEndDate: any, usageLimitTotal?: number | null, usageLimitPerUser?: number | null, minimumBookingAmount?: number | null, active: boolean, marketplaceId: string, createdAt: any, updatedAt: any, procedureGroups: Array<{ __typename?: 'ProcedureBaseDefinitionGroup', id: string, name: string }>, organizations: Array<{ __typename?: 'Organization', id: string, name: string }>, usage: Array<{ __typename?: 'PromoCodeUsage', id: string, marketplaceUserId: string, discountAmount: number, usedAt: any }> } | null };

export type CreateReachIntegrationMutationVariables = Exact<{
  input: CreateReachIntegrationInput;
}>;


export type CreateReachIntegrationMutation = { __typename?: 'Mutation', createReachIntegration?: { __typename?: 'ReachIntegration', id: string, marketplaceId: string, reachId: string } | null };

export type CreateRoleMutationVariables = Exact<{
  input: CreateRoleInput;
}>;


export type CreateRoleMutation = { __typename?: 'Mutation', createRole?: { __typename?: 'Role', id: string, name: string, scope: RoleScope, type: RoleType, permissions: Array<string>, resourceId?: string | null } | null };

export type CreateUploadUrlMutationVariables = Exact<{
  input: CreateUploadUrlInput;
}>;


export type CreateUploadUrlMutation = { __typename?: 'Mutation', createUploadUrl: { __typename?: 'CreateUploadUrlPayload', token: string, url: string, fields: string } };

export type CreateVitalsMutationVariables = Exact<{
  input: CreateVitalsInput;
}>;


export type CreateVitalsMutation = { __typename?: 'Mutation', createVitals: { __typename?: 'Patient', id: string, allergies?: string | null, archivedAt?: any | null, clientProfileId: string, conditions?: string | null, createdAt: any, emrInstanceId: string, immunizations?: string | null, labs?: string | null, medications?: string | null, procedures?: string | null, updatedAt: any } };

export type DeactivatePaymentLinkMutationVariables = Exact<{
  input: DeactivatePaymentLinkInput;
}>;


export type DeactivatePaymentLinkMutation = { __typename?: 'Mutation', deactivatePaymentLink: { __typename?: 'Checkout', id: string, total: number, paid: number, balance: number, marketplaceUserId?: string | null, summary?: string | null, voidedAt?: any | null, paymentMethodType?: PaymentMethodType | null, createdAt: any, updatedAt: any, appointment?: { __typename?: 'Appointment', id: string, location: string, latitude?: number | null, longitude?: number | null, start: any, end: any, duration: number, createdAt: any, updatedAt: any, archivedAt?: any | null, status: AppointmentStatus, startedAt?: any | null, completedAt?: any | null, notes?: string | null, createdBy?: string | null, cancelReason?: string | null, groupId?: string | null, ordersRequired: boolean, participants: Array<{ __typename?: 'AppointmentParticipant', id: string, name: string, type: ParticipantType, status: ParticipationStatus, profileId?: string | null, clientProfileId?: string | null, orderApproved?: boolean | null, participant?: { __typename?: 'ClientProfile', internalNotesUpdatedBy?: string | null, internalNotesUpdatedAt?: any | null, id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null, patient?: { __typename?: 'Patient', id: string, allergies?: string | null, archivedAt?: any | null, clientProfileId: string, conditions?: string | null, createdAt: any, emrInstanceId: string, immunizations?: string | null, labs?: string | null, medications?: string | null, procedures?: string | null, updatedAt: any, orders: Array<{ __typename?: 'Order', id: string, archivedAt?: any | null, createdAt: any, expiresAt: any, providerType: ProviderType, fillCount: number, note?: string | null, refills: number, startsAt: any, updatedAt: any, procedureDefs: Array<{ __typename?: 'ProcedureDefinition', id: string, name: string, description: string, price: number, duration: number, assessmentFormTemplateId?: string | null, interventionFormTemplateId?: string | null, ordersRequired: boolean, createdAt: any, intakeFormTemplates: Array<{ __typename?: 'FormTemplate', id: string, name: string }> }>, profile?: { __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null } | null, organizations: Array<{ __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null }> }>, vitals: Array<{ __typename?: 'VitalSign', id: string, createdAt: any, createdById: string, recordedAt: any, type: VitalSignType, updatedAt: any, value: string }>, signedConsentForms: Array<{ __typename?: 'DocumentSignature', id: string, signerName: string, signerEmail?: string | null, signerType: DocumentSignatureSignerType, signedAt: any, verificationType: DocumentSignatureVerificationType, verificationDetail?: string | null, tzid: string, latitude?: number | null, longitude?: number | null, documentId: string, version: number, documentLabel: string, url?: string | null, createdAt: any, updatedAt: any }>, allergyRecords: Array<{ __typename?: 'AllergyIntolerance', id: string, name: string }>, clinicalProcedureRecords: Array<{ __typename?: 'ClinicalProcedure', id: string, name: string }>, conditionRecords: Array<{ __typename?: 'Condition', id: string, name: string }>, immunizationRecords: Array<{ __typename?: 'Immunization', id: string, name: string }>, labRecords: Array<{ __typename?: 'Lab', id: string, name: string }>, medicationRecords: Array<{ __typename?: 'MedicationStatement', id: string, name: string }>, attachments?: Array<{ __typename?: 'Document', id: string, filename: string, label: string, type: DocumentType, version: number, fileSize: number, url: string, createdAt: any, updatedAt: any }> | null } | null } | { __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null } | null, responses: Array<{ __typename?: 'AppointmentResponse', id: string, start?: any | null, end?: any | null, createdAt: any, updatedAt: any }>, forms: Array<{ __typename?: 'Form', id: string, type: FormType, status: FormStatusType, patientId: string, lockedById?: string | null, editable: boolean, createdAt: any, updatedAt: any, items: Array<{ __typename?: 'FormItem', id: string, index: number, label: string, type: FormItemType, code: string, options?: string | null, createdAt: any, updatedAt: any }>, observations: Array<{ __typename?: 'Observation', id: string, code: string, value: string, note?: string | null, createdById: string, createdAt: any, updatedAt: any, createdBy?: { __typename?: 'Profile', id: string, givenName: string, familyName: string, title: string } | null }>, lockedBy?: { __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null } | null, document?: { __typename?: 'Document', id: string, filename: string, label: string, type: DocumentType, version: number, fileSize: number, url: string, createdAt: any, updatedAt: any } | null, attachments?: Array<{ __typename?: 'Document', id: string, filename: string, label: string, type: DocumentType, version: number, fileSize: number, url: string, createdAt: any, updatedAt: any }> | null, notes: Array<{ __typename?: 'FormNote', id: string, note: string, edited: boolean, profileId: string, createdAt: any, updatedAt: any, author: string }> }> }>, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }> } | null, appointmentRequest?: { __typename?: 'AppointmentRequest', id: string, location: string, latitude?: number | null, longitude?: number | null, status: AppointmentRequestStatus, bookingMode?: BookingMode | null, cancelReason?: string | null, notes?: string | null, lastResetAt?: any | null, waitlistedAt?: any | null, createdAt: any, updatedAt: any, archivedAt?: any | null, marketplace: { __typename?: 'Marketplace', id: string, name: string, groupId: string, createdAt: any, logo?: string | null, favicon?: string | null, primaryColor?: string | null, marketingSiteUrl?: string | null, gtmContainer?: string | null, gtmRequiresConsent: boolean, gtmDataTier: GtmDataTier, gtmV2Enabled: boolean, featureFlags: { __typename?: 'MarketplaceFeatureFlags', waitListEnabled?: boolean | null, acceptedPaymentMethods?: { __typename?: 'AcceptedPaymentMethods', creditCard?: boolean | null, applePay?: boolean | null } | null } }, clientProfiles: Array<{ __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null }>, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }>, constraints: Array<{ __typename?: 'AppointmentConstraint', id: string, organizations: Array<{ __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null }>, profiles: Array<{ __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null }>, timeRanges: Array<{ __typename?: 'AppointmentTimeRange', id: string, start: any, end: any }> }>, additionalPatients: Array<{ __typename?: 'AppointmentRequestPatient', id: string, clientProfile: { __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null }, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }> }> } | null, items: Array<{ __typename?: 'CheckoutItem', id: string, type: CheckoutItemType, description: string, quantity: number, price: number, key?: string | null }>, payments: Array<{ __typename?: 'Payment', id: string, type: PaymentType, status: PaymentStatus, description: string, amount: number, amountRequested: number, amountReversed?: number | null, isDeposit: boolean, createdAt: any, updatedAt: any }>, payouts: Array<{ __typename?: 'Payout', id: string, status: PayoutStatus, description: string, amount: number, amountRequested: number, amountReversed?: number | null, createdAt: any, updatedAt: any, checkoutId: string }>, paymentInstrument?: { __typename?: 'PaymentInstrument', id: string, type: PaymentInstrumentType, processor: PaymentAccountPlatform, brand?: string | null, lastFour?: string | null, expirationMonth?: number | null, expirationYear?: number | null, createdAt: any, updatedAt: any } | null, marketplaceUser?: { __typename?: 'MarketplaceUser', id: string, createdAt: any, updatedAt: any, groupId: string, membership: string, primaryInstrumentId?: string | null, email?: string | null, phone?: string | null, emailConfirmed: boolean, phoneConfirmed: boolean, emailOptIn: boolean, phoneOptIn: boolean, clientProfile?: { __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null } | null } | null, paymentLinks: Array<{ __typename?: 'PaymentLink', id: string, checkoutId: string, url: string, status: PaymentLinkStatus, amount: number, expiresAt?: any | null, createdAt: any, updatedAt: any }> } };

export type DeclineAppointmentMutationVariables = Exact<{
  input: DeclineAppointmentInput;
}>;


export type DeclineAppointmentMutation = { __typename?: 'Mutation', declineAppointment?: { __typename?: 'Appointment', id: string, location: string, latitude?: number | null, longitude?: number | null, start: any, end: any, duration: number, createdAt: any, updatedAt: any, archivedAt?: any | null, status: AppointmentStatus, startedAt?: any | null, completedAt?: any | null, notes?: string | null, createdBy?: string | null, cancelReason?: string | null, groupId?: string | null, ordersRequired: boolean, participants: Array<{ __typename?: 'AppointmentParticipant', id: string, name: string, type: ParticipantType, status: ParticipationStatus, profileId?: string | null, clientProfileId?: string | null, orderApproved?: boolean | null, participant?: { __typename?: 'ClientProfile', internalNotesUpdatedBy?: string | null, internalNotesUpdatedAt?: any | null, id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null, patient?: { __typename?: 'Patient', id: string, allergies?: string | null, archivedAt?: any | null, clientProfileId: string, conditions?: string | null, createdAt: any, emrInstanceId: string, immunizations?: string | null, labs?: string | null, medications?: string | null, procedures?: string | null, updatedAt: any, orders: Array<{ __typename?: 'Order', id: string, archivedAt?: any | null, createdAt: any, expiresAt: any, providerType: ProviderType, fillCount: number, note?: string | null, refills: number, startsAt: any, updatedAt: any, procedureDefs: Array<{ __typename?: 'ProcedureDefinition', id: string, name: string, description: string, price: number, duration: number, assessmentFormTemplateId?: string | null, interventionFormTemplateId?: string | null, ordersRequired: boolean, createdAt: any, intakeFormTemplates: Array<{ __typename?: 'FormTemplate', id: string, name: string }> }>, profile?: { __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null } | null, organizations: Array<{ __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null }> }>, vitals: Array<{ __typename?: 'VitalSign', id: string, createdAt: any, createdById: string, recordedAt: any, type: VitalSignType, updatedAt: any, value: string }>, signedConsentForms: Array<{ __typename?: 'DocumentSignature', id: string, signerName: string, signerEmail?: string | null, signerType: DocumentSignatureSignerType, signedAt: any, verificationType: DocumentSignatureVerificationType, verificationDetail?: string | null, tzid: string, latitude?: number | null, longitude?: number | null, documentId: string, version: number, documentLabel: string, url?: string | null, createdAt: any, updatedAt: any }>, allergyRecords: Array<{ __typename?: 'AllergyIntolerance', id: string, name: string }>, clinicalProcedureRecords: Array<{ __typename?: 'ClinicalProcedure', id: string, name: string }>, conditionRecords: Array<{ __typename?: 'Condition', id: string, name: string }>, immunizationRecords: Array<{ __typename?: 'Immunization', id: string, name: string }>, labRecords: Array<{ __typename?: 'Lab', id: string, name: string }>, medicationRecords: Array<{ __typename?: 'MedicationStatement', id: string, name: string }>, attachments?: Array<{ __typename?: 'Document', id: string, filename: string, label: string, type: DocumentType, version: number, fileSize: number, url: string, createdAt: any, updatedAt: any }> | null } | null } | { __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null } | null, responses: Array<{ __typename?: 'AppointmentResponse', id: string, start?: any | null, end?: any | null, createdAt: any, updatedAt: any }>, forms: Array<{ __typename?: 'Form', id: string, type: FormType, status: FormStatusType, patientId: string, lockedById?: string | null, editable: boolean, createdAt: any, updatedAt: any, items: Array<{ __typename?: 'FormItem', id: string, index: number, label: string, type: FormItemType, code: string, options?: string | null, createdAt: any, updatedAt: any }>, observations: Array<{ __typename?: 'Observation', id: string, code: string, value: string, note?: string | null, createdById: string, createdAt: any, updatedAt: any, createdBy?: { __typename?: 'Profile', id: string, givenName: string, familyName: string, title: string } | null }>, lockedBy?: { __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null } | null, document?: { __typename?: 'Document', id: string, filename: string, label: string, type: DocumentType, version: number, fileSize: number, url: string, createdAt: any, updatedAt: any } | null, attachments?: Array<{ __typename?: 'Document', id: string, filename: string, label: string, type: DocumentType, version: number, fileSize: number, url: string, createdAt: any, updatedAt: any }> | null, notes: Array<{ __typename?: 'FormNote', id: string, note: string, edited: boolean, profileId: string, createdAt: any, updatedAt: any, author: string }> }> }>, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }>, checkout?: { __typename?: 'Checkout', id: string, total: number, paid: number, balance: number, marketplaceUserId?: string | null, summary?: string | null, voidedAt?: any | null, paymentMethodType?: PaymentMethodType | null, createdAt: any, updatedAt: any, items: Array<{ __typename?: 'CheckoutItem', id: string, type: CheckoutItemType, description: string, quantity: number, price: number, key?: string | null }>, payments: Array<{ __typename?: 'Payment', id: string, type: PaymentType, status: PaymentStatus, description: string, amount: number, amountRequested: number, amountReversed?: number | null, isDeposit: boolean, createdAt: any, updatedAt: any }>, payouts: Array<{ __typename?: 'Payout', id: string, status: PayoutStatus, description: string, amount: number, amountRequested: number, amountReversed?: number | null, createdAt: any, updatedAt: any, checkoutId: string }>, paymentInstrument?: { __typename?: 'PaymentInstrument', id: string, type: PaymentInstrumentType, processor: PaymentAccountPlatform, brand?: string | null, lastFour?: string | null, expirationMonth?: number | null, expirationYear?: number | null, createdAt: any, updatedAt: any } | null, marketplaceUser?: { __typename?: 'MarketplaceUser', id: string, createdAt: any, updatedAt: any, groupId: string, membership: string, primaryInstrumentId?: string | null, email?: string | null, phone?: string | null, emailConfirmed: boolean, phoneConfirmed: boolean, emailOptIn: boolean, phoneOptIn: boolean, clientProfile?: { __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null } | null } | null, paymentLinks: Array<{ __typename?: 'PaymentLink', id: string, checkoutId: string, url: string, status: PaymentLinkStatus, amount: number, expiresAt?: any | null, createdAt: any, updatedAt: any }> } | null, qualiphyInvitation?: { __typename?: 'QualiphyInvitation', id: string, expiration: any, meetingUrl?: string | null, exams?: Array<{ __typename?: 'QualiphyExam', id: string, title: string, status?: QualiphyInvitationStatus | null }> | null } | null, additionalPatients: Array<{ __typename?: 'AppointmentRequestPatient', id: string, clientProfile: { __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null }, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }> }> } | null };

export type DeleteAllergyIntoleranceMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteAllergyIntoleranceMutation = { __typename?: 'Mutation', deleteAllergyIntolerance: { __typename?: 'Patient', id: string, allergies?: string | null, archivedAt?: any | null, clientProfileId: string, conditions?: string | null, createdAt: any, emrInstanceId: string, immunizations?: string | null, labs?: string | null, medications?: string | null, procedures?: string | null, updatedAt: any } };

export type DeleteAvailabilityMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteAvailabilityMutation = { __typename?: 'Mutation', deleteAvailability: boolean };

export type DeleteAvailabilityCoverageMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteAvailabilityCoverageMutation = { __typename?: 'Mutation', deleteAvailabilityCoverage?: boolean | null };

export type DeleteClinicalProcedureMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteClinicalProcedureMutation = { __typename?: 'Mutation', deleteClinicalProcedure: { __typename?: 'Patient', id: string, allergies?: string | null, archivedAt?: any | null, clientProfileId: string, conditions?: string | null, createdAt: any, emrInstanceId: string, immunizations?: string | null, labs?: string | null, medications?: string | null, procedures?: string | null, updatedAt: any } };

export type DeleteConditionMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteConditionMutation = { __typename?: 'Mutation', deleteCondition: { __typename?: 'Patient', id: string, allergies?: string | null, archivedAt?: any | null, clientProfileId: string, conditions?: string | null, createdAt: any, emrInstanceId: string, immunizations?: string | null, labs?: string | null, medications?: string | null, procedures?: string | null, updatedAt: any } };

export type DeleteFormTemplateMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteFormTemplateMutation = { __typename?: 'Mutation', deleteFormTemplate: boolean };

export type DeleteGeoperimeterMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteGeoperimeterMutation = { __typename?: 'Mutation', deleteGeoperimeter?: boolean | null };

export type DeleteImmunizationMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteImmunizationMutation = { __typename?: 'Mutation', deleteImmunization: { __typename?: 'Patient', id: string, allergies?: string | null, archivedAt?: any | null, clientProfileId: string, conditions?: string | null, createdAt: any, emrInstanceId: string, immunizations?: string | null, labs?: string | null, medications?: string | null, procedures?: string | null, updatedAt: any } };

export type DeleteLabMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteLabMutation = { __typename?: 'Mutation', deleteLab: { __typename?: 'Patient', id: string, allergies?: string | null, archivedAt?: any | null, clientProfileId: string, conditions?: string | null, createdAt: any, emrInstanceId: string, immunizations?: string | null, labs?: string | null, medications?: string | null, procedures?: string | null, updatedAt: any } };

export type DeleteMedicationMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteMedicationMutation = { __typename?: 'Mutation', deleteMedication: boolean };

export type DeleteMedicationStatementMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteMedicationStatementMutation = { __typename?: 'Mutation', deleteMedicationStatement: { __typename?: 'Patient', id: string, allergies?: string | null, archivedAt?: any | null, clientProfileId: string, conditions?: string | null, createdAt: any, emrInstanceId: string, immunizations?: string | null, labs?: string | null, medications?: string | null, procedures?: string | null, updatedAt: any } };

export type DeleteMembershipMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteMembershipMutation = { __typename?: 'Mutation', deleteMembership?: boolean | null };

export type DeleteOrderMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteOrderMutation = { __typename?: 'Mutation', deleteOrder: boolean };

export type DeletePackageItemMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeletePackageItemMutation = { __typename?: 'Mutation', deletePackageItem?: boolean | null };

export type DeletePaymentInstrumentMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeletePaymentInstrumentMutation = { __typename?: 'Mutation', deletePaymentInstrument?: boolean | null };

export type DeleteProcedureBaseDefGroupMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteProcedureBaseDefGroupMutation = { __typename?: 'Mutation', deleteProcedureBaseDefinitionGroup?: boolean | null };

export type DeleteProcedureBaseDefinitionMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteProcedureBaseDefinitionMutation = { __typename?: 'Mutation', deleteProcedureBaseDefinition: boolean };

export type DeleteProcedureBaseDefinitionTagMutationVariables = Exact<{
  input: ProcedureBaseDefinitionTagInput;
}>;


export type DeleteProcedureBaseDefinitionTagMutation = { __typename?: 'Mutation', deleteProcedureBaseDefinitionTag: { __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null } };

export type DeleteProcedureDefinitionMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteProcedureDefinitionMutation = { __typename?: 'Mutation', deleteProcedureDefinition: boolean };

export type DeleteProcedureProfileMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteProcedureProfileMutation = { __typename?: 'Mutation', deleteProcedureProfile: boolean };

export type DeleteQualiphyExamMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteQualiphyExamMutation = { __typename?: 'Mutation', deleteQualiphyExam: boolean };

export type DeleteReportMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteReportMutation = { __typename?: 'Mutation', deleteReport: boolean };

export type DeleteRoleMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteRoleMutation = { __typename?: 'Mutation', deleteRole: boolean };

export type DeleteVitalMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteVitalMutation = { __typename?: 'Mutation', deleteVital: { __typename?: 'Patient', id: string, allergies?: string | null, archivedAt?: any | null, clientProfileId: string, conditions?: string | null, createdAt: any, emrInstanceId: string, immunizations?: string | null, labs?: string | null, medications?: string | null, procedures?: string | null, updatedAt: any } };

export type FinishPasskeyRegistrationMutationVariables = Exact<{
  input: FinishPasskeyRegistrationInput;
}>;


export type FinishPasskeyRegistrationMutation = { __typename?: 'Mutation', finishPasskeyRegistration: { __typename?: 'FinishPasskeyRegistrationPayload', recoveryCodes: Array<string>, factor: { __typename?: 'MfaFactor', id: string, label?: string | null } } };

export type GeneratePaymentLinkMutationVariables = Exact<{
  input: GeneratePaymentLinkInput;
}>;


export type GeneratePaymentLinkMutation = { __typename?: 'Mutation', generatePaymentLink: { __typename?: 'GeneratePaymentLinkPayload', success: boolean, url?: string | null, message?: string | null, checkout?: { __typename?: 'Checkout', id: string, total: number, paid: number, balance: number, marketplaceUserId?: string | null, summary?: string | null, voidedAt?: any | null, paymentMethodType?: PaymentMethodType | null, createdAt: any, updatedAt: any, appointment?: { __typename?: 'Appointment', id: string, location: string, latitude?: number | null, longitude?: number | null, start: any, end: any, duration: number, createdAt: any, updatedAt: any, archivedAt?: any | null, status: AppointmentStatus, startedAt?: any | null, completedAt?: any | null, notes?: string | null, createdBy?: string | null, cancelReason?: string | null, groupId?: string | null, ordersRequired: boolean, participants: Array<{ __typename?: 'AppointmentParticipant', id: string, name: string, type: ParticipantType, status: ParticipationStatus, profileId?: string | null, clientProfileId?: string | null, orderApproved?: boolean | null, participant?: { __typename?: 'ClientProfile', internalNotesUpdatedBy?: string | null, internalNotesUpdatedAt?: any | null, id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null, patient?: { __typename?: 'Patient', id: string, allergies?: string | null, archivedAt?: any | null, clientProfileId: string, conditions?: string | null, createdAt: any, emrInstanceId: string, immunizations?: string | null, labs?: string | null, medications?: string | null, procedures?: string | null, updatedAt: any, orders: Array<{ __typename?: 'Order', id: string, archivedAt?: any | null, createdAt: any, expiresAt: any, providerType: ProviderType, fillCount: number, note?: string | null, refills: number, startsAt: any, updatedAt: any, procedureDefs: Array<{ __typename?: 'ProcedureDefinition', id: string, name: string, description: string, price: number, duration: number, assessmentFormTemplateId?: string | null, interventionFormTemplateId?: string | null, ordersRequired: boolean, createdAt: any, intakeFormTemplates: Array<{ __typename?: 'FormTemplate', id: string, name: string }> }>, profile?: { __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null } | null, organizations: Array<{ __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null }> }>, vitals: Array<{ __typename?: 'VitalSign', id: string, createdAt: any, createdById: string, recordedAt: any, type: VitalSignType, updatedAt: any, value: string }>, signedConsentForms: Array<{ __typename?: 'DocumentSignature', id: string, signerName: string, signerEmail?: string | null, signerType: DocumentSignatureSignerType, signedAt: any, verificationType: DocumentSignatureVerificationType, verificationDetail?: string | null, tzid: string, latitude?: number | null, longitude?: number | null, documentId: string, version: number, documentLabel: string, url?: string | null, createdAt: any, updatedAt: any }>, allergyRecords: Array<{ __typename?: 'AllergyIntolerance', id: string, name: string }>, clinicalProcedureRecords: Array<{ __typename?: 'ClinicalProcedure', id: string, name: string }>, conditionRecords: Array<{ __typename?: 'Condition', id: string, name: string }>, immunizationRecords: Array<{ __typename?: 'Immunization', id: string, name: string }>, labRecords: Array<{ __typename?: 'Lab', id: string, name: string }>, medicationRecords: Array<{ __typename?: 'MedicationStatement', id: string, name: string }>, attachments?: Array<{ __typename?: 'Document', id: string, filename: string, label: string, type: DocumentType, version: number, fileSize: number, url: string, createdAt: any, updatedAt: any }> | null } | null } | { __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null } | null, responses: Array<{ __typename?: 'AppointmentResponse', id: string, start?: any | null, end?: any | null, createdAt: any, updatedAt: any }>, forms: Array<{ __typename?: 'Form', id: string, type: FormType, status: FormStatusType, patientId: string, lockedById?: string | null, editable: boolean, createdAt: any, updatedAt: any, items: Array<{ __typename?: 'FormItem', id: string, index: number, label: string, type: FormItemType, code: string, options?: string | null, createdAt: any, updatedAt: any }>, observations: Array<{ __typename?: 'Observation', id: string, code: string, value: string, note?: string | null, createdById: string, createdAt: any, updatedAt: any, createdBy?: { __typename?: 'Profile', id: string, givenName: string, familyName: string, title: string } | null }>, lockedBy?: { __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null } | null, document?: { __typename?: 'Document', id: string, filename: string, label: string, type: DocumentType, version: number, fileSize: number, url: string, createdAt: any, updatedAt: any } | null, attachments?: Array<{ __typename?: 'Document', id: string, filename: string, label: string, type: DocumentType, version: number, fileSize: number, url: string, createdAt: any, updatedAt: any }> | null, notes: Array<{ __typename?: 'FormNote', id: string, note: string, edited: boolean, profileId: string, createdAt: any, updatedAt: any, author: string }> }> }>, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }> } | null, appointmentRequest?: { __typename?: 'AppointmentRequest', id: string, location: string, latitude?: number | null, longitude?: number | null, status: AppointmentRequestStatus, bookingMode?: BookingMode | null, cancelReason?: string | null, notes?: string | null, lastResetAt?: any | null, waitlistedAt?: any | null, createdAt: any, updatedAt: any, archivedAt?: any | null, marketplace: { __typename?: 'Marketplace', id: string, name: string, groupId: string, createdAt: any, logo?: string | null, favicon?: string | null, primaryColor?: string | null, marketingSiteUrl?: string | null, gtmContainer?: string | null, gtmRequiresConsent: boolean, gtmDataTier: GtmDataTier, gtmV2Enabled: boolean, featureFlags: { __typename?: 'MarketplaceFeatureFlags', waitListEnabled?: boolean | null, acceptedPaymentMethods?: { __typename?: 'AcceptedPaymentMethods', creditCard?: boolean | null, applePay?: boolean | null } | null } }, clientProfiles: Array<{ __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null }>, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }>, constraints: Array<{ __typename?: 'AppointmentConstraint', id: string, organizations: Array<{ __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null }>, profiles: Array<{ __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null }>, timeRanges: Array<{ __typename?: 'AppointmentTimeRange', id: string, start: any, end: any }> }>, additionalPatients: Array<{ __typename?: 'AppointmentRequestPatient', id: string, clientProfile: { __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null }, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }> }> } | null, items: Array<{ __typename?: 'CheckoutItem', id: string, type: CheckoutItemType, description: string, quantity: number, price: number, key?: string | null }>, payments: Array<{ __typename?: 'Payment', id: string, type: PaymentType, status: PaymentStatus, description: string, amount: number, amountRequested: number, amountReversed?: number | null, isDeposit: boolean, createdAt: any, updatedAt: any }>, payouts: Array<{ __typename?: 'Payout', id: string, status: PayoutStatus, description: string, amount: number, amountRequested: number, amountReversed?: number | null, createdAt: any, updatedAt: any, checkoutId: string }>, paymentInstrument?: { __typename?: 'PaymentInstrument', id: string, type: PaymentInstrumentType, processor: PaymentAccountPlatform, brand?: string | null, lastFour?: string | null, expirationMonth?: number | null, expirationYear?: number | null, createdAt: any, updatedAt: any } | null, marketplaceUser?: { __typename?: 'MarketplaceUser', id: string, createdAt: any, updatedAt: any, groupId: string, membership: string, primaryInstrumentId?: string | null, email?: string | null, phone?: string | null, emailConfirmed: boolean, phoneConfirmed: boolean, emailOptIn: boolean, phoneOptIn: boolean, clientProfile?: { __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null } | null } | null, paymentLinks: Array<{ __typename?: 'PaymentLink', id: string, checkoutId: string, url: string, status: PaymentLinkStatus, amount: number, expiresAt?: any | null, createdAt: any, updatedAt: any }> } | null } };

export type GrantPackageMutationVariables = Exact<{
  input: GrantPackageInput;
}>;


export type GrantPackageMutation = { __typename?: 'Mutation', grantPackage?: Array<{ __typename?: 'PackageItem', id: string, packageItemDefinitionId: string, membershipId?: string | null, balance: number, packageName: string, totalPoints: number, groupNames: string, expiresAt?: any | null, primaryOrganizationId?: string | null }> | null };

export type JoinOrganizationMutationVariables = Exact<{
  input: JoinOrganizationInput;
}>;


export type JoinOrganizationMutation = { __typename?: 'Mutation', joinOrganization?: { __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null } | null };

export type LinkClientProfileToAccountMutationVariables = Exact<{
  input: LinkClientProfileToAccountInput;
}>;


export type LinkClientProfileToAccountMutation = { __typename?: 'Mutation', linkClientProfileToAccount: { __typename?: 'MarketplaceUser', id: string, createdAt: any, updatedAt: any, groupId: string, membership: string, primaryInstrumentId?: string | null, email?: string | null, phone?: string | null, emailConfirmed: boolean, phoneConfirmed: boolean, emailOptIn: boolean, phoneOptIn: boolean, clientProfiles: Array<{ __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null, organizations: Array<{ __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null }> }>, packageItems: Array<{ __typename?: 'PackageItem', marketplaceName: string, id: string, packageItemDefinitionId: string, membershipId?: string | null, balance: number, packageName: string, totalPoints: number, groupNames: string, expiresAt?: any | null, primaryOrganizationId?: string | null }>, memberships: Array<{ __typename?: 'Membership', marketplaceName: string, id: string, membershipDefinitionId: string, renewalDate: any, name: string, status: MembershipStatusType }>, marketplaceGroup: { __typename?: 'MarketplaceGroup', id: string, label: string, createdAt: any, messagingServiceSid?: string | null }, paymentInstruments: Array<{ __typename?: 'PaymentInstrument', id: string, type: PaymentInstrumentType, processor: PaymentAccountPlatform, brand?: string | null, lastFour?: string | null, expirationMonth?: number | null, expirationYear?: number | null, createdAt: any, updatedAt: any }>, checkouts: Array<{ __typename?: 'Checkout', id: string, total: number, paid: number, balance: number, marketplaceUserId?: string | null, summary?: string | null, voidedAt?: any | null, paymentMethodType?: PaymentMethodType | null, createdAt: any, updatedAt: any, items: Array<{ __typename?: 'CheckoutItem', id: string, type: CheckoutItemType, description: string, quantity: number, price: number, key?: string | null }>, paymentLinks: Array<{ __typename?: 'PaymentLink', id: string, checkoutId: string, url: string, status: PaymentLinkStatus, amount: number, expiresAt?: any | null, createdAt: any, updatedAt: any }> }>, appointments: Array<{ __typename?: 'Appointment', intakeStatus?: string | null, id: string, location: string, latitude?: number | null, longitude?: number | null, start: any, end: any, duration: number, createdAt: any, updatedAt: any, archivedAt?: any | null, status: AppointmentStatus, startedAt?: any | null, completedAt?: any | null, notes?: string | null, createdBy?: string | null, cancelReason?: string | null, groupId?: string | null, ordersRequired: boolean, participants: Array<{ __typename?: 'AppointmentParticipant', id: string, name: string, type: ParticipantType, status: ParticipationStatus, profileId?: string | null, clientProfileId?: string | null, orderApproved?: boolean | null }>, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }>, checkout?: { __typename?: 'Checkout', id: string, total: number, paid: number, balance: number, marketplaceUserId?: string | null, summary?: string | null, voidedAt?: any | null, paymentMethodType?: PaymentMethodType | null, createdAt: any, updatedAt: any, paymentLinks: Array<{ __typename?: 'PaymentLink', id: string, checkoutId: string, url: string, status: PaymentLinkStatus, amount: number, expiresAt?: any | null, createdAt: any, updatedAt: any }> } | null, additionalPatients: Array<{ __typename?: 'AppointmentRequestPatient', id: string, clientProfile: { __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null }, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }> }> }>, appointmentRequests: Array<{ __typename?: 'AppointmentRequest', id: string, location: string, latitude?: number | null, longitude?: number | null, status: AppointmentRequestStatus, bookingMode?: BookingMode | null, cancelReason?: string | null, notes?: string | null, lastResetAt?: any | null, waitlistedAt?: any | null, createdAt: any, updatedAt: any, archivedAt?: any | null, marketplace: { __typename?: 'Marketplace', id: string, name: string, groupId: string, createdAt: any, logo?: string | null, favicon?: string | null, primaryColor?: string | null, marketingSiteUrl?: string | null, gtmContainer?: string | null, gtmRequiresConsent: boolean, gtmDataTier: GtmDataTier, gtmV2Enabled: boolean, featureFlags: { __typename?: 'MarketplaceFeatureFlags', waitListEnabled?: boolean | null, acceptedPaymentMethods?: { __typename?: 'AcceptedPaymentMethods', creditCard?: boolean | null, applePay?: boolean | null } | null } }, clientProfiles: Array<{ __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null }>, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }>, constraints: Array<{ __typename?: 'AppointmentConstraint', id: string, organizations: Array<{ __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null }>, profiles: Array<{ __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null }>, timeRanges: Array<{ __typename?: 'AppointmentTimeRange', id: string, start: any, end: any }> }>, additionalPatients: Array<{ __typename?: 'AppointmentRequestPatient', id: string, clientProfile: { __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null }, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }> }> }>, clientProfile?: { __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null } | null } };

export type LockFormMutationVariables = Exact<{
  input: LockFormInput;
}>;


export type LockFormMutation = { __typename?: 'Mutation', lockForm: { __typename?: 'Form', id: string, type: FormType, status: FormStatusType, patientId: string, lockedById?: string | null, editable: boolean, createdAt: any, updatedAt: any, items: Array<{ __typename?: 'FormItem', id: string, index: number, label: string, type: FormItemType, code: string, options?: string | null, createdAt: any, updatedAt: any }>, observations: Array<{ __typename?: 'Observation', id: string, code: string, value: string, note?: string | null, createdById: string, createdAt: any, updatedAt: any, createdBy?: { __typename?: 'Profile', id: string, givenName: string, familyName: string, title: string } | null }>, lockedBy?: { __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null } | null, document?: { __typename?: 'Document', id: string, filename: string, label: string, type: DocumentType, version: number, fileSize: number, url: string, createdAt: any, updatedAt: any } | null, attachments?: Array<{ __typename?: 'Document', id: string, filename: string, label: string, type: DocumentType, version: number, fileSize: number, url: string, createdAt: any, updatedAt: any }> | null, notes: Array<{ __typename?: 'FormNote', id: string, note: string, edited: boolean, profileId: string, createdAt: any, updatedAt: any, author: string }> } };

export type LogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutMutation = { __typename?: 'Mutation', logout: boolean };

export type MfaAuthenticationOptionsMutationVariables = Exact<{
  challengeId?: InputMaybe<Scalars['String']>;
}>;


export type MfaAuthenticationOptionsMutation = { __typename?: 'Mutation', mfaAuthenticationOptions: any };

export type RecordCashPaymentMutationVariables = Exact<{
  input: RecordCashPaymentInput;
}>;


export type RecordCashPaymentMutation = { __typename?: 'Mutation', recordCashPayment: { __typename?: 'RecordCashPaymentPayload', success: boolean, errorMessage?: string | null, checkout: { __typename?: 'Checkout', id: string, total: number, paid: number, balance: number, marketplaceUserId?: string | null, summary?: string | null, voidedAt?: any | null, paymentMethodType?: PaymentMethodType | null, createdAt: any, updatedAt: any, appointment?: { __typename?: 'Appointment', id: string, location: string, latitude?: number | null, longitude?: number | null, start: any, end: any, duration: number, createdAt: any, updatedAt: any, archivedAt?: any | null, status: AppointmentStatus, startedAt?: any | null, completedAt?: any | null, notes?: string | null, createdBy?: string | null, cancelReason?: string | null, groupId?: string | null, ordersRequired: boolean, participants: Array<{ __typename?: 'AppointmentParticipant', id: string, name: string, type: ParticipantType, status: ParticipationStatus, profileId?: string | null, clientProfileId?: string | null, orderApproved?: boolean | null, participant?: { __typename?: 'ClientProfile', internalNotesUpdatedBy?: string | null, internalNotesUpdatedAt?: any | null, id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null, patient?: { __typename?: 'Patient', id: string, allergies?: string | null, archivedAt?: any | null, clientProfileId: string, conditions?: string | null, createdAt: any, emrInstanceId: string, immunizations?: string | null, labs?: string | null, medications?: string | null, procedures?: string | null, updatedAt: any, orders: Array<{ __typename?: 'Order', id: string, archivedAt?: any | null, createdAt: any, expiresAt: any, providerType: ProviderType, fillCount: number, note?: string | null, refills: number, startsAt: any, updatedAt: any, procedureDefs: Array<{ __typename?: 'ProcedureDefinition', id: string, name: string, description: string, price: number, duration: number, assessmentFormTemplateId?: string | null, interventionFormTemplateId?: string | null, ordersRequired: boolean, createdAt: any, intakeFormTemplates: Array<{ __typename?: 'FormTemplate', id: string, name: string }> }>, profile?: { __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null } | null, organizations: Array<{ __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null }> }>, vitals: Array<{ __typename?: 'VitalSign', id: string, createdAt: any, createdById: string, recordedAt: any, type: VitalSignType, updatedAt: any, value: string }>, signedConsentForms: Array<{ __typename?: 'DocumentSignature', id: string, signerName: string, signerEmail?: string | null, signerType: DocumentSignatureSignerType, signedAt: any, verificationType: DocumentSignatureVerificationType, verificationDetail?: string | null, tzid: string, latitude?: number | null, longitude?: number | null, documentId: string, version: number, documentLabel: string, url?: string | null, createdAt: any, updatedAt: any }>, allergyRecords: Array<{ __typename?: 'AllergyIntolerance', id: string, name: string }>, clinicalProcedureRecords: Array<{ __typename?: 'ClinicalProcedure', id: string, name: string }>, conditionRecords: Array<{ __typename?: 'Condition', id: string, name: string }>, immunizationRecords: Array<{ __typename?: 'Immunization', id: string, name: string }>, labRecords: Array<{ __typename?: 'Lab', id: string, name: string }>, medicationRecords: Array<{ __typename?: 'MedicationStatement', id: string, name: string }>, attachments?: Array<{ __typename?: 'Document', id: string, filename: string, label: string, type: DocumentType, version: number, fileSize: number, url: string, createdAt: any, updatedAt: any }> | null } | null } | { __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null } | null, responses: Array<{ __typename?: 'AppointmentResponse', id: string, start?: any | null, end?: any | null, createdAt: any, updatedAt: any }>, forms: Array<{ __typename?: 'Form', id: string, type: FormType, status: FormStatusType, patientId: string, lockedById?: string | null, editable: boolean, createdAt: any, updatedAt: any, items: Array<{ __typename?: 'FormItem', id: string, index: number, label: string, type: FormItemType, code: string, options?: string | null, createdAt: any, updatedAt: any }>, observations: Array<{ __typename?: 'Observation', id: string, code: string, value: string, note?: string | null, createdById: string, createdAt: any, updatedAt: any, createdBy?: { __typename?: 'Profile', id: string, givenName: string, familyName: string, title: string } | null }>, lockedBy?: { __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null } | null, document?: { __typename?: 'Document', id: string, filename: string, label: string, type: DocumentType, version: number, fileSize: number, url: string, createdAt: any, updatedAt: any } | null, attachments?: Array<{ __typename?: 'Document', id: string, filename: string, label: string, type: DocumentType, version: number, fileSize: number, url: string, createdAt: any, updatedAt: any }> | null, notes: Array<{ __typename?: 'FormNote', id: string, note: string, edited: boolean, profileId: string, createdAt: any, updatedAt: any, author: string }> }> }>, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }> } | null, appointmentRequest?: { __typename?: 'AppointmentRequest', id: string, location: string, latitude?: number | null, longitude?: number | null, status: AppointmentRequestStatus, bookingMode?: BookingMode | null, cancelReason?: string | null, notes?: string | null, lastResetAt?: any | null, waitlistedAt?: any | null, createdAt: any, updatedAt: any, archivedAt?: any | null, marketplace: { __typename?: 'Marketplace', id: string, name: string, groupId: string, createdAt: any, logo?: string | null, favicon?: string | null, primaryColor?: string | null, marketingSiteUrl?: string | null, gtmContainer?: string | null, gtmRequiresConsent: boolean, gtmDataTier: GtmDataTier, gtmV2Enabled: boolean, featureFlags: { __typename?: 'MarketplaceFeatureFlags', waitListEnabled?: boolean | null, acceptedPaymentMethods?: { __typename?: 'AcceptedPaymentMethods', creditCard?: boolean | null, applePay?: boolean | null } | null } }, clientProfiles: Array<{ __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null }>, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }>, constraints: Array<{ __typename?: 'AppointmentConstraint', id: string, organizations: Array<{ __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null }>, profiles: Array<{ __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null }>, timeRanges: Array<{ __typename?: 'AppointmentTimeRange', id: string, start: any, end: any }> }>, additionalPatients: Array<{ __typename?: 'AppointmentRequestPatient', id: string, clientProfile: { __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null }, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }> }> } | null, items: Array<{ __typename?: 'CheckoutItem', id: string, type: CheckoutItemType, description: string, quantity: number, price: number, key?: string | null }>, payments: Array<{ __typename?: 'Payment', id: string, type: PaymentType, status: PaymentStatus, description: string, amount: number, amountRequested: number, amountReversed?: number | null, isDeposit: boolean, createdAt: any, updatedAt: any }>, payouts: Array<{ __typename?: 'Payout', id: string, status: PayoutStatus, description: string, amount: number, amountRequested: number, amountReversed?: number | null, createdAt: any, updatedAt: any, checkoutId: string }>, paymentInstrument?: { __typename?: 'PaymentInstrument', id: string, type: PaymentInstrumentType, processor: PaymentAccountPlatform, brand?: string | null, lastFour?: string | null, expirationMonth?: number | null, expirationYear?: number | null, createdAt: any, updatedAt: any } | null, marketplaceUser?: { __typename?: 'MarketplaceUser', id: string, createdAt: any, updatedAt: any, groupId: string, membership: string, primaryInstrumentId?: string | null, email?: string | null, phone?: string | null, emailConfirmed: boolean, phoneConfirmed: boolean, emailOptIn: boolean, phoneOptIn: boolean, clientProfile?: { __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null } | null } | null, paymentLinks: Array<{ __typename?: 'PaymentLink', id: string, checkoutId: string, url: string, status: PaymentLinkStatus, amount: number, expiresAt?: any | null, createdAt: any, updatedAt: any }> } } };

export type RefundCheckoutMutationVariables = Exact<{
  input: RefundCheckoutInput;
}>;


export type RefundCheckoutMutation = { __typename?: 'Mutation', refundCheckout: { __typename?: 'Checkout', id: string, total: number, paid: number, balance: number, marketplaceUserId?: string | null, summary?: string | null, voidedAt?: any | null, paymentMethodType?: PaymentMethodType | null, createdAt: any, updatedAt: any, appointment?: { __typename?: 'Appointment', id: string, location: string, latitude?: number | null, longitude?: number | null, start: any, end: any, duration: number, createdAt: any, updatedAt: any, archivedAt?: any | null, status: AppointmentStatus, startedAt?: any | null, completedAt?: any | null, notes?: string | null, createdBy?: string | null, cancelReason?: string | null, groupId?: string | null, ordersRequired: boolean, participants: Array<{ __typename?: 'AppointmentParticipant', id: string, name: string, type: ParticipantType, status: ParticipationStatus, profileId?: string | null, clientProfileId?: string | null, orderApproved?: boolean | null, participant?: { __typename?: 'ClientProfile', internalNotesUpdatedBy?: string | null, internalNotesUpdatedAt?: any | null, id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null, patient?: { __typename?: 'Patient', id: string, allergies?: string | null, archivedAt?: any | null, clientProfileId: string, conditions?: string | null, createdAt: any, emrInstanceId: string, immunizations?: string | null, labs?: string | null, medications?: string | null, procedures?: string | null, updatedAt: any, orders: Array<{ __typename?: 'Order', id: string, archivedAt?: any | null, createdAt: any, expiresAt: any, providerType: ProviderType, fillCount: number, note?: string | null, refills: number, startsAt: any, updatedAt: any, procedureDefs: Array<{ __typename?: 'ProcedureDefinition', id: string, name: string, description: string, price: number, duration: number, assessmentFormTemplateId?: string | null, interventionFormTemplateId?: string | null, ordersRequired: boolean, createdAt: any, intakeFormTemplates: Array<{ __typename?: 'FormTemplate', id: string, name: string }> }>, profile?: { __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null } | null, organizations: Array<{ __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null }> }>, vitals: Array<{ __typename?: 'VitalSign', id: string, createdAt: any, createdById: string, recordedAt: any, type: VitalSignType, updatedAt: any, value: string }>, signedConsentForms: Array<{ __typename?: 'DocumentSignature', id: string, signerName: string, signerEmail?: string | null, signerType: DocumentSignatureSignerType, signedAt: any, verificationType: DocumentSignatureVerificationType, verificationDetail?: string | null, tzid: string, latitude?: number | null, longitude?: number | null, documentId: string, version: number, documentLabel: string, url?: string | null, createdAt: any, updatedAt: any }>, allergyRecords: Array<{ __typename?: 'AllergyIntolerance', id: string, name: string }>, clinicalProcedureRecords: Array<{ __typename?: 'ClinicalProcedure', id: string, name: string }>, conditionRecords: Array<{ __typename?: 'Condition', id: string, name: string }>, immunizationRecords: Array<{ __typename?: 'Immunization', id: string, name: string }>, labRecords: Array<{ __typename?: 'Lab', id: string, name: string }>, medicationRecords: Array<{ __typename?: 'MedicationStatement', id: string, name: string }>, attachments?: Array<{ __typename?: 'Document', id: string, filename: string, label: string, type: DocumentType, version: number, fileSize: number, url: string, createdAt: any, updatedAt: any }> | null } | null } | { __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null } | null, responses: Array<{ __typename?: 'AppointmentResponse', id: string, start?: any | null, end?: any | null, createdAt: any, updatedAt: any }>, forms: Array<{ __typename?: 'Form', id: string, type: FormType, status: FormStatusType, patientId: string, lockedById?: string | null, editable: boolean, createdAt: any, updatedAt: any, items: Array<{ __typename?: 'FormItem', id: string, index: number, label: string, type: FormItemType, code: string, options?: string | null, createdAt: any, updatedAt: any }>, observations: Array<{ __typename?: 'Observation', id: string, code: string, value: string, note?: string | null, createdById: string, createdAt: any, updatedAt: any, createdBy?: { __typename?: 'Profile', id: string, givenName: string, familyName: string, title: string } | null }>, lockedBy?: { __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null } | null, document?: { __typename?: 'Document', id: string, filename: string, label: string, type: DocumentType, version: number, fileSize: number, url: string, createdAt: any, updatedAt: any } | null, attachments?: Array<{ __typename?: 'Document', id: string, filename: string, label: string, type: DocumentType, version: number, fileSize: number, url: string, createdAt: any, updatedAt: any }> | null, notes: Array<{ __typename?: 'FormNote', id: string, note: string, edited: boolean, profileId: string, createdAt: any, updatedAt: any, author: string }> }> }>, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }> } | null, appointmentRequest?: { __typename?: 'AppointmentRequest', id: string, location: string, latitude?: number | null, longitude?: number | null, status: AppointmentRequestStatus, bookingMode?: BookingMode | null, cancelReason?: string | null, notes?: string | null, lastResetAt?: any | null, waitlistedAt?: any | null, createdAt: any, updatedAt: any, archivedAt?: any | null, marketplace: { __typename?: 'Marketplace', id: string, name: string, groupId: string, createdAt: any, logo?: string | null, favicon?: string | null, primaryColor?: string | null, marketingSiteUrl?: string | null, gtmContainer?: string | null, gtmRequiresConsent: boolean, gtmDataTier: GtmDataTier, gtmV2Enabled: boolean, featureFlags: { __typename?: 'MarketplaceFeatureFlags', waitListEnabled?: boolean | null, acceptedPaymentMethods?: { __typename?: 'AcceptedPaymentMethods', creditCard?: boolean | null, applePay?: boolean | null } | null } }, clientProfiles: Array<{ __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null }>, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }>, constraints: Array<{ __typename?: 'AppointmentConstraint', id: string, organizations: Array<{ __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null }>, profiles: Array<{ __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null }>, timeRanges: Array<{ __typename?: 'AppointmentTimeRange', id: string, start: any, end: any }> }>, additionalPatients: Array<{ __typename?: 'AppointmentRequestPatient', id: string, clientProfile: { __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null }, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }> }> } | null, items: Array<{ __typename?: 'CheckoutItem', id: string, type: CheckoutItemType, description: string, quantity: number, price: number, key?: string | null }>, payments: Array<{ __typename?: 'Payment', id: string, type: PaymentType, status: PaymentStatus, description: string, amount: number, amountRequested: number, amountReversed?: number | null, isDeposit: boolean, createdAt: any, updatedAt: any }>, payouts: Array<{ __typename?: 'Payout', id: string, status: PayoutStatus, description: string, amount: number, amountRequested: number, amountReversed?: number | null, createdAt: any, updatedAt: any, checkoutId: string }>, paymentInstrument?: { __typename?: 'PaymentInstrument', id: string, type: PaymentInstrumentType, processor: PaymentAccountPlatform, brand?: string | null, lastFour?: string | null, expirationMonth?: number | null, expirationYear?: number | null, createdAt: any, updatedAt: any } | null, marketplaceUser?: { __typename?: 'MarketplaceUser', id: string, createdAt: any, updatedAt: any, groupId: string, membership: string, primaryInstrumentId?: string | null, email?: string | null, phone?: string | null, emailConfirmed: boolean, phoneConfirmed: boolean, emailOptIn: boolean, phoneOptIn: boolean, clientProfile?: { __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null } | null } | null, paymentLinks: Array<{ __typename?: 'PaymentLink', id: string, checkoutId: string, url: string, status: PaymentLinkStatus, amount: number, expiresAt?: any | null, createdAt: any, updatedAt: any }> } };

export type RegenerateRecoveryCodesMutationVariables = Exact<{ [key: string]: never; }>;


export type RegenerateRecoveryCodesMutation = { __typename?: 'Mutation', regenerateRecoveryCodes: Array<string> };

export type RegisterMutationVariables = Exact<{
  email: Scalars['String'];
  password: Scalars['String'];
  code: Scalars['String'];
}>;


export type RegisterMutation = { __typename?: 'Mutation', register: { __typename?: 'AuthenticatePayload', user: { __typename?: 'User', id: string, email: string, profiles: Array<{ __typename?: 'Profile', id: string, pid: string }> } } };

export type RemoveMfaFactorMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RemoveMfaFactorMutation = { __typename?: 'Mutation', removeMfaFactor: boolean };

export type RemoveOrganizationsFromMarketplaceMutationVariables = Exact<{
  input: RemoveOrganizationsFromMarketplaceInput;
}>;


export type RemoveOrganizationsFromMarketplaceMutation = { __typename?: 'Mutation', removeOrganizationsFromMarketplace: boolean };

export type ReportAppointmentsMutationVariables = Exact<{
  input: ReportAppointmentsInput;
}>;


export type ReportAppointmentsMutation = { __typename?: 'Mutation', reportAppointments: { __typename?: 'Report', id: string, type: ReportType, filename?: string | null, status: ReportStatus, organizationId: string, userId: string, createdAt: any, updatedAt: any, downloadUrl: string } };

export type ReportPersonnelMutationVariables = Exact<{
  input: ReportPersonnelInput;
}>;


export type ReportPersonnelMutation = { __typename?: 'Mutation', reportPersonnel: { __typename?: 'Report', id: string, type: ReportType, filename?: string | null, status: ReportStatus, organizationId: string, userId: string, createdAt: any, updatedAt: any, downloadUrl: string } };

export type RequestChangeEmailMutationVariables = Exact<{
  newEmail: Scalars['String'];
}>;


export type RequestChangeEmailMutation = { __typename?: 'Mutation', requestChangeEmail: boolean };

export type RequestResetPasswordMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type RequestResetPasswordMutation = { __typename?: 'Mutation', requestResetPassword: boolean };

export type ResendQualiphyExamInviteMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type ResendQualiphyExamInviteMutation = { __typename?: 'Mutation', resendQualiphyExamInvite: { __typename?: 'QualiphyInvitation', id: string, expiration: any, meetingUrl?: string | null, exams?: Array<{ __typename?: 'QualiphyExam', id: string, title: string, status?: QualiphyInvitationStatus | null }> | null } };

export type ResetAppointmentMutationVariables = Exact<{
  input: ResetAppointmentInput;
}>;


export type ResetAppointmentMutation = { __typename?: 'Mutation', resetAppointment?: { __typename?: 'Appointment', id: string, location: string, latitude?: number | null, longitude?: number | null, start: any, end: any, duration: number, createdAt: any, updatedAt: any, archivedAt?: any | null, status: AppointmentStatus, startedAt?: any | null, completedAt?: any | null, notes?: string | null, createdBy?: string | null, cancelReason?: string | null, groupId?: string | null, ordersRequired: boolean, participants: Array<{ __typename?: 'AppointmentParticipant', id: string, name: string, type: ParticipantType, status: ParticipationStatus, profileId?: string | null, clientProfileId?: string | null, orderApproved?: boolean | null, participant?: { __typename?: 'ClientProfile', internalNotesUpdatedBy?: string | null, internalNotesUpdatedAt?: any | null, id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null, patient?: { __typename?: 'Patient', id: string, allergies?: string | null, archivedAt?: any | null, clientProfileId: string, conditions?: string | null, createdAt: any, emrInstanceId: string, immunizations?: string | null, labs?: string | null, medications?: string | null, procedures?: string | null, updatedAt: any, orders: Array<{ __typename?: 'Order', id: string, archivedAt?: any | null, createdAt: any, expiresAt: any, providerType: ProviderType, fillCount: number, note?: string | null, refills: number, startsAt: any, updatedAt: any, procedureDefs: Array<{ __typename?: 'ProcedureDefinition', id: string, name: string, description: string, price: number, duration: number, assessmentFormTemplateId?: string | null, interventionFormTemplateId?: string | null, ordersRequired: boolean, createdAt: any, intakeFormTemplates: Array<{ __typename?: 'FormTemplate', id: string, name: string }> }>, profile?: { __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null } | null, organizations: Array<{ __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null }> }>, vitals: Array<{ __typename?: 'VitalSign', id: string, createdAt: any, createdById: string, recordedAt: any, type: VitalSignType, updatedAt: any, value: string }>, signedConsentForms: Array<{ __typename?: 'DocumentSignature', id: string, signerName: string, signerEmail?: string | null, signerType: DocumentSignatureSignerType, signedAt: any, verificationType: DocumentSignatureVerificationType, verificationDetail?: string | null, tzid: string, latitude?: number | null, longitude?: number | null, documentId: string, version: number, documentLabel: string, url?: string | null, createdAt: any, updatedAt: any }>, allergyRecords: Array<{ __typename?: 'AllergyIntolerance', id: string, name: string }>, clinicalProcedureRecords: Array<{ __typename?: 'ClinicalProcedure', id: string, name: string }>, conditionRecords: Array<{ __typename?: 'Condition', id: string, name: string }>, immunizationRecords: Array<{ __typename?: 'Immunization', id: string, name: string }>, labRecords: Array<{ __typename?: 'Lab', id: string, name: string }>, medicationRecords: Array<{ __typename?: 'MedicationStatement', id: string, name: string }>, attachments?: Array<{ __typename?: 'Document', id: string, filename: string, label: string, type: DocumentType, version: number, fileSize: number, url: string, createdAt: any, updatedAt: any }> | null } | null } | { __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null } | null, responses: Array<{ __typename?: 'AppointmentResponse', id: string, start?: any | null, end?: any | null, createdAt: any, updatedAt: any }>, forms: Array<{ __typename?: 'Form', id: string, type: FormType, status: FormStatusType, patientId: string, lockedById?: string | null, editable: boolean, createdAt: any, updatedAt: any, items: Array<{ __typename?: 'FormItem', id: string, index: number, label: string, type: FormItemType, code: string, options?: string | null, createdAt: any, updatedAt: any }>, observations: Array<{ __typename?: 'Observation', id: string, code: string, value: string, note?: string | null, createdById: string, createdAt: any, updatedAt: any, createdBy?: { __typename?: 'Profile', id: string, givenName: string, familyName: string, title: string } | null }>, lockedBy?: { __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null } | null, document?: { __typename?: 'Document', id: string, filename: string, label: string, type: DocumentType, version: number, fileSize: number, url: string, createdAt: any, updatedAt: any } | null, attachments?: Array<{ __typename?: 'Document', id: string, filename: string, label: string, type: DocumentType, version: number, fileSize: number, url: string, createdAt: any, updatedAt: any }> | null, notes: Array<{ __typename?: 'FormNote', id: string, note: string, edited: boolean, profileId: string, createdAt: any, updatedAt: any, author: string }> }> }>, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }>, checkout?: { __typename?: 'Checkout', id: string, total: number, paid: number, balance: number, marketplaceUserId?: string | null, summary?: string | null, voidedAt?: any | null, paymentMethodType?: PaymentMethodType | null, createdAt: any, updatedAt: any, items: Array<{ __typename?: 'CheckoutItem', id: string, type: CheckoutItemType, description: string, quantity: number, price: number, key?: string | null }>, payments: Array<{ __typename?: 'Payment', id: string, type: PaymentType, status: PaymentStatus, description: string, amount: number, amountRequested: number, amountReversed?: number | null, isDeposit: boolean, createdAt: any, updatedAt: any }>, payouts: Array<{ __typename?: 'Payout', id: string, status: PayoutStatus, description: string, amount: number, amountRequested: number, amountReversed?: number | null, createdAt: any, updatedAt: any, checkoutId: string }>, paymentInstrument?: { __typename?: 'PaymentInstrument', id: string, type: PaymentInstrumentType, processor: PaymentAccountPlatform, brand?: string | null, lastFour?: string | null, expirationMonth?: number | null, expirationYear?: number | null, createdAt: any, updatedAt: any } | null, marketplaceUser?: { __typename?: 'MarketplaceUser', id: string, createdAt: any, updatedAt: any, groupId: string, membership: string, primaryInstrumentId?: string | null, email?: string | null, phone?: string | null, emailConfirmed: boolean, phoneConfirmed: boolean, emailOptIn: boolean, phoneOptIn: boolean, clientProfile?: { __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null } | null } | null, paymentLinks: Array<{ __typename?: 'PaymentLink', id: string, checkoutId: string, url: string, status: PaymentLinkStatus, amount: number, expiresAt?: any | null, createdAt: any, updatedAt: any }> } | null, qualiphyInvitation?: { __typename?: 'QualiphyInvitation', id: string, expiration: any, meetingUrl?: string | null, exams?: Array<{ __typename?: 'QualiphyExam', id: string, title: string, status?: QualiphyInvitationStatus | null }> | null } | null, additionalPatients: Array<{ __typename?: 'AppointmentRequestPatient', id: string, clientProfile: { __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null }, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }> }> } | null };

export type ResetAppointmentRequestMutationVariables = Exact<{
  input: ResetAppointmentRequestInput;
}>;


export type ResetAppointmentRequestMutation = { __typename?: 'Mutation', resetAppointmentRequest?: { __typename?: 'AppointmentRequest', id: string, location: string, latitude?: number | null, longitude?: number | null, status: AppointmentRequestStatus, bookingMode?: BookingMode | null, cancelReason?: string | null, notes?: string | null, lastResetAt?: any | null, waitlistedAt?: any | null, createdAt: any, updatedAt: any, archivedAt?: any | null, declinedProfiles: Array<{ __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null }>, clientProfiles: Array<{ __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null, marketplaceUsers: Array<{ __typename?: 'MarketplaceUser', marketplaceIds: Array<string>, id: string, createdAt: any, updatedAt: any, groupId: string, membership: string, primaryInstrumentId?: string | null, email?: string | null, phone?: string | null, emailConfirmed: boolean, phoneConfirmed: boolean, emailOptIn: boolean, phoneOptIn: boolean, memberships: Array<{ __typename?: 'Membership', marketplaceName: string, id: string, membershipDefinitionId: string, renewalDate: any, name: string, status: MembershipStatusType }>, packageItems: Array<{ __typename?: 'PackageItem', marketplaceName: string, id: string, packageItemDefinitionId: string, membershipId?: string | null, balance: number, packageName: string, totalPoints: number, groupNames: string, expiresAt?: any | null, primaryOrganizationId?: string | null }>, clientProfiles: Array<{ __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null, organizations: Array<{ __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null }> }>, marketplaceGroup: { __typename?: 'MarketplaceGroup', id: string, label: string, createdAt: any, messagingServiceSid?: string | null }, paymentInstruments: Array<{ __typename?: 'PaymentInstrument', id: string, type: PaymentInstrumentType, processor: PaymentAccountPlatform, brand?: string | null, lastFour?: string | null, expirationMonth?: number | null, expirationYear?: number | null, createdAt: any, updatedAt: any }>, checkouts: Array<{ __typename?: 'Checkout', id: string, total: number, paid: number, balance: number, marketplaceUserId?: string | null, summary?: string | null, voidedAt?: any | null, paymentMethodType?: PaymentMethodType | null, createdAt: any, updatedAt: any, items: Array<{ __typename?: 'CheckoutItem', id: string, type: CheckoutItemType, description: string, quantity: number, price: number, key?: string | null }>, paymentLinks: Array<{ __typename?: 'PaymentLink', id: string, checkoutId: string, url: string, status: PaymentLinkStatus, amount: number, expiresAt?: any | null, createdAt: any, updatedAt: any }> }>, appointments: Array<{ __typename?: 'Appointment', intakeStatus?: string | null, id: string, location: string, latitude?: number | null, longitude?: number | null, start: any, end: any, duration: number, createdAt: any, updatedAt: any, archivedAt?: any | null, status: AppointmentStatus, startedAt?: any | null, completedAt?: any | null, notes?: string | null, createdBy?: string | null, cancelReason?: string | null, groupId?: string | null, ordersRequired: boolean, participants: Array<{ __typename?: 'AppointmentParticipant', id: string, name: string, type: ParticipantType, status: ParticipationStatus, profileId?: string | null, clientProfileId?: string | null, orderApproved?: boolean | null }>, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }>, checkout?: { __typename?: 'Checkout', id: string, total: number, paid: number, balance: number, marketplaceUserId?: string | null, summary?: string | null, voidedAt?: any | null, paymentMethodType?: PaymentMethodType | null, createdAt: any, updatedAt: any, paymentLinks: Array<{ __typename?: 'PaymentLink', id: string, checkoutId: string, url: string, status: PaymentLinkStatus, amount: number, expiresAt?: any | null, createdAt: any, updatedAt: any }> } | null, additionalPatients: Array<{ __typename?: 'AppointmentRequestPatient', id: string, clientProfile: { __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null }, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }> }> }>, appointmentRequests: Array<{ __typename?: 'AppointmentRequest', id: string, location: string, latitude?: number | null, longitude?: number | null, status: AppointmentRequestStatus, bookingMode?: BookingMode | null, cancelReason?: string | null, notes?: string | null, lastResetAt?: any | null, waitlistedAt?: any | null, createdAt: any, updatedAt: any, archivedAt?: any | null, marketplace: { __typename?: 'Marketplace', id: string, name: string, groupId: string, createdAt: any, logo?: string | null, favicon?: string | null, primaryColor?: string | null, marketingSiteUrl?: string | null, gtmContainer?: string | null, gtmRequiresConsent: boolean, gtmDataTier: GtmDataTier, gtmV2Enabled: boolean, featureFlags: { __typename?: 'MarketplaceFeatureFlags', waitListEnabled?: boolean | null, acceptedPaymentMethods?: { __typename?: 'AcceptedPaymentMethods', creditCard?: boolean | null, applePay?: boolean | null } | null } }, clientProfiles: Array<{ __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null }>, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }>, constraints: Array<{ __typename?: 'AppointmentConstraint', id: string, organizations: Array<{ __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null }>, profiles: Array<{ __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null }>, timeRanges: Array<{ __typename?: 'AppointmentTimeRange', id: string, start: any, end: any }> }>, additionalPatients: Array<{ __typename?: 'AppointmentRequestPatient', id: string, clientProfile: { __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null }, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }> }> }>, clientProfile?: { __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null } | null }> }>, checkout?: { __typename?: 'Checkout', id: string, total: number, paid: number, balance: number, marketplaceUserId?: string | null, summary?: string | null, voidedAt?: any | null, paymentMethodType?: PaymentMethodType | null, createdAt: any, updatedAt: any, items: Array<{ __typename?: 'CheckoutItem', id: string, type: CheckoutItemType, description: string, quantity: number, price: number, key?: string | null }>, payments: Array<{ __typename?: 'Payment', id: string, type: PaymentType, status: PaymentStatus, description: string, amount: number, amountRequested: number, amountReversed?: number | null, isDeposit: boolean, createdAt: any, updatedAt: any }>, payouts: Array<{ __typename?: 'Payout', id: string, status: PayoutStatus, description: string, amount: number, amountRequested: number, amountReversed?: number | null, createdAt: any, updatedAt: any, checkoutId: string }>, paymentInstrument?: { __typename?: 'PaymentInstrument', id: string, type: PaymentInstrumentType, processor: PaymentAccountPlatform, brand?: string | null, lastFour?: string | null, expirationMonth?: number | null, expirationYear?: number | null, createdAt: any, updatedAt: any } | null, marketplaceUser?: { __typename?: 'MarketplaceUser', id: string, createdAt: any, updatedAt: any, groupId: string, membership: string, primaryInstrumentId?: string | null, email?: string | null, phone?: string | null, emailConfirmed: boolean, phoneConfirmed: boolean, emailOptIn: boolean, phoneOptIn: boolean, clientProfile?: { __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null } | null } | null, paymentLinks: Array<{ __typename?: 'PaymentLink', id: string, checkoutId: string, url: string, status: PaymentLinkStatus, amount: number, expiresAt?: any | null, createdAt: any, updatedAt: any }> } | null, marketplace: { __typename?: 'Marketplace', id: string, name: string, groupId: string, createdAt: any, logo?: string | null, favicon?: string | null, primaryColor?: string | null, marketingSiteUrl?: string | null, gtmContainer?: string | null, gtmRequiresConsent: boolean, gtmDataTier: GtmDataTier, gtmV2Enabled: boolean, featureFlags: { __typename?: 'MarketplaceFeatureFlags', waitListEnabled?: boolean | null, acceptedPaymentMethods?: { __typename?: 'AcceptedPaymentMethods', creditCard?: boolean | null, applePay?: boolean | null } | null } }, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }>, constraints: Array<{ __typename?: 'AppointmentConstraint', id: string, organizations: Array<{ __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null }>, profiles: Array<{ __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null }>, timeRanges: Array<{ __typename?: 'AppointmentTimeRange', id: string, start: any, end: any }> }>, additionalPatients: Array<{ __typename?: 'AppointmentRequestPatient', id: string, clientProfile: { __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null }, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }> }> } | null };

export type ResetPasswordMutationVariables = Exact<{
  input: ResetPasswordInput;
}>;


export type ResetPasswordMutation = { __typename?: 'Mutation', resetPassword: boolean };

export type ResetUserMfaMutationVariables = Exact<{
  input: ResetUserMfaInput;
}>;


export type ResetUserMfaMutation = { __typename?: 'Mutation', resetUserMfa: { __typename?: 'ResetUserMfaPayload', factorsRemoved: number, sessionsEnded: number, graceUntil?: any | null } };

export type RevokeApiKeyMutationVariables = Exact<{
  kid: Scalars['String'];
}>;


export type RevokeApiKeyMutation = { __typename?: 'Mutation', revokeApiKey: boolean };

export type RevokeTrustedDeviceMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RevokeTrustedDeviceMutation = { __typename?: 'Mutation', revokeTrustedDevice: boolean };

export type SendIntakeFormMutationVariables = Exact<{
  appointmentId: Scalars['ID'];
  formTemplateIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  deliveryMethods?: InputMaybe<SendIntakeFormDeliveryInput>;
}>;


export type SendIntakeFormMutation = { __typename?: 'Mutation', sendIntakeForm: { __typename?: 'SendIntakeFormResult', submissions: Array<{ __typename?: 'IntakeSubmission', id: string, status: IntakeSubmissionStatus }>, sms?: { __typename?: 'IntakeChannelOutcome', sent: boolean, destination?: string | null, error?: string | null } | null, email?: { __typename?: 'IntakeChannelOutcome', sent: boolean, destination?: string | null, error?: string | null } | null } };

export type SendPaymentLinkMutationVariables = Exact<{
  input: SendPaymentLinkInput;
}>;


export type SendPaymentLinkMutation = { __typename?: 'Mutation', sendPaymentLink: { __typename?: 'GeneratePaymentLinkPayload', success: boolean, url?: string | null, message?: string | null, checkout?: { __typename?: 'Checkout', id: string, total: number, paid: number, balance: number, marketplaceUserId?: string | null, summary?: string | null, voidedAt?: any | null, paymentMethodType?: PaymentMethodType | null, createdAt: any, updatedAt: any, appointment?: { __typename?: 'Appointment', id: string, location: string, latitude?: number | null, longitude?: number | null, start: any, end: any, duration: number, createdAt: any, updatedAt: any, archivedAt?: any | null, status: AppointmentStatus, startedAt?: any | null, completedAt?: any | null, notes?: string | null, createdBy?: string | null, cancelReason?: string | null, groupId?: string | null, ordersRequired: boolean, participants: Array<{ __typename?: 'AppointmentParticipant', id: string, name: string, type: ParticipantType, status: ParticipationStatus, profileId?: string | null, clientProfileId?: string | null, orderApproved?: boolean | null, participant?: { __typename?: 'ClientProfile', internalNotesUpdatedBy?: string | null, internalNotesUpdatedAt?: any | null, id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null, patient?: { __typename?: 'Patient', id: string, allergies?: string | null, archivedAt?: any | null, clientProfileId: string, conditions?: string | null, createdAt: any, emrInstanceId: string, immunizations?: string | null, labs?: string | null, medications?: string | null, procedures?: string | null, updatedAt: any, orders: Array<{ __typename?: 'Order', id: string, archivedAt?: any | null, createdAt: any, expiresAt: any, providerType: ProviderType, fillCount: number, note?: string | null, refills: number, startsAt: any, updatedAt: any, procedureDefs: Array<{ __typename?: 'ProcedureDefinition', id: string, name: string, description: string, price: number, duration: number, assessmentFormTemplateId?: string | null, interventionFormTemplateId?: string | null, ordersRequired: boolean, createdAt: any, intakeFormTemplates: Array<{ __typename?: 'FormTemplate', id: string, name: string }> }>, profile?: { __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null } | null, organizations: Array<{ __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null }> }>, vitals: Array<{ __typename?: 'VitalSign', id: string, createdAt: any, createdById: string, recordedAt: any, type: VitalSignType, updatedAt: any, value: string }>, signedConsentForms: Array<{ __typename?: 'DocumentSignature', id: string, signerName: string, signerEmail?: string | null, signerType: DocumentSignatureSignerType, signedAt: any, verificationType: DocumentSignatureVerificationType, verificationDetail?: string | null, tzid: string, latitude?: number | null, longitude?: number | null, documentId: string, version: number, documentLabel: string, url?: string | null, createdAt: any, updatedAt: any }>, allergyRecords: Array<{ __typename?: 'AllergyIntolerance', id: string, name: string }>, clinicalProcedureRecords: Array<{ __typename?: 'ClinicalProcedure', id: string, name: string }>, conditionRecords: Array<{ __typename?: 'Condition', id: string, name: string }>, immunizationRecords: Array<{ __typename?: 'Immunization', id: string, name: string }>, labRecords: Array<{ __typename?: 'Lab', id: string, name: string }>, medicationRecords: Array<{ __typename?: 'MedicationStatement', id: string, name: string }>, attachments?: Array<{ __typename?: 'Document', id: string, filename: string, label: string, type: DocumentType, version: number, fileSize: number, url: string, createdAt: any, updatedAt: any }> | null } | null } | { __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null } | null, responses: Array<{ __typename?: 'AppointmentResponse', id: string, start?: any | null, end?: any | null, createdAt: any, updatedAt: any }>, forms: Array<{ __typename?: 'Form', id: string, type: FormType, status: FormStatusType, patientId: string, lockedById?: string | null, editable: boolean, createdAt: any, updatedAt: any, items: Array<{ __typename?: 'FormItem', id: string, index: number, label: string, type: FormItemType, code: string, options?: string | null, createdAt: any, updatedAt: any }>, observations: Array<{ __typename?: 'Observation', id: string, code: string, value: string, note?: string | null, createdById: string, createdAt: any, updatedAt: any, createdBy?: { __typename?: 'Profile', id: string, givenName: string, familyName: string, title: string } | null }>, lockedBy?: { __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null } | null, document?: { __typename?: 'Document', id: string, filename: string, label: string, type: DocumentType, version: number, fileSize: number, url: string, createdAt: any, updatedAt: any } | null, attachments?: Array<{ __typename?: 'Document', id: string, filename: string, label: string, type: DocumentType, version: number, fileSize: number, url: string, createdAt: any, updatedAt: any }> | null, notes: Array<{ __typename?: 'FormNote', id: string, note: string, edited: boolean, profileId: string, createdAt: any, updatedAt: any, author: string }> }> }>, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }> } | null, appointmentRequest?: { __typename?: 'AppointmentRequest', id: string, location: string, latitude?: number | null, longitude?: number | null, status: AppointmentRequestStatus, bookingMode?: BookingMode | null, cancelReason?: string | null, notes?: string | null, lastResetAt?: any | null, waitlistedAt?: any | null, createdAt: any, updatedAt: any, archivedAt?: any | null, marketplace: { __typename?: 'Marketplace', id: string, name: string, groupId: string, createdAt: any, logo?: string | null, favicon?: string | null, primaryColor?: string | null, marketingSiteUrl?: string | null, gtmContainer?: string | null, gtmRequiresConsent: boolean, gtmDataTier: GtmDataTier, gtmV2Enabled: boolean, featureFlags: { __typename?: 'MarketplaceFeatureFlags', waitListEnabled?: boolean | null, acceptedPaymentMethods?: { __typename?: 'AcceptedPaymentMethods', creditCard?: boolean | null, applePay?: boolean | null } | null } }, clientProfiles: Array<{ __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null }>, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }>, constraints: Array<{ __typename?: 'AppointmentConstraint', id: string, organizations: Array<{ __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null }>, profiles: Array<{ __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null }>, timeRanges: Array<{ __typename?: 'AppointmentTimeRange', id: string, start: any, end: any }> }>, additionalPatients: Array<{ __typename?: 'AppointmentRequestPatient', id: string, clientProfile: { __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null }, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }> }> } | null, items: Array<{ __typename?: 'CheckoutItem', id: string, type: CheckoutItemType, description: string, quantity: number, price: number, key?: string | null }>, payments: Array<{ __typename?: 'Payment', id: string, type: PaymentType, status: PaymentStatus, description: string, amount: number, amountRequested: number, amountReversed?: number | null, isDeposit: boolean, createdAt: any, updatedAt: any }>, payouts: Array<{ __typename?: 'Payout', id: string, status: PayoutStatus, description: string, amount: number, amountRequested: number, amountReversed?: number | null, createdAt: any, updatedAt: any, checkoutId: string }>, paymentInstrument?: { __typename?: 'PaymentInstrument', id: string, type: PaymentInstrumentType, processor: PaymentAccountPlatform, brand?: string | null, lastFour?: string | null, expirationMonth?: number | null, expirationYear?: number | null, createdAt: any, updatedAt: any } | null, marketplaceUser?: { __typename?: 'MarketplaceUser', id: string, createdAt: any, updatedAt: any, groupId: string, membership: string, primaryInstrumentId?: string | null, email?: string | null, phone?: string | null, emailConfirmed: boolean, phoneConfirmed: boolean, emailOptIn: boolean, phoneOptIn: boolean, clientProfile?: { __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null } | null } | null, paymentLinks: Array<{ __typename?: 'PaymentLink', id: string, checkoutId: string, url: string, status: PaymentLinkStatus, amount: number, expiresAt?: any | null, createdAt: any, updatedAt: any }> } | null } };

export type SendProfileInvitationMutationVariables = Exact<{
  input: SendInvitationInput;
}>;


export type SendProfileInvitationMutation = { __typename?: 'Mutation', sendProfileInvitation: boolean };

export type SendQualiphyExamInviteMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type SendQualiphyExamInviteMutation = { __typename?: 'Mutation', sendQualiphyExamInvite: { __typename?: 'QualiphyInvitation', id: string, expiration: any, meetingUrl?: string | null, exams?: Array<{ __typename?: 'QualiphyExam', id: string, title: string, status?: QualiphyInvitationStatus | null }> | null } };

export type SendReceiptMutationVariables = Exact<{
  input: SendReceiptInput;
}>;


export type SendReceiptMutation = { __typename?: 'Mutation', sendReceipt: { __typename?: 'SendReceiptPayload', success: boolean, message?: string | null } };

export type SendWaitlistNotificationMutationVariables = Exact<{
  input: SendWaitlistNotificationInput;
}>;


export type SendWaitlistNotificationMutation = { __typename?: 'Mutation', sendWaitlistNotification?: { __typename?: 'AppointmentRequest', id: string, location: string, latitude?: number | null, longitude?: number | null, status: AppointmentRequestStatus, bookingMode?: BookingMode | null, cancelReason?: string | null, notes?: string | null, lastResetAt?: any | null, waitlistedAt?: any | null, createdAt: any, updatedAt: any, archivedAt?: any | null, declinedProfiles: Array<{ __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null }>, clientProfiles: Array<{ __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null, marketplaceUsers: Array<{ __typename?: 'MarketplaceUser', marketplaceIds: Array<string>, id: string, createdAt: any, updatedAt: any, groupId: string, membership: string, primaryInstrumentId?: string | null, email?: string | null, phone?: string | null, emailConfirmed: boolean, phoneConfirmed: boolean, emailOptIn: boolean, phoneOptIn: boolean, memberships: Array<{ __typename?: 'Membership', marketplaceName: string, id: string, membershipDefinitionId: string, renewalDate: any, name: string, status: MembershipStatusType }>, packageItems: Array<{ __typename?: 'PackageItem', marketplaceName: string, id: string, packageItemDefinitionId: string, membershipId?: string | null, balance: number, packageName: string, totalPoints: number, groupNames: string, expiresAt?: any | null, primaryOrganizationId?: string | null }>, clientProfiles: Array<{ __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null, organizations: Array<{ __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null }> }>, marketplaceGroup: { __typename?: 'MarketplaceGroup', id: string, label: string, createdAt: any, messagingServiceSid?: string | null }, paymentInstruments: Array<{ __typename?: 'PaymentInstrument', id: string, type: PaymentInstrumentType, processor: PaymentAccountPlatform, brand?: string | null, lastFour?: string | null, expirationMonth?: number | null, expirationYear?: number | null, createdAt: any, updatedAt: any }>, checkouts: Array<{ __typename?: 'Checkout', id: string, total: number, paid: number, balance: number, marketplaceUserId?: string | null, summary?: string | null, voidedAt?: any | null, paymentMethodType?: PaymentMethodType | null, createdAt: any, updatedAt: any, items: Array<{ __typename?: 'CheckoutItem', id: string, type: CheckoutItemType, description: string, quantity: number, price: number, key?: string | null }>, paymentLinks: Array<{ __typename?: 'PaymentLink', id: string, checkoutId: string, url: string, status: PaymentLinkStatus, amount: number, expiresAt?: any | null, createdAt: any, updatedAt: any }> }>, appointments: Array<{ __typename?: 'Appointment', intakeStatus?: string | null, id: string, location: string, latitude?: number | null, longitude?: number | null, start: any, end: any, duration: number, createdAt: any, updatedAt: any, archivedAt?: any | null, status: AppointmentStatus, startedAt?: any | null, completedAt?: any | null, notes?: string | null, createdBy?: string | null, cancelReason?: string | null, groupId?: string | null, ordersRequired: boolean, participants: Array<{ __typename?: 'AppointmentParticipant', id: string, name: string, type: ParticipantType, status: ParticipationStatus, profileId?: string | null, clientProfileId?: string | null, orderApproved?: boolean | null }>, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }>, checkout?: { __typename?: 'Checkout', id: string, total: number, paid: number, balance: number, marketplaceUserId?: string | null, summary?: string | null, voidedAt?: any | null, paymentMethodType?: PaymentMethodType | null, createdAt: any, updatedAt: any, paymentLinks: Array<{ __typename?: 'PaymentLink', id: string, checkoutId: string, url: string, status: PaymentLinkStatus, amount: number, expiresAt?: any | null, createdAt: any, updatedAt: any }> } | null, additionalPatients: Array<{ __typename?: 'AppointmentRequestPatient', id: string, clientProfile: { __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null }, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }> }> }>, appointmentRequests: Array<{ __typename?: 'AppointmentRequest', id: string, location: string, latitude?: number | null, longitude?: number | null, status: AppointmentRequestStatus, bookingMode?: BookingMode | null, cancelReason?: string | null, notes?: string | null, lastResetAt?: any | null, waitlistedAt?: any | null, createdAt: any, updatedAt: any, archivedAt?: any | null, marketplace: { __typename?: 'Marketplace', id: string, name: string, groupId: string, createdAt: any, logo?: string | null, favicon?: string | null, primaryColor?: string | null, marketingSiteUrl?: string | null, gtmContainer?: string | null, gtmRequiresConsent: boolean, gtmDataTier: GtmDataTier, gtmV2Enabled: boolean, featureFlags: { __typename?: 'MarketplaceFeatureFlags', waitListEnabled?: boolean | null, acceptedPaymentMethods?: { __typename?: 'AcceptedPaymentMethods', creditCard?: boolean | null, applePay?: boolean | null } | null } }, clientProfiles: Array<{ __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null }>, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }>, constraints: Array<{ __typename?: 'AppointmentConstraint', id: string, organizations: Array<{ __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null }>, profiles: Array<{ __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null }>, timeRanges: Array<{ __typename?: 'AppointmentTimeRange', id: string, start: any, end: any }> }>, additionalPatients: Array<{ __typename?: 'AppointmentRequestPatient', id: string, clientProfile: { __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null }, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }> }> }>, clientProfile?: { __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null } | null }> }>, checkout?: { __typename?: 'Checkout', id: string, total: number, paid: number, balance: number, marketplaceUserId?: string | null, summary?: string | null, voidedAt?: any | null, paymentMethodType?: PaymentMethodType | null, createdAt: any, updatedAt: any, items: Array<{ __typename?: 'CheckoutItem', id: string, type: CheckoutItemType, description: string, quantity: number, price: number, key?: string | null }>, payments: Array<{ __typename?: 'Payment', id: string, type: PaymentType, status: PaymentStatus, description: string, amount: number, amountRequested: number, amountReversed?: number | null, isDeposit: boolean, createdAt: any, updatedAt: any }>, payouts: Array<{ __typename?: 'Payout', id: string, status: PayoutStatus, description: string, amount: number, amountRequested: number, amountReversed?: number | null, createdAt: any, updatedAt: any, checkoutId: string }>, paymentInstrument?: { __typename?: 'PaymentInstrument', id: string, type: PaymentInstrumentType, processor: PaymentAccountPlatform, brand?: string | null, lastFour?: string | null, expirationMonth?: number | null, expirationYear?: number | null, createdAt: any, updatedAt: any } | null, marketplaceUser?: { __typename?: 'MarketplaceUser', id: string, createdAt: any, updatedAt: any, groupId: string, membership: string, primaryInstrumentId?: string | null, email?: string | null, phone?: string | null, emailConfirmed: boolean, phoneConfirmed: boolean, emailOptIn: boolean, phoneOptIn: boolean, clientProfile?: { __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null } | null } | null, paymentLinks: Array<{ __typename?: 'PaymentLink', id: string, checkoutId: string, url: string, status: PaymentLinkStatus, amount: number, expiresAt?: any | null, createdAt: any, updatedAt: any }> } | null, marketplace: { __typename?: 'Marketplace', id: string, name: string, groupId: string, createdAt: any, logo?: string | null, favicon?: string | null, primaryColor?: string | null, marketingSiteUrl?: string | null, gtmContainer?: string | null, gtmRequiresConsent: boolean, gtmDataTier: GtmDataTier, gtmV2Enabled: boolean, featureFlags: { __typename?: 'MarketplaceFeatureFlags', waitListEnabled?: boolean | null, acceptedPaymentMethods?: { __typename?: 'AcceptedPaymentMethods', creditCard?: boolean | null, applePay?: boolean | null } | null } }, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }>, constraints: Array<{ __typename?: 'AppointmentConstraint', id: string, organizations: Array<{ __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null }>, profiles: Array<{ __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null }>, timeRanges: Array<{ __typename?: 'AppointmentTimeRange', id: string, start: any, end: any }> }>, additionalPatients: Array<{ __typename?: 'AppointmentRequestPatient', id: string, clientProfile: { __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null }, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }> }> } | null };

export type SetUserMcpAccessMutationVariables = Exact<{
  input: SetUserMcpAccessInput;
}>;


export type SetUserMcpAccessMutation = { __typename?: 'Mutation', setUserMcpAccess: { __typename?: 'User', id: string, isMcpEnabled: boolean } };

export type SignOutEverywhereMutationVariables = Exact<{ [key: string]: never; }>;


export type SignOutEverywhereMutation = { __typename?: 'Mutation', signOutEverywhere: boolean };

export type StartAppointmentMutationVariables = Exact<{
  input: StartAppointmentInput;
}>;


export type StartAppointmentMutation = { __typename?: 'Mutation', startAppointment?: { __typename?: 'Appointment', id: string, location: string, latitude?: number | null, longitude?: number | null, start: any, end: any, duration: number, createdAt: any, updatedAt: any, archivedAt?: any | null, status: AppointmentStatus, startedAt?: any | null, completedAt?: any | null, notes?: string | null, createdBy?: string | null, cancelReason?: string | null, groupId?: string | null, ordersRequired: boolean, participants: Array<{ __typename?: 'AppointmentParticipant', id: string, name: string, type: ParticipantType, status: ParticipationStatus, profileId?: string | null, clientProfileId?: string | null, orderApproved?: boolean | null, participant?: { __typename?: 'ClientProfile', internalNotesUpdatedBy?: string | null, internalNotesUpdatedAt?: any | null, id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null, patient?: { __typename?: 'Patient', id: string, allergies?: string | null, archivedAt?: any | null, clientProfileId: string, conditions?: string | null, createdAt: any, emrInstanceId: string, immunizations?: string | null, labs?: string | null, medications?: string | null, procedures?: string | null, updatedAt: any, orders: Array<{ __typename?: 'Order', id: string, archivedAt?: any | null, createdAt: any, expiresAt: any, providerType: ProviderType, fillCount: number, note?: string | null, refills: number, startsAt: any, updatedAt: any, procedureDefs: Array<{ __typename?: 'ProcedureDefinition', id: string, name: string, description: string, price: number, duration: number, assessmentFormTemplateId?: string | null, interventionFormTemplateId?: string | null, ordersRequired: boolean, createdAt: any, intakeFormTemplates: Array<{ __typename?: 'FormTemplate', id: string, name: string }> }>, profile?: { __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null } | null, organizations: Array<{ __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null }> }>, vitals: Array<{ __typename?: 'VitalSign', id: string, createdAt: any, createdById: string, recordedAt: any, type: VitalSignType, updatedAt: any, value: string }>, signedConsentForms: Array<{ __typename?: 'DocumentSignature', id: string, signerName: string, signerEmail?: string | null, signerType: DocumentSignatureSignerType, signedAt: any, verificationType: DocumentSignatureVerificationType, verificationDetail?: string | null, tzid: string, latitude?: number | null, longitude?: number | null, documentId: string, version: number, documentLabel: string, url?: string | null, createdAt: any, updatedAt: any }>, allergyRecords: Array<{ __typename?: 'AllergyIntolerance', id: string, name: string }>, clinicalProcedureRecords: Array<{ __typename?: 'ClinicalProcedure', id: string, name: string }>, conditionRecords: Array<{ __typename?: 'Condition', id: string, name: string }>, immunizationRecords: Array<{ __typename?: 'Immunization', id: string, name: string }>, labRecords: Array<{ __typename?: 'Lab', id: string, name: string }>, medicationRecords: Array<{ __typename?: 'MedicationStatement', id: string, name: string }>, attachments?: Array<{ __typename?: 'Document', id: string, filename: string, label: string, type: DocumentType, version: number, fileSize: number, url: string, createdAt: any, updatedAt: any }> | null } | null } | { __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null } | null, responses: Array<{ __typename?: 'AppointmentResponse', id: string, start?: any | null, end?: any | null, createdAt: any, updatedAt: any }>, forms: Array<{ __typename?: 'Form', id: string, type: FormType, status: FormStatusType, patientId: string, lockedById?: string | null, editable: boolean, createdAt: any, updatedAt: any, items: Array<{ __typename?: 'FormItem', id: string, index: number, label: string, type: FormItemType, code: string, options?: string | null, createdAt: any, updatedAt: any }>, observations: Array<{ __typename?: 'Observation', id: string, code: string, value: string, note?: string | null, createdById: string, createdAt: any, updatedAt: any, createdBy?: { __typename?: 'Profile', id: string, givenName: string, familyName: string, title: string } | null }>, lockedBy?: { __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null } | null, document?: { __typename?: 'Document', id: string, filename: string, label: string, type: DocumentType, version: number, fileSize: number, url: string, createdAt: any, updatedAt: any } | null, attachments?: Array<{ __typename?: 'Document', id: string, filename: string, label: string, type: DocumentType, version: number, fileSize: number, url: string, createdAt: any, updatedAt: any }> | null, notes: Array<{ __typename?: 'FormNote', id: string, note: string, edited: boolean, profileId: string, createdAt: any, updatedAt: any, author: string }> }> }>, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }>, checkout?: { __typename?: 'Checkout', id: string, total: number, paid: number, balance: number, marketplaceUserId?: string | null, summary?: string | null, voidedAt?: any | null, paymentMethodType?: PaymentMethodType | null, createdAt: any, updatedAt: any, items: Array<{ __typename?: 'CheckoutItem', id: string, type: CheckoutItemType, description: string, quantity: number, price: number, key?: string | null }>, payments: Array<{ __typename?: 'Payment', id: string, type: PaymentType, status: PaymentStatus, description: string, amount: number, amountRequested: number, amountReversed?: number | null, isDeposit: boolean, createdAt: any, updatedAt: any }>, payouts: Array<{ __typename?: 'Payout', id: string, status: PayoutStatus, description: string, amount: number, amountRequested: number, amountReversed?: number | null, createdAt: any, updatedAt: any, checkoutId: string }>, paymentInstrument?: { __typename?: 'PaymentInstrument', id: string, type: PaymentInstrumentType, processor: PaymentAccountPlatform, brand?: string | null, lastFour?: string | null, expirationMonth?: number | null, expirationYear?: number | null, createdAt: any, updatedAt: any } | null, marketplaceUser?: { __typename?: 'MarketplaceUser', id: string, createdAt: any, updatedAt: any, groupId: string, membership: string, primaryInstrumentId?: string | null, email?: string | null, phone?: string | null, emailConfirmed: boolean, phoneConfirmed: boolean, emailOptIn: boolean, phoneOptIn: boolean, clientProfile?: { __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null } | null } | null, paymentLinks: Array<{ __typename?: 'PaymentLink', id: string, checkoutId: string, url: string, status: PaymentLinkStatus, amount: number, expiresAt?: any | null, createdAt: any, updatedAt: any }> } | null, qualiphyInvitation?: { __typename?: 'QualiphyInvitation', id: string, expiration: any, meetingUrl?: string | null, exams?: Array<{ __typename?: 'QualiphyExam', id: string, title: string, status?: QualiphyInvitationStatus | null }> | null } | null, additionalPatients: Array<{ __typename?: 'AppointmentRequestPatient', id: string, clientProfile: { __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null }, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }> }> } | null };

export type StartMfaStepUpMutationVariables = Exact<{ [key: string]: never; }>;


export type StartMfaStepUpMutation = { __typename?: 'Mutation', startMfaStepUp: { __typename?: 'MfaStepUp', challengeId: string, methods: Array<MfaMethod>, expiresAt: any } };

export type StartPasskeyRegistrationMutationVariables = Exact<{ [key: string]: never; }>;


export type StartPasskeyRegistrationMutation = { __typename?: 'Mutation', startPasskeyRegistration: { __typename?: 'PasskeyRegistrationOptions', options: any } };

export type StartTotpEnrollmentMutationVariables = Exact<{ [key: string]: never; }>;


export type StartTotpEnrollmentMutation = { __typename?: 'Mutation', startTotpEnrollment: { __typename?: 'TotpEnrollment', enrollmentId: string, otpauthUrl: string } };

export type UnarchiveProfileMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type UnarchiveProfileMutation = { __typename?: 'Mutation', unarchiveProfile: boolean };

export type UnassignPaymentAccountMutationVariables = Exact<{
  input: UnassignPaymentAccountInput;
}>;


export type UnassignPaymentAccountMutation = { __typename?: 'Mutation', unassignPaymentAccount: boolean };

export type UnassignProcedureProfileMutationVariables = Exact<{
  input: UnassignProcedureProfileInput;
}>;


export type UnassignProcedureProfileMutation = { __typename?: 'Mutation', unassignProcedureProfile: boolean };

export type UnassignRoleMutationVariables = Exact<{
  input: UnassignRoleInput;
}>;


export type UnassignRoleMutation = { __typename?: 'Mutation', unassignRole: boolean };

export type UnlockFormMutationVariables = Exact<{
  input: UnlockFormInput;
}>;


export type UnlockFormMutation = { __typename?: 'Mutation', unlockForm: { __typename?: 'Form', id: string, type: FormType, status: FormStatusType, patientId: string, lockedById?: string | null, editable: boolean, createdAt: any, updatedAt: any, items: Array<{ __typename?: 'FormItem', id: string, index: number, label: string, type: FormItemType, code: string, options?: string | null, createdAt: any, updatedAt: any }>, observations: Array<{ __typename?: 'Observation', id: string, code: string, value: string, note?: string | null, createdById: string, createdAt: any, updatedAt: any, createdBy?: { __typename?: 'Profile', id: string, givenName: string, familyName: string, title: string } | null }>, lockedBy?: { __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null } | null, document?: { __typename?: 'Document', id: string, filename: string, label: string, type: DocumentType, version: number, fileSize: number, url: string, createdAt: any, updatedAt: any } | null, attachments?: Array<{ __typename?: 'Document', id: string, filename: string, label: string, type: DocumentType, version: number, fileSize: number, url: string, createdAt: any, updatedAt: any }> | null, notes: Array<{ __typename?: 'FormNote', id: string, note: string, edited: boolean, profileId: string, createdAt: any, updatedAt: any, author: string }> } };

export type UpdateApiKeyMutationVariables = Exact<{
  input: UpdateApiKeyInput;
}>;


export type UpdateApiKeyMutation = { __typename?: 'Mutation', updateApiKey: { __typename?: 'ApiKey', id: string, kid: string, name: string, createdAt: any, roles: Array<{ __typename?: 'Role', id: string, name: string, scope: RoleScope, type: RoleType, permissions: Array<string>, resourceId?: string | null }> } };

export type UpdateAppointmentMutationVariables = Exact<{
  input: UpdateAppointmentInput;
}>;


export type UpdateAppointmentMutation = { __typename?: 'Mutation', updateAppointment?: { __typename?: 'Appointment', id: string, location: string, latitude?: number | null, longitude?: number | null, start: any, end: any, duration: number, createdAt: any, updatedAt: any, archivedAt?: any | null, status: AppointmentStatus, startedAt?: any | null, completedAt?: any | null, notes?: string | null, createdBy?: string | null, cancelReason?: string | null, groupId?: string | null, ordersRequired: boolean, participants: Array<{ __typename?: 'AppointmentParticipant', id: string, name: string, type: ParticipantType, status: ParticipationStatus, profileId?: string | null, clientProfileId?: string | null, orderApproved?: boolean | null, participant?: { __typename?: 'ClientProfile', internalNotesUpdatedBy?: string | null, internalNotesUpdatedAt?: any | null, id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null, patient?: { __typename?: 'Patient', id: string, allergies?: string | null, archivedAt?: any | null, clientProfileId: string, conditions?: string | null, createdAt: any, emrInstanceId: string, immunizations?: string | null, labs?: string | null, medications?: string | null, procedures?: string | null, updatedAt: any, orders: Array<{ __typename?: 'Order', id: string, archivedAt?: any | null, createdAt: any, expiresAt: any, providerType: ProviderType, fillCount: number, note?: string | null, refills: number, startsAt: any, updatedAt: any, procedureDefs: Array<{ __typename?: 'ProcedureDefinition', id: string, name: string, description: string, price: number, duration: number, assessmentFormTemplateId?: string | null, interventionFormTemplateId?: string | null, ordersRequired: boolean, createdAt: any, intakeFormTemplates: Array<{ __typename?: 'FormTemplate', id: string, name: string }> }>, profile?: { __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null } | null, organizations: Array<{ __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null }> }>, vitals: Array<{ __typename?: 'VitalSign', id: string, createdAt: any, createdById: string, recordedAt: any, type: VitalSignType, updatedAt: any, value: string }>, signedConsentForms: Array<{ __typename?: 'DocumentSignature', id: string, signerName: string, signerEmail?: string | null, signerType: DocumentSignatureSignerType, signedAt: any, verificationType: DocumentSignatureVerificationType, verificationDetail?: string | null, tzid: string, latitude?: number | null, longitude?: number | null, documentId: string, version: number, documentLabel: string, url?: string | null, createdAt: any, updatedAt: any }>, allergyRecords: Array<{ __typename?: 'AllergyIntolerance', id: string, name: string }>, clinicalProcedureRecords: Array<{ __typename?: 'ClinicalProcedure', id: string, name: string }>, conditionRecords: Array<{ __typename?: 'Condition', id: string, name: string }>, immunizationRecords: Array<{ __typename?: 'Immunization', id: string, name: string }>, labRecords: Array<{ __typename?: 'Lab', id: string, name: string }>, medicationRecords: Array<{ __typename?: 'MedicationStatement', id: string, name: string }>, attachments?: Array<{ __typename?: 'Document', id: string, filename: string, label: string, type: DocumentType, version: number, fileSize: number, url: string, createdAt: any, updatedAt: any }> | null } | null } | { __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null } | null, responses: Array<{ __typename?: 'AppointmentResponse', id: string, start?: any | null, end?: any | null, createdAt: any, updatedAt: any }>, forms: Array<{ __typename?: 'Form', id: string, type: FormType, status: FormStatusType, patientId: string, lockedById?: string | null, editable: boolean, createdAt: any, updatedAt: any, items: Array<{ __typename?: 'FormItem', id: string, index: number, label: string, type: FormItemType, code: string, options?: string | null, createdAt: any, updatedAt: any }>, observations: Array<{ __typename?: 'Observation', id: string, code: string, value: string, note?: string | null, createdById: string, createdAt: any, updatedAt: any, createdBy?: { __typename?: 'Profile', id: string, givenName: string, familyName: string, title: string } | null }>, lockedBy?: { __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null } | null, document?: { __typename?: 'Document', id: string, filename: string, label: string, type: DocumentType, version: number, fileSize: number, url: string, createdAt: any, updatedAt: any } | null, attachments?: Array<{ __typename?: 'Document', id: string, filename: string, label: string, type: DocumentType, version: number, fileSize: number, url: string, createdAt: any, updatedAt: any }> | null, notes: Array<{ __typename?: 'FormNote', id: string, note: string, edited: boolean, profileId: string, createdAt: any, updatedAt: any, author: string }> }> }>, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }>, checkout?: { __typename?: 'Checkout', id: string, total: number, paid: number, balance: number, marketplaceUserId?: string | null, summary?: string | null, voidedAt?: any | null, paymentMethodType?: PaymentMethodType | null, createdAt: any, updatedAt: any, items: Array<{ __typename?: 'CheckoutItem', id: string, type: CheckoutItemType, description: string, quantity: number, price: number, key?: string | null }>, payments: Array<{ __typename?: 'Payment', id: string, type: PaymentType, status: PaymentStatus, description: string, amount: number, amountRequested: number, amountReversed?: number | null, isDeposit: boolean, createdAt: any, updatedAt: any }>, payouts: Array<{ __typename?: 'Payout', id: string, status: PayoutStatus, description: string, amount: number, amountRequested: number, amountReversed?: number | null, createdAt: any, updatedAt: any, checkoutId: string }>, paymentInstrument?: { __typename?: 'PaymentInstrument', id: string, type: PaymentInstrumentType, processor: PaymentAccountPlatform, brand?: string | null, lastFour?: string | null, expirationMonth?: number | null, expirationYear?: number | null, createdAt: any, updatedAt: any } | null, marketplaceUser?: { __typename?: 'MarketplaceUser', id: string, createdAt: any, updatedAt: any, groupId: string, membership: string, primaryInstrumentId?: string | null, email?: string | null, phone?: string | null, emailConfirmed: boolean, phoneConfirmed: boolean, emailOptIn: boolean, phoneOptIn: boolean, clientProfile?: { __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null } | null } | null, paymentLinks: Array<{ __typename?: 'PaymentLink', id: string, checkoutId: string, url: string, status: PaymentLinkStatus, amount: number, expiresAt?: any | null, createdAt: any, updatedAt: any }> } | null, qualiphyInvitation?: { __typename?: 'QualiphyInvitation', id: string, expiration: any, meetingUrl?: string | null, exams?: Array<{ __typename?: 'QualiphyExam', id: string, title: string, status?: QualiphyInvitationStatus | null }> | null } | null, additionalPatients: Array<{ __typename?: 'AppointmentRequestPatient', id: string, clientProfile: { __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null }, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }> }> } | null };

export type UpdateAppointmentRequestMutationVariables = Exact<{
  input: UpdateAppointmentRequestInput;
}>;


export type UpdateAppointmentRequestMutation = { __typename?: 'Mutation', updateAppointmentRequest?: { __typename?: 'AppointmentRequest', id: string, location: string, latitude?: number | null, longitude?: number | null, status: AppointmentRequestStatus, bookingMode?: BookingMode | null, cancelReason?: string | null, notes?: string | null, lastResetAt?: any | null, waitlistedAt?: any | null, createdAt: any, updatedAt: any, archivedAt?: any | null, declinedProfiles: Array<{ __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null }>, clientProfiles: Array<{ __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null, marketplaceUsers: Array<{ __typename?: 'MarketplaceUser', marketplaceIds: Array<string>, id: string, createdAt: any, updatedAt: any, groupId: string, membership: string, primaryInstrumentId?: string | null, email?: string | null, phone?: string | null, emailConfirmed: boolean, phoneConfirmed: boolean, emailOptIn: boolean, phoneOptIn: boolean, memberships: Array<{ __typename?: 'Membership', marketplaceName: string, id: string, membershipDefinitionId: string, renewalDate: any, name: string, status: MembershipStatusType }>, packageItems: Array<{ __typename?: 'PackageItem', marketplaceName: string, id: string, packageItemDefinitionId: string, membershipId?: string | null, balance: number, packageName: string, totalPoints: number, groupNames: string, expiresAt?: any | null, primaryOrganizationId?: string | null }>, clientProfiles: Array<{ __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null, organizations: Array<{ __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null }> }>, marketplaceGroup: { __typename?: 'MarketplaceGroup', id: string, label: string, createdAt: any, messagingServiceSid?: string | null }, paymentInstruments: Array<{ __typename?: 'PaymentInstrument', id: string, type: PaymentInstrumentType, processor: PaymentAccountPlatform, brand?: string | null, lastFour?: string | null, expirationMonth?: number | null, expirationYear?: number | null, createdAt: any, updatedAt: any }>, checkouts: Array<{ __typename?: 'Checkout', id: string, total: number, paid: number, balance: number, marketplaceUserId?: string | null, summary?: string | null, voidedAt?: any | null, paymentMethodType?: PaymentMethodType | null, createdAt: any, updatedAt: any, items: Array<{ __typename?: 'CheckoutItem', id: string, type: CheckoutItemType, description: string, quantity: number, price: number, key?: string | null }>, paymentLinks: Array<{ __typename?: 'PaymentLink', id: string, checkoutId: string, url: string, status: PaymentLinkStatus, amount: number, expiresAt?: any | null, createdAt: any, updatedAt: any }> }>, appointments: Array<{ __typename?: 'Appointment', intakeStatus?: string | null, id: string, location: string, latitude?: number | null, longitude?: number | null, start: any, end: any, duration: number, createdAt: any, updatedAt: any, archivedAt?: any | null, status: AppointmentStatus, startedAt?: any | null, completedAt?: any | null, notes?: string | null, createdBy?: string | null, cancelReason?: string | null, groupId?: string | null, ordersRequired: boolean, participants: Array<{ __typename?: 'AppointmentParticipant', id: string, name: string, type: ParticipantType, status: ParticipationStatus, profileId?: string | null, clientProfileId?: string | null, orderApproved?: boolean | null }>, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }>, checkout?: { __typename?: 'Checkout', id: string, total: number, paid: number, balance: number, marketplaceUserId?: string | null, summary?: string | null, voidedAt?: any | null, paymentMethodType?: PaymentMethodType | null, createdAt: any, updatedAt: any, paymentLinks: Array<{ __typename?: 'PaymentLink', id: string, checkoutId: string, url: string, status: PaymentLinkStatus, amount: number, expiresAt?: any | null, createdAt: any, updatedAt: any }> } | null, additionalPatients: Array<{ __typename?: 'AppointmentRequestPatient', id: string, clientProfile: { __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null }, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }> }> }>, appointmentRequests: Array<{ __typename?: 'AppointmentRequest', id: string, location: string, latitude?: number | null, longitude?: number | null, status: AppointmentRequestStatus, bookingMode?: BookingMode | null, cancelReason?: string | null, notes?: string | null, lastResetAt?: any | null, waitlistedAt?: any | null, createdAt: any, updatedAt: any, archivedAt?: any | null, marketplace: { __typename?: 'Marketplace', id: string, name: string, groupId: string, createdAt: any, logo?: string | null, favicon?: string | null, primaryColor?: string | null, marketingSiteUrl?: string | null, gtmContainer?: string | null, gtmRequiresConsent: boolean, gtmDataTier: GtmDataTier, gtmV2Enabled: boolean, featureFlags: { __typename?: 'MarketplaceFeatureFlags', waitListEnabled?: boolean | null, acceptedPaymentMethods?: { __typename?: 'AcceptedPaymentMethods', creditCard?: boolean | null, applePay?: boolean | null } | null } }, clientProfiles: Array<{ __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null }>, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }>, constraints: Array<{ __typename?: 'AppointmentConstraint', id: string, organizations: Array<{ __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null }>, profiles: Array<{ __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null }>, timeRanges: Array<{ __typename?: 'AppointmentTimeRange', id: string, start: any, end: any }> }>, additionalPatients: Array<{ __typename?: 'AppointmentRequestPatient', id: string, clientProfile: { __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null }, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }> }> }>, clientProfile?: { __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null } | null }> }>, checkout?: { __typename?: 'Checkout', id: string, total: number, paid: number, balance: number, marketplaceUserId?: string | null, summary?: string | null, voidedAt?: any | null, paymentMethodType?: PaymentMethodType | null, createdAt: any, updatedAt: any, items: Array<{ __typename?: 'CheckoutItem', id: string, type: CheckoutItemType, description: string, quantity: number, price: number, key?: string | null }>, payments: Array<{ __typename?: 'Payment', id: string, type: PaymentType, status: PaymentStatus, description: string, amount: number, amountRequested: number, amountReversed?: number | null, isDeposit: boolean, createdAt: any, updatedAt: any }>, payouts: Array<{ __typename?: 'Payout', id: string, status: PayoutStatus, description: string, amount: number, amountRequested: number, amountReversed?: number | null, createdAt: any, updatedAt: any, checkoutId: string }>, paymentInstrument?: { __typename?: 'PaymentInstrument', id: string, type: PaymentInstrumentType, processor: PaymentAccountPlatform, brand?: string | null, lastFour?: string | null, expirationMonth?: number | null, expirationYear?: number | null, createdAt: any, updatedAt: any } | null, marketplaceUser?: { __typename?: 'MarketplaceUser', id: string, createdAt: any, updatedAt: any, groupId: string, membership: string, primaryInstrumentId?: string | null, email?: string | null, phone?: string | null, emailConfirmed: boolean, phoneConfirmed: boolean, emailOptIn: boolean, phoneOptIn: boolean, clientProfile?: { __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null } | null } | null, paymentLinks: Array<{ __typename?: 'PaymentLink', id: string, checkoutId: string, url: string, status: PaymentLinkStatus, amount: number, expiresAt?: any | null, createdAt: any, updatedAt: any }> } | null, marketplace: { __typename?: 'Marketplace', id: string, name: string, groupId: string, createdAt: any, logo?: string | null, favicon?: string | null, primaryColor?: string | null, marketingSiteUrl?: string | null, gtmContainer?: string | null, gtmRequiresConsent: boolean, gtmDataTier: GtmDataTier, gtmV2Enabled: boolean, featureFlags: { __typename?: 'MarketplaceFeatureFlags', waitListEnabled?: boolean | null, acceptedPaymentMethods?: { __typename?: 'AcceptedPaymentMethods', creditCard?: boolean | null, applePay?: boolean | null } | null } }, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }>, constraints: Array<{ __typename?: 'AppointmentConstraint', id: string, organizations: Array<{ __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null }>, profiles: Array<{ __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null }>, timeRanges: Array<{ __typename?: 'AppointmentTimeRange', id: string, start: any, end: any }> }>, additionalPatients: Array<{ __typename?: 'AppointmentRequestPatient', id: string, clientProfile: { __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null }, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }> }> } | null };

export type UpdateAppointmentSecondaryParticipantsMutationVariables = Exact<{
  input: UpdateAppointmentSecondaryParticipantsInput;
}>;


export type UpdateAppointmentSecondaryParticipantsMutation = { __typename?: 'Mutation', updateAppointmentSecondaryParticipants?: { __typename?: 'Appointment', id: string, location: string, latitude?: number | null, longitude?: number | null, start: any, end: any, duration: number, createdAt: any, updatedAt: any, archivedAt?: any | null, status: AppointmentStatus, startedAt?: any | null, completedAt?: any | null, notes?: string | null, createdBy?: string | null, cancelReason?: string | null, groupId?: string | null, ordersRequired: boolean, participants: Array<{ __typename?: 'AppointmentParticipant', id: string, name: string, type: ParticipantType, status: ParticipationStatus, profileId?: string | null, clientProfileId?: string | null, orderApproved?: boolean | null, participant?: { __typename?: 'ClientProfile', internalNotesUpdatedBy?: string | null, internalNotesUpdatedAt?: any | null, id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null, patient?: { __typename?: 'Patient', id: string, allergies?: string | null, archivedAt?: any | null, clientProfileId: string, conditions?: string | null, createdAt: any, emrInstanceId: string, immunizations?: string | null, labs?: string | null, medications?: string | null, procedures?: string | null, updatedAt: any, orders: Array<{ __typename?: 'Order', id: string, archivedAt?: any | null, createdAt: any, expiresAt: any, providerType: ProviderType, fillCount: number, note?: string | null, refills: number, startsAt: any, updatedAt: any, procedureDefs: Array<{ __typename?: 'ProcedureDefinition', id: string, name: string, description: string, price: number, duration: number, assessmentFormTemplateId?: string | null, interventionFormTemplateId?: string | null, ordersRequired: boolean, createdAt: any, intakeFormTemplates: Array<{ __typename?: 'FormTemplate', id: string, name: string }> }>, profile?: { __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null } | null, organizations: Array<{ __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null }> }>, vitals: Array<{ __typename?: 'VitalSign', id: string, createdAt: any, createdById: string, recordedAt: any, type: VitalSignType, updatedAt: any, value: string }>, signedConsentForms: Array<{ __typename?: 'DocumentSignature', id: string, signerName: string, signerEmail?: string | null, signerType: DocumentSignatureSignerType, signedAt: any, verificationType: DocumentSignatureVerificationType, verificationDetail?: string | null, tzid: string, latitude?: number | null, longitude?: number | null, documentId: string, version: number, documentLabel: string, url?: string | null, createdAt: any, updatedAt: any }>, allergyRecords: Array<{ __typename?: 'AllergyIntolerance', id: string, name: string }>, clinicalProcedureRecords: Array<{ __typename?: 'ClinicalProcedure', id: string, name: string }>, conditionRecords: Array<{ __typename?: 'Condition', id: string, name: string }>, immunizationRecords: Array<{ __typename?: 'Immunization', id: string, name: string }>, labRecords: Array<{ __typename?: 'Lab', id: string, name: string }>, medicationRecords: Array<{ __typename?: 'MedicationStatement', id: string, name: string }>, attachments?: Array<{ __typename?: 'Document', id: string, filename: string, label: string, type: DocumentType, version: number, fileSize: number, url: string, createdAt: any, updatedAt: any }> | null } | null } | { __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null } | null, responses: Array<{ __typename?: 'AppointmentResponse', id: string, start?: any | null, end?: any | null, createdAt: any, updatedAt: any }>, forms: Array<{ __typename?: 'Form', id: string, type: FormType, status: FormStatusType, patientId: string, lockedById?: string | null, editable: boolean, createdAt: any, updatedAt: any, items: Array<{ __typename?: 'FormItem', id: string, index: number, label: string, type: FormItemType, code: string, options?: string | null, createdAt: any, updatedAt: any }>, observations: Array<{ __typename?: 'Observation', id: string, code: string, value: string, note?: string | null, createdById: string, createdAt: any, updatedAt: any, createdBy?: { __typename?: 'Profile', id: string, givenName: string, familyName: string, title: string } | null }>, lockedBy?: { __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null } | null, document?: { __typename?: 'Document', id: string, filename: string, label: string, type: DocumentType, version: number, fileSize: number, url: string, createdAt: any, updatedAt: any } | null, attachments?: Array<{ __typename?: 'Document', id: string, filename: string, label: string, type: DocumentType, version: number, fileSize: number, url: string, createdAt: any, updatedAt: any }> | null, notes: Array<{ __typename?: 'FormNote', id: string, note: string, edited: boolean, profileId: string, createdAt: any, updatedAt: any, author: string }> }> }>, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }>, checkout?: { __typename?: 'Checkout', id: string, total: number, paid: number, balance: number, marketplaceUserId?: string | null, summary?: string | null, voidedAt?: any | null, paymentMethodType?: PaymentMethodType | null, createdAt: any, updatedAt: any, items: Array<{ __typename?: 'CheckoutItem', id: string, type: CheckoutItemType, description: string, quantity: number, price: number, key?: string | null }>, payments: Array<{ __typename?: 'Payment', id: string, type: PaymentType, status: PaymentStatus, description: string, amount: number, amountRequested: number, amountReversed?: number | null, isDeposit: boolean, createdAt: any, updatedAt: any }>, payouts: Array<{ __typename?: 'Payout', id: string, status: PayoutStatus, description: string, amount: number, amountRequested: number, amountReversed?: number | null, createdAt: any, updatedAt: any, checkoutId: string }>, paymentInstrument?: { __typename?: 'PaymentInstrument', id: string, type: PaymentInstrumentType, processor: PaymentAccountPlatform, brand?: string | null, lastFour?: string | null, expirationMonth?: number | null, expirationYear?: number | null, createdAt: any, updatedAt: any } | null, marketplaceUser?: { __typename?: 'MarketplaceUser', id: string, createdAt: any, updatedAt: any, groupId: string, membership: string, primaryInstrumentId?: string | null, email?: string | null, phone?: string | null, emailConfirmed: boolean, phoneConfirmed: boolean, emailOptIn: boolean, phoneOptIn: boolean, clientProfile?: { __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null } | null } | null, paymentLinks: Array<{ __typename?: 'PaymentLink', id: string, checkoutId: string, url: string, status: PaymentLinkStatus, amount: number, expiresAt?: any | null, createdAt: any, updatedAt: any }> } | null, qualiphyInvitation?: { __typename?: 'QualiphyInvitation', id: string, expiration: any, meetingUrl?: string | null, exams?: Array<{ __typename?: 'QualiphyExam', id: string, title: string, status?: QualiphyInvitationStatus | null }> | null } | null, additionalPatients: Array<{ __typename?: 'AppointmentRequestPatient', id: string, clientProfile: { __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null }, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }> }> } | null };

export type UpdateAttentiveIntegrationMutationVariables = Exact<{
  input: UpdateAttentiveIntegrationInput;
}>;


export type UpdateAttentiveIntegrationMutation = { __typename?: 'Mutation', updateAttentiveIntegration?: { __typename?: 'AttentiveIntegration', id: string, apiKeyDescription?: string | null, appointmentCompletedEnabled?: boolean | null, appointmentCompletedEvent?: string | null, qualiphyTextsEnabled?: boolean | null, qualiphyTextsEvent?: string | null, marketingSignUpUnitId?: string | null, transactionalSignUpUnitId?: string | null } | null };

export type UpdateAvailabilityMutationVariables = Exact<{
  input: UpdateAvailabilityInput;
}>;


export type UpdateAvailabilityMutation = { __typename?: 'Mutation', updateAvailability?: { __typename?: 'Availability', id: string, type: AvailabilityType, start: any, end: any, tzid: string, duration: number, createdAt: any, updatedAt: any, repeat?: { __typename?: 'RepeatRule', id: string, frequency: RepeatFrequencyType, byWeekday: Array<RepeatWeekdayType>, until?: any | null } | null } | null };

export type UpdateAvailabilityCoverageMutationVariables = Exact<{
  input: UpdateAvailabilityCoverageInput;
}>;


export type UpdateAvailabilityCoverageMutation = { __typename?: 'Mutation', updateAvailabilityCoverage?: { __typename?: 'AvailabilityCoverage', id: string, label: string, threshold: number, start: any, end: any, tzid: string, repeat?: { __typename?: 'RepeatRule', id: string, frequency: RepeatFrequencyType, byWeekday: Array<RepeatWeekdayType>, until?: any | null } | null, profiles: Array<{ __typename?: 'ProcedureProfile', id: string }> } | null };

export type UpdateCheckoutMutationVariables = Exact<{
  input: UpdateCheckoutInput;
}>;


export type UpdateCheckoutMutation = { __typename?: 'Mutation', updateCheckout: { __typename?: 'Checkout', id: string, total: number, paid: number, balance: number, marketplaceUserId?: string | null, summary?: string | null, voidedAt?: any | null, paymentMethodType?: PaymentMethodType | null, createdAt: any, updatedAt: any, appointment?: { __typename?: 'Appointment', id: string, location: string, latitude?: number | null, longitude?: number | null, start: any, end: any, duration: number, createdAt: any, updatedAt: any, archivedAt?: any | null, status: AppointmentStatus, startedAt?: any | null, completedAt?: any | null, notes?: string | null, createdBy?: string | null, cancelReason?: string | null, groupId?: string | null, ordersRequired: boolean, participants: Array<{ __typename?: 'AppointmentParticipant', id: string, name: string, type: ParticipantType, status: ParticipationStatus, profileId?: string | null, clientProfileId?: string | null, orderApproved?: boolean | null, participant?: { __typename?: 'ClientProfile', internalNotesUpdatedBy?: string | null, internalNotesUpdatedAt?: any | null, id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null, patient?: { __typename?: 'Patient', id: string, allergies?: string | null, archivedAt?: any | null, clientProfileId: string, conditions?: string | null, createdAt: any, emrInstanceId: string, immunizations?: string | null, labs?: string | null, medications?: string | null, procedures?: string | null, updatedAt: any, orders: Array<{ __typename?: 'Order', id: string, archivedAt?: any | null, createdAt: any, expiresAt: any, providerType: ProviderType, fillCount: number, note?: string | null, refills: number, startsAt: any, updatedAt: any, procedureDefs: Array<{ __typename?: 'ProcedureDefinition', id: string, name: string, description: string, price: number, duration: number, assessmentFormTemplateId?: string | null, interventionFormTemplateId?: string | null, ordersRequired: boolean, createdAt: any, intakeFormTemplates: Array<{ __typename?: 'FormTemplate', id: string, name: string }> }>, profile?: { __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null } | null, organizations: Array<{ __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null }> }>, vitals: Array<{ __typename?: 'VitalSign', id: string, createdAt: any, createdById: string, recordedAt: any, type: VitalSignType, updatedAt: any, value: string }>, signedConsentForms: Array<{ __typename?: 'DocumentSignature', id: string, signerName: string, signerEmail?: string | null, signerType: DocumentSignatureSignerType, signedAt: any, verificationType: DocumentSignatureVerificationType, verificationDetail?: string | null, tzid: string, latitude?: number | null, longitude?: number | null, documentId: string, version: number, documentLabel: string, url?: string | null, createdAt: any, updatedAt: any }>, allergyRecords: Array<{ __typename?: 'AllergyIntolerance', id: string, name: string }>, clinicalProcedureRecords: Array<{ __typename?: 'ClinicalProcedure', id: string, name: string }>, conditionRecords: Array<{ __typename?: 'Condition', id: string, name: string }>, immunizationRecords: Array<{ __typename?: 'Immunization', id: string, name: string }>, labRecords: Array<{ __typename?: 'Lab', id: string, name: string }>, medicationRecords: Array<{ __typename?: 'MedicationStatement', id: string, name: string }>, attachments?: Array<{ __typename?: 'Document', id: string, filename: string, label: string, type: DocumentType, version: number, fileSize: number, url: string, createdAt: any, updatedAt: any }> | null } | null } | { __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null } | null, responses: Array<{ __typename?: 'AppointmentResponse', id: string, start?: any | null, end?: any | null, createdAt: any, updatedAt: any }>, forms: Array<{ __typename?: 'Form', id: string, type: FormType, status: FormStatusType, patientId: string, lockedById?: string | null, editable: boolean, createdAt: any, updatedAt: any, items: Array<{ __typename?: 'FormItem', id: string, index: number, label: string, type: FormItemType, code: string, options?: string | null, createdAt: any, updatedAt: any }>, observations: Array<{ __typename?: 'Observation', id: string, code: string, value: string, note?: string | null, createdById: string, createdAt: any, updatedAt: any, createdBy?: { __typename?: 'Profile', id: string, givenName: string, familyName: string, title: string } | null }>, lockedBy?: { __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null } | null, document?: { __typename?: 'Document', id: string, filename: string, label: string, type: DocumentType, version: number, fileSize: number, url: string, createdAt: any, updatedAt: any } | null, attachments?: Array<{ __typename?: 'Document', id: string, filename: string, label: string, type: DocumentType, version: number, fileSize: number, url: string, createdAt: any, updatedAt: any }> | null, notes: Array<{ __typename?: 'FormNote', id: string, note: string, edited: boolean, profileId: string, createdAt: any, updatedAt: any, author: string }> }> }>, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }> } | null, appointmentRequest?: { __typename?: 'AppointmentRequest', id: string, location: string, latitude?: number | null, longitude?: number | null, status: AppointmentRequestStatus, bookingMode?: BookingMode | null, cancelReason?: string | null, notes?: string | null, lastResetAt?: any | null, waitlistedAt?: any | null, createdAt: any, updatedAt: any, archivedAt?: any | null, marketplace: { __typename?: 'Marketplace', id: string, name: string, groupId: string, createdAt: any, logo?: string | null, favicon?: string | null, primaryColor?: string | null, marketingSiteUrl?: string | null, gtmContainer?: string | null, gtmRequiresConsent: boolean, gtmDataTier: GtmDataTier, gtmV2Enabled: boolean, featureFlags: { __typename?: 'MarketplaceFeatureFlags', waitListEnabled?: boolean | null, acceptedPaymentMethods?: { __typename?: 'AcceptedPaymentMethods', creditCard?: boolean | null, applePay?: boolean | null } | null } }, clientProfiles: Array<{ __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null }>, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }>, constraints: Array<{ __typename?: 'AppointmentConstraint', id: string, organizations: Array<{ __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null }>, profiles: Array<{ __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null }>, timeRanges: Array<{ __typename?: 'AppointmentTimeRange', id: string, start: any, end: any }> }>, additionalPatients: Array<{ __typename?: 'AppointmentRequestPatient', id: string, clientProfile: { __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null }, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }> }> } | null, items: Array<{ __typename?: 'CheckoutItem', id: string, type: CheckoutItemType, description: string, quantity: number, price: number, key?: string | null }>, payments: Array<{ __typename?: 'Payment', id: string, type: PaymentType, status: PaymentStatus, description: string, amount: number, amountRequested: number, amountReversed?: number | null, isDeposit: boolean, createdAt: any, updatedAt: any }>, payouts: Array<{ __typename?: 'Payout', id: string, status: PayoutStatus, description: string, amount: number, amountRequested: number, amountReversed?: number | null, createdAt: any, updatedAt: any, checkoutId: string }>, paymentInstrument?: { __typename?: 'PaymentInstrument', id: string, type: PaymentInstrumentType, processor: PaymentAccountPlatform, brand?: string | null, lastFour?: string | null, expirationMonth?: number | null, expirationYear?: number | null, createdAt: any, updatedAt: any } | null, marketplaceUser?: { __typename?: 'MarketplaceUser', id: string, createdAt: any, updatedAt: any, groupId: string, membership: string, primaryInstrumentId?: string | null, email?: string | null, phone?: string | null, emailConfirmed: boolean, phoneConfirmed: boolean, emailOptIn: boolean, phoneOptIn: boolean, clientProfile?: { __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null } | null } | null, paymentLinks: Array<{ __typename?: 'PaymentLink', id: string, checkoutId: string, url: string, status: PaymentLinkStatus, amount: number, expiresAt?: any | null, createdAt: any, updatedAt: any }> } };

export type UpdateClientProfileMutationVariables = Exact<{
  input: UpdateClientProfileInput;
}>;


export type UpdateClientProfileMutation = { __typename?: 'Mutation', updateClientProfile?: { __typename?: 'ClientProfile', internalNotesUpdatedBy?: string | null, internalNotesUpdatedAt?: any | null, id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null } | null };

export type UpdateDiscountMutationVariables = Exact<{
  input: UpdateDiscountInput;
}>;


export type UpdateDiscountMutation = { __typename?: 'Mutation', updateDiscount?: { __typename?: 'Discount', id: string, percentage: number, membershipDefinitionId: string, procedureGroups: Array<{ __typename?: 'ProcedureBaseDefinitionGroup', id: string, name: string }> } | null };

export type UpdateDocumentMutationVariables = Exact<{
  input: UpdateDocumentInput;
}>;


export type UpdateDocumentMutation = { __typename?: 'Mutation', updateDocument: { __typename?: 'Document', id: string, filename: string, label: string, type: DocumentType, version: number, fileSize: number, url: string, createdAt: any, updatedAt: any } };

export type UpdateEmrInstanceMutationVariables = Exact<{
  input: UpdateEmrInstanceInput;
}>;


export type UpdateEmrInstanceMutation = { __typename?: 'Mutation', updateEmrInstance: { __typename?: 'EmrInstance', id: string, label: string, createdAt: any } };

export type UpdateFormNoteMutationVariables = Exact<{
  input: UpdateFormNoteInput;
}>;


export type UpdateFormNoteMutation = { __typename?: 'Mutation', updateFormNote?: { __typename?: 'FormNote', id: string, note: string, edited: boolean, profileId: string, createdAt: any, updatedAt: any, author: string } | null };

export type UpdateFormTemplateMutationVariables = Exact<{
  input: UpdateFormTemplateInput;
}>;


export type UpdateFormTemplateMutation = { __typename?: 'Mutation', updateFormTemplate?: { __typename?: 'FormTemplate', id: string, name: string, type: FormType, parentId?: string | null, createdAt: any, updatedAt: any, items: Array<{ __typename?: 'FormTemplateItem', id: string, index: number, label: string, type: FormItemType, options?: string | null, createdAt: any, updatedAt: any }> } | null };

export type UpdateGeoperimeterMutationVariables = Exact<{
  input: UpdateGeoperimeterInput;
}>;


export type UpdateGeoperimeterMutation = { __typename?: 'Mutation', updateGeoperimeter?: { __typename?: 'Geoperimeter', id: string, type: GeoperimeterType, organizationId: string, lat?: number | null, lng?: number | null, radius?: number | null, paths?: string | null, travelFee?: number | null } | null };

export type UpdateGroupAppointmentMutationVariables = Exact<{
  input: UpdateGroupAppointmentInput;
}>;


export type UpdateGroupAppointmentMutation = { __typename?: 'Mutation', updateGroupAppointment: Array<{ __typename?: 'Appointment', id: string, location: string, latitude?: number | null, longitude?: number | null, start: any, end: any, duration: number, createdAt: any, updatedAt: any, archivedAt?: any | null, status: AppointmentStatus, startedAt?: any | null, completedAt?: any | null, notes?: string | null, createdBy?: string | null, cancelReason?: string | null, groupId?: string | null, ordersRequired: boolean, participants: Array<{ __typename?: 'AppointmentParticipant', id: string, name: string, type: ParticipantType, status: ParticipationStatus, profileId?: string | null, clientProfileId?: string | null, orderApproved?: boolean | null, participant?: { __typename?: 'ClientProfile', internalNotesUpdatedBy?: string | null, internalNotesUpdatedAt?: any | null, id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null, patient?: { __typename?: 'Patient', id: string, allergies?: string | null, archivedAt?: any | null, clientProfileId: string, conditions?: string | null, createdAt: any, emrInstanceId: string, immunizations?: string | null, labs?: string | null, medications?: string | null, procedures?: string | null, updatedAt: any, orders: Array<{ __typename?: 'Order', id: string, archivedAt?: any | null, createdAt: any, expiresAt: any, providerType: ProviderType, fillCount: number, note?: string | null, refills: number, startsAt: any, updatedAt: any, procedureDefs: Array<{ __typename?: 'ProcedureDefinition', id: string, name: string, description: string, price: number, duration: number, assessmentFormTemplateId?: string | null, interventionFormTemplateId?: string | null, ordersRequired: boolean, createdAt: any, intakeFormTemplates: Array<{ __typename?: 'FormTemplate', id: string, name: string }> }>, profile?: { __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null } | null, organizations: Array<{ __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null }> }>, vitals: Array<{ __typename?: 'VitalSign', id: string, createdAt: any, createdById: string, recordedAt: any, type: VitalSignType, updatedAt: any, value: string }>, signedConsentForms: Array<{ __typename?: 'DocumentSignature', id: string, signerName: string, signerEmail?: string | null, signerType: DocumentSignatureSignerType, signedAt: any, verificationType: DocumentSignatureVerificationType, verificationDetail?: string | null, tzid: string, latitude?: number | null, longitude?: number | null, documentId: string, version: number, documentLabel: string, url?: string | null, createdAt: any, updatedAt: any }>, allergyRecords: Array<{ __typename?: 'AllergyIntolerance', id: string, name: string }>, clinicalProcedureRecords: Array<{ __typename?: 'ClinicalProcedure', id: string, name: string }>, conditionRecords: Array<{ __typename?: 'Condition', id: string, name: string }>, immunizationRecords: Array<{ __typename?: 'Immunization', id: string, name: string }>, labRecords: Array<{ __typename?: 'Lab', id: string, name: string }>, medicationRecords: Array<{ __typename?: 'MedicationStatement', id: string, name: string }>, attachments?: Array<{ __typename?: 'Document', id: string, filename: string, label: string, type: DocumentType, version: number, fileSize: number, url: string, createdAt: any, updatedAt: any }> | null } | null } | { __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null } | null, responses: Array<{ __typename?: 'AppointmentResponse', id: string, start?: any | null, end?: any | null, createdAt: any, updatedAt: any }>, forms: Array<{ __typename?: 'Form', id: string, type: FormType, status: FormStatusType, patientId: string, lockedById?: string | null, editable: boolean, createdAt: any, updatedAt: any, items: Array<{ __typename?: 'FormItem', id: string, index: number, label: string, type: FormItemType, code: string, options?: string | null, createdAt: any, updatedAt: any }>, observations: Array<{ __typename?: 'Observation', id: string, code: string, value: string, note?: string | null, createdById: string, createdAt: any, updatedAt: any, createdBy?: { __typename?: 'Profile', id: string, givenName: string, familyName: string, title: string } | null }>, lockedBy?: { __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null } | null, document?: { __typename?: 'Document', id: string, filename: string, label: string, type: DocumentType, version: number, fileSize: number, url: string, createdAt: any, updatedAt: any } | null, attachments?: Array<{ __typename?: 'Document', id: string, filename: string, label: string, type: DocumentType, version: number, fileSize: number, url: string, createdAt: any, updatedAt: any }> | null, notes: Array<{ __typename?: 'FormNote', id: string, note: string, edited: boolean, profileId: string, createdAt: any, updatedAt: any, author: string }> }> }>, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }>, checkout?: { __typename?: 'Checkout', id: string, total: number, paid: number, balance: number, marketplaceUserId?: string | null, summary?: string | null, voidedAt?: any | null, paymentMethodType?: PaymentMethodType | null, createdAt: any, updatedAt: any, items: Array<{ __typename?: 'CheckoutItem', id: string, type: CheckoutItemType, description: string, quantity: number, price: number, key?: string | null }>, payments: Array<{ __typename?: 'Payment', id: string, type: PaymentType, status: PaymentStatus, description: string, amount: number, amountRequested: number, amountReversed?: number | null, isDeposit: boolean, createdAt: any, updatedAt: any }>, payouts: Array<{ __typename?: 'Payout', id: string, status: PayoutStatus, description: string, amount: number, amountRequested: number, amountReversed?: number | null, createdAt: any, updatedAt: any, checkoutId: string }>, paymentInstrument?: { __typename?: 'PaymentInstrument', id: string, type: PaymentInstrumentType, processor: PaymentAccountPlatform, brand?: string | null, lastFour?: string | null, expirationMonth?: number | null, expirationYear?: number | null, createdAt: any, updatedAt: any } | null, marketplaceUser?: { __typename?: 'MarketplaceUser', id: string, createdAt: any, updatedAt: any, groupId: string, membership: string, primaryInstrumentId?: string | null, email?: string | null, phone?: string | null, emailConfirmed: boolean, phoneConfirmed: boolean, emailOptIn: boolean, phoneOptIn: boolean, clientProfile?: { __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null } | null } | null, paymentLinks: Array<{ __typename?: 'PaymentLink', id: string, checkoutId: string, url: string, status: PaymentLinkStatus, amount: number, expiresAt?: any | null, createdAt: any, updatedAt: any }> } | null, qualiphyInvitation?: { __typename?: 'QualiphyInvitation', id: string, expiration: any, meetingUrl?: string | null, exams?: Array<{ __typename?: 'QualiphyExam', id: string, title: string, status?: QualiphyInvitationStatus | null }> | null } | null, additionalPatients: Array<{ __typename?: 'AppointmentRequestPatient', id: string, clientProfile: { __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null }, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }> }> }> };

export type UpdateMarketplaceMutationVariables = Exact<{
  input: UpdateMarketplaceInput;
}>;


export type UpdateMarketplaceMutation = { __typename?: 'Mutation', updateMarketplace?: { __typename?: 'Marketplace', requireDispatchApproval: boolean, requirePractitionerApproval: boolean, dispatchStrategy?: DispatchStrategy | null, bookingMode?: BookingMode | null, slackWebhookUrl?: string | null, reviewsIoKeyDescription?: string | null, consentTokenSecretDescription?: string | null, reviewsIoStoreId?: string | null, paymentAccountId?: string | null, feeProfileFixed?: number | null, feeProfileBasisPoints?: number | null, logo?: string | null, favicon?: string | null, primaryColor?: string | null, marketingSiteUrl?: string | null, paymentCollectionMethod?: PaymentCollectionMethod | null, paymentDepositType?: PaymentDepositType | null, paymentDepositValue?: number | null, hasPaymentPolicy?: boolean | null, paymentPolicyName?: string | null, paymentPolicyText?: string | null, requirePaymentPolicyAttestation?: boolean | null, id: string, name: string, groupId: string, createdAt: any, gtmContainer?: string | null, gtmRequiresConsent: boolean, gtmDataTier: GtmDataTier, gtmV2Enabled: boolean, checkoutContent: { __typename?: 'MarketplaceCheckoutContent', servicesNotice?: string | null, scheduleNotice?: string | null, confirmationMessage?: string | null, footerLinks: Array<{ __typename?: 'MarketplaceFooterLink', label: string, url: string }> }, featureFlags: { __typename?: 'MarketplaceFeatureFlags', waitListEnabled?: boolean | null, acceptedPaymentMethods?: { __typename?: 'AcceptedPaymentMethods', creditCard?: boolean | null, applePay?: boolean | null } | null, windowBooking?: { __typename?: 'WindowBookingConfig', allowSpecificTimeRequest?: boolean | null, minRemainingMinutes?: number | null, windows?: Array<{ __typename?: 'WindowConfig', key: WindowKey, enabled: boolean, startTime: string, endTime: string }> | null } | null } } | null };

export type UpdateMarketplaceCheckoutNotesMutationVariables = Exact<{
  input: UpdateMarketplaceCheckoutNotesInput;
}>;


export type UpdateMarketplaceCheckoutNotesMutation = { __typename?: 'Mutation', updateMarketplaceCheckoutNotes?: { __typename?: 'Marketplace', id: string, checkoutNotes: Array<{ __typename?: 'CheckoutNoteItem', id: string, index: number, label: string, type: FormItemType, options?: string | null, createdAt: any, updatedAt: any }> } | null };

export type UpdateMarketplaceGroupMutationVariables = Exact<{
  input: UpdateMarketplaceGroupInput;
}>;


export type UpdateMarketplaceGroupMutation = { __typename?: 'Mutation', updateMarketplaceGroup?: { __typename?: 'MarketplaceGroup', id: string, label: string, createdAt: any, messagingServiceSid?: string | null } | null };

export type UpdateMarketplaceMfaModeMutationVariables = Exact<{
  input: UpdateMarketplaceMfaModeInput;
}>;


export type UpdateMarketplaceMfaModeMutation = { __typename?: 'Mutation', updateMarketplaceMfaMode: { __typename?: 'Marketplace', id: string, mfaMode?: { __typename?: 'MfaScopeMode', setting: MfaModeSetting, inherited: MfaMode, effective: MfaMode, enabled: boolean } | null } };

export type UpdateMarketplaceUserMutationVariables = Exact<{
  input: UpdateMarketplaceUserInput;
}>;


export type UpdateMarketplaceUserMutation = { __typename?: 'Mutation', updateMarketplaceUser?: { __typename?: 'MarketplaceUser', id: string, createdAt: any, updatedAt: any, groupId: string, membership: string, primaryInstrumentId?: string | null, email?: string | null, phone?: string | null, emailConfirmed: boolean, phoneConfirmed: boolean, emailOptIn: boolean, phoneOptIn: boolean, clientProfile?: { __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null } | null } | null };

export type UpdateMedicationMutationVariables = Exact<{
  input: UpdateMedicationInput;
}>;


export type UpdateMedicationMutation = { __typename?: 'Mutation', updateMedication: { __typename?: 'Medication', id: string, name: string, unit: string, createdAt: any } };

export type UpdateMembershipMutationVariables = Exact<{
  input: UpdateMembershipInput;
}>;


export type UpdateMembershipMutation = { __typename?: 'Mutation', updateMembership: { __typename?: 'Membership', id: string, membershipDefinitionId: string, renewalDate: any, name: string, status: MembershipStatusType } };

export type UpdateMembershipDefinitionMutationVariables = Exact<{
  input: UpdateMembershipDefinitionInput;
}>;


export type UpdateMembershipDefinitionMutation = { __typename?: 'Mutation', updateMembershipDefinition?: { __typename?: 'MembershipDefinition', id: string, name: string, price: number, period: MembershipDefinitionPeriodType, packageId?: string | null, marketplaceId: string, advertise: boolean, description?: string | null, list?: string | null, discounts: Array<{ __typename?: 'Discount', id: string, percentage: number, membershipDefinitionId: string, procedureGroups: Array<{ __typename?: 'ProcedureBaseDefinitionGroup', id: string, name: string }> }> } | null };

export type UpdateNavigationGroupMutationVariables = Exact<{
  input: UpdateConfigGroupInput;
}>;


export type UpdateNavigationGroupMutation = { __typename?: 'Mutation', updateNavigationGroup?: { __typename?: 'ProcedureBaseDefinitionGroup', id: string, name: string, thumbnail?: string | null, banner?: string | null, type: ProcedureGroupType, description?: string | null, bgcolor?: string | null, fontColor?: string | null, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string }>, featuredBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string }>, procedureBaseDefGroups: Array<{ __typename?: 'ProcedureBaseDefinitionGroup', id: string, name: string, type: ProcedureGroupType }> } | null };

export type UpdateNotificationsGroupMutationVariables = Exact<{
  input: UpdateConfigGroupInput;
}>;


export type UpdateNotificationsGroupMutation = { __typename?: 'Mutation', updateNotificationsGroup?: { __typename?: 'ProcedureBaseDefinitionGroup', id: string, name: string, thumbnail?: string | null, banner?: string | null, type: ProcedureGroupType, description?: string | null, bgcolor?: string | null, fontColor?: string | null, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string }>, featuredBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string }>, procedureBaseDefGroups: Array<{ __typename?: 'ProcedureBaseDefinitionGroup', id: string, name: string, type: ProcedureGroupType }> } | null };

export type UpdateOrderMutationVariables = Exact<{
  input: UpdateOrderInput;
}>;


export type UpdateOrderMutation = { __typename?: 'Mutation', updateOrder: { __typename?: 'Order', id: string, archivedAt?: any | null, createdAt: any, expiresAt: any, providerType: ProviderType, fillCount: number, note?: string | null, refills: number, startsAt: any, updatedAt: any, procedureDefs: Array<{ __typename?: 'ProcedureDefinition', id: string, name: string, description: string, price: number, duration: number, assessmentFormTemplateId?: string | null, interventionFormTemplateId?: string | null, ordersRequired: boolean, createdAt: any, intakeFormTemplates: Array<{ __typename?: 'FormTemplate', id: string, name: string }> }>, profile?: { __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null } | null, organizations: Array<{ __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null }> } };

export type UpdateOrganizationMutationVariables = Exact<{
  input: UpdateOrganizationInput;
}>;


export type UpdateOrganizationMutation = { __typename?: 'Mutation', updateOrganization?: { __typename?: 'Organization', slackWebhookUrl?: string | null, googleReviewsUrl?: string | null, paymentAccountId?: string | null, id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null };

export type UpdateOrganizationMfaModeMutationVariables = Exact<{
  input: UpdateOrganizationMfaModeInput;
}>;


export type UpdateOrganizationMfaModeMutation = { __typename?: 'Mutation', updateOrganizationMfaMode: { __typename?: 'Organization', id: string, mfaMode?: { __typename?: 'MfaScopeMode', setting: MfaModeSetting, inherited: MfaMode, effective: MfaMode, enabled: boolean } | null } };

export type UpdatePackageMutationVariables = Exact<{
  input: UpdatePackageInput;
}>;


export type UpdatePackageMutation = { __typename?: 'Mutation', updatePackage?: { __typename?: 'Package', id: string, name: string, price: number, marketplaceId: string, advertise: boolean, description?: string | null, list?: string | null, packageItemDefinitions: Array<{ __typename?: 'PackageItemDefinition', id: string, packageId: string, points: number, procedureGroups: Array<string> }> } | null };

export type UpdatePackageItemMutationVariables = Exact<{
  input: UpdatePackageItemInput;
}>;


export type UpdatePackageItemMutation = { __typename?: 'Mutation', updatePackageItem: { __typename?: 'PackageItem', id: string, packageItemDefinitionId: string, membershipId?: string | null, balance: number, packageName: string, totalPoints: number, groupNames: string, expiresAt?: any | null, primaryOrganizationId?: string | null } };

export type UpdatePackageItemDefinitionMutationVariables = Exact<{
  input: UpdatePackageItemDefinitionInput;
}>;


export type UpdatePackageItemDefinitionMutation = { __typename?: 'Mutation', updatePackageItemDefinition?: { __typename?: 'PackageItemDefinition', id: string, packageId: string, points: number, procedureGroups: Array<string> } | null };

export type UpdatePatientMutationVariables = Exact<{
  input: UpdatePatientInput;
}>;


export type UpdatePatientMutation = { __typename?: 'Mutation', updatePatient: { __typename?: 'Patient', id: string, allergies?: string | null, archivedAt?: any | null, clientProfileId: string, conditions?: string | null, createdAt: any, emrInstanceId: string, immunizations?: string | null, labs?: string | null, medications?: string | null, procedures?: string | null, updatedAt: any } };

export type UpdatePaymentAccountMutationVariables = Exact<{
  input: UpdatePaymentAccountInput;
}>;


export type UpdatePaymentAccountMutation = { __typename?: 'Mutation', updatePaymentAccount: { __typename?: 'PaymentAccount', id: string, label: string, platform: PaymentAccountPlatform, enabled: boolean, state: PaymentAccountState, onboardingUrl?: string | null, createdAt: any, updatedAt: any } };

export type UpdateProcedureBaseDefinitionMutationVariables = Exact<{
  input: UpdateProcedureBaseDefinitionInput;
}>;


export type UpdateProcedureBaseDefinitionMutation = { __typename?: 'Mutation', updateProcedureBaseDefinition?: { __typename?: 'ProcedureBaseDefinition', tags: Array<string>, addOns: Array<string>, id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null, layouts: Array<{ __typename?: 'ProcedureBaseDefinitionLayout', type: ProcedureBaseDefinitionLayoutType, layout: string, itemIndex: number }> } | null };

export type UpdateProcedureBaseDefGroupMutationVariables = Exact<{
  input: UpdateProcedureBaseDefinitionGroupInput;
}>;


export type UpdateProcedureBaseDefGroupMutation = { __typename?: 'Mutation', updateProcedureBaseDefinitionGroup?: { __typename?: 'ProcedureBaseDefinitionGroup', id: string, name: string, thumbnail?: string | null, banner?: string | null, type: ProcedureGroupType, description?: string | null, bgcolor?: string | null, fontColor?: string | null, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string }>, featuredBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string }>, procedureBaseDefGroups: Array<{ __typename?: 'ProcedureBaseDefinitionGroup', id: string, name: string, type: ProcedureGroupType }> } | null };

export type UpdateProcedureDefinitionMutationVariables = Exact<{
  input: UpdateProcedureDefinitionInput;
}>;


export type UpdateProcedureDefinitionMutation = { __typename?: 'Mutation', updateProcedureDefinition?: { __typename?: 'ProcedureDefinition', id: string, name: string, description: string, price: number, duration: number, assessmentFormTemplateId?: string | null, interventionFormTemplateId?: string | null, ordersRequired: boolean, createdAt: any, baseDefinitions: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }>, medicationProtocols: Array<{ __typename?: 'MedicationProtocol', id: string, dose: number, createdAt: any, medication: { __typename?: 'Medication', id: string, name: string, unit: string, createdAt: any } }>, consentForms: Array<{ __typename?: 'Document', id: string, filename: string, label: string, type: DocumentType, version: number, fileSize: number, url: string, createdAt: any, updatedAt: any }>, intakeFormTemplates: Array<{ __typename?: 'FormTemplate', id: string, name: string }> } | null };

export type UpdateProcedureProfileMutationVariables = Exact<{
  input: UpdateProcedureProfileInput;
}>;


export type UpdateProcedureProfileMutation = { __typename?: 'Mutation', updateProcedureProfile?: { __typename?: 'ProcedureProfile', createdAt: any, id: string, name: string, updatedAt: any, procedureDefs: Array<{ __typename?: 'ProcedureDefinition', id: string, name: string, description: string, price: number, duration: number, assessmentFormTemplateId?: string | null, interventionFormTemplateId?: string | null, ordersRequired: boolean, createdAt: any, intakeFormTemplates: Array<{ __typename?: 'FormTemplate', id: string, name: string }> }> } | null };

export type UpdateProfileMutationVariables = Exact<{
  input: UpdateProfileInput;
}>;


export type UpdateProfileMutation = { __typename?: 'Mutation', updateProfile: { __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, procedureProfiles: Array<{ __typename?: 'ProcedureProfile', createdAt: any, id: string, name: string, updatedAt: any, procedureDefs: Array<{ __typename?: 'ProcedureDefinition', id: string, name: string, description: string, price: number, duration: number, assessmentFormTemplateId?: string | null, interventionFormTemplateId?: string | null, ordersRequired: boolean, createdAt: any, baseDefinitions: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }>, intakeFormTemplates: Array<{ __typename?: 'FormTemplate', id: string, name: string }> }> }>, availabilities: Array<{ __typename?: 'Availability', id: string, type: AvailabilityType, start: any, end: any, tzid: string, duration: number, createdAt: any, updatedAt: any, repeat?: { __typename?: 'RepeatRule', id: string, frequency: RepeatFrequencyType, byWeekday: Array<RepeatWeekdayType>, until?: any | null } | null }>, roles: Array<{ __typename?: 'Role', id: string, name: string, scope: RoleScope, type: RoleType, permissions: Array<string>, resourceId?: string | null }>, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null } };

export type UpdatePromoCodeMutationVariables = Exact<{
  input: UpdatePromoCodeInput;
}>;


export type UpdatePromoCodeMutation = { __typename?: 'Mutation', updatePromoCode?: { __typename?: 'PromoCode', id: string, name: string, code: string, discountType: PromoCodeDiscountType, discountValue: number, activationStartDate: any, activationEndDate: any, usageStartDate: any, usageEndDate: any, usageLimitTotal?: number | null, usageLimitPerUser?: number | null, minimumBookingAmount?: number | null, active: boolean, marketplaceId: string, createdAt: any, updatedAt: any, procedureGroups: Array<{ __typename?: 'ProcedureBaseDefinitionGroup', id: string, name: string }>, organizations: Array<{ __typename?: 'Organization', id: string, name: string }>, usage: Array<{ __typename?: 'PromoCodeUsage', id: string, marketplaceUserId: string, discountAmount: number, usedAt: any }> } | null };

export type UpdateQualiphyExamMutationVariables = Exact<{
  input: UpdateQualiphyExamInput;
}>;


export type UpdateQualiphyExamMutation = { __typename?: 'Mutation', updateQualiphyExam?: { __typename?: 'QualiphyExam', id: string, qualiphyId: string, title: string, index: number, procedureDefinitions?: Array<string> | null, expiresAfter: number, refills: number, archived: boolean } | null };

export type UpdateQualiphyIntegrationMutationVariables = Exact<{
  input: UpdateQualiphyIntegrationInput;
}>;


export type UpdateQualiphyIntegrationMutation = { __typename?: 'Mutation', updateQualiphyIntegration?: { __typename?: 'QualiphyIntegration', id: string, enabled: boolean, apiKeyDescription?: string | null, exams?: Array<{ __typename?: 'QualiphyExam', id: string, qualiphyId: string, title: string, index: number, procedureDefinitions?: Array<string> | null, expiresAfter: number, refills: number, archived: boolean }> | null } | null };

export type UpdateReviewsGroupMutationVariables = Exact<{
  input: UpdateConfigGroupInput;
}>;


export type UpdateReviewsGroupMutation = { __typename?: 'Mutation', updateReviewsGroup?: { __typename?: 'ProcedureBaseDefinitionGroup', id: string, name: string, thumbnail?: string | null, banner?: string | null, type: ProcedureGroupType, description?: string | null, bgcolor?: string | null, fontColor?: string | null, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string }>, featuredBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string }>, procedureBaseDefGroups: Array<{ __typename?: 'ProcedureBaseDefinitionGroup', id: string, name: string, type: ProcedureGroupType }> } | null };

export type UpdateRoleMutationVariables = Exact<{
  input: UpdateRoleInput;
}>;


export type UpdateRoleMutation = { __typename?: 'Mutation', updateRole?: { __typename?: 'Role', id: string, name: string, scope: RoleScope, type: RoleType, permissions: Array<string>, resourceId?: string | null } | null };

export type UpdateSegmentIntegrationMutationVariables = Exact<{
  input: UpdateSegmentIntegrationInput;
}>;


export type UpdateSegmentIntegrationMutation = { __typename?: 'Mutation', updateSegmentIntegration?: { __typename?: 'SegmentIntegration', id: string, writeKeyDescription?: string | null, enabled: boolean, v2Enabled: boolean, v2WriteKeyDescription?: string | null, clientWriteKey?: string | null } | null };

export type UpdateSendgridIntegrationMutationVariables = Exact<{
  input: UpdateSendgridIntegrationInput;
}>;


export type UpdateSendgridIntegrationMutation = { __typename?: 'Mutation', updateSendgridIntegration?: { __typename?: 'SendgridIntegration', apiKeyDescription?: string | null, enabled: boolean, domain: string, webOrigin: string } | null };

export type UpdateTwilioIntegrationMutationVariables = Exact<{
  input: UpdateTwilioIntegrationInput;
}>;


export type UpdateTwilioIntegrationMutation = { __typename?: 'Mutation', updateTwilioIntegration?: { __typename?: 'TwilioIntegration', id: string, appointmentsEnabled: boolean, appointmentRequestsEnabled: boolean, waitlistTextsEnabled: boolean, intakeTextsEnabled: boolean } | null };

export type UsePaymentAccountMutationVariables = Exact<{
  input: UsePaymentAccountInput;
}>;


export type UsePaymentAccountMutation = { __typename?: 'Mutation', usePaymentAccount: boolean };

export type VerifyMfaMutationVariables = Exact<{
  input: VerifyMfaInput;
}>;


export type VerifyMfaMutation = { __typename?: 'Mutation', verifyMfa: { __typename?: 'AuthenticatePayload', user: { __typename?: 'User', id: string } } };

export type VerifyMfaStepUpMutationVariables = Exact<{
  input: VerifyMfaStepUpInput;
}>;


export type VerifyMfaStepUpMutation = { __typename?: 'Mutation', verifyMfaStepUp: { __typename?: 'AuthenticatePayload', user: { __typename?: 'User', id: string } } };

export type WaitlistAppointmentRequestMutationVariables = Exact<{
  input: WaitlistAppointmentRequestInput;
}>;


export type WaitlistAppointmentRequestMutation = { __typename?: 'Mutation', waitlistAppointmentRequest?: { __typename?: 'AppointmentRequest', id: string, location: string, latitude?: number | null, longitude?: number | null, status: AppointmentRequestStatus, bookingMode?: BookingMode | null, cancelReason?: string | null, notes?: string | null, lastResetAt?: any | null, waitlistedAt?: any | null, createdAt: any, updatedAt: any, archivedAt?: any | null, declinedProfiles: Array<{ __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null }>, clientProfiles: Array<{ __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null, marketplaceUsers: Array<{ __typename?: 'MarketplaceUser', marketplaceIds: Array<string>, id: string, createdAt: any, updatedAt: any, groupId: string, membership: string, primaryInstrumentId?: string | null, email?: string | null, phone?: string | null, emailConfirmed: boolean, phoneConfirmed: boolean, emailOptIn: boolean, phoneOptIn: boolean, memberships: Array<{ __typename?: 'Membership', marketplaceName: string, id: string, membershipDefinitionId: string, renewalDate: any, name: string, status: MembershipStatusType }>, packageItems: Array<{ __typename?: 'PackageItem', marketplaceName: string, id: string, packageItemDefinitionId: string, membershipId?: string | null, balance: number, packageName: string, totalPoints: number, groupNames: string, expiresAt?: any | null, primaryOrganizationId?: string | null }>, clientProfiles: Array<{ __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null, organizations: Array<{ __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null }> }>, marketplaceGroup: { __typename?: 'MarketplaceGroup', id: string, label: string, createdAt: any, messagingServiceSid?: string | null }, paymentInstruments: Array<{ __typename?: 'PaymentInstrument', id: string, type: PaymentInstrumentType, processor: PaymentAccountPlatform, brand?: string | null, lastFour?: string | null, expirationMonth?: number | null, expirationYear?: number | null, createdAt: any, updatedAt: any }>, checkouts: Array<{ __typename?: 'Checkout', id: string, total: number, paid: number, balance: number, marketplaceUserId?: string | null, summary?: string | null, voidedAt?: any | null, paymentMethodType?: PaymentMethodType | null, createdAt: any, updatedAt: any, items: Array<{ __typename?: 'CheckoutItem', id: string, type: CheckoutItemType, description: string, quantity: number, price: number, key?: string | null }>, paymentLinks: Array<{ __typename?: 'PaymentLink', id: string, checkoutId: string, url: string, status: PaymentLinkStatus, amount: number, expiresAt?: any | null, createdAt: any, updatedAt: any }> }>, appointments: Array<{ __typename?: 'Appointment', intakeStatus?: string | null, id: string, location: string, latitude?: number | null, longitude?: number | null, start: any, end: any, duration: number, createdAt: any, updatedAt: any, archivedAt?: any | null, status: AppointmentStatus, startedAt?: any | null, completedAt?: any | null, notes?: string | null, createdBy?: string | null, cancelReason?: string | null, groupId?: string | null, ordersRequired: boolean, participants: Array<{ __typename?: 'AppointmentParticipant', id: string, name: string, type: ParticipantType, status: ParticipationStatus, profileId?: string | null, clientProfileId?: string | null, orderApproved?: boolean | null }>, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }>, checkout?: { __typename?: 'Checkout', id: string, total: number, paid: number, balance: number, marketplaceUserId?: string | null, summary?: string | null, voidedAt?: any | null, paymentMethodType?: PaymentMethodType | null, createdAt: any, updatedAt: any, paymentLinks: Array<{ __typename?: 'PaymentLink', id: string, checkoutId: string, url: string, status: PaymentLinkStatus, amount: number, expiresAt?: any | null, createdAt: any, updatedAt: any }> } | null, additionalPatients: Array<{ __typename?: 'AppointmentRequestPatient', id: string, clientProfile: { __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null }, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }> }> }>, appointmentRequests: Array<{ __typename?: 'AppointmentRequest', id: string, location: string, latitude?: number | null, longitude?: number | null, status: AppointmentRequestStatus, bookingMode?: BookingMode | null, cancelReason?: string | null, notes?: string | null, lastResetAt?: any | null, waitlistedAt?: any | null, createdAt: any, updatedAt: any, archivedAt?: any | null, marketplace: { __typename?: 'Marketplace', id: string, name: string, groupId: string, createdAt: any, logo?: string | null, favicon?: string | null, primaryColor?: string | null, marketingSiteUrl?: string | null, gtmContainer?: string | null, gtmRequiresConsent: boolean, gtmDataTier: GtmDataTier, gtmV2Enabled: boolean, featureFlags: { __typename?: 'MarketplaceFeatureFlags', waitListEnabled?: boolean | null, acceptedPaymentMethods?: { __typename?: 'AcceptedPaymentMethods', creditCard?: boolean | null, applePay?: boolean | null } | null } }, clientProfiles: Array<{ __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null }>, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }>, constraints: Array<{ __typename?: 'AppointmentConstraint', id: string, organizations: Array<{ __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null }>, profiles: Array<{ __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null }>, timeRanges: Array<{ __typename?: 'AppointmentTimeRange', id: string, start: any, end: any }> }>, additionalPatients: Array<{ __typename?: 'AppointmentRequestPatient', id: string, clientProfile: { __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null }, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }> }> }>, clientProfile?: { __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null } | null }> }>, checkout?: { __typename?: 'Checkout', id: string, total: number, paid: number, balance: number, marketplaceUserId?: string | null, summary?: string | null, voidedAt?: any | null, paymentMethodType?: PaymentMethodType | null, createdAt: any, updatedAt: any, items: Array<{ __typename?: 'CheckoutItem', id: string, type: CheckoutItemType, description: string, quantity: number, price: number, key?: string | null }>, payments: Array<{ __typename?: 'Payment', id: string, type: PaymentType, status: PaymentStatus, description: string, amount: number, amountRequested: number, amountReversed?: number | null, isDeposit: boolean, createdAt: any, updatedAt: any }>, payouts: Array<{ __typename?: 'Payout', id: string, status: PayoutStatus, description: string, amount: number, amountRequested: number, amountReversed?: number | null, createdAt: any, updatedAt: any, checkoutId: string }>, paymentInstrument?: { __typename?: 'PaymentInstrument', id: string, type: PaymentInstrumentType, processor: PaymentAccountPlatform, brand?: string | null, lastFour?: string | null, expirationMonth?: number | null, expirationYear?: number | null, createdAt: any, updatedAt: any } | null, marketplaceUser?: { __typename?: 'MarketplaceUser', id: string, createdAt: any, updatedAt: any, groupId: string, membership: string, primaryInstrumentId?: string | null, email?: string | null, phone?: string | null, emailConfirmed: boolean, phoneConfirmed: boolean, emailOptIn: boolean, phoneOptIn: boolean, clientProfile?: { __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null } | null } | null, paymentLinks: Array<{ __typename?: 'PaymentLink', id: string, checkoutId: string, url: string, status: PaymentLinkStatus, amount: number, expiresAt?: any | null, createdAt: any, updatedAt: any }> } | null, marketplace: { __typename?: 'Marketplace', id: string, name: string, groupId: string, createdAt: any, logo?: string | null, favicon?: string | null, primaryColor?: string | null, marketingSiteUrl?: string | null, gtmContainer?: string | null, gtmRequiresConsent: boolean, gtmDataTier: GtmDataTier, gtmV2Enabled: boolean, featureFlags: { __typename?: 'MarketplaceFeatureFlags', waitListEnabled?: boolean | null, acceptedPaymentMethods?: { __typename?: 'AcceptedPaymentMethods', creditCard?: boolean | null, applePay?: boolean | null } | null } }, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }>, constraints: Array<{ __typename?: 'AppointmentConstraint', id: string, organizations: Array<{ __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null }>, profiles: Array<{ __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null }>, timeRanges: Array<{ __typename?: 'AppointmentTimeRange', id: string, start: any, end: any }> }>, additionalPatients: Array<{ __typename?: 'AppointmentRequestPatient', id: string, clientProfile: { __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null }, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }> }> } | null };

export type AppointmentQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AppointmentQuery = { __typename?: 'Query', appointment?: { __typename?: 'Appointment', intakeStatus?: string | null, id: string, location: string, latitude?: number | null, longitude?: number | null, start: any, end: any, duration: number, createdAt: any, updatedAt: any, archivedAt?: any | null, status: AppointmentStatus, startedAt?: any | null, completedAt?: any | null, notes?: string | null, createdBy?: string | null, cancelReason?: string | null, groupId?: string | null, ordersRequired: boolean, participants: Array<{ __typename?: 'AppointmentParticipant', id: string, name: string, type: ParticipantType, status: ParticipationStatus, profileId?: string | null, clientProfileId?: string | null, orderApproved?: boolean | null, participant?: { __typename?: 'ClientProfile', internalNotesUpdatedBy?: string | null, internalNotesUpdatedAt?: any | null, id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null, patient?: { __typename?: 'Patient', id: string, allergies?: string | null, archivedAt?: any | null, clientProfileId: string, conditions?: string | null, createdAt: any, emrInstanceId: string, immunizations?: string | null, labs?: string | null, medications?: string | null, procedures?: string | null, updatedAt: any, orders: Array<{ __typename?: 'Order', id: string, archivedAt?: any | null, createdAt: any, expiresAt: any, providerType: ProviderType, fillCount: number, note?: string | null, refills: number, startsAt: any, updatedAt: any, procedureDefs: Array<{ __typename?: 'ProcedureDefinition', id: string, name: string, description: string, price: number, duration: number, assessmentFormTemplateId?: string | null, interventionFormTemplateId?: string | null, ordersRequired: boolean, createdAt: any, intakeFormTemplates: Array<{ __typename?: 'FormTemplate', id: string, name: string }> }>, profile?: { __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null } | null, organizations: Array<{ __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null }> }>, vitals: Array<{ __typename?: 'VitalSign', id: string, createdAt: any, createdById: string, recordedAt: any, type: VitalSignType, updatedAt: any, value: string }>, signedConsentForms: Array<{ __typename?: 'DocumentSignature', id: string, signerName: string, signerEmail?: string | null, signerType: DocumentSignatureSignerType, signedAt: any, verificationType: DocumentSignatureVerificationType, verificationDetail?: string | null, tzid: string, latitude?: number | null, longitude?: number | null, documentId: string, version: number, documentLabel: string, url?: string | null, createdAt: any, updatedAt: any }>, allergyRecords: Array<{ __typename?: 'AllergyIntolerance', id: string, name: string }>, clinicalProcedureRecords: Array<{ __typename?: 'ClinicalProcedure', id: string, name: string }>, conditionRecords: Array<{ __typename?: 'Condition', id: string, name: string }>, immunizationRecords: Array<{ __typename?: 'Immunization', id: string, name: string }>, labRecords: Array<{ __typename?: 'Lab', id: string, name: string }>, medicationRecords: Array<{ __typename?: 'MedicationStatement', id: string, name: string }>, attachments?: Array<{ __typename?: 'Document', id: string, filename: string, label: string, type: DocumentType, version: number, fileSize: number, url: string, createdAt: any, updatedAt: any }> | null } | null } | { __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null } | null, responses: Array<{ __typename?: 'AppointmentResponse', id: string, start?: any | null, end?: any | null, createdAt: any, updatedAt: any }>, forms: Array<{ __typename?: 'Form', id: string, type: FormType, status: FormStatusType, patientId: string, lockedById?: string | null, editable: boolean, createdAt: any, updatedAt: any, items: Array<{ __typename?: 'FormItem', id: string, index: number, label: string, type: FormItemType, code: string, options?: string | null, createdAt: any, updatedAt: any }>, observations: Array<{ __typename?: 'Observation', id: string, code: string, value: string, note?: string | null, createdById: string, createdAt: any, updatedAt: any, createdBy?: { __typename?: 'Profile', id: string, givenName: string, familyName: string, title: string } | null }>, lockedBy?: { __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null } | null, document?: { __typename?: 'Document', id: string, filename: string, label: string, type: DocumentType, version: number, fileSize: number, url: string, createdAt: any, updatedAt: any } | null, attachments?: Array<{ __typename?: 'Document', id: string, filename: string, label: string, type: DocumentType, version: number, fileSize: number, url: string, createdAt: any, updatedAt: any }> | null, notes: Array<{ __typename?: 'FormNote', id: string, note: string, edited: boolean, profileId: string, createdAt: any, updatedAt: any, author: string }> }> }>, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }>, checkout?: { __typename?: 'Checkout', id: string, total: number, paid: number, balance: number, marketplaceUserId?: string | null, summary?: string | null, voidedAt?: any | null, paymentMethodType?: PaymentMethodType | null, createdAt: any, updatedAt: any, items: Array<{ __typename?: 'CheckoutItem', id: string, type: CheckoutItemType, description: string, quantity: number, price: number, key?: string | null }>, payments: Array<{ __typename?: 'Payment', id: string, type: PaymentType, status: PaymentStatus, description: string, amount: number, amountRequested: number, amountReversed?: number | null, isDeposit: boolean, createdAt: any, updatedAt: any }>, payouts: Array<{ __typename?: 'Payout', id: string, status: PayoutStatus, description: string, amount: number, amountRequested: number, amountReversed?: number | null, createdAt: any, updatedAt: any, checkoutId: string }>, paymentInstrument?: { __typename?: 'PaymentInstrument', id: string, type: PaymentInstrumentType, processor: PaymentAccountPlatform, brand?: string | null, lastFour?: string | null, expirationMonth?: number | null, expirationYear?: number | null, createdAt: any, updatedAt: any } | null, marketplaceUser?: { __typename?: 'MarketplaceUser', id: string, createdAt: any, updatedAt: any, groupId: string, membership: string, primaryInstrumentId?: string | null, email?: string | null, phone?: string | null, emailConfirmed: boolean, phoneConfirmed: boolean, emailOptIn: boolean, phoneOptIn: boolean, clientProfile?: { __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null } | null } | null, paymentLinks: Array<{ __typename?: 'PaymentLink', id: string, checkoutId: string, url: string, status: PaymentLinkStatus, amount: number, expiresAt?: any | null, createdAt: any, updatedAt: any }> } | null, qualiphyInvitation?: { __typename?: 'QualiphyInvitation', id: string, expiration: any, meetingUrl?: string | null, exams?: Array<{ __typename?: 'QualiphyExam', id: string, title: string, status?: QualiphyInvitationStatus | null }> | null } | null, additionalPatients: Array<{ __typename?: 'AppointmentRequestPatient', id: string, clientProfile: { __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null }, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }> }>, intakeSubmissions: Array<{ __typename?: 'IntakeSubmission', id: string, formName?: string | null, status: IntakeSubmissionStatus, reviewStatus?: IntakeReviewStatus | null, formUrl?: string | null, formTemplateId: string, triggerType: IntakeTriggerType, submittedAt?: any | null, smsSentAt?: any | null }> } | null };

export type AppointmentIntakeQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AppointmentIntakeQuery = { __typename?: 'Query', appointment?: { __typename?: 'Appointment', id: string, intakeStatus?: string | null, intakeSubmissions: Array<{ __typename?: 'IntakeSubmission', id: string, formName?: string | null, status: IntakeSubmissionStatus, reviewStatus?: IntakeReviewStatus | null, formUrl?: string | null, formTemplateId: string, triggerType: IntakeTriggerType, submittedAt?: any | null, smsSentAt?: any | null }> } | null };

export type AppointmentRequestQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AppointmentRequestQuery = { __typename?: 'Query', appointmentRequest?: { __typename?: 'AppointmentRequest', id: string, location: string, latitude?: number | null, longitude?: number | null, status: AppointmentRequestStatus, bookingMode?: BookingMode | null, cancelReason?: string | null, notes?: string | null, lastResetAt?: any | null, waitlistedAt?: any | null, createdAt: any, updatedAt: any, archivedAt?: any | null, constraints: Array<{ __typename?: 'AppointmentConstraint', id: string, candidates: Array<{ __typename?: 'AppointmentCandidate', id: string, rank: number, start?: any | null, duration?: number | null, reservableTimes: Array<any>, availableTimes: Array<any>, profile?: { __typename?: 'Profile', latitude?: number | null, longitude?: number | null, id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null } | null }>, appointments: Array<{ __typename?: 'Appointment', id: string, location: string, latitude?: number | null, longitude?: number | null, start: any, end: any, duration: number, createdAt: any, updatedAt: any, archivedAt?: any | null, status: AppointmentStatus, startedAt?: any | null, completedAt?: any | null, notes?: string | null, createdBy?: string | null, cancelReason?: string | null, groupId?: string | null, ordersRequired: boolean, participants: Array<{ __typename?: 'AppointmentParticipant', id: string, name: string, type: ParticipantType, status: ParticipationStatus, profileId?: string | null, clientProfileId?: string | null, orderApproved?: boolean | null, participant?: { __typename?: 'ClientProfile', internalNotesUpdatedBy?: string | null, internalNotesUpdatedAt?: any | null, id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null, patient?: { __typename?: 'Patient', id: string, allergies?: string | null, archivedAt?: any | null, clientProfileId: string, conditions?: string | null, createdAt: any, emrInstanceId: string, immunizations?: string | null, labs?: string | null, medications?: string | null, procedures?: string | null, updatedAt: any, orders: Array<{ __typename?: 'Order', id: string, archivedAt?: any | null, createdAt: any, expiresAt: any, providerType: ProviderType, fillCount: number, note?: string | null, refills: number, startsAt: any, updatedAt: any, procedureDefs: Array<{ __typename?: 'ProcedureDefinition', id: string, name: string, description: string, price: number, duration: number, assessmentFormTemplateId?: string | null, interventionFormTemplateId?: string | null, ordersRequired: boolean, createdAt: any, intakeFormTemplates: Array<{ __typename?: 'FormTemplate', id: string, name: string }> }>, profile?: { __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null } | null, organizations: Array<{ __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null }> }>, vitals: Array<{ __typename?: 'VitalSign', id: string, createdAt: any, createdById: string, recordedAt: any, type: VitalSignType, updatedAt: any, value: string }>, signedConsentForms: Array<{ __typename?: 'DocumentSignature', id: string, signerName: string, signerEmail?: string | null, signerType: DocumentSignatureSignerType, signedAt: any, verificationType: DocumentSignatureVerificationType, verificationDetail?: string | null, tzid: string, latitude?: number | null, longitude?: number | null, documentId: string, version: number, documentLabel: string, url?: string | null, createdAt: any, updatedAt: any }>, allergyRecords: Array<{ __typename?: 'AllergyIntolerance', id: string, name: string }>, clinicalProcedureRecords: Array<{ __typename?: 'ClinicalProcedure', id: string, name: string }>, conditionRecords: Array<{ __typename?: 'Condition', id: string, name: string }>, immunizationRecords: Array<{ __typename?: 'Immunization', id: string, name: string }>, labRecords: Array<{ __typename?: 'Lab', id: string, name: string }>, medicationRecords: Array<{ __typename?: 'MedicationStatement', id: string, name: string }>, attachments?: Array<{ __typename?: 'Document', id: string, filename: string, label: string, type: DocumentType, version: number, fileSize: number, url: string, createdAt: any, updatedAt: any }> | null } | null } | { __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null } | null, responses: Array<{ __typename?: 'AppointmentResponse', id: string, start?: any | null, end?: any | null, createdAt: any, updatedAt: any }>, forms: Array<{ __typename?: 'Form', id: string, type: FormType, status: FormStatusType, patientId: string, lockedById?: string | null, editable: boolean, createdAt: any, updatedAt: any, items: Array<{ __typename?: 'FormItem', id: string, index: number, label: string, type: FormItemType, code: string, options?: string | null, createdAt: any, updatedAt: any }>, observations: Array<{ __typename?: 'Observation', id: string, code: string, value: string, note?: string | null, createdById: string, createdAt: any, updatedAt: any, createdBy?: { __typename?: 'Profile', id: string, givenName: string, familyName: string, title: string } | null }>, lockedBy?: { __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null } | null, document?: { __typename?: 'Document', id: string, filename: string, label: string, type: DocumentType, version: number, fileSize: number, url: string, createdAt: any, updatedAt: any } | null, attachments?: Array<{ __typename?: 'Document', id: string, filename: string, label: string, type: DocumentType, version: number, fileSize: number, url: string, createdAt: any, updatedAt: any }> | null, notes: Array<{ __typename?: 'FormNote', id: string, note: string, edited: boolean, profileId: string, createdAt: any, updatedAt: any, author: string }> }> }>, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }>, checkout?: { __typename?: 'Checkout', id: string, total: number, paid: number, balance: number, marketplaceUserId?: string | null, summary?: string | null, voidedAt?: any | null, paymentMethodType?: PaymentMethodType | null, createdAt: any, updatedAt: any, items: Array<{ __typename?: 'CheckoutItem', id: string, type: CheckoutItemType, description: string, quantity: number, price: number, key?: string | null }>, payments: Array<{ __typename?: 'Payment', id: string, type: PaymentType, status: PaymentStatus, description: string, amount: number, amountRequested: number, amountReversed?: number | null, isDeposit: boolean, createdAt: any, updatedAt: any }>, payouts: Array<{ __typename?: 'Payout', id: string, status: PayoutStatus, description: string, amount: number, amountRequested: number, amountReversed?: number | null, createdAt: any, updatedAt: any, checkoutId: string }>, paymentInstrument?: { __typename?: 'PaymentInstrument', id: string, type: PaymentInstrumentType, processor: PaymentAccountPlatform, brand?: string | null, lastFour?: string | null, expirationMonth?: number | null, expirationYear?: number | null, createdAt: any, updatedAt: any } | null, marketplaceUser?: { __typename?: 'MarketplaceUser', id: string, createdAt: any, updatedAt: any, groupId: string, membership: string, primaryInstrumentId?: string | null, email?: string | null, phone?: string | null, emailConfirmed: boolean, phoneConfirmed: boolean, emailOptIn: boolean, phoneOptIn: boolean, clientProfile?: { __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null } | null } | null, paymentLinks: Array<{ __typename?: 'PaymentLink', id: string, checkoutId: string, url: string, status: PaymentLinkStatus, amount: number, expiresAt?: any | null, createdAt: any, updatedAt: any }> } | null, qualiphyInvitation?: { __typename?: 'QualiphyInvitation', id: string, expiration: any, meetingUrl?: string | null, exams?: Array<{ __typename?: 'QualiphyExam', id: string, title: string, status?: QualiphyInvitationStatus | null }> | null } | null, additionalPatients: Array<{ __typename?: 'AppointmentRequestPatient', id: string, clientProfile: { __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null }, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }> }> }>, organizations: Array<{ __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null }>, profiles: Array<{ __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null }>, timeRanges: Array<{ __typename?: 'AppointmentTimeRange', id: string, start: any, end: any }> }>, declinedProfiles: Array<{ __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null }>, clientProfiles: Array<{ __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null, marketplaceUsers: Array<{ __typename?: 'MarketplaceUser', marketplaceIds: Array<string>, id: string, createdAt: any, updatedAt: any, groupId: string, membership: string, primaryInstrumentId?: string | null, email?: string | null, phone?: string | null, emailConfirmed: boolean, phoneConfirmed: boolean, emailOptIn: boolean, phoneOptIn: boolean, memberships: Array<{ __typename?: 'Membership', marketplaceName: string, id: string, membershipDefinitionId: string, renewalDate: any, name: string, status: MembershipStatusType }>, packageItems: Array<{ __typename?: 'PackageItem', marketplaceName: string, id: string, packageItemDefinitionId: string, membershipId?: string | null, balance: number, packageName: string, totalPoints: number, groupNames: string, expiresAt?: any | null, primaryOrganizationId?: string | null }>, clientProfiles: Array<{ __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null, organizations: Array<{ __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null }> }>, marketplaceGroup: { __typename?: 'MarketplaceGroup', id: string, label: string, createdAt: any, messagingServiceSid?: string | null }, paymentInstruments: Array<{ __typename?: 'PaymentInstrument', id: string, type: PaymentInstrumentType, processor: PaymentAccountPlatform, brand?: string | null, lastFour?: string | null, expirationMonth?: number | null, expirationYear?: number | null, createdAt: any, updatedAt: any }>, checkouts: Array<{ __typename?: 'Checkout', id: string, total: number, paid: number, balance: number, marketplaceUserId?: string | null, summary?: string | null, voidedAt?: any | null, paymentMethodType?: PaymentMethodType | null, createdAt: any, updatedAt: any, items: Array<{ __typename?: 'CheckoutItem', id: string, type: CheckoutItemType, description: string, quantity: number, price: number, key?: string | null }>, paymentLinks: Array<{ __typename?: 'PaymentLink', id: string, checkoutId: string, url: string, status: PaymentLinkStatus, amount: number, expiresAt?: any | null, createdAt: any, updatedAt: any }> }>, appointments: Array<{ __typename?: 'Appointment', intakeStatus?: string | null, id: string, location: string, latitude?: number | null, longitude?: number | null, start: any, end: any, duration: number, createdAt: any, updatedAt: any, archivedAt?: any | null, status: AppointmentStatus, startedAt?: any | null, completedAt?: any | null, notes?: string | null, createdBy?: string | null, cancelReason?: string | null, groupId?: string | null, ordersRequired: boolean, participants: Array<{ __typename?: 'AppointmentParticipant', id: string, name: string, type: ParticipantType, status: ParticipationStatus, profileId?: string | null, clientProfileId?: string | null, orderApproved?: boolean | null }>, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }>, checkout?: { __typename?: 'Checkout', id: string, total: number, paid: number, balance: number, marketplaceUserId?: string | null, summary?: string | null, voidedAt?: any | null, paymentMethodType?: PaymentMethodType | null, createdAt: any, updatedAt: any, paymentLinks: Array<{ __typename?: 'PaymentLink', id: string, checkoutId: string, url: string, status: PaymentLinkStatus, amount: number, expiresAt?: any | null, createdAt: any, updatedAt: any }> } | null, additionalPatients: Array<{ __typename?: 'AppointmentRequestPatient', id: string, clientProfile: { __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null }, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }> }> }>, appointmentRequests: Array<{ __typename?: 'AppointmentRequest', id: string, location: string, latitude?: number | null, longitude?: number | null, status: AppointmentRequestStatus, bookingMode?: BookingMode | null, cancelReason?: string | null, notes?: string | null, lastResetAt?: any | null, waitlistedAt?: any | null, createdAt: any, updatedAt: any, archivedAt?: any | null, marketplace: { __typename?: 'Marketplace', id: string, name: string, groupId: string, createdAt: any, logo?: string | null, favicon?: string | null, primaryColor?: string | null, marketingSiteUrl?: string | null, gtmContainer?: string | null, gtmRequiresConsent: boolean, gtmDataTier: GtmDataTier, gtmV2Enabled: boolean, featureFlags: { __typename?: 'MarketplaceFeatureFlags', waitListEnabled?: boolean | null, acceptedPaymentMethods?: { __typename?: 'AcceptedPaymentMethods', creditCard?: boolean | null, applePay?: boolean | null } | null } }, clientProfiles: Array<{ __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null }>, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }>, constraints: Array<{ __typename?: 'AppointmentConstraint', id: string, organizations: Array<{ __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null }>, profiles: Array<{ __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null }>, timeRanges: Array<{ __typename?: 'AppointmentTimeRange', id: string, start: any, end: any }> }>, additionalPatients: Array<{ __typename?: 'AppointmentRequestPatient', id: string, clientProfile: { __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null }, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }> }> }>, clientProfile?: { __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null } | null }> }>, checkout?: { __typename?: 'Checkout', id: string, total: number, paid: number, balance: number, marketplaceUserId?: string | null, summary?: string | null, voidedAt?: any | null, paymentMethodType?: PaymentMethodType | null, createdAt: any, updatedAt: any, items: Array<{ __typename?: 'CheckoutItem', id: string, type: CheckoutItemType, description: string, quantity: number, price: number, key?: string | null }>, payments: Array<{ __typename?: 'Payment', id: string, type: PaymentType, status: PaymentStatus, description: string, amount: number, amountRequested: number, amountReversed?: number | null, isDeposit: boolean, createdAt: any, updatedAt: any }>, payouts: Array<{ __typename?: 'Payout', id: string, status: PayoutStatus, description: string, amount: number, amountRequested: number, amountReversed?: number | null, createdAt: any, updatedAt: any, checkoutId: string }>, paymentInstrument?: { __typename?: 'PaymentInstrument', id: string, type: PaymentInstrumentType, processor: PaymentAccountPlatform, brand?: string | null, lastFour?: string | null, expirationMonth?: number | null, expirationYear?: number | null, createdAt: any, updatedAt: any } | null, marketplaceUser?: { __typename?: 'MarketplaceUser', id: string, createdAt: any, updatedAt: any, groupId: string, membership: string, primaryInstrumentId?: string | null, email?: string | null, phone?: string | null, emailConfirmed: boolean, phoneConfirmed: boolean, emailOptIn: boolean, phoneOptIn: boolean, clientProfile?: { __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null } | null } | null, paymentLinks: Array<{ __typename?: 'PaymentLink', id: string, checkoutId: string, url: string, status: PaymentLinkStatus, amount: number, expiresAt?: any | null, createdAt: any, updatedAt: any }> } | null, marketplace: { __typename?: 'Marketplace', id: string, name: string, groupId: string, createdAt: any, logo?: string | null, favicon?: string | null, primaryColor?: string | null, marketingSiteUrl?: string | null, gtmContainer?: string | null, gtmRequiresConsent: boolean, gtmDataTier: GtmDataTier, gtmV2Enabled: boolean, featureFlags: { __typename?: 'MarketplaceFeatureFlags', waitListEnabled?: boolean | null, acceptedPaymentMethods?: { __typename?: 'AcceptedPaymentMethods', creditCard?: boolean | null, applePay?: boolean | null } | null } }, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }>, additionalPatients: Array<{ __typename?: 'AppointmentRequestPatient', id: string, clientProfile: { __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null }, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }> }> } | null };

export type AppointmentRequestsQueryVariables = Exact<{
  page?: InputMaybe<AppointmentRequestPageInput>;
}>;


export type AppointmentRequestsQuery = { __typename?: 'Query', appointmentRequests?: { __typename?: 'AppointmentRequestPage', totalCount: number, data: Array<{ __typename?: 'AppointmentRequest', orderApproved?: boolean | null, intakeStatus?: string | null, id: string, location: string, latitude?: number | null, longitude?: number | null, status: AppointmentRequestStatus, bookingMode?: BookingMode | null, cancelReason?: string | null, notes?: string | null, lastResetAt?: any | null, waitlistedAt?: any | null, createdAt: any, updatedAt: any, archivedAt?: any | null, checkout?: { __typename?: 'Checkout', id: string, total: number, paid: number, balance: number, marketplaceUserId?: string | null, summary?: string | null, voidedAt?: any | null, paymentMethodType?: PaymentMethodType | null, createdAt: any, updatedAt: any, paymentLinks: Array<{ __typename?: 'PaymentLink', id: string, checkoutId: string, url: string, status: PaymentLinkStatus, amount: number, expiresAt?: any | null, createdAt: any, updatedAt: any }> } | null, marketplace: { __typename?: 'Marketplace', id: string, name: string, groupId: string, createdAt: any, logo?: string | null, favicon?: string | null, primaryColor?: string | null, marketingSiteUrl?: string | null, gtmContainer?: string | null, gtmRequiresConsent: boolean, gtmDataTier: GtmDataTier, gtmV2Enabled: boolean, featureFlags: { __typename?: 'MarketplaceFeatureFlags', waitListEnabled?: boolean | null, acceptedPaymentMethods?: { __typename?: 'AcceptedPaymentMethods', creditCard?: boolean | null, applePay?: boolean | null } | null } }, clientProfiles: Array<{ __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null }>, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }>, constraints: Array<{ __typename?: 'AppointmentConstraint', id: string, organizations: Array<{ __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null }>, profiles: Array<{ __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null }>, timeRanges: Array<{ __typename?: 'AppointmentTimeRange', id: string, start: any, end: any }> }>, additionalPatients: Array<{ __typename?: 'AppointmentRequestPatient', id: string, clientProfile: { __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null }, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }> }> }> } | null };

export type AppointmentsByGroupQueryVariables = Exact<{
  groupId: Scalars['String'];
}>;


export type AppointmentsByGroupQuery = { __typename?: 'Query', appointmentsByGroup: Array<{ __typename?: 'Appointment', id: string, location: string, latitude?: number | null, longitude?: number | null, start: any, end: any, duration: number, createdAt: any, updatedAt: any, archivedAt?: any | null, status: AppointmentStatus, startedAt?: any | null, completedAt?: any | null, notes?: string | null, createdBy?: string | null, cancelReason?: string | null, groupId?: string | null, ordersRequired: boolean, participants: Array<{ __typename?: 'AppointmentParticipant', id: string, name: string, type: ParticipantType, status: ParticipationStatus, profileId?: string | null, clientProfileId?: string | null, orderApproved?: boolean | null, participant?: { __typename?: 'ClientProfile', internalNotesUpdatedBy?: string | null, internalNotesUpdatedAt?: any | null, id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null, patient?: { __typename?: 'Patient', id: string, allergies?: string | null, archivedAt?: any | null, clientProfileId: string, conditions?: string | null, createdAt: any, emrInstanceId: string, immunizations?: string | null, labs?: string | null, medications?: string | null, procedures?: string | null, updatedAt: any, orders: Array<{ __typename?: 'Order', id: string, archivedAt?: any | null, createdAt: any, expiresAt: any, providerType: ProviderType, fillCount: number, note?: string | null, refills: number, startsAt: any, updatedAt: any, procedureDefs: Array<{ __typename?: 'ProcedureDefinition', id: string, name: string, description: string, price: number, duration: number, assessmentFormTemplateId?: string | null, interventionFormTemplateId?: string | null, ordersRequired: boolean, createdAt: any, intakeFormTemplates: Array<{ __typename?: 'FormTemplate', id: string, name: string }> }>, profile?: { __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null } | null, organizations: Array<{ __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null }> }>, vitals: Array<{ __typename?: 'VitalSign', id: string, createdAt: any, createdById: string, recordedAt: any, type: VitalSignType, updatedAt: any, value: string }>, signedConsentForms: Array<{ __typename?: 'DocumentSignature', id: string, signerName: string, signerEmail?: string | null, signerType: DocumentSignatureSignerType, signedAt: any, verificationType: DocumentSignatureVerificationType, verificationDetail?: string | null, tzid: string, latitude?: number | null, longitude?: number | null, documentId: string, version: number, documentLabel: string, url?: string | null, createdAt: any, updatedAt: any }>, allergyRecords: Array<{ __typename?: 'AllergyIntolerance', id: string, name: string }>, clinicalProcedureRecords: Array<{ __typename?: 'ClinicalProcedure', id: string, name: string }>, conditionRecords: Array<{ __typename?: 'Condition', id: string, name: string }>, immunizationRecords: Array<{ __typename?: 'Immunization', id: string, name: string }>, labRecords: Array<{ __typename?: 'Lab', id: string, name: string }>, medicationRecords: Array<{ __typename?: 'MedicationStatement', id: string, name: string }>, attachments?: Array<{ __typename?: 'Document', id: string, filename: string, label: string, type: DocumentType, version: number, fileSize: number, url: string, createdAt: any, updatedAt: any }> | null } | null } | { __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null } | null, responses: Array<{ __typename?: 'AppointmentResponse', id: string, start?: any | null, end?: any | null, createdAt: any, updatedAt: any }>, forms: Array<{ __typename?: 'Form', id: string, type: FormType, status: FormStatusType, patientId: string, lockedById?: string | null, editable: boolean, createdAt: any, updatedAt: any, items: Array<{ __typename?: 'FormItem', id: string, index: number, label: string, type: FormItemType, code: string, options?: string | null, createdAt: any, updatedAt: any }>, observations: Array<{ __typename?: 'Observation', id: string, code: string, value: string, note?: string | null, createdById: string, createdAt: any, updatedAt: any, createdBy?: { __typename?: 'Profile', id: string, givenName: string, familyName: string, title: string } | null }>, lockedBy?: { __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null } | null, document?: { __typename?: 'Document', id: string, filename: string, label: string, type: DocumentType, version: number, fileSize: number, url: string, createdAt: any, updatedAt: any } | null, attachments?: Array<{ __typename?: 'Document', id: string, filename: string, label: string, type: DocumentType, version: number, fileSize: number, url: string, createdAt: any, updatedAt: any }> | null, notes: Array<{ __typename?: 'FormNote', id: string, note: string, edited: boolean, profileId: string, createdAt: any, updatedAt: any, author: string }> }> }>, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }>, checkout?: { __typename?: 'Checkout', id: string, total: number, paid: number, balance: number, marketplaceUserId?: string | null, summary?: string | null, voidedAt?: any | null, paymentMethodType?: PaymentMethodType | null, createdAt: any, updatedAt: any, items: Array<{ __typename?: 'CheckoutItem', id: string, type: CheckoutItemType, description: string, quantity: number, price: number, key?: string | null }>, payments: Array<{ __typename?: 'Payment', id: string, type: PaymentType, status: PaymentStatus, description: string, amount: number, amountRequested: number, amountReversed?: number | null, isDeposit: boolean, createdAt: any, updatedAt: any }>, payouts: Array<{ __typename?: 'Payout', id: string, status: PayoutStatus, description: string, amount: number, amountRequested: number, amountReversed?: number | null, createdAt: any, updatedAt: any, checkoutId: string }>, paymentInstrument?: { __typename?: 'PaymentInstrument', id: string, type: PaymentInstrumentType, processor: PaymentAccountPlatform, brand?: string | null, lastFour?: string | null, expirationMonth?: number | null, expirationYear?: number | null, createdAt: any, updatedAt: any } | null, marketplaceUser?: { __typename?: 'MarketplaceUser', id: string, createdAt: any, updatedAt: any, groupId: string, membership: string, primaryInstrumentId?: string | null, email?: string | null, phone?: string | null, emailConfirmed: boolean, phoneConfirmed: boolean, emailOptIn: boolean, phoneOptIn: boolean, clientProfile?: { __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null } | null } | null, paymentLinks: Array<{ __typename?: 'PaymentLink', id: string, checkoutId: string, url: string, status: PaymentLinkStatus, amount: number, expiresAt?: any | null, createdAt: any, updatedAt: any }> } | null, qualiphyInvitation?: { __typename?: 'QualiphyInvitation', id: string, expiration: any, meetingUrl?: string | null, exams?: Array<{ __typename?: 'QualiphyExam', id: string, title: string, status?: QualiphyInvitationStatus | null }> | null } | null, additionalPatients: Array<{ __typename?: 'AppointmentRequestPatient', id: string, clientProfile: { __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null }, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }> }> }> };

export type CheckoutQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CheckoutQuery = { __typename?: 'Query', checkout: { __typename?: 'Checkout', id: string, total: number, paid: number, balance: number, marketplaceUserId?: string | null, summary?: string | null, voidedAt?: any | null, paymentMethodType?: PaymentMethodType | null, createdAt: any, updatedAt: any, appointment?: { __typename?: 'Appointment', id: string, location: string, latitude?: number | null, longitude?: number | null, start: any, end: any, duration: number, createdAt: any, updatedAt: any, archivedAt?: any | null, status: AppointmentStatus, startedAt?: any | null, completedAt?: any | null, notes?: string | null, createdBy?: string | null, cancelReason?: string | null, groupId?: string | null, ordersRequired: boolean, participants: Array<{ __typename?: 'AppointmentParticipant', id: string, name: string, type: ParticipantType, status: ParticipationStatus, profileId?: string | null, clientProfileId?: string | null, orderApproved?: boolean | null, participant?: { __typename?: 'ClientProfile', internalNotesUpdatedBy?: string | null, internalNotesUpdatedAt?: any | null, id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null, patient?: { __typename?: 'Patient', id: string, allergies?: string | null, archivedAt?: any | null, clientProfileId: string, conditions?: string | null, createdAt: any, emrInstanceId: string, immunizations?: string | null, labs?: string | null, medications?: string | null, procedures?: string | null, updatedAt: any, orders: Array<{ __typename?: 'Order', id: string, archivedAt?: any | null, createdAt: any, expiresAt: any, providerType: ProviderType, fillCount: number, note?: string | null, refills: number, startsAt: any, updatedAt: any, procedureDefs: Array<{ __typename?: 'ProcedureDefinition', id: string, name: string, description: string, price: number, duration: number, assessmentFormTemplateId?: string | null, interventionFormTemplateId?: string | null, ordersRequired: boolean, createdAt: any, intakeFormTemplates: Array<{ __typename?: 'FormTemplate', id: string, name: string }> }>, profile?: { __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null } | null, organizations: Array<{ __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null }> }>, vitals: Array<{ __typename?: 'VitalSign', id: string, createdAt: any, createdById: string, recordedAt: any, type: VitalSignType, updatedAt: any, value: string }>, signedConsentForms: Array<{ __typename?: 'DocumentSignature', id: string, signerName: string, signerEmail?: string | null, signerType: DocumentSignatureSignerType, signedAt: any, verificationType: DocumentSignatureVerificationType, verificationDetail?: string | null, tzid: string, latitude?: number | null, longitude?: number | null, documentId: string, version: number, documentLabel: string, url?: string | null, createdAt: any, updatedAt: any }>, allergyRecords: Array<{ __typename?: 'AllergyIntolerance', id: string, name: string }>, clinicalProcedureRecords: Array<{ __typename?: 'ClinicalProcedure', id: string, name: string }>, conditionRecords: Array<{ __typename?: 'Condition', id: string, name: string }>, immunizationRecords: Array<{ __typename?: 'Immunization', id: string, name: string }>, labRecords: Array<{ __typename?: 'Lab', id: string, name: string }>, medicationRecords: Array<{ __typename?: 'MedicationStatement', id: string, name: string }>, attachments?: Array<{ __typename?: 'Document', id: string, filename: string, label: string, type: DocumentType, version: number, fileSize: number, url: string, createdAt: any, updatedAt: any }> | null } | null } | { __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null } | null, responses: Array<{ __typename?: 'AppointmentResponse', id: string, start?: any | null, end?: any | null, createdAt: any, updatedAt: any }>, forms: Array<{ __typename?: 'Form', id: string, type: FormType, status: FormStatusType, patientId: string, lockedById?: string | null, editable: boolean, createdAt: any, updatedAt: any, items: Array<{ __typename?: 'FormItem', id: string, index: number, label: string, type: FormItemType, code: string, options?: string | null, createdAt: any, updatedAt: any }>, observations: Array<{ __typename?: 'Observation', id: string, code: string, value: string, note?: string | null, createdById: string, createdAt: any, updatedAt: any, createdBy?: { __typename?: 'Profile', id: string, givenName: string, familyName: string, title: string } | null }>, lockedBy?: { __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null } | null, document?: { __typename?: 'Document', id: string, filename: string, label: string, type: DocumentType, version: number, fileSize: number, url: string, createdAt: any, updatedAt: any } | null, attachments?: Array<{ __typename?: 'Document', id: string, filename: string, label: string, type: DocumentType, version: number, fileSize: number, url: string, createdAt: any, updatedAt: any }> | null, notes: Array<{ __typename?: 'FormNote', id: string, note: string, edited: boolean, profileId: string, createdAt: any, updatedAt: any, author: string }> }> }>, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }> } | null, appointmentRequest?: { __typename?: 'AppointmentRequest', id: string, location: string, latitude?: number | null, longitude?: number | null, status: AppointmentRequestStatus, bookingMode?: BookingMode | null, cancelReason?: string | null, notes?: string | null, lastResetAt?: any | null, waitlistedAt?: any | null, createdAt: any, updatedAt: any, archivedAt?: any | null, marketplace: { __typename?: 'Marketplace', id: string, name: string, groupId: string, createdAt: any, logo?: string | null, favicon?: string | null, primaryColor?: string | null, marketingSiteUrl?: string | null, gtmContainer?: string | null, gtmRequiresConsent: boolean, gtmDataTier: GtmDataTier, gtmV2Enabled: boolean, featureFlags: { __typename?: 'MarketplaceFeatureFlags', waitListEnabled?: boolean | null, acceptedPaymentMethods?: { __typename?: 'AcceptedPaymentMethods', creditCard?: boolean | null, applePay?: boolean | null } | null } }, clientProfiles: Array<{ __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null }>, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }>, constraints: Array<{ __typename?: 'AppointmentConstraint', id: string, organizations: Array<{ __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null }>, profiles: Array<{ __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null }>, timeRanges: Array<{ __typename?: 'AppointmentTimeRange', id: string, start: any, end: any }> }>, additionalPatients: Array<{ __typename?: 'AppointmentRequestPatient', id: string, clientProfile: { __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null }, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }> }> } | null, items: Array<{ __typename?: 'CheckoutItem', id: string, type: CheckoutItemType, description: string, quantity: number, price: number, key?: string | null }>, payments: Array<{ __typename?: 'Payment', id: string, type: PaymentType, status: PaymentStatus, description: string, amount: number, amountRequested: number, amountReversed?: number | null, isDeposit: boolean, createdAt: any, updatedAt: any }>, payouts: Array<{ __typename?: 'Payout', id: string, status: PayoutStatus, description: string, amount: number, amountRequested: number, amountReversed?: number | null, createdAt: any, updatedAt: any, checkoutId: string }>, paymentInstrument?: { __typename?: 'PaymentInstrument', id: string, type: PaymentInstrumentType, processor: PaymentAccountPlatform, brand?: string | null, lastFour?: string | null, expirationMonth?: number | null, expirationYear?: number | null, createdAt: any, updatedAt: any } | null, marketplaceUser?: { __typename?: 'MarketplaceUser', id: string, createdAt: any, updatedAt: any, groupId: string, membership: string, primaryInstrumentId?: string | null, email?: string | null, phone?: string | null, emailConfirmed: boolean, phoneConfirmed: boolean, emailOptIn: boolean, phoneOptIn: boolean, clientProfile?: { __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null } | null } | null, paymentLinks: Array<{ __typename?: 'PaymentLink', id: string, checkoutId: string, url: string, status: PaymentLinkStatus, amount: number, expiresAt?: any | null, createdAt: any, updatedAt: any }> } };

export type CheckoutsQueryVariables = Exact<{
  page?: InputMaybe<CheckoutPageInput>;
}>;


export type CheckoutsQuery = { __typename?: 'Query', checkouts: { __typename?: 'CheckoutPage', totalCount: number, data: Array<{ __typename?: 'Checkout', id: string, total: number, paid: number, balance: number, marketplaceUserId?: string | null, summary?: string | null, voidedAt?: any | null, paymentMethodType?: PaymentMethodType | null, createdAt: any, updatedAt: any, marketplace?: { __typename?: 'Marketplace', id: string, name: string, groupId: string, createdAt: any, logo?: string | null, favicon?: string | null, primaryColor?: string | null, marketingSiteUrl?: string | null, gtmContainer?: string | null, gtmRequiresConsent: boolean, gtmDataTier: GtmDataTier, gtmV2Enabled: boolean, featureFlags: { __typename?: 'MarketplaceFeatureFlags', waitListEnabled?: boolean | null, acceptedPaymentMethods?: { __typename?: 'AcceptedPaymentMethods', creditCard?: boolean | null, applePay?: boolean | null } | null } } | null, marketplaceUser?: { __typename?: 'MarketplaceUser', id: string, createdAt: any, updatedAt: any, groupId: string, membership: string, primaryInstrumentId?: string | null, email?: string | null, phone?: string | null, emailConfirmed: boolean, phoneConfirmed: boolean, emailOptIn: boolean, phoneOptIn: boolean, clientProfile?: { __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null } | null } | null, paymentLinks: Array<{ __typename?: 'PaymentLink', id: string, checkoutId: string, url: string, status: PaymentLinkStatus, amount: number, expiresAt?: any | null, createdAt: any, updatedAt: any }> }> } };

export type ClientProfileQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ClientProfileQuery = { __typename?: 'Query', clientProfile?: { __typename?: 'ClientProfile', internalNotesUpdatedBy?: string | null, internalNotesUpdatedAt?: any | null, id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null, patient?: { __typename?: 'Patient', id: string, allergies?: string | null, archivedAt?: any | null, clientProfileId: string, conditions?: string | null, createdAt: any, emrInstanceId: string, immunizations?: string | null, labs?: string | null, medications?: string | null, procedures?: string | null, updatedAt: any, orders: Array<{ __typename?: 'Order', id: string, archivedAt?: any | null, createdAt: any, expiresAt: any, providerType: ProviderType, fillCount: number, note?: string | null, refills: number, startsAt: any, updatedAt: any, procedureDefs: Array<{ __typename?: 'ProcedureDefinition', id: string, name: string, description: string, price: number, duration: number, assessmentFormTemplateId?: string | null, interventionFormTemplateId?: string | null, ordersRequired: boolean, createdAt: any, intakeFormTemplates: Array<{ __typename?: 'FormTemplate', id: string, name: string }> }>, profile?: { __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null } | null, organizations: Array<{ __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null }> }>, vitals: Array<{ __typename?: 'VitalSign', id: string, createdAt: any, createdById: string, recordedAt: any, type: VitalSignType, updatedAt: any, value: string }>, signedConsentForms: Array<{ __typename?: 'DocumentSignature', id: string, signerName: string, signerEmail?: string | null, signerType: DocumentSignatureSignerType, signedAt: any, verificationType: DocumentSignatureVerificationType, verificationDetail?: string | null, tzid: string, latitude?: number | null, longitude?: number | null, documentId: string, version: number, documentLabel: string, url?: string | null, createdAt: any, updatedAt: any }>, allergyRecords: Array<{ __typename?: 'AllergyIntolerance', id: string, name: string }>, clinicalProcedureRecords: Array<{ __typename?: 'ClinicalProcedure', id: string, name: string }>, conditionRecords: Array<{ __typename?: 'Condition', id: string, name: string }>, immunizationRecords: Array<{ __typename?: 'Immunization', id: string, name: string }>, labRecords: Array<{ __typename?: 'Lab', id: string, name: string }>, medicationRecords: Array<{ __typename?: 'MedicationStatement', id: string, name: string }>, attachments?: Array<{ __typename?: 'Document', id: string, filename: string, label: string, type: DocumentType, version: number, fileSize: number, url: string, createdAt: any, updatedAt: any }> | null } | null, appointments: Array<{ __typename?: 'Appointment', id: string, status: AppointmentStatus, cancelReason?: string | null, start: any, end: any, duration: number, location: string, groupId?: string | null, archivedAt?: any | null, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string }>, participants: Array<{ __typename?: 'AppointmentParticipant', id: string, name: string, type: ParticipantType, status: ParticipationStatus, profileId?: string | null, clientProfileId?: string | null, orderApproved?: boolean | null }> }>, intakeSubmissions: Array<{ __typename?: 'IntakeSubmission', id: string, status: IntakeSubmissionStatus, reviewStatus?: IntakeReviewStatus | null, formName?: string | null, submittedAt?: any | null, appointmentId: string, pdfUrl?: string | null, reviewedByName?: string | null, documentId?: string | null, appointment?: { __typename?: 'Appointment', id: string, start: any, status: AppointmentStatus } | null }> } | null };

export type ClientProfileAppointmentsQueryVariables = Exact<{
  id: Scalars['ID'];
  limit: Scalars['Int'];
  offset: Scalars['Int'];
}>;


export type ClientProfileAppointmentsQuery = { __typename?: 'Query', clientProfile?: { __typename?: 'ClientProfile', id: string, appointments: Array<{ __typename?: 'Appointment', id: string, status: AppointmentStatus, cancelReason?: string | null, start: any, end: any, duration: number, location: string, groupId?: string | null, archivedAt?: any | null, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string }>, participants: Array<{ __typename?: 'AppointmentParticipant', id: string, name: string, type: ParticipantType, status: ParticipationStatus, profileId?: string | null, clientProfileId?: string | null, orderApproved?: boolean | null }> }> } | null };

export type ClientProfileMarketplaceUserQueryVariables = Exact<{
  id: Scalars['ID'];
  groupId?: InputMaybe<Scalars['ID']>;
}>;


export type ClientProfileMarketplaceUserQuery = { __typename?: 'Query', clientProfile?: { __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null, marketplaceUsers: Array<{ __typename?: 'MarketplaceUser', id: string, createdAt: any, updatedAt: any, groupId: string, membership: string, primaryInstrumentId?: string | null, email?: string | null, phone?: string | null, emailConfirmed: boolean, phoneConfirmed: boolean, emailOptIn: boolean, phoneOptIn: boolean, clientProfiles: Array<{ __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null, organizations: Array<{ __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null }> }>, packageItems: Array<{ __typename?: 'PackageItem', marketplaceName: string, id: string, packageItemDefinitionId: string, membershipId?: string | null, balance: number, packageName: string, totalPoints: number, groupNames: string, expiresAt?: any | null, primaryOrganizationId?: string | null }>, memberships: Array<{ __typename?: 'Membership', marketplaceName: string, id: string, membershipDefinitionId: string, renewalDate: any, name: string, status: MembershipStatusType }>, marketplaceGroup: { __typename?: 'MarketplaceGroup', id: string, label: string, createdAt: any, messagingServiceSid?: string | null }, paymentInstruments: Array<{ __typename?: 'PaymentInstrument', id: string, type: PaymentInstrumentType, processor: PaymentAccountPlatform, brand?: string | null, lastFour?: string | null, expirationMonth?: number | null, expirationYear?: number | null, createdAt: any, updatedAt: any }>, checkouts: Array<{ __typename?: 'Checkout', id: string, total: number, paid: number, balance: number, marketplaceUserId?: string | null, summary?: string | null, voidedAt?: any | null, paymentMethodType?: PaymentMethodType | null, createdAt: any, updatedAt: any, items: Array<{ __typename?: 'CheckoutItem', id: string, type: CheckoutItemType, description: string, quantity: number, price: number, key?: string | null }>, paymentLinks: Array<{ __typename?: 'PaymentLink', id: string, checkoutId: string, url: string, status: PaymentLinkStatus, amount: number, expiresAt?: any | null, createdAt: any, updatedAt: any }> }>, appointments: Array<{ __typename?: 'Appointment', intakeStatus?: string | null, id: string, location: string, latitude?: number | null, longitude?: number | null, start: any, end: any, duration: number, createdAt: any, updatedAt: any, archivedAt?: any | null, status: AppointmentStatus, startedAt?: any | null, completedAt?: any | null, notes?: string | null, createdBy?: string | null, cancelReason?: string | null, groupId?: string | null, ordersRequired: boolean, participants: Array<{ __typename?: 'AppointmentParticipant', id: string, name: string, type: ParticipantType, status: ParticipationStatus, profileId?: string | null, clientProfileId?: string | null, orderApproved?: boolean | null }>, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }>, checkout?: { __typename?: 'Checkout', id: string, total: number, paid: number, balance: number, marketplaceUserId?: string | null, summary?: string | null, voidedAt?: any | null, paymentMethodType?: PaymentMethodType | null, createdAt: any, updatedAt: any, paymentLinks: Array<{ __typename?: 'PaymentLink', id: string, checkoutId: string, url: string, status: PaymentLinkStatus, amount: number, expiresAt?: any | null, createdAt: any, updatedAt: any }> } | null, additionalPatients: Array<{ __typename?: 'AppointmentRequestPatient', id: string, clientProfile: { __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null }, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }> }> }>, appointmentRequests: Array<{ __typename?: 'AppointmentRequest', id: string, location: string, latitude?: number | null, longitude?: number | null, status: AppointmentRequestStatus, bookingMode?: BookingMode | null, cancelReason?: string | null, notes?: string | null, lastResetAt?: any | null, waitlistedAt?: any | null, createdAt: any, updatedAt: any, archivedAt?: any | null, marketplace: { __typename?: 'Marketplace', id: string, name: string, groupId: string, createdAt: any, logo?: string | null, favicon?: string | null, primaryColor?: string | null, marketingSiteUrl?: string | null, gtmContainer?: string | null, gtmRequiresConsent: boolean, gtmDataTier: GtmDataTier, gtmV2Enabled: boolean, featureFlags: { __typename?: 'MarketplaceFeatureFlags', waitListEnabled?: boolean | null, acceptedPaymentMethods?: { __typename?: 'AcceptedPaymentMethods', creditCard?: boolean | null, applePay?: boolean | null } | null } }, clientProfiles: Array<{ __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null }>, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }>, constraints: Array<{ __typename?: 'AppointmentConstraint', id: string, organizations: Array<{ __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null }>, profiles: Array<{ __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null }>, timeRanges: Array<{ __typename?: 'AppointmentTimeRange', id: string, start: any, end: any }> }>, additionalPatients: Array<{ __typename?: 'AppointmentRequestPatient', id: string, clientProfile: { __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null }, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }> }> }>, clientProfile?: { __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null } | null }> } | null };

export type ClientProfilesQueryVariables = Exact<{
  page?: InputMaybe<ClientProfilePageInput>;
}>;


export type ClientProfilesQuery = { __typename?: 'Query', clientProfiles: { __typename?: 'ClientProfilePage', totalCount: number, data: Array<{ __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null }> } };

export type EmrInstanceQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type EmrInstanceQuery = { __typename?: 'Query', emrInstance?: { __typename?: 'EmrInstance', id: string, label: string, createdAt: any, formTemplates: Array<{ __typename?: 'FormTemplate', id: string, name: string, type: FormType, parentId?: string | null, createdAt: any, updatedAt: any, items: Array<{ __typename?: 'FormTemplateItem', id: string, index: number, label: string, type: FormItemType, options?: string | null, createdAt: any, updatedAt: any }> }>, consentForms: Array<{ __typename?: 'Document', id: string, filename: string, label: string, type: DocumentType, version: number, fileSize: number, url: string, createdAt: any, updatedAt: any }>, organizations: Array<{ __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null }> } | null };

export type EmrInstancesQueryVariables = Exact<{ [key: string]: never; }>;


export type EmrInstancesQuery = { __typename?: 'Query', emrInstances: Array<{ __typename?: 'EmrInstance', id: string, label: string, createdAt: any }> };

export type MarketplaceQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type MarketplaceQuery = { __typename?: 'Query', marketplace?: { __typename?: 'Marketplace', requireDispatchApproval: boolean, requirePractitionerApproval: boolean, dispatchStrategy?: DispatchStrategy | null, bookingMode?: BookingMode | null, slackWebhookUrl?: string | null, reviewsIoKeyDescription?: string | null, consentTokenSecretDescription?: string | null, reviewsIoStoreId?: string | null, paymentAccountId?: string | null, feeProfileFixed?: number | null, feeProfileBasisPoints?: number | null, logo?: string | null, favicon?: string | null, primaryColor?: string | null, marketingSiteUrl?: string | null, paymentCollectionMethod?: PaymentCollectionMethod | null, paymentDepositType?: PaymentDepositType | null, paymentDepositValue?: number | null, hasPaymentPolicy?: boolean | null, paymentPolicyName?: string | null, paymentPolicyText?: string | null, requirePaymentPolicyAttestation?: boolean | null, id: string, name: string, groupId: string, createdAt: any, gtmContainer?: string | null, gtmRequiresConsent: boolean, gtmDataTier: GtmDataTier, gtmV2Enabled: boolean, checkoutNotes: Array<{ __typename?: 'CheckoutNoteItem', id: string, index: number, label: string, type: FormItemType, options?: string | null, createdAt: any, updatedAt: any }>, roles: Array<{ __typename?: 'Role', id: string, name: string, scope: RoleScope, type: RoleType, permissions: Array<string>, resourceId?: string | null }>, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', tags: Array<string>, id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }>, procedureBaseDefGroups: Array<{ __typename?: 'ProcedureBaseDefinitionGroup', id: string, name: string, thumbnail?: string | null, banner?: string | null, type: ProcedureGroupType, description?: string | null, bgcolor?: string | null, fontColor?: string | null, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string }>, featuredBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string }>, procedureBaseDefGroups: Array<{ __typename?: 'ProcedureBaseDefinitionGroup', id: string, name: string, type: ProcedureGroupType }> }>, organizations: Array<{ __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null }>, group: { __typename?: 'MarketplaceGroup', id: string, label: string }, packages: Array<{ __typename?: 'Package', id: string, name: string, price: number, marketplaceId: string, advertise: boolean, description?: string | null, list?: string | null }>, membershipDefinitions: Array<{ __typename?: 'MembershipDefinition', id: string, name: string, price: number, period: MembershipDefinitionPeriodType, packageId?: string | null, marketplaceId: string, advertise: boolean, description?: string | null, list?: string | null }>, attentive?: { __typename?: 'AttentiveIntegration', id: string, apiKeyDescription?: string | null, appointmentCompletedEnabled?: boolean | null, appointmentCompletedEvent?: string | null, qualiphyTextsEnabled?: boolean | null, qualiphyTextsEvent?: string | null, marketingSignUpUnitId?: string | null, transactionalSignUpUnitId?: string | null } | null, sendgrid?: { __typename?: 'SendgridIntegration', apiKeyDescription?: string | null, enabled: boolean, domain: string, webOrigin: string } | null, paymentAccounts: Array<{ __typename?: 'PaymentAccount', id: string, label: string, platform: PaymentAccountPlatform, enabled: boolean, state: PaymentAccountState, onboardingUrl?: string | null, createdAt: any, updatedAt: any }>, twilio?: { __typename?: 'TwilioIntegration', id: string, appointmentsEnabled: boolean, appointmentRequestsEnabled: boolean, waitlistTextsEnabled: boolean, intakeTextsEnabled: boolean } | null, segment?: { __typename?: 'SegmentIntegration', id: string, writeKeyDescription?: string | null, enabled: boolean, v2Enabled: boolean, v2WriteKeyDescription?: string | null, clientWriteKey?: string | null } | null, reach?: { __typename?: 'ReachIntegration', id: string, reachId: string } | null, checkoutContent: { __typename?: 'MarketplaceCheckoutContent', servicesNotice?: string | null, scheduleNotice?: string | null, confirmationMessage?: string | null, footerLinks: Array<{ __typename?: 'MarketplaceFooterLink', label: string, url: string }> }, featureFlags: { __typename?: 'MarketplaceFeatureFlags', waitListEnabled?: boolean | null, acceptedPaymentMethods?: { __typename?: 'AcceptedPaymentMethods', creditCard?: boolean | null, applePay?: boolean | null } | null, windowBooking?: { __typename?: 'WindowBookingConfig', allowSpecificTimeRequest?: boolean | null, minRemainingMinutes?: number | null, windows?: Array<{ __typename?: 'WindowConfig', key: WindowKey, enabled: boolean, startTime: string, endTime: string }> | null } | null } } | null };

export type MarketplaceDispatchQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type MarketplaceDispatchQuery = { __typename?: 'Query', marketplace?: { __typename?: 'Marketplace', id: string, name: string, groupId: string, createdAt: any, logo?: string | null, favicon?: string | null, primaryColor?: string | null, marketingSiteUrl?: string | null, gtmContainer?: string | null, gtmRequiresConsent: boolean, gtmDataTier: GtmDataTier, gtmV2Enabled: boolean, twilio?: { __typename?: 'TwilioIntegration', id: string, appointmentsEnabled: boolean, appointmentRequestsEnabled: boolean, waitlistTextsEnabled: boolean, intakeTextsEnabled: boolean } | null, roles: Array<{ __typename?: 'Role', id: string, name: string, scope: RoleScope, type: RoleType, permissions: Array<string>, resourceId?: string | null }>, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }>, organizations: Array<{ __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null, profiles: Array<{ __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null }> }>, featureFlags: { __typename?: 'MarketplaceFeatureFlags', waitListEnabled?: boolean | null, acceptedPaymentMethods?: { __typename?: 'AcceptedPaymentMethods', creditCard?: boolean | null, applePay?: boolean | null } | null } } | null };

export type MarketplaceGroupQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type MarketplaceGroupQuery = { __typename?: 'Query', marketplaceGroup?: { __typename?: 'MarketplaceGroup', id: string, label: string, createdAt: any, messagingServiceSid?: string | null, marketplaces: Array<{ __typename?: 'Marketplace', id: string, name: string, groupId: string, createdAt: any, logo?: string | null, favicon?: string | null, primaryColor?: string | null, marketingSiteUrl?: string | null, gtmContainer?: string | null, gtmRequiresConsent: boolean, gtmDataTier: GtmDataTier, gtmV2Enabled: boolean, featureFlags: { __typename?: 'MarketplaceFeatureFlags', waitListEnabled?: boolean | null, acceptedPaymentMethods?: { __typename?: 'AcceptedPaymentMethods', creditCard?: boolean | null, applePay?: boolean | null } | null } }> } | null };

export type MarketplaceGroupMembershipsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type MarketplaceGroupMembershipsQuery = { __typename?: 'Query', marketplaceGroup?: { __typename?: 'MarketplaceGroup', id: string, label: string, createdAt: any, messagingServiceSid?: string | null, marketplaces: Array<{ __typename?: 'Marketplace', id: string, name: string, groupId: string, createdAt: any, logo?: string | null, favicon?: string | null, primaryColor?: string | null, marketingSiteUrl?: string | null, gtmContainer?: string | null, gtmRequiresConsent: boolean, gtmDataTier: GtmDataTier, gtmV2Enabled: boolean, membershipDefinitions: Array<{ __typename?: 'MembershipDefinition', id: string, name: string, price: number, period: MembershipDefinitionPeriodType, packageId?: string | null, marketplaceId: string, advertise: boolean, description?: string | null, list?: string | null }>, packages: Array<{ __typename?: 'Package', id: string, name: string, price: number, marketplaceId: string, advertise: boolean, description?: string | null, list?: string | null }>, organizations: Array<{ __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null }>, featureFlags: { __typename?: 'MarketplaceFeatureFlags', waitListEnabled?: boolean | null, acceptedPaymentMethods?: { __typename?: 'AcceptedPaymentMethods', creditCard?: boolean | null, applePay?: boolean | null } | null } }> } | null };

export type MarketplaceGroupUsersQueryVariables = Exact<{
  id: Scalars['ID'];
  page?: InputMaybe<MarketplaceUserPageInput>;
}>;


export type MarketplaceGroupUsersQuery = { __typename?: 'Query', marketplaceGroup?: { __typename?: 'MarketplaceGroup', id: string, label: string, createdAt: any, messagingServiceSid?: string | null, marketplaceUsers: { __typename?: 'MarketplaceUserPage', totalCount: number, data: Array<{ __typename?: 'MarketplaceUser', id: string, createdAt: any, updatedAt: any, groupId: string, membership: string, primaryInstrumentId?: string | null, email?: string | null, phone?: string | null, emailConfirmed: boolean, phoneConfirmed: boolean, emailOptIn: boolean, phoneOptIn: boolean, clientProfile?: { __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null } | null }> }, marketplaces: Array<{ __typename?: 'Marketplace', packages: Array<{ __typename?: 'Package', id: string, name: string, price: number, marketplaceId: string, advertise: boolean, description?: string | null, list?: string | null }>, membershipDefinitions: Array<{ __typename?: 'MembershipDefinition', id: string, name: string, price: number, period: MembershipDefinitionPeriodType, packageId?: string | null, marketplaceId: string, advertise: boolean, description?: string | null, list?: string | null }> }> } | null };

export type MarketplaceGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type MarketplaceGroupsQuery = { __typename?: 'Query', marketplaceGroups: Array<{ __typename?: 'MarketplaceGroup', id: string, label: string, createdAt: any, messagingServiceSid?: string | null, marketplaces: Array<{ __typename?: 'Marketplace', id: string, name: string, groupId: string, createdAt: any, logo?: string | null, favicon?: string | null, primaryColor?: string | null, marketingSiteUrl?: string | null, gtmContainer?: string | null, gtmRequiresConsent: boolean, gtmDataTier: GtmDataTier, gtmV2Enabled: boolean, featureFlags: { __typename?: 'MarketplaceFeatureFlags', waitListEnabled?: boolean | null, acceptedPaymentMethods?: { __typename?: 'AcceptedPaymentMethods', creditCard?: boolean | null, applePay?: boolean | null } | null } }> }> };

export type MarketplaceMessagingSenderQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type MarketplaceMessagingSenderQuery = { __typename?: 'Query', marketplace?: { __typename?: 'Marketplace', id: string, twilio?: { __typename?: 'TwilioIntegration', id: string, messagingSender?: { __typename?: 'MessagingSenderStatus', sid?: string | null, source: MessagingSenderSource, phoneNumbers?: Array<string> | null, error?: string | null } | null } | null } | null };

export type MarketplaceMfaModeQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type MarketplaceMfaModeQuery = { __typename?: 'Query', marketplace?: { __typename?: 'Marketplace', id: string, mfaMode?: { __typename?: 'MfaScopeMode', setting: MfaModeSetting, inherited: MfaMode, effective: MfaMode, enabled: boolean } | null } | null };

export type MarketplacePaymentsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type MarketplacePaymentsQuery = { __typename?: 'Query', marketplace?: { __typename?: 'Marketplace', requireDispatchApproval: boolean, requirePractitionerApproval: boolean, dispatchStrategy?: DispatchStrategy | null, bookingMode?: BookingMode | null, slackWebhookUrl?: string | null, reviewsIoKeyDescription?: string | null, consentTokenSecretDescription?: string | null, reviewsIoStoreId?: string | null, paymentAccountId?: string | null, feeProfileFixed?: number | null, feeProfileBasisPoints?: number | null, logo?: string | null, favicon?: string | null, primaryColor?: string | null, marketingSiteUrl?: string | null, paymentCollectionMethod?: PaymentCollectionMethod | null, paymentDepositType?: PaymentDepositType | null, paymentDepositValue?: number | null, hasPaymentPolicy?: boolean | null, paymentPolicyName?: string | null, paymentPolicyText?: string | null, requirePaymentPolicyAttestation?: boolean | null, id: string, name: string, groupId: string, createdAt: any, gtmContainer?: string | null, gtmRequiresConsent: boolean, gtmDataTier: GtmDataTier, gtmV2Enabled: boolean, paymentAccounts: Array<{ __typename?: 'PaymentAccount', id: string, label: string, platform: PaymentAccountPlatform, enabled: boolean, state: PaymentAccountState, onboardingUrl?: string | null, createdAt: any, updatedAt: any }>, checkoutContent: { __typename?: 'MarketplaceCheckoutContent', servicesNotice?: string | null, scheduleNotice?: string | null, confirmationMessage?: string | null, footerLinks: Array<{ __typename?: 'MarketplaceFooterLink', label: string, url: string }> }, featureFlags: { __typename?: 'MarketplaceFeatureFlags', waitListEnabled?: boolean | null, acceptedPaymentMethods?: { __typename?: 'AcceptedPaymentMethods', creditCard?: boolean | null, applePay?: boolean | null } | null, windowBooking?: { __typename?: 'WindowBookingConfig', allowSpecificTimeRequest?: boolean | null, minRemainingMinutes?: number | null, windows?: Array<{ __typename?: 'WindowConfig', key: WindowKey, enabled: boolean, startTime: string, endTime: string }> | null } | null } } | null };

export type MarketplaceUserQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type MarketplaceUserQuery = { __typename?: 'Query', marketplaceUser: { __typename?: 'MarketplaceUser', id: string, createdAt: any, updatedAt: any, groupId: string, membership: string, primaryInstrumentId?: string | null, email?: string | null, phone?: string | null, emailConfirmed: boolean, phoneConfirmed: boolean, emailOptIn: boolean, phoneOptIn: boolean, clientProfiles: Array<{ __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null, organizations: Array<{ __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null }> }>, packageItems: Array<{ __typename?: 'PackageItem', marketplaceName: string, id: string, packageItemDefinitionId: string, membershipId?: string | null, balance: number, packageName: string, totalPoints: number, groupNames: string, expiresAt?: any | null, primaryOrganizationId?: string | null }>, memberships: Array<{ __typename?: 'Membership', marketplaceName: string, id: string, membershipDefinitionId: string, renewalDate: any, name: string, status: MembershipStatusType }>, marketplaceGroup: { __typename?: 'MarketplaceGroup', id: string, label: string, createdAt: any, messagingServiceSid?: string | null }, paymentInstruments: Array<{ __typename?: 'PaymentInstrument', id: string, type: PaymentInstrumentType, processor: PaymentAccountPlatform, brand?: string | null, lastFour?: string | null, expirationMonth?: number | null, expirationYear?: number | null, createdAt: any, updatedAt: any }>, checkouts: Array<{ __typename?: 'Checkout', id: string, total: number, paid: number, balance: number, marketplaceUserId?: string | null, summary?: string | null, voidedAt?: any | null, paymentMethodType?: PaymentMethodType | null, createdAt: any, updatedAt: any, items: Array<{ __typename?: 'CheckoutItem', id: string, type: CheckoutItemType, description: string, quantity: number, price: number, key?: string | null }>, paymentLinks: Array<{ __typename?: 'PaymentLink', id: string, checkoutId: string, url: string, status: PaymentLinkStatus, amount: number, expiresAt?: any | null, createdAt: any, updatedAt: any }> }>, appointments: Array<{ __typename?: 'Appointment', intakeStatus?: string | null, id: string, location: string, latitude?: number | null, longitude?: number | null, start: any, end: any, duration: number, createdAt: any, updatedAt: any, archivedAt?: any | null, status: AppointmentStatus, startedAt?: any | null, completedAt?: any | null, notes?: string | null, createdBy?: string | null, cancelReason?: string | null, groupId?: string | null, ordersRequired: boolean, participants: Array<{ __typename?: 'AppointmentParticipant', id: string, name: string, type: ParticipantType, status: ParticipationStatus, profileId?: string | null, clientProfileId?: string | null, orderApproved?: boolean | null }>, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }>, checkout?: { __typename?: 'Checkout', id: string, total: number, paid: number, balance: number, marketplaceUserId?: string | null, summary?: string | null, voidedAt?: any | null, paymentMethodType?: PaymentMethodType | null, createdAt: any, updatedAt: any, paymentLinks: Array<{ __typename?: 'PaymentLink', id: string, checkoutId: string, url: string, status: PaymentLinkStatus, amount: number, expiresAt?: any | null, createdAt: any, updatedAt: any }> } | null, additionalPatients: Array<{ __typename?: 'AppointmentRequestPatient', id: string, clientProfile: { __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null }, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }> }> }>, appointmentRequests: Array<{ __typename?: 'AppointmentRequest', id: string, location: string, latitude?: number | null, longitude?: number | null, status: AppointmentRequestStatus, bookingMode?: BookingMode | null, cancelReason?: string | null, notes?: string | null, lastResetAt?: any | null, waitlistedAt?: any | null, createdAt: any, updatedAt: any, archivedAt?: any | null, marketplace: { __typename?: 'Marketplace', id: string, name: string, groupId: string, createdAt: any, logo?: string | null, favicon?: string | null, primaryColor?: string | null, marketingSiteUrl?: string | null, gtmContainer?: string | null, gtmRequiresConsent: boolean, gtmDataTier: GtmDataTier, gtmV2Enabled: boolean, featureFlags: { __typename?: 'MarketplaceFeatureFlags', waitListEnabled?: boolean | null, acceptedPaymentMethods?: { __typename?: 'AcceptedPaymentMethods', creditCard?: boolean | null, applePay?: boolean | null } | null } }, clientProfiles: Array<{ __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null }>, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }>, constraints: Array<{ __typename?: 'AppointmentConstraint', id: string, organizations: Array<{ __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null }>, profiles: Array<{ __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null }>, timeRanges: Array<{ __typename?: 'AppointmentTimeRange', id: string, start: any, end: any }> }>, additionalPatients: Array<{ __typename?: 'AppointmentRequestPatient', id: string, clientProfile: { __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null }, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }> }> }>, clientProfile?: { __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null } | null } };

export type MarketplaceUsersQueryVariables = Exact<{
  page?: InputMaybe<MarketplaceUserPageInput>;
}>;


export type MarketplaceUsersQuery = { __typename?: 'Query', marketplaceUsers: { __typename?: 'MarketplaceUserPage', totalCount: number, data: Array<{ __typename?: 'MarketplaceUser', id: string, createdAt: any, updatedAt: any, groupId: string, membership: string, primaryInstrumentId?: string | null, email?: string | null, phone?: string | null, emailConfirmed: boolean, phoneConfirmed: boolean, emailOptIn: boolean, phoneOptIn: boolean, memberships: Array<{ __typename?: 'Membership', id: string, membershipDefinitionId: string, renewalDate: any, name: string, status: MembershipStatusType }>, marketplaceGroup: { __typename?: 'MarketplaceGroup', id: string, label: string, createdAt: any, messagingServiceSid?: string | null }, clientProfile?: { __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null } | null }> } };

export type MarketplacesQueryVariables = Exact<{ [key: string]: never; }>;


export type MarketplacesQuery = { __typename?: 'Query', marketplaces: Array<{ __typename?: 'Marketplace', id: string, name: string, groupId: string, createdAt: any, logo?: string | null, favicon?: string | null, primaryColor?: string | null, marketingSiteUrl?: string | null, gtmContainer?: string | null, gtmRequiresConsent: boolean, gtmDataTier: GtmDataTier, gtmV2Enabled: boolean, roles: Array<{ __typename?: 'Role', id: string, name: string, scope: RoleScope, type: RoleType, permissions: Array<string>, resourceId?: string | null }>, organizations: Array<{ __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null }>, featureFlags: { __typename?: 'MarketplaceFeatureFlags', waitListEnabled?: boolean | null, acceptedPaymentMethods?: { __typename?: 'AcceptedPaymentMethods', creditCard?: boolean | null, applePay?: boolean | null } | null } }> };

export type MarketplacesMetricsQueryVariables = Exact<{ [key: string]: never; }>;


export type MarketplacesMetricsQuery = { __typename?: 'Query', marketplaces: Array<{ __typename?: 'Marketplace', id: string, name: string, groupId: string, createdAt: any, logo?: string | null, favicon?: string | null, primaryColor?: string | null, marketingSiteUrl?: string | null, gtmContainer?: string | null, gtmRequiresConsent: boolean, gtmDataTier: GtmDataTier, gtmV2Enabled: boolean, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }>, procedureBaseDefGroups: Array<{ __typename?: 'ProcedureBaseDefinitionGroup', id: string, name: string, thumbnail?: string | null, banner?: string | null, type: ProcedureGroupType, description?: string | null, bgcolor?: string | null, fontColor?: string | null, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string }>, featuredBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string }>, procedureBaseDefGroups: Array<{ __typename?: 'ProcedureBaseDefinitionGroup', id: string, name: string, type: ProcedureGroupType }> }>, organizations: Array<{ __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null }>, featureFlags: { __typename?: 'MarketplaceFeatureFlags', waitListEnabled?: boolean | null, acceptedPaymentMethods?: { __typename?: 'AcceptedPaymentMethods', creditCard?: boolean | null, applePay?: boolean | null } | null } }> };

export type MembershipDefinitionQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type MembershipDefinitionQuery = { __typename?: 'Query', membershipDefinition?: { __typename?: 'MembershipDefinition', id: string, name: string, price: number, period: MembershipDefinitionPeriodType, packageId?: string | null, marketplaceId: string, advertise: boolean, description?: string | null, list?: string | null, discounts: Array<{ __typename?: 'Discount', id: string, percentage: number, membershipDefinitionId: string, procedureGroups: Array<{ __typename?: 'ProcedureBaseDefinitionGroup', id: string, name: string }> }> } | null };

export type MetricsQueryVariables = Exact<{
  input: MetricsInput;
}>;


export type MetricsQuery = { __typename?: 'Query', metrics: Array<{ __typename?: 'MetricData', id: string, type: MetricChartTypes, count?: number | null, data?: { __typename?: 'ChartData', labels: Array<string>, datasets: Array<{ __typename?: 'Dataset', label: string, data: Array<number>, backgroundColor: Array<string>, borderColor: Array<string> }> } | null }> };

export type MfaEnrollmentReportQueryVariables = Exact<{ [key: string]: never; }>;


export type MfaEnrollmentReportQuery = { __typename?: 'Query', mfaEnrollmentReport: { __typename?: 'MfaEnrollmentReport', enabled: boolean, platformMode: MfaMode, generatedAt: any, totals: { __typename?: 'MfaEnrollmentTotals', users: number, enrolled: number, percentEnrolled: number, inGrace: number, pastGrace: number }, rows: Array<{ __typename?: 'MfaEnrollmentRow', kind: RoleScope, id?: string | null, name: string, setting: MfaModeSetting, mode: MfaMode, users: number, enrolled: number, percentEnrolled: number, inGrace: number, pastGrace: number }> } };

export type OrganizationQueryVariables = Exact<{
  id: Scalars['ID'];
  includeArchived?: InputMaybe<Scalars['Boolean']>;
}>;


export type OrganizationQuery = { __typename?: 'Query', organization?: { __typename?: 'Organization', qualiphyEnabled: boolean, id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null, archivedProfiles: Array<{ __typename?: 'Profile', archivedAt?: any | null, id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, procedureProfiles: Array<{ __typename?: 'ProcedureProfile', createdAt: any, id: string, name: string, updatedAt: any }>, availabilities: Array<{ __typename?: 'Availability', id: string, type: AvailabilityType, start: any, end: any, tzid: string, duration: number, createdAt: any, updatedAt: any, repeat?: { __typename?: 'RepeatRule', id: string, frequency: RepeatFrequencyType, byWeekday: Array<RepeatWeekdayType>, until?: any | null } | null }>, roles: Array<{ __typename?: 'Role', id: string, name: string, scope: RoleScope, type: RoleType, permissions: Array<string>, resourceId?: string | null }>, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null }>, profiles: Array<{ __typename?: 'Profile', latitude?: number | null, longitude?: number | null, id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, procedureProfiles: Array<{ __typename?: 'ProcedureProfile', createdAt: any, id: string, name: string, updatedAt: any }>, availabilities: Array<{ __typename?: 'Availability', id: string, type: AvailabilityType, start: any, end: any, tzid: string, duration: number, createdAt: any, updatedAt: any, repeat?: { __typename?: 'RepeatRule', id: string, frequency: RepeatFrequencyType, byWeekday: Array<RepeatWeekdayType>, until?: any | null } | null }>, roles: Array<{ __typename?: 'Role', id: string, name: string, scope: RoleScope, type: RoleType, permissions: Array<string>, resourceId?: string | null }>, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null }>, roles: Array<{ __typename?: 'Role', id: string, name: string, scope: RoleScope, type: RoleType, permissions: Array<string>, resourceId?: string | null }>, procedureDefs: Array<{ __typename?: 'ProcedureDefinition', id: string, name: string, description: string, price: number, duration: number, assessmentFormTemplateId?: string | null, interventionFormTemplateId?: string | null, ordersRequired: boolean, createdAt: any, baseDefinitions: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }>, consentForms: Array<{ __typename?: 'Document', id: string, filename: string, label: string, type: DocumentType, version: number, fileSize: number, url: string, createdAt: any, updatedAt: any }>, intakeFormTemplates: Array<{ __typename?: 'FormTemplate', id: string, name: string }> }>, procedureProfiles: Array<{ __typename?: 'ProcedureProfile', createdAt: any, id: string, name: string, updatedAt: any, procedureDefs: Array<{ __typename?: 'ProcedureDefinition', id: string }> }>, marketplaces: Array<{ __typename?: 'Marketplace', id: string, name: string, groupId: string, createdAt: any, logo?: string | null, favicon?: string | null, primaryColor?: string | null, marketingSiteUrl?: string | null, gtmContainer?: string | null, gtmRequiresConsent: boolean, gtmDataTier: GtmDataTier, gtmV2Enabled: boolean, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }>, featureFlags: { __typename?: 'MarketplaceFeatureFlags', waitListEnabled?: boolean | null, acceptedPaymentMethods?: { __typename?: 'AcceptedPaymentMethods', creditCard?: boolean | null, applePay?: boolean | null } | null } }>, emrInstance?: { __typename?: 'EmrInstance', id: string, label: string, createdAt: any } | null, medications: Array<{ __typename?: 'Medication', id: string, name: string, unit: string, createdAt: any }>, availabilityCoverages: Array<{ __typename?: 'AvailabilityCoverage', id: string, label: string, threshold: number, start: any, end: any, tzid: string, repeat?: { __typename?: 'RepeatRule', id: string, frequency: RepeatFrequencyType, byWeekday: Array<RepeatWeekdayType>, until?: any | null } | null, profiles: Array<{ __typename?: 'ProcedureProfile', id: string }> }>, paymentAccounts: Array<{ __typename?: 'PaymentAccount', id: string, label: string, platform: PaymentAccountPlatform, enabled: boolean, state: PaymentAccountState, onboardingUrl?: string | null, createdAt: any, updatedAt: any }> } | null };

export type OrganizationAppointmentsQueryVariables = Exact<{
  id: Scalars['ID'];
  page?: InputMaybe<AppointmentPageInput>;
}>;


export type OrganizationAppointmentsQuery = { __typename?: 'Query', organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null, appointments: { __typename?: 'AppointmentPage', totalCount: number, data: Array<{ __typename?: 'Appointment', intakeStatus?: string | null, id: string, location: string, latitude?: number | null, longitude?: number | null, start: any, end: any, duration: number, createdAt: any, updatedAt: any, archivedAt?: any | null, status: AppointmentStatus, startedAt?: any | null, completedAt?: any | null, notes?: string | null, createdBy?: string | null, cancelReason?: string | null, groupId?: string | null, ordersRequired: boolean, participants: Array<{ __typename?: 'AppointmentParticipant', id: string, name: string, type: ParticipantType, status: ParticipationStatus, profileId?: string | null, clientProfileId?: string | null, orderApproved?: boolean | null }>, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }>, checkout?: { __typename?: 'Checkout', id: string, total: number, paid: number, balance: number, marketplaceUserId?: string | null, summary?: string | null, voidedAt?: any | null, paymentMethodType?: PaymentMethodType | null, createdAt: any, updatedAt: any, paymentLinks: Array<{ __typename?: 'PaymentLink', id: string, checkoutId: string, url: string, status: PaymentLinkStatus, amount: number, expiresAt?: any | null, createdAt: any, updatedAt: any }> } | null, additionalPatients: Array<{ __typename?: 'AppointmentRequestPatient', id: string, clientProfile: { __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null }, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }> }> }> } } | null };

export type OrganizationClientProfilesQueryVariables = Exact<{
  id: Scalars['ID'];
  page?: InputMaybe<ClientProfilePageInput>;
}>;


export type OrganizationClientProfilesQuery = { __typename?: 'Query', organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null, clientProfiles: { __typename?: 'ClientProfilePage', totalCount: number, data: Array<{ __typename?: 'ClientProfile', id: string, dob: string, email: string, givenName: string, familyName: string, internalNotes?: string | null, phone: string, address: string, tzid: string, sexAssignedAtBirth?: string | null, createdAt: any, updatedAt: any, membership: string, marketplaceUserId?: string | null }> } } | null };

export type OrganizationCoverageRangesQueryVariables = Exact<{
  id: Scalars['ID'];
  input: AvailabilityCoverageRangeInput;
}>;


export type OrganizationCoverageRangesQuery = { __typename?: 'Query', organization?: { __typename?: 'Organization', id: string, availabilityCoverageRanges: Array<{ __typename?: 'AvailabilityCoverageRange', tzid: string, id: string, start: any, end: any, label: string, type: CoverageType, procedureProfileIds: Array<string> }> } | null };

export type OrganizationDetailQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type OrganizationDetailQuery = { __typename?: 'Query', organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null, roles: Array<{ __typename?: 'Role', id: string, name: string, scope: RoleScope, type: RoleType, permissions: Array<string>, resourceId?: string | null }>, procedureProfiles: Array<{ __typename?: 'ProcedureProfile', createdAt: any, id: string, name: string, updatedAt: any, procedureDefs: Array<{ __typename?: 'ProcedureDefinition', id: string, name: string, description: string, price: number, duration: number, assessmentFormTemplateId?: string | null, interventionFormTemplateId?: string | null, ordersRequired: boolean, createdAt: any, intakeFormTemplates: Array<{ __typename?: 'FormTemplate', id: string, name: string }> }> }> } | null };

export type OrganizationGeoperimetersQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type OrganizationGeoperimetersQuery = { __typename?: 'Query', organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null, geoperimeters: Array<{ __typename?: 'Geoperimeter', id: string, type: GeoperimeterType, organizationId: string, lat?: number | null, lng?: number | null, radius?: number | null, paths?: string | null, travelFee?: number | null }> } | null };

export type OrganizationMfaModeQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type OrganizationMfaModeQuery = { __typename?: 'Query', organization?: { __typename?: 'Organization', id: string, mfaMode?: { __typename?: 'MfaScopeMode', setting: MfaModeSetting, inherited: MfaMode, effective: MfaMode, enabled: boolean } | null } | null };

export type OrganizationPaymentsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type OrganizationPaymentsQuery = { __typename?: 'Query', organization?: { __typename?: 'Organization', paymentAccountId?: string | null, id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null, paymentAccounts: Array<{ __typename?: 'PaymentAccount', id: string, label: string, platform: PaymentAccountPlatform, enabled: boolean, state: PaymentAccountState, onboardingUrl?: string | null, createdAt: any, updatedAt: any }> } | null };

export type OrganizationQualiphyConfigQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type OrganizationQualiphyConfigQuery = { __typename?: 'Query', organization?: { __typename?: 'Organization', slackWebhookUrl?: string | null, qualiphyEnabled: boolean, id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null, qualiphy?: { __typename?: 'QualiphyIntegration', id: string, enabled: boolean, apiKeyDescription?: string | null, exams?: Array<{ __typename?: 'QualiphyExam', id: string, qualiphyId: string, title: string, index: number, procedureDefinitions?: Array<string> | null, expiresAfter: number, refills: number, archived: boolean }> | null } | null, profiles: Array<{ __typename?: 'Profile', latitude?: number | null, longitude?: number | null, id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, procedureProfiles: Array<{ __typename?: 'ProcedureProfile', createdAt: any, id: string, name: string, updatedAt: any }>, availabilities: Array<{ __typename?: 'Availability', id: string, type: AvailabilityType, start: any, end: any, tzid: string, duration: number, createdAt: any, updatedAt: any, repeat?: { __typename?: 'RepeatRule', id: string, frequency: RepeatFrequencyType, byWeekday: Array<RepeatWeekdayType>, until?: any | null } | null }>, roles: Array<{ __typename?: 'Role', id: string, name: string, scope: RoleScope, type: RoleType, permissions: Array<string>, resourceId?: string | null }>, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null }>, roles: Array<{ __typename?: 'Role', id: string, name: string, scope: RoleScope, type: RoleType, permissions: Array<string>, resourceId?: string | null }>, procedureDefs: Array<{ __typename?: 'ProcedureDefinition', id: string, name: string, description: string, price: number, duration: number, assessmentFormTemplateId?: string | null, interventionFormTemplateId?: string | null, ordersRequired: boolean, createdAt: any, baseDefinitions: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }>, consentForms: Array<{ __typename?: 'Document', id: string, filename: string, label: string, type: DocumentType, version: number, fileSize: number, url: string, createdAt: any, updatedAt: any }>, intakeFormTemplates: Array<{ __typename?: 'FormTemplate', id: string, name: string }> }>, procedureProfiles: Array<{ __typename?: 'ProcedureProfile', createdAt: any, id: string, name: string, updatedAt: any, procedureDefs: Array<{ __typename?: 'ProcedureDefinition', id: string }> }>, marketplaces: Array<{ __typename?: 'Marketplace', id: string, name: string, groupId: string, createdAt: any, logo?: string | null, favicon?: string | null, primaryColor?: string | null, marketingSiteUrl?: string | null, gtmContainer?: string | null, gtmRequiresConsent: boolean, gtmDataTier: GtmDataTier, gtmV2Enabled: boolean, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }>, featureFlags: { __typename?: 'MarketplaceFeatureFlags', waitListEnabled?: boolean | null, acceptedPaymentMethods?: { __typename?: 'AcceptedPaymentMethods', creditCard?: boolean | null, applePay?: boolean | null } | null } }>, emrInstance?: { __typename?: 'EmrInstance', id: string, label: string, createdAt: any } | null, medications: Array<{ __typename?: 'Medication', id: string, name: string, unit: string, createdAt: any }>, availabilityCoverages: Array<{ __typename?: 'AvailabilityCoverage', id: string, label: string, threshold: number, start: any, end: any, tzid: string, repeat?: { __typename?: 'RepeatRule', id: string, frequency: RepeatFrequencyType, byWeekday: Array<RepeatWeekdayType>, until?: any | null } | null, profiles: Array<{ __typename?: 'ProcedureProfile', id: string }> }>, paymentAccounts: Array<{ __typename?: 'PaymentAccount', id: string, label: string, platform: PaymentAccountPlatform, enabled: boolean, state: PaymentAccountState, onboardingUrl?: string | null, createdAt: any, updatedAt: any }> } | null };

export type OrganizationSettingsQueryVariables = Exact<{
  id: Scalars['ID'];
  includeArchived?: InputMaybe<Scalars['Boolean']>;
}>;


export type OrganizationSettingsQuery = { __typename?: 'Query', organization?: { __typename?: 'Organization', slackWebhookUrl?: string | null, googleReviewsUrl?: string | null, paymentAccountId?: string | null, qualiphyEnabled: boolean, id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null, archivedProfiles: Array<{ __typename?: 'Profile', archivedAt?: any | null, id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, procedureProfiles: Array<{ __typename?: 'ProcedureProfile', createdAt: any, id: string, name: string, updatedAt: any }>, availabilities: Array<{ __typename?: 'Availability', id: string, type: AvailabilityType, start: any, end: any, tzid: string, duration: number, createdAt: any, updatedAt: any, repeat?: { __typename?: 'RepeatRule', id: string, frequency: RepeatFrequencyType, byWeekday: Array<RepeatWeekdayType>, until?: any | null } | null }>, roles: Array<{ __typename?: 'Role', id: string, name: string, scope: RoleScope, type: RoleType, permissions: Array<string>, resourceId?: string | null }>, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null }>, profiles: Array<{ __typename?: 'Profile', latitude?: number | null, longitude?: number | null, id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, procedureProfiles: Array<{ __typename?: 'ProcedureProfile', createdAt: any, id: string, name: string, updatedAt: any }>, availabilities: Array<{ __typename?: 'Availability', id: string, type: AvailabilityType, start: any, end: any, tzid: string, duration: number, createdAt: any, updatedAt: any, repeat?: { __typename?: 'RepeatRule', id: string, frequency: RepeatFrequencyType, byWeekday: Array<RepeatWeekdayType>, until?: any | null } | null }>, roles: Array<{ __typename?: 'Role', id: string, name: string, scope: RoleScope, type: RoleType, permissions: Array<string>, resourceId?: string | null }>, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null }>, roles: Array<{ __typename?: 'Role', id: string, name: string, scope: RoleScope, type: RoleType, permissions: Array<string>, resourceId?: string | null }>, procedureDefs: Array<{ __typename?: 'ProcedureDefinition', id: string, name: string, description: string, price: number, duration: number, assessmentFormTemplateId?: string | null, interventionFormTemplateId?: string | null, ordersRequired: boolean, createdAt: any, baseDefinitions: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }>, consentForms: Array<{ __typename?: 'Document', id: string, filename: string, label: string, type: DocumentType, version: number, fileSize: number, url: string, createdAt: any, updatedAt: any }>, intakeFormTemplates: Array<{ __typename?: 'FormTemplate', id: string, name: string }> }>, procedureProfiles: Array<{ __typename?: 'ProcedureProfile', createdAt: any, id: string, name: string, updatedAt: any, procedureDefs: Array<{ __typename?: 'ProcedureDefinition', id: string }> }>, marketplaces: Array<{ __typename?: 'Marketplace', id: string, name: string, groupId: string, createdAt: any, logo?: string | null, favicon?: string | null, primaryColor?: string | null, marketingSiteUrl?: string | null, gtmContainer?: string | null, gtmRequiresConsent: boolean, gtmDataTier: GtmDataTier, gtmV2Enabled: boolean, procedureBaseDefs: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }>, featureFlags: { __typename?: 'MarketplaceFeatureFlags', waitListEnabled?: boolean | null, acceptedPaymentMethods?: { __typename?: 'AcceptedPaymentMethods', creditCard?: boolean | null, applePay?: boolean | null } | null } }>, emrInstance?: { __typename?: 'EmrInstance', id: string, label: string, createdAt: any } | null, medications: Array<{ __typename?: 'Medication', id: string, name: string, unit: string, createdAt: any }>, availabilityCoverages: Array<{ __typename?: 'AvailabilityCoverage', id: string, label: string, threshold: number, start: any, end: any, tzid: string, repeat?: { __typename?: 'RepeatRule', id: string, frequency: RepeatFrequencyType, byWeekday: Array<RepeatWeekdayType>, until?: any | null } | null, profiles: Array<{ __typename?: 'ProcedureProfile', id: string }> }>, paymentAccounts: Array<{ __typename?: 'PaymentAccount', id: string, label: string, platform: PaymentAccountPlatform, enabled: boolean, state: PaymentAccountState, onboardingUrl?: string | null, createdAt: any, updatedAt: any }> } | null };

export type OrganizationsQueryVariables = Exact<{ [key: string]: never; }>;


export type OrganizationsQuery = { __typename?: 'Query', organizations: Array<{ __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null }> };

export type PackageQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type PackageQuery = { __typename?: 'Query', package?: { __typename?: 'Package', id: string, name: string, price: number, marketplaceId: string, advertise: boolean, description?: string | null, list?: string | null, packageItemDefinitions: Array<{ __typename?: 'PackageItemDefinition', id: string, packageId: string, points: number, procedureGroups: Array<string> }> } | null };

export type PaymentAccountQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type PaymentAccountQuery = { __typename?: 'Query', paymentAccount?: { __typename?: 'PaymentAccount', id: string, label: string, platform: PaymentAccountPlatform, enabled: boolean, state: PaymentAccountState, onboardingUrl?: string | null, createdAt: any, updatedAt: any, organizations: Array<{ __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null }>, marketplaces: Array<{ __typename?: 'Marketplace', id: string, name: string, groupId: string, createdAt: any, logo?: string | null, favicon?: string | null, primaryColor?: string | null, marketingSiteUrl?: string | null, gtmContainer?: string | null, gtmRequiresConsent: boolean, gtmDataTier: GtmDataTier, gtmV2Enabled: boolean, featureFlags: { __typename?: 'MarketplaceFeatureFlags', waitListEnabled?: boolean | null, acceptedPaymentMethods?: { __typename?: 'AcceptedPaymentMethods', creditCard?: boolean | null, applePay?: boolean | null } | null } }> } | null };

export type PaymentAccountsQueryVariables = Exact<{ [key: string]: never; }>;


export type PaymentAccountsQuery = { __typename?: 'Query', paymentAccounts: Array<{ __typename?: 'PaymentAccount', id: string, label: string, platform: PaymentAccountPlatform, enabled: boolean, state: PaymentAccountState, onboardingUrl?: string | null, createdAt: any, updatedAt: any, organizations: Array<{ __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null }>, marketplaces: Array<{ __typename?: 'Marketplace', id: string, name: string, groupId: string, createdAt: any, logo?: string | null, favicon?: string | null, primaryColor?: string | null, marketingSiteUrl?: string | null, gtmContainer?: string | null, gtmRequiresConsent: boolean, gtmDataTier: GtmDataTier, gtmV2Enabled: boolean, featureFlags: { __typename?: 'MarketplaceFeatureFlags', waitListEnabled?: boolean | null, acceptedPaymentMethods?: { __typename?: 'AcceptedPaymentMethods', creditCard?: boolean | null, applePay?: boolean | null } | null } }> }> };

export type PayoutsQueryVariables = Exact<{
  page?: InputMaybe<PayoutPageInput>;
}>;


export type PayoutsQuery = { __typename?: 'Query', payouts: { __typename?: 'PayoutPage', totalCount: number, data: Array<{ __typename?: 'Payout', id: string, status: PayoutStatus, description: string, amount: number, amountRequested: number, amountReversed?: number | null, createdAt: any, updatedAt: any, checkoutId: string, checkout?: { __typename?: 'Checkout', id: string, total: number, paid: number, balance: number, marketplaceUserId?: string | null, summary?: string | null, voidedAt?: any | null, paymentMethodType?: PaymentMethodType | null, createdAt: any, updatedAt: any, marketplace?: { __typename?: 'Marketplace', id: string, name: string, groupId: string, createdAt: any, logo?: string | null, favicon?: string | null, primaryColor?: string | null, marketingSiteUrl?: string | null, gtmContainer?: string | null, gtmRequiresConsent: boolean, gtmDataTier: GtmDataTier, gtmV2Enabled: boolean, featureFlags: { __typename?: 'MarketplaceFeatureFlags', waitListEnabled?: boolean | null, acceptedPaymentMethods?: { __typename?: 'AcceptedPaymentMethods', creditCard?: boolean | null, applePay?: boolean | null } | null } } | null, paymentLinks: Array<{ __typename?: 'PaymentLink', id: string, checkoutId: string, url: string, status: PaymentLinkStatus, amount: number, expiresAt?: any | null, createdAt: any, updatedAt: any }> } | null }> } };

export type ProcedureBaseDefinitionQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ProcedureBaseDefinitionQuery = { __typename?: 'Query', procedureBaseDefinition?: { __typename?: 'ProcedureBaseDefinition', tags: Array<string>, addOns: Array<string>, id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null, layouts: Array<{ __typename?: 'ProcedureBaseDefinitionLayout', type: ProcedureBaseDefinitionLayoutType, layout: string, itemIndex: number }> } | null };

export type ProcedureDefinitionQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ProcedureDefinitionQuery = { __typename?: 'Query', procedureDefinition?: { __typename?: 'ProcedureDefinition', id: string, name: string, description: string, price: number, duration: number, assessmentFormTemplateId?: string | null, interventionFormTemplateId?: string | null, ordersRequired: boolean, createdAt: any, baseDefinitions: Array<{ __typename?: 'ProcedureBaseDefinition', tags: Array<string>, id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }>, medicationProtocols: Array<{ __typename?: 'MedicationProtocol', id: string, dose: number, createdAt: any, medication: { __typename?: 'Medication', id: string, name: string, unit: string, createdAt: any } }>, consentForms: Array<{ __typename?: 'Document', id: string, filename: string, label: string, type: DocumentType, version: number, fileSize: number, url: string, createdAt: any, updatedAt: any }>, intakeFormTemplates: Array<{ __typename?: 'FormTemplate', id: string, name: string }> } | null };

export type ProfileQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ProfileQuery = { __typename?: 'Query', profile?: { __typename?: 'Profile', latitude?: number | null, longitude?: number | null, id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null, procedureProfiles: Array<{ __typename?: 'ProcedureProfile', createdAt: any, id: string, name: string, updatedAt: any, procedureDefs: Array<{ __typename?: 'ProcedureDefinition', id: string, name: string, description: string, price: number, duration: number, assessmentFormTemplateId?: string | null, interventionFormTemplateId?: string | null, ordersRequired: boolean, createdAt: any, baseDefinitions: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }>, intakeFormTemplates: Array<{ __typename?: 'FormTemplate', id: string, name: string }> }> }>, availabilities: Array<{ __typename?: 'Availability', id: string, type: AvailabilityType, start: any, end: any, tzid: string, duration: number, createdAt: any, updatedAt: any, repeat?: { __typename?: 'RepeatRule', id: string, frequency: RepeatFrequencyType, byWeekday: Array<RepeatWeekdayType>, until?: any | null } | null }>, roles: Array<{ __typename?: 'Role', id: string, name: string, scope: RoleScope, type: RoleType, permissions: Array<string>, resourceId?: string | null }> } | null };

export type ProfilesQueryVariables = Exact<{ [key: string]: never; }>;


export type ProfilesQuery = { __typename?: 'Query', profiles: Array<{ __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null }> };

export type PromoCodeQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type PromoCodeQuery = { __typename?: 'Query', promoCode?: { __typename?: 'PromoCode', id: string, name: string, code: string, discountType: PromoCodeDiscountType, discountValue: number, activationStartDate: any, activationEndDate: any, usageStartDate: any, usageEndDate: any, usageLimitTotal?: number | null, usageLimitPerUser?: number | null, minimumBookingAmount?: number | null, active: boolean, marketplaceId: string, createdAt: any, updatedAt: any, procedureGroups: Array<{ __typename?: 'ProcedureBaseDefinitionGroup', id: string, name: string }>, organizations: Array<{ __typename?: 'Organization', id: string, name: string }>, usage: Array<{ __typename?: 'PromoCodeUsage', id: string, marketplaceUserId: string, discountAmount: number, usedAt: any }> } | null };

export type PromoCodesQueryVariables = Exact<{
  marketplaceId: Scalars['ID'];
}>;


export type PromoCodesQuery = { __typename?: 'Query', promoCodes: Array<{ __typename?: 'PromoCode', id: string, name: string, code: string, discountType: PromoCodeDiscountType, discountValue: number, activationStartDate: any, activationEndDate: any, usageStartDate: any, usageEndDate: any, usageLimitTotal?: number | null, usageLimitPerUser?: number | null, minimumBookingAmount?: number | null, active: boolean, marketplaceId: string, createdAt: any, updatedAt: any, procedureGroups: Array<{ __typename?: 'ProcedureBaseDefinitionGroup', id: string, name: string }>, organizations: Array<{ __typename?: 'Organization', id: string, name: string }>, usage: Array<{ __typename?: 'PromoCodeUsage', id: string, marketplaceUserId: string, discountAmount: number, usedAt: any }> }> };

export type ReachJwtQueryVariables = Exact<{
  marketplaceId: Scalars['ID'];
}>;


export type ReachJwtQuery = { __typename?: 'Query', reachJwt: string };

export type ReportsQueryVariables = Exact<{
  page: ReportPageInput;
}>;


export type ReportsQuery = { __typename?: 'Query', reports: { __typename?: 'ReportPage', totalCount: number, data: Array<{ __typename?: 'Report', id: string, type: ReportType, filename?: string | null, status: ReportStatus, organizationId: string, userId: string, userName?: string | null, createdAt: any, updatedAt: any, downloadUrl: string }> } };

export type RolesQueryVariables = Exact<{ [key: string]: never; }>;


export type RolesQuery = { __typename?: 'Query', roles: Array<{ __typename?: 'Role', id: string, name: string, scope: RoleScope, type: RoleType, permissions: Array<string>, resourceId?: string | null }> };

export type UserQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type UserQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: string, email: string, emailConfirmed: boolean, isMcpEnabled: boolean, createdAt: any, mfa?: { __typename?: 'MfaStatus', mode: MfaMode, enabled: boolean, required: boolean, graceUntil?: any | null, recoveryCodesLeft: number, factors: Array<{ __typename?: 'MfaFactor', id: string, type: MfaFactorType, label?: string | null, createdAt: any, verifiedAt?: any | null, lastUsedAt?: any | null, backedUp?: boolean | null }> } | null, profiles: Array<{ __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null, procedureProfiles: Array<{ __typename?: 'ProcedureProfile', createdAt: any, id: string, name: string, updatedAt: any, procedureDefs: Array<{ __typename?: 'ProcedureDefinition', id: string, name: string, description: string, price: number, duration: number, assessmentFormTemplateId?: string | null, interventionFormTemplateId?: string | null, ordersRequired: boolean, createdAt: any, baseDefinitions: Array<{ __typename?: 'ProcedureBaseDefinition', id: string, name: string, description: string, duration: number, ingredients?: string | null, thumbnail?: string | null, marketplaceId: string, createdAt: any, points?: number | null }>, intakeFormTemplates: Array<{ __typename?: 'FormTemplate', id: string, name: string }> }> }>, availabilities: Array<{ __typename?: 'Availability', id: string, type: AvailabilityType, start: any, end: any, tzid: string, duration: number, createdAt: any, updatedAt: any, repeat?: { __typename?: 'RepeatRule', id: string, frequency: RepeatFrequencyType, byWeekday: Array<RepeatWeekdayType>, until?: any | null } | null }>, roles: Array<{ __typename?: 'Role', id: string, name: string, scope: RoleScope, type: RoleType, permissions: Array<string>, resourceId?: string | null }> }>, apiKeys: Array<{ __typename?: 'ApiKey', id: string, kid: string, name: string, createdAt: any, roles: Array<{ __typename?: 'Role', id: string, name: string, scope: RoleScope, type: RoleType, permissions: Array<string>, resourceId?: string | null }> }> } | null };

export type UsersQueryVariables = Exact<{ [key: string]: never; }>;


export type UsersQuery = { __typename?: 'Query', users: Array<{ __typename?: 'User', id: string, email: string, emailConfirmed: boolean, isMcpEnabled: boolean, createdAt: any }> };

export type ValidatePromoCodeQueryVariables = Exact<{
  input: ValidatePromoCodeInput;
}>;


export type ValidatePromoCodeQuery = { __typename?: 'Query', validatePromoCode: { __typename?: 'PromoCodeValidationResult', valid: boolean, error?: string | null, discountAmount?: number | null, itemDiscounts?: Array<{ __typename?: 'PromoCodeItemDiscount', procedureBaseDefId: string, discountAmount: number }> | null } };

export type ViewerQueryVariables = Exact<{ [key: string]: never; }>;


export type ViewerQuery = { __typename?: 'Query', viewer?: { __typename?: 'User', id: string, email: string, emailConfirmed: boolean, isMcpEnabled: boolean, createdAt: any, profiles: Array<{ __typename?: 'Profile', id: string, pid: string, email: string, givenName: string, familyName: string, title: string, phone: string, address: string, tzid: string, userId?: string | null, color: string, availableUntil?: any | null, allowSmsNotifications: boolean, createdAt: any, roles: Array<{ __typename?: 'Role', id: string, name: string, scope: RoleScope, type: RoleType, permissions: Array<string>, resourceId?: string | null }>, organization?: { __typename?: 'Organization', id: string, name: string, tzid: string, emrInstanceId?: string | null, createdAt: any, phone?: string | null, email?: string | null, address?: string | null, state?: StateCode | null, providesAtClinic: boolean, enablePractitionerSms: boolean, enableReceiptSending: boolean, active: boolean, intakeAutoSendMode?: IntakeAutoSendMode | null, intakeDeliveryChannel?: IntakeDeliveryChannel | null, intakeSmsTemplate?: string | null } | null }> } | null };

export type ViewerMfaQueryVariables = Exact<{ [key: string]: never; }>;


export type ViewerMfaQuery = { __typename?: 'Query', viewer?: { __typename?: 'User', id: string, email: string, mfa?: { __typename?: 'MfaStatus', mode: MfaMode, enabled: boolean, required: boolean, graceUntil?: any | null, recoveryCodesLeft: number, factors: Array<{ __typename?: 'MfaFactor', id: string, type: MfaFactorType, label?: string | null, createdAt: any, verifiedAt?: any | null, lastUsedAt?: any | null, backedUp?: boolean | null }> } | null } | null };

export type ViewerTrustedDevicesQueryVariables = Exact<{ [key: string]: never; }>;


export type ViewerTrustedDevicesQuery = { __typename?: 'Query', viewer?: { __typename?: 'User', id: string, trustedDevices?: Array<{ __typename?: 'TrustedDevice', id: string, label: string, current: boolean, createdAt: any, lastUsedAt?: any | null, expiresAt: any }> | null } | null };

export const RoleFieldsFragmentDoc = gql`
    fragment RoleFields on Role {
  id
  name
  scope
  type
  permissions
  resourceId
}
    `;
export const ApiKeyFieldsFragmentDoc = gql`
    fragment ApiKeyFields on ApiKey {
  id
  kid
  name
  createdAt
  roles {
    ...RoleFields
  }
}
    ${RoleFieldsFragmentDoc}`;
export const OrganizationFieldsFragmentDoc = gql`
    fragment OrganizationFields on Organization {
  id
  name
  tzid
  emrInstanceId
  createdAt
  phone
  email
  address
  state
  providesAtClinic
  enablePractitionerSms
  enableReceiptSending
  active
  intakeAutoSendMode
  intakeDeliveryChannel
  intakeSmsTemplate
}
    `;
export const ProfileFieldsFragmentDoc = gql`
    fragment ProfileFields on Profile {
  id
  pid
  email
  givenName
  familyName
  title
  phone
  address
  tzid
  userId
  color
  availableUntil
  allowSmsNotifications
  createdAt
  organization {
    ...OrganizationFields
  }
}
    ${OrganizationFieldsFragmentDoc}`;
export const AppointmentCandidateFieldsFragmentDoc = gql`
    fragment AppointmentCandidateFields on AppointmentCandidate {
  id
  rank
  start
  duration
  reservableTimes
  availableTimes
  profile {
    ...ProfileFields
    latitude
    longitude
  }
}
    ${ProfileFieldsFragmentDoc}`;
export const AppointmentIntakeFieldsFragmentDoc = gql`
    fragment AppointmentIntakeFields on Appointment {
  intakeStatus
  intakeSubmissions {
    id
    formName
    status
    reviewStatus
    formUrl
    formTemplateId
    triggerType
    submittedAt
    smsSentAt
  }
}
    `;
export const AttentiveFieldsFragmentDoc = gql`
    fragment AttentiveFields on AttentiveIntegration {
  id
  apiKeyDescription
  appointmentCompletedEnabled
  appointmentCompletedEvent
  qualiphyTextsEnabled
  qualiphyTextsEvent
  marketingSignUpUnitId
  transactionalSignUpUnitId
}
    `;
export const AvailabilityCoverageRangeFieldsFragmentDoc = gql`
    fragment AvailabilityCoverageRangeFields on AvailabilityCoverageRange {
  tzid
  id
  start
  end
  label
  type
  procedureProfileIds
}
    `;
export const CheckoutNoteItemFieldsFragmentDoc = gql`
    fragment CheckoutNoteItemFields on CheckoutNoteItem {
  id
  index
  label
  type
  options
  createdAt
  updatedAt
}
    `;
export const PaymentLinkFieldsFragmentDoc = gql`
    fragment PaymentLinkFields on PaymentLink {
  id
  checkoutId
  url
  status
  amount
  expiresAt
  createdAt
  updatedAt
}
    `;
export const CheckoutFieldsFragmentDoc = gql`
    fragment CheckoutFields on Checkout {
  id
  total
  paid
  balance
  marketplaceUserId
  summary
  voidedAt
  paymentMethodType
  paymentLinks {
    ...PaymentLinkFields
  }
  createdAt
  updatedAt
}
    ${PaymentLinkFieldsFragmentDoc}`;
export const CheckoutItemFieldsFragmentDoc = gql`
    fragment CheckoutItemFields on CheckoutItem {
  id
  type
  description
  quantity
  price
  key
}
    `;
export const PaymentFieldsFragmentDoc = gql`
    fragment PaymentFields on Payment {
  id
  type
  status
  description
  amount
  amountRequested
  amountReversed
  isDeposit
  createdAt
  updatedAt
}
    `;
export const PayoutFieldsFragmentDoc = gql`
    fragment PayoutFields on Payout {
  id
  status
  description
  amount
  amountRequested
  amountReversed
  createdAt
  updatedAt
  checkoutId
}
    `;
export const PaymentInstrumentFieldsFragmentDoc = gql`
    fragment PaymentInstrumentFields on PaymentInstrument {
  id
  type
  processor
  brand
  lastFour
  expirationMonth
  expirationYear
  createdAt
  updatedAt
}
    `;
export const ClientProfileFieldsFragmentDoc = gql`
    fragment ClientProfileFields on ClientProfile {
  id
  dob
  email
  givenName
  familyName
  internalNotes
  phone
  address
  tzid
  sexAssignedAtBirth
  createdAt
  updatedAt
  membership
  marketplaceUserId
}
    `;
export const MarketplaceUserFieldsFragmentDoc = gql`
    fragment MarketplaceUserFields on MarketplaceUser {
  id
  createdAt
  updatedAt
  groupId
  membership
  primaryInstrumentId
  email
  phone
  emailConfirmed
  phoneConfirmed
  emailOptIn
  phoneOptIn
  clientProfile {
    ...ClientProfileFields
  }
}
    ${ClientProfileFieldsFragmentDoc}`;
export const FullCheckoutFieldsFragmentDoc = gql`
    fragment FullCheckoutFields on Checkout {
  ...CheckoutFields
  items {
    ...CheckoutItemFields
  }
  payments {
    ...PaymentFields
  }
  payouts {
    ...PayoutFields
  }
  paymentInstrument {
    ...PaymentInstrumentFields
  }
  marketplaceUser {
    ...MarketplaceUserFields
  }
}
    ${CheckoutFieldsFragmentDoc}
${CheckoutItemFieldsFragmentDoc}
${PaymentFieldsFragmentDoc}
${PayoutFieldsFragmentDoc}
${PaymentInstrumentFieldsFragmentDoc}
${MarketplaceUserFieldsFragmentDoc}`;
export const AppointmentFieldsFragmentDoc = gql`
    fragment AppointmentFields on Appointment {
  id
  location
  latitude
  longitude
  start
  end
  duration
  createdAt
  updatedAt
  archivedAt
  status
  startedAt
  completedAt
  notes
  createdBy
  cancelReason
  groupId
  ordersRequired
}
    `;
export const AppointmentParticipantFieldsFragmentDoc = gql`
    fragment AppointmentParticipantFields on AppointmentParticipant {
  id
  name
  type
  status
  profileId
  clientProfileId
  orderApproved
}
    `;
export const PatientFieldsFragmentDoc = gql`
    fragment PatientFields on Patient {
  id
  allergies
  archivedAt
  clientProfileId
  conditions
  createdAt
  emrInstanceId
  immunizations
  labs
  medications
  procedures
  updatedAt
}
    `;
export const ProcedureDefFieldsFragmentDoc = gql`
    fragment ProcedureDefFields on ProcedureDefinition {
  id
  name
  description
  price
  duration
  assessmentFormTemplateId
  interventionFormTemplateId
  intakeFormTemplates {
    id
    name
  }
  ordersRequired
  createdAt
}
    `;
export const OrderFieldsFragmentDoc = gql`
    fragment OrderFields on Order {
  id
  archivedAt
  createdAt
  expiresAt
  providerType
  fillCount
  note
  refills
  startsAt
  updatedAt
  procedureDefs {
    ...ProcedureDefFields
  }
  profile {
    ...ProfileFields
  }
  organizations {
    ...OrganizationFields
  }
}
    ${ProcedureDefFieldsFragmentDoc}
${ProfileFieldsFragmentDoc}
${OrganizationFieldsFragmentDoc}`;
export const VitalSignFieldsFragmentDoc = gql`
    fragment VitalSignFields on VitalSign {
  id
  createdAt
  createdById
  recordedAt
  type
  updatedAt
  value
}
    `;
export const DocumentSignatureFieldsFragmentDoc = gql`
    fragment DocumentSignatureFields on DocumentSignature {
  id
  signerName
  signerEmail
  signerType
  signedAt
  verificationType
  verificationDetail
  tzid
  latitude
  longitude
  documentId
  version
  documentLabel
  url
  createdAt
  updatedAt
}
    `;
export const AllergyIntoleranceFieldsFragmentDoc = gql`
    fragment AllergyIntoleranceFields on AllergyIntolerance {
  id
  name
}
    `;
export const ClinicalProcedureFieldsFragmentDoc = gql`
    fragment ClinicalProcedureFields on ClinicalProcedure {
  id
  name
}
    `;
export const ConditionFieldsFragmentDoc = gql`
    fragment ConditionFields on Condition {
  id
  name
}
    `;
export const ImmunizationFieldsFragmentDoc = gql`
    fragment ImmunizationFields on Immunization {
  id
  name
}
    `;
export const LabFieldsFragmentDoc = gql`
    fragment LabFields on Lab {
  id
  name
}
    `;
export const MedicationStatementFieldsFragmentDoc = gql`
    fragment MedicationStatementFields on MedicationStatement {
  id
  name
}
    `;
export const DocumentFieldsFragmentDoc = gql`
    fragment DocumentFields on Document {
  id
  filename
  label
  type
  version
  fileSize
  url
  createdAt
  updatedAt
}
    `;
export const FullPatientFieldsFragmentDoc = gql`
    fragment FullPatientFields on Patient {
  ...PatientFields
  orders {
    ...OrderFields
  }
  vitals {
    ...VitalSignFields
  }
  signedConsentForms {
    ...DocumentSignatureFields
  }
  allergyRecords {
    ...AllergyIntoleranceFields
  }
  clinicalProcedureRecords {
    ...ClinicalProcedureFields
  }
  conditionRecords {
    ...ConditionFields
  }
  immunizationRecords {
    ...ImmunizationFields
  }
  labRecords {
    ...LabFields
  }
  medicationRecords {
    ...MedicationStatementFields
  }
  attachments {
    ...DocumentFields
  }
}
    ${PatientFieldsFragmentDoc}
${OrderFieldsFragmentDoc}
${VitalSignFieldsFragmentDoc}
${DocumentSignatureFieldsFragmentDoc}
${AllergyIntoleranceFieldsFragmentDoc}
${ClinicalProcedureFieldsFragmentDoc}
${ConditionFieldsFragmentDoc}
${ImmunizationFieldsFragmentDoc}
${LabFieldsFragmentDoc}
${MedicationStatementFieldsFragmentDoc}
${DocumentFieldsFragmentDoc}`;
export const FormFieldsFragmentDoc = gql`
    fragment FormFields on Form {
  id
  type
  status
  patientId
  lockedById
  editable
  createdAt
  updatedAt
}
    `;
export const FormItemFieldsFragmentDoc = gql`
    fragment FormItemFields on FormItem {
  id
  index
  label
  type
  code
  options
  createdAt
  updatedAt
}
    `;
export const FormNoteFieldsFragmentDoc = gql`
    fragment FormNoteFields on FormNote {
  id
  note
  edited
  profileId
  createdAt
  updatedAt
  author
}
    `;
export const RegularFormFieldsFragmentDoc = gql`
    fragment RegularFormFields on Form {
  ...FormFields
  items {
    ...FormItemFields
  }
  observations {
    id
    code
    value
    note
    createdById
    createdAt
    updatedAt
    createdBy {
      id
      givenName
      familyName
      title
    }
  }
  lockedBy {
    ...ProfileFields
  }
  document {
    ...DocumentFields
  }
  attachments {
    ...DocumentFields
  }
  notes {
    ...FormNoteFields
  }
}
    ${FormFieldsFragmentDoc}
${FormItemFieldsFragmentDoc}
${ProfileFieldsFragmentDoc}
${DocumentFieldsFragmentDoc}
${FormNoteFieldsFragmentDoc}`;
export const FullAppointmentParticipantFieldsFragmentDoc = gql`
    fragment FullAppointmentParticipantFields on AppointmentParticipant {
  ...AppointmentParticipantFields
  participant {
    ... on ClientProfile {
      ...ClientProfileFields
      internalNotesUpdatedBy
      internalNotesUpdatedAt
      patient {
        ...FullPatientFields
      }
    }
    ... on Profile {
      ...ProfileFields
    }
  }
  responses {
    id
    start
    end
    createdAt
    updatedAt
  }
  forms {
    ...RegularFormFields
  }
}
    ${AppointmentParticipantFieldsFragmentDoc}
${ClientProfileFieldsFragmentDoc}
${FullPatientFieldsFragmentDoc}
${ProfileFieldsFragmentDoc}
${RegularFormFieldsFragmentDoc}`;
export const ProcedureBaseDefFieldsFragmentDoc = gql`
    fragment ProcedureBaseDefFields on ProcedureBaseDefinition {
  id
  name
  description
  duration
  ingredients
  thumbnail
  marketplaceId
  createdAt
  points
}
    `;
export const AppointmentRequestFieldsFragmentDoc = gql`
    fragment AppointmentRequestFields on AppointmentRequest {
  id
  location
  latitude
  longitude
  status
  bookingMode
  cancelReason
  notes
  lastResetAt
  waitlistedAt
  createdAt
  updatedAt
  archivedAt
}
    `;
export const MarketplaceFieldsFragmentDoc = gql`
    fragment MarketplaceFields on Marketplace {
  id
  name
  groupId
  createdAt
  logo
  favicon
  primaryColor
  marketingSiteUrl
  gtmContainer
  gtmRequiresConsent
  gtmDataTier
  gtmV2Enabled
  featureFlags {
    waitListEnabled
    acceptedPaymentMethods {
      creditCard
      applePay
    }
  }
}
    `;
export const AppointmentTimeRangeFieldsFragmentDoc = gql`
    fragment AppointmentTimeRangeFields on AppointmentTimeRange {
  id
  start
  end
}
    `;
export const AppointmentConstraintFieldsFragmentDoc = gql`
    fragment AppointmentConstraintFields on AppointmentConstraint {
  id
  organizations {
    ...OrganizationFields
  }
  profiles {
    ...ProfileFields
  }
  timeRanges {
    ...AppointmentTimeRangeFields
  }
}
    ${OrganizationFieldsFragmentDoc}
${ProfileFieldsFragmentDoc}
${AppointmentTimeRangeFieldsFragmentDoc}`;
export const RegularAppointmentRequestFieldsFragmentDoc = gql`
    fragment RegularAppointmentRequestFields on AppointmentRequest {
  ...AppointmentRequestFields
  marketplace {
    ...MarketplaceFields
  }
  clientProfiles {
    ...ClientProfileFields
  }
  procedureBaseDefs {
    ...ProcedureBaseDefFields
  }
  constraints {
    ...AppointmentConstraintFields
  }
  additionalPatients {
    id
    clientProfile {
      ...ClientProfileFields
    }
    procedureBaseDefs {
      ...ProcedureBaseDefFields
    }
  }
}
    ${AppointmentRequestFieldsFragmentDoc}
${MarketplaceFieldsFragmentDoc}
${ClientProfileFieldsFragmentDoc}
${ProcedureBaseDefFieldsFragmentDoc}
${AppointmentConstraintFieldsFragmentDoc}`;
export const CheckoutWithAppointmentFieldsFragmentDoc = gql`
    fragment CheckoutWithAppointmentFields on Checkout {
  ...FullCheckoutFields
  appointment {
    ...AppointmentFields
    participants {
      ...FullAppointmentParticipantFields
    }
    procedureBaseDefs {
      ...ProcedureBaseDefFields
    }
  }
  appointmentRequest {
    ...RegularAppointmentRequestFields
  }
}
    ${FullCheckoutFieldsFragmentDoc}
${AppointmentFieldsFragmentDoc}
${FullAppointmentParticipantFieldsFragmentDoc}
${ProcedureBaseDefFieldsFragmentDoc}
${RegularAppointmentRequestFieldsFragmentDoc}`;
export const FormTemplateItemFieldsFragmentDoc = gql`
    fragment FormTemplateItemFields on FormTemplateItem {
  id
  index
  label
  type
  options
  createdAt
  updatedAt
}
    `;
export const FormTemplateFieldsFragmentDoc = gql`
    fragment FormTemplateFields on FormTemplate {
  id
  name
  type
  parentId
  createdAt
  updatedAt
  items {
    ...FormTemplateItemFields
  }
}
    ${FormTemplateItemFieldsFragmentDoc}`;
export const QualiphyInvitationFieldsFragmentDoc = gql`
    fragment QualiphyInvitationFields on QualiphyInvitation {
  id
  expiration
  meetingUrl
  exams {
    id
    title
    status
  }
}
    `;
export const FullAppointmentFieldsFragmentDoc = gql`
    fragment FullAppointmentFields on Appointment {
  ...AppointmentFields
  participants {
    ...FullAppointmentParticipantFields
  }
  procedureBaseDefs {
    ...ProcedureBaseDefFields
  }
  checkout {
    ...FullCheckoutFields
  }
  qualiphyInvitation {
    ...QualiphyInvitationFields
  }
  additionalPatients {
    id
    clientProfile {
      ...ClientProfileFields
    }
    procedureBaseDefs {
      ...ProcedureBaseDefFields
    }
  }
}
    ${AppointmentFieldsFragmentDoc}
${FullAppointmentParticipantFieldsFragmentDoc}
${ProcedureBaseDefFieldsFragmentDoc}
${FullCheckoutFieldsFragmentDoc}
${QualiphyInvitationFieldsFragmentDoc}
${ClientProfileFieldsFragmentDoc}`;
export const PackageItemFieldsFragmentDoc = gql`
    fragment PackageItemFields on PackageItem {
  id
  packageItemDefinitionId
  membershipId
  balance
  packageName
  totalPoints
  groupNames
  expiresAt
  primaryOrganizationId
}
    `;
export const MembershipFieldsFragmentDoc = gql`
    fragment MembershipFields on Membership {
  id
  membershipDefinitionId
  renewalDate
  name
  status
}
    `;
export const MarketplaceGroupFieldsFragmentDoc = gql`
    fragment MarketplaceGroupFields on MarketplaceGroup {
  id
  label
  createdAt
  messagingServiceSid
}
    `;
export const RegularAppointmentFieldsFragmentDoc = gql`
    fragment RegularAppointmentFields on Appointment {
  ...AppointmentFields
  intakeStatus
  participants {
    ...AppointmentParticipantFields
  }
  procedureBaseDefs {
    ...ProcedureBaseDefFields
  }
  checkout {
    ...CheckoutFields
  }
  additionalPatients {
    id
    clientProfile {
      ...ClientProfileFields
    }
    procedureBaseDefs {
      ...ProcedureBaseDefFields
    }
  }
}
    ${AppointmentFieldsFragmentDoc}
${AppointmentParticipantFieldsFragmentDoc}
${ProcedureBaseDefFieldsFragmentDoc}
${CheckoutFieldsFragmentDoc}
${ClientProfileFieldsFragmentDoc}`;
export const FullMarketplaceUserFieldsFragmentDoc = gql`
    fragment FullMarketplaceUserFields on MarketplaceUser {
  ...MarketplaceUserFields
  clientProfiles {
    ...ClientProfileFields
    organizations {
      ...OrganizationFields
    }
  }
  packageItems {
    ...PackageItemFields
    marketplaceName
  }
  memberships {
    ...MembershipFields
    marketplaceName
  }
  marketplaceGroup {
    ...MarketplaceGroupFields
  }
  paymentInstruments {
    ...PaymentInstrumentFields
  }
  checkouts {
    ...CheckoutFields
    items {
      ...CheckoutItemFields
    }
  }
  appointments {
    ...RegularAppointmentFields
  }
  appointmentRequests {
    ...RegularAppointmentRequestFields
  }
}
    ${MarketplaceUserFieldsFragmentDoc}
${ClientProfileFieldsFragmentDoc}
${OrganizationFieldsFragmentDoc}
${PackageItemFieldsFragmentDoc}
${MembershipFieldsFragmentDoc}
${MarketplaceGroupFieldsFragmentDoc}
${PaymentInstrumentFieldsFragmentDoc}
${CheckoutFieldsFragmentDoc}
${CheckoutItemFieldsFragmentDoc}
${RegularAppointmentFieldsFragmentDoc}
${RegularAppointmentRequestFieldsFragmentDoc}`;
export const FullAppointmentRequestFieldsFragmentDoc = gql`
    fragment FullAppointmentRequestFields on AppointmentRequest {
  ...RegularAppointmentRequestFields
  declinedProfiles {
    ...ProfileFields
  }
  clientProfiles {
    ...ClientProfileFields
    marketplaceUsers {
      ...FullMarketplaceUserFields
      marketplaceIds
      memberships {
        ...MembershipFields
      }
      packageItems {
        ...PackageItemFields
      }
    }
  }
  checkout {
    ...FullCheckoutFields
  }
}
    ${RegularAppointmentRequestFieldsFragmentDoc}
${ProfileFieldsFragmentDoc}
${ClientProfileFieldsFragmentDoc}
${FullMarketplaceUserFieldsFragmentDoc}
${MembershipFieldsFragmentDoc}
${PackageItemFieldsFragmentDoc}
${FullCheckoutFieldsFragmentDoc}`;
export const AppointmentSummaryFieldsFragmentDoc = gql`
    fragment AppointmentSummaryFields on Appointment {
  id
  status
  cancelReason
  start
  end
  duration
  location
  groupId
  archivedAt
  procedureBaseDefs {
    id
    name
  }
  participants {
    ...AppointmentParticipantFields
  }
}
    ${AppointmentParticipantFieldsFragmentDoc}`;
export const FullClientProfileFieldsFragmentDoc = gql`
    fragment FullClientProfileFields on ClientProfile {
  ...ClientProfileFields
  internalNotesUpdatedBy
  internalNotesUpdatedAt
  patient {
    ...FullPatientFields
  }
  appointments(limit: 3) {
    ...AppointmentSummaryFields
  }
  intakeSubmissions {
    id
    status
    reviewStatus
    formName
    submittedAt
    appointmentId
    pdfUrl
    reviewedByName
    documentId
    appointment {
      id
      start
      status
    }
  }
}
    ${ClientProfileFieldsFragmentDoc}
${FullPatientFieldsFragmentDoc}
${AppointmentSummaryFieldsFragmentDoc}`;
export const MembershipDefinitionFieldsFragmentDoc = gql`
    fragment MembershipDefinitionFields on MembershipDefinition {
  id
  name
  price
  period
  packageId
  marketplaceId
  advertise
  description
  list
}
    `;
export const DiscountFieldsFragmentDoc = gql`
    fragment DiscountFields on Discount {
  id
  percentage
  membershipDefinitionId
  procedureGroups {
    id
    name
  }
}
    `;
export const FullMembershipDefinitionFieldsFragmentDoc = gql`
    fragment FullMembershipDefinitionFields on MembershipDefinition {
  ...MembershipDefinitionFields
  discounts {
    ...DiscountFields
  }
}
    ${MembershipDefinitionFieldsFragmentDoc}
${DiscountFieldsFragmentDoc}`;
export const ProfileRolesFragmentDoc = gql`
    fragment ProfileRoles on Profile {
  ...ProfileFields
  roles {
    ...RoleFields
  }
}
    ${ProfileFieldsFragmentDoc}
${RoleFieldsFragmentDoc}`;
export const ProcedureProfileFieldsFragmentDoc = gql`
    fragment ProcedureProfileFields on ProcedureProfile {
  createdAt
  id
  name
  updatedAt
}
    `;
export const RepeatRuleFieldsFragmentDoc = gql`
    fragment RepeatRuleFields on RepeatRule {
  id
  frequency
  byWeekday
  until
}
    `;
export const AvailabilityFieldsFragmentDoc = gql`
    fragment AvailabilityFields on Availability {
  id
  type
  start
  end
  tzid
  duration
  repeat {
    ...RepeatRuleFields
  }
  createdAt
  updatedAt
}
    ${RepeatRuleFieldsFragmentDoc}`;
export const FullProcedureDefFieldsFragmentDoc = gql`
    fragment FullProcedureDefFields on ProcedureDefinition {
  ...ProcedureDefFields
  baseDefinitions {
    ...ProcedureBaseDefFields
  }
  consentForms {
    ...DocumentFields
  }
}
    ${ProcedureDefFieldsFragmentDoc}
${ProcedureBaseDefFieldsFragmentDoc}
${DocumentFieldsFragmentDoc}`;
export const EmrInstanceFieldsFragmentDoc = gql`
    fragment EmrInstanceFields on EmrInstance {
  id
  label
  createdAt
}
    `;
export const MedicationFieldsFragmentDoc = gql`
    fragment MedicationFields on Medication {
  id
  name
  unit
  createdAt
}
    `;
export const AvailabilityCoverageFieldsFragmentDoc = gql`
    fragment AvailabilityCoverageFields on AvailabilityCoverage {
  id
  label
  threshold
  start
  end
  tzid
  repeat {
    ...RepeatRuleFields
  }
  profiles {
    id
  }
}
    ${RepeatRuleFieldsFragmentDoc}`;
export const PaymentAccountFieldsFragmentDoc = gql`
    fragment PaymentAccountFields on PaymentAccount {
  id
  label
  platform
  enabled
  state
  onboardingUrl
  createdAt
  updatedAt
}
    `;
export const FullOrganizationFragmentDoc = gql`
    fragment FullOrganization on Organization {
  ...OrganizationFields
  profiles {
    ...ProfileRoles
    latitude
    longitude
    procedureProfiles {
      ...ProcedureProfileFields
    }
    availabilities {
      ...AvailabilityFields
    }
  }
  roles {
    ...RoleFields
  }
  procedureDefs {
    ...FullProcedureDefFields
  }
  procedureProfiles {
    ...ProcedureProfileFields
    procedureDefs {
      id
    }
  }
  marketplaces {
    ...MarketplaceFields
    procedureBaseDefs {
      ...ProcedureBaseDefFields
    }
  }
  emrInstance {
    ...EmrInstanceFields
  }
  medications {
    ...MedicationFields
  }
  availabilityCoverages {
    ...AvailabilityCoverageFields
  }
  paymentAccounts {
    ...PaymentAccountFields
  }
  qualiphyEnabled
}
    ${OrganizationFieldsFragmentDoc}
${ProfileRolesFragmentDoc}
${ProcedureProfileFieldsFragmentDoc}
${AvailabilityFieldsFragmentDoc}
${RoleFieldsFragmentDoc}
${FullProcedureDefFieldsFragmentDoc}
${MarketplaceFieldsFragmentDoc}
${ProcedureBaseDefFieldsFragmentDoc}
${EmrInstanceFieldsFragmentDoc}
${MedicationFieldsFragmentDoc}
${AvailabilityCoverageFieldsFragmentDoc}
${PaymentAccountFieldsFragmentDoc}`;
export const PackageFieldsFragmentDoc = gql`
    fragment PackageFields on Package {
  id
  name
  price
  marketplaceId
  advertise
  description
  list
}
    `;
export const PackageItemDefinitionFieldsFragmentDoc = gql`
    fragment PackageItemDefinitionFields on PackageItemDefinition {
  id
  packageId
  points
  procedureGroups
}
    `;
export const FullPackageFieldsFragmentDoc = gql`
    fragment FullPackageFields on Package {
  ...PackageFields
  packageItemDefinitions {
    ...PackageItemDefinitionFields
  }
}
    ${PackageFieldsFragmentDoc}
${PackageItemDefinitionFieldsFragmentDoc}`;
export const ProcedureBaseDefLayoutFieldsFragmentDoc = gql`
    fragment ProcedureBaseDefLayoutFields on ProcedureBaseDefinitionLayout {
  type
  layout
  itemIndex
}
    `;
export const FullProcedureBaseDefFieldsFragmentDoc = gql`
    fragment FullProcedureBaseDefFields on ProcedureBaseDefinition {
  ...ProcedureBaseDefFields
  tags
  addOns
  layouts {
    ...ProcedureBaseDefLayoutFields
  }
}
    ${ProcedureBaseDefFieldsFragmentDoc}
${ProcedureBaseDefLayoutFieldsFragmentDoc}`;
export const FullProfileFragmentDoc = gql`
    fragment FullProfile on Profile {
  ...ProfileRoles
  procedureProfiles {
    ...ProcedureProfileFields
    procedureDefs {
      ...ProcedureDefFields
      baseDefinitions {
        ...ProcedureBaseDefFields
      }
    }
  }
  availabilities {
    ...AvailabilityFields
  }
}
    ${ProfileRolesFragmentDoc}
${ProcedureProfileFieldsFragmentDoc}
${ProcedureDefFieldsFragmentDoc}
${ProcedureBaseDefFieldsFragmentDoc}
${AvailabilityFieldsFragmentDoc}`;
export const GeoperimeterFieldsFragmentDoc = gql`
    fragment GeoperimeterFields on Geoperimeter {
  id
  type
  organizationId
  lat
  lng
  radius
  paths
  travelFee
}
    `;
export const MarketplaceSettingsFieldsFragmentDoc = gql`
    fragment MarketplaceSettingsFields on Marketplace {
  ...MarketplaceFields
  requireDispatchApproval
  requirePractitionerApproval
  dispatchStrategy
  bookingMode
  slackWebhookUrl
  reviewsIoKeyDescription
  consentTokenSecretDescription
  reviewsIoStoreId
  paymentAccountId
  feeProfileFixed
  feeProfileBasisPoints
  logo
  favicon
  primaryColor
  marketingSiteUrl
  paymentCollectionMethod
  paymentDepositType
  paymentDepositValue
  hasPaymentPolicy
  paymentPolicyName
  paymentPolicyText
  requirePaymentPolicyAttestation
  checkoutContent {
    footerLinks {
      label
      url
    }
    servicesNotice
    scheduleNotice
    confirmationMessage
  }
  featureFlags {
    waitListEnabled
    acceptedPaymentMethods {
      creditCard
      applePay
    }
    windowBooking {
      allowSpecificTimeRequest
      minRemainingMinutes
      windows {
        key
        enabled
        startTime
        endTime
      }
    }
  }
}
    ${MarketplaceFieldsFragmentDoc}`;
export const MedicationProtocolFieldsFragmentDoc = gql`
    fragment MedicationProtocolFields on MedicationProtocol {
  id
  dose
  createdAt
}
    `;
export const DatasetFieldsFragmentDoc = gql`
    fragment DatasetFields on Dataset {
  label
  data
  backgroundColor
  borderColor
}
    `;
export const ChartDataFieldsFragmentDoc = gql`
    fragment ChartDataFields on ChartData {
  labels
  datasets {
    ...DatasetFields
  }
}
    ${DatasetFieldsFragmentDoc}`;
export const MetricDataFieldsFragmentDoc = gql`
    fragment MetricDataFields on MetricData {
  id
  type
  data {
    ...ChartDataFields
  }
  count
}
    ${ChartDataFieldsFragmentDoc}`;
export const ProcedureBaseDefGroupFieldsFragmentDoc = gql`
    fragment ProcedureBaseDefGroupFields on ProcedureBaseDefinitionGroup {
  id
  name
  thumbnail
  banner
  type
  description
  bgcolor
  fontColor
  procedureBaseDefs {
    id
    name
  }
  featuredBaseDefs {
    id
    name
  }
  procedureBaseDefGroups {
    id
    name
    type
  }
}
    `;
export const MetricsMarketplaceFieldsFragmentDoc = gql`
    fragment MetricsMarketplaceFields on Marketplace {
  ...MarketplaceFields
  procedureBaseDefs {
    ...ProcedureBaseDefFields
  }
  procedureBaseDefGroups {
    ...ProcedureBaseDefGroupFields
  }
  organizations {
    ...OrganizationFields
  }
}
    ${MarketplaceFieldsFragmentDoc}
${ProcedureBaseDefFieldsFragmentDoc}
${ProcedureBaseDefGroupFieldsFragmentDoc}
${OrganizationFieldsFragmentDoc}`;
export const MfaScopeModeFieldsFragmentDoc = gql`
    fragment MfaScopeModeFields on MfaScopeMode {
  setting
  inherited
  effective
  enabled
}
    `;
export const MfaStatusFieldsFragmentDoc = gql`
    fragment MfaStatusFields on MfaStatus {
  mode
  enabled
  required
  graceUntil
  recoveryCodesLeft
  factors {
    id
    type
    label
    createdAt
    verifiedAt
    lastUsedAt
    backedUp
  }
}
    `;
export const OrganizationSettingsFieldsFragmentDoc = gql`
    fragment OrganizationSettingsFields on Organization {
  ...OrganizationFields
  slackWebhookUrl
  googleReviewsUrl
  paymentAccountId
}
    ${OrganizationFieldsFragmentDoc}`;
export const PaginatedAppointmentRequestFieldsFragmentDoc = gql`
    fragment PaginatedAppointmentRequestFields on AppointmentRequest {
  ...RegularAppointmentRequestFields
  checkout {
    ...CheckoutFields
  }
  orderApproved
  intakeStatus
}
    ${RegularAppointmentRequestFieldsFragmentDoc}
${CheckoutFieldsFragmentDoc}`;
export const PaginatedCheckoutFieldsFragmentDoc = gql`
    fragment PaginatedCheckoutFields on Checkout {
  ...CheckoutFields
  marketplace {
    ...MarketplaceFields
  }
  marketplaceUser {
    ...MarketplaceUserFields
  }
}
    ${CheckoutFieldsFragmentDoc}
${MarketplaceFieldsFragmentDoc}
${MarketplaceUserFieldsFragmentDoc}`;
export const PaginatedMarketplaceUserFieldsFragmentDoc = gql`
    fragment PaginatedMarketplaceUserFields on MarketplaceUser {
  ...MarketplaceUserFields
  memberships {
    ...MembershipFields
  }
  marketplaceGroup {
    ...MarketplaceGroupFields
  }
}
    ${MarketplaceUserFieldsFragmentDoc}
${MembershipFieldsFragmentDoc}
${MarketplaceGroupFieldsFragmentDoc}`;
export const PaginatedPayoutFieldsFragmentDoc = gql`
    fragment PaginatedPayoutFields on Payout {
  ...PayoutFields
  checkout {
    ...CheckoutFields
    marketplace {
      ...MarketplaceFields
    }
  }
}
    ${PayoutFieldsFragmentDoc}
${CheckoutFieldsFragmentDoc}
${MarketplaceFieldsFragmentDoc}`;
export const PromoCodeFieldsFragmentDoc = gql`
    fragment PromoCodeFields on PromoCode {
  id
  name
  code
  discountType
  discountValue
  activationStartDate
  activationEndDate
  usageStartDate
  usageEndDate
  usageLimitTotal
  usageLimitPerUser
  minimumBookingAmount
  active
  marketplaceId
  createdAt
  updatedAt
  procedureGroups {
    id
    name
  }
  organizations {
    id
    name
  }
  usage {
    id
    marketplaceUserId
    discountAmount
    usedAt
  }
}
    `;
export const QualiphyExamFieldsFragmentDoc = gql`
    fragment QualiphyExamFields on QualiphyExam {
  id
  qualiphyId
  title
  index
  procedureDefinitions
  expiresAfter
  refills
  archived
}
    `;
export const QualiphyFieldsFragmentDoc = gql`
    fragment QualiphyFields on QualiphyIntegration {
  id
  enabled
  apiKeyDescription
  exams {
    ...QualiphyExamFields
  }
}
    ${QualiphyExamFieldsFragmentDoc}`;
export const SegmentFieldsFragmentDoc = gql`
    fragment SegmentFields on SegmentIntegration {
  id
  writeKeyDescription
  enabled
  v2Enabled
  v2WriteKeyDescription
  clientWriteKey
}
    `;
export const SendgridFieldsFragmentDoc = gql`
    fragment SendgridFields on SendgridIntegration {
  apiKeyDescription
  enabled
  domain
  webOrigin
}
    `;
export const TwilioFieldsFragmentDoc = gql`
    fragment TwilioFields on TwilioIntegration {
  id
  appointmentsEnabled
  appointmentRequestsEnabled
  waitlistTextsEnabled
  intakeTextsEnabled
}
    `;
export const UserFieldsFragmentDoc = gql`
    fragment UserFields on User {
  id
  email
  emailConfirmed
  isMcpEnabled
  createdAt
}
    `;
export const SaveProfileLocationDocument = gql`
    mutation SaveProfileLocation($input: SaveProfileLocationInput!) {
  saveProfileLocation(input: $input) {
    ...ProfileFields
    latitude
    longitude
  }
}
    ${ProfileFieldsFragmentDoc}`;
export type SaveProfileLocationMutationFn = Apollo.MutationFunction<SaveProfileLocationMutation, SaveProfileLocationMutationVariables>;

/**
 * __useSaveProfileLocationMutation__
 *
 * To run a mutation, you first call `useSaveProfileLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveProfileLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveProfileLocationMutation, { data, loading, error }] = useSaveProfileLocationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveProfileLocationMutation(baseOptions?: Apollo.MutationHookOptions<SaveProfileLocationMutation, SaveProfileLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveProfileLocationMutation, SaveProfileLocationMutationVariables>(SaveProfileLocationDocument, options);
      }
export type SaveProfileLocationMutationHookResult = ReturnType<typeof useSaveProfileLocationMutation>;
export type SaveProfileLocationMutationResult = Apollo.MutationResult<SaveProfileLocationMutation>;
export type SaveProfileLocationMutationOptions = Apollo.BaseMutationOptions<SaveProfileLocationMutation, SaveProfileLocationMutationVariables>;
export const AcceptAppointmentDocument = gql`
    mutation AcceptAppointment($input: AcceptAppointmentInput!) {
  acceptAppointment(input: $input) {
    ...FullAppointmentFields
  }
}
    ${FullAppointmentFieldsFragmentDoc}`;
export type AcceptAppointmentMutationFn = Apollo.MutationFunction<AcceptAppointmentMutation, AcceptAppointmentMutationVariables>;

/**
 * __useAcceptAppointmentMutation__
 *
 * To run a mutation, you first call `useAcceptAppointmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptAppointmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptAppointmentMutation, { data, loading, error }] = useAcceptAppointmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAcceptAppointmentMutation(baseOptions?: Apollo.MutationHookOptions<AcceptAppointmentMutation, AcceptAppointmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptAppointmentMutation, AcceptAppointmentMutationVariables>(AcceptAppointmentDocument, options);
      }
export type AcceptAppointmentMutationHookResult = ReturnType<typeof useAcceptAppointmentMutation>;
export type AcceptAppointmentMutationResult = Apollo.MutationResult<AcceptAppointmentMutation>;
export type AcceptAppointmentMutationOptions = Apollo.BaseMutationOptions<AcceptAppointmentMutation, AcceptAppointmentMutationVariables>;
export const AddOrganizationsToMarketplaceDocument = gql`
    mutation AddOrganizationsToMarketplace($input: AddOrganizationsToMarketplaceInput!) {
  addOrganizationsToMarketplace(input: $input)
}
    `;
export type AddOrganizationsToMarketplaceMutationFn = Apollo.MutationFunction<AddOrganizationsToMarketplaceMutation, AddOrganizationsToMarketplaceMutationVariables>;

/**
 * __useAddOrganizationsToMarketplaceMutation__
 *
 * To run a mutation, you first call `useAddOrganizationsToMarketplaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddOrganizationsToMarketplaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addOrganizationsToMarketplaceMutation, { data, loading, error }] = useAddOrganizationsToMarketplaceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddOrganizationsToMarketplaceMutation(baseOptions?: Apollo.MutationHookOptions<AddOrganizationsToMarketplaceMutation, AddOrganizationsToMarketplaceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddOrganizationsToMarketplaceMutation, AddOrganizationsToMarketplaceMutationVariables>(AddOrganizationsToMarketplaceDocument, options);
      }
export type AddOrganizationsToMarketplaceMutationHookResult = ReturnType<typeof useAddOrganizationsToMarketplaceMutation>;
export type AddOrganizationsToMarketplaceMutationResult = Apollo.MutationResult<AddOrganizationsToMarketplaceMutation>;
export type AddOrganizationsToMarketplaceMutationOptions = Apollo.BaseMutationOptions<AddOrganizationsToMarketplaceMutation, AddOrganizationsToMarketplaceMutationVariables>;
export const ApproveAppointmentRequestDocument = gql`
    mutation ApproveAppointmentRequest($input: ApproveAppointmentRequestInput!) {
  approveAppointmentRequest(input: $input) {
    ...FullAppointmentRequestFields
  }
}
    ${FullAppointmentRequestFieldsFragmentDoc}`;
export type ApproveAppointmentRequestMutationFn = Apollo.MutationFunction<ApproveAppointmentRequestMutation, ApproveAppointmentRequestMutationVariables>;

/**
 * __useApproveAppointmentRequestMutation__
 *
 * To run a mutation, you first call `useApproveAppointmentRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveAppointmentRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveAppointmentRequestMutation, { data, loading, error }] = useApproveAppointmentRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useApproveAppointmentRequestMutation(baseOptions?: Apollo.MutationHookOptions<ApproveAppointmentRequestMutation, ApproveAppointmentRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveAppointmentRequestMutation, ApproveAppointmentRequestMutationVariables>(ApproveAppointmentRequestDocument, options);
      }
export type ApproveAppointmentRequestMutationHookResult = ReturnType<typeof useApproveAppointmentRequestMutation>;
export type ApproveAppointmentRequestMutationResult = Apollo.MutationResult<ApproveAppointmentRequestMutation>;
export type ApproveAppointmentRequestMutationOptions = Apollo.BaseMutationOptions<ApproveAppointmentRequestMutation, ApproveAppointmentRequestMutationVariables>;
export const ArchiveAppointmentDocument = gql`
    mutation ArchiveAppointment($input: ArchiveAppointmentInput!) {
  archiveAppointment(input: $input) {
    ...AppointmentFields
  }
}
    ${AppointmentFieldsFragmentDoc}`;
export type ArchiveAppointmentMutationFn = Apollo.MutationFunction<ArchiveAppointmentMutation, ArchiveAppointmentMutationVariables>;

/**
 * __useArchiveAppointmentMutation__
 *
 * To run a mutation, you first call `useArchiveAppointmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveAppointmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveAppointmentMutation, { data, loading, error }] = useArchiveAppointmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useArchiveAppointmentMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveAppointmentMutation, ArchiveAppointmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveAppointmentMutation, ArchiveAppointmentMutationVariables>(ArchiveAppointmentDocument, options);
      }
export type ArchiveAppointmentMutationHookResult = ReturnType<typeof useArchiveAppointmentMutation>;
export type ArchiveAppointmentMutationResult = Apollo.MutationResult<ArchiveAppointmentMutation>;
export type ArchiveAppointmentMutationOptions = Apollo.BaseMutationOptions<ArchiveAppointmentMutation, ArchiveAppointmentMutationVariables>;
export const ArchiveAppointmentRequestDocument = gql`
    mutation ArchiveAppointmentRequest($input: ArchiveAppointmentRequestInput!) {
  archiveAppointmentRequest(input: $input) {
    ...FullAppointmentRequestFields
  }
}
    ${FullAppointmentRequestFieldsFragmentDoc}`;
export type ArchiveAppointmentRequestMutationFn = Apollo.MutationFunction<ArchiveAppointmentRequestMutation, ArchiveAppointmentRequestMutationVariables>;

/**
 * __useArchiveAppointmentRequestMutation__
 *
 * To run a mutation, you first call `useArchiveAppointmentRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveAppointmentRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveAppointmentRequestMutation, { data, loading, error }] = useArchiveAppointmentRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useArchiveAppointmentRequestMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveAppointmentRequestMutation, ArchiveAppointmentRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveAppointmentRequestMutation, ArchiveAppointmentRequestMutationVariables>(ArchiveAppointmentRequestDocument, options);
      }
export type ArchiveAppointmentRequestMutationHookResult = ReturnType<typeof useArchiveAppointmentRequestMutation>;
export type ArchiveAppointmentRequestMutationResult = Apollo.MutationResult<ArchiveAppointmentRequestMutation>;
export type ArchiveAppointmentRequestMutationOptions = Apollo.BaseMutationOptions<ArchiveAppointmentRequestMutation, ArchiveAppointmentRequestMutationVariables>;
export const ArchiveDiscountDocument = gql`
    mutation ArchiveDiscount($id: ID!) {
  archiveDiscount(id: $id)
}
    `;
export type ArchiveDiscountMutationFn = Apollo.MutationFunction<ArchiveDiscountMutation, ArchiveDiscountMutationVariables>;

/**
 * __useArchiveDiscountMutation__
 *
 * To run a mutation, you first call `useArchiveDiscountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveDiscountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveDiscountMutation, { data, loading, error }] = useArchiveDiscountMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useArchiveDiscountMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveDiscountMutation, ArchiveDiscountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveDiscountMutation, ArchiveDiscountMutationVariables>(ArchiveDiscountDocument, options);
      }
export type ArchiveDiscountMutationHookResult = ReturnType<typeof useArchiveDiscountMutation>;
export type ArchiveDiscountMutationResult = Apollo.MutationResult<ArchiveDiscountMutation>;
export type ArchiveDiscountMutationOptions = Apollo.BaseMutationOptions<ArchiveDiscountMutation, ArchiveDiscountMutationVariables>;
export const ArchiveDocumentDocument = gql`
    mutation ArchiveDocument($id: ID!) {
  archiveDocument(id: $id)
}
    `;
export type ArchiveDocumentMutationFn = Apollo.MutationFunction<ArchiveDocumentMutation, ArchiveDocumentMutationVariables>;

/**
 * __useArchiveDocumentMutation__
 *
 * To run a mutation, you first call `useArchiveDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveDocumentMutation, { data, loading, error }] = useArchiveDocumentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useArchiveDocumentMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveDocumentMutation, ArchiveDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveDocumentMutation, ArchiveDocumentMutationVariables>(ArchiveDocumentDocument, options);
      }
export type ArchiveDocumentMutationHookResult = ReturnType<typeof useArchiveDocumentMutation>;
export type ArchiveDocumentMutationResult = Apollo.MutationResult<ArchiveDocumentMutation>;
export type ArchiveDocumentMutationOptions = Apollo.BaseMutationOptions<ArchiveDocumentMutation, ArchiveDocumentMutationVariables>;
export const ArchiveEmrInstanceDocument = gql`
    mutation ArchiveEmrInstance($id: ID!) {
  archiveEmrInstance(id: $id)
}
    `;
export type ArchiveEmrInstanceMutationFn = Apollo.MutationFunction<ArchiveEmrInstanceMutation, ArchiveEmrInstanceMutationVariables>;

/**
 * __useArchiveEmrInstanceMutation__
 *
 * To run a mutation, you first call `useArchiveEmrInstanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveEmrInstanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveEmrInstanceMutation, { data, loading, error }] = useArchiveEmrInstanceMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useArchiveEmrInstanceMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveEmrInstanceMutation, ArchiveEmrInstanceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveEmrInstanceMutation, ArchiveEmrInstanceMutationVariables>(ArchiveEmrInstanceDocument, options);
      }
export type ArchiveEmrInstanceMutationHookResult = ReturnType<typeof useArchiveEmrInstanceMutation>;
export type ArchiveEmrInstanceMutationResult = Apollo.MutationResult<ArchiveEmrInstanceMutation>;
export type ArchiveEmrInstanceMutationOptions = Apollo.BaseMutationOptions<ArchiveEmrInstanceMutation, ArchiveEmrInstanceMutationVariables>;
export const ArchiveFormNoteDocument = gql`
    mutation ArchiveFormNote($id: ID!) {
  archiveFormNote(id: $id)
}
    `;
export type ArchiveFormNoteMutationFn = Apollo.MutationFunction<ArchiveFormNoteMutation, ArchiveFormNoteMutationVariables>;

/**
 * __useArchiveFormNoteMutation__
 *
 * To run a mutation, you first call `useArchiveFormNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveFormNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveFormNoteMutation, { data, loading, error }] = useArchiveFormNoteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useArchiveFormNoteMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveFormNoteMutation, ArchiveFormNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveFormNoteMutation, ArchiveFormNoteMutationVariables>(ArchiveFormNoteDocument, options);
      }
export type ArchiveFormNoteMutationHookResult = ReturnType<typeof useArchiveFormNoteMutation>;
export type ArchiveFormNoteMutationResult = Apollo.MutationResult<ArchiveFormNoteMutation>;
export type ArchiveFormNoteMutationOptions = Apollo.BaseMutationOptions<ArchiveFormNoteMutation, ArchiveFormNoteMutationVariables>;
export const ArchiveMarketplaceGroupDocument = gql`
    mutation ArchiveMarketplaceGroup($input: ArchiveMarketplaceGroupInput!) {
  archiveMarketplaceGroup(input: $input)
}
    `;
export type ArchiveMarketplaceGroupMutationFn = Apollo.MutationFunction<ArchiveMarketplaceGroupMutation, ArchiveMarketplaceGroupMutationVariables>;

/**
 * __useArchiveMarketplaceGroupMutation__
 *
 * To run a mutation, you first call `useArchiveMarketplaceGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveMarketplaceGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveMarketplaceGroupMutation, { data, loading, error }] = useArchiveMarketplaceGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useArchiveMarketplaceGroupMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveMarketplaceGroupMutation, ArchiveMarketplaceGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveMarketplaceGroupMutation, ArchiveMarketplaceGroupMutationVariables>(ArchiveMarketplaceGroupDocument, options);
      }
export type ArchiveMarketplaceGroupMutationHookResult = ReturnType<typeof useArchiveMarketplaceGroupMutation>;
export type ArchiveMarketplaceGroupMutationResult = Apollo.MutationResult<ArchiveMarketplaceGroupMutation>;
export type ArchiveMarketplaceGroupMutationOptions = Apollo.BaseMutationOptions<ArchiveMarketplaceGroupMutation, ArchiveMarketplaceGroupMutationVariables>;
export const ArchiveMembershipDefinitionDocument = gql`
    mutation ArchiveMembershipDefinition($id: ID!) {
  archiveMembershipDefinition(id: $id)
}
    `;
export type ArchiveMembershipDefinitionMutationFn = Apollo.MutationFunction<ArchiveMembershipDefinitionMutation, ArchiveMembershipDefinitionMutationVariables>;

/**
 * __useArchiveMembershipDefinitionMutation__
 *
 * To run a mutation, you first call `useArchiveMembershipDefinitionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveMembershipDefinitionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveMembershipDefinitionMutation, { data, loading, error }] = useArchiveMembershipDefinitionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useArchiveMembershipDefinitionMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveMembershipDefinitionMutation, ArchiveMembershipDefinitionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveMembershipDefinitionMutation, ArchiveMembershipDefinitionMutationVariables>(ArchiveMembershipDefinitionDocument, options);
      }
export type ArchiveMembershipDefinitionMutationHookResult = ReturnType<typeof useArchiveMembershipDefinitionMutation>;
export type ArchiveMembershipDefinitionMutationResult = Apollo.MutationResult<ArchiveMembershipDefinitionMutation>;
export type ArchiveMembershipDefinitionMutationOptions = Apollo.BaseMutationOptions<ArchiveMembershipDefinitionMutation, ArchiveMembershipDefinitionMutationVariables>;
export const ArchivePackageDocument = gql`
    mutation ArchivePackage($id: ID!) {
  archivePackage(id: $id)
}
    `;
export type ArchivePackageMutationFn = Apollo.MutationFunction<ArchivePackageMutation, ArchivePackageMutationVariables>;

/**
 * __useArchivePackageMutation__
 *
 * To run a mutation, you first call `useArchivePackageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchivePackageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archivePackageMutation, { data, loading, error }] = useArchivePackageMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useArchivePackageMutation(baseOptions?: Apollo.MutationHookOptions<ArchivePackageMutation, ArchivePackageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchivePackageMutation, ArchivePackageMutationVariables>(ArchivePackageDocument, options);
      }
export type ArchivePackageMutationHookResult = ReturnType<typeof useArchivePackageMutation>;
export type ArchivePackageMutationResult = Apollo.MutationResult<ArchivePackageMutation>;
export type ArchivePackageMutationOptions = Apollo.BaseMutationOptions<ArchivePackageMutation, ArchivePackageMutationVariables>;
export const ArchivePackageItemDefinitionDocument = gql`
    mutation ArchivePackageItemDefinition($id: ID!) {
  archivePackageItemDefinition(id: $id)
}
    `;
export type ArchivePackageItemDefinitionMutationFn = Apollo.MutationFunction<ArchivePackageItemDefinitionMutation, ArchivePackageItemDefinitionMutationVariables>;

/**
 * __useArchivePackageItemDefinitionMutation__
 *
 * To run a mutation, you first call `useArchivePackageItemDefinitionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchivePackageItemDefinitionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archivePackageItemDefinitionMutation, { data, loading, error }] = useArchivePackageItemDefinitionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useArchivePackageItemDefinitionMutation(baseOptions?: Apollo.MutationHookOptions<ArchivePackageItemDefinitionMutation, ArchivePackageItemDefinitionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchivePackageItemDefinitionMutation, ArchivePackageItemDefinitionMutationVariables>(ArchivePackageItemDefinitionDocument, options);
      }
export type ArchivePackageItemDefinitionMutationHookResult = ReturnType<typeof useArchivePackageItemDefinitionMutation>;
export type ArchivePackageItemDefinitionMutationResult = Apollo.MutationResult<ArchivePackageItemDefinitionMutation>;
export type ArchivePackageItemDefinitionMutationOptions = Apollo.BaseMutationOptions<ArchivePackageItemDefinitionMutation, ArchivePackageItemDefinitionMutationVariables>;
export const ArchivePaymentAccountDocument = gql`
    mutation ArchivePaymentAccount($id: ID!) {
  archivePaymentAccount(input: {paymentAccountId: $id})
}
    `;
export type ArchivePaymentAccountMutationFn = Apollo.MutationFunction<ArchivePaymentAccountMutation, ArchivePaymentAccountMutationVariables>;

/**
 * __useArchivePaymentAccountMutation__
 *
 * To run a mutation, you first call `useArchivePaymentAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchivePaymentAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archivePaymentAccountMutation, { data, loading, error }] = useArchivePaymentAccountMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useArchivePaymentAccountMutation(baseOptions?: Apollo.MutationHookOptions<ArchivePaymentAccountMutation, ArchivePaymentAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchivePaymentAccountMutation, ArchivePaymentAccountMutationVariables>(ArchivePaymentAccountDocument, options);
      }
export type ArchivePaymentAccountMutationHookResult = ReturnType<typeof useArchivePaymentAccountMutation>;
export type ArchivePaymentAccountMutationResult = Apollo.MutationResult<ArchivePaymentAccountMutation>;
export type ArchivePaymentAccountMutationOptions = Apollo.BaseMutationOptions<ArchivePaymentAccountMutation, ArchivePaymentAccountMutationVariables>;
export const ArchiveProfileDocument = gql`
    mutation ArchiveProfile($id: ID!) {
  archiveProfile(input: {profileId: $id})
}
    `;
export type ArchiveProfileMutationFn = Apollo.MutationFunction<ArchiveProfileMutation, ArchiveProfileMutationVariables>;

/**
 * __useArchiveProfileMutation__
 *
 * To run a mutation, you first call `useArchiveProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveProfileMutation, { data, loading, error }] = useArchiveProfileMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useArchiveProfileMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveProfileMutation, ArchiveProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveProfileMutation, ArchiveProfileMutationVariables>(ArchiveProfileDocument, options);
      }
export type ArchiveProfileMutationHookResult = ReturnType<typeof useArchiveProfileMutation>;
export type ArchiveProfileMutationResult = Apollo.MutationResult<ArchiveProfileMutation>;
export type ArchiveProfileMutationOptions = Apollo.BaseMutationOptions<ArchiveProfileMutation, ArchiveProfileMutationVariables>;
export const ArchivePromoCodeDocument = gql`
    mutation ArchivePromoCode($id: ID!) {
  archivePromoCode(id: $id)
}
    `;
export type ArchivePromoCodeMutationFn = Apollo.MutationFunction<ArchivePromoCodeMutation, ArchivePromoCodeMutationVariables>;

/**
 * __useArchivePromoCodeMutation__
 *
 * To run a mutation, you first call `useArchivePromoCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchivePromoCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archivePromoCodeMutation, { data, loading, error }] = useArchivePromoCodeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useArchivePromoCodeMutation(baseOptions?: Apollo.MutationHookOptions<ArchivePromoCodeMutation, ArchivePromoCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchivePromoCodeMutation, ArchivePromoCodeMutationVariables>(ArchivePromoCodeDocument, options);
      }
export type ArchivePromoCodeMutationHookResult = ReturnType<typeof useArchivePromoCodeMutation>;
export type ArchivePromoCodeMutationResult = Apollo.MutationResult<ArchivePromoCodeMutation>;
export type ArchivePromoCodeMutationOptions = Apollo.BaseMutationOptions<ArchivePromoCodeMutation, ArchivePromoCodeMutationVariables>;
export const AssignEmrInstanceDocument = gql`
    mutation AssignEmrInstance($input: AssignEmrInstanceInput!) {
  assignEmrInstance(input: $input)
}
    `;
export type AssignEmrInstanceMutationFn = Apollo.MutationFunction<AssignEmrInstanceMutation, AssignEmrInstanceMutationVariables>;

/**
 * __useAssignEmrInstanceMutation__
 *
 * To run a mutation, you first call `useAssignEmrInstanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignEmrInstanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignEmrInstanceMutation, { data, loading, error }] = useAssignEmrInstanceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAssignEmrInstanceMutation(baseOptions?: Apollo.MutationHookOptions<AssignEmrInstanceMutation, AssignEmrInstanceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignEmrInstanceMutation, AssignEmrInstanceMutationVariables>(AssignEmrInstanceDocument, options);
      }
export type AssignEmrInstanceMutationHookResult = ReturnType<typeof useAssignEmrInstanceMutation>;
export type AssignEmrInstanceMutationResult = Apollo.MutationResult<AssignEmrInstanceMutation>;
export type AssignEmrInstanceMutationOptions = Apollo.BaseMutationOptions<AssignEmrInstanceMutation, AssignEmrInstanceMutationVariables>;
export const AssignPaymentAccountDocument = gql`
    mutation AssignPaymentAccount($input: AssignPaymentAccountInput!) {
  assignPaymentAccount(input: $input)
}
    `;
export type AssignPaymentAccountMutationFn = Apollo.MutationFunction<AssignPaymentAccountMutation, AssignPaymentAccountMutationVariables>;

/**
 * __useAssignPaymentAccountMutation__
 *
 * To run a mutation, you first call `useAssignPaymentAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignPaymentAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignPaymentAccountMutation, { data, loading, error }] = useAssignPaymentAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAssignPaymentAccountMutation(baseOptions?: Apollo.MutationHookOptions<AssignPaymentAccountMutation, AssignPaymentAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignPaymentAccountMutation, AssignPaymentAccountMutationVariables>(AssignPaymentAccountDocument, options);
      }
export type AssignPaymentAccountMutationHookResult = ReturnType<typeof useAssignPaymentAccountMutation>;
export type AssignPaymentAccountMutationResult = Apollo.MutationResult<AssignPaymentAccountMutation>;
export type AssignPaymentAccountMutationOptions = Apollo.BaseMutationOptions<AssignPaymentAccountMutation, AssignPaymentAccountMutationVariables>;
export const AssignProcedureProfileDocument = gql`
    mutation AssignProcedureProfile($input: AssignProcedureProfileInput!) {
  assignProcedureProfile(input: $input)
}
    `;
export type AssignProcedureProfileMutationFn = Apollo.MutationFunction<AssignProcedureProfileMutation, AssignProcedureProfileMutationVariables>;

/**
 * __useAssignProcedureProfileMutation__
 *
 * To run a mutation, you first call `useAssignProcedureProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignProcedureProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignProcedureProfileMutation, { data, loading, error }] = useAssignProcedureProfileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAssignProcedureProfileMutation(baseOptions?: Apollo.MutationHookOptions<AssignProcedureProfileMutation, AssignProcedureProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignProcedureProfileMutation, AssignProcedureProfileMutationVariables>(AssignProcedureProfileDocument, options);
      }
export type AssignProcedureProfileMutationHookResult = ReturnType<typeof useAssignProcedureProfileMutation>;
export type AssignProcedureProfileMutationResult = Apollo.MutationResult<AssignProcedureProfileMutation>;
export type AssignProcedureProfileMutationOptions = Apollo.BaseMutationOptions<AssignProcedureProfileMutation, AssignProcedureProfileMutationVariables>;
export const AssignRoleDocument = gql`
    mutation AssignRole($input: AssignRoleInput!) {
  assignRole(input: $input)
}
    `;
export type AssignRoleMutationFn = Apollo.MutationFunction<AssignRoleMutation, AssignRoleMutationVariables>;

/**
 * __useAssignRoleMutation__
 *
 * To run a mutation, you first call `useAssignRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignRoleMutation, { data, loading, error }] = useAssignRoleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAssignRoleMutation(baseOptions?: Apollo.MutationHookOptions<AssignRoleMutation, AssignRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignRoleMutation, AssignRoleMutationVariables>(AssignRoleDocument, options);
      }
export type AssignRoleMutationHookResult = ReturnType<typeof useAssignRoleMutation>;
export type AssignRoleMutationResult = Apollo.MutationResult<AssignRoleMutation>;
export type AssignRoleMutationOptions = Apollo.BaseMutationOptions<AssignRoleMutation, AssignRoleMutationVariables>;
export const AuthenticateDocument = gql`
    mutation Authenticate($email: String!, $password: String!, $ignoreTrustedDevice: Boolean) {
  authenticate(
    input: {email: $email, password: $password, ignoreTrustedDevice: $ignoreTrustedDevice}
  ) {
    user {
      id
      email
    }
  }
}
    `;
export type AuthenticateMutationFn = Apollo.MutationFunction<AuthenticateMutation, AuthenticateMutationVariables>;

/**
 * __useAuthenticateMutation__
 *
 * To run a mutation, you first call `useAuthenticateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthenticateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authenticateMutation, { data, loading, error }] = useAuthenticateMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *      ignoreTrustedDevice: // value for 'ignoreTrustedDevice'
 *   },
 * });
 */
export function useAuthenticateMutation(baseOptions?: Apollo.MutationHookOptions<AuthenticateMutation, AuthenticateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AuthenticateMutation, AuthenticateMutationVariables>(AuthenticateDocument, options);
      }
export type AuthenticateMutationHookResult = ReturnType<typeof useAuthenticateMutation>;
export type AuthenticateMutationResult = Apollo.MutationResult<AuthenticateMutation>;
export type AuthenticateMutationOptions = Apollo.BaseMutationOptions<AuthenticateMutation, AuthenticateMutationVariables>;
export const AuthenticateAsDocument = gql`
    mutation AuthenticateAs($userId: ID!) {
  authenticateAs(userId: $userId) {
    user {
      id
      email
    }
  }
}
    `;
export type AuthenticateAsMutationFn = Apollo.MutationFunction<AuthenticateAsMutation, AuthenticateAsMutationVariables>;

/**
 * __useAuthenticateAsMutation__
 *
 * To run a mutation, you first call `useAuthenticateAsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthenticateAsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authenticateAsMutation, { data, loading, error }] = useAuthenticateAsMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useAuthenticateAsMutation(baseOptions?: Apollo.MutationHookOptions<AuthenticateAsMutation, AuthenticateAsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AuthenticateAsMutation, AuthenticateAsMutationVariables>(AuthenticateAsDocument, options);
      }
export type AuthenticateAsMutationHookResult = ReturnType<typeof useAuthenticateAsMutation>;
export type AuthenticateAsMutationResult = Apollo.MutationResult<AuthenticateAsMutation>;
export type AuthenticateAsMutationOptions = Apollo.BaseMutationOptions<AuthenticateAsMutation, AuthenticateAsMutationVariables>;
export const CancelAppointmentDocument = gql`
    mutation CancelAppointment($input: CancelAppointmentInput!) {
  cancelAppointment(input: $input) {
    ...FullAppointmentFields
  }
}
    ${FullAppointmentFieldsFragmentDoc}`;
export type CancelAppointmentMutationFn = Apollo.MutationFunction<CancelAppointmentMutation, CancelAppointmentMutationVariables>;

/**
 * __useCancelAppointmentMutation__
 *
 * To run a mutation, you first call `useCancelAppointmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelAppointmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelAppointmentMutation, { data, loading, error }] = useCancelAppointmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCancelAppointmentMutation(baseOptions?: Apollo.MutationHookOptions<CancelAppointmentMutation, CancelAppointmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelAppointmentMutation, CancelAppointmentMutationVariables>(CancelAppointmentDocument, options);
      }
export type CancelAppointmentMutationHookResult = ReturnType<typeof useCancelAppointmentMutation>;
export type CancelAppointmentMutationResult = Apollo.MutationResult<CancelAppointmentMutation>;
export type CancelAppointmentMutationOptions = Apollo.BaseMutationOptions<CancelAppointmentMutation, CancelAppointmentMutationVariables>;
export const CancelAppointmentGroupDocument = gql`
    mutation CancelAppointmentGroup($input: CancelAppointmentGroupInput!) {
  cancelAppointmentGroup(input: $input)
}
    `;
export type CancelAppointmentGroupMutationFn = Apollo.MutationFunction<CancelAppointmentGroupMutation, CancelAppointmentGroupMutationVariables>;

/**
 * __useCancelAppointmentGroupMutation__
 *
 * To run a mutation, you first call `useCancelAppointmentGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelAppointmentGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelAppointmentGroupMutation, { data, loading, error }] = useCancelAppointmentGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCancelAppointmentGroupMutation(baseOptions?: Apollo.MutationHookOptions<CancelAppointmentGroupMutation, CancelAppointmentGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelAppointmentGroupMutation, CancelAppointmentGroupMutationVariables>(CancelAppointmentGroupDocument, options);
      }
export type CancelAppointmentGroupMutationHookResult = ReturnType<typeof useCancelAppointmentGroupMutation>;
export type CancelAppointmentGroupMutationResult = Apollo.MutationResult<CancelAppointmentGroupMutation>;
export type CancelAppointmentGroupMutationOptions = Apollo.BaseMutationOptions<CancelAppointmentGroupMutation, CancelAppointmentGroupMutationVariables>;
export const CancelAppointmentRequestDocument = gql`
    mutation CancelAppointmentRequest($input: CancelAppointmentRequestInput!) {
  cancelAppointmentRequest(input: $input) {
    ...FullAppointmentRequestFields
  }
}
    ${FullAppointmentRequestFieldsFragmentDoc}`;
export type CancelAppointmentRequestMutationFn = Apollo.MutationFunction<CancelAppointmentRequestMutation, CancelAppointmentRequestMutationVariables>;

/**
 * __useCancelAppointmentRequestMutation__
 *
 * To run a mutation, you first call `useCancelAppointmentRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelAppointmentRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelAppointmentRequestMutation, { data, loading, error }] = useCancelAppointmentRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCancelAppointmentRequestMutation(baseOptions?: Apollo.MutationHookOptions<CancelAppointmentRequestMutation, CancelAppointmentRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelAppointmentRequestMutation, CancelAppointmentRequestMutationVariables>(CancelAppointmentRequestDocument, options);
      }
export type CancelAppointmentRequestMutationHookResult = ReturnType<typeof useCancelAppointmentRequestMutation>;
export type CancelAppointmentRequestMutationResult = Apollo.MutationResult<CancelAppointmentRequestMutation>;
export type CancelAppointmentRequestMutationOptions = Apollo.BaseMutationOptions<CancelAppointmentRequestMutation, CancelAppointmentRequestMutationVariables>;
export const CancelMembershipDocument = gql`
    mutation CancelMembership($id: ID!) {
  cancelMembership(id: $id)
}
    `;
export type CancelMembershipMutationFn = Apollo.MutationFunction<CancelMembershipMutation, CancelMembershipMutationVariables>;

/**
 * __useCancelMembershipMutation__
 *
 * To run a mutation, you first call `useCancelMembershipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelMembershipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelMembershipMutation, { data, loading, error }] = useCancelMembershipMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCancelMembershipMutation(baseOptions?: Apollo.MutationHookOptions<CancelMembershipMutation, CancelMembershipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelMembershipMutation, CancelMembershipMutationVariables>(CancelMembershipDocument, options);
      }
export type CancelMembershipMutationHookResult = ReturnType<typeof useCancelMembershipMutation>;
export type CancelMembershipMutationResult = Apollo.MutationResult<CancelMembershipMutation>;
export type CancelMembershipMutationOptions = Apollo.BaseMutationOptions<CancelMembershipMutation, CancelMembershipMutationVariables>;
export const ChangeEmailDocument = gql`
    mutation ChangeEmail($input: ChangeEmailInput!) {
  changeEmail(input: $input)
}
    `;
export type ChangeEmailMutationFn = Apollo.MutationFunction<ChangeEmailMutation, ChangeEmailMutationVariables>;

/**
 * __useChangeEmailMutation__
 *
 * To run a mutation, you first call `useChangeEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeEmailMutation, { data, loading, error }] = useChangeEmailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChangeEmailMutation(baseOptions?: Apollo.MutationHookOptions<ChangeEmailMutation, ChangeEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeEmailMutation, ChangeEmailMutationVariables>(ChangeEmailDocument, options);
      }
export type ChangeEmailMutationHookResult = ReturnType<typeof useChangeEmailMutation>;
export type ChangeEmailMutationResult = Apollo.MutationResult<ChangeEmailMutation>;
export type ChangeEmailMutationOptions = Apollo.BaseMutationOptions<ChangeEmailMutation, ChangeEmailMutationVariables>;
export const CompleteAppointmentDocument = gql`
    mutation CompleteAppointment($input: CompleteAppointmentInput!) {
  completeAppointment(input: $input) {
    ...FullAppointmentFields
  }
}
    ${FullAppointmentFieldsFragmentDoc}`;
export type CompleteAppointmentMutationFn = Apollo.MutationFunction<CompleteAppointmentMutation, CompleteAppointmentMutationVariables>;

/**
 * __useCompleteAppointmentMutation__
 *
 * To run a mutation, you first call `useCompleteAppointmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteAppointmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeAppointmentMutation, { data, loading, error }] = useCompleteAppointmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCompleteAppointmentMutation(baseOptions?: Apollo.MutationHookOptions<CompleteAppointmentMutation, CompleteAppointmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompleteAppointmentMutation, CompleteAppointmentMutationVariables>(CompleteAppointmentDocument, options);
      }
export type CompleteAppointmentMutationHookResult = ReturnType<typeof useCompleteAppointmentMutation>;
export type CompleteAppointmentMutationResult = Apollo.MutationResult<CompleteAppointmentMutation>;
export type CompleteAppointmentMutationOptions = Apollo.BaseMutationOptions<CompleteAppointmentMutation, CompleteAppointmentMutationVariables>;
export const CompleteCheckoutDocument = gql`
    mutation CompleteCheckout($input: CompleteCheckoutInput!) {
  completeCheckout(input: $input) {
    success
    errorMessage
    checkout {
      ...CheckoutWithAppointmentFields
    }
  }
}
    ${CheckoutWithAppointmentFieldsFragmentDoc}`;
export type CompleteCheckoutMutationFn = Apollo.MutationFunction<CompleteCheckoutMutation, CompleteCheckoutMutationVariables>;

/**
 * __useCompleteCheckoutMutation__
 *
 * To run a mutation, you first call `useCompleteCheckoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteCheckoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeCheckoutMutation, { data, loading, error }] = useCompleteCheckoutMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCompleteCheckoutMutation(baseOptions?: Apollo.MutationHookOptions<CompleteCheckoutMutation, CompleteCheckoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompleteCheckoutMutation, CompleteCheckoutMutationVariables>(CompleteCheckoutDocument, options);
      }
export type CompleteCheckoutMutationHookResult = ReturnType<typeof useCompleteCheckoutMutation>;
export type CompleteCheckoutMutationResult = Apollo.MutationResult<CompleteCheckoutMutation>;
export type CompleteCheckoutMutationOptions = Apollo.BaseMutationOptions<CompleteCheckoutMutation, CompleteCheckoutMutationVariables>;
export const ConfirmTotpEnrollmentDocument = gql`
    mutation ConfirmTotpEnrollment($input: ConfirmTotpEnrollmentInput!) {
  confirmTotpEnrollment(input: $input) {
    recoveryCodes
  }
}
    `;
export type ConfirmTotpEnrollmentMutationFn = Apollo.MutationFunction<ConfirmTotpEnrollmentMutation, ConfirmTotpEnrollmentMutationVariables>;

/**
 * __useConfirmTotpEnrollmentMutation__
 *
 * To run a mutation, you first call `useConfirmTotpEnrollmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmTotpEnrollmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmTotpEnrollmentMutation, { data, loading, error }] = useConfirmTotpEnrollmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConfirmTotpEnrollmentMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmTotpEnrollmentMutation, ConfirmTotpEnrollmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfirmTotpEnrollmentMutation, ConfirmTotpEnrollmentMutationVariables>(ConfirmTotpEnrollmentDocument, options);
      }
export type ConfirmTotpEnrollmentMutationHookResult = ReturnType<typeof useConfirmTotpEnrollmentMutation>;
export type ConfirmTotpEnrollmentMutationResult = Apollo.MutationResult<ConfirmTotpEnrollmentMutation>;
export type ConfirmTotpEnrollmentMutationOptions = Apollo.BaseMutationOptions<ConfirmTotpEnrollmentMutation, ConfirmTotpEnrollmentMutationVariables>;
export const CreateAllergyIntoleranceDocument = gql`
    mutation CreateAllergyIntolerance($input: CreateAllergyIntoleranceInput!) {
  createAllergyIntolerance(input: $input) {
    ...AllergyIntoleranceFields
  }
}
    ${AllergyIntoleranceFieldsFragmentDoc}`;
export type CreateAllergyIntoleranceMutationFn = Apollo.MutationFunction<CreateAllergyIntoleranceMutation, CreateAllergyIntoleranceMutationVariables>;

/**
 * __useCreateAllergyIntoleranceMutation__
 *
 * To run a mutation, you first call `useCreateAllergyIntoleranceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAllergyIntoleranceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAllergyIntoleranceMutation, { data, loading, error }] = useCreateAllergyIntoleranceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAllergyIntoleranceMutation(baseOptions?: Apollo.MutationHookOptions<CreateAllergyIntoleranceMutation, CreateAllergyIntoleranceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAllergyIntoleranceMutation, CreateAllergyIntoleranceMutationVariables>(CreateAllergyIntoleranceDocument, options);
      }
export type CreateAllergyIntoleranceMutationHookResult = ReturnType<typeof useCreateAllergyIntoleranceMutation>;
export type CreateAllergyIntoleranceMutationResult = Apollo.MutationResult<CreateAllergyIntoleranceMutation>;
export type CreateAllergyIntoleranceMutationOptions = Apollo.BaseMutationOptions<CreateAllergyIntoleranceMutation, CreateAllergyIntoleranceMutationVariables>;
export const CreateApiKeyDocument = gql`
    mutation CreateApiKey($input: CreateApiKeyInput!) {
  createApiKey(input: $input) {
    apiKey {
      ...ApiKeyFields
    }
    privateKey
  }
}
    ${ApiKeyFieldsFragmentDoc}`;
export type CreateApiKeyMutationFn = Apollo.MutationFunction<CreateApiKeyMutation, CreateApiKeyMutationVariables>;

/**
 * __useCreateApiKeyMutation__
 *
 * To run a mutation, you first call `useCreateApiKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateApiKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createApiKeyMutation, { data, loading, error }] = useCreateApiKeyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateApiKeyMutation(baseOptions?: Apollo.MutationHookOptions<CreateApiKeyMutation, CreateApiKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateApiKeyMutation, CreateApiKeyMutationVariables>(CreateApiKeyDocument, options);
      }
export type CreateApiKeyMutationHookResult = ReturnType<typeof useCreateApiKeyMutation>;
export type CreateApiKeyMutationResult = Apollo.MutationResult<CreateApiKeyMutation>;
export type CreateApiKeyMutationOptions = Apollo.BaseMutationOptions<CreateApiKeyMutation, CreateApiKeyMutationVariables>;
export const CreateAppointmentDocument = gql`
    mutation CreateAppointment($input: CreateAppointmentInput!) {
  createAppointment(input: $input) {
    ...FullAppointmentFields
  }
}
    ${FullAppointmentFieldsFragmentDoc}`;
export type CreateAppointmentMutationFn = Apollo.MutationFunction<CreateAppointmentMutation, CreateAppointmentMutationVariables>;

/**
 * __useCreateAppointmentMutation__
 *
 * To run a mutation, you first call `useCreateAppointmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAppointmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAppointmentMutation, { data, loading, error }] = useCreateAppointmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAppointmentMutation(baseOptions?: Apollo.MutationHookOptions<CreateAppointmentMutation, CreateAppointmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAppointmentMutation, CreateAppointmentMutationVariables>(CreateAppointmentDocument, options);
      }
export type CreateAppointmentMutationHookResult = ReturnType<typeof useCreateAppointmentMutation>;
export type CreateAppointmentMutationResult = Apollo.MutationResult<CreateAppointmentMutation>;
export type CreateAppointmentMutationOptions = Apollo.BaseMutationOptions<CreateAppointmentMutation, CreateAppointmentMutationVariables>;
export const CreateAppointmentRequestDocument = gql`
    mutation CreateAppointmentRequest($input: CreateAppointmentRequestInput!) {
  createAppointmentRequest(input: $input) {
    ...FullAppointmentRequestFields
  }
}
    ${FullAppointmentRequestFieldsFragmentDoc}`;
export type CreateAppointmentRequestMutationFn = Apollo.MutationFunction<CreateAppointmentRequestMutation, CreateAppointmentRequestMutationVariables>;

/**
 * __useCreateAppointmentRequestMutation__
 *
 * To run a mutation, you first call `useCreateAppointmentRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAppointmentRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAppointmentRequestMutation, { data, loading, error }] = useCreateAppointmentRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAppointmentRequestMutation(baseOptions?: Apollo.MutationHookOptions<CreateAppointmentRequestMutation, CreateAppointmentRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAppointmentRequestMutation, CreateAppointmentRequestMutationVariables>(CreateAppointmentRequestDocument, options);
      }
export type CreateAppointmentRequestMutationHookResult = ReturnType<typeof useCreateAppointmentRequestMutation>;
export type CreateAppointmentRequestMutationResult = Apollo.MutationResult<CreateAppointmentRequestMutation>;
export type CreateAppointmentRequestMutationOptions = Apollo.BaseMutationOptions<CreateAppointmentRequestMutation, CreateAppointmentRequestMutationVariables>;
export const CreateAttachmentDocument = gql`
    mutation CreateAttachment($input: CreateAttachmentInput!) {
  createAttachment(input: $input) {
    ...DocumentFields
  }
}
    ${DocumentFieldsFragmentDoc}`;
export type CreateAttachmentMutationFn = Apollo.MutationFunction<CreateAttachmentMutation, CreateAttachmentMutationVariables>;

/**
 * __useCreateAttachmentMutation__
 *
 * To run a mutation, you first call `useCreateAttachmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAttachmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAttachmentMutation, { data, loading, error }] = useCreateAttachmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAttachmentMutation(baseOptions?: Apollo.MutationHookOptions<CreateAttachmentMutation, CreateAttachmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAttachmentMutation, CreateAttachmentMutationVariables>(CreateAttachmentDocument, options);
      }
export type CreateAttachmentMutationHookResult = ReturnType<typeof useCreateAttachmentMutation>;
export type CreateAttachmentMutationResult = Apollo.MutationResult<CreateAttachmentMutation>;
export type CreateAttachmentMutationOptions = Apollo.BaseMutationOptions<CreateAttachmentMutation, CreateAttachmentMutationVariables>;
export const CreateAvailabilityDocument = gql`
    mutation CreateAvailability($input: CreateAvailabilityInput!) {
  createAvailability(input: $input) {
    ...AvailabilityFields
  }
}
    ${AvailabilityFieldsFragmentDoc}`;
export type CreateAvailabilityMutationFn = Apollo.MutationFunction<CreateAvailabilityMutation, CreateAvailabilityMutationVariables>;

/**
 * __useCreateAvailabilityMutation__
 *
 * To run a mutation, you first call `useCreateAvailabilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAvailabilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAvailabilityMutation, { data, loading, error }] = useCreateAvailabilityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAvailabilityMutation(baseOptions?: Apollo.MutationHookOptions<CreateAvailabilityMutation, CreateAvailabilityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAvailabilityMutation, CreateAvailabilityMutationVariables>(CreateAvailabilityDocument, options);
      }
export type CreateAvailabilityMutationHookResult = ReturnType<typeof useCreateAvailabilityMutation>;
export type CreateAvailabilityMutationResult = Apollo.MutationResult<CreateAvailabilityMutation>;
export type CreateAvailabilityMutationOptions = Apollo.BaseMutationOptions<CreateAvailabilityMutation, CreateAvailabilityMutationVariables>;
export const CreateAvailabilityCoverageDocument = gql`
    mutation CreateAvailabilityCoverage($input: CreateAvailabilityCoverageInput!) {
  createAvailabilityCoverage(input: $input) {
    ...AvailabilityCoverageFields
  }
}
    ${AvailabilityCoverageFieldsFragmentDoc}`;
export type CreateAvailabilityCoverageMutationFn = Apollo.MutationFunction<CreateAvailabilityCoverageMutation, CreateAvailabilityCoverageMutationVariables>;

/**
 * __useCreateAvailabilityCoverageMutation__
 *
 * To run a mutation, you first call `useCreateAvailabilityCoverageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAvailabilityCoverageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAvailabilityCoverageMutation, { data, loading, error }] = useCreateAvailabilityCoverageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAvailabilityCoverageMutation(baseOptions?: Apollo.MutationHookOptions<CreateAvailabilityCoverageMutation, CreateAvailabilityCoverageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAvailabilityCoverageMutation, CreateAvailabilityCoverageMutationVariables>(CreateAvailabilityCoverageDocument, options);
      }
export type CreateAvailabilityCoverageMutationHookResult = ReturnType<typeof useCreateAvailabilityCoverageMutation>;
export type CreateAvailabilityCoverageMutationResult = Apollo.MutationResult<CreateAvailabilityCoverageMutation>;
export type CreateAvailabilityCoverageMutationOptions = Apollo.BaseMutationOptions<CreateAvailabilityCoverageMutation, CreateAvailabilityCoverageMutationVariables>;
export const CreateClientProfileDocument = gql`
    mutation CreateClientProfile($input: CreateClientProfileInput!) {
  createClientProfile(input: $input) {
    ...FullClientProfileFields
  }
}
    ${FullClientProfileFieldsFragmentDoc}`;
export type CreateClientProfileMutationFn = Apollo.MutationFunction<CreateClientProfileMutation, CreateClientProfileMutationVariables>;

/**
 * __useCreateClientProfileMutation__
 *
 * To run a mutation, you first call `useCreateClientProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateClientProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createClientProfileMutation, { data, loading, error }] = useCreateClientProfileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateClientProfileMutation(baseOptions?: Apollo.MutationHookOptions<CreateClientProfileMutation, CreateClientProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateClientProfileMutation, CreateClientProfileMutationVariables>(CreateClientProfileDocument, options);
      }
export type CreateClientProfileMutationHookResult = ReturnType<typeof useCreateClientProfileMutation>;
export type CreateClientProfileMutationResult = Apollo.MutationResult<CreateClientProfileMutation>;
export type CreateClientProfileMutationOptions = Apollo.BaseMutationOptions<CreateClientProfileMutation, CreateClientProfileMutationVariables>;
export const CreateClinicalProcedureDocument = gql`
    mutation CreateClinicalProcedure($input: CreateClinicalProcedureInput!) {
  createClinicalProcedure(input: $input) {
    ...ClinicalProcedureFields
  }
}
    ${ClinicalProcedureFieldsFragmentDoc}`;
export type CreateClinicalProcedureMutationFn = Apollo.MutationFunction<CreateClinicalProcedureMutation, CreateClinicalProcedureMutationVariables>;

/**
 * __useCreateClinicalProcedureMutation__
 *
 * To run a mutation, you first call `useCreateClinicalProcedureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateClinicalProcedureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createClinicalProcedureMutation, { data, loading, error }] = useCreateClinicalProcedureMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateClinicalProcedureMutation(baseOptions?: Apollo.MutationHookOptions<CreateClinicalProcedureMutation, CreateClinicalProcedureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateClinicalProcedureMutation, CreateClinicalProcedureMutationVariables>(CreateClinicalProcedureDocument, options);
      }
export type CreateClinicalProcedureMutationHookResult = ReturnType<typeof useCreateClinicalProcedureMutation>;
export type CreateClinicalProcedureMutationResult = Apollo.MutationResult<CreateClinicalProcedureMutation>;
export type CreateClinicalProcedureMutationOptions = Apollo.BaseMutationOptions<CreateClinicalProcedureMutation, CreateClinicalProcedureMutationVariables>;
export const CreateConditionDocument = gql`
    mutation CreateCondition($input: CreateConditionInput!) {
  createCondition(input: $input) {
    ...ConditionFields
  }
}
    ${ConditionFieldsFragmentDoc}`;
export type CreateConditionMutationFn = Apollo.MutationFunction<CreateConditionMutation, CreateConditionMutationVariables>;

/**
 * __useCreateConditionMutation__
 *
 * To run a mutation, you first call `useCreateConditionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateConditionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createConditionMutation, { data, loading, error }] = useCreateConditionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateConditionMutation(baseOptions?: Apollo.MutationHookOptions<CreateConditionMutation, CreateConditionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateConditionMutation, CreateConditionMutationVariables>(CreateConditionDocument, options);
      }
export type CreateConditionMutationHookResult = ReturnType<typeof useCreateConditionMutation>;
export type CreateConditionMutationResult = Apollo.MutationResult<CreateConditionMutation>;
export type CreateConditionMutationOptions = Apollo.BaseMutationOptions<CreateConditionMutation, CreateConditionMutationVariables>;
export const CreateDiscountDocument = gql`
    mutation CreateDiscount($input: CreateDiscountInput!) {
  createDiscount(input: $input) {
    ...DiscountFields
  }
}
    ${DiscountFieldsFragmentDoc}`;
export type CreateDiscountMutationFn = Apollo.MutationFunction<CreateDiscountMutation, CreateDiscountMutationVariables>;

/**
 * __useCreateDiscountMutation__
 *
 * To run a mutation, you first call `useCreateDiscountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDiscountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDiscountMutation, { data, loading, error }] = useCreateDiscountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDiscountMutation(baseOptions?: Apollo.MutationHookOptions<CreateDiscountMutation, CreateDiscountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDiscountMutation, CreateDiscountMutationVariables>(CreateDiscountDocument, options);
      }
export type CreateDiscountMutationHookResult = ReturnType<typeof useCreateDiscountMutation>;
export type CreateDiscountMutationResult = Apollo.MutationResult<CreateDiscountMutation>;
export type CreateDiscountMutationOptions = Apollo.BaseMutationOptions<CreateDiscountMutation, CreateDiscountMutationVariables>;
export const CreateDocumentDocument = gql`
    mutation CreateDocument($input: CreateDocumentInput!) {
  createDocument(input: $input) {
    ...DocumentFields
  }
}
    ${DocumentFieldsFragmentDoc}`;
export type CreateDocumentMutationFn = Apollo.MutationFunction<CreateDocumentMutation, CreateDocumentMutationVariables>;

/**
 * __useCreateDocumentMutation__
 *
 * To run a mutation, you first call `useCreateDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDocumentMutation, { data, loading, error }] = useCreateDocumentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDocumentMutation(baseOptions?: Apollo.MutationHookOptions<CreateDocumentMutation, CreateDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDocumentMutation, CreateDocumentMutationVariables>(CreateDocumentDocument, options);
      }
export type CreateDocumentMutationHookResult = ReturnType<typeof useCreateDocumentMutation>;
export type CreateDocumentMutationResult = Apollo.MutationResult<CreateDocumentMutation>;
export type CreateDocumentMutationOptions = Apollo.BaseMutationOptions<CreateDocumentMutation, CreateDocumentMutationVariables>;
export const CreateEmrInstanceDocument = gql`
    mutation CreateEmrInstance($input: CreateEmrInstanceInput!) {
  createEmrInstance(input: $input) {
    ...EmrInstanceFields
  }
}
    ${EmrInstanceFieldsFragmentDoc}`;
export type CreateEmrInstanceMutationFn = Apollo.MutationFunction<CreateEmrInstanceMutation, CreateEmrInstanceMutationVariables>;

/**
 * __useCreateEmrInstanceMutation__
 *
 * To run a mutation, you first call `useCreateEmrInstanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEmrInstanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEmrInstanceMutation, { data, loading, error }] = useCreateEmrInstanceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateEmrInstanceMutation(baseOptions?: Apollo.MutationHookOptions<CreateEmrInstanceMutation, CreateEmrInstanceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEmrInstanceMutation, CreateEmrInstanceMutationVariables>(CreateEmrInstanceDocument, options);
      }
export type CreateEmrInstanceMutationHookResult = ReturnType<typeof useCreateEmrInstanceMutation>;
export type CreateEmrInstanceMutationResult = Apollo.MutationResult<CreateEmrInstanceMutation>;
export type CreateEmrInstanceMutationOptions = Apollo.BaseMutationOptions<CreateEmrInstanceMutation, CreateEmrInstanceMutationVariables>;
export const CreateFormNoteDocument = gql`
    mutation CreateFormNote($input: CreateFormNoteInput!) {
  createFormNote(input: $input) {
    ...FormNoteFields
  }
}
    ${FormNoteFieldsFragmentDoc}`;
export type CreateFormNoteMutationFn = Apollo.MutationFunction<CreateFormNoteMutation, CreateFormNoteMutationVariables>;

/**
 * __useCreateFormNoteMutation__
 *
 * To run a mutation, you first call `useCreateFormNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFormNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFormNoteMutation, { data, loading, error }] = useCreateFormNoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFormNoteMutation(baseOptions?: Apollo.MutationHookOptions<CreateFormNoteMutation, CreateFormNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFormNoteMutation, CreateFormNoteMutationVariables>(CreateFormNoteDocument, options);
      }
export type CreateFormNoteMutationHookResult = ReturnType<typeof useCreateFormNoteMutation>;
export type CreateFormNoteMutationResult = Apollo.MutationResult<CreateFormNoteMutation>;
export type CreateFormNoteMutationOptions = Apollo.BaseMutationOptions<CreateFormNoteMutation, CreateFormNoteMutationVariables>;
export const CreateFormTemplateDocument = gql`
    mutation CreateFormTemplate($input: CreateFormTemplateInput!) {
  createFormTemplate(input: $input) {
    ...FormTemplateFields
  }
}
    ${FormTemplateFieldsFragmentDoc}`;
export type CreateFormTemplateMutationFn = Apollo.MutationFunction<CreateFormTemplateMutation, CreateFormTemplateMutationVariables>;

/**
 * __useCreateFormTemplateMutation__
 *
 * To run a mutation, you first call `useCreateFormTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFormTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFormTemplateMutation, { data, loading, error }] = useCreateFormTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFormTemplateMutation(baseOptions?: Apollo.MutationHookOptions<CreateFormTemplateMutation, CreateFormTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFormTemplateMutation, CreateFormTemplateMutationVariables>(CreateFormTemplateDocument, options);
      }
export type CreateFormTemplateMutationHookResult = ReturnType<typeof useCreateFormTemplateMutation>;
export type CreateFormTemplateMutationResult = Apollo.MutationResult<CreateFormTemplateMutation>;
export type CreateFormTemplateMutationOptions = Apollo.BaseMutationOptions<CreateFormTemplateMutation, CreateFormTemplateMutationVariables>;
export const CreateGeoperimeterDocument = gql`
    mutation CreateGeoperimeter($input: CreateGeoperimeterInput!) {
  createGeoperimeter(input: $input) {
    ...GeoperimeterFields
  }
}
    ${GeoperimeterFieldsFragmentDoc}`;
export type CreateGeoperimeterMutationFn = Apollo.MutationFunction<CreateGeoperimeterMutation, CreateGeoperimeterMutationVariables>;

/**
 * __useCreateGeoperimeterMutation__
 *
 * To run a mutation, you first call `useCreateGeoperimeterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGeoperimeterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGeoperimeterMutation, { data, loading, error }] = useCreateGeoperimeterMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateGeoperimeterMutation(baseOptions?: Apollo.MutationHookOptions<CreateGeoperimeterMutation, CreateGeoperimeterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateGeoperimeterMutation, CreateGeoperimeterMutationVariables>(CreateGeoperimeterDocument, options);
      }
export type CreateGeoperimeterMutationHookResult = ReturnType<typeof useCreateGeoperimeterMutation>;
export type CreateGeoperimeterMutationResult = Apollo.MutationResult<CreateGeoperimeterMutation>;
export type CreateGeoperimeterMutationOptions = Apollo.BaseMutationOptions<CreateGeoperimeterMutation, CreateGeoperimeterMutationVariables>;
export const CreateImmunizationDocument = gql`
    mutation CreateImmunization($input: CreateImmunizationInput!) {
  createImmunization(input: $input) {
    ...ImmunizationFields
  }
}
    ${ImmunizationFieldsFragmentDoc}`;
export type CreateImmunizationMutationFn = Apollo.MutationFunction<CreateImmunizationMutation, CreateImmunizationMutationVariables>;

/**
 * __useCreateImmunizationMutation__
 *
 * To run a mutation, you first call `useCreateImmunizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateImmunizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createImmunizationMutation, { data, loading, error }] = useCreateImmunizationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateImmunizationMutation(baseOptions?: Apollo.MutationHookOptions<CreateImmunizationMutation, CreateImmunizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateImmunizationMutation, CreateImmunizationMutationVariables>(CreateImmunizationDocument, options);
      }
export type CreateImmunizationMutationHookResult = ReturnType<typeof useCreateImmunizationMutation>;
export type CreateImmunizationMutationResult = Apollo.MutationResult<CreateImmunizationMutation>;
export type CreateImmunizationMutationOptions = Apollo.BaseMutationOptions<CreateImmunizationMutation, CreateImmunizationMutationVariables>;
export const CreateLabDocument = gql`
    mutation CreateLab($input: CreateLabInput!) {
  createLab(input: $input) {
    ...LabFields
  }
}
    ${LabFieldsFragmentDoc}`;
export type CreateLabMutationFn = Apollo.MutationFunction<CreateLabMutation, CreateLabMutationVariables>;

/**
 * __useCreateLabMutation__
 *
 * To run a mutation, you first call `useCreateLabMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLabMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLabMutation, { data, loading, error }] = useCreateLabMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateLabMutation(baseOptions?: Apollo.MutationHookOptions<CreateLabMutation, CreateLabMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLabMutation, CreateLabMutationVariables>(CreateLabDocument, options);
      }
export type CreateLabMutationHookResult = ReturnType<typeof useCreateLabMutation>;
export type CreateLabMutationResult = Apollo.MutationResult<CreateLabMutation>;
export type CreateLabMutationOptions = Apollo.BaseMutationOptions<CreateLabMutation, CreateLabMutationVariables>;
export const CreateMarketplaceDocument = gql`
    mutation CreateMarketplace($input: CreateMarketplaceInput!) {
  createMarketplace(input: $input) {
    ...MarketplaceSettingsFields
    roles {
      ...RoleFields
    }
  }
}
    ${MarketplaceSettingsFieldsFragmentDoc}
${RoleFieldsFragmentDoc}`;
export type CreateMarketplaceMutationFn = Apollo.MutationFunction<CreateMarketplaceMutation, CreateMarketplaceMutationVariables>;

/**
 * __useCreateMarketplaceMutation__
 *
 * To run a mutation, you first call `useCreateMarketplaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMarketplaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMarketplaceMutation, { data, loading, error }] = useCreateMarketplaceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMarketplaceMutation(baseOptions?: Apollo.MutationHookOptions<CreateMarketplaceMutation, CreateMarketplaceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMarketplaceMutation, CreateMarketplaceMutationVariables>(CreateMarketplaceDocument, options);
      }
export type CreateMarketplaceMutationHookResult = ReturnType<typeof useCreateMarketplaceMutation>;
export type CreateMarketplaceMutationResult = Apollo.MutationResult<CreateMarketplaceMutation>;
export type CreateMarketplaceMutationOptions = Apollo.BaseMutationOptions<CreateMarketplaceMutation, CreateMarketplaceMutationVariables>;
export const CreateMedicationDocument = gql`
    mutation CreateMedication($input: CreateMedicationInput!) {
  createMedication(input: $input) {
    ...MedicationFields
  }
}
    ${MedicationFieldsFragmentDoc}`;
export type CreateMedicationMutationFn = Apollo.MutationFunction<CreateMedicationMutation, CreateMedicationMutationVariables>;

/**
 * __useCreateMedicationMutation__
 *
 * To run a mutation, you first call `useCreateMedicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMedicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMedicationMutation, { data, loading, error }] = useCreateMedicationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMedicationMutation(baseOptions?: Apollo.MutationHookOptions<CreateMedicationMutation, CreateMedicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMedicationMutation, CreateMedicationMutationVariables>(CreateMedicationDocument, options);
      }
export type CreateMedicationMutationHookResult = ReturnType<typeof useCreateMedicationMutation>;
export type CreateMedicationMutationResult = Apollo.MutationResult<CreateMedicationMutation>;
export type CreateMedicationMutationOptions = Apollo.BaseMutationOptions<CreateMedicationMutation, CreateMedicationMutationVariables>;
export const CreateMedicationStatementDocument = gql`
    mutation CreateMedicationStatement($input: CreateMedicationStatementInput!) {
  createMedicationStatement(input: $input) {
    ...MedicationStatementFields
  }
}
    ${MedicationStatementFieldsFragmentDoc}`;
export type CreateMedicationStatementMutationFn = Apollo.MutationFunction<CreateMedicationStatementMutation, CreateMedicationStatementMutationVariables>;

/**
 * __useCreateMedicationStatementMutation__
 *
 * To run a mutation, you first call `useCreateMedicationStatementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMedicationStatementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMedicationStatementMutation, { data, loading, error }] = useCreateMedicationStatementMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMedicationStatementMutation(baseOptions?: Apollo.MutationHookOptions<CreateMedicationStatementMutation, CreateMedicationStatementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMedicationStatementMutation, CreateMedicationStatementMutationVariables>(CreateMedicationStatementDocument, options);
      }
export type CreateMedicationStatementMutationHookResult = ReturnType<typeof useCreateMedicationStatementMutation>;
export type CreateMedicationStatementMutationResult = Apollo.MutationResult<CreateMedicationStatementMutation>;
export type CreateMedicationStatementMutationOptions = Apollo.BaseMutationOptions<CreateMedicationStatementMutation, CreateMedicationStatementMutationVariables>;
export const CreateMembershipDocument = gql`
    mutation CreateMembership($input: CreateMembershipInput!) {
  createMembership(input: $input) {
    ...MembershipFields
  }
}
    ${MembershipFieldsFragmentDoc}`;
export type CreateMembershipMutationFn = Apollo.MutationFunction<CreateMembershipMutation, CreateMembershipMutationVariables>;

/**
 * __useCreateMembershipMutation__
 *
 * To run a mutation, you first call `useCreateMembershipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMembershipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMembershipMutation, { data, loading, error }] = useCreateMembershipMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMembershipMutation(baseOptions?: Apollo.MutationHookOptions<CreateMembershipMutation, CreateMembershipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMembershipMutation, CreateMembershipMutationVariables>(CreateMembershipDocument, options);
      }
export type CreateMembershipMutationHookResult = ReturnType<typeof useCreateMembershipMutation>;
export type CreateMembershipMutationResult = Apollo.MutationResult<CreateMembershipMutation>;
export type CreateMembershipMutationOptions = Apollo.BaseMutationOptions<CreateMembershipMutation, CreateMembershipMutationVariables>;
export const CreateMembershipDefinitionDocument = gql`
    mutation CreateMembershipDefinition($input: CreateMembershipDefinitionInput!) {
  createMembershipDefinition(input: $input) {
    ...MembershipDefinitionFields
  }
}
    ${MembershipDefinitionFieldsFragmentDoc}`;
export type CreateMembershipDefinitionMutationFn = Apollo.MutationFunction<CreateMembershipDefinitionMutation, CreateMembershipDefinitionMutationVariables>;

/**
 * __useCreateMembershipDefinitionMutation__
 *
 * To run a mutation, you first call `useCreateMembershipDefinitionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMembershipDefinitionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMembershipDefinitionMutation, { data, loading, error }] = useCreateMembershipDefinitionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMembershipDefinitionMutation(baseOptions?: Apollo.MutationHookOptions<CreateMembershipDefinitionMutation, CreateMembershipDefinitionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMembershipDefinitionMutation, CreateMembershipDefinitionMutationVariables>(CreateMembershipDefinitionDocument, options);
      }
export type CreateMembershipDefinitionMutationHookResult = ReturnType<typeof useCreateMembershipDefinitionMutation>;
export type CreateMembershipDefinitionMutationResult = Apollo.MutationResult<CreateMembershipDefinitionMutation>;
export type CreateMembershipDefinitionMutationOptions = Apollo.BaseMutationOptions<CreateMembershipDefinitionMutation, CreateMembershipDefinitionMutationVariables>;
export const CreateObservationsDocument = gql`
    mutation CreateObservations($input: CreateObservationsInput!) {
  createObservations(input: $input) {
    ...RegularFormFields
  }
}
    ${RegularFormFieldsFragmentDoc}`;
export type CreateObservationsMutationFn = Apollo.MutationFunction<CreateObservationsMutation, CreateObservationsMutationVariables>;

/**
 * __useCreateObservationsMutation__
 *
 * To run a mutation, you first call `useCreateObservationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateObservationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createObservationsMutation, { data, loading, error }] = useCreateObservationsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateObservationsMutation(baseOptions?: Apollo.MutationHookOptions<CreateObservationsMutation, CreateObservationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateObservationsMutation, CreateObservationsMutationVariables>(CreateObservationsDocument, options);
      }
export type CreateObservationsMutationHookResult = ReturnType<typeof useCreateObservationsMutation>;
export type CreateObservationsMutationResult = Apollo.MutationResult<CreateObservationsMutation>;
export type CreateObservationsMutationOptions = Apollo.BaseMutationOptions<CreateObservationsMutation, CreateObservationsMutationVariables>;
export const CreateOrderDocument = gql`
    mutation CreateOrder($input: CreateOrderInput!) {
  createOrder(input: $input) {
    ...OrderFields
  }
}
    ${OrderFieldsFragmentDoc}`;
export type CreateOrderMutationFn = Apollo.MutationFunction<CreateOrderMutation, CreateOrderMutationVariables>;

/**
 * __useCreateOrderMutation__
 *
 * To run a mutation, you first call `useCreateOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrderMutation, { data, loading, error }] = useCreateOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrderMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrderMutation, CreateOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrderMutation, CreateOrderMutationVariables>(CreateOrderDocument, options);
      }
export type CreateOrderMutationHookResult = ReturnType<typeof useCreateOrderMutation>;
export type CreateOrderMutationResult = Apollo.MutationResult<CreateOrderMutation>;
export type CreateOrderMutationOptions = Apollo.BaseMutationOptions<CreateOrderMutation, CreateOrderMutationVariables>;
export const CreateOrganizationDocument = gql`
    mutation CreateOrganization($input: CreateOrganizationInput!) {
  createOrganization(input: $input) {
    ...OrganizationSettingsFields
  }
}
    ${OrganizationSettingsFieldsFragmentDoc}`;
export type CreateOrganizationMutationFn = Apollo.MutationFunction<CreateOrganizationMutation, CreateOrganizationMutationVariables>;

/**
 * __useCreateOrganizationMutation__
 *
 * To run a mutation, you first call `useCreateOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrganizationMutation, { data, loading, error }] = useCreateOrganizationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrganizationMutation, CreateOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrganizationMutation, CreateOrganizationMutationVariables>(CreateOrganizationDocument, options);
      }
export type CreateOrganizationMutationHookResult = ReturnType<typeof useCreateOrganizationMutation>;
export type CreateOrganizationMutationResult = Apollo.MutationResult<CreateOrganizationMutation>;
export type CreateOrganizationMutationOptions = Apollo.BaseMutationOptions<CreateOrganizationMutation, CreateOrganizationMutationVariables>;
export const CreatePackageDocument = gql`
    mutation CreatePackage($input: CreatePackageInput!) {
  createPackage(input: $input) {
    ...PackageFields
  }
}
    ${PackageFieldsFragmentDoc}`;
export type CreatePackageMutationFn = Apollo.MutationFunction<CreatePackageMutation, CreatePackageMutationVariables>;

/**
 * __useCreatePackageMutation__
 *
 * To run a mutation, you first call `useCreatePackageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePackageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPackageMutation, { data, loading, error }] = useCreatePackageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePackageMutation(baseOptions?: Apollo.MutationHookOptions<CreatePackageMutation, CreatePackageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePackageMutation, CreatePackageMutationVariables>(CreatePackageDocument, options);
      }
export type CreatePackageMutationHookResult = ReturnType<typeof useCreatePackageMutation>;
export type CreatePackageMutationResult = Apollo.MutationResult<CreatePackageMutation>;
export type CreatePackageMutationOptions = Apollo.BaseMutationOptions<CreatePackageMutation, CreatePackageMutationVariables>;
export const CreatePackageItemDefinitionDocument = gql`
    mutation CreatePackageItemDefinition($input: CreatePackageItemDefinitionInput!) {
  createPackageItemDefinition(input: $input) {
    ...PackageItemDefinitionFields
  }
}
    ${PackageItemDefinitionFieldsFragmentDoc}`;
export type CreatePackageItemDefinitionMutationFn = Apollo.MutationFunction<CreatePackageItemDefinitionMutation, CreatePackageItemDefinitionMutationVariables>;

/**
 * __useCreatePackageItemDefinitionMutation__
 *
 * To run a mutation, you first call `useCreatePackageItemDefinitionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePackageItemDefinitionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPackageItemDefinitionMutation, { data, loading, error }] = useCreatePackageItemDefinitionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePackageItemDefinitionMutation(baseOptions?: Apollo.MutationHookOptions<CreatePackageItemDefinitionMutation, CreatePackageItemDefinitionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePackageItemDefinitionMutation, CreatePackageItemDefinitionMutationVariables>(CreatePackageItemDefinitionDocument, options);
      }
export type CreatePackageItemDefinitionMutationHookResult = ReturnType<typeof useCreatePackageItemDefinitionMutation>;
export type CreatePackageItemDefinitionMutationResult = Apollo.MutationResult<CreatePackageItemDefinitionMutation>;
export type CreatePackageItemDefinitionMutationOptions = Apollo.BaseMutationOptions<CreatePackageItemDefinitionMutation, CreatePackageItemDefinitionMutationVariables>;
export const CreatePaymentAccountDocument = gql`
    mutation CreatePaymentAccount($input: CreatePaymentAccountInput!) {
  createPaymentAccount(input: $input) {
    ...PaymentAccountFields
  }
}
    ${PaymentAccountFieldsFragmentDoc}`;
export type CreatePaymentAccountMutationFn = Apollo.MutationFunction<CreatePaymentAccountMutation, CreatePaymentAccountMutationVariables>;

/**
 * __useCreatePaymentAccountMutation__
 *
 * To run a mutation, you first call `useCreatePaymentAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePaymentAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPaymentAccountMutation, { data, loading, error }] = useCreatePaymentAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePaymentAccountMutation(baseOptions?: Apollo.MutationHookOptions<CreatePaymentAccountMutation, CreatePaymentAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePaymentAccountMutation, CreatePaymentAccountMutationVariables>(CreatePaymentAccountDocument, options);
      }
export type CreatePaymentAccountMutationHookResult = ReturnType<typeof useCreatePaymentAccountMutation>;
export type CreatePaymentAccountMutationResult = Apollo.MutationResult<CreatePaymentAccountMutation>;
export type CreatePaymentAccountMutationOptions = Apollo.BaseMutationOptions<CreatePaymentAccountMutation, CreatePaymentAccountMutationVariables>;
export const CreatePaymentInstrumentDocument = gql`
    mutation CreatePaymentInstrument($input: PaymentMethodInput!) {
  createPaymentInstrument(input: $input) {
    ...PaymentInstrumentFields
  }
}
    ${PaymentInstrumentFieldsFragmentDoc}`;
export type CreatePaymentInstrumentMutationFn = Apollo.MutationFunction<CreatePaymentInstrumentMutation, CreatePaymentInstrumentMutationVariables>;

/**
 * __useCreatePaymentInstrumentMutation__
 *
 * To run a mutation, you first call `useCreatePaymentInstrumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePaymentInstrumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPaymentInstrumentMutation, { data, loading, error }] = useCreatePaymentInstrumentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePaymentInstrumentMutation(baseOptions?: Apollo.MutationHookOptions<CreatePaymentInstrumentMutation, CreatePaymentInstrumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePaymentInstrumentMutation, CreatePaymentInstrumentMutationVariables>(CreatePaymentInstrumentDocument, options);
      }
export type CreatePaymentInstrumentMutationHookResult = ReturnType<typeof useCreatePaymentInstrumentMutation>;
export type CreatePaymentInstrumentMutationResult = Apollo.MutationResult<CreatePaymentInstrumentMutation>;
export type CreatePaymentInstrumentMutationOptions = Apollo.BaseMutationOptions<CreatePaymentInstrumentMutation, CreatePaymentInstrumentMutationVariables>;
export const CreateProcedureBaseDefGroupDocument = gql`
    mutation CreateProcedureBaseDefGroup($input: CreateProcedureBaseDefinitionGroupInput!) {
  createProcedureBaseDefinitionGroup(input: $input) {
    ...ProcedureBaseDefGroupFields
  }
}
    ${ProcedureBaseDefGroupFieldsFragmentDoc}`;
export type CreateProcedureBaseDefGroupMutationFn = Apollo.MutationFunction<CreateProcedureBaseDefGroupMutation, CreateProcedureBaseDefGroupMutationVariables>;

/**
 * __useCreateProcedureBaseDefGroupMutation__
 *
 * To run a mutation, you first call `useCreateProcedureBaseDefGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProcedureBaseDefGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProcedureBaseDefGroupMutation, { data, loading, error }] = useCreateProcedureBaseDefGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProcedureBaseDefGroupMutation(baseOptions?: Apollo.MutationHookOptions<CreateProcedureBaseDefGroupMutation, CreateProcedureBaseDefGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProcedureBaseDefGroupMutation, CreateProcedureBaseDefGroupMutationVariables>(CreateProcedureBaseDefGroupDocument, options);
      }
export type CreateProcedureBaseDefGroupMutationHookResult = ReturnType<typeof useCreateProcedureBaseDefGroupMutation>;
export type CreateProcedureBaseDefGroupMutationResult = Apollo.MutationResult<CreateProcedureBaseDefGroupMutation>;
export type CreateProcedureBaseDefGroupMutationOptions = Apollo.BaseMutationOptions<CreateProcedureBaseDefGroupMutation, CreateProcedureBaseDefGroupMutationVariables>;
export const CreateProcedureBaseDefinitionDocument = gql`
    mutation CreateProcedureBaseDefinition($input: CreateProcedureBaseDefinitionInput!) {
  createProcedureBaseDefinition(input: $input) {
    ...FullProcedureBaseDefFields
  }
}
    ${FullProcedureBaseDefFieldsFragmentDoc}`;
export type CreateProcedureBaseDefinitionMutationFn = Apollo.MutationFunction<CreateProcedureBaseDefinitionMutation, CreateProcedureBaseDefinitionMutationVariables>;

/**
 * __useCreateProcedureBaseDefinitionMutation__
 *
 * To run a mutation, you first call `useCreateProcedureBaseDefinitionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProcedureBaseDefinitionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProcedureBaseDefinitionMutation, { data, loading, error }] = useCreateProcedureBaseDefinitionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProcedureBaseDefinitionMutation(baseOptions?: Apollo.MutationHookOptions<CreateProcedureBaseDefinitionMutation, CreateProcedureBaseDefinitionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProcedureBaseDefinitionMutation, CreateProcedureBaseDefinitionMutationVariables>(CreateProcedureBaseDefinitionDocument, options);
      }
export type CreateProcedureBaseDefinitionMutationHookResult = ReturnType<typeof useCreateProcedureBaseDefinitionMutation>;
export type CreateProcedureBaseDefinitionMutationResult = Apollo.MutationResult<CreateProcedureBaseDefinitionMutation>;
export type CreateProcedureBaseDefinitionMutationOptions = Apollo.BaseMutationOptions<CreateProcedureBaseDefinitionMutation, CreateProcedureBaseDefinitionMutationVariables>;
export const CreateProcedureBaseDefinitionTagDocument = gql`
    mutation CreateProcedureBaseDefinitionTag($input: ProcedureBaseDefinitionTagInput!) {
  createProcedureBaseDefinitionTag(input: $input) {
    ...ProcedureBaseDefFields
  }
}
    ${ProcedureBaseDefFieldsFragmentDoc}`;
export type CreateProcedureBaseDefinitionTagMutationFn = Apollo.MutationFunction<CreateProcedureBaseDefinitionTagMutation, CreateProcedureBaseDefinitionTagMutationVariables>;

/**
 * __useCreateProcedureBaseDefinitionTagMutation__
 *
 * To run a mutation, you first call `useCreateProcedureBaseDefinitionTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProcedureBaseDefinitionTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProcedureBaseDefinitionTagMutation, { data, loading, error }] = useCreateProcedureBaseDefinitionTagMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProcedureBaseDefinitionTagMutation(baseOptions?: Apollo.MutationHookOptions<CreateProcedureBaseDefinitionTagMutation, CreateProcedureBaseDefinitionTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProcedureBaseDefinitionTagMutation, CreateProcedureBaseDefinitionTagMutationVariables>(CreateProcedureBaseDefinitionTagDocument, options);
      }
export type CreateProcedureBaseDefinitionTagMutationHookResult = ReturnType<typeof useCreateProcedureBaseDefinitionTagMutation>;
export type CreateProcedureBaseDefinitionTagMutationResult = Apollo.MutationResult<CreateProcedureBaseDefinitionTagMutation>;
export type CreateProcedureBaseDefinitionTagMutationOptions = Apollo.BaseMutationOptions<CreateProcedureBaseDefinitionTagMutation, CreateProcedureBaseDefinitionTagMutationVariables>;
export const CreateProcedureDefinitionDocument = gql`
    mutation CreateProcedureDefinition($input: CreateProcedureDefinitionInput!) {
  createProcedureDefinition(input: $input) {
    ...ProcedureDefFields
  }
}
    ${ProcedureDefFieldsFragmentDoc}`;
export type CreateProcedureDefinitionMutationFn = Apollo.MutationFunction<CreateProcedureDefinitionMutation, CreateProcedureDefinitionMutationVariables>;

/**
 * __useCreateProcedureDefinitionMutation__
 *
 * To run a mutation, you first call `useCreateProcedureDefinitionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProcedureDefinitionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProcedureDefinitionMutation, { data, loading, error }] = useCreateProcedureDefinitionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProcedureDefinitionMutation(baseOptions?: Apollo.MutationHookOptions<CreateProcedureDefinitionMutation, CreateProcedureDefinitionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProcedureDefinitionMutation, CreateProcedureDefinitionMutationVariables>(CreateProcedureDefinitionDocument, options);
      }
export type CreateProcedureDefinitionMutationHookResult = ReturnType<typeof useCreateProcedureDefinitionMutation>;
export type CreateProcedureDefinitionMutationResult = Apollo.MutationResult<CreateProcedureDefinitionMutation>;
export type CreateProcedureDefinitionMutationOptions = Apollo.BaseMutationOptions<CreateProcedureDefinitionMutation, CreateProcedureDefinitionMutationVariables>;
export const CreateProcedureProfileDocument = gql`
    mutation CreateProcedureProfile($input: CreateProcedureProfileInput!) {
  createProcedureProfile(input: $input) {
    ...ProcedureProfileFields
    procedureDefs {
      ...ProcedureDefFields
      baseDefinitions {
        ...ProcedureBaseDefFields
      }
    }
  }
}
    ${ProcedureProfileFieldsFragmentDoc}
${ProcedureDefFieldsFragmentDoc}
${ProcedureBaseDefFieldsFragmentDoc}`;
export type CreateProcedureProfileMutationFn = Apollo.MutationFunction<CreateProcedureProfileMutation, CreateProcedureProfileMutationVariables>;

/**
 * __useCreateProcedureProfileMutation__
 *
 * To run a mutation, you first call `useCreateProcedureProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProcedureProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProcedureProfileMutation, { data, loading, error }] = useCreateProcedureProfileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProcedureProfileMutation(baseOptions?: Apollo.MutationHookOptions<CreateProcedureProfileMutation, CreateProcedureProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProcedureProfileMutation, CreateProcedureProfileMutationVariables>(CreateProcedureProfileDocument, options);
      }
export type CreateProcedureProfileMutationHookResult = ReturnType<typeof useCreateProcedureProfileMutation>;
export type CreateProcedureProfileMutationResult = Apollo.MutationResult<CreateProcedureProfileMutation>;
export type CreateProcedureProfileMutationOptions = Apollo.BaseMutationOptions<CreateProcedureProfileMutation, CreateProcedureProfileMutationVariables>;
export const CreateProfileDocument = gql`
    mutation CreateProfile($input: CreateProfileInput!) {
  createProfile(input: $input) {
    ...FullProfile
  }
}
    ${FullProfileFragmentDoc}`;
export type CreateProfileMutationFn = Apollo.MutationFunction<CreateProfileMutation, CreateProfileMutationVariables>;

/**
 * __useCreateProfileMutation__
 *
 * To run a mutation, you first call `useCreateProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProfileMutation, { data, loading, error }] = useCreateProfileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProfileMutation(baseOptions?: Apollo.MutationHookOptions<CreateProfileMutation, CreateProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProfileMutation, CreateProfileMutationVariables>(CreateProfileDocument, options);
      }
export type CreateProfileMutationHookResult = ReturnType<typeof useCreateProfileMutation>;
export type CreateProfileMutationResult = Apollo.MutationResult<CreateProfileMutation>;
export type CreateProfileMutationOptions = Apollo.BaseMutationOptions<CreateProfileMutation, CreateProfileMutationVariables>;
export const CreatePromoCodeDocument = gql`
    mutation CreatePromoCode($input: CreatePromoCodeInput!) {
  createPromoCode(input: $input) {
    ...PromoCodeFields
  }
}
    ${PromoCodeFieldsFragmentDoc}`;
export type CreatePromoCodeMutationFn = Apollo.MutationFunction<CreatePromoCodeMutation, CreatePromoCodeMutationVariables>;

/**
 * __useCreatePromoCodeMutation__
 *
 * To run a mutation, you first call `useCreatePromoCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePromoCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPromoCodeMutation, { data, loading, error }] = useCreatePromoCodeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePromoCodeMutation(baseOptions?: Apollo.MutationHookOptions<CreatePromoCodeMutation, CreatePromoCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePromoCodeMutation, CreatePromoCodeMutationVariables>(CreatePromoCodeDocument, options);
      }
export type CreatePromoCodeMutationHookResult = ReturnType<typeof useCreatePromoCodeMutation>;
export type CreatePromoCodeMutationResult = Apollo.MutationResult<CreatePromoCodeMutation>;
export type CreatePromoCodeMutationOptions = Apollo.BaseMutationOptions<CreatePromoCodeMutation, CreatePromoCodeMutationVariables>;
export const CreateReachIntegrationDocument = gql`
    mutation CreateReachIntegration($input: CreateReachIntegrationInput!) {
  createReachIntegration(input: $input) {
    id
    marketplaceId
    reachId
  }
}
    `;
export type CreateReachIntegrationMutationFn = Apollo.MutationFunction<CreateReachIntegrationMutation, CreateReachIntegrationMutationVariables>;

/**
 * __useCreateReachIntegrationMutation__
 *
 * To run a mutation, you first call `useCreateReachIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReachIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReachIntegrationMutation, { data, loading, error }] = useCreateReachIntegrationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateReachIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<CreateReachIntegrationMutation, CreateReachIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateReachIntegrationMutation, CreateReachIntegrationMutationVariables>(CreateReachIntegrationDocument, options);
      }
export type CreateReachIntegrationMutationHookResult = ReturnType<typeof useCreateReachIntegrationMutation>;
export type CreateReachIntegrationMutationResult = Apollo.MutationResult<CreateReachIntegrationMutation>;
export type CreateReachIntegrationMutationOptions = Apollo.BaseMutationOptions<CreateReachIntegrationMutation, CreateReachIntegrationMutationVariables>;
export const CreateRoleDocument = gql`
    mutation CreateRole($input: CreateRoleInput!) {
  createRole(input: $input) {
    ...RoleFields
  }
}
    ${RoleFieldsFragmentDoc}`;
export type CreateRoleMutationFn = Apollo.MutationFunction<CreateRoleMutation, CreateRoleMutationVariables>;

/**
 * __useCreateRoleMutation__
 *
 * To run a mutation, you first call `useCreateRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRoleMutation, { data, loading, error }] = useCreateRoleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateRoleMutation(baseOptions?: Apollo.MutationHookOptions<CreateRoleMutation, CreateRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRoleMutation, CreateRoleMutationVariables>(CreateRoleDocument, options);
      }
export type CreateRoleMutationHookResult = ReturnType<typeof useCreateRoleMutation>;
export type CreateRoleMutationResult = Apollo.MutationResult<CreateRoleMutation>;
export type CreateRoleMutationOptions = Apollo.BaseMutationOptions<CreateRoleMutation, CreateRoleMutationVariables>;
export const CreateUploadUrlDocument = gql`
    mutation CreateUploadUrl($input: CreateUploadUrlInput!) {
  createUploadUrl(input: $input) {
    token
    url
    fields
  }
}
    `;
export type CreateUploadUrlMutationFn = Apollo.MutationFunction<CreateUploadUrlMutation, CreateUploadUrlMutationVariables>;

/**
 * __useCreateUploadUrlMutation__
 *
 * To run a mutation, you first call `useCreateUploadUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUploadUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUploadUrlMutation, { data, loading, error }] = useCreateUploadUrlMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUploadUrlMutation(baseOptions?: Apollo.MutationHookOptions<CreateUploadUrlMutation, CreateUploadUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUploadUrlMutation, CreateUploadUrlMutationVariables>(CreateUploadUrlDocument, options);
      }
export type CreateUploadUrlMutationHookResult = ReturnType<typeof useCreateUploadUrlMutation>;
export type CreateUploadUrlMutationResult = Apollo.MutationResult<CreateUploadUrlMutation>;
export type CreateUploadUrlMutationOptions = Apollo.BaseMutationOptions<CreateUploadUrlMutation, CreateUploadUrlMutationVariables>;
export const CreateVitalsDocument = gql`
    mutation CreateVitals($input: CreateVitalsInput!) {
  createVitals(input: $input) {
    ...PatientFields
  }
}
    ${PatientFieldsFragmentDoc}`;
export type CreateVitalsMutationFn = Apollo.MutationFunction<CreateVitalsMutation, CreateVitalsMutationVariables>;

/**
 * __useCreateVitalsMutation__
 *
 * To run a mutation, you first call `useCreateVitalsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateVitalsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createVitalsMutation, { data, loading, error }] = useCreateVitalsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateVitalsMutation(baseOptions?: Apollo.MutationHookOptions<CreateVitalsMutation, CreateVitalsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateVitalsMutation, CreateVitalsMutationVariables>(CreateVitalsDocument, options);
      }
export type CreateVitalsMutationHookResult = ReturnType<typeof useCreateVitalsMutation>;
export type CreateVitalsMutationResult = Apollo.MutationResult<CreateVitalsMutation>;
export type CreateVitalsMutationOptions = Apollo.BaseMutationOptions<CreateVitalsMutation, CreateVitalsMutationVariables>;
export const DeactivatePaymentLinkDocument = gql`
    mutation DeactivatePaymentLink($input: DeactivatePaymentLinkInput!) {
  deactivatePaymentLink(input: $input) {
    ...CheckoutWithAppointmentFields
  }
}
    ${CheckoutWithAppointmentFieldsFragmentDoc}`;
export type DeactivatePaymentLinkMutationFn = Apollo.MutationFunction<DeactivatePaymentLinkMutation, DeactivatePaymentLinkMutationVariables>;

/**
 * __useDeactivatePaymentLinkMutation__
 *
 * To run a mutation, you first call `useDeactivatePaymentLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivatePaymentLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivatePaymentLinkMutation, { data, loading, error }] = useDeactivatePaymentLinkMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeactivatePaymentLinkMutation(baseOptions?: Apollo.MutationHookOptions<DeactivatePaymentLinkMutation, DeactivatePaymentLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeactivatePaymentLinkMutation, DeactivatePaymentLinkMutationVariables>(DeactivatePaymentLinkDocument, options);
      }
export type DeactivatePaymentLinkMutationHookResult = ReturnType<typeof useDeactivatePaymentLinkMutation>;
export type DeactivatePaymentLinkMutationResult = Apollo.MutationResult<DeactivatePaymentLinkMutation>;
export type DeactivatePaymentLinkMutationOptions = Apollo.BaseMutationOptions<DeactivatePaymentLinkMutation, DeactivatePaymentLinkMutationVariables>;
export const DeclineAppointmentDocument = gql`
    mutation DeclineAppointment($input: DeclineAppointmentInput!) {
  declineAppointment(input: $input) {
    ...FullAppointmentFields
  }
}
    ${FullAppointmentFieldsFragmentDoc}`;
export type DeclineAppointmentMutationFn = Apollo.MutationFunction<DeclineAppointmentMutation, DeclineAppointmentMutationVariables>;

/**
 * __useDeclineAppointmentMutation__
 *
 * To run a mutation, you first call `useDeclineAppointmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeclineAppointmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [declineAppointmentMutation, { data, loading, error }] = useDeclineAppointmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeclineAppointmentMutation(baseOptions?: Apollo.MutationHookOptions<DeclineAppointmentMutation, DeclineAppointmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeclineAppointmentMutation, DeclineAppointmentMutationVariables>(DeclineAppointmentDocument, options);
      }
export type DeclineAppointmentMutationHookResult = ReturnType<typeof useDeclineAppointmentMutation>;
export type DeclineAppointmentMutationResult = Apollo.MutationResult<DeclineAppointmentMutation>;
export type DeclineAppointmentMutationOptions = Apollo.BaseMutationOptions<DeclineAppointmentMutation, DeclineAppointmentMutationVariables>;
export const DeleteAllergyIntoleranceDocument = gql`
    mutation DeleteAllergyIntolerance($id: ID!) {
  deleteAllergyIntolerance(id: $id) {
    ...PatientFields
  }
}
    ${PatientFieldsFragmentDoc}`;
export type DeleteAllergyIntoleranceMutationFn = Apollo.MutationFunction<DeleteAllergyIntoleranceMutation, DeleteAllergyIntoleranceMutationVariables>;

/**
 * __useDeleteAllergyIntoleranceMutation__
 *
 * To run a mutation, you first call `useDeleteAllergyIntoleranceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAllergyIntoleranceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAllergyIntoleranceMutation, { data, loading, error }] = useDeleteAllergyIntoleranceMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAllergyIntoleranceMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAllergyIntoleranceMutation, DeleteAllergyIntoleranceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAllergyIntoleranceMutation, DeleteAllergyIntoleranceMutationVariables>(DeleteAllergyIntoleranceDocument, options);
      }
export type DeleteAllergyIntoleranceMutationHookResult = ReturnType<typeof useDeleteAllergyIntoleranceMutation>;
export type DeleteAllergyIntoleranceMutationResult = Apollo.MutationResult<DeleteAllergyIntoleranceMutation>;
export type DeleteAllergyIntoleranceMutationOptions = Apollo.BaseMutationOptions<DeleteAllergyIntoleranceMutation, DeleteAllergyIntoleranceMutationVariables>;
export const DeleteAvailabilityDocument = gql`
    mutation DeleteAvailability($id: ID!) {
  deleteAvailability(id: $id)
}
    `;
export type DeleteAvailabilityMutationFn = Apollo.MutationFunction<DeleteAvailabilityMutation, DeleteAvailabilityMutationVariables>;

/**
 * __useDeleteAvailabilityMutation__
 *
 * To run a mutation, you first call `useDeleteAvailabilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAvailabilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAvailabilityMutation, { data, loading, error }] = useDeleteAvailabilityMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAvailabilityMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAvailabilityMutation, DeleteAvailabilityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAvailabilityMutation, DeleteAvailabilityMutationVariables>(DeleteAvailabilityDocument, options);
      }
export type DeleteAvailabilityMutationHookResult = ReturnType<typeof useDeleteAvailabilityMutation>;
export type DeleteAvailabilityMutationResult = Apollo.MutationResult<DeleteAvailabilityMutation>;
export type DeleteAvailabilityMutationOptions = Apollo.BaseMutationOptions<DeleteAvailabilityMutation, DeleteAvailabilityMutationVariables>;
export const DeleteAvailabilityCoverageDocument = gql`
    mutation DeleteAvailabilityCoverage($id: ID!) {
  deleteAvailabilityCoverage(id: $id)
}
    `;
export type DeleteAvailabilityCoverageMutationFn = Apollo.MutationFunction<DeleteAvailabilityCoverageMutation, DeleteAvailabilityCoverageMutationVariables>;

/**
 * __useDeleteAvailabilityCoverageMutation__
 *
 * To run a mutation, you first call `useDeleteAvailabilityCoverageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAvailabilityCoverageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAvailabilityCoverageMutation, { data, loading, error }] = useDeleteAvailabilityCoverageMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAvailabilityCoverageMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAvailabilityCoverageMutation, DeleteAvailabilityCoverageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAvailabilityCoverageMutation, DeleteAvailabilityCoverageMutationVariables>(DeleteAvailabilityCoverageDocument, options);
      }
export type DeleteAvailabilityCoverageMutationHookResult = ReturnType<typeof useDeleteAvailabilityCoverageMutation>;
export type DeleteAvailabilityCoverageMutationResult = Apollo.MutationResult<DeleteAvailabilityCoverageMutation>;
export type DeleteAvailabilityCoverageMutationOptions = Apollo.BaseMutationOptions<DeleteAvailabilityCoverageMutation, DeleteAvailabilityCoverageMutationVariables>;
export const DeleteClinicalProcedureDocument = gql`
    mutation DeleteClinicalProcedure($id: ID!) {
  deleteClinicalProcedure(id: $id) {
    ...PatientFields
  }
}
    ${PatientFieldsFragmentDoc}`;
export type DeleteClinicalProcedureMutationFn = Apollo.MutationFunction<DeleteClinicalProcedureMutation, DeleteClinicalProcedureMutationVariables>;

/**
 * __useDeleteClinicalProcedureMutation__
 *
 * To run a mutation, you first call `useDeleteClinicalProcedureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteClinicalProcedureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteClinicalProcedureMutation, { data, loading, error }] = useDeleteClinicalProcedureMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteClinicalProcedureMutation(baseOptions?: Apollo.MutationHookOptions<DeleteClinicalProcedureMutation, DeleteClinicalProcedureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteClinicalProcedureMutation, DeleteClinicalProcedureMutationVariables>(DeleteClinicalProcedureDocument, options);
      }
export type DeleteClinicalProcedureMutationHookResult = ReturnType<typeof useDeleteClinicalProcedureMutation>;
export type DeleteClinicalProcedureMutationResult = Apollo.MutationResult<DeleteClinicalProcedureMutation>;
export type DeleteClinicalProcedureMutationOptions = Apollo.BaseMutationOptions<DeleteClinicalProcedureMutation, DeleteClinicalProcedureMutationVariables>;
export const DeleteConditionDocument = gql`
    mutation DeleteCondition($id: ID!) {
  deleteCondition(id: $id) {
    ...PatientFields
  }
}
    ${PatientFieldsFragmentDoc}`;
export type DeleteConditionMutationFn = Apollo.MutationFunction<DeleteConditionMutation, DeleteConditionMutationVariables>;

/**
 * __useDeleteConditionMutation__
 *
 * To run a mutation, you first call `useDeleteConditionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteConditionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteConditionMutation, { data, loading, error }] = useDeleteConditionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteConditionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteConditionMutation, DeleteConditionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteConditionMutation, DeleteConditionMutationVariables>(DeleteConditionDocument, options);
      }
export type DeleteConditionMutationHookResult = ReturnType<typeof useDeleteConditionMutation>;
export type DeleteConditionMutationResult = Apollo.MutationResult<DeleteConditionMutation>;
export type DeleteConditionMutationOptions = Apollo.BaseMutationOptions<DeleteConditionMutation, DeleteConditionMutationVariables>;
export const DeleteFormTemplateDocument = gql`
    mutation DeleteFormTemplate($id: ID!) {
  deleteFormTemplate(id: $id)
}
    `;
export type DeleteFormTemplateMutationFn = Apollo.MutationFunction<DeleteFormTemplateMutation, DeleteFormTemplateMutationVariables>;

/**
 * __useDeleteFormTemplateMutation__
 *
 * To run a mutation, you first call `useDeleteFormTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFormTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFormTemplateMutation, { data, loading, error }] = useDeleteFormTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteFormTemplateMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFormTemplateMutation, DeleteFormTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteFormTemplateMutation, DeleteFormTemplateMutationVariables>(DeleteFormTemplateDocument, options);
      }
export type DeleteFormTemplateMutationHookResult = ReturnType<typeof useDeleteFormTemplateMutation>;
export type DeleteFormTemplateMutationResult = Apollo.MutationResult<DeleteFormTemplateMutation>;
export type DeleteFormTemplateMutationOptions = Apollo.BaseMutationOptions<DeleteFormTemplateMutation, DeleteFormTemplateMutationVariables>;
export const DeleteGeoperimeterDocument = gql`
    mutation DeleteGeoperimeter($id: ID!) {
  deleteGeoperimeter(id: $id)
}
    `;
export type DeleteGeoperimeterMutationFn = Apollo.MutationFunction<DeleteGeoperimeterMutation, DeleteGeoperimeterMutationVariables>;

/**
 * __useDeleteGeoperimeterMutation__
 *
 * To run a mutation, you first call `useDeleteGeoperimeterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteGeoperimeterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteGeoperimeterMutation, { data, loading, error }] = useDeleteGeoperimeterMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteGeoperimeterMutation(baseOptions?: Apollo.MutationHookOptions<DeleteGeoperimeterMutation, DeleteGeoperimeterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteGeoperimeterMutation, DeleteGeoperimeterMutationVariables>(DeleteGeoperimeterDocument, options);
      }
export type DeleteGeoperimeterMutationHookResult = ReturnType<typeof useDeleteGeoperimeterMutation>;
export type DeleteGeoperimeterMutationResult = Apollo.MutationResult<DeleteGeoperimeterMutation>;
export type DeleteGeoperimeterMutationOptions = Apollo.BaseMutationOptions<DeleteGeoperimeterMutation, DeleteGeoperimeterMutationVariables>;
export const DeleteImmunizationDocument = gql`
    mutation DeleteImmunization($id: ID!) {
  deleteImmunization(id: $id) {
    ...PatientFields
  }
}
    ${PatientFieldsFragmentDoc}`;
export type DeleteImmunizationMutationFn = Apollo.MutationFunction<DeleteImmunizationMutation, DeleteImmunizationMutationVariables>;

/**
 * __useDeleteImmunizationMutation__
 *
 * To run a mutation, you first call `useDeleteImmunizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteImmunizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteImmunizationMutation, { data, loading, error }] = useDeleteImmunizationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteImmunizationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteImmunizationMutation, DeleteImmunizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteImmunizationMutation, DeleteImmunizationMutationVariables>(DeleteImmunizationDocument, options);
      }
export type DeleteImmunizationMutationHookResult = ReturnType<typeof useDeleteImmunizationMutation>;
export type DeleteImmunizationMutationResult = Apollo.MutationResult<DeleteImmunizationMutation>;
export type DeleteImmunizationMutationOptions = Apollo.BaseMutationOptions<DeleteImmunizationMutation, DeleteImmunizationMutationVariables>;
export const DeleteLabDocument = gql`
    mutation DeleteLab($id: ID!) {
  deleteLab(id: $id) {
    ...PatientFields
  }
}
    ${PatientFieldsFragmentDoc}`;
export type DeleteLabMutationFn = Apollo.MutationFunction<DeleteLabMutation, DeleteLabMutationVariables>;

/**
 * __useDeleteLabMutation__
 *
 * To run a mutation, you first call `useDeleteLabMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLabMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLabMutation, { data, loading, error }] = useDeleteLabMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteLabMutation(baseOptions?: Apollo.MutationHookOptions<DeleteLabMutation, DeleteLabMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteLabMutation, DeleteLabMutationVariables>(DeleteLabDocument, options);
      }
export type DeleteLabMutationHookResult = ReturnType<typeof useDeleteLabMutation>;
export type DeleteLabMutationResult = Apollo.MutationResult<DeleteLabMutation>;
export type DeleteLabMutationOptions = Apollo.BaseMutationOptions<DeleteLabMutation, DeleteLabMutationVariables>;
export const DeleteMedicationDocument = gql`
    mutation DeleteMedication($id: ID!) {
  deleteMedication(id: $id)
}
    `;
export type DeleteMedicationMutationFn = Apollo.MutationFunction<DeleteMedicationMutation, DeleteMedicationMutationVariables>;

/**
 * __useDeleteMedicationMutation__
 *
 * To run a mutation, you first call `useDeleteMedicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMedicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMedicationMutation, { data, loading, error }] = useDeleteMedicationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteMedicationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMedicationMutation, DeleteMedicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMedicationMutation, DeleteMedicationMutationVariables>(DeleteMedicationDocument, options);
      }
export type DeleteMedicationMutationHookResult = ReturnType<typeof useDeleteMedicationMutation>;
export type DeleteMedicationMutationResult = Apollo.MutationResult<DeleteMedicationMutation>;
export type DeleteMedicationMutationOptions = Apollo.BaseMutationOptions<DeleteMedicationMutation, DeleteMedicationMutationVariables>;
export const DeleteMedicationStatementDocument = gql`
    mutation DeleteMedicationStatement($id: ID!) {
  deleteMedicationStatement(id: $id) {
    ...PatientFields
  }
}
    ${PatientFieldsFragmentDoc}`;
export type DeleteMedicationStatementMutationFn = Apollo.MutationFunction<DeleteMedicationStatementMutation, DeleteMedicationStatementMutationVariables>;

/**
 * __useDeleteMedicationStatementMutation__
 *
 * To run a mutation, you first call `useDeleteMedicationStatementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMedicationStatementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMedicationStatementMutation, { data, loading, error }] = useDeleteMedicationStatementMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteMedicationStatementMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMedicationStatementMutation, DeleteMedicationStatementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMedicationStatementMutation, DeleteMedicationStatementMutationVariables>(DeleteMedicationStatementDocument, options);
      }
export type DeleteMedicationStatementMutationHookResult = ReturnType<typeof useDeleteMedicationStatementMutation>;
export type DeleteMedicationStatementMutationResult = Apollo.MutationResult<DeleteMedicationStatementMutation>;
export type DeleteMedicationStatementMutationOptions = Apollo.BaseMutationOptions<DeleteMedicationStatementMutation, DeleteMedicationStatementMutationVariables>;
export const DeleteMembershipDocument = gql`
    mutation DeleteMembership($id: ID!) {
  deleteMembership(id: $id)
}
    `;
export type DeleteMembershipMutationFn = Apollo.MutationFunction<DeleteMembershipMutation, DeleteMembershipMutationVariables>;

/**
 * __useDeleteMembershipMutation__
 *
 * To run a mutation, you first call `useDeleteMembershipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMembershipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMembershipMutation, { data, loading, error }] = useDeleteMembershipMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteMembershipMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMembershipMutation, DeleteMembershipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMembershipMutation, DeleteMembershipMutationVariables>(DeleteMembershipDocument, options);
      }
export type DeleteMembershipMutationHookResult = ReturnType<typeof useDeleteMembershipMutation>;
export type DeleteMembershipMutationResult = Apollo.MutationResult<DeleteMembershipMutation>;
export type DeleteMembershipMutationOptions = Apollo.BaseMutationOptions<DeleteMembershipMutation, DeleteMembershipMutationVariables>;
export const DeleteOrderDocument = gql`
    mutation DeleteOrder($id: ID!) {
  deleteOrder(id: $id)
}
    `;
export type DeleteOrderMutationFn = Apollo.MutationFunction<DeleteOrderMutation, DeleteOrderMutationVariables>;

/**
 * __useDeleteOrderMutation__
 *
 * To run a mutation, you first call `useDeleteOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrderMutation, { data, loading, error }] = useDeleteOrderMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteOrderMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOrderMutation, DeleteOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOrderMutation, DeleteOrderMutationVariables>(DeleteOrderDocument, options);
      }
export type DeleteOrderMutationHookResult = ReturnType<typeof useDeleteOrderMutation>;
export type DeleteOrderMutationResult = Apollo.MutationResult<DeleteOrderMutation>;
export type DeleteOrderMutationOptions = Apollo.BaseMutationOptions<DeleteOrderMutation, DeleteOrderMutationVariables>;
export const DeletePackageItemDocument = gql`
    mutation DeletePackageItem($id: ID!) {
  deletePackageItem(id: $id)
}
    `;
export type DeletePackageItemMutationFn = Apollo.MutationFunction<DeletePackageItemMutation, DeletePackageItemMutationVariables>;

/**
 * __useDeletePackageItemMutation__
 *
 * To run a mutation, you first call `useDeletePackageItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePackageItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePackageItemMutation, { data, loading, error }] = useDeletePackageItemMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeletePackageItemMutation(baseOptions?: Apollo.MutationHookOptions<DeletePackageItemMutation, DeletePackageItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePackageItemMutation, DeletePackageItemMutationVariables>(DeletePackageItemDocument, options);
      }
export type DeletePackageItemMutationHookResult = ReturnType<typeof useDeletePackageItemMutation>;
export type DeletePackageItemMutationResult = Apollo.MutationResult<DeletePackageItemMutation>;
export type DeletePackageItemMutationOptions = Apollo.BaseMutationOptions<DeletePackageItemMutation, DeletePackageItemMutationVariables>;
export const DeletePaymentInstrumentDocument = gql`
    mutation DeletePaymentInstrument($id: ID!) {
  deletePaymentInstrument(id: $id)
}
    `;
export type DeletePaymentInstrumentMutationFn = Apollo.MutationFunction<DeletePaymentInstrumentMutation, DeletePaymentInstrumentMutationVariables>;

/**
 * __useDeletePaymentInstrumentMutation__
 *
 * To run a mutation, you first call `useDeletePaymentInstrumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePaymentInstrumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePaymentInstrumentMutation, { data, loading, error }] = useDeletePaymentInstrumentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeletePaymentInstrumentMutation(baseOptions?: Apollo.MutationHookOptions<DeletePaymentInstrumentMutation, DeletePaymentInstrumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePaymentInstrumentMutation, DeletePaymentInstrumentMutationVariables>(DeletePaymentInstrumentDocument, options);
      }
export type DeletePaymentInstrumentMutationHookResult = ReturnType<typeof useDeletePaymentInstrumentMutation>;
export type DeletePaymentInstrumentMutationResult = Apollo.MutationResult<DeletePaymentInstrumentMutation>;
export type DeletePaymentInstrumentMutationOptions = Apollo.BaseMutationOptions<DeletePaymentInstrumentMutation, DeletePaymentInstrumentMutationVariables>;
export const DeleteProcedureBaseDefGroupDocument = gql`
    mutation DeleteProcedureBaseDefGroup($id: ID!) {
  deleteProcedureBaseDefinitionGroup(id: $id)
}
    `;
export type DeleteProcedureBaseDefGroupMutationFn = Apollo.MutationFunction<DeleteProcedureBaseDefGroupMutation, DeleteProcedureBaseDefGroupMutationVariables>;

/**
 * __useDeleteProcedureBaseDefGroupMutation__
 *
 * To run a mutation, you first call `useDeleteProcedureBaseDefGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProcedureBaseDefGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProcedureBaseDefGroupMutation, { data, loading, error }] = useDeleteProcedureBaseDefGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteProcedureBaseDefGroupMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProcedureBaseDefGroupMutation, DeleteProcedureBaseDefGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProcedureBaseDefGroupMutation, DeleteProcedureBaseDefGroupMutationVariables>(DeleteProcedureBaseDefGroupDocument, options);
      }
export type DeleteProcedureBaseDefGroupMutationHookResult = ReturnType<typeof useDeleteProcedureBaseDefGroupMutation>;
export type DeleteProcedureBaseDefGroupMutationResult = Apollo.MutationResult<DeleteProcedureBaseDefGroupMutation>;
export type DeleteProcedureBaseDefGroupMutationOptions = Apollo.BaseMutationOptions<DeleteProcedureBaseDefGroupMutation, DeleteProcedureBaseDefGroupMutationVariables>;
export const DeleteProcedureBaseDefinitionDocument = gql`
    mutation DeleteProcedureBaseDefinition($id: ID!) {
  deleteProcedureBaseDefinition(id: $id)
}
    `;
export type DeleteProcedureBaseDefinitionMutationFn = Apollo.MutationFunction<DeleteProcedureBaseDefinitionMutation, DeleteProcedureBaseDefinitionMutationVariables>;

/**
 * __useDeleteProcedureBaseDefinitionMutation__
 *
 * To run a mutation, you first call `useDeleteProcedureBaseDefinitionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProcedureBaseDefinitionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProcedureBaseDefinitionMutation, { data, loading, error }] = useDeleteProcedureBaseDefinitionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteProcedureBaseDefinitionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProcedureBaseDefinitionMutation, DeleteProcedureBaseDefinitionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProcedureBaseDefinitionMutation, DeleteProcedureBaseDefinitionMutationVariables>(DeleteProcedureBaseDefinitionDocument, options);
      }
export type DeleteProcedureBaseDefinitionMutationHookResult = ReturnType<typeof useDeleteProcedureBaseDefinitionMutation>;
export type DeleteProcedureBaseDefinitionMutationResult = Apollo.MutationResult<DeleteProcedureBaseDefinitionMutation>;
export type DeleteProcedureBaseDefinitionMutationOptions = Apollo.BaseMutationOptions<DeleteProcedureBaseDefinitionMutation, DeleteProcedureBaseDefinitionMutationVariables>;
export const DeleteProcedureBaseDefinitionTagDocument = gql`
    mutation DeleteProcedureBaseDefinitionTag($input: ProcedureBaseDefinitionTagInput!) {
  deleteProcedureBaseDefinitionTag(input: $input) {
    ...ProcedureBaseDefFields
  }
}
    ${ProcedureBaseDefFieldsFragmentDoc}`;
export type DeleteProcedureBaseDefinitionTagMutationFn = Apollo.MutationFunction<DeleteProcedureBaseDefinitionTagMutation, DeleteProcedureBaseDefinitionTagMutationVariables>;

/**
 * __useDeleteProcedureBaseDefinitionTagMutation__
 *
 * To run a mutation, you first call `useDeleteProcedureBaseDefinitionTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProcedureBaseDefinitionTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProcedureBaseDefinitionTagMutation, { data, loading, error }] = useDeleteProcedureBaseDefinitionTagMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteProcedureBaseDefinitionTagMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProcedureBaseDefinitionTagMutation, DeleteProcedureBaseDefinitionTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProcedureBaseDefinitionTagMutation, DeleteProcedureBaseDefinitionTagMutationVariables>(DeleteProcedureBaseDefinitionTagDocument, options);
      }
export type DeleteProcedureBaseDefinitionTagMutationHookResult = ReturnType<typeof useDeleteProcedureBaseDefinitionTagMutation>;
export type DeleteProcedureBaseDefinitionTagMutationResult = Apollo.MutationResult<DeleteProcedureBaseDefinitionTagMutation>;
export type DeleteProcedureBaseDefinitionTagMutationOptions = Apollo.BaseMutationOptions<DeleteProcedureBaseDefinitionTagMutation, DeleteProcedureBaseDefinitionTagMutationVariables>;
export const DeleteProcedureDefinitionDocument = gql`
    mutation DeleteProcedureDefinition($id: ID!) {
  deleteProcedureDefinition(id: $id)
}
    `;
export type DeleteProcedureDefinitionMutationFn = Apollo.MutationFunction<DeleteProcedureDefinitionMutation, DeleteProcedureDefinitionMutationVariables>;

/**
 * __useDeleteProcedureDefinitionMutation__
 *
 * To run a mutation, you first call `useDeleteProcedureDefinitionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProcedureDefinitionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProcedureDefinitionMutation, { data, loading, error }] = useDeleteProcedureDefinitionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteProcedureDefinitionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProcedureDefinitionMutation, DeleteProcedureDefinitionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProcedureDefinitionMutation, DeleteProcedureDefinitionMutationVariables>(DeleteProcedureDefinitionDocument, options);
      }
export type DeleteProcedureDefinitionMutationHookResult = ReturnType<typeof useDeleteProcedureDefinitionMutation>;
export type DeleteProcedureDefinitionMutationResult = Apollo.MutationResult<DeleteProcedureDefinitionMutation>;
export type DeleteProcedureDefinitionMutationOptions = Apollo.BaseMutationOptions<DeleteProcedureDefinitionMutation, DeleteProcedureDefinitionMutationVariables>;
export const DeleteProcedureProfileDocument = gql`
    mutation DeleteProcedureProfile($id: ID!) {
  deleteProcedureProfile(id: $id)
}
    `;
export type DeleteProcedureProfileMutationFn = Apollo.MutationFunction<DeleteProcedureProfileMutation, DeleteProcedureProfileMutationVariables>;

/**
 * __useDeleteProcedureProfileMutation__
 *
 * To run a mutation, you first call `useDeleteProcedureProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProcedureProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProcedureProfileMutation, { data, loading, error }] = useDeleteProcedureProfileMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteProcedureProfileMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProcedureProfileMutation, DeleteProcedureProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProcedureProfileMutation, DeleteProcedureProfileMutationVariables>(DeleteProcedureProfileDocument, options);
      }
export type DeleteProcedureProfileMutationHookResult = ReturnType<typeof useDeleteProcedureProfileMutation>;
export type DeleteProcedureProfileMutationResult = Apollo.MutationResult<DeleteProcedureProfileMutation>;
export type DeleteProcedureProfileMutationOptions = Apollo.BaseMutationOptions<DeleteProcedureProfileMutation, DeleteProcedureProfileMutationVariables>;
export const DeleteQualiphyExamDocument = gql`
    mutation DeleteQualiphyExam($id: ID!) {
  deleteQualiphyExam(id: $id)
}
    `;
export type DeleteQualiphyExamMutationFn = Apollo.MutationFunction<DeleteQualiphyExamMutation, DeleteQualiphyExamMutationVariables>;

/**
 * __useDeleteQualiphyExamMutation__
 *
 * To run a mutation, you first call `useDeleteQualiphyExamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteQualiphyExamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteQualiphyExamMutation, { data, loading, error }] = useDeleteQualiphyExamMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteQualiphyExamMutation(baseOptions?: Apollo.MutationHookOptions<DeleteQualiphyExamMutation, DeleteQualiphyExamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteQualiphyExamMutation, DeleteQualiphyExamMutationVariables>(DeleteQualiphyExamDocument, options);
      }
export type DeleteQualiphyExamMutationHookResult = ReturnType<typeof useDeleteQualiphyExamMutation>;
export type DeleteQualiphyExamMutationResult = Apollo.MutationResult<DeleteQualiphyExamMutation>;
export type DeleteQualiphyExamMutationOptions = Apollo.BaseMutationOptions<DeleteQualiphyExamMutation, DeleteQualiphyExamMutationVariables>;
export const DeleteReportDocument = gql`
    mutation DeleteReport($id: ID!) {
  deleteReport(id: $id)
}
    `;
export type DeleteReportMutationFn = Apollo.MutationFunction<DeleteReportMutation, DeleteReportMutationVariables>;

/**
 * __useDeleteReportMutation__
 *
 * To run a mutation, you first call `useDeleteReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteReportMutation, { data, loading, error }] = useDeleteReportMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteReportMutation(baseOptions?: Apollo.MutationHookOptions<DeleteReportMutation, DeleteReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteReportMutation, DeleteReportMutationVariables>(DeleteReportDocument, options);
      }
export type DeleteReportMutationHookResult = ReturnType<typeof useDeleteReportMutation>;
export type DeleteReportMutationResult = Apollo.MutationResult<DeleteReportMutation>;
export type DeleteReportMutationOptions = Apollo.BaseMutationOptions<DeleteReportMutation, DeleteReportMutationVariables>;
export const DeleteRoleDocument = gql`
    mutation DeleteRole($id: ID!) {
  deleteRole(id: $id)
}
    `;
export type DeleteRoleMutationFn = Apollo.MutationFunction<DeleteRoleMutation, DeleteRoleMutationVariables>;

/**
 * __useDeleteRoleMutation__
 *
 * To run a mutation, you first call `useDeleteRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRoleMutation, { data, loading, error }] = useDeleteRoleMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteRoleMutation(baseOptions?: Apollo.MutationHookOptions<DeleteRoleMutation, DeleteRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteRoleMutation, DeleteRoleMutationVariables>(DeleteRoleDocument, options);
      }
export type DeleteRoleMutationHookResult = ReturnType<typeof useDeleteRoleMutation>;
export type DeleteRoleMutationResult = Apollo.MutationResult<DeleteRoleMutation>;
export type DeleteRoleMutationOptions = Apollo.BaseMutationOptions<DeleteRoleMutation, DeleteRoleMutationVariables>;
export const DeleteVitalDocument = gql`
    mutation DeleteVital($id: ID!) {
  deleteVital(id: $id) {
    ...PatientFields
  }
}
    ${PatientFieldsFragmentDoc}`;
export type DeleteVitalMutationFn = Apollo.MutationFunction<DeleteVitalMutation, DeleteVitalMutationVariables>;

/**
 * __useDeleteVitalMutation__
 *
 * To run a mutation, you first call `useDeleteVitalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteVitalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteVitalMutation, { data, loading, error }] = useDeleteVitalMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteVitalMutation(baseOptions?: Apollo.MutationHookOptions<DeleteVitalMutation, DeleteVitalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteVitalMutation, DeleteVitalMutationVariables>(DeleteVitalDocument, options);
      }
export type DeleteVitalMutationHookResult = ReturnType<typeof useDeleteVitalMutation>;
export type DeleteVitalMutationResult = Apollo.MutationResult<DeleteVitalMutation>;
export type DeleteVitalMutationOptions = Apollo.BaseMutationOptions<DeleteVitalMutation, DeleteVitalMutationVariables>;
export const FinishPasskeyRegistrationDocument = gql`
    mutation FinishPasskeyRegistration($input: FinishPasskeyRegistrationInput!) {
  finishPasskeyRegistration(input: $input) {
    factor {
      id
      label
    }
    recoveryCodes
  }
}
    `;
export type FinishPasskeyRegistrationMutationFn = Apollo.MutationFunction<FinishPasskeyRegistrationMutation, FinishPasskeyRegistrationMutationVariables>;

/**
 * __useFinishPasskeyRegistrationMutation__
 *
 * To run a mutation, you first call `useFinishPasskeyRegistrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinishPasskeyRegistrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [finishPasskeyRegistrationMutation, { data, loading, error }] = useFinishPasskeyRegistrationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFinishPasskeyRegistrationMutation(baseOptions?: Apollo.MutationHookOptions<FinishPasskeyRegistrationMutation, FinishPasskeyRegistrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FinishPasskeyRegistrationMutation, FinishPasskeyRegistrationMutationVariables>(FinishPasskeyRegistrationDocument, options);
      }
export type FinishPasskeyRegistrationMutationHookResult = ReturnType<typeof useFinishPasskeyRegistrationMutation>;
export type FinishPasskeyRegistrationMutationResult = Apollo.MutationResult<FinishPasskeyRegistrationMutation>;
export type FinishPasskeyRegistrationMutationOptions = Apollo.BaseMutationOptions<FinishPasskeyRegistrationMutation, FinishPasskeyRegistrationMutationVariables>;
export const GeneratePaymentLinkDocument = gql`
    mutation GeneratePaymentLink($input: GeneratePaymentLinkInput!) {
  generatePaymentLink(input: $input) {
    success
    url
    message
    checkout {
      ...CheckoutWithAppointmentFields
    }
  }
}
    ${CheckoutWithAppointmentFieldsFragmentDoc}`;
export type GeneratePaymentLinkMutationFn = Apollo.MutationFunction<GeneratePaymentLinkMutation, GeneratePaymentLinkMutationVariables>;

/**
 * __useGeneratePaymentLinkMutation__
 *
 * To run a mutation, you first call `useGeneratePaymentLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGeneratePaymentLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generatePaymentLinkMutation, { data, loading, error }] = useGeneratePaymentLinkMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGeneratePaymentLinkMutation(baseOptions?: Apollo.MutationHookOptions<GeneratePaymentLinkMutation, GeneratePaymentLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GeneratePaymentLinkMutation, GeneratePaymentLinkMutationVariables>(GeneratePaymentLinkDocument, options);
      }
export type GeneratePaymentLinkMutationHookResult = ReturnType<typeof useGeneratePaymentLinkMutation>;
export type GeneratePaymentLinkMutationResult = Apollo.MutationResult<GeneratePaymentLinkMutation>;
export type GeneratePaymentLinkMutationOptions = Apollo.BaseMutationOptions<GeneratePaymentLinkMutation, GeneratePaymentLinkMutationVariables>;
export const GrantPackageDocument = gql`
    mutation GrantPackage($input: GrantPackageInput!) {
  grantPackage(input: $input) {
    ...PackageItemFields
  }
}
    ${PackageItemFieldsFragmentDoc}`;
export type GrantPackageMutationFn = Apollo.MutationFunction<GrantPackageMutation, GrantPackageMutationVariables>;

/**
 * __useGrantPackageMutation__
 *
 * To run a mutation, you first call `useGrantPackageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGrantPackageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [grantPackageMutation, { data, loading, error }] = useGrantPackageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGrantPackageMutation(baseOptions?: Apollo.MutationHookOptions<GrantPackageMutation, GrantPackageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GrantPackageMutation, GrantPackageMutationVariables>(GrantPackageDocument, options);
      }
export type GrantPackageMutationHookResult = ReturnType<typeof useGrantPackageMutation>;
export type GrantPackageMutationResult = Apollo.MutationResult<GrantPackageMutation>;
export type GrantPackageMutationOptions = Apollo.BaseMutationOptions<GrantPackageMutation, GrantPackageMutationVariables>;
export const JoinOrganizationDocument = gql`
    mutation JoinOrganization($input: JoinOrganizationInput!) {
  joinOrganization(input: $input) {
    ...ProfileFields
  }
}
    ${ProfileFieldsFragmentDoc}`;
export type JoinOrganizationMutationFn = Apollo.MutationFunction<JoinOrganizationMutation, JoinOrganizationMutationVariables>;

/**
 * __useJoinOrganizationMutation__
 *
 * To run a mutation, you first call `useJoinOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useJoinOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [joinOrganizationMutation, { data, loading, error }] = useJoinOrganizationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useJoinOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<JoinOrganizationMutation, JoinOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<JoinOrganizationMutation, JoinOrganizationMutationVariables>(JoinOrganizationDocument, options);
      }
export type JoinOrganizationMutationHookResult = ReturnType<typeof useJoinOrganizationMutation>;
export type JoinOrganizationMutationResult = Apollo.MutationResult<JoinOrganizationMutation>;
export type JoinOrganizationMutationOptions = Apollo.BaseMutationOptions<JoinOrganizationMutation, JoinOrganizationMutationVariables>;
export const LinkClientProfileToAccountDocument = gql`
    mutation LinkClientProfileToAccount($input: LinkClientProfileToAccountInput!) {
  linkClientProfileToAccount(input: $input) {
    ...FullMarketplaceUserFields
  }
}
    ${FullMarketplaceUserFieldsFragmentDoc}`;
export type LinkClientProfileToAccountMutationFn = Apollo.MutationFunction<LinkClientProfileToAccountMutation, LinkClientProfileToAccountMutationVariables>;

/**
 * __useLinkClientProfileToAccountMutation__
 *
 * To run a mutation, you first call `useLinkClientProfileToAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkClientProfileToAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkClientProfileToAccountMutation, { data, loading, error }] = useLinkClientProfileToAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLinkClientProfileToAccountMutation(baseOptions?: Apollo.MutationHookOptions<LinkClientProfileToAccountMutation, LinkClientProfileToAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LinkClientProfileToAccountMutation, LinkClientProfileToAccountMutationVariables>(LinkClientProfileToAccountDocument, options);
      }
export type LinkClientProfileToAccountMutationHookResult = ReturnType<typeof useLinkClientProfileToAccountMutation>;
export type LinkClientProfileToAccountMutationResult = Apollo.MutationResult<LinkClientProfileToAccountMutation>;
export type LinkClientProfileToAccountMutationOptions = Apollo.BaseMutationOptions<LinkClientProfileToAccountMutation, LinkClientProfileToAccountMutationVariables>;
export const LockFormDocument = gql`
    mutation LockForm($input: LockFormInput!) {
  lockForm(input: $input) {
    ...RegularFormFields
  }
}
    ${RegularFormFieldsFragmentDoc}`;
export type LockFormMutationFn = Apollo.MutationFunction<LockFormMutation, LockFormMutationVariables>;

/**
 * __useLockFormMutation__
 *
 * To run a mutation, you first call `useLockFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLockFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [lockFormMutation, { data, loading, error }] = useLockFormMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLockFormMutation(baseOptions?: Apollo.MutationHookOptions<LockFormMutation, LockFormMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LockFormMutation, LockFormMutationVariables>(LockFormDocument, options);
      }
export type LockFormMutationHookResult = ReturnType<typeof useLockFormMutation>;
export type LockFormMutationResult = Apollo.MutationResult<LockFormMutation>;
export type LockFormMutationOptions = Apollo.BaseMutationOptions<LockFormMutation, LockFormMutationVariables>;
export const LogoutDocument = gql`
    mutation Logout {
  logout
}
    `;
export type LogoutMutationFn = Apollo.MutationFunction<LogoutMutation, LogoutMutationVariables>;

/**
 * __useLogoutMutation__
 *
 * To run a mutation, you first call `useLogoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logoutMutation, { data, loading, error }] = useLogoutMutation({
 *   variables: {
 *   },
 * });
 */
export function useLogoutMutation(baseOptions?: Apollo.MutationHookOptions<LogoutMutation, LogoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LogoutMutation, LogoutMutationVariables>(LogoutDocument, options);
      }
export type LogoutMutationHookResult = ReturnType<typeof useLogoutMutation>;
export type LogoutMutationResult = Apollo.MutationResult<LogoutMutation>;
export type LogoutMutationOptions = Apollo.BaseMutationOptions<LogoutMutation, LogoutMutationVariables>;
export const MfaAuthenticationOptionsDocument = gql`
    mutation MfaAuthenticationOptions($challengeId: String) {
  mfaAuthenticationOptions(challengeId: $challengeId)
}
    `;
export type MfaAuthenticationOptionsMutationFn = Apollo.MutationFunction<MfaAuthenticationOptionsMutation, MfaAuthenticationOptionsMutationVariables>;

/**
 * __useMfaAuthenticationOptionsMutation__
 *
 * To run a mutation, you first call `useMfaAuthenticationOptionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMfaAuthenticationOptionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mfaAuthenticationOptionsMutation, { data, loading, error }] = useMfaAuthenticationOptionsMutation({
 *   variables: {
 *      challengeId: // value for 'challengeId'
 *   },
 * });
 */
export function useMfaAuthenticationOptionsMutation(baseOptions?: Apollo.MutationHookOptions<MfaAuthenticationOptionsMutation, MfaAuthenticationOptionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MfaAuthenticationOptionsMutation, MfaAuthenticationOptionsMutationVariables>(MfaAuthenticationOptionsDocument, options);
      }
export type MfaAuthenticationOptionsMutationHookResult = ReturnType<typeof useMfaAuthenticationOptionsMutation>;
export type MfaAuthenticationOptionsMutationResult = Apollo.MutationResult<MfaAuthenticationOptionsMutation>;
export type MfaAuthenticationOptionsMutationOptions = Apollo.BaseMutationOptions<MfaAuthenticationOptionsMutation, MfaAuthenticationOptionsMutationVariables>;
export const RecordCashPaymentDocument = gql`
    mutation RecordCashPayment($input: RecordCashPaymentInput!) {
  recordCashPayment(input: $input) {
    success
    errorMessage
    checkout {
      ...CheckoutWithAppointmentFields
    }
  }
}
    ${CheckoutWithAppointmentFieldsFragmentDoc}`;
export type RecordCashPaymentMutationFn = Apollo.MutationFunction<RecordCashPaymentMutation, RecordCashPaymentMutationVariables>;

/**
 * __useRecordCashPaymentMutation__
 *
 * To run a mutation, you first call `useRecordCashPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecordCashPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recordCashPaymentMutation, { data, loading, error }] = useRecordCashPaymentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRecordCashPaymentMutation(baseOptions?: Apollo.MutationHookOptions<RecordCashPaymentMutation, RecordCashPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecordCashPaymentMutation, RecordCashPaymentMutationVariables>(RecordCashPaymentDocument, options);
      }
export type RecordCashPaymentMutationHookResult = ReturnType<typeof useRecordCashPaymentMutation>;
export type RecordCashPaymentMutationResult = Apollo.MutationResult<RecordCashPaymentMutation>;
export type RecordCashPaymentMutationOptions = Apollo.BaseMutationOptions<RecordCashPaymentMutation, RecordCashPaymentMutationVariables>;
export const RefundCheckoutDocument = gql`
    mutation RefundCheckout($input: RefundCheckoutInput!) {
  refundCheckout(input: $input) {
    ...CheckoutWithAppointmentFields
  }
}
    ${CheckoutWithAppointmentFieldsFragmentDoc}`;
export type RefundCheckoutMutationFn = Apollo.MutationFunction<RefundCheckoutMutation, RefundCheckoutMutationVariables>;

/**
 * __useRefundCheckoutMutation__
 *
 * To run a mutation, you first call `useRefundCheckoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefundCheckoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refundCheckoutMutation, { data, loading, error }] = useRefundCheckoutMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRefundCheckoutMutation(baseOptions?: Apollo.MutationHookOptions<RefundCheckoutMutation, RefundCheckoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefundCheckoutMutation, RefundCheckoutMutationVariables>(RefundCheckoutDocument, options);
      }
export type RefundCheckoutMutationHookResult = ReturnType<typeof useRefundCheckoutMutation>;
export type RefundCheckoutMutationResult = Apollo.MutationResult<RefundCheckoutMutation>;
export type RefundCheckoutMutationOptions = Apollo.BaseMutationOptions<RefundCheckoutMutation, RefundCheckoutMutationVariables>;
export const RegenerateRecoveryCodesDocument = gql`
    mutation RegenerateRecoveryCodes {
  regenerateRecoveryCodes
}
    `;
export type RegenerateRecoveryCodesMutationFn = Apollo.MutationFunction<RegenerateRecoveryCodesMutation, RegenerateRecoveryCodesMutationVariables>;

/**
 * __useRegenerateRecoveryCodesMutation__
 *
 * To run a mutation, you first call `useRegenerateRecoveryCodesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegenerateRecoveryCodesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [regenerateRecoveryCodesMutation, { data, loading, error }] = useRegenerateRecoveryCodesMutation({
 *   variables: {
 *   },
 * });
 */
export function useRegenerateRecoveryCodesMutation(baseOptions?: Apollo.MutationHookOptions<RegenerateRecoveryCodesMutation, RegenerateRecoveryCodesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegenerateRecoveryCodesMutation, RegenerateRecoveryCodesMutationVariables>(RegenerateRecoveryCodesDocument, options);
      }
export type RegenerateRecoveryCodesMutationHookResult = ReturnType<typeof useRegenerateRecoveryCodesMutation>;
export type RegenerateRecoveryCodesMutationResult = Apollo.MutationResult<RegenerateRecoveryCodesMutation>;
export type RegenerateRecoveryCodesMutationOptions = Apollo.BaseMutationOptions<RegenerateRecoveryCodesMutation, RegenerateRecoveryCodesMutationVariables>;
export const RegisterDocument = gql`
    mutation Register($email: String!, $password: String!, $code: String!) {
  register(input: {email: $email, password: $password, code: $code}) {
    user {
      id
      email
      profiles {
        id
        pid
      }
    }
  }
}
    `;
export type RegisterMutationFn = Apollo.MutationFunction<RegisterMutation, RegisterMutationVariables>;

/**
 * __useRegisterMutation__
 *
 * To run a mutation, you first call `useRegisterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerMutation, { data, loading, error }] = useRegisterMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *      code: // value for 'code'
 *   },
 * });
 */
export function useRegisterMutation(baseOptions?: Apollo.MutationHookOptions<RegisterMutation, RegisterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterMutation, RegisterMutationVariables>(RegisterDocument, options);
      }
export type RegisterMutationHookResult = ReturnType<typeof useRegisterMutation>;
export type RegisterMutationResult = Apollo.MutationResult<RegisterMutation>;
export type RegisterMutationOptions = Apollo.BaseMutationOptions<RegisterMutation, RegisterMutationVariables>;
export const RemoveMfaFactorDocument = gql`
    mutation RemoveMfaFactor($id: ID!) {
  removeMfaFactor(id: $id)
}
    `;
export type RemoveMfaFactorMutationFn = Apollo.MutationFunction<RemoveMfaFactorMutation, RemoveMfaFactorMutationVariables>;

/**
 * __useRemoveMfaFactorMutation__
 *
 * To run a mutation, you first call `useRemoveMfaFactorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveMfaFactorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeMfaFactorMutation, { data, loading, error }] = useRemoveMfaFactorMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveMfaFactorMutation(baseOptions?: Apollo.MutationHookOptions<RemoveMfaFactorMutation, RemoveMfaFactorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveMfaFactorMutation, RemoveMfaFactorMutationVariables>(RemoveMfaFactorDocument, options);
      }
export type RemoveMfaFactorMutationHookResult = ReturnType<typeof useRemoveMfaFactorMutation>;
export type RemoveMfaFactorMutationResult = Apollo.MutationResult<RemoveMfaFactorMutation>;
export type RemoveMfaFactorMutationOptions = Apollo.BaseMutationOptions<RemoveMfaFactorMutation, RemoveMfaFactorMutationVariables>;
export const RemoveOrganizationsFromMarketplaceDocument = gql`
    mutation RemoveOrganizationsFromMarketplace($input: RemoveOrganizationsFromMarketplaceInput!) {
  removeOrganizationsFromMarketplace(input: $input)
}
    `;
export type RemoveOrganizationsFromMarketplaceMutationFn = Apollo.MutationFunction<RemoveOrganizationsFromMarketplaceMutation, RemoveOrganizationsFromMarketplaceMutationVariables>;

/**
 * __useRemoveOrganizationsFromMarketplaceMutation__
 *
 * To run a mutation, you first call `useRemoveOrganizationsFromMarketplaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveOrganizationsFromMarketplaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeOrganizationsFromMarketplaceMutation, { data, loading, error }] = useRemoveOrganizationsFromMarketplaceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveOrganizationsFromMarketplaceMutation(baseOptions?: Apollo.MutationHookOptions<RemoveOrganizationsFromMarketplaceMutation, RemoveOrganizationsFromMarketplaceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveOrganizationsFromMarketplaceMutation, RemoveOrganizationsFromMarketplaceMutationVariables>(RemoveOrganizationsFromMarketplaceDocument, options);
      }
export type RemoveOrganizationsFromMarketplaceMutationHookResult = ReturnType<typeof useRemoveOrganizationsFromMarketplaceMutation>;
export type RemoveOrganizationsFromMarketplaceMutationResult = Apollo.MutationResult<RemoveOrganizationsFromMarketplaceMutation>;
export type RemoveOrganizationsFromMarketplaceMutationOptions = Apollo.BaseMutationOptions<RemoveOrganizationsFromMarketplaceMutation, RemoveOrganizationsFromMarketplaceMutationVariables>;
export const ReportAppointmentsDocument = gql`
    mutation ReportAppointments($input: ReportAppointmentsInput!) {
  reportAppointments(input: $input) {
    id
    type
    filename
    status
    organizationId
    userId
    createdAt
    updatedAt
    downloadUrl
  }
}
    `;
export type ReportAppointmentsMutationFn = Apollo.MutationFunction<ReportAppointmentsMutation, ReportAppointmentsMutationVariables>;

/**
 * __useReportAppointmentsMutation__
 *
 * To run a mutation, you first call `useReportAppointmentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReportAppointmentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reportAppointmentsMutation, { data, loading, error }] = useReportAppointmentsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReportAppointmentsMutation(baseOptions?: Apollo.MutationHookOptions<ReportAppointmentsMutation, ReportAppointmentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReportAppointmentsMutation, ReportAppointmentsMutationVariables>(ReportAppointmentsDocument, options);
      }
export type ReportAppointmentsMutationHookResult = ReturnType<typeof useReportAppointmentsMutation>;
export type ReportAppointmentsMutationResult = Apollo.MutationResult<ReportAppointmentsMutation>;
export type ReportAppointmentsMutationOptions = Apollo.BaseMutationOptions<ReportAppointmentsMutation, ReportAppointmentsMutationVariables>;
export const ReportPersonnelDocument = gql`
    mutation ReportPersonnel($input: ReportPersonnelInput!) {
  reportPersonnel(input: $input) {
    id
    type
    filename
    status
    organizationId
    userId
    createdAt
    updatedAt
    downloadUrl
  }
}
    `;
export type ReportPersonnelMutationFn = Apollo.MutationFunction<ReportPersonnelMutation, ReportPersonnelMutationVariables>;

/**
 * __useReportPersonnelMutation__
 *
 * To run a mutation, you first call `useReportPersonnelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReportPersonnelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reportPersonnelMutation, { data, loading, error }] = useReportPersonnelMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReportPersonnelMutation(baseOptions?: Apollo.MutationHookOptions<ReportPersonnelMutation, ReportPersonnelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReportPersonnelMutation, ReportPersonnelMutationVariables>(ReportPersonnelDocument, options);
      }
export type ReportPersonnelMutationHookResult = ReturnType<typeof useReportPersonnelMutation>;
export type ReportPersonnelMutationResult = Apollo.MutationResult<ReportPersonnelMutation>;
export type ReportPersonnelMutationOptions = Apollo.BaseMutationOptions<ReportPersonnelMutation, ReportPersonnelMutationVariables>;
export const RequestChangeEmailDocument = gql`
    mutation requestChangeEmail($newEmail: String!) {
  requestChangeEmail(newEmail: $newEmail)
}
    `;
export type RequestChangeEmailMutationFn = Apollo.MutationFunction<RequestChangeEmailMutation, RequestChangeEmailMutationVariables>;

/**
 * __useRequestChangeEmailMutation__
 *
 * To run a mutation, you first call `useRequestChangeEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestChangeEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestChangeEmailMutation, { data, loading, error }] = useRequestChangeEmailMutation({
 *   variables: {
 *      newEmail: // value for 'newEmail'
 *   },
 * });
 */
export function useRequestChangeEmailMutation(baseOptions?: Apollo.MutationHookOptions<RequestChangeEmailMutation, RequestChangeEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestChangeEmailMutation, RequestChangeEmailMutationVariables>(RequestChangeEmailDocument, options);
      }
export type RequestChangeEmailMutationHookResult = ReturnType<typeof useRequestChangeEmailMutation>;
export type RequestChangeEmailMutationResult = Apollo.MutationResult<RequestChangeEmailMutation>;
export type RequestChangeEmailMutationOptions = Apollo.BaseMutationOptions<RequestChangeEmailMutation, RequestChangeEmailMutationVariables>;
export const RequestResetPasswordDocument = gql`
    mutation requestResetPassword($email: String!) {
  requestResetPassword(email: $email)
}
    `;
export type RequestResetPasswordMutationFn = Apollo.MutationFunction<RequestResetPasswordMutation, RequestResetPasswordMutationVariables>;

/**
 * __useRequestResetPasswordMutation__
 *
 * To run a mutation, you first call `useRequestResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestResetPasswordMutation, { data, loading, error }] = useRequestResetPasswordMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useRequestResetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<RequestResetPasswordMutation, RequestResetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestResetPasswordMutation, RequestResetPasswordMutationVariables>(RequestResetPasswordDocument, options);
      }
export type RequestResetPasswordMutationHookResult = ReturnType<typeof useRequestResetPasswordMutation>;
export type RequestResetPasswordMutationResult = Apollo.MutationResult<RequestResetPasswordMutation>;
export type RequestResetPasswordMutationOptions = Apollo.BaseMutationOptions<RequestResetPasswordMutation, RequestResetPasswordMutationVariables>;
export const ResendQualiphyExamInviteDocument = gql`
    mutation ResendQualiphyExamInvite($id: String!) {
  resendQualiphyExamInvite(id: $id) {
    ...QualiphyInvitationFields
  }
}
    ${QualiphyInvitationFieldsFragmentDoc}`;
export type ResendQualiphyExamInviteMutationFn = Apollo.MutationFunction<ResendQualiphyExamInviteMutation, ResendQualiphyExamInviteMutationVariables>;

/**
 * __useResendQualiphyExamInviteMutation__
 *
 * To run a mutation, you first call `useResendQualiphyExamInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendQualiphyExamInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendQualiphyExamInviteMutation, { data, loading, error }] = useResendQualiphyExamInviteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useResendQualiphyExamInviteMutation(baseOptions?: Apollo.MutationHookOptions<ResendQualiphyExamInviteMutation, ResendQualiphyExamInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendQualiphyExamInviteMutation, ResendQualiphyExamInviteMutationVariables>(ResendQualiphyExamInviteDocument, options);
      }
export type ResendQualiphyExamInviteMutationHookResult = ReturnType<typeof useResendQualiphyExamInviteMutation>;
export type ResendQualiphyExamInviteMutationResult = Apollo.MutationResult<ResendQualiphyExamInviteMutation>;
export type ResendQualiphyExamInviteMutationOptions = Apollo.BaseMutationOptions<ResendQualiphyExamInviteMutation, ResendQualiphyExamInviteMutationVariables>;
export const ResetAppointmentDocument = gql`
    mutation ResetAppointment($input: ResetAppointmentInput!) {
  resetAppointment(input: $input) {
    ...FullAppointmentFields
  }
}
    ${FullAppointmentFieldsFragmentDoc}`;
export type ResetAppointmentMutationFn = Apollo.MutationFunction<ResetAppointmentMutation, ResetAppointmentMutationVariables>;

/**
 * __useResetAppointmentMutation__
 *
 * To run a mutation, you first call `useResetAppointmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetAppointmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetAppointmentMutation, { data, loading, error }] = useResetAppointmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResetAppointmentMutation(baseOptions?: Apollo.MutationHookOptions<ResetAppointmentMutation, ResetAppointmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetAppointmentMutation, ResetAppointmentMutationVariables>(ResetAppointmentDocument, options);
      }
export type ResetAppointmentMutationHookResult = ReturnType<typeof useResetAppointmentMutation>;
export type ResetAppointmentMutationResult = Apollo.MutationResult<ResetAppointmentMutation>;
export type ResetAppointmentMutationOptions = Apollo.BaseMutationOptions<ResetAppointmentMutation, ResetAppointmentMutationVariables>;
export const ResetAppointmentRequestDocument = gql`
    mutation ResetAppointmentRequest($input: ResetAppointmentRequestInput!) {
  resetAppointmentRequest(input: $input) {
    ...FullAppointmentRequestFields
  }
}
    ${FullAppointmentRequestFieldsFragmentDoc}`;
export type ResetAppointmentRequestMutationFn = Apollo.MutationFunction<ResetAppointmentRequestMutation, ResetAppointmentRequestMutationVariables>;

/**
 * __useResetAppointmentRequestMutation__
 *
 * To run a mutation, you first call `useResetAppointmentRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetAppointmentRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetAppointmentRequestMutation, { data, loading, error }] = useResetAppointmentRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResetAppointmentRequestMutation(baseOptions?: Apollo.MutationHookOptions<ResetAppointmentRequestMutation, ResetAppointmentRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetAppointmentRequestMutation, ResetAppointmentRequestMutationVariables>(ResetAppointmentRequestDocument, options);
      }
export type ResetAppointmentRequestMutationHookResult = ReturnType<typeof useResetAppointmentRequestMutation>;
export type ResetAppointmentRequestMutationResult = Apollo.MutationResult<ResetAppointmentRequestMutation>;
export type ResetAppointmentRequestMutationOptions = Apollo.BaseMutationOptions<ResetAppointmentRequestMutation, ResetAppointmentRequestMutationVariables>;
export const ResetPasswordDocument = gql`
    mutation ResetPassword($input: ResetPasswordInput!) {
  resetPassword(input: $input)
}
    `;
export type ResetPasswordMutationFn = Apollo.MutationFunction<ResetPasswordMutation, ResetPasswordMutationVariables>;

/**
 * __useResetPasswordMutation__
 *
 * To run a mutation, you first call `useResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordMutation, { data, loading, error }] = useResetPasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ResetPasswordMutation, ResetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetPasswordMutation, ResetPasswordMutationVariables>(ResetPasswordDocument, options);
      }
export type ResetPasswordMutationHookResult = ReturnType<typeof useResetPasswordMutation>;
export type ResetPasswordMutationResult = Apollo.MutationResult<ResetPasswordMutation>;
export type ResetPasswordMutationOptions = Apollo.BaseMutationOptions<ResetPasswordMutation, ResetPasswordMutationVariables>;
export const ResetUserMfaDocument = gql`
    mutation ResetUserMfa($input: ResetUserMfaInput!) {
  resetUserMfa(input: $input) {
    factorsRemoved
    sessionsEnded
    graceUntil
  }
}
    `;
export type ResetUserMfaMutationFn = Apollo.MutationFunction<ResetUserMfaMutation, ResetUserMfaMutationVariables>;

/**
 * __useResetUserMfaMutation__
 *
 * To run a mutation, you first call `useResetUserMfaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetUserMfaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetUserMfaMutation, { data, loading, error }] = useResetUserMfaMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResetUserMfaMutation(baseOptions?: Apollo.MutationHookOptions<ResetUserMfaMutation, ResetUserMfaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetUserMfaMutation, ResetUserMfaMutationVariables>(ResetUserMfaDocument, options);
      }
export type ResetUserMfaMutationHookResult = ReturnType<typeof useResetUserMfaMutation>;
export type ResetUserMfaMutationResult = Apollo.MutationResult<ResetUserMfaMutation>;
export type ResetUserMfaMutationOptions = Apollo.BaseMutationOptions<ResetUserMfaMutation, ResetUserMfaMutationVariables>;
export const RevokeApiKeyDocument = gql`
    mutation RevokeApiKey($kid: String!) {
  revokeApiKey(kid: $kid)
}
    `;
export type RevokeApiKeyMutationFn = Apollo.MutationFunction<RevokeApiKeyMutation, RevokeApiKeyMutationVariables>;

/**
 * __useRevokeApiKeyMutation__
 *
 * To run a mutation, you first call `useRevokeApiKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokeApiKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokeApiKeyMutation, { data, loading, error }] = useRevokeApiKeyMutation({
 *   variables: {
 *      kid: // value for 'kid'
 *   },
 * });
 */
export function useRevokeApiKeyMutation(baseOptions?: Apollo.MutationHookOptions<RevokeApiKeyMutation, RevokeApiKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RevokeApiKeyMutation, RevokeApiKeyMutationVariables>(RevokeApiKeyDocument, options);
      }
export type RevokeApiKeyMutationHookResult = ReturnType<typeof useRevokeApiKeyMutation>;
export type RevokeApiKeyMutationResult = Apollo.MutationResult<RevokeApiKeyMutation>;
export type RevokeApiKeyMutationOptions = Apollo.BaseMutationOptions<RevokeApiKeyMutation, RevokeApiKeyMutationVariables>;
export const RevokeTrustedDeviceDocument = gql`
    mutation RevokeTrustedDevice($id: ID!) {
  revokeTrustedDevice(id: $id)
}
    `;
export type RevokeTrustedDeviceMutationFn = Apollo.MutationFunction<RevokeTrustedDeviceMutation, RevokeTrustedDeviceMutationVariables>;

/**
 * __useRevokeTrustedDeviceMutation__
 *
 * To run a mutation, you first call `useRevokeTrustedDeviceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokeTrustedDeviceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokeTrustedDeviceMutation, { data, loading, error }] = useRevokeTrustedDeviceMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRevokeTrustedDeviceMutation(baseOptions?: Apollo.MutationHookOptions<RevokeTrustedDeviceMutation, RevokeTrustedDeviceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RevokeTrustedDeviceMutation, RevokeTrustedDeviceMutationVariables>(RevokeTrustedDeviceDocument, options);
      }
export type RevokeTrustedDeviceMutationHookResult = ReturnType<typeof useRevokeTrustedDeviceMutation>;
export type RevokeTrustedDeviceMutationResult = Apollo.MutationResult<RevokeTrustedDeviceMutation>;
export type RevokeTrustedDeviceMutationOptions = Apollo.BaseMutationOptions<RevokeTrustedDeviceMutation, RevokeTrustedDeviceMutationVariables>;
export const SendIntakeFormDocument = gql`
    mutation SendIntakeForm($appointmentId: ID!, $formTemplateIds: [ID!], $deliveryMethods: SendIntakeFormDeliveryInput) {
  sendIntakeForm(
    appointmentId: $appointmentId
    formTemplateIds: $formTemplateIds
    deliveryMethods: $deliveryMethods
  ) {
    submissions {
      id
      status
    }
    sms {
      sent
      destination
      error
    }
    email {
      sent
      destination
      error
    }
  }
}
    `;
export type SendIntakeFormMutationFn = Apollo.MutationFunction<SendIntakeFormMutation, SendIntakeFormMutationVariables>;

/**
 * __useSendIntakeFormMutation__
 *
 * To run a mutation, you first call `useSendIntakeFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendIntakeFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendIntakeFormMutation, { data, loading, error }] = useSendIntakeFormMutation({
 *   variables: {
 *      appointmentId: // value for 'appointmentId'
 *      formTemplateIds: // value for 'formTemplateIds'
 *      deliveryMethods: // value for 'deliveryMethods'
 *   },
 * });
 */
export function useSendIntakeFormMutation(baseOptions?: Apollo.MutationHookOptions<SendIntakeFormMutation, SendIntakeFormMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendIntakeFormMutation, SendIntakeFormMutationVariables>(SendIntakeFormDocument, options);
      }
export type SendIntakeFormMutationHookResult = ReturnType<typeof useSendIntakeFormMutation>;
export type SendIntakeFormMutationResult = Apollo.MutationResult<SendIntakeFormMutation>;
export type SendIntakeFormMutationOptions = Apollo.BaseMutationOptions<SendIntakeFormMutation, SendIntakeFormMutationVariables>;
export const SendPaymentLinkDocument = gql`
    mutation SendPaymentLink($input: SendPaymentLinkInput!) {
  sendPaymentLink(input: $input) {
    success
    url
    message
    checkout {
      ...CheckoutWithAppointmentFields
    }
  }
}
    ${CheckoutWithAppointmentFieldsFragmentDoc}`;
export type SendPaymentLinkMutationFn = Apollo.MutationFunction<SendPaymentLinkMutation, SendPaymentLinkMutationVariables>;

/**
 * __useSendPaymentLinkMutation__
 *
 * To run a mutation, you first call `useSendPaymentLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendPaymentLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendPaymentLinkMutation, { data, loading, error }] = useSendPaymentLinkMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendPaymentLinkMutation(baseOptions?: Apollo.MutationHookOptions<SendPaymentLinkMutation, SendPaymentLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendPaymentLinkMutation, SendPaymentLinkMutationVariables>(SendPaymentLinkDocument, options);
      }
export type SendPaymentLinkMutationHookResult = ReturnType<typeof useSendPaymentLinkMutation>;
export type SendPaymentLinkMutationResult = Apollo.MutationResult<SendPaymentLinkMutation>;
export type SendPaymentLinkMutationOptions = Apollo.BaseMutationOptions<SendPaymentLinkMutation, SendPaymentLinkMutationVariables>;
export const SendProfileInvitationDocument = gql`
    mutation SendProfileInvitation($input: SendInvitationInput!) {
  sendProfileInvitation(input: $input)
}
    `;
export type SendProfileInvitationMutationFn = Apollo.MutationFunction<SendProfileInvitationMutation, SendProfileInvitationMutationVariables>;

/**
 * __useSendProfileInvitationMutation__
 *
 * To run a mutation, you first call `useSendProfileInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendProfileInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendProfileInvitationMutation, { data, loading, error }] = useSendProfileInvitationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendProfileInvitationMutation(baseOptions?: Apollo.MutationHookOptions<SendProfileInvitationMutation, SendProfileInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendProfileInvitationMutation, SendProfileInvitationMutationVariables>(SendProfileInvitationDocument, options);
      }
export type SendProfileInvitationMutationHookResult = ReturnType<typeof useSendProfileInvitationMutation>;
export type SendProfileInvitationMutationResult = Apollo.MutationResult<SendProfileInvitationMutation>;
export type SendProfileInvitationMutationOptions = Apollo.BaseMutationOptions<SendProfileInvitationMutation, SendProfileInvitationMutationVariables>;
export const SendQualiphyExamInviteDocument = gql`
    mutation SendQualiphyExamInvite($id: String!) {
  sendQualiphyExamInvite(id: $id) {
    ...QualiphyInvitationFields
  }
}
    ${QualiphyInvitationFieldsFragmentDoc}`;
export type SendQualiphyExamInviteMutationFn = Apollo.MutationFunction<SendQualiphyExamInviteMutation, SendQualiphyExamInviteMutationVariables>;

/**
 * __useSendQualiphyExamInviteMutation__
 *
 * To run a mutation, you first call `useSendQualiphyExamInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendQualiphyExamInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendQualiphyExamInviteMutation, { data, loading, error }] = useSendQualiphyExamInviteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSendQualiphyExamInviteMutation(baseOptions?: Apollo.MutationHookOptions<SendQualiphyExamInviteMutation, SendQualiphyExamInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendQualiphyExamInviteMutation, SendQualiphyExamInviteMutationVariables>(SendQualiphyExamInviteDocument, options);
      }
export type SendQualiphyExamInviteMutationHookResult = ReturnType<typeof useSendQualiphyExamInviteMutation>;
export type SendQualiphyExamInviteMutationResult = Apollo.MutationResult<SendQualiphyExamInviteMutation>;
export type SendQualiphyExamInviteMutationOptions = Apollo.BaseMutationOptions<SendQualiphyExamInviteMutation, SendQualiphyExamInviteMutationVariables>;
export const SendReceiptDocument = gql`
    mutation SendReceipt($input: SendReceiptInput!) {
  sendReceipt(input: $input) {
    success
    message
  }
}
    `;
export type SendReceiptMutationFn = Apollo.MutationFunction<SendReceiptMutation, SendReceiptMutationVariables>;

/**
 * __useSendReceiptMutation__
 *
 * To run a mutation, you first call `useSendReceiptMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendReceiptMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendReceiptMutation, { data, loading, error }] = useSendReceiptMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendReceiptMutation(baseOptions?: Apollo.MutationHookOptions<SendReceiptMutation, SendReceiptMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendReceiptMutation, SendReceiptMutationVariables>(SendReceiptDocument, options);
      }
export type SendReceiptMutationHookResult = ReturnType<typeof useSendReceiptMutation>;
export type SendReceiptMutationResult = Apollo.MutationResult<SendReceiptMutation>;
export type SendReceiptMutationOptions = Apollo.BaseMutationOptions<SendReceiptMutation, SendReceiptMutationVariables>;
export const SendWaitlistNotificationDocument = gql`
    mutation SendWaitlistNotification($input: SendWaitlistNotificationInput!) {
  sendWaitlistNotification(input: $input) {
    ...FullAppointmentRequestFields
  }
}
    ${FullAppointmentRequestFieldsFragmentDoc}`;
export type SendWaitlistNotificationMutationFn = Apollo.MutationFunction<SendWaitlistNotificationMutation, SendWaitlistNotificationMutationVariables>;

/**
 * __useSendWaitlistNotificationMutation__
 *
 * To run a mutation, you first call `useSendWaitlistNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendWaitlistNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendWaitlistNotificationMutation, { data, loading, error }] = useSendWaitlistNotificationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendWaitlistNotificationMutation(baseOptions?: Apollo.MutationHookOptions<SendWaitlistNotificationMutation, SendWaitlistNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendWaitlistNotificationMutation, SendWaitlistNotificationMutationVariables>(SendWaitlistNotificationDocument, options);
      }
export type SendWaitlistNotificationMutationHookResult = ReturnType<typeof useSendWaitlistNotificationMutation>;
export type SendWaitlistNotificationMutationResult = Apollo.MutationResult<SendWaitlistNotificationMutation>;
export type SendWaitlistNotificationMutationOptions = Apollo.BaseMutationOptions<SendWaitlistNotificationMutation, SendWaitlistNotificationMutationVariables>;
export const SetUserMcpAccessDocument = gql`
    mutation setUserMcpAccess($input: SetUserMcpAccessInput!) {
  setUserMcpAccess(input: $input) {
    id
    isMcpEnabled
  }
}
    `;
export type SetUserMcpAccessMutationFn = Apollo.MutationFunction<SetUserMcpAccessMutation, SetUserMcpAccessMutationVariables>;

/**
 * __useSetUserMcpAccessMutation__
 *
 * To run a mutation, you first call `useSetUserMcpAccessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetUserMcpAccessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setUserMcpAccessMutation, { data, loading, error }] = useSetUserMcpAccessMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetUserMcpAccessMutation(baseOptions?: Apollo.MutationHookOptions<SetUserMcpAccessMutation, SetUserMcpAccessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetUserMcpAccessMutation, SetUserMcpAccessMutationVariables>(SetUserMcpAccessDocument, options);
      }
export type SetUserMcpAccessMutationHookResult = ReturnType<typeof useSetUserMcpAccessMutation>;
export type SetUserMcpAccessMutationResult = Apollo.MutationResult<SetUserMcpAccessMutation>;
export type SetUserMcpAccessMutationOptions = Apollo.BaseMutationOptions<SetUserMcpAccessMutation, SetUserMcpAccessMutationVariables>;
export const SignOutEverywhereDocument = gql`
    mutation SignOutEverywhere {
  signOutEverywhere
}
    `;
export type SignOutEverywhereMutationFn = Apollo.MutationFunction<SignOutEverywhereMutation, SignOutEverywhereMutationVariables>;

/**
 * __useSignOutEverywhereMutation__
 *
 * To run a mutation, you first call `useSignOutEverywhereMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignOutEverywhereMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signOutEverywhereMutation, { data, loading, error }] = useSignOutEverywhereMutation({
 *   variables: {
 *   },
 * });
 */
export function useSignOutEverywhereMutation(baseOptions?: Apollo.MutationHookOptions<SignOutEverywhereMutation, SignOutEverywhereMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignOutEverywhereMutation, SignOutEverywhereMutationVariables>(SignOutEverywhereDocument, options);
      }
export type SignOutEverywhereMutationHookResult = ReturnType<typeof useSignOutEverywhereMutation>;
export type SignOutEverywhereMutationResult = Apollo.MutationResult<SignOutEverywhereMutation>;
export type SignOutEverywhereMutationOptions = Apollo.BaseMutationOptions<SignOutEverywhereMutation, SignOutEverywhereMutationVariables>;
export const StartAppointmentDocument = gql`
    mutation StartAppointment($input: StartAppointmentInput!) {
  startAppointment(input: $input) {
    ...FullAppointmentFields
  }
}
    ${FullAppointmentFieldsFragmentDoc}`;
export type StartAppointmentMutationFn = Apollo.MutationFunction<StartAppointmentMutation, StartAppointmentMutationVariables>;

/**
 * __useStartAppointmentMutation__
 *
 * To run a mutation, you first call `useStartAppointmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartAppointmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startAppointmentMutation, { data, loading, error }] = useStartAppointmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStartAppointmentMutation(baseOptions?: Apollo.MutationHookOptions<StartAppointmentMutation, StartAppointmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartAppointmentMutation, StartAppointmentMutationVariables>(StartAppointmentDocument, options);
      }
export type StartAppointmentMutationHookResult = ReturnType<typeof useStartAppointmentMutation>;
export type StartAppointmentMutationResult = Apollo.MutationResult<StartAppointmentMutation>;
export type StartAppointmentMutationOptions = Apollo.BaseMutationOptions<StartAppointmentMutation, StartAppointmentMutationVariables>;
export const StartMfaStepUpDocument = gql`
    mutation StartMfaStepUp {
  startMfaStepUp {
    challengeId
    methods
    expiresAt
  }
}
    `;
export type StartMfaStepUpMutationFn = Apollo.MutationFunction<StartMfaStepUpMutation, StartMfaStepUpMutationVariables>;

/**
 * __useStartMfaStepUpMutation__
 *
 * To run a mutation, you first call `useStartMfaStepUpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartMfaStepUpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startMfaStepUpMutation, { data, loading, error }] = useStartMfaStepUpMutation({
 *   variables: {
 *   },
 * });
 */
export function useStartMfaStepUpMutation(baseOptions?: Apollo.MutationHookOptions<StartMfaStepUpMutation, StartMfaStepUpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartMfaStepUpMutation, StartMfaStepUpMutationVariables>(StartMfaStepUpDocument, options);
      }
export type StartMfaStepUpMutationHookResult = ReturnType<typeof useStartMfaStepUpMutation>;
export type StartMfaStepUpMutationResult = Apollo.MutationResult<StartMfaStepUpMutation>;
export type StartMfaStepUpMutationOptions = Apollo.BaseMutationOptions<StartMfaStepUpMutation, StartMfaStepUpMutationVariables>;
export const StartPasskeyRegistrationDocument = gql`
    mutation StartPasskeyRegistration {
  startPasskeyRegistration {
    options
  }
}
    `;
export type StartPasskeyRegistrationMutationFn = Apollo.MutationFunction<StartPasskeyRegistrationMutation, StartPasskeyRegistrationMutationVariables>;

/**
 * __useStartPasskeyRegistrationMutation__
 *
 * To run a mutation, you first call `useStartPasskeyRegistrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartPasskeyRegistrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startPasskeyRegistrationMutation, { data, loading, error }] = useStartPasskeyRegistrationMutation({
 *   variables: {
 *   },
 * });
 */
export function useStartPasskeyRegistrationMutation(baseOptions?: Apollo.MutationHookOptions<StartPasskeyRegistrationMutation, StartPasskeyRegistrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartPasskeyRegistrationMutation, StartPasskeyRegistrationMutationVariables>(StartPasskeyRegistrationDocument, options);
      }
export type StartPasskeyRegistrationMutationHookResult = ReturnType<typeof useStartPasskeyRegistrationMutation>;
export type StartPasskeyRegistrationMutationResult = Apollo.MutationResult<StartPasskeyRegistrationMutation>;
export type StartPasskeyRegistrationMutationOptions = Apollo.BaseMutationOptions<StartPasskeyRegistrationMutation, StartPasskeyRegistrationMutationVariables>;
export const StartTotpEnrollmentDocument = gql`
    mutation StartTotpEnrollment {
  startTotpEnrollment {
    enrollmentId
    otpauthUrl
  }
}
    `;
export type StartTotpEnrollmentMutationFn = Apollo.MutationFunction<StartTotpEnrollmentMutation, StartTotpEnrollmentMutationVariables>;

/**
 * __useStartTotpEnrollmentMutation__
 *
 * To run a mutation, you first call `useStartTotpEnrollmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartTotpEnrollmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startTotpEnrollmentMutation, { data, loading, error }] = useStartTotpEnrollmentMutation({
 *   variables: {
 *   },
 * });
 */
export function useStartTotpEnrollmentMutation(baseOptions?: Apollo.MutationHookOptions<StartTotpEnrollmentMutation, StartTotpEnrollmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartTotpEnrollmentMutation, StartTotpEnrollmentMutationVariables>(StartTotpEnrollmentDocument, options);
      }
export type StartTotpEnrollmentMutationHookResult = ReturnType<typeof useStartTotpEnrollmentMutation>;
export type StartTotpEnrollmentMutationResult = Apollo.MutationResult<StartTotpEnrollmentMutation>;
export type StartTotpEnrollmentMutationOptions = Apollo.BaseMutationOptions<StartTotpEnrollmentMutation, StartTotpEnrollmentMutationVariables>;
export const UnarchiveProfileDocument = gql`
    mutation UnarchiveProfile($id: ID!) {
  unarchiveProfile(input: {profileId: $id})
}
    `;
export type UnarchiveProfileMutationFn = Apollo.MutationFunction<UnarchiveProfileMutation, UnarchiveProfileMutationVariables>;

/**
 * __useUnarchiveProfileMutation__
 *
 * To run a mutation, you first call `useUnarchiveProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnarchiveProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unarchiveProfileMutation, { data, loading, error }] = useUnarchiveProfileMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUnarchiveProfileMutation(baseOptions?: Apollo.MutationHookOptions<UnarchiveProfileMutation, UnarchiveProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnarchiveProfileMutation, UnarchiveProfileMutationVariables>(UnarchiveProfileDocument, options);
      }
export type UnarchiveProfileMutationHookResult = ReturnType<typeof useUnarchiveProfileMutation>;
export type UnarchiveProfileMutationResult = Apollo.MutationResult<UnarchiveProfileMutation>;
export type UnarchiveProfileMutationOptions = Apollo.BaseMutationOptions<UnarchiveProfileMutation, UnarchiveProfileMutationVariables>;
export const UnassignPaymentAccountDocument = gql`
    mutation UnassignPaymentAccount($input: UnassignPaymentAccountInput!) {
  unassignPaymentAccount(input: $input)
}
    `;
export type UnassignPaymentAccountMutationFn = Apollo.MutationFunction<UnassignPaymentAccountMutation, UnassignPaymentAccountMutationVariables>;

/**
 * __useUnassignPaymentAccountMutation__
 *
 * To run a mutation, you first call `useUnassignPaymentAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnassignPaymentAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unassignPaymentAccountMutation, { data, loading, error }] = useUnassignPaymentAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnassignPaymentAccountMutation(baseOptions?: Apollo.MutationHookOptions<UnassignPaymentAccountMutation, UnassignPaymentAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnassignPaymentAccountMutation, UnassignPaymentAccountMutationVariables>(UnassignPaymentAccountDocument, options);
      }
export type UnassignPaymentAccountMutationHookResult = ReturnType<typeof useUnassignPaymentAccountMutation>;
export type UnassignPaymentAccountMutationResult = Apollo.MutationResult<UnassignPaymentAccountMutation>;
export type UnassignPaymentAccountMutationOptions = Apollo.BaseMutationOptions<UnassignPaymentAccountMutation, UnassignPaymentAccountMutationVariables>;
export const UnassignProcedureProfileDocument = gql`
    mutation UnassignProcedureProfile($input: UnassignProcedureProfileInput!) {
  unassignProcedureProfile(input: $input)
}
    `;
export type UnassignProcedureProfileMutationFn = Apollo.MutationFunction<UnassignProcedureProfileMutation, UnassignProcedureProfileMutationVariables>;

/**
 * __useUnassignProcedureProfileMutation__
 *
 * To run a mutation, you first call `useUnassignProcedureProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnassignProcedureProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unassignProcedureProfileMutation, { data, loading, error }] = useUnassignProcedureProfileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnassignProcedureProfileMutation(baseOptions?: Apollo.MutationHookOptions<UnassignProcedureProfileMutation, UnassignProcedureProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnassignProcedureProfileMutation, UnassignProcedureProfileMutationVariables>(UnassignProcedureProfileDocument, options);
      }
export type UnassignProcedureProfileMutationHookResult = ReturnType<typeof useUnassignProcedureProfileMutation>;
export type UnassignProcedureProfileMutationResult = Apollo.MutationResult<UnassignProcedureProfileMutation>;
export type UnassignProcedureProfileMutationOptions = Apollo.BaseMutationOptions<UnassignProcedureProfileMutation, UnassignProcedureProfileMutationVariables>;
export const UnassignRoleDocument = gql`
    mutation UnassignRole($input: UnassignRoleInput!) {
  unassignRole(input: $input)
}
    `;
export type UnassignRoleMutationFn = Apollo.MutationFunction<UnassignRoleMutation, UnassignRoleMutationVariables>;

/**
 * __useUnassignRoleMutation__
 *
 * To run a mutation, you first call `useUnassignRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnassignRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unassignRoleMutation, { data, loading, error }] = useUnassignRoleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnassignRoleMutation(baseOptions?: Apollo.MutationHookOptions<UnassignRoleMutation, UnassignRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnassignRoleMutation, UnassignRoleMutationVariables>(UnassignRoleDocument, options);
      }
export type UnassignRoleMutationHookResult = ReturnType<typeof useUnassignRoleMutation>;
export type UnassignRoleMutationResult = Apollo.MutationResult<UnassignRoleMutation>;
export type UnassignRoleMutationOptions = Apollo.BaseMutationOptions<UnassignRoleMutation, UnassignRoleMutationVariables>;
export const UnlockFormDocument = gql`
    mutation UnlockForm($input: UnlockFormInput!) {
  unlockForm(input: $input) {
    ...RegularFormFields
  }
}
    ${RegularFormFieldsFragmentDoc}`;
export type UnlockFormMutationFn = Apollo.MutationFunction<UnlockFormMutation, UnlockFormMutationVariables>;

/**
 * __useUnlockFormMutation__
 *
 * To run a mutation, you first call `useUnlockFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlockFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlockFormMutation, { data, loading, error }] = useUnlockFormMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnlockFormMutation(baseOptions?: Apollo.MutationHookOptions<UnlockFormMutation, UnlockFormMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnlockFormMutation, UnlockFormMutationVariables>(UnlockFormDocument, options);
      }
export type UnlockFormMutationHookResult = ReturnType<typeof useUnlockFormMutation>;
export type UnlockFormMutationResult = Apollo.MutationResult<UnlockFormMutation>;
export type UnlockFormMutationOptions = Apollo.BaseMutationOptions<UnlockFormMutation, UnlockFormMutationVariables>;
export const UpdateApiKeyDocument = gql`
    mutation UpdateApiKey($input: UpdateApiKeyInput!) {
  updateApiKey(input: $input) {
    ...ApiKeyFields
  }
}
    ${ApiKeyFieldsFragmentDoc}`;
export type UpdateApiKeyMutationFn = Apollo.MutationFunction<UpdateApiKeyMutation, UpdateApiKeyMutationVariables>;

/**
 * __useUpdateApiKeyMutation__
 *
 * To run a mutation, you first call `useUpdateApiKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateApiKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateApiKeyMutation, { data, loading, error }] = useUpdateApiKeyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateApiKeyMutation(baseOptions?: Apollo.MutationHookOptions<UpdateApiKeyMutation, UpdateApiKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateApiKeyMutation, UpdateApiKeyMutationVariables>(UpdateApiKeyDocument, options);
      }
export type UpdateApiKeyMutationHookResult = ReturnType<typeof useUpdateApiKeyMutation>;
export type UpdateApiKeyMutationResult = Apollo.MutationResult<UpdateApiKeyMutation>;
export type UpdateApiKeyMutationOptions = Apollo.BaseMutationOptions<UpdateApiKeyMutation, UpdateApiKeyMutationVariables>;
export const UpdateAppointmentDocument = gql`
    mutation UpdateAppointment($input: UpdateAppointmentInput!) {
  updateAppointment(input: $input) {
    ...FullAppointmentFields
  }
}
    ${FullAppointmentFieldsFragmentDoc}`;
export type UpdateAppointmentMutationFn = Apollo.MutationFunction<UpdateAppointmentMutation, UpdateAppointmentMutationVariables>;

/**
 * __useUpdateAppointmentMutation__
 *
 * To run a mutation, you first call `useUpdateAppointmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAppointmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAppointmentMutation, { data, loading, error }] = useUpdateAppointmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAppointmentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAppointmentMutation, UpdateAppointmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAppointmentMutation, UpdateAppointmentMutationVariables>(UpdateAppointmentDocument, options);
      }
export type UpdateAppointmentMutationHookResult = ReturnType<typeof useUpdateAppointmentMutation>;
export type UpdateAppointmentMutationResult = Apollo.MutationResult<UpdateAppointmentMutation>;
export type UpdateAppointmentMutationOptions = Apollo.BaseMutationOptions<UpdateAppointmentMutation, UpdateAppointmentMutationVariables>;
export const UpdateAppointmentRequestDocument = gql`
    mutation UpdateAppointmentRequest($input: UpdateAppointmentRequestInput!) {
  updateAppointmentRequest(input: $input) {
    ...FullAppointmentRequestFields
  }
}
    ${FullAppointmentRequestFieldsFragmentDoc}`;
export type UpdateAppointmentRequestMutationFn = Apollo.MutationFunction<UpdateAppointmentRequestMutation, UpdateAppointmentRequestMutationVariables>;

/**
 * __useUpdateAppointmentRequestMutation__
 *
 * To run a mutation, you first call `useUpdateAppointmentRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAppointmentRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAppointmentRequestMutation, { data, loading, error }] = useUpdateAppointmentRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAppointmentRequestMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAppointmentRequestMutation, UpdateAppointmentRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAppointmentRequestMutation, UpdateAppointmentRequestMutationVariables>(UpdateAppointmentRequestDocument, options);
      }
export type UpdateAppointmentRequestMutationHookResult = ReturnType<typeof useUpdateAppointmentRequestMutation>;
export type UpdateAppointmentRequestMutationResult = Apollo.MutationResult<UpdateAppointmentRequestMutation>;
export type UpdateAppointmentRequestMutationOptions = Apollo.BaseMutationOptions<UpdateAppointmentRequestMutation, UpdateAppointmentRequestMutationVariables>;
export const UpdateAppointmentSecondaryParticipantsDocument = gql`
    mutation UpdateAppointmentSecondaryParticipants($input: UpdateAppointmentSecondaryParticipantsInput!) {
  updateAppointmentSecondaryParticipants(input: $input) {
    ...FullAppointmentFields
  }
}
    ${FullAppointmentFieldsFragmentDoc}`;
export type UpdateAppointmentSecondaryParticipantsMutationFn = Apollo.MutationFunction<UpdateAppointmentSecondaryParticipantsMutation, UpdateAppointmentSecondaryParticipantsMutationVariables>;

/**
 * __useUpdateAppointmentSecondaryParticipantsMutation__
 *
 * To run a mutation, you first call `useUpdateAppointmentSecondaryParticipantsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAppointmentSecondaryParticipantsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAppointmentSecondaryParticipantsMutation, { data, loading, error }] = useUpdateAppointmentSecondaryParticipantsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAppointmentSecondaryParticipantsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAppointmentSecondaryParticipantsMutation, UpdateAppointmentSecondaryParticipantsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAppointmentSecondaryParticipantsMutation, UpdateAppointmentSecondaryParticipantsMutationVariables>(UpdateAppointmentSecondaryParticipantsDocument, options);
      }
export type UpdateAppointmentSecondaryParticipantsMutationHookResult = ReturnType<typeof useUpdateAppointmentSecondaryParticipantsMutation>;
export type UpdateAppointmentSecondaryParticipantsMutationResult = Apollo.MutationResult<UpdateAppointmentSecondaryParticipantsMutation>;
export type UpdateAppointmentSecondaryParticipantsMutationOptions = Apollo.BaseMutationOptions<UpdateAppointmentSecondaryParticipantsMutation, UpdateAppointmentSecondaryParticipantsMutationVariables>;
export const UpdateAttentiveIntegrationDocument = gql`
    mutation UpdateAttentiveIntegration($input: UpdateAttentiveIntegrationInput!) {
  updateAttentiveIntegration(input: $input) {
    ...AttentiveFields
  }
}
    ${AttentiveFieldsFragmentDoc}`;
export type UpdateAttentiveIntegrationMutationFn = Apollo.MutationFunction<UpdateAttentiveIntegrationMutation, UpdateAttentiveIntegrationMutationVariables>;

/**
 * __useUpdateAttentiveIntegrationMutation__
 *
 * To run a mutation, you first call `useUpdateAttentiveIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAttentiveIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAttentiveIntegrationMutation, { data, loading, error }] = useUpdateAttentiveIntegrationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAttentiveIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAttentiveIntegrationMutation, UpdateAttentiveIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAttentiveIntegrationMutation, UpdateAttentiveIntegrationMutationVariables>(UpdateAttentiveIntegrationDocument, options);
      }
export type UpdateAttentiveIntegrationMutationHookResult = ReturnType<typeof useUpdateAttentiveIntegrationMutation>;
export type UpdateAttentiveIntegrationMutationResult = Apollo.MutationResult<UpdateAttentiveIntegrationMutation>;
export type UpdateAttentiveIntegrationMutationOptions = Apollo.BaseMutationOptions<UpdateAttentiveIntegrationMutation, UpdateAttentiveIntegrationMutationVariables>;
export const UpdateAvailabilityDocument = gql`
    mutation UpdateAvailability($input: UpdateAvailabilityInput!) {
  updateAvailability(input: $input) {
    ...AvailabilityFields
  }
}
    ${AvailabilityFieldsFragmentDoc}`;
export type UpdateAvailabilityMutationFn = Apollo.MutationFunction<UpdateAvailabilityMutation, UpdateAvailabilityMutationVariables>;

/**
 * __useUpdateAvailabilityMutation__
 *
 * To run a mutation, you first call `useUpdateAvailabilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAvailabilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAvailabilityMutation, { data, loading, error }] = useUpdateAvailabilityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAvailabilityMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAvailabilityMutation, UpdateAvailabilityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAvailabilityMutation, UpdateAvailabilityMutationVariables>(UpdateAvailabilityDocument, options);
      }
export type UpdateAvailabilityMutationHookResult = ReturnType<typeof useUpdateAvailabilityMutation>;
export type UpdateAvailabilityMutationResult = Apollo.MutationResult<UpdateAvailabilityMutation>;
export type UpdateAvailabilityMutationOptions = Apollo.BaseMutationOptions<UpdateAvailabilityMutation, UpdateAvailabilityMutationVariables>;
export const UpdateAvailabilityCoverageDocument = gql`
    mutation UpdateAvailabilityCoverage($input: UpdateAvailabilityCoverageInput!) {
  updateAvailabilityCoverage(input: $input) {
    ...AvailabilityCoverageFields
  }
}
    ${AvailabilityCoverageFieldsFragmentDoc}`;
export type UpdateAvailabilityCoverageMutationFn = Apollo.MutationFunction<UpdateAvailabilityCoverageMutation, UpdateAvailabilityCoverageMutationVariables>;

/**
 * __useUpdateAvailabilityCoverageMutation__
 *
 * To run a mutation, you first call `useUpdateAvailabilityCoverageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAvailabilityCoverageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAvailabilityCoverageMutation, { data, loading, error }] = useUpdateAvailabilityCoverageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAvailabilityCoverageMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAvailabilityCoverageMutation, UpdateAvailabilityCoverageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAvailabilityCoverageMutation, UpdateAvailabilityCoverageMutationVariables>(UpdateAvailabilityCoverageDocument, options);
      }
export type UpdateAvailabilityCoverageMutationHookResult = ReturnType<typeof useUpdateAvailabilityCoverageMutation>;
export type UpdateAvailabilityCoverageMutationResult = Apollo.MutationResult<UpdateAvailabilityCoverageMutation>;
export type UpdateAvailabilityCoverageMutationOptions = Apollo.BaseMutationOptions<UpdateAvailabilityCoverageMutation, UpdateAvailabilityCoverageMutationVariables>;
export const UpdateCheckoutDocument = gql`
    mutation UpdateCheckout($input: UpdateCheckoutInput!) {
  updateCheckout(input: $input) {
    ...CheckoutWithAppointmentFields
  }
}
    ${CheckoutWithAppointmentFieldsFragmentDoc}`;
export type UpdateCheckoutMutationFn = Apollo.MutationFunction<UpdateCheckoutMutation, UpdateCheckoutMutationVariables>;

/**
 * __useUpdateCheckoutMutation__
 *
 * To run a mutation, you first call `useUpdateCheckoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCheckoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCheckoutMutation, { data, loading, error }] = useUpdateCheckoutMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCheckoutMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCheckoutMutation, UpdateCheckoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCheckoutMutation, UpdateCheckoutMutationVariables>(UpdateCheckoutDocument, options);
      }
export type UpdateCheckoutMutationHookResult = ReturnType<typeof useUpdateCheckoutMutation>;
export type UpdateCheckoutMutationResult = Apollo.MutationResult<UpdateCheckoutMutation>;
export type UpdateCheckoutMutationOptions = Apollo.BaseMutationOptions<UpdateCheckoutMutation, UpdateCheckoutMutationVariables>;
export const UpdateClientProfileDocument = gql`
    mutation UpdateClientProfile($input: UpdateClientProfileInput!) {
  updateClientProfile(input: $input) {
    ...ClientProfileFields
    internalNotesUpdatedBy
    internalNotesUpdatedAt
  }
}
    ${ClientProfileFieldsFragmentDoc}`;
export type UpdateClientProfileMutationFn = Apollo.MutationFunction<UpdateClientProfileMutation, UpdateClientProfileMutationVariables>;

/**
 * __useUpdateClientProfileMutation__
 *
 * To run a mutation, you first call `useUpdateClientProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClientProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClientProfileMutation, { data, loading, error }] = useUpdateClientProfileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateClientProfileMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClientProfileMutation, UpdateClientProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClientProfileMutation, UpdateClientProfileMutationVariables>(UpdateClientProfileDocument, options);
      }
export type UpdateClientProfileMutationHookResult = ReturnType<typeof useUpdateClientProfileMutation>;
export type UpdateClientProfileMutationResult = Apollo.MutationResult<UpdateClientProfileMutation>;
export type UpdateClientProfileMutationOptions = Apollo.BaseMutationOptions<UpdateClientProfileMutation, UpdateClientProfileMutationVariables>;
export const UpdateDiscountDocument = gql`
    mutation UpdateDiscount($input: UpdateDiscountInput!) {
  updateDiscount(input: $input) {
    ...DiscountFields
  }
}
    ${DiscountFieldsFragmentDoc}`;
export type UpdateDiscountMutationFn = Apollo.MutationFunction<UpdateDiscountMutation, UpdateDiscountMutationVariables>;

/**
 * __useUpdateDiscountMutation__
 *
 * To run a mutation, you first call `useUpdateDiscountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDiscountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDiscountMutation, { data, loading, error }] = useUpdateDiscountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDiscountMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDiscountMutation, UpdateDiscountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDiscountMutation, UpdateDiscountMutationVariables>(UpdateDiscountDocument, options);
      }
export type UpdateDiscountMutationHookResult = ReturnType<typeof useUpdateDiscountMutation>;
export type UpdateDiscountMutationResult = Apollo.MutationResult<UpdateDiscountMutation>;
export type UpdateDiscountMutationOptions = Apollo.BaseMutationOptions<UpdateDiscountMutation, UpdateDiscountMutationVariables>;
export const UpdateDocumentDocument = gql`
    mutation UpdateDocument($input: UpdateDocumentInput!) {
  updateDocument(input: $input) {
    ...DocumentFields
  }
}
    ${DocumentFieldsFragmentDoc}`;
export type UpdateDocumentMutationFn = Apollo.MutationFunction<UpdateDocumentMutation, UpdateDocumentMutationVariables>;

/**
 * __useUpdateDocumentMutation__
 *
 * To run a mutation, you first call `useUpdateDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDocumentMutation, { data, loading, error }] = useUpdateDocumentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDocumentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDocumentMutation, UpdateDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDocumentMutation, UpdateDocumentMutationVariables>(UpdateDocumentDocument, options);
      }
export type UpdateDocumentMutationHookResult = ReturnType<typeof useUpdateDocumentMutation>;
export type UpdateDocumentMutationResult = Apollo.MutationResult<UpdateDocumentMutation>;
export type UpdateDocumentMutationOptions = Apollo.BaseMutationOptions<UpdateDocumentMutation, UpdateDocumentMutationVariables>;
export const UpdateEmrInstanceDocument = gql`
    mutation UpdateEmrInstance($input: UpdateEmrInstanceInput!) {
  updateEmrInstance(input: $input) {
    ...EmrInstanceFields
  }
}
    ${EmrInstanceFieldsFragmentDoc}`;
export type UpdateEmrInstanceMutationFn = Apollo.MutationFunction<UpdateEmrInstanceMutation, UpdateEmrInstanceMutationVariables>;

/**
 * __useUpdateEmrInstanceMutation__
 *
 * To run a mutation, you first call `useUpdateEmrInstanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEmrInstanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEmrInstanceMutation, { data, loading, error }] = useUpdateEmrInstanceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEmrInstanceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEmrInstanceMutation, UpdateEmrInstanceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEmrInstanceMutation, UpdateEmrInstanceMutationVariables>(UpdateEmrInstanceDocument, options);
      }
export type UpdateEmrInstanceMutationHookResult = ReturnType<typeof useUpdateEmrInstanceMutation>;
export type UpdateEmrInstanceMutationResult = Apollo.MutationResult<UpdateEmrInstanceMutation>;
export type UpdateEmrInstanceMutationOptions = Apollo.BaseMutationOptions<UpdateEmrInstanceMutation, UpdateEmrInstanceMutationVariables>;
export const UpdateFormNoteDocument = gql`
    mutation UpdateFormNote($input: UpdateFormNoteInput!) {
  updateFormNote(input: $input) {
    ...FormNoteFields
  }
}
    ${FormNoteFieldsFragmentDoc}`;
export type UpdateFormNoteMutationFn = Apollo.MutationFunction<UpdateFormNoteMutation, UpdateFormNoteMutationVariables>;

/**
 * __useUpdateFormNoteMutation__
 *
 * To run a mutation, you first call `useUpdateFormNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFormNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFormNoteMutation, { data, loading, error }] = useUpdateFormNoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateFormNoteMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFormNoteMutation, UpdateFormNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFormNoteMutation, UpdateFormNoteMutationVariables>(UpdateFormNoteDocument, options);
      }
export type UpdateFormNoteMutationHookResult = ReturnType<typeof useUpdateFormNoteMutation>;
export type UpdateFormNoteMutationResult = Apollo.MutationResult<UpdateFormNoteMutation>;
export type UpdateFormNoteMutationOptions = Apollo.BaseMutationOptions<UpdateFormNoteMutation, UpdateFormNoteMutationVariables>;
export const UpdateFormTemplateDocument = gql`
    mutation UpdateFormTemplate($input: UpdateFormTemplateInput!) {
  updateFormTemplate(input: $input) {
    ...FormTemplateFields
  }
}
    ${FormTemplateFieldsFragmentDoc}`;
export type UpdateFormTemplateMutationFn = Apollo.MutationFunction<UpdateFormTemplateMutation, UpdateFormTemplateMutationVariables>;

/**
 * __useUpdateFormTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateFormTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFormTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFormTemplateMutation, { data, loading, error }] = useUpdateFormTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateFormTemplateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFormTemplateMutation, UpdateFormTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFormTemplateMutation, UpdateFormTemplateMutationVariables>(UpdateFormTemplateDocument, options);
      }
export type UpdateFormTemplateMutationHookResult = ReturnType<typeof useUpdateFormTemplateMutation>;
export type UpdateFormTemplateMutationResult = Apollo.MutationResult<UpdateFormTemplateMutation>;
export type UpdateFormTemplateMutationOptions = Apollo.BaseMutationOptions<UpdateFormTemplateMutation, UpdateFormTemplateMutationVariables>;
export const UpdateGeoperimeterDocument = gql`
    mutation UpdateGeoperimeter($input: UpdateGeoperimeterInput!) {
  updateGeoperimeter(input: $input) {
    ...GeoperimeterFields
  }
}
    ${GeoperimeterFieldsFragmentDoc}`;
export type UpdateGeoperimeterMutationFn = Apollo.MutationFunction<UpdateGeoperimeterMutation, UpdateGeoperimeterMutationVariables>;

/**
 * __useUpdateGeoperimeterMutation__
 *
 * To run a mutation, you first call `useUpdateGeoperimeterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGeoperimeterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGeoperimeterMutation, { data, loading, error }] = useUpdateGeoperimeterMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateGeoperimeterMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGeoperimeterMutation, UpdateGeoperimeterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGeoperimeterMutation, UpdateGeoperimeterMutationVariables>(UpdateGeoperimeterDocument, options);
      }
export type UpdateGeoperimeterMutationHookResult = ReturnType<typeof useUpdateGeoperimeterMutation>;
export type UpdateGeoperimeterMutationResult = Apollo.MutationResult<UpdateGeoperimeterMutation>;
export type UpdateGeoperimeterMutationOptions = Apollo.BaseMutationOptions<UpdateGeoperimeterMutation, UpdateGeoperimeterMutationVariables>;
export const UpdateGroupAppointmentDocument = gql`
    mutation UpdateGroupAppointment($input: UpdateGroupAppointmentInput!) {
  updateGroupAppointment(input: $input) {
    ...FullAppointmentFields
  }
}
    ${FullAppointmentFieldsFragmentDoc}`;
export type UpdateGroupAppointmentMutationFn = Apollo.MutationFunction<UpdateGroupAppointmentMutation, UpdateGroupAppointmentMutationVariables>;

/**
 * __useUpdateGroupAppointmentMutation__
 *
 * To run a mutation, you first call `useUpdateGroupAppointmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGroupAppointmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGroupAppointmentMutation, { data, loading, error }] = useUpdateGroupAppointmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateGroupAppointmentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGroupAppointmentMutation, UpdateGroupAppointmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGroupAppointmentMutation, UpdateGroupAppointmentMutationVariables>(UpdateGroupAppointmentDocument, options);
      }
export type UpdateGroupAppointmentMutationHookResult = ReturnType<typeof useUpdateGroupAppointmentMutation>;
export type UpdateGroupAppointmentMutationResult = Apollo.MutationResult<UpdateGroupAppointmentMutation>;
export type UpdateGroupAppointmentMutationOptions = Apollo.BaseMutationOptions<UpdateGroupAppointmentMutation, UpdateGroupAppointmentMutationVariables>;
export const UpdateMarketplaceDocument = gql`
    mutation UpdateMarketplace($input: UpdateMarketplaceInput!) {
  updateMarketplace(input: $input) {
    ...MarketplaceSettingsFields
  }
}
    ${MarketplaceSettingsFieldsFragmentDoc}`;
export type UpdateMarketplaceMutationFn = Apollo.MutationFunction<UpdateMarketplaceMutation, UpdateMarketplaceMutationVariables>;

/**
 * __useUpdateMarketplaceMutation__
 *
 * To run a mutation, you first call `useUpdateMarketplaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMarketplaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMarketplaceMutation, { data, loading, error }] = useUpdateMarketplaceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMarketplaceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMarketplaceMutation, UpdateMarketplaceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMarketplaceMutation, UpdateMarketplaceMutationVariables>(UpdateMarketplaceDocument, options);
      }
export type UpdateMarketplaceMutationHookResult = ReturnType<typeof useUpdateMarketplaceMutation>;
export type UpdateMarketplaceMutationResult = Apollo.MutationResult<UpdateMarketplaceMutation>;
export type UpdateMarketplaceMutationOptions = Apollo.BaseMutationOptions<UpdateMarketplaceMutation, UpdateMarketplaceMutationVariables>;
export const UpdateMarketplaceCheckoutNotesDocument = gql`
    mutation UpdateMarketplaceCheckoutNotes($input: UpdateMarketplaceCheckoutNotesInput!) {
  updateMarketplaceCheckoutNotes(input: $input) {
    id
    checkoutNotes {
      ...CheckoutNoteItemFields
    }
  }
}
    ${CheckoutNoteItemFieldsFragmentDoc}`;
export type UpdateMarketplaceCheckoutNotesMutationFn = Apollo.MutationFunction<UpdateMarketplaceCheckoutNotesMutation, UpdateMarketplaceCheckoutNotesMutationVariables>;

/**
 * __useUpdateMarketplaceCheckoutNotesMutation__
 *
 * To run a mutation, you first call `useUpdateMarketplaceCheckoutNotesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMarketplaceCheckoutNotesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMarketplaceCheckoutNotesMutation, { data, loading, error }] = useUpdateMarketplaceCheckoutNotesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMarketplaceCheckoutNotesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMarketplaceCheckoutNotesMutation, UpdateMarketplaceCheckoutNotesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMarketplaceCheckoutNotesMutation, UpdateMarketplaceCheckoutNotesMutationVariables>(UpdateMarketplaceCheckoutNotesDocument, options);
      }
export type UpdateMarketplaceCheckoutNotesMutationHookResult = ReturnType<typeof useUpdateMarketplaceCheckoutNotesMutation>;
export type UpdateMarketplaceCheckoutNotesMutationResult = Apollo.MutationResult<UpdateMarketplaceCheckoutNotesMutation>;
export type UpdateMarketplaceCheckoutNotesMutationOptions = Apollo.BaseMutationOptions<UpdateMarketplaceCheckoutNotesMutation, UpdateMarketplaceCheckoutNotesMutationVariables>;
export const UpdateMarketplaceGroupDocument = gql`
    mutation UpdateMarketplaceGroup($input: UpdateMarketplaceGroupInput!) {
  updateMarketplaceGroup(input: $input) {
    ...MarketplaceGroupFields
  }
}
    ${MarketplaceGroupFieldsFragmentDoc}`;
export type UpdateMarketplaceGroupMutationFn = Apollo.MutationFunction<UpdateMarketplaceGroupMutation, UpdateMarketplaceGroupMutationVariables>;

/**
 * __useUpdateMarketplaceGroupMutation__
 *
 * To run a mutation, you first call `useUpdateMarketplaceGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMarketplaceGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMarketplaceGroupMutation, { data, loading, error }] = useUpdateMarketplaceGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMarketplaceGroupMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMarketplaceGroupMutation, UpdateMarketplaceGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMarketplaceGroupMutation, UpdateMarketplaceGroupMutationVariables>(UpdateMarketplaceGroupDocument, options);
      }
export type UpdateMarketplaceGroupMutationHookResult = ReturnType<typeof useUpdateMarketplaceGroupMutation>;
export type UpdateMarketplaceGroupMutationResult = Apollo.MutationResult<UpdateMarketplaceGroupMutation>;
export type UpdateMarketplaceGroupMutationOptions = Apollo.BaseMutationOptions<UpdateMarketplaceGroupMutation, UpdateMarketplaceGroupMutationVariables>;
export const UpdateMarketplaceMfaModeDocument = gql`
    mutation UpdateMarketplaceMfaMode($input: UpdateMarketplaceMfaModeInput!) {
  updateMarketplaceMfaMode(input: $input) {
    id
    mfaMode {
      ...MfaScopeModeFields
    }
  }
}
    ${MfaScopeModeFieldsFragmentDoc}`;
export type UpdateMarketplaceMfaModeMutationFn = Apollo.MutationFunction<UpdateMarketplaceMfaModeMutation, UpdateMarketplaceMfaModeMutationVariables>;

/**
 * __useUpdateMarketplaceMfaModeMutation__
 *
 * To run a mutation, you first call `useUpdateMarketplaceMfaModeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMarketplaceMfaModeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMarketplaceMfaModeMutation, { data, loading, error }] = useUpdateMarketplaceMfaModeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMarketplaceMfaModeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMarketplaceMfaModeMutation, UpdateMarketplaceMfaModeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMarketplaceMfaModeMutation, UpdateMarketplaceMfaModeMutationVariables>(UpdateMarketplaceMfaModeDocument, options);
      }
export type UpdateMarketplaceMfaModeMutationHookResult = ReturnType<typeof useUpdateMarketplaceMfaModeMutation>;
export type UpdateMarketplaceMfaModeMutationResult = Apollo.MutationResult<UpdateMarketplaceMfaModeMutation>;
export type UpdateMarketplaceMfaModeMutationOptions = Apollo.BaseMutationOptions<UpdateMarketplaceMfaModeMutation, UpdateMarketplaceMfaModeMutationVariables>;
export const UpdateMarketplaceUserDocument = gql`
    mutation UpdateMarketplaceUser($input: UpdateMarketplaceUserInput!) {
  updateMarketplaceUser(input: $input) {
    ...MarketplaceUserFields
  }
}
    ${MarketplaceUserFieldsFragmentDoc}`;
export type UpdateMarketplaceUserMutationFn = Apollo.MutationFunction<UpdateMarketplaceUserMutation, UpdateMarketplaceUserMutationVariables>;

/**
 * __useUpdateMarketplaceUserMutation__
 *
 * To run a mutation, you first call `useUpdateMarketplaceUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMarketplaceUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMarketplaceUserMutation, { data, loading, error }] = useUpdateMarketplaceUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMarketplaceUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMarketplaceUserMutation, UpdateMarketplaceUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMarketplaceUserMutation, UpdateMarketplaceUserMutationVariables>(UpdateMarketplaceUserDocument, options);
      }
export type UpdateMarketplaceUserMutationHookResult = ReturnType<typeof useUpdateMarketplaceUserMutation>;
export type UpdateMarketplaceUserMutationResult = Apollo.MutationResult<UpdateMarketplaceUserMutation>;
export type UpdateMarketplaceUserMutationOptions = Apollo.BaseMutationOptions<UpdateMarketplaceUserMutation, UpdateMarketplaceUserMutationVariables>;
export const UpdateMedicationDocument = gql`
    mutation UpdateMedication($input: UpdateMedicationInput!) {
  updateMedication(input: $input) {
    ...MedicationFields
  }
}
    ${MedicationFieldsFragmentDoc}`;
export type UpdateMedicationMutationFn = Apollo.MutationFunction<UpdateMedicationMutation, UpdateMedicationMutationVariables>;

/**
 * __useUpdateMedicationMutation__
 *
 * To run a mutation, you first call `useUpdateMedicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMedicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMedicationMutation, { data, loading, error }] = useUpdateMedicationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMedicationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMedicationMutation, UpdateMedicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMedicationMutation, UpdateMedicationMutationVariables>(UpdateMedicationDocument, options);
      }
export type UpdateMedicationMutationHookResult = ReturnType<typeof useUpdateMedicationMutation>;
export type UpdateMedicationMutationResult = Apollo.MutationResult<UpdateMedicationMutation>;
export type UpdateMedicationMutationOptions = Apollo.BaseMutationOptions<UpdateMedicationMutation, UpdateMedicationMutationVariables>;
export const UpdateMembershipDocument = gql`
    mutation UpdateMembership($input: UpdateMembershipInput!) {
  updateMembership(input: $input) {
    ...MembershipFields
  }
}
    ${MembershipFieldsFragmentDoc}`;
export type UpdateMembershipMutationFn = Apollo.MutationFunction<UpdateMembershipMutation, UpdateMembershipMutationVariables>;

/**
 * __useUpdateMembershipMutation__
 *
 * To run a mutation, you first call `useUpdateMembershipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMembershipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMembershipMutation, { data, loading, error }] = useUpdateMembershipMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMembershipMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMembershipMutation, UpdateMembershipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMembershipMutation, UpdateMembershipMutationVariables>(UpdateMembershipDocument, options);
      }
export type UpdateMembershipMutationHookResult = ReturnType<typeof useUpdateMembershipMutation>;
export type UpdateMembershipMutationResult = Apollo.MutationResult<UpdateMembershipMutation>;
export type UpdateMembershipMutationOptions = Apollo.BaseMutationOptions<UpdateMembershipMutation, UpdateMembershipMutationVariables>;
export const UpdateMembershipDefinitionDocument = gql`
    mutation UpdateMembershipDefinition($input: UpdateMembershipDefinitionInput!) {
  updateMembershipDefinition(input: $input) {
    ...FullMembershipDefinitionFields
  }
}
    ${FullMembershipDefinitionFieldsFragmentDoc}`;
export type UpdateMembershipDefinitionMutationFn = Apollo.MutationFunction<UpdateMembershipDefinitionMutation, UpdateMembershipDefinitionMutationVariables>;

/**
 * __useUpdateMembershipDefinitionMutation__
 *
 * To run a mutation, you first call `useUpdateMembershipDefinitionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMembershipDefinitionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMembershipDefinitionMutation, { data, loading, error }] = useUpdateMembershipDefinitionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMembershipDefinitionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMembershipDefinitionMutation, UpdateMembershipDefinitionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMembershipDefinitionMutation, UpdateMembershipDefinitionMutationVariables>(UpdateMembershipDefinitionDocument, options);
      }
export type UpdateMembershipDefinitionMutationHookResult = ReturnType<typeof useUpdateMembershipDefinitionMutation>;
export type UpdateMembershipDefinitionMutationResult = Apollo.MutationResult<UpdateMembershipDefinitionMutation>;
export type UpdateMembershipDefinitionMutationOptions = Apollo.BaseMutationOptions<UpdateMembershipDefinitionMutation, UpdateMembershipDefinitionMutationVariables>;
export const UpdateNavigationGroupDocument = gql`
    mutation UpdateNavigationGroup($input: UpdateConfigGroupInput!) {
  updateNavigationGroup(input: $input) {
    ...ProcedureBaseDefGroupFields
  }
}
    ${ProcedureBaseDefGroupFieldsFragmentDoc}`;
export type UpdateNavigationGroupMutationFn = Apollo.MutationFunction<UpdateNavigationGroupMutation, UpdateNavigationGroupMutationVariables>;

/**
 * __useUpdateNavigationGroupMutation__
 *
 * To run a mutation, you first call `useUpdateNavigationGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNavigationGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNavigationGroupMutation, { data, loading, error }] = useUpdateNavigationGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateNavigationGroupMutation(baseOptions?: Apollo.MutationHookOptions<UpdateNavigationGroupMutation, UpdateNavigationGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateNavigationGroupMutation, UpdateNavigationGroupMutationVariables>(UpdateNavigationGroupDocument, options);
      }
export type UpdateNavigationGroupMutationHookResult = ReturnType<typeof useUpdateNavigationGroupMutation>;
export type UpdateNavigationGroupMutationResult = Apollo.MutationResult<UpdateNavigationGroupMutation>;
export type UpdateNavigationGroupMutationOptions = Apollo.BaseMutationOptions<UpdateNavigationGroupMutation, UpdateNavigationGroupMutationVariables>;
export const UpdateNotificationsGroupDocument = gql`
    mutation UpdateNotificationsGroup($input: UpdateConfigGroupInput!) {
  updateNotificationsGroup(input: $input) {
    ...ProcedureBaseDefGroupFields
  }
}
    ${ProcedureBaseDefGroupFieldsFragmentDoc}`;
export type UpdateNotificationsGroupMutationFn = Apollo.MutationFunction<UpdateNotificationsGroupMutation, UpdateNotificationsGroupMutationVariables>;

/**
 * __useUpdateNotificationsGroupMutation__
 *
 * To run a mutation, you first call `useUpdateNotificationsGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNotificationsGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNotificationsGroupMutation, { data, loading, error }] = useUpdateNotificationsGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateNotificationsGroupMutation(baseOptions?: Apollo.MutationHookOptions<UpdateNotificationsGroupMutation, UpdateNotificationsGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateNotificationsGroupMutation, UpdateNotificationsGroupMutationVariables>(UpdateNotificationsGroupDocument, options);
      }
export type UpdateNotificationsGroupMutationHookResult = ReturnType<typeof useUpdateNotificationsGroupMutation>;
export type UpdateNotificationsGroupMutationResult = Apollo.MutationResult<UpdateNotificationsGroupMutation>;
export type UpdateNotificationsGroupMutationOptions = Apollo.BaseMutationOptions<UpdateNotificationsGroupMutation, UpdateNotificationsGroupMutationVariables>;
export const UpdateOrderDocument = gql`
    mutation UpdateOrder($input: UpdateOrderInput!) {
  updateOrder(input: $input) {
    ...OrderFields
  }
}
    ${OrderFieldsFragmentDoc}`;
export type UpdateOrderMutationFn = Apollo.MutationFunction<UpdateOrderMutation, UpdateOrderMutationVariables>;

/**
 * __useUpdateOrderMutation__
 *
 * To run a mutation, you first call `useUpdateOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrderMutation, { data, loading, error }] = useUpdateOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrderMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrderMutation, UpdateOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrderMutation, UpdateOrderMutationVariables>(UpdateOrderDocument, options);
      }
export type UpdateOrderMutationHookResult = ReturnType<typeof useUpdateOrderMutation>;
export type UpdateOrderMutationResult = Apollo.MutationResult<UpdateOrderMutation>;
export type UpdateOrderMutationOptions = Apollo.BaseMutationOptions<UpdateOrderMutation, UpdateOrderMutationVariables>;
export const UpdateOrganizationDocument = gql`
    mutation UpdateOrganization($input: UpdateOrganizationInput!) {
  updateOrganization(input: $input) {
    ...OrganizationSettingsFields
  }
}
    ${OrganizationSettingsFieldsFragmentDoc}`;
export type UpdateOrganizationMutationFn = Apollo.MutationFunction<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>;

/**
 * __useUpdateOrganizationMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationMutation, { data, loading, error }] = useUpdateOrganizationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>(UpdateOrganizationDocument, options);
      }
export type UpdateOrganizationMutationHookResult = ReturnType<typeof useUpdateOrganizationMutation>;
export type UpdateOrganizationMutationResult = Apollo.MutationResult<UpdateOrganizationMutation>;
export type UpdateOrganizationMutationOptions = Apollo.BaseMutationOptions<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>;
export const UpdateOrganizationMfaModeDocument = gql`
    mutation UpdateOrganizationMfaMode($input: UpdateOrganizationMfaModeInput!) {
  updateOrganizationMfaMode(input: $input) {
    id
    mfaMode {
      ...MfaScopeModeFields
    }
  }
}
    ${MfaScopeModeFieldsFragmentDoc}`;
export type UpdateOrganizationMfaModeMutationFn = Apollo.MutationFunction<UpdateOrganizationMfaModeMutation, UpdateOrganizationMfaModeMutationVariables>;

/**
 * __useUpdateOrganizationMfaModeMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationMfaModeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationMfaModeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationMfaModeMutation, { data, loading, error }] = useUpdateOrganizationMfaModeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrganizationMfaModeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrganizationMfaModeMutation, UpdateOrganizationMfaModeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrganizationMfaModeMutation, UpdateOrganizationMfaModeMutationVariables>(UpdateOrganizationMfaModeDocument, options);
      }
export type UpdateOrganizationMfaModeMutationHookResult = ReturnType<typeof useUpdateOrganizationMfaModeMutation>;
export type UpdateOrganizationMfaModeMutationResult = Apollo.MutationResult<UpdateOrganizationMfaModeMutation>;
export type UpdateOrganizationMfaModeMutationOptions = Apollo.BaseMutationOptions<UpdateOrganizationMfaModeMutation, UpdateOrganizationMfaModeMutationVariables>;
export const UpdatePackageDocument = gql`
    mutation UpdatePackage($input: UpdatePackageInput!) {
  updatePackage(input: $input) {
    ...FullPackageFields
  }
}
    ${FullPackageFieldsFragmentDoc}`;
export type UpdatePackageMutationFn = Apollo.MutationFunction<UpdatePackageMutation, UpdatePackageMutationVariables>;

/**
 * __useUpdatePackageMutation__
 *
 * To run a mutation, you first call `useUpdatePackageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePackageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePackageMutation, { data, loading, error }] = useUpdatePackageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePackageMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePackageMutation, UpdatePackageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePackageMutation, UpdatePackageMutationVariables>(UpdatePackageDocument, options);
      }
export type UpdatePackageMutationHookResult = ReturnType<typeof useUpdatePackageMutation>;
export type UpdatePackageMutationResult = Apollo.MutationResult<UpdatePackageMutation>;
export type UpdatePackageMutationOptions = Apollo.BaseMutationOptions<UpdatePackageMutation, UpdatePackageMutationVariables>;
export const UpdatePackageItemDocument = gql`
    mutation UpdatePackageItem($input: UpdatePackageItemInput!) {
  updatePackageItem(input: $input) {
    ...PackageItemFields
  }
}
    ${PackageItemFieldsFragmentDoc}`;
export type UpdatePackageItemMutationFn = Apollo.MutationFunction<UpdatePackageItemMutation, UpdatePackageItemMutationVariables>;

/**
 * __useUpdatePackageItemMutation__
 *
 * To run a mutation, you first call `useUpdatePackageItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePackageItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePackageItemMutation, { data, loading, error }] = useUpdatePackageItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePackageItemMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePackageItemMutation, UpdatePackageItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePackageItemMutation, UpdatePackageItemMutationVariables>(UpdatePackageItemDocument, options);
      }
export type UpdatePackageItemMutationHookResult = ReturnType<typeof useUpdatePackageItemMutation>;
export type UpdatePackageItemMutationResult = Apollo.MutationResult<UpdatePackageItemMutation>;
export type UpdatePackageItemMutationOptions = Apollo.BaseMutationOptions<UpdatePackageItemMutation, UpdatePackageItemMutationVariables>;
export const UpdatePackageItemDefinitionDocument = gql`
    mutation UpdatePackageItemDefinition($input: UpdatePackageItemDefinitionInput!) {
  updatePackageItemDefinition(input: $input) {
    ...PackageItemDefinitionFields
  }
}
    ${PackageItemDefinitionFieldsFragmentDoc}`;
export type UpdatePackageItemDefinitionMutationFn = Apollo.MutationFunction<UpdatePackageItemDefinitionMutation, UpdatePackageItemDefinitionMutationVariables>;

/**
 * __useUpdatePackageItemDefinitionMutation__
 *
 * To run a mutation, you first call `useUpdatePackageItemDefinitionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePackageItemDefinitionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePackageItemDefinitionMutation, { data, loading, error }] = useUpdatePackageItemDefinitionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePackageItemDefinitionMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePackageItemDefinitionMutation, UpdatePackageItemDefinitionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePackageItemDefinitionMutation, UpdatePackageItemDefinitionMutationVariables>(UpdatePackageItemDefinitionDocument, options);
      }
export type UpdatePackageItemDefinitionMutationHookResult = ReturnType<typeof useUpdatePackageItemDefinitionMutation>;
export type UpdatePackageItemDefinitionMutationResult = Apollo.MutationResult<UpdatePackageItemDefinitionMutation>;
export type UpdatePackageItemDefinitionMutationOptions = Apollo.BaseMutationOptions<UpdatePackageItemDefinitionMutation, UpdatePackageItemDefinitionMutationVariables>;
export const UpdatePatientDocument = gql`
    mutation UpdatePatient($input: UpdatePatientInput!) {
  updatePatient(input: $input) {
    ...PatientFields
  }
}
    ${PatientFieldsFragmentDoc}`;
export type UpdatePatientMutationFn = Apollo.MutationFunction<UpdatePatientMutation, UpdatePatientMutationVariables>;

/**
 * __useUpdatePatientMutation__
 *
 * To run a mutation, you first call `useUpdatePatientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePatientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePatientMutation, { data, loading, error }] = useUpdatePatientMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePatientMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePatientMutation, UpdatePatientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePatientMutation, UpdatePatientMutationVariables>(UpdatePatientDocument, options);
      }
export type UpdatePatientMutationHookResult = ReturnType<typeof useUpdatePatientMutation>;
export type UpdatePatientMutationResult = Apollo.MutationResult<UpdatePatientMutation>;
export type UpdatePatientMutationOptions = Apollo.BaseMutationOptions<UpdatePatientMutation, UpdatePatientMutationVariables>;
export const UpdatePaymentAccountDocument = gql`
    mutation UpdatePaymentAccount($input: UpdatePaymentAccountInput!) {
  updatePaymentAccount(input: $input) {
    ...PaymentAccountFields
  }
}
    ${PaymentAccountFieldsFragmentDoc}`;
export type UpdatePaymentAccountMutationFn = Apollo.MutationFunction<UpdatePaymentAccountMutation, UpdatePaymentAccountMutationVariables>;

/**
 * __useUpdatePaymentAccountMutation__
 *
 * To run a mutation, you first call `useUpdatePaymentAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePaymentAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePaymentAccountMutation, { data, loading, error }] = useUpdatePaymentAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePaymentAccountMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePaymentAccountMutation, UpdatePaymentAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePaymentAccountMutation, UpdatePaymentAccountMutationVariables>(UpdatePaymentAccountDocument, options);
      }
export type UpdatePaymentAccountMutationHookResult = ReturnType<typeof useUpdatePaymentAccountMutation>;
export type UpdatePaymentAccountMutationResult = Apollo.MutationResult<UpdatePaymentAccountMutation>;
export type UpdatePaymentAccountMutationOptions = Apollo.BaseMutationOptions<UpdatePaymentAccountMutation, UpdatePaymentAccountMutationVariables>;
export const UpdateProcedureBaseDefinitionDocument = gql`
    mutation UpdateProcedureBaseDefinition($input: UpdateProcedureBaseDefinitionInput!) {
  updateProcedureBaseDefinition(input: $input) {
    ...FullProcedureBaseDefFields
  }
}
    ${FullProcedureBaseDefFieldsFragmentDoc}`;
export type UpdateProcedureBaseDefinitionMutationFn = Apollo.MutationFunction<UpdateProcedureBaseDefinitionMutation, UpdateProcedureBaseDefinitionMutationVariables>;

/**
 * __useUpdateProcedureBaseDefinitionMutation__
 *
 * To run a mutation, you first call `useUpdateProcedureBaseDefinitionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProcedureBaseDefinitionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProcedureBaseDefinitionMutation, { data, loading, error }] = useUpdateProcedureBaseDefinitionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProcedureBaseDefinitionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProcedureBaseDefinitionMutation, UpdateProcedureBaseDefinitionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProcedureBaseDefinitionMutation, UpdateProcedureBaseDefinitionMutationVariables>(UpdateProcedureBaseDefinitionDocument, options);
      }
export type UpdateProcedureBaseDefinitionMutationHookResult = ReturnType<typeof useUpdateProcedureBaseDefinitionMutation>;
export type UpdateProcedureBaseDefinitionMutationResult = Apollo.MutationResult<UpdateProcedureBaseDefinitionMutation>;
export type UpdateProcedureBaseDefinitionMutationOptions = Apollo.BaseMutationOptions<UpdateProcedureBaseDefinitionMutation, UpdateProcedureBaseDefinitionMutationVariables>;
export const UpdateProcedureBaseDefGroupDocument = gql`
    mutation UpdateProcedureBaseDefGroup($input: UpdateProcedureBaseDefinitionGroupInput!) {
  updateProcedureBaseDefinitionGroup(input: $input) {
    ...ProcedureBaseDefGroupFields
  }
}
    ${ProcedureBaseDefGroupFieldsFragmentDoc}`;
export type UpdateProcedureBaseDefGroupMutationFn = Apollo.MutationFunction<UpdateProcedureBaseDefGroupMutation, UpdateProcedureBaseDefGroupMutationVariables>;

/**
 * __useUpdateProcedureBaseDefGroupMutation__
 *
 * To run a mutation, you first call `useUpdateProcedureBaseDefGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProcedureBaseDefGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProcedureBaseDefGroupMutation, { data, loading, error }] = useUpdateProcedureBaseDefGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProcedureBaseDefGroupMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProcedureBaseDefGroupMutation, UpdateProcedureBaseDefGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProcedureBaseDefGroupMutation, UpdateProcedureBaseDefGroupMutationVariables>(UpdateProcedureBaseDefGroupDocument, options);
      }
export type UpdateProcedureBaseDefGroupMutationHookResult = ReturnType<typeof useUpdateProcedureBaseDefGroupMutation>;
export type UpdateProcedureBaseDefGroupMutationResult = Apollo.MutationResult<UpdateProcedureBaseDefGroupMutation>;
export type UpdateProcedureBaseDefGroupMutationOptions = Apollo.BaseMutationOptions<UpdateProcedureBaseDefGroupMutation, UpdateProcedureBaseDefGroupMutationVariables>;
export const UpdateProcedureDefinitionDocument = gql`
    mutation UpdateProcedureDefinition($input: UpdateProcedureDefinitionInput!) {
  updateProcedureDefinition(input: $input) {
    ...ProcedureDefFields
    baseDefinitions {
      ...ProcedureBaseDefFields
    }
    medicationProtocols {
      ...MedicationProtocolFields
      medication {
        ...MedicationFields
      }
    }
    consentForms {
      ...DocumentFields
    }
  }
}
    ${ProcedureDefFieldsFragmentDoc}
${ProcedureBaseDefFieldsFragmentDoc}
${MedicationProtocolFieldsFragmentDoc}
${MedicationFieldsFragmentDoc}
${DocumentFieldsFragmentDoc}`;
export type UpdateProcedureDefinitionMutationFn = Apollo.MutationFunction<UpdateProcedureDefinitionMutation, UpdateProcedureDefinitionMutationVariables>;

/**
 * __useUpdateProcedureDefinitionMutation__
 *
 * To run a mutation, you first call `useUpdateProcedureDefinitionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProcedureDefinitionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProcedureDefinitionMutation, { data, loading, error }] = useUpdateProcedureDefinitionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProcedureDefinitionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProcedureDefinitionMutation, UpdateProcedureDefinitionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProcedureDefinitionMutation, UpdateProcedureDefinitionMutationVariables>(UpdateProcedureDefinitionDocument, options);
      }
export type UpdateProcedureDefinitionMutationHookResult = ReturnType<typeof useUpdateProcedureDefinitionMutation>;
export type UpdateProcedureDefinitionMutationResult = Apollo.MutationResult<UpdateProcedureDefinitionMutation>;
export type UpdateProcedureDefinitionMutationOptions = Apollo.BaseMutationOptions<UpdateProcedureDefinitionMutation, UpdateProcedureDefinitionMutationVariables>;
export const UpdateProcedureProfileDocument = gql`
    mutation UpdateProcedureProfile($input: UpdateProcedureProfileInput!) {
  updateProcedureProfile(input: $input) {
    ...ProcedureProfileFields
    procedureDefs {
      ...ProcedureDefFields
    }
  }
}
    ${ProcedureProfileFieldsFragmentDoc}
${ProcedureDefFieldsFragmentDoc}`;
export type UpdateProcedureProfileMutationFn = Apollo.MutationFunction<UpdateProcedureProfileMutation, UpdateProcedureProfileMutationVariables>;

/**
 * __useUpdateProcedureProfileMutation__
 *
 * To run a mutation, you first call `useUpdateProcedureProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProcedureProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProcedureProfileMutation, { data, loading, error }] = useUpdateProcedureProfileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProcedureProfileMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProcedureProfileMutation, UpdateProcedureProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProcedureProfileMutation, UpdateProcedureProfileMutationVariables>(UpdateProcedureProfileDocument, options);
      }
export type UpdateProcedureProfileMutationHookResult = ReturnType<typeof useUpdateProcedureProfileMutation>;
export type UpdateProcedureProfileMutationResult = Apollo.MutationResult<UpdateProcedureProfileMutation>;
export type UpdateProcedureProfileMutationOptions = Apollo.BaseMutationOptions<UpdateProcedureProfileMutation, UpdateProcedureProfileMutationVariables>;
export const UpdateProfileDocument = gql`
    mutation UpdateProfile($input: UpdateProfileInput!) {
  updateProfile(input: $input) {
    ...FullProfile
  }
}
    ${FullProfileFragmentDoc}`;
export type UpdateProfileMutationFn = Apollo.MutationFunction<UpdateProfileMutation, UpdateProfileMutationVariables>;

/**
 * __useUpdateProfileMutation__
 *
 * To run a mutation, you first call `useUpdateProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProfileMutation, { data, loading, error }] = useUpdateProfileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProfileMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProfileMutation, UpdateProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProfileMutation, UpdateProfileMutationVariables>(UpdateProfileDocument, options);
      }
export type UpdateProfileMutationHookResult = ReturnType<typeof useUpdateProfileMutation>;
export type UpdateProfileMutationResult = Apollo.MutationResult<UpdateProfileMutation>;
export type UpdateProfileMutationOptions = Apollo.BaseMutationOptions<UpdateProfileMutation, UpdateProfileMutationVariables>;
export const UpdatePromoCodeDocument = gql`
    mutation UpdatePromoCode($input: UpdatePromoCodeInput!) {
  updatePromoCode(input: $input) {
    ...PromoCodeFields
  }
}
    ${PromoCodeFieldsFragmentDoc}`;
export type UpdatePromoCodeMutationFn = Apollo.MutationFunction<UpdatePromoCodeMutation, UpdatePromoCodeMutationVariables>;

/**
 * __useUpdatePromoCodeMutation__
 *
 * To run a mutation, you first call `useUpdatePromoCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePromoCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePromoCodeMutation, { data, loading, error }] = useUpdatePromoCodeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePromoCodeMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePromoCodeMutation, UpdatePromoCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePromoCodeMutation, UpdatePromoCodeMutationVariables>(UpdatePromoCodeDocument, options);
      }
export type UpdatePromoCodeMutationHookResult = ReturnType<typeof useUpdatePromoCodeMutation>;
export type UpdatePromoCodeMutationResult = Apollo.MutationResult<UpdatePromoCodeMutation>;
export type UpdatePromoCodeMutationOptions = Apollo.BaseMutationOptions<UpdatePromoCodeMutation, UpdatePromoCodeMutationVariables>;
export const UpdateQualiphyExamDocument = gql`
    mutation UpdateQualiphyExam($input: UpdateQualiphyExamInput!) {
  updateQualiphyExam(input: $input) {
    ...QualiphyExamFields
  }
}
    ${QualiphyExamFieldsFragmentDoc}`;
export type UpdateQualiphyExamMutationFn = Apollo.MutationFunction<UpdateQualiphyExamMutation, UpdateQualiphyExamMutationVariables>;

/**
 * __useUpdateQualiphyExamMutation__
 *
 * To run a mutation, you first call `useUpdateQualiphyExamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateQualiphyExamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateQualiphyExamMutation, { data, loading, error }] = useUpdateQualiphyExamMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateQualiphyExamMutation(baseOptions?: Apollo.MutationHookOptions<UpdateQualiphyExamMutation, UpdateQualiphyExamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateQualiphyExamMutation, UpdateQualiphyExamMutationVariables>(UpdateQualiphyExamDocument, options);
      }
export type UpdateQualiphyExamMutationHookResult = ReturnType<typeof useUpdateQualiphyExamMutation>;
export type UpdateQualiphyExamMutationResult = Apollo.MutationResult<UpdateQualiphyExamMutation>;
export type UpdateQualiphyExamMutationOptions = Apollo.BaseMutationOptions<UpdateQualiphyExamMutation, UpdateQualiphyExamMutationVariables>;
export const UpdateQualiphyIntegrationDocument = gql`
    mutation UpdateQualiphyIntegration($input: UpdateQualiphyIntegrationInput!) {
  updateQualiphyIntegration(input: $input) {
    ...QualiphyFields
  }
}
    ${QualiphyFieldsFragmentDoc}`;
export type UpdateQualiphyIntegrationMutationFn = Apollo.MutationFunction<UpdateQualiphyIntegrationMutation, UpdateQualiphyIntegrationMutationVariables>;

/**
 * __useUpdateQualiphyIntegrationMutation__
 *
 * To run a mutation, you first call `useUpdateQualiphyIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateQualiphyIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateQualiphyIntegrationMutation, { data, loading, error }] = useUpdateQualiphyIntegrationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateQualiphyIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateQualiphyIntegrationMutation, UpdateQualiphyIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateQualiphyIntegrationMutation, UpdateQualiphyIntegrationMutationVariables>(UpdateQualiphyIntegrationDocument, options);
      }
export type UpdateQualiphyIntegrationMutationHookResult = ReturnType<typeof useUpdateQualiphyIntegrationMutation>;
export type UpdateQualiphyIntegrationMutationResult = Apollo.MutationResult<UpdateQualiphyIntegrationMutation>;
export type UpdateQualiphyIntegrationMutationOptions = Apollo.BaseMutationOptions<UpdateQualiphyIntegrationMutation, UpdateQualiphyIntegrationMutationVariables>;
export const UpdateReviewsGroupDocument = gql`
    mutation UpdateReviewsGroup($input: UpdateConfigGroupInput!) {
  updateReviewsGroup(input: $input) {
    ...ProcedureBaseDefGroupFields
  }
}
    ${ProcedureBaseDefGroupFieldsFragmentDoc}`;
export type UpdateReviewsGroupMutationFn = Apollo.MutationFunction<UpdateReviewsGroupMutation, UpdateReviewsGroupMutationVariables>;

/**
 * __useUpdateReviewsGroupMutation__
 *
 * To run a mutation, you first call `useUpdateReviewsGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReviewsGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReviewsGroupMutation, { data, loading, error }] = useUpdateReviewsGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateReviewsGroupMutation(baseOptions?: Apollo.MutationHookOptions<UpdateReviewsGroupMutation, UpdateReviewsGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateReviewsGroupMutation, UpdateReviewsGroupMutationVariables>(UpdateReviewsGroupDocument, options);
      }
export type UpdateReviewsGroupMutationHookResult = ReturnType<typeof useUpdateReviewsGroupMutation>;
export type UpdateReviewsGroupMutationResult = Apollo.MutationResult<UpdateReviewsGroupMutation>;
export type UpdateReviewsGroupMutationOptions = Apollo.BaseMutationOptions<UpdateReviewsGroupMutation, UpdateReviewsGroupMutationVariables>;
export const UpdateRoleDocument = gql`
    mutation UpdateRole($input: UpdateRoleInput!) {
  updateRole(input: $input) {
    ...RoleFields
  }
}
    ${RoleFieldsFragmentDoc}`;
export type UpdateRoleMutationFn = Apollo.MutationFunction<UpdateRoleMutation, UpdateRoleMutationVariables>;

/**
 * __useUpdateRoleMutation__
 *
 * To run a mutation, you first call `useUpdateRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRoleMutation, { data, loading, error }] = useUpdateRoleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateRoleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRoleMutation, UpdateRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRoleMutation, UpdateRoleMutationVariables>(UpdateRoleDocument, options);
      }
export type UpdateRoleMutationHookResult = ReturnType<typeof useUpdateRoleMutation>;
export type UpdateRoleMutationResult = Apollo.MutationResult<UpdateRoleMutation>;
export type UpdateRoleMutationOptions = Apollo.BaseMutationOptions<UpdateRoleMutation, UpdateRoleMutationVariables>;
export const UpdateSegmentIntegrationDocument = gql`
    mutation UpdateSegmentIntegration($input: UpdateSegmentIntegrationInput!) {
  updateSegmentIntegration(input: $input) {
    ...SegmentFields
  }
}
    ${SegmentFieldsFragmentDoc}`;
export type UpdateSegmentIntegrationMutationFn = Apollo.MutationFunction<UpdateSegmentIntegrationMutation, UpdateSegmentIntegrationMutationVariables>;

/**
 * __useUpdateSegmentIntegrationMutation__
 *
 * To run a mutation, you first call `useUpdateSegmentIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSegmentIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSegmentIntegrationMutation, { data, loading, error }] = useUpdateSegmentIntegrationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSegmentIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSegmentIntegrationMutation, UpdateSegmentIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSegmentIntegrationMutation, UpdateSegmentIntegrationMutationVariables>(UpdateSegmentIntegrationDocument, options);
      }
export type UpdateSegmentIntegrationMutationHookResult = ReturnType<typeof useUpdateSegmentIntegrationMutation>;
export type UpdateSegmentIntegrationMutationResult = Apollo.MutationResult<UpdateSegmentIntegrationMutation>;
export type UpdateSegmentIntegrationMutationOptions = Apollo.BaseMutationOptions<UpdateSegmentIntegrationMutation, UpdateSegmentIntegrationMutationVariables>;
export const UpdateSendgridIntegrationDocument = gql`
    mutation UpdateSendgridIntegration($input: UpdateSendgridIntegrationInput!) {
  updateSendgridIntegration(input: $input) {
    ...SendgridFields
  }
}
    ${SendgridFieldsFragmentDoc}`;
export type UpdateSendgridIntegrationMutationFn = Apollo.MutationFunction<UpdateSendgridIntegrationMutation, UpdateSendgridIntegrationMutationVariables>;

/**
 * __useUpdateSendgridIntegrationMutation__
 *
 * To run a mutation, you first call `useUpdateSendgridIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSendgridIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSendgridIntegrationMutation, { data, loading, error }] = useUpdateSendgridIntegrationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSendgridIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSendgridIntegrationMutation, UpdateSendgridIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSendgridIntegrationMutation, UpdateSendgridIntegrationMutationVariables>(UpdateSendgridIntegrationDocument, options);
      }
export type UpdateSendgridIntegrationMutationHookResult = ReturnType<typeof useUpdateSendgridIntegrationMutation>;
export type UpdateSendgridIntegrationMutationResult = Apollo.MutationResult<UpdateSendgridIntegrationMutation>;
export type UpdateSendgridIntegrationMutationOptions = Apollo.BaseMutationOptions<UpdateSendgridIntegrationMutation, UpdateSendgridIntegrationMutationVariables>;
export const UpdateTwilioIntegrationDocument = gql`
    mutation UpdateTwilioIntegration($input: UpdateTwilioIntegrationInput!) {
  updateTwilioIntegration(input: $input) {
    ...TwilioFields
  }
}
    ${TwilioFieldsFragmentDoc}`;
export type UpdateTwilioIntegrationMutationFn = Apollo.MutationFunction<UpdateTwilioIntegrationMutation, UpdateTwilioIntegrationMutationVariables>;

/**
 * __useUpdateTwilioIntegrationMutation__
 *
 * To run a mutation, you first call `useUpdateTwilioIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTwilioIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTwilioIntegrationMutation, { data, loading, error }] = useUpdateTwilioIntegrationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTwilioIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTwilioIntegrationMutation, UpdateTwilioIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTwilioIntegrationMutation, UpdateTwilioIntegrationMutationVariables>(UpdateTwilioIntegrationDocument, options);
      }
export type UpdateTwilioIntegrationMutationHookResult = ReturnType<typeof useUpdateTwilioIntegrationMutation>;
export type UpdateTwilioIntegrationMutationResult = Apollo.MutationResult<UpdateTwilioIntegrationMutation>;
export type UpdateTwilioIntegrationMutationOptions = Apollo.BaseMutationOptions<UpdateTwilioIntegrationMutation, UpdateTwilioIntegrationMutationVariables>;
export const UsePaymentAccountDocument = gql`
    mutation UsePaymentAccount($input: UsePaymentAccountInput!) {
  usePaymentAccount(input: $input)
}
    `;
export type UsePaymentAccountMutationFn = Apollo.MutationFunction<UsePaymentAccountMutation, UsePaymentAccountMutationVariables>;

/**
 * __useUsePaymentAccountMutation__
 *
 * To run a mutation, you first call `useUsePaymentAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUsePaymentAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [usePaymentAccountMutation, { data, loading, error }] = useUsePaymentAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUsePaymentAccountMutation(baseOptions?: Apollo.MutationHookOptions<UsePaymentAccountMutation, UsePaymentAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UsePaymentAccountMutation, UsePaymentAccountMutationVariables>(UsePaymentAccountDocument, options);
      }
export type UsePaymentAccountMutationHookResult = ReturnType<typeof useUsePaymentAccountMutation>;
export type UsePaymentAccountMutationResult = Apollo.MutationResult<UsePaymentAccountMutation>;
export type UsePaymentAccountMutationOptions = Apollo.BaseMutationOptions<UsePaymentAccountMutation, UsePaymentAccountMutationVariables>;
export const VerifyMfaDocument = gql`
    mutation VerifyMfa($input: VerifyMfaInput!) {
  verifyMfa(input: $input) {
    user {
      id
    }
  }
}
    `;
export type VerifyMfaMutationFn = Apollo.MutationFunction<VerifyMfaMutation, VerifyMfaMutationVariables>;

/**
 * __useVerifyMfaMutation__
 *
 * To run a mutation, you first call `useVerifyMfaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyMfaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyMfaMutation, { data, loading, error }] = useVerifyMfaMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useVerifyMfaMutation(baseOptions?: Apollo.MutationHookOptions<VerifyMfaMutation, VerifyMfaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyMfaMutation, VerifyMfaMutationVariables>(VerifyMfaDocument, options);
      }
export type VerifyMfaMutationHookResult = ReturnType<typeof useVerifyMfaMutation>;
export type VerifyMfaMutationResult = Apollo.MutationResult<VerifyMfaMutation>;
export type VerifyMfaMutationOptions = Apollo.BaseMutationOptions<VerifyMfaMutation, VerifyMfaMutationVariables>;
export const VerifyMfaStepUpDocument = gql`
    mutation VerifyMfaStepUp($input: VerifyMfaStepUpInput!) {
  verifyMfaStepUp(input: $input) {
    user {
      id
    }
  }
}
    `;
export type VerifyMfaStepUpMutationFn = Apollo.MutationFunction<VerifyMfaStepUpMutation, VerifyMfaStepUpMutationVariables>;

/**
 * __useVerifyMfaStepUpMutation__
 *
 * To run a mutation, you first call `useVerifyMfaStepUpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyMfaStepUpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyMfaStepUpMutation, { data, loading, error }] = useVerifyMfaStepUpMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useVerifyMfaStepUpMutation(baseOptions?: Apollo.MutationHookOptions<VerifyMfaStepUpMutation, VerifyMfaStepUpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyMfaStepUpMutation, VerifyMfaStepUpMutationVariables>(VerifyMfaStepUpDocument, options);
      }
export type VerifyMfaStepUpMutationHookResult = ReturnType<typeof useVerifyMfaStepUpMutation>;
export type VerifyMfaStepUpMutationResult = Apollo.MutationResult<VerifyMfaStepUpMutation>;
export type VerifyMfaStepUpMutationOptions = Apollo.BaseMutationOptions<VerifyMfaStepUpMutation, VerifyMfaStepUpMutationVariables>;
export const WaitlistAppointmentRequestDocument = gql`
    mutation WaitlistAppointmentRequest($input: WaitlistAppointmentRequestInput!) {
  waitlistAppointmentRequest(input: $input) {
    ...FullAppointmentRequestFields
  }
}
    ${FullAppointmentRequestFieldsFragmentDoc}`;
export type WaitlistAppointmentRequestMutationFn = Apollo.MutationFunction<WaitlistAppointmentRequestMutation, WaitlistAppointmentRequestMutationVariables>;

/**
 * __useWaitlistAppointmentRequestMutation__
 *
 * To run a mutation, you first call `useWaitlistAppointmentRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWaitlistAppointmentRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [waitlistAppointmentRequestMutation, { data, loading, error }] = useWaitlistAppointmentRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useWaitlistAppointmentRequestMutation(baseOptions?: Apollo.MutationHookOptions<WaitlistAppointmentRequestMutation, WaitlistAppointmentRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WaitlistAppointmentRequestMutation, WaitlistAppointmentRequestMutationVariables>(WaitlistAppointmentRequestDocument, options);
      }
export type WaitlistAppointmentRequestMutationHookResult = ReturnType<typeof useWaitlistAppointmentRequestMutation>;
export type WaitlistAppointmentRequestMutationResult = Apollo.MutationResult<WaitlistAppointmentRequestMutation>;
export type WaitlistAppointmentRequestMutationOptions = Apollo.BaseMutationOptions<WaitlistAppointmentRequestMutation, WaitlistAppointmentRequestMutationVariables>;
export const AppointmentDocument = gql`
    query Appointment($id: ID!) {
  appointment(id: $id) {
    ...FullAppointmentFields
    ...AppointmentIntakeFields
  }
}
    ${FullAppointmentFieldsFragmentDoc}
${AppointmentIntakeFieldsFragmentDoc}`;

/**
 * __useAppointmentQuery__
 *
 * To run a query within a React component, call `useAppointmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useAppointmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAppointmentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAppointmentQuery(baseOptions: Apollo.QueryHookOptions<AppointmentQuery, AppointmentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AppointmentQuery, AppointmentQueryVariables>(AppointmentDocument, options);
      }
export function useAppointmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AppointmentQuery, AppointmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AppointmentQuery, AppointmentQueryVariables>(AppointmentDocument, options);
        }
export type AppointmentQueryHookResult = ReturnType<typeof useAppointmentQuery>;
export type AppointmentLazyQueryHookResult = ReturnType<typeof useAppointmentLazyQuery>;
export type AppointmentQueryResult = Apollo.QueryResult<AppointmentQuery, AppointmentQueryVariables>;
export const AppointmentIntakeDocument = gql`
    query AppointmentIntake($id: ID!) {
  appointment(id: $id) {
    id
    ...AppointmentIntakeFields
  }
}
    ${AppointmentIntakeFieldsFragmentDoc}`;

/**
 * __useAppointmentIntakeQuery__
 *
 * To run a query within a React component, call `useAppointmentIntakeQuery` and pass it any options that fit your needs.
 * When your component renders, `useAppointmentIntakeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAppointmentIntakeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAppointmentIntakeQuery(baseOptions: Apollo.QueryHookOptions<AppointmentIntakeQuery, AppointmentIntakeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AppointmentIntakeQuery, AppointmentIntakeQueryVariables>(AppointmentIntakeDocument, options);
      }
export function useAppointmentIntakeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AppointmentIntakeQuery, AppointmentIntakeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AppointmentIntakeQuery, AppointmentIntakeQueryVariables>(AppointmentIntakeDocument, options);
        }
export type AppointmentIntakeQueryHookResult = ReturnType<typeof useAppointmentIntakeQuery>;
export type AppointmentIntakeLazyQueryHookResult = ReturnType<typeof useAppointmentIntakeLazyQuery>;
export type AppointmentIntakeQueryResult = Apollo.QueryResult<AppointmentIntakeQuery, AppointmentIntakeQueryVariables>;
export const AppointmentRequestDocument = gql`
    query AppointmentRequest($id: ID!) {
  appointmentRequest(id: $id) {
    ...FullAppointmentRequestFields
    constraints {
      ...AppointmentConstraintFields
      candidates {
        ...AppointmentCandidateFields
      }
      appointments {
        ...FullAppointmentFields
      }
    }
  }
}
    ${FullAppointmentRequestFieldsFragmentDoc}
${AppointmentConstraintFieldsFragmentDoc}
${AppointmentCandidateFieldsFragmentDoc}
${FullAppointmentFieldsFragmentDoc}`;

/**
 * __useAppointmentRequestQuery__
 *
 * To run a query within a React component, call `useAppointmentRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useAppointmentRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAppointmentRequestQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAppointmentRequestQuery(baseOptions: Apollo.QueryHookOptions<AppointmentRequestQuery, AppointmentRequestQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AppointmentRequestQuery, AppointmentRequestQueryVariables>(AppointmentRequestDocument, options);
      }
export function useAppointmentRequestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AppointmentRequestQuery, AppointmentRequestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AppointmentRequestQuery, AppointmentRequestQueryVariables>(AppointmentRequestDocument, options);
        }
export type AppointmentRequestQueryHookResult = ReturnType<typeof useAppointmentRequestQuery>;
export type AppointmentRequestLazyQueryHookResult = ReturnType<typeof useAppointmentRequestLazyQuery>;
export type AppointmentRequestQueryResult = Apollo.QueryResult<AppointmentRequestQuery, AppointmentRequestQueryVariables>;
export const AppointmentRequestsDocument = gql`
    query AppointmentRequests($page: AppointmentRequestPageInput) {
  appointmentRequests(page: $page) {
    totalCount
    data {
      ...PaginatedAppointmentRequestFields
    }
  }
}
    ${PaginatedAppointmentRequestFieldsFragmentDoc}`;

/**
 * __useAppointmentRequestsQuery__
 *
 * To run a query within a React component, call `useAppointmentRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAppointmentRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAppointmentRequestsQuery({
 *   variables: {
 *      page: // value for 'page'
 *   },
 * });
 */
export function useAppointmentRequestsQuery(baseOptions?: Apollo.QueryHookOptions<AppointmentRequestsQuery, AppointmentRequestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AppointmentRequestsQuery, AppointmentRequestsQueryVariables>(AppointmentRequestsDocument, options);
      }
export function useAppointmentRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AppointmentRequestsQuery, AppointmentRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AppointmentRequestsQuery, AppointmentRequestsQueryVariables>(AppointmentRequestsDocument, options);
        }
export type AppointmentRequestsQueryHookResult = ReturnType<typeof useAppointmentRequestsQuery>;
export type AppointmentRequestsLazyQueryHookResult = ReturnType<typeof useAppointmentRequestsLazyQuery>;
export type AppointmentRequestsQueryResult = Apollo.QueryResult<AppointmentRequestsQuery, AppointmentRequestsQueryVariables>;
export const AppointmentsByGroupDocument = gql`
    query AppointmentsByGroup($groupId: String!) {
  appointmentsByGroup(groupId: $groupId) {
    ...FullAppointmentFields
  }
}
    ${FullAppointmentFieldsFragmentDoc}`;

/**
 * __useAppointmentsByGroupQuery__
 *
 * To run a query within a React component, call `useAppointmentsByGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useAppointmentsByGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAppointmentsByGroupQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useAppointmentsByGroupQuery(baseOptions: Apollo.QueryHookOptions<AppointmentsByGroupQuery, AppointmentsByGroupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AppointmentsByGroupQuery, AppointmentsByGroupQueryVariables>(AppointmentsByGroupDocument, options);
      }
export function useAppointmentsByGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AppointmentsByGroupQuery, AppointmentsByGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AppointmentsByGroupQuery, AppointmentsByGroupQueryVariables>(AppointmentsByGroupDocument, options);
        }
export type AppointmentsByGroupQueryHookResult = ReturnType<typeof useAppointmentsByGroupQuery>;
export type AppointmentsByGroupLazyQueryHookResult = ReturnType<typeof useAppointmentsByGroupLazyQuery>;
export type AppointmentsByGroupQueryResult = Apollo.QueryResult<AppointmentsByGroupQuery, AppointmentsByGroupQueryVariables>;
export const CheckoutDocument = gql`
    query Checkout($id: ID!) {
  checkout(id: $id) {
    ...CheckoutWithAppointmentFields
  }
}
    ${CheckoutWithAppointmentFieldsFragmentDoc}`;

/**
 * __useCheckoutQuery__
 *
 * To run a query within a React component, call `useCheckoutQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckoutQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckoutQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCheckoutQuery(baseOptions: Apollo.QueryHookOptions<CheckoutQuery, CheckoutQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckoutQuery, CheckoutQueryVariables>(CheckoutDocument, options);
      }
export function useCheckoutLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckoutQuery, CheckoutQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckoutQuery, CheckoutQueryVariables>(CheckoutDocument, options);
        }
export type CheckoutQueryHookResult = ReturnType<typeof useCheckoutQuery>;
export type CheckoutLazyQueryHookResult = ReturnType<typeof useCheckoutLazyQuery>;
export type CheckoutQueryResult = Apollo.QueryResult<CheckoutQuery, CheckoutQueryVariables>;
export const CheckoutsDocument = gql`
    query Checkouts($page: CheckoutPageInput) {
  checkouts(page: $page) {
    totalCount
    data {
      ...PaginatedCheckoutFields
    }
  }
}
    ${PaginatedCheckoutFieldsFragmentDoc}`;

/**
 * __useCheckoutsQuery__
 *
 * To run a query within a React component, call `useCheckoutsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckoutsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckoutsQuery({
 *   variables: {
 *      page: // value for 'page'
 *   },
 * });
 */
export function useCheckoutsQuery(baseOptions?: Apollo.QueryHookOptions<CheckoutsQuery, CheckoutsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckoutsQuery, CheckoutsQueryVariables>(CheckoutsDocument, options);
      }
export function useCheckoutsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckoutsQuery, CheckoutsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckoutsQuery, CheckoutsQueryVariables>(CheckoutsDocument, options);
        }
export type CheckoutsQueryHookResult = ReturnType<typeof useCheckoutsQuery>;
export type CheckoutsLazyQueryHookResult = ReturnType<typeof useCheckoutsLazyQuery>;
export type CheckoutsQueryResult = Apollo.QueryResult<CheckoutsQuery, CheckoutsQueryVariables>;
export const ClientProfileDocument = gql`
    query ClientProfile($id: ID!) {
  clientProfile(id: $id) {
    ...FullClientProfileFields
  }
}
    ${FullClientProfileFieldsFragmentDoc}`;

/**
 * __useClientProfileQuery__
 *
 * To run a query within a React component, call `useClientProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientProfileQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useClientProfileQuery(baseOptions: Apollo.QueryHookOptions<ClientProfileQuery, ClientProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClientProfileQuery, ClientProfileQueryVariables>(ClientProfileDocument, options);
      }
export function useClientProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClientProfileQuery, ClientProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClientProfileQuery, ClientProfileQueryVariables>(ClientProfileDocument, options);
        }
export type ClientProfileQueryHookResult = ReturnType<typeof useClientProfileQuery>;
export type ClientProfileLazyQueryHookResult = ReturnType<typeof useClientProfileLazyQuery>;
export type ClientProfileQueryResult = Apollo.QueryResult<ClientProfileQuery, ClientProfileQueryVariables>;
export const ClientProfileAppointmentsDocument = gql`
    query ClientProfileAppointments($id: ID!, $limit: Int!, $offset: Int!) {
  clientProfile(id: $id) {
    id
    appointments(page: {limit: $limit, offset: $offset}) {
      ...AppointmentSummaryFields
    }
  }
}
    ${AppointmentSummaryFieldsFragmentDoc}`;

/**
 * __useClientProfileAppointmentsQuery__
 *
 * To run a query within a React component, call `useClientProfileAppointmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientProfileAppointmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientProfileAppointmentsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useClientProfileAppointmentsQuery(baseOptions: Apollo.QueryHookOptions<ClientProfileAppointmentsQuery, ClientProfileAppointmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClientProfileAppointmentsQuery, ClientProfileAppointmentsQueryVariables>(ClientProfileAppointmentsDocument, options);
      }
export function useClientProfileAppointmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClientProfileAppointmentsQuery, ClientProfileAppointmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClientProfileAppointmentsQuery, ClientProfileAppointmentsQueryVariables>(ClientProfileAppointmentsDocument, options);
        }
export type ClientProfileAppointmentsQueryHookResult = ReturnType<typeof useClientProfileAppointmentsQuery>;
export type ClientProfileAppointmentsLazyQueryHookResult = ReturnType<typeof useClientProfileAppointmentsLazyQuery>;
export type ClientProfileAppointmentsQueryResult = Apollo.QueryResult<ClientProfileAppointmentsQuery, ClientProfileAppointmentsQueryVariables>;
export const ClientProfileMarketplaceUserDocument = gql`
    query ClientProfileMarketplaceUser($id: ID!, $groupId: ID) {
  clientProfile(id: $id) {
    ...ClientProfileFields
    marketplaceUsers(groupId: $groupId) {
      ...FullMarketplaceUserFields
    }
  }
}
    ${ClientProfileFieldsFragmentDoc}
${FullMarketplaceUserFieldsFragmentDoc}`;

/**
 * __useClientProfileMarketplaceUserQuery__
 *
 * To run a query within a React component, call `useClientProfileMarketplaceUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientProfileMarketplaceUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientProfileMarketplaceUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useClientProfileMarketplaceUserQuery(baseOptions: Apollo.QueryHookOptions<ClientProfileMarketplaceUserQuery, ClientProfileMarketplaceUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClientProfileMarketplaceUserQuery, ClientProfileMarketplaceUserQueryVariables>(ClientProfileMarketplaceUserDocument, options);
      }
export function useClientProfileMarketplaceUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClientProfileMarketplaceUserQuery, ClientProfileMarketplaceUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClientProfileMarketplaceUserQuery, ClientProfileMarketplaceUserQueryVariables>(ClientProfileMarketplaceUserDocument, options);
        }
export type ClientProfileMarketplaceUserQueryHookResult = ReturnType<typeof useClientProfileMarketplaceUserQuery>;
export type ClientProfileMarketplaceUserLazyQueryHookResult = ReturnType<typeof useClientProfileMarketplaceUserLazyQuery>;
export type ClientProfileMarketplaceUserQueryResult = Apollo.QueryResult<ClientProfileMarketplaceUserQuery, ClientProfileMarketplaceUserQueryVariables>;
export const ClientProfilesDocument = gql`
    query ClientProfiles($page: ClientProfilePageInput) {
  clientProfiles(page: $page) {
    totalCount
    data {
      ...ClientProfileFields
    }
  }
}
    ${ClientProfileFieldsFragmentDoc}`;

/**
 * __useClientProfilesQuery__
 *
 * To run a query within a React component, call `useClientProfilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientProfilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientProfilesQuery({
 *   variables: {
 *      page: // value for 'page'
 *   },
 * });
 */
export function useClientProfilesQuery(baseOptions?: Apollo.QueryHookOptions<ClientProfilesQuery, ClientProfilesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClientProfilesQuery, ClientProfilesQueryVariables>(ClientProfilesDocument, options);
      }
export function useClientProfilesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClientProfilesQuery, ClientProfilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClientProfilesQuery, ClientProfilesQueryVariables>(ClientProfilesDocument, options);
        }
export type ClientProfilesQueryHookResult = ReturnType<typeof useClientProfilesQuery>;
export type ClientProfilesLazyQueryHookResult = ReturnType<typeof useClientProfilesLazyQuery>;
export type ClientProfilesQueryResult = Apollo.QueryResult<ClientProfilesQuery, ClientProfilesQueryVariables>;
export const EmrInstanceDocument = gql`
    query EmrInstance($id: ID!) {
  emrInstance(id: $id) {
    ...EmrInstanceFields
    formTemplates {
      ...FormTemplateFields
    }
    consentForms {
      ...DocumentFields
    }
    organizations {
      ...OrganizationFields
    }
  }
}
    ${EmrInstanceFieldsFragmentDoc}
${FormTemplateFieldsFragmentDoc}
${DocumentFieldsFragmentDoc}
${OrganizationFieldsFragmentDoc}`;

/**
 * __useEmrInstanceQuery__
 *
 * To run a query within a React component, call `useEmrInstanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmrInstanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmrInstanceQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEmrInstanceQuery(baseOptions: Apollo.QueryHookOptions<EmrInstanceQuery, EmrInstanceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmrInstanceQuery, EmrInstanceQueryVariables>(EmrInstanceDocument, options);
      }
export function useEmrInstanceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmrInstanceQuery, EmrInstanceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmrInstanceQuery, EmrInstanceQueryVariables>(EmrInstanceDocument, options);
        }
export type EmrInstanceQueryHookResult = ReturnType<typeof useEmrInstanceQuery>;
export type EmrInstanceLazyQueryHookResult = ReturnType<typeof useEmrInstanceLazyQuery>;
export type EmrInstanceQueryResult = Apollo.QueryResult<EmrInstanceQuery, EmrInstanceQueryVariables>;
export const EmrInstancesDocument = gql`
    query EmrInstances {
  emrInstances {
    ...EmrInstanceFields
  }
}
    ${EmrInstanceFieldsFragmentDoc}`;

/**
 * __useEmrInstancesQuery__
 *
 * To run a query within a React component, call `useEmrInstancesQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmrInstancesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmrInstancesQuery({
 *   variables: {
 *   },
 * });
 */
export function useEmrInstancesQuery(baseOptions?: Apollo.QueryHookOptions<EmrInstancesQuery, EmrInstancesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmrInstancesQuery, EmrInstancesQueryVariables>(EmrInstancesDocument, options);
      }
export function useEmrInstancesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmrInstancesQuery, EmrInstancesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmrInstancesQuery, EmrInstancesQueryVariables>(EmrInstancesDocument, options);
        }
export type EmrInstancesQueryHookResult = ReturnType<typeof useEmrInstancesQuery>;
export type EmrInstancesLazyQueryHookResult = ReturnType<typeof useEmrInstancesLazyQuery>;
export type EmrInstancesQueryResult = Apollo.QueryResult<EmrInstancesQuery, EmrInstancesQueryVariables>;
export const MarketplaceDocument = gql`
    query Marketplace($id: ID!) {
  marketplace(id: $id) {
    ...MarketplaceSettingsFields
    checkoutNotes {
      ...CheckoutNoteItemFields
    }
    roles {
      ...RoleFields
    }
    procedureBaseDefs {
      ...ProcedureBaseDefFields
      tags
    }
    procedureBaseDefGroups {
      ...ProcedureBaseDefGroupFields
    }
    organizations {
      ...OrganizationFields
    }
    group {
      id
      label
    }
    packages {
      ...PackageFields
    }
    membershipDefinitions {
      ...MembershipDefinitionFields
    }
    attentive {
      ...AttentiveFields
    }
    sendgrid {
      ...SendgridFields
    }
    paymentAccounts {
      ...PaymentAccountFields
    }
    twilio {
      ...TwilioFields
    }
    segment {
      ...SegmentFields
    }
    reach {
      id
      reachId
    }
  }
}
    ${MarketplaceSettingsFieldsFragmentDoc}
${CheckoutNoteItemFieldsFragmentDoc}
${RoleFieldsFragmentDoc}
${ProcedureBaseDefFieldsFragmentDoc}
${ProcedureBaseDefGroupFieldsFragmentDoc}
${OrganizationFieldsFragmentDoc}
${PackageFieldsFragmentDoc}
${MembershipDefinitionFieldsFragmentDoc}
${AttentiveFieldsFragmentDoc}
${SendgridFieldsFragmentDoc}
${PaymentAccountFieldsFragmentDoc}
${TwilioFieldsFragmentDoc}
${SegmentFieldsFragmentDoc}`;

/**
 * __useMarketplaceQuery__
 *
 * To run a query within a React component, call `useMarketplaceQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketplaceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketplaceQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMarketplaceQuery(baseOptions: Apollo.QueryHookOptions<MarketplaceQuery, MarketplaceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MarketplaceQuery, MarketplaceQueryVariables>(MarketplaceDocument, options);
      }
export function useMarketplaceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MarketplaceQuery, MarketplaceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MarketplaceQuery, MarketplaceQueryVariables>(MarketplaceDocument, options);
        }
export type MarketplaceQueryHookResult = ReturnType<typeof useMarketplaceQuery>;
export type MarketplaceLazyQueryHookResult = ReturnType<typeof useMarketplaceLazyQuery>;
export type MarketplaceQueryResult = Apollo.QueryResult<MarketplaceQuery, MarketplaceQueryVariables>;
export const MarketplaceDispatchDocument = gql`
    query MarketplaceDispatch($id: ID!) {
  marketplace(id: $id) {
    ...MarketplaceFields
    twilio {
      ...TwilioFields
    }
    roles {
      ...RoleFields
    }
    procedureBaseDefs {
      ...ProcedureBaseDefFields
    }
    organizations {
      ...OrganizationFields
      profiles {
        ...ProfileFields
      }
    }
  }
}
    ${MarketplaceFieldsFragmentDoc}
${TwilioFieldsFragmentDoc}
${RoleFieldsFragmentDoc}
${ProcedureBaseDefFieldsFragmentDoc}
${OrganizationFieldsFragmentDoc}
${ProfileFieldsFragmentDoc}`;

/**
 * __useMarketplaceDispatchQuery__
 *
 * To run a query within a React component, call `useMarketplaceDispatchQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketplaceDispatchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketplaceDispatchQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMarketplaceDispatchQuery(baseOptions: Apollo.QueryHookOptions<MarketplaceDispatchQuery, MarketplaceDispatchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MarketplaceDispatchQuery, MarketplaceDispatchQueryVariables>(MarketplaceDispatchDocument, options);
      }
export function useMarketplaceDispatchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MarketplaceDispatchQuery, MarketplaceDispatchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MarketplaceDispatchQuery, MarketplaceDispatchQueryVariables>(MarketplaceDispatchDocument, options);
        }
export type MarketplaceDispatchQueryHookResult = ReturnType<typeof useMarketplaceDispatchQuery>;
export type MarketplaceDispatchLazyQueryHookResult = ReturnType<typeof useMarketplaceDispatchLazyQuery>;
export type MarketplaceDispatchQueryResult = Apollo.QueryResult<MarketplaceDispatchQuery, MarketplaceDispatchQueryVariables>;
export const MarketplaceGroupDocument = gql`
    query MarketplaceGroup($id: ID!) {
  marketplaceGroup(id: $id) {
    ...MarketplaceGroupFields
    marketplaces {
      ...MarketplaceFields
    }
  }
}
    ${MarketplaceGroupFieldsFragmentDoc}
${MarketplaceFieldsFragmentDoc}`;

/**
 * __useMarketplaceGroupQuery__
 *
 * To run a query within a React component, call `useMarketplaceGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketplaceGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketplaceGroupQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMarketplaceGroupQuery(baseOptions: Apollo.QueryHookOptions<MarketplaceGroupQuery, MarketplaceGroupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MarketplaceGroupQuery, MarketplaceGroupQueryVariables>(MarketplaceGroupDocument, options);
      }
export function useMarketplaceGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MarketplaceGroupQuery, MarketplaceGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MarketplaceGroupQuery, MarketplaceGroupQueryVariables>(MarketplaceGroupDocument, options);
        }
export type MarketplaceGroupQueryHookResult = ReturnType<typeof useMarketplaceGroupQuery>;
export type MarketplaceGroupLazyQueryHookResult = ReturnType<typeof useMarketplaceGroupLazyQuery>;
export type MarketplaceGroupQueryResult = Apollo.QueryResult<MarketplaceGroupQuery, MarketplaceGroupQueryVariables>;
export const MarketplaceGroupMembershipsDocument = gql`
    query MarketplaceGroupMemberships($id: ID!) {
  marketplaceGroup(id: $id) {
    ...MarketplaceGroupFields
    marketplaces {
      ...MarketplaceFields
      membershipDefinitions {
        ...MembershipDefinitionFields
      }
      packages {
        ...PackageFields
      }
      organizations {
        ...OrganizationFields
      }
    }
  }
}
    ${MarketplaceGroupFieldsFragmentDoc}
${MarketplaceFieldsFragmentDoc}
${MembershipDefinitionFieldsFragmentDoc}
${PackageFieldsFragmentDoc}
${OrganizationFieldsFragmentDoc}`;

/**
 * __useMarketplaceGroupMembershipsQuery__
 *
 * To run a query within a React component, call `useMarketplaceGroupMembershipsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketplaceGroupMembershipsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketplaceGroupMembershipsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMarketplaceGroupMembershipsQuery(baseOptions: Apollo.QueryHookOptions<MarketplaceGroupMembershipsQuery, MarketplaceGroupMembershipsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MarketplaceGroupMembershipsQuery, MarketplaceGroupMembershipsQueryVariables>(MarketplaceGroupMembershipsDocument, options);
      }
export function useMarketplaceGroupMembershipsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MarketplaceGroupMembershipsQuery, MarketplaceGroupMembershipsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MarketplaceGroupMembershipsQuery, MarketplaceGroupMembershipsQueryVariables>(MarketplaceGroupMembershipsDocument, options);
        }
export type MarketplaceGroupMembershipsQueryHookResult = ReturnType<typeof useMarketplaceGroupMembershipsQuery>;
export type MarketplaceGroupMembershipsLazyQueryHookResult = ReturnType<typeof useMarketplaceGroupMembershipsLazyQuery>;
export type MarketplaceGroupMembershipsQueryResult = Apollo.QueryResult<MarketplaceGroupMembershipsQuery, MarketplaceGroupMembershipsQueryVariables>;
export const MarketplaceGroupUsersDocument = gql`
    query MarketplaceGroupUsers($id: ID!, $page: MarketplaceUserPageInput) {
  marketplaceGroup(id: $id) {
    ...MarketplaceGroupFields
    marketplaceUsers(page: $page) {
      totalCount
      data {
        ...MarketplaceUserFields
      }
    }
    marketplaces {
      packages {
        ...PackageFields
      }
      membershipDefinitions {
        ...MembershipDefinitionFields
      }
    }
  }
}
    ${MarketplaceGroupFieldsFragmentDoc}
${MarketplaceUserFieldsFragmentDoc}
${PackageFieldsFragmentDoc}
${MembershipDefinitionFieldsFragmentDoc}`;

/**
 * __useMarketplaceGroupUsersQuery__
 *
 * To run a query within a React component, call `useMarketplaceGroupUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketplaceGroupUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketplaceGroupUsersQuery({
 *   variables: {
 *      id: // value for 'id'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useMarketplaceGroupUsersQuery(baseOptions: Apollo.QueryHookOptions<MarketplaceGroupUsersQuery, MarketplaceGroupUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MarketplaceGroupUsersQuery, MarketplaceGroupUsersQueryVariables>(MarketplaceGroupUsersDocument, options);
      }
export function useMarketplaceGroupUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MarketplaceGroupUsersQuery, MarketplaceGroupUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MarketplaceGroupUsersQuery, MarketplaceGroupUsersQueryVariables>(MarketplaceGroupUsersDocument, options);
        }
export type MarketplaceGroupUsersQueryHookResult = ReturnType<typeof useMarketplaceGroupUsersQuery>;
export type MarketplaceGroupUsersLazyQueryHookResult = ReturnType<typeof useMarketplaceGroupUsersLazyQuery>;
export type MarketplaceGroupUsersQueryResult = Apollo.QueryResult<MarketplaceGroupUsersQuery, MarketplaceGroupUsersQueryVariables>;
export const MarketplaceGroupsDocument = gql`
    query MarketplaceGroups {
  marketplaceGroups {
    ...MarketplaceGroupFields
    marketplaces {
      ...MarketplaceFields
    }
  }
}
    ${MarketplaceGroupFieldsFragmentDoc}
${MarketplaceFieldsFragmentDoc}`;

/**
 * __useMarketplaceGroupsQuery__
 *
 * To run a query within a React component, call `useMarketplaceGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketplaceGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketplaceGroupsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMarketplaceGroupsQuery(baseOptions?: Apollo.QueryHookOptions<MarketplaceGroupsQuery, MarketplaceGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MarketplaceGroupsQuery, MarketplaceGroupsQueryVariables>(MarketplaceGroupsDocument, options);
      }
export function useMarketplaceGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MarketplaceGroupsQuery, MarketplaceGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MarketplaceGroupsQuery, MarketplaceGroupsQueryVariables>(MarketplaceGroupsDocument, options);
        }
export type MarketplaceGroupsQueryHookResult = ReturnType<typeof useMarketplaceGroupsQuery>;
export type MarketplaceGroupsLazyQueryHookResult = ReturnType<typeof useMarketplaceGroupsLazyQuery>;
export type MarketplaceGroupsQueryResult = Apollo.QueryResult<MarketplaceGroupsQuery, MarketplaceGroupsQueryVariables>;
export const MarketplaceMessagingSenderDocument = gql`
    query MarketplaceMessagingSender($id: ID!) {
  marketplace(id: $id) {
    id
    twilio {
      id
      messagingSender {
        sid
        source
        phoneNumbers
        error
      }
    }
  }
}
    `;

/**
 * __useMarketplaceMessagingSenderQuery__
 *
 * To run a query within a React component, call `useMarketplaceMessagingSenderQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketplaceMessagingSenderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketplaceMessagingSenderQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMarketplaceMessagingSenderQuery(baseOptions: Apollo.QueryHookOptions<MarketplaceMessagingSenderQuery, MarketplaceMessagingSenderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MarketplaceMessagingSenderQuery, MarketplaceMessagingSenderQueryVariables>(MarketplaceMessagingSenderDocument, options);
      }
export function useMarketplaceMessagingSenderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MarketplaceMessagingSenderQuery, MarketplaceMessagingSenderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MarketplaceMessagingSenderQuery, MarketplaceMessagingSenderQueryVariables>(MarketplaceMessagingSenderDocument, options);
        }
export type MarketplaceMessagingSenderQueryHookResult = ReturnType<typeof useMarketplaceMessagingSenderQuery>;
export type MarketplaceMessagingSenderLazyQueryHookResult = ReturnType<typeof useMarketplaceMessagingSenderLazyQuery>;
export type MarketplaceMessagingSenderQueryResult = Apollo.QueryResult<MarketplaceMessagingSenderQuery, MarketplaceMessagingSenderQueryVariables>;
export const MarketplaceMfaModeDocument = gql`
    query MarketplaceMfaMode($id: ID!) {
  marketplace(id: $id) {
    id
    mfaMode {
      ...MfaScopeModeFields
    }
  }
}
    ${MfaScopeModeFieldsFragmentDoc}`;

/**
 * __useMarketplaceMfaModeQuery__
 *
 * To run a query within a React component, call `useMarketplaceMfaModeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketplaceMfaModeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketplaceMfaModeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMarketplaceMfaModeQuery(baseOptions: Apollo.QueryHookOptions<MarketplaceMfaModeQuery, MarketplaceMfaModeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MarketplaceMfaModeQuery, MarketplaceMfaModeQueryVariables>(MarketplaceMfaModeDocument, options);
      }
export function useMarketplaceMfaModeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MarketplaceMfaModeQuery, MarketplaceMfaModeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MarketplaceMfaModeQuery, MarketplaceMfaModeQueryVariables>(MarketplaceMfaModeDocument, options);
        }
export type MarketplaceMfaModeQueryHookResult = ReturnType<typeof useMarketplaceMfaModeQuery>;
export type MarketplaceMfaModeLazyQueryHookResult = ReturnType<typeof useMarketplaceMfaModeLazyQuery>;
export type MarketplaceMfaModeQueryResult = Apollo.QueryResult<MarketplaceMfaModeQuery, MarketplaceMfaModeQueryVariables>;
export const MarketplacePaymentsDocument = gql`
    query MarketplacePayments($id: ID!) {
  marketplace(id: $id) {
    ...MarketplaceSettingsFields
    paymentAccounts {
      ...PaymentAccountFields
    }
  }
}
    ${MarketplaceSettingsFieldsFragmentDoc}
${PaymentAccountFieldsFragmentDoc}`;

/**
 * __useMarketplacePaymentsQuery__
 *
 * To run a query within a React component, call `useMarketplacePaymentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketplacePaymentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketplacePaymentsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMarketplacePaymentsQuery(baseOptions: Apollo.QueryHookOptions<MarketplacePaymentsQuery, MarketplacePaymentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MarketplacePaymentsQuery, MarketplacePaymentsQueryVariables>(MarketplacePaymentsDocument, options);
      }
export function useMarketplacePaymentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MarketplacePaymentsQuery, MarketplacePaymentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MarketplacePaymentsQuery, MarketplacePaymentsQueryVariables>(MarketplacePaymentsDocument, options);
        }
export type MarketplacePaymentsQueryHookResult = ReturnType<typeof useMarketplacePaymentsQuery>;
export type MarketplacePaymentsLazyQueryHookResult = ReturnType<typeof useMarketplacePaymentsLazyQuery>;
export type MarketplacePaymentsQueryResult = Apollo.QueryResult<MarketplacePaymentsQuery, MarketplacePaymentsQueryVariables>;
export const MarketplaceUserDocument = gql`
    query MarketplaceUser($id: ID!) {
  marketplaceUser(id: $id) {
    ...FullMarketplaceUserFields
  }
}
    ${FullMarketplaceUserFieldsFragmentDoc}`;

/**
 * __useMarketplaceUserQuery__
 *
 * To run a query within a React component, call `useMarketplaceUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketplaceUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketplaceUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMarketplaceUserQuery(baseOptions: Apollo.QueryHookOptions<MarketplaceUserQuery, MarketplaceUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MarketplaceUserQuery, MarketplaceUserQueryVariables>(MarketplaceUserDocument, options);
      }
export function useMarketplaceUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MarketplaceUserQuery, MarketplaceUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MarketplaceUserQuery, MarketplaceUserQueryVariables>(MarketplaceUserDocument, options);
        }
export type MarketplaceUserQueryHookResult = ReturnType<typeof useMarketplaceUserQuery>;
export type MarketplaceUserLazyQueryHookResult = ReturnType<typeof useMarketplaceUserLazyQuery>;
export type MarketplaceUserQueryResult = Apollo.QueryResult<MarketplaceUserQuery, MarketplaceUserQueryVariables>;
export const MarketplaceUsersDocument = gql`
    query MarketplaceUsers($page: MarketplaceUserPageInput) {
  marketplaceUsers(page: $page) {
    totalCount
    data {
      ...PaginatedMarketplaceUserFields
    }
  }
}
    ${PaginatedMarketplaceUserFieldsFragmentDoc}`;

/**
 * __useMarketplaceUsersQuery__
 *
 * To run a query within a React component, call `useMarketplaceUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketplaceUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketplaceUsersQuery({
 *   variables: {
 *      page: // value for 'page'
 *   },
 * });
 */
export function useMarketplaceUsersQuery(baseOptions?: Apollo.QueryHookOptions<MarketplaceUsersQuery, MarketplaceUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MarketplaceUsersQuery, MarketplaceUsersQueryVariables>(MarketplaceUsersDocument, options);
      }
export function useMarketplaceUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MarketplaceUsersQuery, MarketplaceUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MarketplaceUsersQuery, MarketplaceUsersQueryVariables>(MarketplaceUsersDocument, options);
        }
export type MarketplaceUsersQueryHookResult = ReturnType<typeof useMarketplaceUsersQuery>;
export type MarketplaceUsersLazyQueryHookResult = ReturnType<typeof useMarketplaceUsersLazyQuery>;
export type MarketplaceUsersQueryResult = Apollo.QueryResult<MarketplaceUsersQuery, MarketplaceUsersQueryVariables>;
export const MarketplacesDocument = gql`
    query Marketplaces {
  marketplaces {
    ...MarketplaceFields
    roles {
      ...RoleFields
    }
    organizations {
      ...OrganizationFields
    }
  }
}
    ${MarketplaceFieldsFragmentDoc}
${RoleFieldsFragmentDoc}
${OrganizationFieldsFragmentDoc}`;

/**
 * __useMarketplacesQuery__
 *
 * To run a query within a React component, call `useMarketplacesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketplacesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketplacesQuery({
 *   variables: {
 *   },
 * });
 */
export function useMarketplacesQuery(baseOptions?: Apollo.QueryHookOptions<MarketplacesQuery, MarketplacesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MarketplacesQuery, MarketplacesQueryVariables>(MarketplacesDocument, options);
      }
export function useMarketplacesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MarketplacesQuery, MarketplacesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MarketplacesQuery, MarketplacesQueryVariables>(MarketplacesDocument, options);
        }
export type MarketplacesQueryHookResult = ReturnType<typeof useMarketplacesQuery>;
export type MarketplacesLazyQueryHookResult = ReturnType<typeof useMarketplacesLazyQuery>;
export type MarketplacesQueryResult = Apollo.QueryResult<MarketplacesQuery, MarketplacesQueryVariables>;
export const MarketplacesMetricsDocument = gql`
    query MarketplacesMetrics {
  marketplaces {
    ...MetricsMarketplaceFields
  }
}
    ${MetricsMarketplaceFieldsFragmentDoc}`;

/**
 * __useMarketplacesMetricsQuery__
 *
 * To run a query within a React component, call `useMarketplacesMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketplacesMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketplacesMetricsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMarketplacesMetricsQuery(baseOptions?: Apollo.QueryHookOptions<MarketplacesMetricsQuery, MarketplacesMetricsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MarketplacesMetricsQuery, MarketplacesMetricsQueryVariables>(MarketplacesMetricsDocument, options);
      }
export function useMarketplacesMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MarketplacesMetricsQuery, MarketplacesMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MarketplacesMetricsQuery, MarketplacesMetricsQueryVariables>(MarketplacesMetricsDocument, options);
        }
export type MarketplacesMetricsQueryHookResult = ReturnType<typeof useMarketplacesMetricsQuery>;
export type MarketplacesMetricsLazyQueryHookResult = ReturnType<typeof useMarketplacesMetricsLazyQuery>;
export type MarketplacesMetricsQueryResult = Apollo.QueryResult<MarketplacesMetricsQuery, MarketplacesMetricsQueryVariables>;
export const MembershipDefinitionDocument = gql`
    query MembershipDefinition($id: ID!) {
  membershipDefinition(id: $id) {
    ...FullMembershipDefinitionFields
  }
}
    ${FullMembershipDefinitionFieldsFragmentDoc}`;

/**
 * __useMembershipDefinitionQuery__
 *
 * To run a query within a React component, call `useMembershipDefinitionQuery` and pass it any options that fit your needs.
 * When your component renders, `useMembershipDefinitionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMembershipDefinitionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMembershipDefinitionQuery(baseOptions: Apollo.QueryHookOptions<MembershipDefinitionQuery, MembershipDefinitionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MembershipDefinitionQuery, MembershipDefinitionQueryVariables>(MembershipDefinitionDocument, options);
      }
export function useMembershipDefinitionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MembershipDefinitionQuery, MembershipDefinitionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MembershipDefinitionQuery, MembershipDefinitionQueryVariables>(MembershipDefinitionDocument, options);
        }
export type MembershipDefinitionQueryHookResult = ReturnType<typeof useMembershipDefinitionQuery>;
export type MembershipDefinitionLazyQueryHookResult = ReturnType<typeof useMembershipDefinitionLazyQuery>;
export type MembershipDefinitionQueryResult = Apollo.QueryResult<MembershipDefinitionQuery, MembershipDefinitionQueryVariables>;
export const MetricsDocument = gql`
    query Metrics($input: MetricsInput!) {
  metrics(input: $input) {
    ...MetricDataFields
  }
}
    ${MetricDataFieldsFragmentDoc}`;

/**
 * __useMetricsQuery__
 *
 * To run a query within a React component, call `useMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMetricsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMetricsQuery(baseOptions: Apollo.QueryHookOptions<MetricsQuery, MetricsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MetricsQuery, MetricsQueryVariables>(MetricsDocument, options);
      }
export function useMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MetricsQuery, MetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MetricsQuery, MetricsQueryVariables>(MetricsDocument, options);
        }
export type MetricsQueryHookResult = ReturnType<typeof useMetricsQuery>;
export type MetricsLazyQueryHookResult = ReturnType<typeof useMetricsLazyQuery>;
export type MetricsQueryResult = Apollo.QueryResult<MetricsQuery, MetricsQueryVariables>;
export const MfaEnrollmentReportDocument = gql`
    query MfaEnrollmentReport {
  mfaEnrollmentReport {
    enabled
    platformMode
    generatedAt
    totals {
      users
      enrolled
      percentEnrolled
      inGrace
      pastGrace
    }
    rows {
      kind
      id
      name
      setting
      mode
      users
      enrolled
      percentEnrolled
      inGrace
      pastGrace
    }
  }
}
    `;

/**
 * __useMfaEnrollmentReportQuery__
 *
 * To run a query within a React component, call `useMfaEnrollmentReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useMfaEnrollmentReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMfaEnrollmentReportQuery({
 *   variables: {
 *   },
 * });
 */
export function useMfaEnrollmentReportQuery(baseOptions?: Apollo.QueryHookOptions<MfaEnrollmentReportQuery, MfaEnrollmentReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MfaEnrollmentReportQuery, MfaEnrollmentReportQueryVariables>(MfaEnrollmentReportDocument, options);
      }
export function useMfaEnrollmentReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MfaEnrollmentReportQuery, MfaEnrollmentReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MfaEnrollmentReportQuery, MfaEnrollmentReportQueryVariables>(MfaEnrollmentReportDocument, options);
        }
export type MfaEnrollmentReportQueryHookResult = ReturnType<typeof useMfaEnrollmentReportQuery>;
export type MfaEnrollmentReportLazyQueryHookResult = ReturnType<typeof useMfaEnrollmentReportLazyQuery>;
export type MfaEnrollmentReportQueryResult = Apollo.QueryResult<MfaEnrollmentReportQuery, MfaEnrollmentReportQueryVariables>;
export const OrganizationDocument = gql`
    query Organization($id: ID!, $includeArchived: Boolean = false) {
  organization(id: $id) {
    ...FullOrganization
    archivedProfiles: profiles(includeArchived: true) @include(if: $includeArchived) {
      ...ProfileRoles
      procedureProfiles {
        ...ProcedureProfileFields
      }
      availabilities {
        ...AvailabilityFields
      }
      archivedAt
    }
  }
}
    ${FullOrganizationFragmentDoc}
${ProfileRolesFragmentDoc}
${ProcedureProfileFieldsFragmentDoc}
${AvailabilityFieldsFragmentDoc}`;

/**
 * __useOrganizationQuery__
 *
 * To run a query within a React component, call `useOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationQuery({
 *   variables: {
 *      id: // value for 'id'
 *      includeArchived: // value for 'includeArchived'
 *   },
 * });
 */
export function useOrganizationQuery(baseOptions: Apollo.QueryHookOptions<OrganizationQuery, OrganizationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationQuery, OrganizationQueryVariables>(OrganizationDocument, options);
      }
export function useOrganizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationQuery, OrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationQuery, OrganizationQueryVariables>(OrganizationDocument, options);
        }
export type OrganizationQueryHookResult = ReturnType<typeof useOrganizationQuery>;
export type OrganizationLazyQueryHookResult = ReturnType<typeof useOrganizationLazyQuery>;
export type OrganizationQueryResult = Apollo.QueryResult<OrganizationQuery, OrganizationQueryVariables>;
export const OrganizationAppointmentsDocument = gql`
    query OrganizationAppointments($id: ID!, $page: AppointmentPageInput) {
  organization(id: $id) {
    ...OrganizationFields
    appointments(page: $page) {
      totalCount
      data {
        ...RegularAppointmentFields
      }
    }
  }
}
    ${OrganizationFieldsFragmentDoc}
${RegularAppointmentFieldsFragmentDoc}`;

/**
 * __useOrganizationAppointmentsQuery__
 *
 * To run a query within a React component, call `useOrganizationAppointmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationAppointmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationAppointmentsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useOrganizationAppointmentsQuery(baseOptions: Apollo.QueryHookOptions<OrganizationAppointmentsQuery, OrganizationAppointmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationAppointmentsQuery, OrganizationAppointmentsQueryVariables>(OrganizationAppointmentsDocument, options);
      }
export function useOrganizationAppointmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationAppointmentsQuery, OrganizationAppointmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationAppointmentsQuery, OrganizationAppointmentsQueryVariables>(OrganizationAppointmentsDocument, options);
        }
export type OrganizationAppointmentsQueryHookResult = ReturnType<typeof useOrganizationAppointmentsQuery>;
export type OrganizationAppointmentsLazyQueryHookResult = ReturnType<typeof useOrganizationAppointmentsLazyQuery>;
export type OrganizationAppointmentsQueryResult = Apollo.QueryResult<OrganizationAppointmentsQuery, OrganizationAppointmentsQueryVariables>;
export const OrganizationClientProfilesDocument = gql`
    query OrganizationClientProfiles($id: ID!, $page: ClientProfilePageInput) {
  organization(id: $id) {
    ...OrganizationFields
    clientProfiles(page: $page) {
      totalCount
      data {
        ...ClientProfileFields
      }
    }
  }
}
    ${OrganizationFieldsFragmentDoc}
${ClientProfileFieldsFragmentDoc}`;

/**
 * __useOrganizationClientProfilesQuery__
 *
 * To run a query within a React component, call `useOrganizationClientProfilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationClientProfilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationClientProfilesQuery({
 *   variables: {
 *      id: // value for 'id'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useOrganizationClientProfilesQuery(baseOptions: Apollo.QueryHookOptions<OrganizationClientProfilesQuery, OrganizationClientProfilesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationClientProfilesQuery, OrganizationClientProfilesQueryVariables>(OrganizationClientProfilesDocument, options);
      }
export function useOrganizationClientProfilesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationClientProfilesQuery, OrganizationClientProfilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationClientProfilesQuery, OrganizationClientProfilesQueryVariables>(OrganizationClientProfilesDocument, options);
        }
export type OrganizationClientProfilesQueryHookResult = ReturnType<typeof useOrganizationClientProfilesQuery>;
export type OrganizationClientProfilesLazyQueryHookResult = ReturnType<typeof useOrganizationClientProfilesLazyQuery>;
export type OrganizationClientProfilesQueryResult = Apollo.QueryResult<OrganizationClientProfilesQuery, OrganizationClientProfilesQueryVariables>;
export const OrganizationCoverageRangesDocument = gql`
    query OrganizationCoverageRanges($id: ID!, $input: AvailabilityCoverageRangeInput!) {
  organization(id: $id) {
    id
    availabilityCoverageRanges(input: $input) {
      ...AvailabilityCoverageRangeFields
    }
  }
}
    ${AvailabilityCoverageRangeFieldsFragmentDoc}`;

/**
 * __useOrganizationCoverageRangesQuery__
 *
 * To run a query within a React component, call `useOrganizationCoverageRangesQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationCoverageRangesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationCoverageRangesQuery({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOrganizationCoverageRangesQuery(baseOptions: Apollo.QueryHookOptions<OrganizationCoverageRangesQuery, OrganizationCoverageRangesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationCoverageRangesQuery, OrganizationCoverageRangesQueryVariables>(OrganizationCoverageRangesDocument, options);
      }
export function useOrganizationCoverageRangesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationCoverageRangesQuery, OrganizationCoverageRangesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationCoverageRangesQuery, OrganizationCoverageRangesQueryVariables>(OrganizationCoverageRangesDocument, options);
        }
export type OrganizationCoverageRangesQueryHookResult = ReturnType<typeof useOrganizationCoverageRangesQuery>;
export type OrganizationCoverageRangesLazyQueryHookResult = ReturnType<typeof useOrganizationCoverageRangesLazyQuery>;
export type OrganizationCoverageRangesQueryResult = Apollo.QueryResult<OrganizationCoverageRangesQuery, OrganizationCoverageRangesQueryVariables>;
export const OrganizationDetailDocument = gql`
    query OrganizationDetail($id: ID!) {
  organization(id: $id) {
    ...OrganizationFields
    roles {
      ...RoleFields
    }
    procedureProfiles {
      ...ProcedureProfileFields
      procedureDefs {
        ...ProcedureDefFields
      }
    }
  }
}
    ${OrganizationFieldsFragmentDoc}
${RoleFieldsFragmentDoc}
${ProcedureProfileFieldsFragmentDoc}
${ProcedureDefFieldsFragmentDoc}`;

/**
 * __useOrganizationDetailQuery__
 *
 * To run a query within a React component, call `useOrganizationDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOrganizationDetailQuery(baseOptions: Apollo.QueryHookOptions<OrganizationDetailQuery, OrganizationDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationDetailQuery, OrganizationDetailQueryVariables>(OrganizationDetailDocument, options);
      }
export function useOrganizationDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationDetailQuery, OrganizationDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationDetailQuery, OrganizationDetailQueryVariables>(OrganizationDetailDocument, options);
        }
export type OrganizationDetailQueryHookResult = ReturnType<typeof useOrganizationDetailQuery>;
export type OrganizationDetailLazyQueryHookResult = ReturnType<typeof useOrganizationDetailLazyQuery>;
export type OrganizationDetailQueryResult = Apollo.QueryResult<OrganizationDetailQuery, OrganizationDetailQueryVariables>;
export const OrganizationGeoperimetersDocument = gql`
    query OrganizationGeoperimeters($id: ID!) {
  organization(id: $id) {
    ...OrganizationFields
    geoperimeters {
      ...GeoperimeterFields
    }
  }
}
    ${OrganizationFieldsFragmentDoc}
${GeoperimeterFieldsFragmentDoc}`;

/**
 * __useOrganizationGeoperimetersQuery__
 *
 * To run a query within a React component, call `useOrganizationGeoperimetersQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationGeoperimetersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationGeoperimetersQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOrganizationGeoperimetersQuery(baseOptions: Apollo.QueryHookOptions<OrganizationGeoperimetersQuery, OrganizationGeoperimetersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationGeoperimetersQuery, OrganizationGeoperimetersQueryVariables>(OrganizationGeoperimetersDocument, options);
      }
export function useOrganizationGeoperimetersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationGeoperimetersQuery, OrganizationGeoperimetersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationGeoperimetersQuery, OrganizationGeoperimetersQueryVariables>(OrganizationGeoperimetersDocument, options);
        }
export type OrganizationGeoperimetersQueryHookResult = ReturnType<typeof useOrganizationGeoperimetersQuery>;
export type OrganizationGeoperimetersLazyQueryHookResult = ReturnType<typeof useOrganizationGeoperimetersLazyQuery>;
export type OrganizationGeoperimetersQueryResult = Apollo.QueryResult<OrganizationGeoperimetersQuery, OrganizationGeoperimetersQueryVariables>;
export const OrganizationMfaModeDocument = gql`
    query OrganizationMfaMode($id: ID!) {
  organization(id: $id) {
    id
    mfaMode {
      ...MfaScopeModeFields
    }
  }
}
    ${MfaScopeModeFieldsFragmentDoc}`;

/**
 * __useOrganizationMfaModeQuery__
 *
 * To run a query within a React component, call `useOrganizationMfaModeQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationMfaModeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationMfaModeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOrganizationMfaModeQuery(baseOptions: Apollo.QueryHookOptions<OrganizationMfaModeQuery, OrganizationMfaModeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationMfaModeQuery, OrganizationMfaModeQueryVariables>(OrganizationMfaModeDocument, options);
      }
export function useOrganizationMfaModeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationMfaModeQuery, OrganizationMfaModeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationMfaModeQuery, OrganizationMfaModeQueryVariables>(OrganizationMfaModeDocument, options);
        }
export type OrganizationMfaModeQueryHookResult = ReturnType<typeof useOrganizationMfaModeQuery>;
export type OrganizationMfaModeLazyQueryHookResult = ReturnType<typeof useOrganizationMfaModeLazyQuery>;
export type OrganizationMfaModeQueryResult = Apollo.QueryResult<OrganizationMfaModeQuery, OrganizationMfaModeQueryVariables>;
export const OrganizationPaymentsDocument = gql`
    query OrganizationPayments($id: ID!) {
  organization(id: $id) {
    ...OrganizationFields
    paymentAccountId
    paymentAccounts {
      ...PaymentAccountFields
    }
  }
}
    ${OrganizationFieldsFragmentDoc}
${PaymentAccountFieldsFragmentDoc}`;

/**
 * __useOrganizationPaymentsQuery__
 *
 * To run a query within a React component, call `useOrganizationPaymentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationPaymentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationPaymentsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOrganizationPaymentsQuery(baseOptions: Apollo.QueryHookOptions<OrganizationPaymentsQuery, OrganizationPaymentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationPaymentsQuery, OrganizationPaymentsQueryVariables>(OrganizationPaymentsDocument, options);
      }
export function useOrganizationPaymentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationPaymentsQuery, OrganizationPaymentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationPaymentsQuery, OrganizationPaymentsQueryVariables>(OrganizationPaymentsDocument, options);
        }
export type OrganizationPaymentsQueryHookResult = ReturnType<typeof useOrganizationPaymentsQuery>;
export type OrganizationPaymentsLazyQueryHookResult = ReturnType<typeof useOrganizationPaymentsLazyQuery>;
export type OrganizationPaymentsQueryResult = Apollo.QueryResult<OrganizationPaymentsQuery, OrganizationPaymentsQueryVariables>;
export const OrganizationQualiphyConfigDocument = gql`
    query OrganizationQualiphyConfig($id: ID!) {
  organization(id: $id) {
    ...FullOrganization
    slackWebhookUrl
    qualiphy {
      ...QualiphyFields
    }
  }
}
    ${FullOrganizationFragmentDoc}
${QualiphyFieldsFragmentDoc}`;

/**
 * __useOrganizationQualiphyConfigQuery__
 *
 * To run a query within a React component, call `useOrganizationQualiphyConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationQualiphyConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationQualiphyConfigQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOrganizationQualiphyConfigQuery(baseOptions: Apollo.QueryHookOptions<OrganizationQualiphyConfigQuery, OrganizationQualiphyConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationQualiphyConfigQuery, OrganizationQualiphyConfigQueryVariables>(OrganizationQualiphyConfigDocument, options);
      }
export function useOrganizationQualiphyConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationQualiphyConfigQuery, OrganizationQualiphyConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationQualiphyConfigQuery, OrganizationQualiphyConfigQueryVariables>(OrganizationQualiphyConfigDocument, options);
        }
export type OrganizationQualiphyConfigQueryHookResult = ReturnType<typeof useOrganizationQualiphyConfigQuery>;
export type OrganizationQualiphyConfigLazyQueryHookResult = ReturnType<typeof useOrganizationQualiphyConfigLazyQuery>;
export type OrganizationQualiphyConfigQueryResult = Apollo.QueryResult<OrganizationQualiphyConfigQuery, OrganizationQualiphyConfigQueryVariables>;
export const OrganizationSettingsDocument = gql`
    query OrganizationSettings($id: ID!, $includeArchived: Boolean = false) {
  organization(id: $id) {
    ...FullOrganization
    archivedProfiles: profiles(includeArchived: true) @include(if: $includeArchived) {
      ...ProfileRoles
      procedureProfiles {
        ...ProcedureProfileFields
      }
      availabilities {
        ...AvailabilityFields
      }
      archivedAt
    }
    slackWebhookUrl
    googleReviewsUrl
    paymentAccountId
  }
}
    ${FullOrganizationFragmentDoc}
${ProfileRolesFragmentDoc}
${ProcedureProfileFieldsFragmentDoc}
${AvailabilityFieldsFragmentDoc}`;

/**
 * __useOrganizationSettingsQuery__
 *
 * To run a query within a React component, call `useOrganizationSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationSettingsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      includeArchived: // value for 'includeArchived'
 *   },
 * });
 */
export function useOrganizationSettingsQuery(baseOptions: Apollo.QueryHookOptions<OrganizationSettingsQuery, OrganizationSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationSettingsQuery, OrganizationSettingsQueryVariables>(OrganizationSettingsDocument, options);
      }
export function useOrganizationSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationSettingsQuery, OrganizationSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationSettingsQuery, OrganizationSettingsQueryVariables>(OrganizationSettingsDocument, options);
        }
export type OrganizationSettingsQueryHookResult = ReturnType<typeof useOrganizationSettingsQuery>;
export type OrganizationSettingsLazyQueryHookResult = ReturnType<typeof useOrganizationSettingsLazyQuery>;
export type OrganizationSettingsQueryResult = Apollo.QueryResult<OrganizationSettingsQuery, OrganizationSettingsQueryVariables>;
export const OrganizationsDocument = gql`
    query Organizations {
  organizations {
    ...OrganizationFields
  }
}
    ${OrganizationFieldsFragmentDoc}`;

/**
 * __useOrganizationsQuery__
 *
 * To run a query within a React component, call `useOrganizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrganizationsQuery(baseOptions?: Apollo.QueryHookOptions<OrganizationsQuery, OrganizationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationsQuery, OrganizationsQueryVariables>(OrganizationsDocument, options);
      }
export function useOrganizationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationsQuery, OrganizationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationsQuery, OrganizationsQueryVariables>(OrganizationsDocument, options);
        }
export type OrganizationsQueryHookResult = ReturnType<typeof useOrganizationsQuery>;
export type OrganizationsLazyQueryHookResult = ReturnType<typeof useOrganizationsLazyQuery>;
export type OrganizationsQueryResult = Apollo.QueryResult<OrganizationsQuery, OrganizationsQueryVariables>;
export const PackageDocument = gql`
    query Package($id: ID!) {
  package(id: $id) {
    ...FullPackageFields
  }
}
    ${FullPackageFieldsFragmentDoc}`;

/**
 * __usePackageQuery__
 *
 * To run a query within a React component, call `usePackageQuery` and pass it any options that fit your needs.
 * When your component renders, `usePackageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePackageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePackageQuery(baseOptions: Apollo.QueryHookOptions<PackageQuery, PackageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PackageQuery, PackageQueryVariables>(PackageDocument, options);
      }
export function usePackageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PackageQuery, PackageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PackageQuery, PackageQueryVariables>(PackageDocument, options);
        }
export type PackageQueryHookResult = ReturnType<typeof usePackageQuery>;
export type PackageLazyQueryHookResult = ReturnType<typeof usePackageLazyQuery>;
export type PackageQueryResult = Apollo.QueryResult<PackageQuery, PackageQueryVariables>;
export const PaymentAccountDocument = gql`
    query PaymentAccount($id: ID!) {
  paymentAccount(id: $id) {
    ...PaymentAccountFields
    organizations {
      ...OrganizationFields
    }
    marketplaces {
      ...MarketplaceFields
    }
  }
}
    ${PaymentAccountFieldsFragmentDoc}
${OrganizationFieldsFragmentDoc}
${MarketplaceFieldsFragmentDoc}`;

/**
 * __usePaymentAccountQuery__
 *
 * To run a query within a React component, call `usePaymentAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentAccountQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePaymentAccountQuery(baseOptions: Apollo.QueryHookOptions<PaymentAccountQuery, PaymentAccountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaymentAccountQuery, PaymentAccountQueryVariables>(PaymentAccountDocument, options);
      }
export function usePaymentAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaymentAccountQuery, PaymentAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaymentAccountQuery, PaymentAccountQueryVariables>(PaymentAccountDocument, options);
        }
export type PaymentAccountQueryHookResult = ReturnType<typeof usePaymentAccountQuery>;
export type PaymentAccountLazyQueryHookResult = ReturnType<typeof usePaymentAccountLazyQuery>;
export type PaymentAccountQueryResult = Apollo.QueryResult<PaymentAccountQuery, PaymentAccountQueryVariables>;
export const PaymentAccountsDocument = gql`
    query PaymentAccounts {
  paymentAccounts {
    ...PaymentAccountFields
    organizations {
      ...OrganizationFields
    }
    marketplaces {
      ...MarketplaceFields
    }
  }
}
    ${PaymentAccountFieldsFragmentDoc}
${OrganizationFieldsFragmentDoc}
${MarketplaceFieldsFragmentDoc}`;

/**
 * __usePaymentAccountsQuery__
 *
 * To run a query within a React component, call `usePaymentAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentAccountsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePaymentAccountsQuery(baseOptions?: Apollo.QueryHookOptions<PaymentAccountsQuery, PaymentAccountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaymentAccountsQuery, PaymentAccountsQueryVariables>(PaymentAccountsDocument, options);
      }
export function usePaymentAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaymentAccountsQuery, PaymentAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaymentAccountsQuery, PaymentAccountsQueryVariables>(PaymentAccountsDocument, options);
        }
export type PaymentAccountsQueryHookResult = ReturnType<typeof usePaymentAccountsQuery>;
export type PaymentAccountsLazyQueryHookResult = ReturnType<typeof usePaymentAccountsLazyQuery>;
export type PaymentAccountsQueryResult = Apollo.QueryResult<PaymentAccountsQuery, PaymentAccountsQueryVariables>;
export const PayoutsDocument = gql`
    query Payouts($page: PayoutPageInput) {
  payouts(page: $page) {
    totalCount
    data {
      ...PaginatedPayoutFields
    }
  }
}
    ${PaginatedPayoutFieldsFragmentDoc}`;

/**
 * __usePayoutsQuery__
 *
 * To run a query within a React component, call `usePayoutsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePayoutsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePayoutsQuery({
 *   variables: {
 *      page: // value for 'page'
 *   },
 * });
 */
export function usePayoutsQuery(baseOptions?: Apollo.QueryHookOptions<PayoutsQuery, PayoutsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PayoutsQuery, PayoutsQueryVariables>(PayoutsDocument, options);
      }
export function usePayoutsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PayoutsQuery, PayoutsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PayoutsQuery, PayoutsQueryVariables>(PayoutsDocument, options);
        }
export type PayoutsQueryHookResult = ReturnType<typeof usePayoutsQuery>;
export type PayoutsLazyQueryHookResult = ReturnType<typeof usePayoutsLazyQuery>;
export type PayoutsQueryResult = Apollo.QueryResult<PayoutsQuery, PayoutsQueryVariables>;
export const ProcedureBaseDefinitionDocument = gql`
    query ProcedureBaseDefinition($id: ID!) {
  procedureBaseDefinition(id: $id) {
    ...FullProcedureBaseDefFields
  }
}
    ${FullProcedureBaseDefFieldsFragmentDoc}`;

/**
 * __useProcedureBaseDefinitionQuery__
 *
 * To run a query within a React component, call `useProcedureBaseDefinitionQuery` and pass it any options that fit your needs.
 * When your component renders, `useProcedureBaseDefinitionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProcedureBaseDefinitionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProcedureBaseDefinitionQuery(baseOptions: Apollo.QueryHookOptions<ProcedureBaseDefinitionQuery, ProcedureBaseDefinitionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProcedureBaseDefinitionQuery, ProcedureBaseDefinitionQueryVariables>(ProcedureBaseDefinitionDocument, options);
      }
export function useProcedureBaseDefinitionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProcedureBaseDefinitionQuery, ProcedureBaseDefinitionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProcedureBaseDefinitionQuery, ProcedureBaseDefinitionQueryVariables>(ProcedureBaseDefinitionDocument, options);
        }
export type ProcedureBaseDefinitionQueryHookResult = ReturnType<typeof useProcedureBaseDefinitionQuery>;
export type ProcedureBaseDefinitionLazyQueryHookResult = ReturnType<typeof useProcedureBaseDefinitionLazyQuery>;
export type ProcedureBaseDefinitionQueryResult = Apollo.QueryResult<ProcedureBaseDefinitionQuery, ProcedureBaseDefinitionQueryVariables>;
export const ProcedureDefinitionDocument = gql`
    query ProcedureDefinition($id: ID!) {
  procedureDefinition(id: $id) {
    ...ProcedureDefFields
    baseDefinitions {
      ...ProcedureBaseDefFields
      tags
    }
    medicationProtocols {
      ...MedicationProtocolFields
      medication {
        ...MedicationFields
      }
    }
    consentForms {
      ...DocumentFields
    }
  }
}
    ${ProcedureDefFieldsFragmentDoc}
${ProcedureBaseDefFieldsFragmentDoc}
${MedicationProtocolFieldsFragmentDoc}
${MedicationFieldsFragmentDoc}
${DocumentFieldsFragmentDoc}`;

/**
 * __useProcedureDefinitionQuery__
 *
 * To run a query within a React component, call `useProcedureDefinitionQuery` and pass it any options that fit your needs.
 * When your component renders, `useProcedureDefinitionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProcedureDefinitionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProcedureDefinitionQuery(baseOptions: Apollo.QueryHookOptions<ProcedureDefinitionQuery, ProcedureDefinitionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProcedureDefinitionQuery, ProcedureDefinitionQueryVariables>(ProcedureDefinitionDocument, options);
      }
export function useProcedureDefinitionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProcedureDefinitionQuery, ProcedureDefinitionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProcedureDefinitionQuery, ProcedureDefinitionQueryVariables>(ProcedureDefinitionDocument, options);
        }
export type ProcedureDefinitionQueryHookResult = ReturnType<typeof useProcedureDefinitionQuery>;
export type ProcedureDefinitionLazyQueryHookResult = ReturnType<typeof useProcedureDefinitionLazyQuery>;
export type ProcedureDefinitionQueryResult = Apollo.QueryResult<ProcedureDefinitionQuery, ProcedureDefinitionQueryVariables>;
export const ProfileDocument = gql`
    query Profile($id: ID!) {
  profile(id: $id) {
    ...FullProfile
    latitude
    longitude
    organization {
      ...OrganizationFields
    }
  }
}
    ${FullProfileFragmentDoc}
${OrganizationFieldsFragmentDoc}`;

/**
 * __useProfileQuery__
 *
 * To run a query within a React component, call `useProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfileQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProfileQuery(baseOptions: Apollo.QueryHookOptions<ProfileQuery, ProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProfileQuery, ProfileQueryVariables>(ProfileDocument, options);
      }
export function useProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProfileQuery, ProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProfileQuery, ProfileQueryVariables>(ProfileDocument, options);
        }
export type ProfileQueryHookResult = ReturnType<typeof useProfileQuery>;
export type ProfileLazyQueryHookResult = ReturnType<typeof useProfileLazyQuery>;
export type ProfileQueryResult = Apollo.QueryResult<ProfileQuery, ProfileQueryVariables>;
export const ProfilesDocument = gql`
    query Profiles {
  profiles {
    ...ProfileFields
    organization {
      ...OrganizationFields
    }
  }
}
    ${ProfileFieldsFragmentDoc}
${OrganizationFieldsFragmentDoc}`;

/**
 * __useProfilesQuery__
 *
 * To run a query within a React component, call `useProfilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfilesQuery({
 *   variables: {
 *   },
 * });
 */
export function useProfilesQuery(baseOptions?: Apollo.QueryHookOptions<ProfilesQuery, ProfilesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProfilesQuery, ProfilesQueryVariables>(ProfilesDocument, options);
      }
export function useProfilesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProfilesQuery, ProfilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProfilesQuery, ProfilesQueryVariables>(ProfilesDocument, options);
        }
export type ProfilesQueryHookResult = ReturnType<typeof useProfilesQuery>;
export type ProfilesLazyQueryHookResult = ReturnType<typeof useProfilesLazyQuery>;
export type ProfilesQueryResult = Apollo.QueryResult<ProfilesQuery, ProfilesQueryVariables>;
export const PromoCodeDocument = gql`
    query PromoCode($id: ID!) {
  promoCode(id: $id) {
    ...PromoCodeFields
  }
}
    ${PromoCodeFieldsFragmentDoc}`;

/**
 * __usePromoCodeQuery__
 *
 * To run a query within a React component, call `usePromoCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `usePromoCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePromoCodeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePromoCodeQuery(baseOptions: Apollo.QueryHookOptions<PromoCodeQuery, PromoCodeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PromoCodeQuery, PromoCodeQueryVariables>(PromoCodeDocument, options);
      }
export function usePromoCodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PromoCodeQuery, PromoCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PromoCodeQuery, PromoCodeQueryVariables>(PromoCodeDocument, options);
        }
export type PromoCodeQueryHookResult = ReturnType<typeof usePromoCodeQuery>;
export type PromoCodeLazyQueryHookResult = ReturnType<typeof usePromoCodeLazyQuery>;
export type PromoCodeQueryResult = Apollo.QueryResult<PromoCodeQuery, PromoCodeQueryVariables>;
export const PromoCodesDocument = gql`
    query PromoCodes($marketplaceId: ID!) {
  promoCodes(marketplaceId: $marketplaceId) {
    ...PromoCodeFields
  }
}
    ${PromoCodeFieldsFragmentDoc}`;

/**
 * __usePromoCodesQuery__
 *
 * To run a query within a React component, call `usePromoCodesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePromoCodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePromoCodesQuery({
 *   variables: {
 *      marketplaceId: // value for 'marketplaceId'
 *   },
 * });
 */
export function usePromoCodesQuery(baseOptions: Apollo.QueryHookOptions<PromoCodesQuery, PromoCodesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PromoCodesQuery, PromoCodesQueryVariables>(PromoCodesDocument, options);
      }
export function usePromoCodesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PromoCodesQuery, PromoCodesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PromoCodesQuery, PromoCodesQueryVariables>(PromoCodesDocument, options);
        }
export type PromoCodesQueryHookResult = ReturnType<typeof usePromoCodesQuery>;
export type PromoCodesLazyQueryHookResult = ReturnType<typeof usePromoCodesLazyQuery>;
export type PromoCodesQueryResult = Apollo.QueryResult<PromoCodesQuery, PromoCodesQueryVariables>;
export const ReachJwtDocument = gql`
    query ReachJwt($marketplaceId: ID!) {
  reachJwt(marketplaceId: $marketplaceId)
}
    `;

/**
 * __useReachJwtQuery__
 *
 * To run a query within a React component, call `useReachJwtQuery` and pass it any options that fit your needs.
 * When your component renders, `useReachJwtQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReachJwtQuery({
 *   variables: {
 *      marketplaceId: // value for 'marketplaceId'
 *   },
 * });
 */
export function useReachJwtQuery(baseOptions: Apollo.QueryHookOptions<ReachJwtQuery, ReachJwtQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReachJwtQuery, ReachJwtQueryVariables>(ReachJwtDocument, options);
      }
export function useReachJwtLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReachJwtQuery, ReachJwtQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReachJwtQuery, ReachJwtQueryVariables>(ReachJwtDocument, options);
        }
export type ReachJwtQueryHookResult = ReturnType<typeof useReachJwtQuery>;
export type ReachJwtLazyQueryHookResult = ReturnType<typeof useReachJwtLazyQuery>;
export type ReachJwtQueryResult = Apollo.QueryResult<ReachJwtQuery, ReachJwtQueryVariables>;
export const ReportsDocument = gql`
    query Reports($page: ReportPageInput!) {
  reports(page: $page) {
    data {
      id
      type
      filename
      status
      organizationId
      userId
      userName
      createdAt
      updatedAt
      downloadUrl
    }
    totalCount
  }
}
    `;

/**
 * __useReportsQuery__
 *
 * To run a query within a React component, call `useReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportsQuery({
 *   variables: {
 *      page: // value for 'page'
 *   },
 * });
 */
export function useReportsQuery(baseOptions: Apollo.QueryHookOptions<ReportsQuery, ReportsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportsQuery, ReportsQueryVariables>(ReportsDocument, options);
      }
export function useReportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportsQuery, ReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportsQuery, ReportsQueryVariables>(ReportsDocument, options);
        }
export type ReportsQueryHookResult = ReturnType<typeof useReportsQuery>;
export type ReportsLazyQueryHookResult = ReturnType<typeof useReportsLazyQuery>;
export type ReportsQueryResult = Apollo.QueryResult<ReportsQuery, ReportsQueryVariables>;
export const RolesDocument = gql`
    query Roles {
  roles {
    ...RoleFields
  }
}
    ${RoleFieldsFragmentDoc}`;

/**
 * __useRolesQuery__
 *
 * To run a query within a React component, call `useRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRolesQuery({
 *   variables: {
 *   },
 * });
 */
export function useRolesQuery(baseOptions?: Apollo.QueryHookOptions<RolesQuery, RolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RolesQuery, RolesQueryVariables>(RolesDocument, options);
      }
export function useRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RolesQuery, RolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RolesQuery, RolesQueryVariables>(RolesDocument, options);
        }
export type RolesQueryHookResult = ReturnType<typeof useRolesQuery>;
export type RolesLazyQueryHookResult = ReturnType<typeof useRolesLazyQuery>;
export type RolesQueryResult = Apollo.QueryResult<RolesQuery, RolesQueryVariables>;
export const UserDocument = gql`
    query User($id: ID!) {
  user(id: $id) {
    ...UserFields
    mfa {
      ...MfaStatusFields
    }
    profiles {
      ...FullProfile
      organization {
        ...OrganizationFields
      }
    }
    apiKeys {
      ...ApiKeyFields
    }
  }
}
    ${UserFieldsFragmentDoc}
${MfaStatusFieldsFragmentDoc}
${FullProfileFragmentDoc}
${OrganizationFieldsFragmentDoc}
${ApiKeyFieldsFragmentDoc}`;

/**
 * __useUserQuery__
 *
 * To run a query within a React component, call `useUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserQuery(baseOptions: Apollo.QueryHookOptions<UserQuery, UserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserQuery, UserQueryVariables>(UserDocument, options);
      }
export function useUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserQuery, UserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserQuery, UserQueryVariables>(UserDocument, options);
        }
export type UserQueryHookResult = ReturnType<typeof useUserQuery>;
export type UserLazyQueryHookResult = ReturnType<typeof useUserLazyQuery>;
export type UserQueryResult = Apollo.QueryResult<UserQuery, UserQueryVariables>;
export const UsersDocument = gql`
    query Users {
  users {
    ...UserFields
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useUsersQuery__
 *
 * To run a query within a React component, call `useUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useUsersQuery(baseOptions?: Apollo.QueryHookOptions<UsersQuery, UsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UsersQuery, UsersQueryVariables>(UsersDocument, options);
      }
export function useUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UsersQuery, UsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UsersQuery, UsersQueryVariables>(UsersDocument, options);
        }
export type UsersQueryHookResult = ReturnType<typeof useUsersQuery>;
export type UsersLazyQueryHookResult = ReturnType<typeof useUsersLazyQuery>;
export type UsersQueryResult = Apollo.QueryResult<UsersQuery, UsersQueryVariables>;
export const ValidatePromoCodeDocument = gql`
    query ValidatePromoCode($input: ValidatePromoCodeInput!) {
  validatePromoCode(input: $input) {
    valid
    error
    discountAmount
    itemDiscounts {
      procedureBaseDefId
      discountAmount
    }
  }
}
    `;

/**
 * __useValidatePromoCodeQuery__
 *
 * To run a query within a React component, call `useValidatePromoCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidatePromoCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidatePromoCodeQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useValidatePromoCodeQuery(baseOptions: Apollo.QueryHookOptions<ValidatePromoCodeQuery, ValidatePromoCodeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ValidatePromoCodeQuery, ValidatePromoCodeQueryVariables>(ValidatePromoCodeDocument, options);
      }
export function useValidatePromoCodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ValidatePromoCodeQuery, ValidatePromoCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ValidatePromoCodeQuery, ValidatePromoCodeQueryVariables>(ValidatePromoCodeDocument, options);
        }
export type ValidatePromoCodeQueryHookResult = ReturnType<typeof useValidatePromoCodeQuery>;
export type ValidatePromoCodeLazyQueryHookResult = ReturnType<typeof useValidatePromoCodeLazyQuery>;
export type ValidatePromoCodeQueryResult = Apollo.QueryResult<ValidatePromoCodeQuery, ValidatePromoCodeQueryVariables>;
export const ViewerDocument = gql`
    query Viewer {
  viewer {
    ...UserFields
    profiles {
      ...ProfileRoles
    }
  }
}
    ${UserFieldsFragmentDoc}
${ProfileRolesFragmentDoc}`;

/**
 * __useViewerQuery__
 *
 * To run a query within a React component, call `useViewerQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewerQuery({
 *   variables: {
 *   },
 * });
 */
export function useViewerQuery(baseOptions?: Apollo.QueryHookOptions<ViewerQuery, ViewerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ViewerQuery, ViewerQueryVariables>(ViewerDocument, options);
      }
export function useViewerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ViewerQuery, ViewerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ViewerQuery, ViewerQueryVariables>(ViewerDocument, options);
        }
export type ViewerQueryHookResult = ReturnType<typeof useViewerQuery>;
export type ViewerLazyQueryHookResult = ReturnType<typeof useViewerLazyQuery>;
export type ViewerQueryResult = Apollo.QueryResult<ViewerQuery, ViewerQueryVariables>;
export const ViewerMfaDocument = gql`
    query ViewerMfa {
  viewer {
    id
    email
    mfa {
      ...MfaStatusFields
    }
  }
}
    ${MfaStatusFieldsFragmentDoc}`;

/**
 * __useViewerMfaQuery__
 *
 * To run a query within a React component, call `useViewerMfaQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewerMfaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewerMfaQuery({
 *   variables: {
 *   },
 * });
 */
export function useViewerMfaQuery(baseOptions?: Apollo.QueryHookOptions<ViewerMfaQuery, ViewerMfaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ViewerMfaQuery, ViewerMfaQueryVariables>(ViewerMfaDocument, options);
      }
export function useViewerMfaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ViewerMfaQuery, ViewerMfaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ViewerMfaQuery, ViewerMfaQueryVariables>(ViewerMfaDocument, options);
        }
export type ViewerMfaQueryHookResult = ReturnType<typeof useViewerMfaQuery>;
export type ViewerMfaLazyQueryHookResult = ReturnType<typeof useViewerMfaLazyQuery>;
export type ViewerMfaQueryResult = Apollo.QueryResult<ViewerMfaQuery, ViewerMfaQueryVariables>;
export const ViewerTrustedDevicesDocument = gql`
    query ViewerTrustedDevices {
  viewer {
    id
    trustedDevices {
      id
      label
      current
      createdAt
      lastUsedAt
      expiresAt
    }
  }
}
    `;

/**
 * __useViewerTrustedDevicesQuery__
 *
 * To run a query within a React component, call `useViewerTrustedDevicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewerTrustedDevicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewerTrustedDevicesQuery({
 *   variables: {
 *   },
 * });
 */
export function useViewerTrustedDevicesQuery(baseOptions?: Apollo.QueryHookOptions<ViewerTrustedDevicesQuery, ViewerTrustedDevicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ViewerTrustedDevicesQuery, ViewerTrustedDevicesQueryVariables>(ViewerTrustedDevicesDocument, options);
      }
export function useViewerTrustedDevicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ViewerTrustedDevicesQuery, ViewerTrustedDevicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ViewerTrustedDevicesQuery, ViewerTrustedDevicesQueryVariables>(ViewerTrustedDevicesDocument, options);
        }
export type ViewerTrustedDevicesQueryHookResult = ReturnType<typeof useViewerTrustedDevicesQuery>;
export type ViewerTrustedDevicesLazyQueryHookResult = ReturnType<typeof useViewerTrustedDevicesLazyQuery>;
export type ViewerTrustedDevicesQueryResult = Apollo.QueryResult<ViewerTrustedDevicesQuery, ViewerTrustedDevicesQueryVariables>;